
// minifier: path aliases

enyo.path.addPaths({educate: "../source/educate/", layout: "/opt/atlassian/pipelines/agent/build/src/enyo/enyo/tools/../../lib/layout/", onyx: "/opt/atlassian/pipelines/agent/build/src/enyo/enyo/tools/../../lib/onyx/", onyx: "/opt/atlassian/pipelines/agent/build/src/enyo/enyo/tools/../../lib/onyx/source/", canvas: "/opt/atlassian/pipelines/agent/build/src/enyo/enyo/tools/../../lib/canvas/"});

// FittableLayout.js

enyo.kind({
name: "enyo.FittableLayout",
kind: "Layout",
calcFitIndex: function() {
for (var e = 0, t = this.container.children, n; n = t[e]; e++) if (n.fit && n.showing) return e;
},
getFitControl: function() {
var e = this.container.children, t = e[this.fitIndex];
return t && t.fit && t.showing || (this.fitIndex = this.calcFitIndex(), t = e[this.fitIndex]), t;
},
getLastControl: function() {
var e = this.container.children, t = e.length - 1, n = e[t];
while ((n = e[t]) && !n.showing) t--;
return n;
},
_reflow: function(e, t, n, r) {
this.container.addRemoveClass("enyo-stretch", !this.container.noStretch);
var i = this.getFitControl();
if (!i) return;
var s = 0, o = 0, u = 0, a, f = this.container.hasNode();
f && (a = enyo.dom.calcPaddingExtents(f), s = f[t] - (a[n] + a[r]));
var l = i.getBounds();
o = l[n] - (a && a[n] || 0);
var c = this.getLastControl();
if (c) {
var h = enyo.dom.getComputedBoxValue(c.hasNode(), "margin", r) || 0;
if (c != i) {
var p = c.getBounds(), d = l[n] + l[e], v = p[n] + p[e] + h;
u = v - d;
} else u = h;
}
var m = s - (o + u);
i.applyStyle(e, m + "px");
},
reflow: function() {
this.orient == "h" ? this._reflow("width", "clientWidth", "left", "right") : this._reflow("height", "clientHeight", "top", "bottom");
}
}), enyo.kind({
name: "enyo.FittableColumnsLayout",
kind: "FittableLayout",
orient: "h",
layoutClass: "enyo-fittable-columns-layout"
}), enyo.kind({
name: "enyo.FittableRowsLayout",
kind: "FittableLayout",
layoutClass: "enyo-fittable-rows-layout",
orient: "v"
});

// FittableRows.js

enyo.kind({
name: "enyo.FittableRows",
layoutKind: "FittableRowsLayout",
noStretch: !1
});

// FittableColumns.js

enyo.kind({
name: "enyo.FittableColumns",
layoutKind: "FittableColumnsLayout",
noStretch: !1
});

// FlyweightRepeater.js

enyo.kind({
name: "enyo.FlyweightRepeater",
published: {
count: 0,
noSelect: !1,
multiSelect: !1,
toggleSelected: !1,
clientClasses: "",
clientStyle: ""
},
events: {
onSetupItem: ""
},
bottomUp: !1,
components: [ {
kind: "Selection",
onSelect: "selectDeselect",
onDeselect: "selectDeselect"
}, {
name: "client"
} ],
rowOffset: 0,
create: function() {
this.inherited(arguments), this.noSelectChanged(), this.multiSelectChanged(), this.clientClassesChanged(), this.clientStyleChanged();
},
noSelectChanged: function() {
this.noSelect && this.$.selection.clear();
},
multiSelectChanged: function() {
this.$.selection.setMulti(this.multiSelect);
},
clientClassesChanged: function() {
this.$.client.setClasses(this.clientClasses);
},
clientStyleChanged: function() {
this.$.client.setStyle(this.clientStyle);
},
setupItem: function(e) {
this.doSetupItem({
index: e,
selected: this.isSelected(e)
});
},
generateChildHtml: function() {
var e = "";
this.index = null;
for (var t = 0, n = 0; t < this.count; t++) n = this.rowOffset + (this.bottomUp ? this.count - t - 1 : t), this.setupItem(n), this.$.client.setAttribute("data-enyo-index", n), e += this.inherited(arguments), this.$.client.teardownRender();
return e;
},
previewDomEvent: function(e) {
var t = this.index = this.rowForEvent(e);
e.rowIndex = e.index = t, e.flyweight = this;
},
decorateEvent: function(e, t, n) {
var r = t && t.index != null ? t.index : this.index;
t && r != null && (t.index = r, t.flyweight = this), this.inherited(arguments);
},
tap: function(e, t) {
if (this.noSelect) return;
this.toggleSelected ? this.$.selection.toggle(t.index) : this.$.selection.select(t.index);
},
selectDeselect: function(e, t) {
this.renderRow(t.key);
},
getSelection: function() {
return this.$.selection;
},
isSelected: function(e) {
return this.getSelection().isSelected(e);
},
renderRow: function(e) {
var t = this.fetchRowNode(e);
t && (this.setupItem(e), t.innerHTML = this.$.client.generateChildHtml(), this.$.client.teardownChildren());
},
fetchRowNode: function(e) {
if (this.hasNode()) {
var t = this.node.querySelectorAll('[data-enyo-index="' + e + '"]');
return t && t[0];
}
},
rowForEvent: function(e) {
var t = e.target, n = this.hasNode().id;
while (t && t.parentNode && t.id != n) {
var r = t.getAttribute && t.getAttribute("data-enyo-index");
if (r !== null) return Number(r);
t = t.parentNode;
}
return -1;
},
prepareRow: function(e) {
var t = this.fetchRowNode(e);
enyo.FlyweightRepeater.claimNode(this.$.client, t);
},
lockRow: function() {
this.$.client.teardownChildren();
},
performOnRow: function(e, t, n) {
t && (this.prepareRow(e), enyo.call(n || null, t), this.lockRow());
},
statics: {
claimNode: function(e, t) {
var n = t && t.querySelectorAll("#" + e.id);
n = n && n[0], e.generated = Boolean(n || !e.tag), e.node = n, e.node && e.rendered();
for (var r = 0, i = e.children, s; s = i[r]; r++) this.claimNode(s, t);
}
}
});

// List.js

enyo.kind({
name: "enyo.List",
kind: "Scroller",
classes: "enyo-list",
published: {
count: 0,
rowsPerPage: 50,
bottomUp: !1,
noSelect: !1,
multiSelect: !1,
toggleSelected: !1,
fixedHeight: !1
},
events: {
onSetupItem: ""
},
handlers: {
onAnimateFinish: "animateFinish"
},
rowHeight: 0,
listTools: [ {
name: "port",
classes: "enyo-list-port enyo-border-box",
components: [ {
name: "generator",
kind: "FlyweightRepeater",
canGenerate: !1,
components: [ {
tag: null,
name: "client"
} ]
}, {
name: "page0",
allowHtml: !0,
classes: "enyo-list-page"
}, {
name: "page1",
allowHtml: !0,
classes: "enyo-list-page"
} ]
} ],
create: function() {
this.pageHeights = [], this.inherited(arguments), this.getStrategy().translateOptimized = !0, this.bottomUpChanged(), this.noSelectChanged(), this.multiSelectChanged(), this.toggleSelectedChanged();
},
createStrategy: function() {
this.controlParentName = "strategy", this.inherited(arguments), this.createChrome(this.listTools), this.controlParentName = "client", this.discoverControlParent();
},
rendered: function() {
this.inherited(arguments), this.$.generator.node = this.$.port.hasNode(), this.$.generator.generated = !0, this.reset();
},
resizeHandler: function() {
this.inherited(arguments), this.refresh();
},
bottomUpChanged: function() {
this.$.generator.bottomUp = this.bottomUp, this.$.page0.applyStyle(this.pageBound, null), this.$.page1.applyStyle(this.pageBound, null), this.pageBound = this.bottomUp ? "bottom" : "top", this.hasNode() && this.reset();
},
noSelectChanged: function() {
this.$.generator.setNoSelect(this.noSelect);
},
multiSelectChanged: function() {
this.$.generator.setMultiSelect(this.multiSelect);
},
toggleSelectedChanged: function() {
this.$.generator.setToggleSelected(this.toggleSelected);
},
countChanged: function() {
this.hasNode() && this.updateMetrics();
},
updateMetrics: function() {
this.defaultPageHeight = this.rowsPerPage * (this.rowHeight || 100), this.pageCount = Math.ceil(this.count / this.rowsPerPage), this.portSize = 0;
for (var e = 0; e < this.pageCount; e++) this.portSize += this.getPageHeight(e);
this.adjustPortSize();
},
generatePage: function(e, t) {
this.page = e;
var n = this.$.generator.rowOffset = this.rowsPerPage * this.page, r = this.$.generator.count = Math.min(this.count - n, this.rowsPerPage), i = this.$.generator.generateChildHtml();
t.setContent(i);
var s = t.getBounds().height;
!this.rowHeight && s > 0 && (this.rowHeight = Math.floor(s / r), this.updateMetrics());
if (!this.fixedHeight) {
var o = this.getPageHeight(e);
o != s && s > 0 && (this.pageHeights[e] = s, this.portSize += s - o);
}
},
update: function(e) {
var t = !1, n = this.positionToPageInfo(e), r = n.pos + this.scrollerHeight / 2, i = Math.floor(r / Math.max(n.height, this.scrollerHeight) + .5) + n.no, s = i % 2 === 0 ? i : i - 1;
this.p0 != s && this.isPageInRange(s) && (this.generatePage(s, this.$.page0), this.positionPage(s, this.$.page0), this.p0 = s, t = !0), s = i % 2 === 0 ? Math.max(1, i - 1) : i, this.p1 != s && this.isPageInRange(s) && (this.generatePage(s, this.$.page1), this.positionPage(s, this.$.page1), this.p1 = s, t = !0), t && !this.fixedHeight && (this.adjustBottomPage(), this.adjustPortSize());
},
updateForPosition: function(e) {
this.update(this.calcPos(e));
},
calcPos: function(e) {
return this.bottomUp ? this.portSize - this.scrollerHeight - e : e;
},
adjustBottomPage: function() {
var e = this.p0 >= this.p1 ? this.$.page0 : this.$.page1;
this.positionPage(e.pageNo, e);
},
adjustPortSize: function() {
this.scrollerHeight = this.getBounds().height;
var e = Math.max(this.scrollerHeight, this.portSize);
this.$.port.applyStyle("height", e + "px");
},
positionPage: function(e, t) {
t.pageNo = e;
var n = this.pageToPosition(e);
t.applyStyle(this.pageBound, n + "px");
},
pageToPosition: function(e) {
var t = 0, n = e;
while (n > 0) n--, t += this.getPageHeight(n);
return t;
},
positionToPageInfo: function(e) {
var t = -1, n = this.calcPos(e), r = this.defaultPageHeight;
while (n >= 0) t++, r = this.getPageHeight(t), n -= r;
return {
no: t,
height: r,
pos: n + r
};
},
isPageInRange: function(e) {
return e == Math.max(0, Math.min(this.pageCount - 1, e));
},
getPageHeight: function(e) {
return this.pageHeights[e] || this.defaultPageHeight;
},
invalidatePages: function() {
this.p0 = this.p1 = null, this.$.page0.setContent(""), this.$.page1.setContent("");
},
invalidateMetrics: function() {
this.pageHeights = [], this.rowHeight = 0, this.updateMetrics();
},
scroll: function(e, t) {
var n = this.inherited(arguments);
return this.update(this.getScrollTop()), n;
},
scrollToBottom: function() {
this.update(this.getScrollBounds().maxTop), this.inherited(arguments);
},
setScrollTop: function(e) {
this.update(e), this.inherited(arguments), this.twiddle();
},
getScrollPosition: function() {
return this.calcPos(this.getScrollTop());
},
setScrollPosition: function(e) {
this.setScrollTop(this.calcPos(e));
},
scrollToRow: function(e) {
var t = Math.floor(e / this.rowsPerPage), n = e % this.rowsPerPage, r = this.pageToPosition(t);
this.updateForPosition(r), r = this.pageToPosition(t), this.setScrollPosition(r);
if (t == this.p0 || t == this.p1) {
var i = this.$.generator.fetchRowNode(e);
if (i) {
var s = i.offsetTop;
this.bottomUp && (s = this.getPageHeight(t) - i.offsetHeight - s);
var o = this.getScrollPosition() + s;
this.setScrollPosition(o);
}
}
},
scrollToStart: function() {
this[this.bottomUp ? "scrollToBottom" : "scrollToTop"]();
},
scrollToEnd: function() {
this[this.bottomUp ? "scrollToTop" : "scrollToBottom"]();
},
refresh: function() {
this.invalidatePages(), this.update(this.getScrollTop()), this.stabilize(), enyo.platform.android === 4 && this.twiddle();
},
reset: function() {
this.getSelection().clear(), this.invalidateMetrics(), this.invalidatePages(), this.stabilize(), this.scrollToStart();
},
getSelection: function() {
return this.$.generator.getSelection();
},
select: function(e, t) {
return this.getSelection().select(e, t);
},
deselect: function(e) {
return this.getSelection().deselect(e);
},
isSelected: function(e) {
return this.$.generator.isSelected(e);
},
renderRow: function(e) {
this.$.generator.renderRow(e);
},
prepareRow: function(e) {
this.$.generator.prepareRow(e);
},
lockRow: function() {
this.$.generator.lockRow();
},
performOnRow: function(e, t, n) {
this.$.generator.performOnRow(e, t, n);
},
animateFinish: function(e) {
return this.twiddle(), !0;
},
twiddle: function() {
var e = this.getStrategy();
enyo.call(e, "twiddle");
}
});

// PulldownList.js

enyo.kind({
name: "enyo.PulldownList",
kind: "List",
touch: !0,
pully: null,
pulldownTools: [ {
name: "pulldown",
classes: "enyo-list-pulldown",
components: [ {
name: "puller",
kind: "Puller"
} ]
} ],
events: {
onPullStart: "",
onPullCancel: "",
onPull: "",
onPullRelease: "",
onPullComplete: ""
},
handlers: {
onScrollStart: "scrollStartHandler",
onScrollStop: "scrollStopHandler",
ondragfinish: "dragfinish"
},
pullingMessage: "Pull down to refresh...",
pulledMessage: "Release to refresh...",
loadingMessage: "Loading...",
pullingIconClass: "enyo-puller-arrow enyo-puller-arrow-down",
pulledIconClass: "enyo-puller-arrow enyo-puller-arrow-up",
loadingIconClass: "",
create: function() {
var e = {
kind: "Puller",
showing: !1,
text: this.loadingMessage,
iconClass: this.loadingIconClass,
onCreate: "setPully"
};
this.listTools.splice(0, 0, e), this.inherited(arguments), this.setPulling();
},
initComponents: function() {
this.createChrome(this.pulldownTools), this.accel = enyo.dom.canAccelerate(), this.translation = this.accel ? "translate3d" : "translate", this.inherited(arguments);
},
setPully: function(e, t) {
this.pully = t.originator;
},
scrollStartHandler: function() {
this.firedPullStart = !1, this.firedPull = !1, this.firedPullCancel = !1;
},
scroll: function(e, t) {
var n = this.inherited(arguments);
this.completingPull && this.pully.setShowing(!1);
var r = this.getStrategy().$.scrollMath, i = r.y;
return r.isInOverScroll() && i > 0 && (enyo.dom.transformValue(this.$.pulldown, this.translation, "0," + i + "px" + (this.accel ? ",0" : "")), this.firedPullStart || (this.firedPullStart = !0, this.pullStart(), this.pullHeight = this.$.pulldown.getBounds().height), i > this.pullHeight && !this.firedPull && (this.firedPull = !0, this.firedPullCancel = !1, this.pull()), this.firedPull && !this.firedPullCancel && i < this.pullHeight && (this.firedPullCancel = !0, this.firedPull = !1, this.pullCancel())), n;
},
scrollStopHandler: function() {
this.completingPull && (this.completingPull = !1, this.doPullComplete());
},
dragfinish: function() {
if (this.firedPull) {
var e = this.getStrategy().$.scrollMath;
e.setScrollY(e.y - this.pullHeight), this.pullRelease();
}
},
completePull: function() {
this.completingPull = !0, this.$.strategy.$.scrollMath.setScrollY(this.pullHeight), this.$.strategy.$.scrollMath.start();
},
pullStart: function() {
this.setPulling(), this.pully.setShowing(!1), this.$.puller.setShowing(!0), this.doPullStart();
},
pull: function() {
this.setPulled(), this.doPull();
},
pullCancel: function() {
this.setPulling(), this.doPullCancel();
},
pullRelease: function() {
this.$.puller.setShowing(!1), this.pully.setShowing(!0), this.doPullRelease();
},
setPulling: function() {
this.$.puller.setText(this.pullingMessage), this.$.puller.setIconClass(this.pullingIconClass);
},
setPulled: function() {
this.$.puller.setText(this.pulledMessage), this.$.puller.setIconClass(this.pulledIconClass);
}
}), enyo.kind({
name: "enyo.Puller",
classes: "enyo-puller",
published: {
text: "",
iconClass: ""
},
events: {
onCreate: ""
},
components: [ {
name: "icon"
}, {
name: "text",
tag: "span",
classes: "enyo-puller-text"
} ],
create: function() {
this.inherited(arguments), this.doCreate(), this.textChanged(), this.iconClassChanged();
},
textChanged: function() {
this.$.text.setContent(this.text);
},
iconClassChanged: function() {
this.$.icon.setClasses(this.iconClass);
}
});

// AroundList.js

enyo.kind({
name: "enyo.AroundList",
kind: "enyo.List",
listTools: [ {
name: "port",
classes: "enyo-list-port enyo-border-box",
components: [ {
name: "aboveClient"
}, {
name: "generator",
kind: "enyo.FlyweightRepeater",
canGenerate: !1,
components: [ {
tag: null,
name: "client"
} ]
}, {
name: "page0",
allowHtml: !0,
classes: "enyo-list-page"
}, {
name: "page1",
allowHtml: !0,
classes: "enyo-list-page"
}, {
name: "belowClient"
} ]
} ],
aboveComponents: null,
initComponents: function() {
this.inherited(arguments), this.aboveComponents && this.$.aboveClient.createComponents(this.aboveComponents, {
owner: this.owner
}), this.belowComponents && this.$.belowClient.createComponents(this.belowComponents, {
owner: this.owner
});
},
updateMetrics: function() {
this.defaultPageHeight = this.rowsPerPage * (this.rowHeight || 100), this.pageCount = Math.ceil(this.count / this.rowsPerPage), this.aboveHeight = this.$.aboveClient.getBounds().height, this.belowHeight = this.$.belowClient.getBounds().height, this.portSize = this.aboveHeight + this.belowHeight;
for (var e = 0; e < this.pageCount; e++) this.portSize += this.getPageHeight(e);
this.adjustPortSize();
},
positionPage: function(e, t) {
t.pageNo = e;
var n = this.pageToPosition(e), r = this.bottomUp ? this.belowHeight : this.aboveHeight;
n += r, t.applyStyle(this.pageBound, n + "px");
},
scrollToContentStart: function() {
var e = this.bottomUp ? this.belowHeight : this.aboveHeight;
this.setScrollPosition(e);
}
});

// Slideable.js

enyo.kind({
name: "enyo.Slideable",
kind: "Control",
published: {
axis: "h",
value: 0,
unit: "px",
min: 0,
max: 0,
accelerated: "auto",
overMoving: !0,
draggable: !0
},
events: {
onAnimateFinish: "",
onChange: ""
},
preventDragPropagation: !1,
tools: [ {
kind: "Animator",
onStep: "animatorStep",
onEnd: "animatorComplete"
} ],
handlers: {
ondragstart: "dragstart",
ondrag: "drag",
ondragfinish: "dragfinish"
},
kDragScalar: 1,
dragEventProp: "dx",
unitModifier: !1,
canTransform: !1,
create: function() {
this.inherited(arguments), this.acceleratedChanged(), this.transformChanged(), this.axisChanged(), this.valueChanged(), this.addClass("enyo-slideable");
},
initComponents: function() {
this.createComponents(this.tools), this.inherited(arguments);
},
rendered: function() {
this.inherited(arguments), this.canModifyUnit(), this.updateDragScalar();
},
resizeHandler: function() {
this.inherited(arguments), this.updateDragScalar();
},
canModifyUnit: function() {
if (!this.canTransform) {
var e = this.getInitialStyleValue(this.hasNode(), this.boundary);
e.match(/px/i) && this.unit === "%" && (this.unitModifier = this.getBounds()[this.dimension]);
}
},
getInitialStyleValue: function(e, t) {
var n = enyo.dom.getComputedStyle(e);
return n ? n.getPropertyValue(t) : e && e.currentStyle ? e.currentStyle[t] : "0";
},
updateBounds: function(e, t) {
var n = {};
n[this.boundary] = e, this.setBounds(n, this.unit), this.setInlineStyles(e, t);
},
updateDragScalar: function() {
if (this.unit == "%") {
var e = this.getBounds()[this.dimension];
this.kDragScalar = e ? 100 / e : 1, this.canTransform || this.updateBounds(this.value, 100);
}
},
transformChanged: function() {
this.canTransform = enyo.dom.canTransform();
},
acceleratedChanged: function() {
enyo.platform.android > 2 || enyo.dom.accelerate(this, this.accelerated);
},
axisChanged: function() {
var e = this.axis == "h";
this.dragMoveProp = e ? "dx" : "dy", this.shouldDragProp = e ? "horizontal" : "vertical", this.transform = e ? "translateX" : "translateY", this.dimension = e ? "width" : "height", this.boundary = e ? "left" : "top";
},
setInlineStyles: function(e, t) {
var n = {};
this.unitModifier ? (n[this.boundary] = this.percentToPixels(e, this.unitModifier), n[this.dimension] = this.unitModifier, this.setBounds(n)) : (t ? n[this.dimension] = t : n[this.boundary] = e, this.setBounds(n, this.unit));
},
valueChanged: function(e) {
var t = this.value;
this.isOob(t) && !this.isAnimating() && (this.value = this.overMoving ? this.dampValue(t) : this.clampValue(t)), enyo.platform.android > 2 && (this.value ? (e === 0 || e === undefined) && enyo.dom.accelerate(this, this.accelerated) : enyo.dom.accelerate(this, !1)), this.canTransform ? enyo.dom.transformValue(this, this.transform, this.value + this.unit) : this.setInlineStyles(this.value, !1), this.doChange();
},
getAnimator: function() {
return this.$.animator;
},
isAtMin: function() {
return this.value <= this.calcMin();
},
isAtMax: function() {
return this.value >= this.calcMax();
},
calcMin: function() {
return this.min;
},
calcMax: function() {
return this.max;
},
clampValue: function(e) {
var t = this.calcMin(), n = this.calcMax();
return Math.max(t, Math.min(e, n));
},
dampValue: function(e) {
return this.dampBound(this.dampBound(e, this.min, 1), this.max, -1);
},
dampBound: function(e, t, n) {
var r = e;
return r * n < t * n && (r = t + (r - t) / 4), r;
},
percentToPixels: function(e, t) {
return Math.floor(t / 100 * e);
},
pixelsToPercent: function(e) {
var t = this.unitModifier ? this.getBounds()[this.dimension] : this.container.getBounds()[this.dimension];
return e / t * 100;
},
shouldDrag: function(e) {
return this.draggable && e[this.shouldDragProp];
},
isOob: function(e) {
return e > this.calcMax() || e < this.calcMin();
},
dragstart: function(e, t) {
if (this.shouldDrag(t)) return t.preventDefault(), this.$.animator.stop(), t.dragInfo = {}, this.dragging = !0, this.drag0 = this.value, this.dragd0 = 0, this.preventDragPropagation;
},
drag: function(e, t) {
if (this.dragging) {
t.preventDefault();
var n = this.canTransform ? t[this.dragMoveProp] * this.kDragScalar : this.pixelsToPercent(t[this.dragMoveProp]), r = this.drag0 + n, i = n - this.dragd0;
return this.dragd0 = n, i && (t.dragInfo.minimizing = i < 0), this.setValue(r), this.preventDragPropagation;
}
},
dragfinish: function(e, t) {
if (this.dragging) return this.dragging = !1, this.completeDrag(t), t.preventTap(), this.preventDragPropagation;
},
completeDrag: function(e) {
this.value !== this.calcMax() && this.value != this.calcMin() && this.animateToMinMax(e.dragInfo.minimizing);
},
isAnimating: function() {
return this.$.animator.isAnimating();
},
play: function(e, t) {
this.$.animator.play({
startValue: e,
endValue: t,
node: this.hasNode()
});
},
animateTo: function(e) {
this.play(this.value, e);
},
animateToMin: function() {
this.animateTo(this.calcMin());
},
animateToMax: function() {
this.animateTo(this.calcMax());
},
animateToMinMax: function(e) {
e ? this.animateToMin() : this.animateToMax();
},
animatorStep: function(e) {
return this.setValue(e.value), !0;
},
animatorComplete: function(e) {
return this.doAnimateFinish(e), !0;
},
toggleMinMax: function() {
this.animateToMinMax(!this.isAtMin());
}
});

// Arranger.js

enyo.kind({
name: "enyo.Arranger",
kind: "Layout",
layoutClass: "enyo-arranger",
accelerated: "auto",
dragProp: "ddx",
dragDirectionProp: "xDirection",
canDragProp: "horizontal",
incrementalPoints: !1,
destroy: function() {
var e = this.container.getPanels();
for (var t = 0, n; n = e[t]; t++) n._arranger = null;
this.inherited(arguments);
},
arrange: function(e, t) {},
size: function() {},
start: function() {
var e = this.container.fromIndex, t = this.container.toIndex, n = this.container.transitionPoints = [ e ];
if (this.incrementalPoints) {
var r = Math.abs(t - e) - 2, i = e;
while (r >= 0) i += t < e ? -1 : 1, n.push(i), r--;
}
n.push(this.container.toIndex);
},
finish: function() {},
calcArrangementDifference: function(e, t, n, r) {},
canDragEvent: function(e) {
return e[this.canDragProp];
},
calcDragDirection: function(e) {
return e[this.dragDirectionProp];
},
calcDrag: function(e) {
return e[this.dragProp];
},
drag: function(e, t, n, r, i) {
var s = this.measureArrangementDelta(-e, t, n, r, i);
return s;
},
measureArrangementDelta: function(e, t, n, r, i) {
var s = this.calcArrangementDifference(t, n, r, i), o = s ? e / Math.abs(s) : 0;
return o *= this.container.fromIndex > this.container.toIndex ? -1 : 1, o;
},
_arrange: function(e) {
this.containerBounds || this.reflow();
var t = this.getOrderedControls(e);
this.arrange(t, e);
},
arrangeControl: function(e, t) {
e._arranger = enyo.mixin(e._arranger || {}, t);
},
flow: function() {
this.c$ = [].concat(this.container.getPanels()), this.controlsIndex = 0;
for (var e = 0, t = this.container.getPanels(), n; n = t[e]; e++) {
enyo.dom.accelerate(n, this.accelerated);
if (enyo.platform.safari) {
var r = n.children;
for (var i = 0, s; s = r[i]; i++) enyo.dom.accelerate(s, this.accelerated);
}
}
},
reflow: function() {
var e = this.container.hasNode();
this.containerBounds = e ? {
width: e.clientWidth,
height: e.clientHeight
} : {}, this.size();
},
flowArrangement: function() {
var e = this.container.arrangement;
if (e) for (var t = 0, n = this.container.getPanels(), r; r = n[t]; t++) this.flowControl(r, e[t]);
},
flowControl: function(e, t) {
enyo.Arranger.positionControl(e, t);
var n = t.opacity;
n != null && enyo.Arranger.opacifyControl(e, n);
},
getOrderedControls: function(e) {
var t = Math.floor(e), n = t - this.controlsIndex, r = n > 0, i = this.c$ || [];
for (var s = 0; s < Math.abs(n); s++) r ? i.push(i.shift()) : i.unshift(i.pop());
return this.controlsIndex = t, i;
},
statics: {
positionControl: function(e, t, n) {
var r = n || "px";
if (!this.updating) if (enyo.dom.canTransform() && !enyo.platform.android) {
var i = t.left, s = t.top;
i = enyo.isString(i) ? i : i && i + r, s = enyo.isString(s) ? s : s && s + r, enyo.dom.transform(e, {
translateX: i || null,
translateY: s || null
});
} else e.setBounds(t, n);
},
opacifyControl: function(e, t) {
var n = t;
n = n > .99 ? 1 : n < .01 ? 0 : n, enyo.platform.ie < 9 ? e.applyStyle("filter", "progid:DXImageTransform.Microsoft.Alpha(Opacity=" + n * 100 + ")") : e.applyStyle("opacity", n);
}
}
});

// CardArranger.js

enyo.kind({
name: "enyo.CardArranger",
kind: "Arranger",
layoutClass: "enyo-arranger enyo-arranger-fit",
calcArrangementDifference: function(e, t, n, r) {
return this.containerBounds.width;
},
arrange: function(e, t) {
for (var n = 0, r, i, s; r = e[n]; n++) s = n === 0 ? 1 : 0, this.arrangeControl(r, {
opacity: s
});
},
start: function() {
this.inherited(arguments);
var e = this.container.getPanels();
for (var t = 0, n; n = e[t]; t++) {
var r = n.showing;
n.setShowing(t == this.container.fromIndex || t == this.container.toIndex), n.showing && !r && n.resized();
}
},
finish: function() {
this.inherited(arguments);
var e = this.container.getPanels();
for (var t = 0, n; n = e[t]; t++) n.setShowing(t == this.container.toIndex);
},
destroy: function() {
var e = this.container.getPanels();
for (var t = 0, n; n = e[t]; t++) enyo.Arranger.opacifyControl(n, 1), n.showing || n.setShowing(!0);
this.inherited(arguments);
}
});

// CardSlideInArranger.js

enyo.kind({
name: "enyo.CardSlideInArranger",
kind: "CardArranger",
start: function() {
var e = this.container.getPanels();
for (var t = 0, n; n = e[t]; t++) {
var r = n.showing;
n.setShowing(t == this.container.fromIndex || t == this.container.toIndex), n.showing && !r && n.resized();
}
var i = this.container.fromIndex;
t = this.container.toIndex, this.container.transitionPoints = [ t + "." + i + ".s", t + "." + i + ".f" ];
},
finish: function() {
this.inherited(arguments);
var e = this.container.getPanels();
for (var t = 0, n; n = e[t]; t++) n.setShowing(t == this.container.toIndex);
},
arrange: function(e, t) {
var n = t.split("."), r = n[0], i = n[1], s = n[2] == "s", o = this.containerBounds.width;
for (var u = 0, a = this.container.getPanels(), f, l; f = a[u]; u++) l = o, i == u && (l = s ? 0 : -o), r == u && (l = s ? o : 0), i == u && i == r && (l = 0), this.arrangeControl(f, {
left: l
});
},
destroy: function() {
var e = this.container.getPanels();
for (var t = 0, n; n = e[t]; t++) enyo.Arranger.positionControl(n, {
left: null
});
this.inherited(arguments);
}
});

// CarouselArranger.js

enyo.kind({
name: "enyo.CarouselArranger",
kind: "Arranger",
size: function() {
var e = this.container.getPanels(), t = this.containerPadding = this.container.hasNode() ? enyo.dom.calcPaddingExtents(this.container.node) : {}, n = this.containerBounds, r, i, s, o, u;
n.height -= t.top + t.bottom, n.width -= t.left + t.right;
var a;
for (r = 0, s = 0; u = e[r]; r++) o = enyo.dom.calcMarginExtents(u.hasNode()), u.width = u.getBounds().width, u.marginWidth = o.right + o.left, s += (u.fit ? 0 : u.width) + u.marginWidth, u.fit && (a = u);
if (a) {
var f = n.width - s;
a.width = f >= 0 ? f : a.width;
}
for (r = 0, i = t.left; u = e[r]; r++) u.setBounds({
top: t.top,
bottom: t.bottom,
width: u.fit ? u.width : null
});
},
arrange: function(e, t) {
this.container.wrap ? this.arrangeWrap(e, t) : this.arrangeNoWrap(e, t);
},
arrangeNoWrap: function(e, t) {
var n, r, i, s, o = this.container.getPanels(), u = this.container.clamp(t), a = this.containerBounds.width;
for (n = u, i = 0; s = o[n]; n++) {
i += s.width + s.marginWidth;
if (i > a) break;
}
var f = a - i, l = 0;
if (f > 0) {
var c = u;
for (n = u - 1, r = 0; s = o[n]; n--) {
r += s.width + s.marginWidth;
if (f - r <= 0) {
l = f - r, u = n;
break;
}
}
}
var h, p;
for (n = 0, p = this.containerPadding.left + l; s = o[n]; n++) h = s.width + s.marginWidth, n < u ? this.arrangeControl(s, {
left: -h
}) : (this.arrangeControl(s, {
left: Math.floor(p)
}), p += h);
},
arrangeWrap: function(e, t) {
for (var n = 0, r = this.containerPadding.left, i, s; s = e[n]; n++) this.arrangeControl(s, {
left: r
}), r += s.width + s.marginWidth;
},
calcArrangementDifference: function(e, t, n, r) {
var i = Math.abs(e % this.c$.length);
return t[i].left - r[i].left;
},
destroy: function() {
var e = this.container.getPanels();
for (var t = 0, n; n = e[t]; t++) enyo.Arranger.positionControl(n, {
left: null,
top: null
}), n.applyStyle("top", null), n.applyStyle("bottom", null), n.applyStyle("left", null), n.applyStyle("width", null);
this.inherited(arguments);
}
});

// CollapsingArranger.js

enyo.kind({
name: "enyo.CollapsingArranger",
kind: "CarouselArranger",
size: function() {
this.clearLastSize(), this.inherited(arguments);
},
clearLastSize: function() {
for (var e = 0, t = this.container.getPanels(), n; n = t[e]; e++) n._fit && e != t.length - 1 && (n.applyStyle("width", null), n._fit = null);
},
arrange: function(e, t) {
var n = this.container.getPanels();
for (var r = 0, i = this.containerPadding.left, s, o; o = n[r]; r++) this.arrangeControl(o, {
left: i
}), r >= t && (i += o.width + o.marginWidth), r == n.length - 1 && t < 0 && this.arrangeControl(o, {
left: i - t
});
},
calcArrangementDifference: function(e, t, n, r) {
var i = this.container.getPanels().length - 1;
return Math.abs(r[i].left - t[i].left);
},
flowControl: function(e, t) {
this.inherited(arguments);
if (this.container.realtimeFit) {
var n = this.container.getPanels(), r = n.length - 1, i = n[r];
e == i && this.fitControl(e, t.left);
}
},
finish: function() {
this.inherited(arguments);
if (!this.container.realtimeFit && this.containerBounds) {
var e = this.container.getPanels(), t = this.container.arrangement, n = e.length - 1, r = e[n];
this.fitControl(r, t[n].left);
}
},
fitControl: function(e, t) {
e._fit = !0, e.applyStyle("width", this.containerBounds.width - t + "px"), e.resized();
}
});

// OtherArrangers.js

enyo.kind({
name: "enyo.LeftRightArranger",
kind: "Arranger",
margin: 40,
axisSize: "width",
offAxisSize: "height",
axisPosition: "left",
constructor: function() {
this.inherited(arguments), this.margin = this.container.margin != null ? this.container.margin : this.margin;
},
size: function() {
var e = this.container.getPanels(), t = this.containerBounds[this.axisSize], n = t - this.margin - this.margin;
for (var r = 0, i, s; s = e[r]; r++) i = {}, i[this.axisSize] = n, i[this.offAxisSize] = "100%", s.setBounds(i);
},
start: function() {
this.inherited(arguments);
var e = this.container.fromIndex, t = this.container.toIndex, n = this.getOrderedControls(t), r = Math.floor(n.length / 2);
for (var i = 0, s; s = n[i]; i++) e > t ? i == n.length - r ? s.applyStyle("z-index", 0) : s.applyStyle("z-index", 1) : i == n.length - 1 - r ? s.applyStyle("z-index", 0) : s.applyStyle("z-index", 1);
},
arrange: function(e, t) {
var n, r, i, s;
if (this.container.getPanels().length == 1) {
s = {}, s[this.axisPosition] = this.margin, this.arrangeControl(this.container.getPanels()[0], s);
return;
}
var o = Math.floor(this.container.getPanels().length / 2), u = this.getOrderedControls(Math.floor(t) - o), a = this.containerBounds[this.axisSize] - this.margin - this.margin, f = this.margin - a * o;
for (n = 0; r = u[n]; n++) s = {}, s[this.axisPosition] = f, this.arrangeControl(r, s), f += a;
},
calcArrangementDifference: function(e, t, n, r) {
if (this.container.getPanels().length == 1) return 0;
var i = Math.abs(e % this.c$.length);
return t[i][this.axisPosition] - r[i][this.axisPosition];
},
destroy: function() {
var e = this.container.getPanels();
for (var t = 0, n; n = e[t]; t++) enyo.Arranger.positionControl(n, {
left: null,
top: null
}), enyo.Arranger.opacifyControl(n, 1), n.applyStyle("left", null), n.applyStyle("top", null), n.applyStyle("height", null), n.applyStyle("width", null);
this.inherited(arguments);
}
}), enyo.kind({
name: "enyo.TopBottomArranger",
kind: "LeftRightArranger",
dragProp: "ddy",
dragDirectionProp: "yDirection",
canDragProp: "vertical",
axisSize: "height",
offAxisSize: "width",
axisPosition: "top"
}), enyo.kind({
name: "enyo.SpiralArranger",
kind: "Arranger",
incrementalPoints: !0,
inc: 20,
size: function() {
var e = this.container.getPanels(), t = this.containerBounds, n = this.controlWidth = t.width / 3, r = this.controlHeight = t.height / 3;
for (var i = 0, s; s = e[i]; i++) s.setBounds({
width: n,
height: r
});
},
arrange: function(e, t) {
var n = this.inc;
for (var r = 0, i = e.length, s; s = e[r]; r++) {
var o = Math.cos(r / i * 2 * Math.PI) * r * n + this.controlWidth, u = Math.sin(r / i * 2 * Math.PI) * r * n + this.controlHeight;
this.arrangeControl(s, {
left: o,
top: u
});
}
},
start: function() {
this.inherited(arguments);
var e = this.getOrderedControls(this.container.toIndex);
for (var t = 0, n; n = e[t]; t++) n.applyStyle("z-index", e.length - t);
},
calcArrangementDifference: function(e, t, n, r) {
return this.controlWidth;
},
destroy: function() {
var e = this.container.getPanels();
for (var t = 0, n; n = e[t]; t++) n.applyStyle("z-index", null), enyo.Arranger.positionControl(n, {
left: null,
top: null
}), n.applyStyle("left", null), n.applyStyle("top", null), n.applyStyle("height", null), n.applyStyle("width", null);
this.inherited(arguments);
}
}), enyo.kind({
name: "enyo.GridArranger",
kind: "Arranger",
incrementalPoints: !0,
colWidth: 100,
colHeight: 100,
size: function() {
var e = this.container.getPanels(), t = this.colWidth, n = this.colHeight;
for (var r = 0, i; i = e[r]; r++) i.setBounds({
width: t,
height: n
});
},
arrange: function(e, t) {
var n = this.colWidth, r = this.colHeight, i = Math.max(1, Math.floor(this.containerBounds.width / n)), s;
for (var o = 0, u = 0; u < e.length; o++) for (var a = 0; a < i && (s = e[u]); a++, u++) this.arrangeControl(s, {
left: n * a,
top: r * o
});
},
flowControl: function(e, t) {
this.inherited(arguments), enyo.Arranger.opacifyControl(e, t.top % this.colHeight !== 0 ? .25 : 1);
},
calcArrangementDifference: function(e, t, n, r) {
return this.colWidth;
},
destroy: function() {
var e = this.container.getPanels();
for (var t = 0, n; n = e[t]; t++) enyo.Arranger.positionControl(n, {
left: null,
top: null
}), n.applyStyle("left", null), n.applyStyle("top", null), n.applyStyle("height", null), n.applyStyle("width", null);
this.inherited(arguments);
}
});

// Panels.js

enyo.kind({
name: "enyo.Panels",
classes: "enyo-panels",
published: {
index: 0,
draggable: !0,
animate: !0,
wrap: !1,
arrangerKind: "CardArranger",
narrowFit: !0
},
events: {
onTransitionStart: "",
onTransitionFinish: ""
},
handlers: {
ondragstart: "dragstart",
ondrag: "drag",
ondragfinish: "dragfinish",
onscroll: "domScroll"
},
tools: [ {
kind: "Animator",
onStep: "step",
onEnd: "completed"
} ],
fraction: 0,
create: function() {
this.transitionPoints = [], this.inherited(arguments), this.arrangerKindChanged(), this.narrowFitChanged(), this.indexChanged(), this.setAttribute("onscroll", enyo.bubbler);
},
domScroll: function(e, t) {
this.hasNode() && this.node.scrollLeft > 0 && (this.node.scrollLeft = 0);
},
initComponents: function() {
this.createChrome(this.tools), this.inherited(arguments);
},
arrangerKindChanged: function() {
this.setLayoutKind(this.arrangerKind);
},
narrowFitChanged: function() {
this.addRemoveClass("enyo-panels-fit-narrow", this.narrowFit);
},
removeControl: function(e) {
this.inherited(arguments), this.controls.length > 0 && this.isPanel(e) && (this.setIndex(Math.max(this.index - 1, 0)), this.flow(), this.reflow());
},
isPanel: function() {
return !0;
},
flow: function() {
this.arrangements = [], this.inherited(arguments);
},
reflow: function() {
this.arrangements = [], this.inherited(arguments), this.refresh();
},
getPanels: function() {
var e = this.controlParent || this;
return e.children;
},
getActive: function() {
var e = this.getPanels(), t = this.index % e.length;
return t < 0 ? t += e.length : enyo.nop, e[t];
},
getAnimator: function() {
return this.$.animator;
},
setIndex: function(e) {
this.setPropertyValue("index", e, "indexChanged");
},
setIndexDirect: function(e) {
this.setIndex(e), this.completed();
},
previous: function() {
this.setIndex(this.index - 1);
},
next: function() {
this.setIndex(this.index + 1);
},
clamp: function(e) {
var t = this.getPanels().length - 1;
return this.wrap ? e : Math.max(0, Math.min(e, t));
},
indexChanged: function(e) {
this.lastIndex = e, this.index = this.clamp(this.index), !this.dragging && this.$.animator && (this.$.animator.isAnimating() && this.completed(), this.$.animator.stop(), this.hasNode() && (this.animate ? (this.startTransition(), this.$.animator.play({
startValue: this.fraction
})) : this.refresh()));
},
step: function(e) {
this.fraction = e.value, this.stepTransition();
},
completed: function() {
this.$.animator.isAnimating() && this.$.animator.stop(), this.fraction = 1, this.stepTransition(), this.finishTransition();
},
dragstart: function(e, t) {
if (this.draggable && this.layout && this.layout.canDragEvent(t)) return t.preventDefault(), this.dragstartTransition(t), this.dragging = !0, this.$.animator.stop(), !0;
},
drag: function(e, t) {
this.dragging && (t.preventDefault(), this.dragTransition(t));
},
dragfinish: function(e, t) {
this.dragging && (this.dragging = !1, t.preventTap(), this.dragfinishTransition(t));
},
dragstartTransition: function(e) {
if (!this.$.animator.isAnimating()) {
var t = this.fromIndex = this.index;
this.toIndex = t - (this.layout ? this.layout.calcDragDirection(e) : 0);
} else this.verifyDragTransition(e);
this.fromIndex = this.clamp(this.fromIndex), this.toIndex = this.clamp(this.toIndex), this.fireTransitionStart(), this.layout && this.layout.start();
},
dragTransition: function(e) {
var t = this.layout ? this.layout.calcDrag(e) : 0, n = this.transitionPoints, r = n[0], i = n[n.length - 1], s = this.fetchArrangement(r), o = this.fetchArrangement(i), u = this.layout ? this.layout.drag(t, r, s, i, o) : 0, a = t && !u;
a, this.fraction += u;
var f = this.fraction;
if (f > 1 || f < 0 || a) (f > 0 || a) && this.dragfinishTransition(e), this.dragstartTransition(e), this.fraction = 0;
this.stepTransition();
},
dragfinishTransition: function(e) {
this.verifyDragTransition(e), this.setIndex(this.toIndex), this.dragging && this.fireTransitionFinish();
},
verifyDragTransition: function(e) {
var t = this.layout ? this.layout.calcDragDirection(e) : 0, n = Math.min(this.fromIndex, this.toIndex), r = Math.max(this.fromIndex, this.toIndex);
if (t > 0) {
var i = n;
n = r, r = i;
}
n != this.fromIndex && (this.fraction = 1 - this.fraction), this.fromIndex = n, this.toIndex = r;
},
refresh: function() {
this.$.animator && this.$.animator.isAnimating() && this.$.animator.stop(), this.startTransition(), this.fraction = 1, this.stepTransition(), this.finishTransition();
},
startTransition: function() {
this.fromIndex = this.fromIndex != null ? this.fromIndex : this.lastIndex || 0, this.toIndex = this.toIndex != null ? this.toIndex : this.index, this.layout && this.layout.start(), this.fireTransitionStart();
},
finishTransition: function() {
this.layout && this.layout.finish(), this.transitionPoints = [], this.fraction = 0, this.fromIndex = this.toIndex = null, this.fireTransitionFinish();
},
fireTransitionStart: function() {
var e = this.startTransitionInfo;
this.hasNode() && (!e || e.fromIndex != this.fromIndex || e.toIndex != this.toIndex) && (this.startTransitionInfo = {
fromIndex: this.fromIndex,
toIndex: this.toIndex
}, this.doTransitionStart(enyo.clone(this.startTransitionInfo)));
},
fireTransitionFinish: function() {
var e = this.finishTransitionInfo;
this.hasNode() && (!e || e.fromIndex != this.lastIndex || e.toIndex != this.index) && (this.finishTransitionInfo = {
fromIndex: this.lastIndex,
toIndex: this.index
}, this.doTransitionFinish(enyo.clone(this.finishTransitionInfo))), this.lastIndex = this.index;
},
stepTransition: function() {
if (this.hasNode()) {
var e = this.transitionPoints, t = (this.fraction || 0) * (e.length - 1), n = Math.floor(t);
t -= n;
var r = e[n], i = e[n + 1], s = this.fetchArrangement(r), o = this.fetchArrangement(i);
this.arrangement = s && o ? enyo.Panels.lerp(s, o, t) : s || o, this.arrangement && this.layout && this.layout.flowArrangement();
}
},
fetchArrangement: function(e) {
return e != null && !this.arrangements[e] && this.layout && (this.layout._arrange(e), this.arrangements[e] = this.readArrangement(this.getPanels())), this.arrangements[e];
},
readArrangement: function(e) {
var t = [];
for (var n = 0, r = e, i; i = r[n]; n++) t.push(enyo.clone(i._arranger));
return t;
},
statics: {
isScreenNarrow: function() {
return enyo.dom.getWindowWidth() <= 800;
},
lerp: function(e, t, n) {
var r = [];
for (var i = 0, s = enyo.keys(e), o; o = s[i]; i++) r.push(this.lerpObject(e[o], t[o], n));
return r;
},
lerpObject: function(e, t, n) {
var r = enyo.clone(e), i, s;
if (t) for (var o in e) i = e[o], s = t[o], i != s && (r[o] = i - (i - s) * n);
return r;
}
}
});

// Node.js

enyo.kind({
name: "enyo.Node",
published: {
expandable: !1,
expanded: !1,
icon: "",
onlyIconExpands: !1,
selected: !1
},
style: "padding: 0 0 0 16px;",
content: "Node",
defaultKind: "Node",
classes: "enyo-node",
components: [ {
name: "icon",
kind: "Image",
showing: !1
}, {
kind: "Control",
name: "caption",
Xtag: "span",
style: "display: inline-block; padding: 4px;",
allowHtml: !0
}, {
kind: "Control",
name: "extra",
tag: "span",
allowHtml: !0
} ],
childClient: [ {
kind: "Control",
name: "box",
classes: "enyo-node-box",
Xstyle: "border: 1px solid orange;",
components: [ {
kind: "Control",
name: "client",
classes: "enyo-node-client",
Xstyle: "border: 1px solid lightblue;"
} ]
} ],
handlers: {
ondblclick: "dblclick"
},
events: {
onNodeTap: "nodeTap",
onNodeDblClick: "nodeDblClick",
onExpand: "nodeExpand",
onDestroyed: "nodeDestroyed"
},
create: function() {
this.inherited(arguments), this.selectedChanged(), this.iconChanged();
},
destroy: function() {
this.doDestroyed(), this.inherited(arguments);
},
initComponents: function() {
this.expandable && (this.kindComponents = this.kindComponents.concat(this.childClient)), this.inherited(arguments);
},
contentChanged: function() {
this.$.caption.setContent(this.content);
},
iconChanged: function() {
this.$.icon.setSrc(this.icon), this.$.icon.setShowing(Boolean(this.icon));
},
selectedChanged: function() {
this.addRemoveClass("enyo-selected", this.selected);
},
rendered: function() {
this.inherited(arguments), this.expandable && !this.expanded && this.quickCollapse();
},
addNodes: function(e) {
this.destroyClientControls();
for (var t = 0, n; n = e[t]; t++) this.createComponent(n);
this.$.client.render();
},
addTextNodes: function(e) {
this.destroyClientControls();
for (var t = 0, n; n = e[t]; t++) this.createComponent({
content: n
});
this.$.client.render();
},
tap: function(e, t) {
return this.onlyIconExpands ? t.target == this.$.icon.hasNode() ? this.toggleExpanded() : this.doNodeTap() : (this.toggleExpanded(), this.doNodeTap()), !0;
},
dblclick: function(e, t) {
return this.doNodeDblClick(), !0;
},
toggleExpanded: function() {
this.setExpanded(!this.expanded);
},
quickCollapse: function() {
this.removeClass("enyo-animate"), this.$.box.applyStyle("height", "0");
var e = this.$.client.getBounds().height;
this.$.client.setBounds({
top: -e
});
},
_expand: function() {
this.addClass("enyo-animate");
var e = this.$.client.getBounds().height;
this.$.box.setBounds({
height: e
}), this.$.client.setBounds({
top: 0
}), setTimeout(enyo.bind(this, function() {
this.expanded && (this.removeClass("enyo-animate"), this.$.box.applyStyle("height", "auto"));
}), 225);
},
_collapse: function() {
this.removeClass("enyo-animate");
var e = this.$.client.getBounds().height;
this.$.box.setBounds({
height: e
}), setTimeout(enyo.bind(this, function() {
this.addClass("enyo-animate"), this.$.box.applyStyle("height", "0"), this.$.client.setBounds({
top: -e
});
}), 25);
},
expandedChanged: function(e) {
if (!this.expandable) this.expanded = !1; else {
var t = {
expanded: this.expanded
};
this.doExpand(t), t.wait || this.effectExpanded();
}
},
effectExpanded: function() {
this.$.client && (this.expanded ? this._expand() : this._collapse());
}
});

// ImageView.js

enyo.kind({
name: "enyo.ImageView",
kind: enyo.Scroller,
touchOverscroll: !1,
thumb: !1,
animate: !0,
verticalDragPropagation: !0,
horizontalDragPropagation: !0,
published: {
scale: "auto",
disableZoom: !1,
src: undefined
},
events: {
onZoom: ""
},
touch: !0,
preventDragPropagation: !1,
handlers: {
ondragstart: "dragPropagation"
},
components: [ {
name: "animator",
kind: "Animator",
onStep: "zoomAnimationStep",
onEnd: "zoomAnimationEnd"
}, {
name: "viewport",
style: "overflow:hidden;min-height:100%;min-width:100%;",
classes: "enyo-fit",
ongesturechange: "gestureTransform",
ongestureend: "saveState",
ontap: "singleTap",
ondblclick: "doubleClick",
onmousewheel: "mousewheel",
components: [ {
kind: "Image",
ondown: "down"
} ]
} ],
create: function() {
this.inherited(arguments), this.canTransform = enyo.dom.canTransform(), this.canTransform || this.$.image.applyStyle("position", "relative"), this.canAccelerate = enyo.dom.canAccelerate(), this.bufferImage = new Image, this.bufferImage.onload = enyo.bind(this, "imageLoaded"), this.bufferImage.onerror = enyo.bind(this, "imageError"), this.srcChanged(), this.getStrategy().setDragDuringGesture(!1);
},
down: function(e, t) {
t.preventDefault();
},
dragPropagation: function(e, t) {
var n = this.getStrategy().getScrollBounds(), r = n.top === 0 && t.dy > 0 || n.top >= n.maxTop - 2 && t.dy < 0, i = n.left === 0 && t.dx > 0 || n.left >= n.maxLeft - 2 && t.dx < 0;
return !(r && this.verticalDragPropagation || i && this.horizontalDragPropagation);
},
mousewheel: function(e, t) {
t.pageX |= t.clientX + t.target.scrollLeft, t.pageY |= t.clientY + t.target.scrollTop;
var n = (this.maxScale - this.minScale) / 10, r = this.scale;
if (t.wheelDelta > 0 || t.detail < 0) this.scale = this.limitScale(this.scale + n); else if (t.wheelDelta < 0 || t.detail > 0) this.scale = this.limitScale(this.scale - n);
return this.eventPt = this.calcEventLocation(t), this.transformImage(this.scale), r != this.scale && this.doZoom({
scale: this.scale
}), this.ratioX = this.ratioY = null, t.preventDefault(), !0;
},
srcChanged: function() {
this.src && this.src.length > 0 && this.bufferImage && this.src != this.bufferImage.src && (this.bufferImage.src = this.src);
},
imageLoaded: function(e) {
this.originalWidth = this.bufferImage.width, this.originalHeight = this.bufferImage.height, this.scaleChanged(), this.$.image.setSrc(this.bufferImage.src), enyo.dom.transformValue(this.getStrategy().$.client, "translate3d", "0px, 0px, 0");
},
resizeHandler: function() {
this.inherited(arguments), this.$.image.src && this.scaleChanged();
},
scaleChanged: function() {
var e = this.hasNode();
if (e) {
this.containerWidth = e.clientWidth, this.containerHeight = e.clientHeight;
var t = this.containerWidth / this.originalWidth, n = this.containerHeight / this.originalHeight;
this.minScale = Math.min(t, n), this.maxScale = this.minScale * 3 < 1 ? 1 : this.minScale * 3, this.scale == "auto" ? this.scale = this.minScale : this.scale == "width" ? this.scale = t : this.scale == "height" ? this.scale = n : (this.maxScale = Math.max(this.maxScale, this.scale), this.scale = this.limitScale(this.scale));
}
this.eventPt = this.calcEventLocation(), this.transformImage(this.scale);
},
imageError: function(e) {
enyo.error("Error loading image: " + this.src), this.bubble("onerror", e);
},
gestureTransform: function(e, t) {
this.eventPt = this.calcEventLocation(t), this.transformImage(this.limitScale(this.scale * t.scale));
},
calcEventLocation: function(e) {
var t = {
x: 0,
y: 0
};
if (e && this.hasNode()) {
var n = this.node.getBoundingClientRect();
t.x = Math.round(e.pageX - n.left - this.imageBounds.x), t.x = Math.max(0, Math.min(this.imageBounds.width, t.x)), t.y = Math.round(e.pageY - n.top - this.imageBounds.y), t.y = Math.max(0, Math.min(this.imageBounds.height, t.y));
}
return t;
},
transformImage: function(e) {
this.tapped = !1;
var t = this.imageBounds || this.innerImageBounds(e);
this.imageBounds = this.innerImageBounds(e), this.scale > this.minScale ? this.$.viewport.applyStyle("cursor", "move") : this.$.viewport.applyStyle("cursor", null), this.$.viewport.setBounds({
width: this.imageBounds.width + "px",
height: this.imageBounds.height + "px"
}), this.ratioX = this.ratioX || (this.eventPt.x + this.getScrollLeft()) / t.width, this.ratioY = this.ratioY || (this.eventPt.y + this.getScrollTop()) / t.height;
var n, r;
this.$.animator.ratioLock ? (n = this.$.animator.ratioLock.x * this.imageBounds.width - this.containerWidth / 2, r = this.$.animator.ratioLock.y * this.imageBounds.height - this.containerHeight / 2) : (n = this.ratioX * this.imageBounds.width - this.eventPt.x, r = this.ratioY * this.imageBounds.height - this.eventPt.y), n = Math.max(0, Math.min(this.imageBounds.width - this.containerWidth, n)), r = Math.max(0, Math.min(this.imageBounds.height - this.containerHeight, r));
if (this.canTransform) {
var i = {
scale: e
};
this.canAccelerate ? i = enyo.mixin({
translate3d: Math.round(this.imageBounds.left) + "px, " + Math.round(this.imageBounds.top) + "px, 0px"
}, i) : i = enyo.mixin({
translate: this.imageBounds.left + "px, " + this.imageBounds.top + "px"
}, i), enyo.dom.transform(this.$.image, i);
} else this.$.image.setBounds({
width: this.imageBounds.width + "px",
height: this.imageBounds.height + "px",
left: this.imageBounds.left + "px",
top: this.imageBounds.top + "px"
});
this.setScrollLeft(n), this.setScrollTop(r);
},
limitScale: function(e) {
return this.disableZoom ? e = this.scale : e > this.maxScale ? e = this.maxScale : e < this.minScale && (e = this.minScale), e;
},
innerImageBounds: function(e) {
var t = this.originalWidth * e, n = this.originalHeight * e, r = {
x: 0,
y: 0,
transX: 0,
transY: 0
};
return t < this.containerWidth && (r.x += (this.containerWidth - t) / 2), n < this.containerHeight && (r.y += (this.containerHeight - n) / 2), this.canTransform && (r.transX -= (this.originalWidth - t) / 2, r.transY -= (this.originalHeight - n) / 2), {
left: r.x + r.transX,
top: r.y + r.transY,
width: t,
height: n,
x: r.x,
y: r.y
};
},
saveState: function(e, t) {
var n = this.scale;
this.scale *= t.scale, this.scale = this.limitScale(this.scale), n != this.scale && this.doZoom({
scale: this.scale
}), this.ratioX = this.ratioY = null;
},
doubleClick: function(e, t) {
enyo.platform.ie == 8 && (this.tapped = !0, t.pageX = t.clientX + t.target.scrollLeft, t.pageY = t.clientY + t.target.scrollTop, this.singleTap(e, t), t.preventDefault());
},
singleTap: function(e, t) {
setTimeout(enyo.bind(this, function() {
this.tapped = !1;
}), 300), this.tapped ? (this.tapped = !1, this.smartZoom(e, t)) : this.tapped = !0;
},
smartZoom: function(e, t) {
var n = this.hasNode(), r = this.$.image.hasNode();
if (n && r && this.hasNode() && !this.disableZoom) {
var i = this.scale;
this.scale != this.minScale ? this.scale = this.minScale : this.scale = this.maxScale, this.eventPt = this.calcEventLocation(t);
if (this.animate) {
var s = {
x: (this.eventPt.x + this.getScrollLeft()) / this.imageBounds.width,
y: (this.eventPt.y + this.getScrollTop()) / this.imageBounds.height
};
this.$.animator.play({
duration: 350,
ratioLock: s,
baseScale: i,
deltaScale: this.scale - i
});
} else this.transformImage(this.scale), this.doZoom({
scale: this.scale
});
}
},
zoomAnimationStep: function(e, t) {
var n = this.$.animator.baseScale + this.$.animator.deltaScale * this.$.animator.value;
this.transformImage(n);
},
zoomAnimationEnd: function(e, t) {
this.doZoom({
scale: this.scale
}), this.$.animator.ratioLock = undefined;
}
});

// ImageCarousel.js

enyo.kind({
name: "enyo.ImageCarousel",
kind: enyo.Panels,
arrangerKind: "enyo.CarouselArranger",
defaultScale: "auto",
disableZoom: !1,
lowMemory: !1,
published: {
images: []
},
handlers: {
onTransitionStart: "transitionStart",
onTransitionFinish: "transitionFinish"
},
create: function() {
this.inherited(arguments), this.imageCount = this.images.length, this.images.length > 0 && (this.initContainers(), this.loadNearby());
},
initContainers: function() {
for (var e = 0; e < this.images.length; e++) this.$["container" + e] || (this.createComponent({
name: "container" + e,
style: "height:100%; width:100%;"
}), this.$["container" + e].render());
for (e = this.images.length; e < this.imageCount; e++) this.$["image" + e] && this.$["image" + e].destroy(), this.$["container" + e].destroy();
this.imageCount = this.images.length;
},
loadNearby: function() {
this.images.length > 0 && (this.loadImageView(this.index - 1), this.loadImageView(this.index), this.loadImageView(this.index + 1));
},
loadImageView: function(e) {
return this.wrap && (e = (e % this.images.length + this.images.length) % this.images.length), e >= 0 && e <= this.images.length - 1 && (this.$["image" + e] ? (this.$["image" + e].src != this.images[e] && this.$["image" + e].setSrc(this.images[e]), this.$["image" + e].setScale(this.defaultScale), this.$["image" + e].setDisableZoom(this.disableZoom)) : (this.$["container" + e].createComponent({
name: "image" + e,
kind: "ImageView",
scale: this.defaultScale,
disableZoom: this.disableZoom,
src: this.images[e],
verticalDragPropagation: !1,
style: "height:100%; width:100%;"
}, {
owner: this
}), this.$["image" + e].render())), this.$["image" + e];
},
setImages: function(e) {
this.setPropertyValue("images", e, "imagesChanged");
},
imagesChanged: function() {
this.initContainers(), this.loadNearby();
},
indexChanged: function() {
this.loadNearby(), this.lowMemory && this.cleanupMemory(), this.inherited(arguments);
},
transitionStart: function(e, t) {
if (t.fromIndex == t.toIndex) return !0;
},
transitionFinish: function(e, t) {
this.loadImageView(this.index - 1), this.loadImageView(this.index + 1), this.lowMemory && this.cleanupMemory();
},
getActiveImage: function() {
return this.getImageByIndex(this.index);
},
getImageByIndex: function(e) {
return this.$["image" + e] || this.loadImageView(e);
},
cleanupMemory: function() {
for (var e = 0; e < this.images.length; e++) (e < this.index - 1 || e > this.index + 1) && this.$["image" + e] && this.$["image" + e].destroy();
}
});

// Icon.js

enyo.kind({
name: "onyx.Icon",
published: {
src: "",
disabled: !1
},
classes: "onyx-icon",
create: function() {
this.inherited(arguments), this.src && this.srcChanged(), this.disabledChanged();
},
disabledChanged: function() {
this.addRemoveClass("disabled", this.disabled);
},
srcChanged: function() {
this.applyStyle("background-image", "url(" + enyo.path.rewrite(this.src) + ")");
}
});

// Button.js

enyo.kind({
name: "onyx.Button",
kind: "enyo.Button",
classes: "onyx-button enyo-unselectable"
});

// IconButton.js

enyo.kind({
name: "onyx.IconButton",
kind: "onyx.Icon",
published: {
active: !1
},
classes: "onyx-icon-button",
rendered: function() {
this.inherited(arguments), this.activeChanged();
},
tap: function() {
if (this.disabled) return !0;
this.setActive(!0);
},
activeChanged: function() {
this.bubble("onActivate");
}
});

// Checkbox.js

enyo.kind({
name: "onyx.Checkbox",
classes: "onyx-checkbox",
kind: enyo.Checkbox,
tag: "div",
handlers: {
ondown: "downHandler",
onclick: ""
},
downHandler: function(e, t) {
return this.disabled || (this.setChecked(!this.getChecked()), this.bubble("onchange")), !0;
},
tap: function(e, t) {
return !this.disabled;
}
});

// Drawer.js

enyo.kind({
name: "onyx.Drawer",
published: {
open: !0,
orient: "v",
animated: !0
},
style: "overflow: hidden; position: relative;",
tools: [ {
kind: "Animator",
onStep: "animatorStep",
onEnd: "animatorEnd"
}, {
name: "client",
style: "position: relative;",
classes: "enyo-border-box"
} ],
create: function() {
this.inherited(arguments), this.animatedChanged(), this.openChanged();
},
initComponents: function() {
this.createChrome(this.tools), this.inherited(arguments);
},
animatedChanged: function() {
!this.animated && this.hasNode() && this.$.animator.isAnimating() && (this.$.animator.stop(), this.animatorEnd());
},
openChanged: function() {
this.$.client.show();
if (this.hasNode()) if (this.$.animator.isAnimating()) this.$.animator.reverse(); else {
var e = this.orient == "v", t = e ? "height" : "width", n = e ? "top" : "left";
this.applyStyle(t, null);
var r = this.hasNode()[e ? "scrollHeight" : "scrollWidth"];
this.animated ? this.$.animator.play({
startValue: this.open ? 0 : r,
endValue: this.open ? r : 0,
dimension: t,
position: n
}) : this.animatorEnd();
} else this.$.client.setShowing(this.open);
},
animatorStep: function(e) {
if (this.hasNode()) {
var t = e.dimension;
this.node.style[t] = this.domStyles[t] = e.value + "px";
}
var n = this.$.client.hasNode();
if (n) {
var r = e.position, i = this.open ? e.endValue : e.startValue;
n.style[r] = this.$.client.domStyles[r] = e.value - i + "px";
}
this.container && this.container.resized();
},
animatorEnd: function() {
if (!this.open) this.$.client.hide(); else {
var e = this.orient == "v", t = e ? "height" : "width", n = e ? "top" : "left", r = this.$.client.hasNode();
r && (r.style[n] = this.$.client.domStyles[n] = null), this.node && (this.node.style[t] = this.domStyles[t] = null);
}
this.container && this.container.resized();
}
});

// Grabber.js

enyo.kind({
name: "onyx.Grabber",
classes: "onyx-grabber"
});

// Groupbox.js

enyo.kind({
name: "onyx.Groupbox",
classes: "onyx-groupbox"
}), enyo.kind({
name: "onyx.GroupboxHeader",
classes: "onyx-groupbox-header"
});

// Input.js

enyo.kind({
name: "onyx.Input",
kind: "enyo.Input",
classes: "onyx-input"
});

// Popup.js

enyo.kind({
name: "onyx.Popup",
kind: "Popup",
classes: "onyx-popup",
published: {
scrimWhenModal: !0,
scrim: !1,
scrimClassName: ""
},
statics: {
count: 0
},
defaultZ: 120,
showingChanged: function() {
this.showing ? (onyx.Popup.count++, this.applyZIndex()) : onyx.Popup.count > 0 && onyx.Popup.count--, this.showHideScrim(this.showing), this.inherited(arguments);
},
showHideScrim: function(e) {
if (this.floating && (this.scrim || this.modal && this.scrimWhenModal)) {
var t = this.getScrim();
if (e) {
var n = this.getScrimZIndex();
this._scrimZ = n, t.showAtZIndex(n);
} else t.hideAtZIndex(this._scrimZ);
enyo.call(t, "addRemoveClass", [ this.scrimClassName, t.showing ]);
}
},
getScrimZIndex: function() {
return this.findZIndex() - 1;
},
getScrim: function() {
return this.modal && this.scrimWhenModal && !this.scrim ? onyx.scrimTransparent.make() : onyx.scrim.make();
},
applyZIndex: function() {
this._zIndex = onyx.Popup.count * 2 + this.findZIndex() + 1, this.applyStyle("z-index", this._zIndex);
},
findZIndex: function() {
var e = this.defaultZ;
return this._zIndex ? e = this._zIndex : this.hasNode() && (e = Number(enyo.dom.getComputedStyleValue(this.node, "z-index")) || e), this._zIndex = e;
}
});

// TextArea.js

enyo.kind({
name: "onyx.TextArea",
kind: "enyo.TextArea",
classes: "onyx-textarea"
});

// RichText.js

enyo.kind({
name: "onyx.RichText",
kind: "enyo.RichText",
classes: "onyx-richtext"
});

// InputDecorator.js

enyo.kind({
name: "onyx.InputDecorator",
kind: "enyo.ToolDecorator",
tag: "label",
classes: "onyx-input-decorator",
published: {
alwaysLooksFocused: !1
},
handlers: {
onDisabledChange: "disabledChange",
onfocus: "receiveFocus",
onblur: "receiveBlur"
},
create: function() {
this.inherited(arguments), this.updateFocus(!1);
},
alwaysLooksFocusedChanged: function(e) {
this.updateFocus(this.focus);
},
updateFocus: function(e) {
this.focused = e, this.addRemoveClass("onyx-focused", this.alwaysLooksFocused || this.focused);
},
receiveFocus: function() {
this.updateFocus(!0);
},
receiveBlur: function() {
this.updateFocus(!1);
},
disabledChange: function(e, t) {
this.addRemoveClass("onyx-disabled", t.originator.disabled);
}
});

// Tooltip.js

enyo.kind({
name: "onyx.Tooltip",
kind: "onyx.Popup",
classes: "onyx-tooltip below left-arrow",
autoDismiss: !1,
showDelay: 500,
defaultLeft: -6,
handlers: {
onRequestShowTooltip: "requestShow",
onRequestHideTooltip: "requestHide"
},
requestShow: function() {
return this.showJob = setTimeout(enyo.bind(this, "show"), this.showDelay), !0;
},
cancelShow: function() {
clearTimeout(this.showJob);
},
requestHide: function() {
return this.cancelShow(), this.inherited(arguments);
},
showingChanged: function() {
this.cancelShow(), this.adjustPosition(!0), this.inherited(arguments);
},
applyPosition: function(e) {
var t = "";
for (var n in e) t += n + ":" + e[n] + (isNaN(e[n]) ? "; " : "px; ");
this.addStyles(t);
},
adjustPosition: function(e) {
if (this.showing && this.hasNode()) {
var t = this.node.getBoundingClientRect();
t.top + t.height > window.innerHeight ? (this.addRemoveClass("below", !1), this.addRemoveClass("above", !0)) : (this.addRemoveClass("above", !1), this.addRemoveClass("below", !0)), t.left + t.width > window.innerWidth && (this.applyPosition({
"margin-left": -t.width,
bottom: "auto"
}), this.addRemoveClass("left-arrow", !1), this.addRemoveClass("right-arrow", !0));
}
},
resizeHandler: function() {
this.applyPosition({
"margin-left": this.defaultLeft,
bottom: "auto"
}), this.addRemoveClass("left-arrow", !0), this.addRemoveClass("right-arrow", !1), this.adjustPosition(!0), this.inherited(arguments);
}
});

// TooltipDecorator.js

enyo.kind({
name: "onyx.TooltipDecorator",
defaultKind: "onyx.Button",
classes: "onyx-popup-decorator",
handlers: {
onenter: "enter",
onleave: "leave"
},
enter: function() {
this.requestShowTooltip();
},
leave: function() {
this.requestHideTooltip();
},
tap: function() {
this.requestHideTooltip();
},
requestShowTooltip: function() {
this.waterfallDown("onRequestShowTooltip");
},
requestHideTooltip: function() {
this.waterfallDown("onRequestHideTooltip");
}
});

// MenuDecorator.js

enyo.kind({
name: "onyx.MenuDecorator",
kind: "onyx.TooltipDecorator",
defaultKind: "onyx.Button",
classes: "onyx-popup-decorator enyo-unselectable",
handlers: {
onActivate: "activated",
onHide: "menuHidden"
},
activated: function(e, t) {
this.requestHideTooltip(), t.originator.active && (this.menuActive = !0, this.activator = t.originator, this.activator.addClass("active"), this.requestShowMenu());
},
requestShowMenu: function() {
this.waterfallDown("onRequestShowMenu", {
activator: this.activator
});
},
requestHideMenu: function() {
this.waterfallDown("onRequestHideMenu");
},
menuHidden: function() {
this.menuActive = !1, this.activator && (this.activator.setActive(!1), this.activator.removeClass("active"));
},
enter: function(e) {
this.menuActive || this.inherited(arguments);
},
leave: function(e, t) {
this.menuActive || this.inherited(arguments);
}
});

// Menu.js

enyo.kind({
name: "onyx.Menu",
kind: "onyx.Popup",
modal: !0,
defaultKind: "onyx.MenuItem",
classes: "onyx-menu",
published: {
maxHeight: 200,
scrolling: !0
},
handlers: {
onActivate: "itemActivated",
onRequestShowMenu: "requestMenuShow",
onRequestHideMenu: "requestHide"
},
childComponents: [ {
name: "client",
kind: "enyo.Scroller",
strategyKind: "TouchScrollStrategy"
} ],
showOnTop: !1,
scrollerName: "client",
create: function() {
this.inherited(arguments), this.maxHeightChanged();
},
initComponents: function() {
this.scrolling ? this.createComponents(this.childComponents, {
isChrome: !0
}) : enyo.nop, this.inherited(arguments);
},
getScroller: function() {
return this.$[this.scrollerName];
},
maxHeightChanged: function() {
this.scrolling ? this.getScroller().setMaxHeight(this.maxHeight + "px") : enyo.nop;
},
itemActivated: function(e, t) {
return t.originator.setActive(!1), !0;
},
showingChanged: function() {
this.inherited(arguments), this.scrolling ? this.getScroller().setShowing(this.showing) : enyo.nop, this.adjustPosition(!0);
},
requestMenuShow: function(e, t) {
if (this.floating) {
var n = t.activator.hasNode();
if (n) {
var r = this.activatorOffset = this.getPageOffset(n);
this.applyPosition({
top: r.top + (this.showOnTop ? 0 : r.height),
left: r.left,
width: r.width
});
}
}
return this.show(), !0;
},
applyPosition: function(e) {
var t = "";
for (n in e) t += n + ":" + e[n] + (isNaN(e[n]) ? "; " : "px; ");
this.addStyles(t);
},
getPageOffset: function(e) {
var t = e.getBoundingClientRect(), n = window.pageYOffset === undefined ? document.documentElement.scrollTop : window.pageYOffset, r = window.pageXOffset === undefined ? document.documentElement.scrollLeft : window.pageXOffset, i = t.height === undefined ? t.bottom - t.top : t.height, s = t.width === undefined ? t.right - t.left : t.width;
return {
top: t.top + n,
left: t.left + r,
height: i,
width: s
};
},
adjustPosition: function() {
if (this.showing && this.hasNode()) {
this.scrolling && !this.showOnTop ? this.getScroller().setMaxHeight(this.maxHeight + "px") : enyo.nop, this.removeClass("onyx-menu-up"), this.floating ? enyo.noop : this.applyPosition({
left: "auto"
});
var e = this.node.getBoundingClientRect(), t = e.height === undefined ? e.bottom - e.top : e.height, n = window.innerHeight === undefined ? document.documentElement.clientHeight : window.innerHeight, r = window.innerWidth === undefined ? document.documentElement.clientWidth : window.innerWidth;
this.menuUp = e.top + t > n && n - e.bottom < e.top - t, this.addRemoveClass("onyx-menu-up", this.menuUp);
if (this.floating) {
var i = this.activatorOffset;
this.menuUp ? this.applyPosition({
top: i.top - t + (this.showOnTop ? i.height : 0),
bottom: "auto"
}) : e.top < i.top && i.top + (this.showOnTop ? 0 : i.height) + t < n && this.applyPosition({
top: i.top + (this.showOnTop ? 0 : i.height),
bottom: "auto"
});
}
e.right > r && (this.floating ? this.applyPosition({
left: r - e.width
}) : this.applyPosition({
left: -(e.right - r)
})), e.left < 0 && (this.floating ? this.applyPosition({
left: 0,
right: "auto"
}) : this.getComputedStyleValue("right") == "auto" ? this.applyPosition({
left: -e.left
}) : this.applyPosition({
right: e.left
}));
if (this.scrolling && !this.showOnTop) {
e = this.node.getBoundingClientRect();
var s;
this.menuUp ? s = this.maxHeight < e.bottom ? this.maxHeight : e.bottom : s = e.top + this.maxHeight < n ? this.maxHeight : n - e.top, this.getScroller().setMaxHeight(s + "px");
}
}
},
resizeHandler: function() {
this.inherited(arguments), this.adjustPosition();
},
requestHide: function() {
this.setShowing(!1);
}
});

// MenuItem.js

enyo.kind({
name: "onyx.MenuItem",
kind: "enyo.Button",
events: {
onSelect: ""
},
classes: "onyx-menu-item",
tag: "div",
tap: function(e) {
this.inherited(arguments), this.bubble("onRequestHideMenu"), this.doSelect({
selected: this,
content: this.content
});
}
});

// PickerDecorator.js

enyo.kind({
name: "onyx.PickerDecorator",
kind: "onyx.MenuDecorator",
classes: "onyx-picker-decorator",
defaultKind: "onyx.PickerButton",
handlers: {
onChange: "change"
},
change: function(e, t) {
this.waterfallDown("onChange", t);
}
});

// PickerButton.js

enyo.kind({
name: "onyx.PickerButton",
kind: "onyx.Button",
handlers: {
onChange: "change"
},
change: function(e, t) {
this.setContent(t.content);
}
});

// Picker.js

enyo.kind({
name: "onyx.Picker",
kind: "onyx.Menu",
classes: "onyx-picker enyo-unselectable",
published: {
selected: null
},
events: {
onChange: ""
},
floating: !0,
showOnTop: !0,
initComponents: function() {
this.setScrolling(!0), this.inherited(arguments);
},
showingChanged: function() {
this.getScroller().setShowing(this.showing), this.inherited(arguments), this.showing && this.selected && this.scrollToSelected();
},
scrollToSelected: function() {
this.getScroller().scrollToControl(this.selected, !this.menuUp);
},
itemActivated: function(e, t) {
return this.processActivatedItem(t.originator), this.inherited(arguments);
},
processActivatedItem: function(e) {
e.active && this.setSelected(e);
},
selectedChanged: function(e) {
e && e.removeClass("selected"), this.selected && (this.selected.addClass("selected"), this.doChange({
selected: this.selected,
content: this.selected.content
}));
},
resizeHandler: function() {
this.inherited(arguments), this.adjustPosition();
}
});

// FlyweightPicker.js

enyo.kind({
name: "onyx.FlyweightPicker",
kind: "onyx.Picker",
classes: "onyx-flyweight-picker",
published: {
count: 0
},
events: {
onSetupItem: "",
onSelect: ""
},
handlers: {
onSelect: "itemSelect"
},
components: [ {
name: "scroller",
kind: "enyo.Scroller",
strategyKind: "TouchScrollStrategy",
components: [ {
name: "flyweight",
kind: "FlyweightRepeater",
ontap: "itemTap"
} ]
} ],
scrollerName: "scroller",
initComponents: function() {
this.controlParentName = "flyweight", this.inherited(arguments);
},
create: function() {
this.inherited(arguments), this.countChanged();
},
rendered: function() {
this.inherited(arguments), this.selectedChanged();
},
scrollToSelected: function() {
var e = this.$.flyweight.fetchRowNode(this.selected);
this.getScroller().scrollToNode(e, !this.menuUp);
},
countChanged: function() {
this.$.flyweight.count = this.count;
},
processActivatedItem: function(e) {
this.item = e;
},
selectedChanged: function(e) {
if (!this.item) return;
e !== undefined && (this.item.removeClass("selected"), this.$.flyweight.renderRow(e)), this.item.addClass("selected"), this.$.flyweight.renderRow(this.selected), this.item.removeClass("selected");
var t = this.$.flyweight.fetchRowNode(this.selected);
this.doChange({
selected: this.selected,
content: t && t.textContent || this.item.content
});
},
itemTap: function(e, t) {
this.setSelected(t.rowIndex), this.doSelect({
selected: this.item,
content: this.item.content
});
},
itemSelect: function(e, t) {
if (t.originator != this) return !0;
}
});

// DatePicker.js

enyo.kind({
name: "onyx.DatePicker",
classes: "onyx-toolbar-inline",
published: {
disabled: !1,
locale: null,
dayHidden: !1,
monthHidden: !1,
yearHidden: !1,
minYear: 1900,
maxYear: 2099,
value: null
},
events: {
onSelect: ""
},
create: function() {
this.inherited(arguments);
if (!this.locale) try {
this.locale = enyo.g11n.currentLocale().getLocale();
} catch (e) {
this.locale = "en_us";
}
this.initDefaults();
},
initDefaults: function() {
var e;
try {
this._tf = new enyo.g11n.Fmts({
locale: this.locale
}), e = this._tf.getMonthFields();
} catch (t) {
e = [ "Jan", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC" ];
}
this.setupPickers(this._tf ? this._tf.getDateFieldOrder() : "mdy"), this.dayHiddenChanged(), this.monthHiddenChanged(), this.yearHiddenChanged();
var n = this.value = this.value || new Date;
for (var r = 0, i; i = e[r]; r++) this.$.monthPicker.createComponent({
content: i,
value: r,
active: r == n.getMonth()
});
var s = n.getFullYear();
this.$.yearPicker.setSelected(s - this.minYear), this.$.year.setContent(s);
for (r = 1; r <= this.monthLength(n.getYear(), n.getMonth()); r++) this.$.dayPicker.createComponent({
content: r,
value: r,
active: r == n.getDate()
});
},
monthLength: function(e, t) {
return 32 - (new Date(e, t, 32)).getDate();
},
setupYear: function(e, t) {
this.$.year.setContent(this.minYear + t.index);
},
setupPickers: function(e) {
var t = e.split(""), n, r, i;
for (r = 0, i = t.length; r < i; r++) {
n = t[r];
switch (n) {
case "d":
this.createDay();
break;
case "m":
this.createMonth();
break;
case "y":
this.createYear();
break;
default:
}
}
},
createYear: function() {
var e = this.maxYear - this.minYear;
this.createComponent({
kind: "onyx.PickerDecorator",
onSelect: "updateYear",
components: [ {
classes: "onyx-datepicker-year",
name: "yearPickerButton",
disabled: this.disabled
}, {
name: "yearPicker",
kind: "onyx.FlyweightPicker",
count: ++e,
onSetupItem: "setupYear",
components: [ {
name: "year"
} ]
} ]
});
},
createMonth: function() {
this.createComponent({
kind: "onyx.PickerDecorator",
onSelect: "updateMonth",
components: [ {
classes: "onyx-datepicker-month",
name: "monthPickerButton",
disabled: this.disabled
}, {
name: "monthPicker",
kind: "onyx.Picker"
} ]
});
},
createDay: function() {
this.createComponent({
kind: "onyx.PickerDecorator",
onSelect: "updateDay",
components: [ {
classes: "onyx-datepicker-day",
name: "dayPickerButton",
disabled: this.disabled
}, {
name: "dayPicker",
kind: "onyx.Picker"
} ]
});
},
localeChanged: function() {
this.refresh();
},
dayHiddenChanged: function() {
this.$.dayPicker.getParent().setShowing(this.dayHidden ? !1 : !0);
},
monthHiddenChanged: function() {
this.$.monthPicker.getParent().setShowing(this.monthHidden ? !1 : !0);
},
yearHiddenChanged: function() {
this.$.yearPicker.getParent().setShowing(this.yearHidden ? !1 : !0);
},
minYearChanged: function() {
this.refresh();
},
maxYearChanged: function() {
this.refresh();
},
valueChanged: function() {
this.refresh();
},
disabledChanged: function() {
this.yearPickerButton.setDisabled(this.disabled), this.monthPickerButton.setDisabled(this.disabled), this.dayPickerButton.setDisabled(this.disabled);
},
updateDay: function(e, t) {
var n = this.calcDate(this.value.getFullYear(), this.value.getMonth(), t.selected.value);
return this.doSelect({
name: this.name,
value: n
}), this.setValue(n), !0;
},
updateMonth: function(e, t) {
var n = this.calcDate(this.value.getFullYear(), t.selected.value, this.value.getDate());
return this.doSelect({
name: this.name,
value: n
}), this.setValue(n), !0;
},
updateYear: function(e, t) {
if (t.originator.selected != -1) {
var n = this.calcDate(this.minYear + t.originator.selected, this.value.getMonth(), this.value.getDate());
this.doSelect({
name: this.name,
value: n
}), this.setValue(n);
}
return !0;
},
calcDate: function(e, t, n) {
return new Date(e, t, n, this.value.getHours(), this.value.getMinutes(), this.value.getSeconds(), this.value.getMilliseconds());
},
refresh: function() {
this.destroyClientControls(), this.initDefaults(), this.render();
}
});

// TimePicker.js

enyo.kind({
name: "onyx.TimePicker",
classes: "onyx-toolbar-inline",
published: {
disabled: !1,
locale: null,
is24HrMode: null,
value: null
},
events: {
onSelect: ""
},
create: function() {
this.inherited(arguments);
if (!this.locale) try {
this.locale = enyo.g11n.currentLocale().getLocale();
} catch (e) {
this.locale = "en_us";
}
this.initDefaults();
},
initDefaults: function() {
var e, t;
try {
this._tf = new enyo.g11n.Fmts({
locale: this.locale
}), e = this._tf.getAmCaption(), t = this._tf.getPmCaption(), this.is24HrMode == null && (this.is24HrMode = !this._tf.isAmPm());
} catch (n) {
e = "AM", t = "PM", this.is24HrMode = !1;
}
this.setupPickers(this._tf ? this._tf.getTimeFieldOrder() : "hma");
var r = this.value = this.value || new Date, i;
if (!this.is24HrMode) {
var s = r.getHours();
s = s === 0 ? 12 : s;
for (i = 1; i <= 12; i++) this.$.hourPicker.createComponent({
content: i,
value: i,
active: i == (s > 12 ? s % 12 : s)
});
} else for (i = 0; i < 24; i++) this.$.hourPicker.createComponent({
content: i,
value: i,
active: i == r.getHours()
});
for (i = 0; i <= 59; i++) this.$.minutePicker.createComponent({
content: i < 10 ? "0" + i : i,
value: i,
active: i == r.getMinutes()
});
r.getHours() >= 12 ? this.$.ampmPicker.createComponents([ {
content: e
}, {
content: t,
active: !0
} ]) : this.$.ampmPicker.createComponents([ {
content: e,
active: !0
}, {
content: t
} ]), this.$.ampmPicker.getParent().setShowing(!this.is24HrMode);
},
setupPickers: function(e) {
var t = e.split(""), n, r, i;
for (r = 0, i = t.length; r < i; r++) {
n = t[r];
switch (n) {
case "h":
this.createHour();
break;
case "m":
this.createMinute();
break;
case "a":
this.createAmPm();
break;
default:
}
}
},
createHour: function() {
this.createComponent({
kind: "onyx.PickerDecorator",
onSelect: "updateHour",
components: [ {
classes: "onyx-timepicker-hour",
name: "hourPickerButton",
disabled: this.disabled
}, {
name: "hourPicker",
kind: "onyx.Picker"
} ]
});
},
createMinute: function() {
this.createComponent({
kind: "onyx.PickerDecorator",
onSelect: "updateMinute",
components: [ {
classes: "onyx-timepicker-minute",
name: "minutePickerButton",
disabled: this.disabled
}, {
name: "minutePicker",
kind: "onyx.Picker"
} ]
});
},
createAmPm: function() {
this.createComponent({
kind: "onyx.PickerDecorator",
onSelect: "updateAmPm",
components: [ {
classes: "onyx-timepicker-ampm",
name: "ampmPickerButton",
disabled: this.disabled
}, {
name: "ampmPicker",
kind: "onyx.Picker"
} ]
});
},
disabledChanged: function() {
this.$.hourPickerButton.setDisabled(this.disabled), this.$.minutePickerButton.setDisabled(this.disabled), this.$.ampmPickerButton.setDisabled(this.disabled);
},
localeChanged: function() {
this.is24HrMode = null, this.refresh();
},
is24HrModeChanged: function() {
this.refresh();
},
valueChanged: function() {
this.refresh();
},
updateHour: function(e, t) {
var n = t.selected.value;
if (!this.is24HrMode) {
var r = this.$.ampmPicker.getParent().controlAtIndex(0).content;
n = n + (n == 12 ? -12 : 0) + (this.isAm(r) ? 0 : 12);
}
return this.value = this.calcTime(n, this.value.getMinutes()), this.doSelect({
name: this.name,
value: this.value
}), !0;
},
updateMinute: function(e, t) {
return this.value = this.calcTime(this.value.getHours(), t.selected.value), this.doSelect({
name: this.name,
value: this.value
}), !0;
},
updateAmPm: function(e, t) {
var n = this.value.getHours();
return this.is24HrMode || (n += n > 11 ? this.isAm(t.content) ? -12 : 0 : this.isAm(t.content) ? 0 : 12), this.value = this.calcTime(n, this.value.getMinutes()), this.doSelect({
name: this.name,
value: this.value
}), !0;
},
calcTime: function(e, t) {
return new Date(this.value.getFullYear(), this.value.getMonth(), this.value.getDate(), e, t, this.value.getSeconds(), this.value.getMilliseconds());
},
isAm: function(e) {
var t, n, r;
try {
t = this._tf.getAmCaption(), n = this._tf.getPmCaption();
} catch (i) {
t = "AM", n = "PM";
}
return e == t ? !0 : !1;
},
refresh: function() {
this.destroyClientControls(), this.initDefaults(), this.render();
}
});

// RadioButton.js

enyo.kind({
name: "onyx.RadioButton",
kind: "Button",
classes: "onyx-radiobutton"
});

// RadioGroup.js

enyo.kind({
name: "onyx.RadioGroup",
kind: "Group",
defaultKind: "onyx.RadioButton",
highlander: !0
});

// ToggleButton.js

enyo.kind({
name: "onyx.ToggleButton",
classes: "onyx-toggle-button",
published: {
active: !1,
value: !1,
onContent: "On",
offContent: "Off",
disabled: !1
},
events: {
onChange: ""
},
handlers: {
ondragstart: "dragstart",
ondrag: "drag",
ondragfinish: "dragfinish"
},
components: [ {
name: "contentOn",
classes: "onyx-toggle-content on"
}, {
name: "contentOff",
classes: "onyx-toggle-content off"
}, {
classes: "onyx-toggle-button-knob"
} ],
create: function() {
this.inherited(arguments), this.value = Boolean(this.value || this.active), this.onContentChanged(), this.offContentChanged(), this.disabledChanged();
},
rendered: function() {
this.inherited(arguments), this.updateVisualState();
},
updateVisualState: function() {
this.addRemoveClass("off", !this.value), this.$.contentOn.setShowing(this.value), this.$.contentOff.setShowing(!this.value), this.setActive(this.value);
},
valueChanged: function() {
this.updateVisualState(), this.doChange({
value: this.value
});
},
activeChanged: function() {
this.setValue(this.active), this.bubble("onActivate");
},
onContentChanged: function() {
this.$.contentOn.setContent(this.onContent || ""), this.$.contentOn.addRemoveClass("empty", !this.onContent);
},
offContentChanged: function() {
this.$.contentOff.setContent(this.offContent || ""), this.$.contentOff.addRemoveClass("empty", !this.onContent);
},
disabledChanged: function() {
this.addRemoveClass("disabled", this.disabled);
},
updateValue: function(e) {
this.disabled || this.setValue(e);
},
tap: function() {
this.updateValue(!this.value);
},
dragstart: function(e, t) {
if (t.horizontal) return t.preventDefault(), this.dragging = !0, this.dragged = !1, !0;
},
drag: function(e, t) {
if (this.dragging) {
var n = t.dx;
return Math.abs(n) > 10 && (this.updateValue(n > 0), this.dragged = !0), !0;
}
},
dragfinish: function(e, t) {
this.dragging = !1, this.dragged && t.preventTap();
}
});

// ToggleIconButton.js

enyo.kind({
name: "onyx.ToggleIconButton",
kind: "onyx.Icon",
published: {
active: !1,
value: !1
},
events: {
onChange: ""
},
classes: "onyx-icon-button onyx-icon-toggle",
activeChanged: function() {
this.addRemoveClass("active", this.value), this.bubble("onActivate");
},
updateValue: function(e) {
this.disabled || (this.setValue(e), this.doChange({
value: this.value
}));
},
tap: function() {
this.updateValue(!this.value);
},
valueChanged: function() {
this.setActive(this.value);
},
create: function() {
this.inherited(arguments), this.value = Boolean(this.value || this.active);
},
rendered: function() {
this.inherited(arguments), this.valueChanged(), this.removeClass("onyx-icon");
}
});

// Toolbar.js

enyo.kind({
name: "onyx.Toolbar",
classes: "onyx onyx-toolbar onyx-toolbar-inline",
create: function() {
this.inherited(arguments), this.hasClass("onyx-menu-toolbar") && enyo.platform.android >= 4 && this.applyStyle("position", "static");
}
});

// Tooltip.js

enyo.kind({
name: "onyx.Tooltip",
kind: "onyx.Popup",
classes: "onyx-tooltip below left-arrow",
autoDismiss: !1,
showDelay: 500,
defaultLeft: -6,
handlers: {
onRequestShowTooltip: "requestShow",
onRequestHideTooltip: "requestHide"
},
requestShow: function() {
return this.showJob = setTimeout(enyo.bind(this, "show"), this.showDelay), !0;
},
cancelShow: function() {
clearTimeout(this.showJob);
},
requestHide: function() {
return this.cancelShow(), this.inherited(arguments);
},
showingChanged: function() {
this.cancelShow(), this.adjustPosition(!0), this.inherited(arguments);
},
applyPosition: function(e) {
var t = "";
for (var n in e) t += n + ":" + e[n] + (isNaN(e[n]) ? "; " : "px; ");
this.addStyles(t);
},
adjustPosition: function(e) {
if (this.showing && this.hasNode()) {
var t = this.node.getBoundingClientRect();
t.top + t.height > window.innerHeight ? (this.addRemoveClass("below", !1), this.addRemoveClass("above", !0)) : (this.addRemoveClass("above", !1), this.addRemoveClass("below", !0)), t.left + t.width > window.innerWidth && (this.applyPosition({
"margin-left": -t.width,
bottom: "auto"
}), this.addRemoveClass("left-arrow", !1), this.addRemoveClass("right-arrow", !0));
}
},
resizeHandler: function() {
this.applyPosition({
"margin-left": this.defaultLeft,
bottom: "auto"
}), this.addRemoveClass("left-arrow", !0), this.addRemoveClass("right-arrow", !1), this.adjustPosition(!0), this.inherited(arguments);
}
});

// TooltipDecorator.js

enyo.kind({
name: "onyx.TooltipDecorator",
defaultKind: "onyx.Button",
classes: "onyx-popup-decorator",
handlers: {
onenter: "enter",
onleave: "leave"
},
enter: function() {
this.requestShowTooltip();
},
leave: function() {
this.requestHideTooltip();
},
tap: function() {
this.requestHideTooltip();
},
requestShowTooltip: function() {
this.waterfallDown("onRequestShowTooltip");
},
requestHideTooltip: function() {
this.waterfallDown("onRequestHideTooltip");
}
});

// ProgressBar.js

enyo.kind({
name: "onyx.ProgressBar",
classes: "onyx-progress-bar",
published: {
progress: 0,
min: 0,
max: 100,
barClasses: "",
showStripes: !0,
animateStripes: !0
},
events: {
onAnimateProgressFinish: ""
},
components: [ {
name: "progressAnimator",
kind: "Animator",
onStep: "progressAnimatorStep",
onEnd: "progressAnimatorComplete"
}, {
name: "bar",
classes: "onyx-progress-bar-bar"
} ],
create: function() {
this.inherited(arguments), this.progressChanged(), this.barClassesChanged(), this.showStripesChanged(), this.animateStripesChanged();
},
barClassesChanged: function(e) {
this.$.bar.removeClass(e), this.$.bar.addClass(this.barClasses);
},
showStripesChanged: function() {
this.$.bar.addRemoveClass("striped", this.showStripes);
},
animateStripesChanged: function() {
this.$.bar.addRemoveClass("animated", this.animateStripes);
},
progressChanged: function() {
this.progress = this.clampValue(this.min, this.max, this.progress);
var e = this.calcPercent(this.progress);
this.updateBarPosition(e);
},
clampValue: function(e, t, n) {
return Math.max(e, Math.min(n, t));
},
calcRatio: function(e) {
return (e - this.min) / (this.max - this.min);
},
calcPercent: function(e) {
return this.calcRatio(e) * 100;
},
updateBarPosition: function(e) {
this.$.bar.applyStyle("width", e + "%");
},
animateProgressTo: function(e) {
this.$.progressAnimator.play({
startValue: this.progress,
endValue: e,
node: this.hasNode()
});
},
progressAnimatorStep: function(e) {
return this.setProgress(e.value), !0;
},
progressAnimatorComplete: function(e) {
return this.doAnimateProgressFinish(e), !0;
}
});

// ProgressButton.js

enyo.kind({
name: "onyx.ProgressButton",
kind: "onyx.ProgressBar",
classes: "onyx-progress-button",
events: {
onCancel: ""
},
components: [ {
name: "progressAnimator",
kind: "Animator",
onStep: "progressAnimatorStep",
onEnd: "progressAnimatorComplete"
}, {
name: "bar",
classes: "onyx-progress-bar-bar onyx-progress-button-bar"
}, {
name: "client",
classes: "onyx-progress-button-client"
}, {
kind: "onyx.Icon",
src: "$lib/onyx/images/progress-button-cancel.png",
classes: "onyx-progress-button-icon",
ontap: "cancelTap"
} ],
cancelTap: function() {
this.doCancel();
}
});

// Scrim.js

enyo.kind({
name: "onyx.Scrim",
showing: !1,
classes: "onyx-scrim enyo-fit",
floating: !1,
create: function() {
this.inherited(arguments), this.zStack = [], this.floating && this.setParent(enyo.floatingLayer);
},
showingChanged: function() {
this.floating && this.showing && !this.hasNode() && this.render(), this.inherited(arguments);
},
addZIndex: function(e) {
enyo.indexOf(e, this.zStack) < 0 && this.zStack.push(e);
},
removeZIndex: function(e) {
enyo.remove(e, this.zStack);
},
showAtZIndex: function(e) {
this.addZIndex(e), e !== undefined && this.setZIndex(e), this.show();
},
hideAtZIndex: function(e) {
this.removeZIndex(e);
if (!this.zStack.length) this.hide(); else {
var t = this.zStack[this.zStack.length - 1];
this.setZIndex(t);
}
},
setZIndex: function(e) {
this.zIndex = e, this.applyStyle("z-index", e);
},
make: function() {
return this;
}
}), enyo.kind({
name: "onyx.scrimSingleton",
kind: null,
constructor: function(e, t) {
this.instanceName = e, enyo.setObject(this.instanceName, this), this.props = t || {};
},
make: function() {
var e = new onyx.Scrim(this.props);
return enyo.setObject(this.instanceName, e), e;
},
showAtZIndex: function(e) {
var t = this.make();
t.showAtZIndex(e);
},
hideAtZIndex: enyo.nop,
show: function() {
var e = this.make();
e.show();
}
}), new onyx.scrimSingleton("onyx.scrim", {
floating: !0,
classes: "onyx-scrim-translucent"
}), new onyx.scrimSingleton("onyx.scrimTransparent", {
floating: !0,
classes: "onyx-scrim-transparent"
});

// Slider.js

enyo.kind({
name: "onyx.Slider",
kind: "onyx.ProgressBar",
classes: "onyx-slider",
published: {
value: 0,
lockBar: !0,
tappable: !0
},
events: {
onChange: "",
onChanging: "",
onAnimateFinish: ""
},
showStripes: !1,
handlers: {
ondragstart: "dragstart",
ondrag: "drag",
ondragfinish: "dragfinish"
},
moreComponents: [ {
kind: "Animator",
onStep: "animatorStep",
onEnd: "animatorComplete"
}, {
classes: "onyx-slider-taparea"
}, {
name: "knob",
classes: "onyx-slider-knob"
} ],
create: function() {
this.inherited(arguments), this.createComponents(this.moreComponents), this.valueChanged();
},
valueChanged: function() {
this.value = this.clampValue(this.min, this.max, this.value);
var e = this.calcPercent(this.value);
this.updateKnobPosition(e), this.lockBar && this.setProgress(this.value);
},
updateKnobPosition: function(e) {
this.$.knob.applyStyle("left", e + "%");
},
calcKnobPosition: function(e) {
var t = e.clientX - this.hasNode().getBoundingClientRect().left;
return t / this.getBounds().width * (this.max - this.min) + this.min;
},
dragstart: function(e, t) {
if (t.horizontal) return t.preventDefault(), this.dragging = !0, !0;
},
drag: function(e, t) {
if (this.dragging) {
var n = this.calcKnobPosition(t);
return this.setValue(n), this.doChanging({
value: this.value
}), !0;
}
},
dragfinish: function(e, t) {
return this.dragging = !1, t.preventTap(), this.doChange({
value: this.value
}), !0;
},
tap: function(e, t) {
if (this.tappable) {
var n = this.calcKnobPosition(t);
return this.tapped = !0, this.animateTo(n), !0;
}
},
animateTo: function(e) {
this.$.animator.play({
startValue: this.value,
endValue: e,
node: this.hasNode()
});
},
animatorStep: function(e) {
return this.setValue(e.value), !0;
},
animatorComplete: function(e) {
return this.tapped && (this.tapped = !1, this.doChange({
value: this.value
})), this.doAnimateFinish(e), !0;
}
});

// RangeSlider.js

enyo.kind({
name: "onyx.RangeSlider",
kind: "onyx.ProgressBar",
classes: "onyx-slider",
published: {
rangeMin: 0,
rangeMax: 100,
rangeStart: 0,
rangeEnd: 100,
increment: 0,
beginValue: 0,
endValue: 0
},
events: {
onChange: "",
onChanging: ""
},
showStripes: !1,
showLabels: !1,
handlers: {
ondragstart: "dragstart",
ondrag: "drag",
ondragfinish: "dragfinish",
ondown: "down"
},
moreComponents: [ {
name: "startKnob",
classes: "onyx-slider-knob"
}, {
name: "endKnob",
classes: "onyx-slider-knob onyx-range-slider-knob"
} ],
create: function() {
this.inherited(arguments), this.createComponents(this.moreComponents), this.initControls();
},
rendered: function() {
this.inherited(arguments);
var e = this.calcPercent(this.beginValue);
this.updateBarPosition(e);
},
initControls: function() {
this.$.bar.applyStyle("position", "relative"), this.refreshRangeSlider(), this.showLabels && (this.$.startKnob.createComponent({
name: "startLabel",
kind: "onyx.RangeSliderKnobLabel"
}), this.$.endKnob.createComponent({
name: "endLabel",
kind: "onyx.RangeSliderKnobLabel"
}));
},
refreshRangeSlider: function() {
this.beginValue = this.calcKnobPercent(this.rangeStart), this.endValue = this.calcKnobPercent(this.rangeEnd), this.beginValueChanged(), this.endValueChanged();
},
calcKnobRatio: function(e) {
return (e - this.rangeMin) / (this.rangeMax - this.rangeMin);
},
calcKnobPercent: function(e) {
return this.calcKnobRatio(e) * 100;
},
beginValueChanged: function(e) {
if (e === undefined) {
var t = this.calcPercent(this.beginValue);
this.updateKnobPosition(t, this.$.startKnob);
}
},
endValueChanged: function(e) {
if (e === undefined) {
var t = this.calcPercent(this.endValue);
this.updateKnobPosition(t, this.$.endKnob);
}
},
calcKnobPosition: function(e) {
var t = e.clientX - this.hasNode().getBoundingClientRect().left;
return t / this.getBounds().width * (this.max - this.min) + this.min;
},
updateKnobPosition: function(e, t) {
t.applyStyle("left", e + "%"), this.updateBarPosition();
},
updateBarPosition: function() {
if (this.$.startKnob !== undefined && this.$.endKnob !== undefined) {
var e = this.calcKnobPercent(this.rangeStart), t = this.calcKnobPercent(this.rangeEnd) - e;
this.$.bar.applyStyle("left", e + "%"), this.$.bar.applyStyle("width", t + "%");
}
},
calcIncrement: function(e) {
return Math.ceil(e / this.increment) * this.increment;
},
calcRangeRatio: function(e) {
return e / 100 * (this.rangeMax - this.rangeMin) + this.rangeMin - this.increment / 2;
},
swapZIndex: function(e) {
e === "startKnob" ? (this.$.startKnob.applyStyle("z-index", 1), this.$.endKnob.applyStyle("z-index", 0)) : e === "endKnob" && (this.$.startKnob.applyStyle("z-index", 0), this.$.endKnob.applyStyle("z-index", 1));
},
down: function(e, t) {
this.swapZIndex(e.name);
},
dragstart: function(e, t) {
if (t.horizontal) return t.preventDefault(), this.dragging = !0, !0;
},
drag: function(e, t) {
if (this.dragging) {
var n = this.calcKnobPosition(t);
if (e.name === "startKnob" && n >= 0) {
if (n <= this.endValue && t.xDirection === -1 || n <= this.endValue) {
this.setBeginValue(n);
var r = this.calcRangeRatio(this.beginValue), i = this.increment ? this.calcIncrement(r) : r, s = this.calcKnobPercent(i);
this.updateKnobPosition(s, this.$.startKnob), this.setRangeStart(i), this.doChanging({
value: i
});
}
} else if (e.name === "endKnob" && n <= 100) if (n >= this.beginValue && t.xDirection === 1 || n >= this.beginValue) {
this.setEndValue(n);
var r = this.calcRangeRatio(this.endValue), i = this.increment ? this.calcIncrement(r) : r, s = this.calcKnobPercent(i);
this.updateKnobPosition(s, this.$.endKnob), this.setRangeEnd(i), this.doChanging({
value: i
});
}
return !0;
}
},
dragfinish: function(e, t) {
this.dragging = !1, t.preventTap();
if (e.name === "startKnob") {
var n = this.calcRangeRatio(this.beginValue);
this.doChange({
value: n,
startChanged: !0
});
} else if (e.name === "endKnob") {
var n = this.calcRangeRatio(this.endValue);
this.doChange({
value: n,
startChanged: !1
});
}
return !0;
},
rangeMinChanged: function() {
this.refreshRangeSlider();
},
rangeMaxChanged: function() {
this.refreshRangeSlider();
},
rangeStartChanged: function() {
this.refreshRangeSlider();
},
rangeEndChanged: function() {
this.refreshRangeSlider();
},
setStartLabel: function(e) {
this.$.startKnob.waterfallDown("onSetLabel", e);
},
setEndLabel: function(e) {
this.$.endKnob.waterfallDown("onSetLabel", e);
}
}), enyo.kind({
name: "onyx.RangeSliderKnobLabel",
classes: "onyx-range-slider-label",
handlers: {
onSetLabel: "setLabel"
},
setLabel: function(e, t) {
this.setContent(t);
}
});

// Item.js

enyo.kind({
name: "onyx.Item",
classes: "onyx-item",
tapHighlight: !0,
handlers: {
onhold: "hold",
onrelease: "release"
},
hold: function(e, t) {
this.tapHighlight && onyx.Item.addFlyweightClass(this.controlParent || this, "onyx-highlight", t);
},
release: function(e, t) {
this.tapHighlight && onyx.Item.removeFlyweightClass(this.controlParent || this, "onyx-highlight", t);
},
statics: {
addFlyweightClass: function(e, t, n, r) {
var i = n.flyweight;
if (i) {
var s = r !== undefined ? r : n.index;
i.performOnRow(s, function() {
e.hasClass(t) ? e.setClassAttribute(e.getClassAttribute()) : e.addClass(t);
}), e.removeClass(t);
}
},
removeFlyweightClass: function(e, t, n, r) {
var i = n.flyweight;
if (i) {
var s = r !== undefined ? r : n.index;
i.performOnRow(s, function() {
e.hasClass(t) ? e.removeClass(t) : e.setClassAttribute(e.getClassAttribute());
});
}
}
}
});

// Spinner.js

enyo.kind({
name: "onyx.Spinner",
classes: "onyx-spinner",
stop: function() {
this.setShowing(!1);
},
start: function() {
this.setShowing(!0);
},
toggle: function() {
this.setShowing(!this.getShowing());
}
});

// MoreToolbar.js

enyo.kind({
name: "onyx.MoreToolbar",
classes: "onyx-toolbar onyx-more-toolbar",
menuClass: "",
movedClass: "",
layoutKind: "FittableColumnsLayout",
noStretch: !0,
handlers: {
onHide: "reflow"
},
published: {
clientLayoutKind: "FittableColumnsLayout"
},
tools: [ {
name: "client",
noStretch: !0,
fit: !0,
classes: "onyx-toolbar-inline"
}, {
name: "nard",
kind: "onyx.MenuDecorator",
showing: !1,
onActivate: "activated",
components: [ {
kind: "onyx.IconButton",
classes: "onyx-more-button"
}, {
name: "menu",
kind: "onyx.Menu",
scrolling: !1,
classes: "onyx-more-menu"
} ]
} ],
initComponents: function() {
this.menuClass && this.menuClass.length > 0 && !this.$.menu.hasClass(this.menuClass) && this.$.menu.addClass(this.menuClass), this.createChrome(this.tools), this.inherited(arguments), this.$.client.setLayoutKind(this.clientLayoutKind);
},
clientLayoutKindChanged: function() {
this.$.client.setLayoutKind(this.clientLayoutKind);
},
reflow: function() {
this.inherited(arguments), this.isContentOverflowing() ? (this.$.nard.show(), this.popItem() && this.reflow()) : this.tryPushItem() ? this.reflow() : this.$.menu.children.length || (this.$.nard.hide(), this.$.menu.hide());
},
activated: function(e, t) {
this.addRemoveClass("active", t.originator.active);
},
popItem: function() {
var e = this.findCollapsibleItem();
if (e) {
this.movedClass && this.movedClass.length > 0 && !e.hasClass(this.movedClass) && e.addClass(this.movedClass), this.$.menu.addChild(e, null);
var t = this.$.menu.hasNode();
return t && e.hasNode() && e.insertNodeInParent(t), !0;
}
},
pushItem: function() {
var e = this.$.menu.children, t = e[0];
if (t) {
this.movedClass && this.movedClass.length > 0 && t.hasClass(this.movedClass) && t.removeClass(this.movedClass), this.$.client.addChild(t);
var n = this.$.client.hasNode();
if (n && t.hasNode()) {
var r, i;
for (var s = 0; s < this.$.client.children.length; s++) {
var o = this.$.client.children[s];
if (o.toolbarIndex !== undefined && o.toolbarIndex != s) {
r = o, i = s;
break;
}
}
if (r && r.hasNode()) {
t.insertNodeInParent(n, r.node);
var u = this.$.client.children.pop();
this.$.client.children.splice(i, 0, u);
} else t.appendNodeToParent(n);
}
return !0;
}
},
tryPushItem: function() {
if (this.pushItem()) {
if (!this.isContentOverflowing()) return !0;
this.popItem();
}
},
isContentOverflowing: function() {
if (this.$.client.hasNode()) {
var e = this.$.client.children, t = e[e.length - 1].hasNode();
if (t) return this.$.client.reflow(), t.offsetLeft + t.offsetWidth > this.$.client.node.clientWidth;
}
},
findCollapsibleItem: function() {
var e = this.$.client.children;
for (var t = e.length - 1; c = e[t]; t--) {
if (!c.unmoveable) return c;
c.toolbarIndex === undefined && (c.toolbarIndex = t);
}
}
});

// Canvas.js

enyo.kind({
name: "enyo.Canvas",
kind: enyo.Control,
tag: "canvas",
attributes: {
width: 500,
height: 500
},
defaultKind: "enyo.canvas.Control",
generateInnerHtml: function() {
return "";
},
teardownChildren: function() {},
rendered: function() {
this.renderChildren();
},
addChild: function() {
enyo.UiComponent.prototype.addChild.apply(this, arguments);
},
removeChild: function() {
enyo.UiComponent.prototype.removeChild.apply(this, arguments);
},
renderChildren: function(e) {
var t = e, n = this.hasNode();
t || n.getContext && (t = n.getContext("2d"));
if (t) for (var r = 0, i; i = this.children[r]; r++) i.render(t);
},
update: function() {
var e = this.hasNode();
if (e.getContext) {
var t = e.getContext("2d"), n = this.getBounds();
t.clearRect(0, 0, n.width, n.height), this.renderChildren(t);
}
}
});

// CanvasControl.js

enyo.kind({
name: "enyo.canvas.Control",
kind: enyo.UiComponent,
defaultKind: "enyo.canvas.Control",
published: {
bounds: null
},
events: {
onRender: ""
},
constructor: function() {
this.bounds = {
l: enyo.irand(400),
t: enyo.irand(400),
w: enyo.irand(100),
h: enyo.irand(100)
}, this.inherited(arguments);
},
importProps: function(e) {
this.inherited(arguments), e.bounds && (enyo.mixin(this.bounds, e.bounds), delete e.bounds);
},
renderSelf: function(e) {
this.doRender({
context: e
});
},
render: function(e) {
this.children.length ? this.renderChildren(e) : this.renderSelf(e);
},
renderChildren: function(e) {
for (var t = 0, n; n = this.children[t]; t++) n.render(e);
}
});

// Shape.js

enyo.kind({
name: "enyo.canvas.Shape",
kind: enyo.canvas.Control,
published: {
color: "red",
outlineColor: ""
},
fill: function(e) {
e.fill();
},
outline: function(e) {
e.stroke();
},
draw: function(e) {
this.color && (e.fillStyle = this.color, this.fill(e)), this.outlineColor && (e.strokeStyle = this.outlineColor, this.outline(e));
}
});

// Circle.js

enyo.kind({
name: "enyo.canvas.Circle",
kind: enyo.canvas.Shape,
renderSelf: function(e) {
e.beginPath(), e.arc(this.bounds.l, this.bounds.t, this.bounds.w, 0, Math.PI * 2), this.draw(e);
}
});

// Rectangle.js

enyo.kind({
name: "enyo.canvas.Rectangle",
kind: enyo.canvas.Shape,
published: {
clear: !1
},
renderSelf: function(e) {
this.clear ? e.clearRect(this.bounds.l, this.bounds.t, this.bounds.w, this.bounds.h) : this.draw(e);
},
fill: function(e) {
e.fillRect(this.bounds.l, this.bounds.t, this.bounds.w, this.bounds.h);
},
outline: function(e) {
e.strokeRect(this.bounds.l, this.bounds.t, this.bounds.w, this.bounds.h);
}
});

// Text.js

enyo.kind({
name: "enyo.canvas.Text",
kind: enyo.canvas.Shape,
published: {
text: "",
font: "12pt Arial",
align: "left"
},
renderSelf: function(e) {
e.textAlign = this.align, e.font = this.font, this.draw(e);
},
fill: function(e) {
e.fillText(this.text, this.bounds.l, this.bounds.t);
},
outline: function(e) {
e.strokeText(this.text, this.bounds.l, this.bounds.t);
}
});

// Image.js

enyo.kind({
name: "enyo.canvas.Image",
kind: enyo.canvas.Control,
published: {
src: ""
},
create: function() {
this.image = new Image, this.inherited(arguments), this.srcChanged();
},
srcChanged: function() {
this.src && (this.image.src = this.src);
},
renderSelf: function(e) {
e.drawImage(this.image, this.bounds.l, this.bounds.t);
}
});

// List.js

enyo.kind({
name: "educate.hulpklassen.list.List",
kind: "enyo.Scroller",
horizontal: "hidden",
classes: "list",
handlers: {
ontap: "ontapHandler"
},
components: [],
published: {
width: "150",
height: "500",
arrList: "",
selectedListItem: ""
},
create: function() {
this.inherited(arguments), this.listLayout(), this.makeList();
},
arrListChanged: function() {
this.recreateList(), this.render();
},
listLayout: function() {
this.applyStyle("width", this.getWidth() + "px"), this.applyStyle("height", this.getHeight() + "px");
},
makeList: function() {
var e = this.getArrList();
for (var t in e) this.createListItem(e[t]);
},
recreateList: function() {
this.clearList(), this.makeList();
},
createListItem: function(e) {
this.createComponent({
kind: "educate.hulpklassen.list.ListItem",
container: this,
link: e.link,
label: e.label
});
},
addItem: function(e) {
this.getArrList().push(e), this.createListItem(e);
},
getSelection: function() {
return this.getSelectedListItem();
},
getAllListItems: function() {
var e = this.getArrList();
return e;
},
clearList: function() {
var e = this.controls, t = 1;
while (t > 0) {
t = 0;
for (var n = 0; n < e.length; n++) e[n].kindName == "educate.hulpklassen.list.ListItem" && (t += 1), e[n].kindName == "educate.hulpklassen.list.ListItem" && e[n].destroy();
}
},
updateItem: function(e, t) {
var n = this.getArrList();
for (var r in n) n[r].label == e && (n[r].label = t.label, n[r].link = t.link);
this.recreateList();
},
removeItem: function(e) {
var t = this.getArrList();
for (var n in t) t[n].label == e.label && this.getArrList().splice(n, 1);
this.recreateList(), this.render();
},
ontapHandler: function(e, t) {
var n = this.controls;
for (var r in n) n[r].kindName == "educate.hulpklassen.list.ListItem" && n[r].removeClass("listItemSelected");
t.dispatchTarget.kindName == "educate.hulpklassen.list.ListItem" && t.dispatchTarget.addClass("listItemSelected"), this.setSelectedListItem(t.dispatchTarget.kindName == "educate.hulpklassen.list.ListItem" ? t.dispatchTarget : "");
},
selectItem: function(e) {
var t = this.controls;
for (var n in t) t[n].link == e && (t[n].addClass("listItemSelected"), this.setSelectedListItem(t[n]));
}
});

// ListItem.js

enyo.kind({
name: "educate.hulpklassen.list.ListItem",
kind: enyo.Control,
tag: "div",
classes: "listItem",
handlers: {},
components: [],
published: {
width: "",
height: "",
link: "",
label: ""
},
create: function() {
this.inherited(arguments), this.content = this.getLabel(), this.render();
}
});

// Library.js

enyo.kind({
name: "educate.hulpklassen.library.Library",
classes: "modal library",
published: {
layername: "",
value: "",
solution: "",
answered: "",
position_x: 0,
position_y: 0,
width: 0,
height: 0,
fontSize: 1,
carrier: 0,
inLayerHolder: 0,
layerHolderDefault: 0,
active: 0,
objectId: ""
},
components: [ {
name: "modalHeader",
classes: "modal-header",
components: [ {
kind: enyo.Button,
classes: "close",
content: "\u00d7",
ontap: "cancelLibraryPopup"
}, {
tag: "h3",
name: "modalTitle",
content: "assets"
} ]
}, {
name: "modalBody",
classes: "modal-body"
}, {
tag: "div",
name: "modalButtonsCon",
classes: "modal-footer",
components: [ {
kind: "enyo.Button",
name: "savelibrarybtn",
content: "selecteer",
ontap: "submitLibraryPopup",
classes: "btn btn-primary"
}, {
kind: "enyo.Button",
name: "cancellibrarybtn",
content: "annuleer",
ontap: "cancelLibraryPopup",
classes: "btn"
} ]
} ],
create: function() {
this.inherited(arguments);
},
rendered: function() {
this.inherited(arguments);
},
submitLibraryPopup: function() {
this.hide();
},
cancelLibraryPopup: function() {
this.hide();
},
clearLibraryContent: function() {
this.$.modalBody.destroyClientControls();
},
errorHandler: function(e, t) {
console.log("searchError", e, t);
}
});

// AssetsLibrary.js

enyo.kind({
name: "educate.hulpklassen.library.AssetsLibrary",
kind: "educate.hulpklassen.library.Library",
classes: "",
published: {
searchType: "all",
selectedAsset: "",
viewId: "",
searchValue: ""
},
handlers: {
fileUploaded: "fileUploadedHandler"
},
create: function() {
this.inherited(arguments), this.generateComponents(), this.getAssets();
},
rendered: function() {
this.inherited(arguments), this.$.searchTag && this.searchValueChanged(), this.makeSearchInputTypeahead();
},
searchValueChanged: function() {
this.$.searchTag.setValue(this.getSearchValue());
},
generateComponents: function() {
this.createComponents([ {
kind: "enyo.Button",
name: "previewAssetBtn",
content: "Preview",
classes: "btn pull-left",
ontap: "previewAssetItem",
container: this.$.modalButtonsCon
}, {
kind: "enyo.Button",
name: "uploadAssetBtn",
content: "Upload asset",
classes: "btn pull-left",
ontap: "uploadAssetHandler",
container: this.$.modalButtonsCon
} ]);
},
uploadAssetHandler: function() {
this.$.assetUploadModal ? this.$.assetUploadModal.setShowing(!0) : this.createComponent({
name: "assetUploadModal",
kind: "educate.hulpklassen.library.AssetUpload",
viewId: this.getViewId(),
uploadType: this.getSearchType(),
container: this.parent
});
},
getAssets: function() {
this.clearLibraryContent();
var e = new enyo.Ajax({
url: Settings.WEBAPP + "/asset/asset/frontendAssetPicker",
method: "GET",
handleAs: "json"
});
e.response(enyo.bind(this, "completeGetAssetsHandler")), e.go({
searchType: this.getSearchType()
});
},
completeGetAssetsHandler: function(e, t) {
this.handleAssetsResponse(t), this.createSearchContainer(), this.render();
},
handleAssetsResponse: function(e) {
var t = 0, n = 0;
console.log(e);
for (var r in e) {
var i = !0;
t % 3 === 0 && (n++, this.createComponent({
tag: "div",
classes: "row-fluid",
container: this.$.modalBody,
name: "row-" + n
})), this.createComponent({
name: e[r].name + "_" + r + "_Con",
container: this.$["row-" + n],
classes: "span4 assetLibraryItemCon",
assetObj: e[r],
ontap: "assetLibraryItemClicked",
components: [ {
tag: "h4",
content: e[r].options ? e[r].options : " "
}, {
tag: "img",
name: e[r].name + "_" + r,
src: Settings.WEBAPP + "/" + e[r].answered,
classes: "img-rounded img-polaroid"
}, {
tag: "div",
name: e[r].name + "_" + r + "_ConTags",
classes: "row-fluid",
style: "margin-top: 5px;"
} ]
});
var s = e[r].css_class.split(/ ?, ?/);
for (var o in s) this.createComponent({
tag: "span",
content: s[o],
classes: "label label-info",
container: this.$[e[r].name + "_" + r + "_ConTags"],
style: "margin: 0px 3px 3px 0px;"
});
t++;
}
!i && this.createComponent({
classes: "alert",
container: this.$.modalBody,
components: [ {
tag: "h3",
content: "opgelet"
}, {
tag: "p",
content: "Er werden geen bestanden gevonden die voldoen aan uw zoektocht. Misschien moet je er zelf enkele uploaden?"
} ]
});
},
createSearchContainer: function() {
this.createComponents([ {
tag: "div",
name: "searchCon",
container: this.$.modalBody,
classes: "row-fluid",
addBefore: null,
components: [ {
kind: "enyo.Input",
name: "searchTag",
classes: "searchTagInput span12",
placeholder: "zoeken op naam of kernwoorden",
onchange: "searchHandler",
type: "text"
} ]
} ]);
},
makeSearchInputTypeahead: function() {
var e = this;
$(".searchTagInput").typeahead({
source: function(t, n) {
return $.ajax({
url: Settings.SERVER + "searchAssetsTypeahead",
type: "get",
data: {
query: t,
type: e.getSearchType()
},
dataType: "json",
success: function(e) {
return n(e);
}
});
}
});
},
searchHandler: function(e, t) {
this.setSearchValue(e.getValue());
var n = "type=" + this.getSearchType() + "&searchvalue=" + e.getValue();
$.ajax({
url: Settings.SERVER + "searchAssets",
type: "GET",
data: n,
dataType: "json",
success: enyo.bind(this, "completeSearchHandler"),
error: this.errorHandler
});
},
completeSearchHandler: function(e, t) {
this.clearLibraryContent(), this.handleAssetsResponse(e), this.createSearchContainer(), this.render();
},
toggleAssetButtons: function() {
this.$.previewAssetBtn.setShowing(!this.$.previewAssetBtn.getShowing()), this.$.uploadAssetBtn.setShowing(!this.$.uploadAssetBtn.getShowing());
},
assetLibraryItemClicked: function(e, t) {
this.deselectAssetItems(), this.selectAssetItem(e), this.setSelectedAsset(e.assetObj);
},
selectAssetItem: function(e) {
e.addClass("assetSelected");
},
deselectAssetItems: function() {
var e = this.$.modalBody.children;
for (var t in e) {
var n = e[t].children;
for (var r in n) n[r].removeClass("assetSelected");
}
},
previewAssetItem: function(e, t) {
this.getSelectedAsset() != "" && this.bubble("previewAssetBtnClicked", {
assetSrc: this.getSelectedAsset()
});
},
fileUploadedHandler: function(e, t) {
this.getAssets();
},
submitLibraryPopup: function() {
this.getSelectedAsset() != "" && (this.inherited(arguments), this.bubble("assetsLibrarySubmitted", this));
},
cancelLibraryPopup: function() {
this.inherited(arguments), this.setSelectedAsset("");
}
});

// PreviewBox.js

enyo.kind({
name: "educate.hulpklassen.library.PreviewBox",
kind: "enyo.Popup",
tag: "div",
classes: "previewbox modal",
showing: !1,
attributes: {},
published: {
previewSrc: "",
sprite: ""
},
components: [ {
kind: "Signals",
onPreviewLoaded: "resizePreviewBox"
}, {
tag: "div",
classes: "modal-header",
components: [ {
tag: "button",
classes: "close",
content: "&times",
allowHtml: !0,
ontap: "closePreviewBox"
}, {
tag: "h3",
content: "Preview"
} ]
}, {
tag: "div",
name: "previewboxContent",
classes: "previewboxContent modal-body"
} ],
create: function() {
this.inherited(arguments), this.initPreviewBox(), this.render();
},
rendered: function() {
this.inherited(arguments), this.showPreviewBox();
},
initPreviewBox: function() {
this.getPreviewSrc().solution == "Animatie" ? this.sprite = this.createComponent({
kind: "educate.components.animatie.AnimatiePreview",
name: "animatiePreview",
value: this.getPreviewSrc().value,
solution: this.getPreviewSrc().parent,
container: this.$.previewboxContent
}) : this.createComponent({
tag: "img",
name: "previewImg",
src: Settings.WEBAPP + "/" + this.getPreviewSrc().value,
container: this.$.previewboxContent
});
},
showPreviewBox: function() {
this.show();
},
resizePreviewBox: function(e, t) {},
closePreviewBox: function() {
this.hide();
}
});

// AssetUpload.js

enyo.kind({
name: "educate.hulpklassen.library.AssetUpload",
kind: "enyo.Control",
classes: "modal uploader",
published: {
uploadType: "all",
uploadedAsset: "",
viewId: "",
tags: [],
files: [],
readyFiles: []
},
components: [ {
classes: "modal-header",
components: [ {
tag: "h3",
components: [ {
tag: "i",
classes: "icon-upload",
content: " "
}, {
tag: "span",
name: "txtTitle",
content: "upload"
} ]
} ]
}, {
classes: "modal-body",
components: [ {
classes: "form form-horizontal",
name: "modalBody",
tag: "form",
attributes: {
enctype: "multipart/form-data",
action: "#"
},
components: [ {
kind: enyo.Input,
name: "file",
type: "file",
style: "display: none;",
onchange: "fileSelectedHandler"
}, {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: "bestand"
}, {
classes: "controls",
components: [ {
classes: "input-append",
components: [ {
kind: enyo.Input,
name: "txtFile",
ontap: "selectFile",
attributes: {
readonly: "readonly"
}
}, {
kind: enyo.Button,
classes: "btn",
ontap: "selectFile",
components: [ {
tag: "i",
classes: "icon-upload",
content: ""
} ]
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: "tags"
}, {
classes: "controls",
components: [ {
name: "tags",
classes: "tags"
}, {
kind: enyo.Input,
name: "txtTags",
onkeyup: "tagsKeyUp",
onchange: "tagsOnchangeHandler"
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: "bestandstype"
}, {
classes: "controls",
components: [ {
kind: enyo.Select,
name: "selectType",
components: [ {
content: "bronbestand",
value: "0"
}, {
content: "aangepast",
value: "1"
} ]
} ]
} ]
} ]
}, {
name: "uploadAssetCon",
allowHtml: !0
} ]
}, {
classes: "modal-footer",
components: [ {
name: "loadBar",
classes: "progress progress-striped active",
components: [ {
classes: "bar",
style: "width: 100%;"
} ]
}, {
kind: enyo.Button,
classes: "btn",
content: "annuleer",
ontap: "cancelUpload"
}, {
kind: enyo.Button,
name: "btnUpload",
classes: "btn btn-primary",
content: "uploaden",
ontap: "uploadAssetHandler"
} ]
} ],
create: function() {
this.inherited(arguments), this.uploadTypeChanged(), this.render();
},
uploadTypeChanged: function() {
this.$.txtTitle.content = this.getUploadType() === "all" ? "upload" : "upload " + this.getUploadType();
switch (this.getUploadType()) {
case "Video":
this.uploadVideo();
break;
default:
console.log('case "' + this.getUploadType() + '": break;');
}
this.render();
},
uploadVideo: function() {
this.$.modalBody.destroyComponents(), this.$.modalBody.destroyClientControls(), this.$.modalBody.createComponents([ {
kind: enyo.Input,
name: "fileMp4",
type: "file",
style: "display: none;",
onchange: "fileSelectedHandler",
attributes: {
accept: ".mp4"
}
}, {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: "mp4"
}, {
classes: "controls",
components: [ {
classes: "input-append",
components: [ {
kind: enyo.Input,
name: "txtFileMp4",
ontap: "selectFile",
attributes: {
readonly: "readonly"
}
}, {
kind: enyo.Button,
classes: "btn",
name: "btnMp4",
ontap: "selectFile",
components: [ {
tag: "i",
classes: "icon-upload",
content: ""
} ]
} ]
} ]
} ]
}, {
kind: enyo.Input,
name: "fileOgv",
type: "file",
style: "display: none;",
onchange: "fileSelectedHandler",
attributes: {
accept: ".ogv"
}
}, {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: "ogv"
}, {
classes: "controls",
components: [ {
classes: "input-append",
components: [ {
kind: enyo.Input,
name: "txtFileOgv",
ontap: "selectFile",
attributes: {
readonly: "readonly"
}
}, {
kind: enyo.Button,
classes: "btn",
name: "btnOgv",
ontap: "selectFile",
components: [ {
tag: "i",
classes: "icon-upload",
content: ""
} ]
} ]
} ]
} ]
}, {
kind: enyo.Input,
name: "fileWebm",
type: "file",
style: "display: none;",
onchange: "fileSelectedHandler",
attributes: {
accept: ".webm"
}
}, {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: "webm"
}, {
classes: "controls",
components: [ {
classes: "input-append",
components: [ {
kind: enyo.Input,
name: "txtFileWebm",
ontap: "selectFile",
attributes: {
readonly: "readonly"
}
}, {
kind: enyo.Button,
classes: "btn",
name: "btnWebm",
ontap: "selectFile",
components: [ {
tag: "i",
classes: "icon-upload",
content: ""
} ]
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: "tags"
}, {
classes: "controls",
components: [ {
name: "tags",
classes: "tags"
}, {
kind: enyo.Input,
name: "txtTags",
onkeyup: "tagsKeyUp",
onchange: "tagsOnchangeHandler"
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: "bestandstype"
}, {
classes: "controls",
components: [ {
kind: enyo.Select,
name: "selectType",
components: [ {
content: "bronbestand",
value: "0"
}, {
content: "aangepast",
value: "1"
} ]
} ]
} ]
} ], {
owner: this
});
},
tagsKeyUp: function(e, t) {
var n = this.$.txtTags.getValue(), r = n.indexOf(",");
if (r !== -1) {
var i = n.substr(0, r);
this.createComponent({
container: this.$.tags,
classes: "label label-info",
components: [ {
tag: "span",
content: i
}, {
tag: "a",
ontap: "removeTag",
content: "x"
} ]
}), this.tags.push(i), r++, this.$.txtTags.setValue(n.substr(r)), this.render(), document.getElementById(this.$.txtTags.id).focus();
}
},
tagsOnchangeHandler: function(e, t) {
var n = this.$.txtTags.getValue();
this.createComponent({
container: this.$.tags,
classes: "label label-info",
components: [ {
tag: "span",
content: n
}, {
tag: "a",
ontap: "removeTag",
content: "x"
} ]
}), this.tags.push(n), this.$.txtTags.setValue(""), this.render();
},
tagsChanged: function() {
this.$.tags.destroyClientControls(), this.$.tags.destroyComponents();
var e, t = this.getTags().length;
for (e = 0; e < t; e++) this.createComponent({
container: this.$.tags,
classes: "label label-info",
components: [ {
tag: "span",
content: this.getTags()[e]
}, {
tag: "a",
ontap: "removeTag",
content: "x"
} ]
});
},
removeTag: function(e, t) {
var n = e.parent, r = n.children[0].getContent(), i = this.tags.indexOf(r);
this.tags.splice(i, 1), n.hide(), n.destroy();
},
selectFile: function(e, t) {
e.name.indexOf("Mp4") !== -1 ? this.dispatchClick(this.$.fileMp4) : e.name.indexOf("Ogv") !== -1 ? this.dispatchClick(this.$.fileOgv) : e.name.indexOf("Webm") !== -1 ? this.dispatchClick(this.$.fileWebm) : this.dispatchClick(this.$.file);
},
dispatchClick: function(e) {
if (!this.checkFileUploadWindow) {
this.checkFileUploadWindow = !0;
var t;
document.createEventObject ? (t = document.createEventObject(), e.hasNode().fireEvent("onclick", t)) : (t = document.createEvent("HTMLEvents"), t.initEvent("click", !0, !0), e.hasNode().dispatchEvent(t));
}
},
fileSelectedHandler: function(e, t) {
var n = e.hasNode().files, r = e.name.indexOf("Mp4") !== -1 ? this.$.txtFileMp4 : e.name.indexOf("Ogv") !== -1 ? this.$.txtFileOgv : e.name.indexOf("Webm") !== -1 ? this.$.txtFileWebm : this.$.txtFile;
this.files.push(n[0]), r.setValue(n[0].name), this.checkFileUploadWindow = !1;
},
rendered: function() {
this.inherited(arguments);
},
cancelUpload: function() {
this.hide();
},
uploadAssetHandler: function() {
this.$.loadBar.applyStyle("opacity", 1), this.$.btnUpload.setAttribute("disabled", "disabled"), this.readyFiles = [];
var e = new FormData, t, n = this.getFiles().length;
for (t = 0; t < n; t++) e.append("files[]", this.getFiles()[t]);
n = this.getTags().length;
for (t = 0; t < n; t++) e.append("tags[]", this.getTags()[t]);
e.append("filetype", this.$.selectType.getValue()), e.append("type", this.getUploadType()), $.ajax({
url: Settings.WEBAPP + "/asset/default/upload",
type: "POST",
data: e,
complete: enyo.bind(this, "completeFormUploadHandler"),
error: this.errorHandler,
cache: !1,
contentType: !1,
processData: !1
});
},
completeFormUploadHandler: function(e, t) {
this.$.loadBar.applyStyle("opacity", 0), this.$.btnUpload.setAttribute("disabled", null), e.responseText === "success" ? (this.bubble("fileUploaded"), this.hide()) : console.log(e.responseText);
},
showingChanged: function() {
this.inherited(arguments), this.getShowing() && (this.setTags([]), this.$.selectType && this.$.selectType.setSelected(0), this.$.txtFile && this.$.txtFile.setValue(""), this.$.file && this.$.file.setValue(""), this.$.txtFileMp4 && this.$.txtFileMp4.setValue(""), this.$.fileMp4 && this.$.fileMp4.setValue(""), this.$.txtFileOgv && this.$.txtFileOgv.setValue(""), this.$.fileOgv && this.$.fileOgv.setValue(""), this.$.txtFileWebm && this.$.txtFileWebm.setValue(""), this.$.fileWebm && this.$.fileWebm.setValue(""));
}
});

// MenuStructuur.js

enyo.kind({
name: "educate.hulpklassen.menuStructuur.MenuStructuur",
kind: "enyo.Control",
tag: "div",
classes: "menuStructuur",
published: {
i: "",
niveau: "",
selectNiveau: !1
},
components: [ {
tag: "div",
name: "btnToggleJaarVakCon",
content: "jaar/vak",
classes: "btnToggleJaarVakCon icon-chevron-down",
ontap: "toggleJaarVakCon"
}, {
tag: "div",
name: "jaarVakCon",
classes: "jaarVakCon",
components: [ {
tag: "ul",
name: "jaren",
classes: "menuJaren"
}, {
tag: "ul",
name: "vakken",
classes: "menuVakken",
showing: !1
} ]
}, {
tag: "div",
name: "navcon",
classes: "accordion navcon",
showing: !1
} ],
create: function() {
this.inherited(arguments), this.getJaren(), this.render();
},
rendered: function() {
this.inherited(arguments);
},
getJaren: function() {
this.getMenuAjax("jaren", "");
},
getVakken: function(e, t) {
this.getMenuAjax("vakken", t.originator.jaarId);
},
getAccordionMenu: function(e, t) {
this.toggleJaarVakCon(), this.getMenuAjax("accordion", t.originator.vakId);
},
toggleJaarVakCon: function() {
var e = this;
$(this.$.jaarVakCon.hasNode()).slideToggle("fast", function() {
e.$.jaarVakCon.setShowing(!e.$.jaarVakCon.getShowing()), e.handleJaarVakIcon();
});
},
handleJaarVakIcon: function() {
this.$.btnToggleJaarVakCon.hasClass("icon-chevron-down") ? (this.$.btnToggleJaarVakCon.removeClass("icon-chevron-down"), this.$.btnToggleJaarVakCon.addClass("icon-chevron-up")) : (this.$.btnToggleJaarVakCon.removeClass("icon-chevron-up"), this.$.btnToggleJaarVakCon.addClass("icon-chevron-down"));
},
toonJaren: function(e) {
for (var t in e) this.createComponent({
container: this.$.jaren,
tag: "li",
kind: "enyo.Control",
name: "jaar" + e[t].value,
content: e[t].name,
jaarId: e[t].id,
ontap: "getVakken"
});
this.$.jaren.render();
},
toonVakken: function(e) {
this.clearVakken();
for (var t in e) this.createComponent({
container: this.$.vakken,
tag: "li",
kind: "enyo.Control",
name: "vak" + e[t].name,
content: e[t].name + " (" + e[t].value + ")",
jaarId: e[t].parent,
vakId: e[t].id,
ontap: "getAccordionMenu"
});
this.$.vakken.setShowing(!0), this.$.vakken.render();
},
clearVakken: function() {
this.$.vakken.destroyClientControls();
},
toonAccordionMenu: function(e) {
this.$.navcon.destroyClientControls(), this.$.navcon.setShowing(!0), this.setI(0), this.parseCollection(e, "navcon", this.getNiveau()), this.render(), $(".navcon").mlamenu();
},
getMenuAjax: function(e, t) {
var n = "type=" + e;
n += t && "&parent=" + t;
var r;
switch (e) {
case "jaren":
r = "getJaren";
break;
case "vakken":
r = "getVakken";
break;
case "accordion":
r = "getAccordionMenu";
break;
default:
console.log("geen url");
}
this.sendAjaxRequest(r, n);
},
sendAjaxRequest: function(e, t) {
$.ajax({
url: Settings.SERVER + e,
type: "POST",
xhr: function() {
return myXhr = $.ajaxSettings.xhr(), myXhr;
},
success: enyo.bind(this, "completeGetMenuHandler"),
error: this.errorHandler,
data: t,
dataType: "json",
cache: !1,
processData: !1
});
},
completeGetMenuHandler: function(e, t) {
switch (e.type) {
case "jaren":
this.toonJaren(e.items);
break;
case "vakken":
this.toonVakken(e.items);
break;
case "accordion":
this.toonAccordionMenu(e.items);
break;
default:
console.log("Geen type");
}
},
errorHandler: function(e, t) {
console.log("getMenuError", e, t);
},
parseCollection: function(e, t, n) {
var r = this;
for (var i in e) {
var s = e[i];
s.carrier.type == "carrier" && this.checkTypeMenuItem(s.carrier.name) && (this.setI(this.getI() + 1), this.createComponents([ {
tag: "div",
name: s.name + this.getI(),
container: this.$[t],
components: [ {
tag: "p",
classes: s.carrier.name,
content: s.name,
linked: {
code: s.carrier.code,
linkUrl: s.id,
col: s.collection,
naam: s.name,
value: s.value
},
niveau: s.carrier.name,
ontap: "menuItemClickedHandler"
} ]
} ]), this.checkCollectionEmpty(s.collection) || n[n.length - 1] != s.carrier.name && this.parseCollection(s.collection, s.name + this.getI(), n));
}
},
checkCollectionEmpty: function(e) {
for (var t in e) return !1;
return !0;
},
checkTypeMenuItem: function(e) {
switch (e) {
case "hoofdstuk":
case "module":
case "categorie":
case "scene":
case "oefening":
return !0;
default:
return !1;
}
},
menuItemClickedHandler: function(e, t) {
var n = new Object;
n.selectedId = t.originator.linked.linkUrl, n.selectedNaam = t.originator.linked.naam, n.selectedValue = t.originator.linked.value;
if (this.getSelectNiveau()) {
var r = this.getNiveau().indexOf(t.originator.niveau);
r > -1 && this.bubble("menuItemSelected", n);
} else this.bubble("menuItemSelected", n);
}
});

// actie.js

enyo.kind({
name: "educate.Actie",
kind: enyo.Component,
published: {
eventName: "event",
eventID: "",
event: "",
targets: [ "" ],
targetComponents: [ "" ],
reactions: [ [ [ "" ] ] ],
eigenschap: "",
formule: "",
variableNames: [ [ [ "" ] ] ],
isGlobalVar: [ [ [ "" ] ] ],
isRandomVar: [ [ [ "" ] ] ],
offset: "",
databaseId: ""
},
create: function() {
this.inherited(arguments), this.eventID = (new Date).getTime(), this.event = "", this.targets = [ "" ], this.reactions = [ [ [ "" ] ] ], this.variableNames = [ [ [] ] ], this.isGlobalVar = [ [ [] ] ], this.isRandomVar = [ [ [] ] ];
}
});

// string.js

enyo.kind({
name: "educate.String",
kind: enyo.Component,
statics: {
toCamelCase: function(e) {
return e.toLowerCase().replace(/[-\s _](.)/g, function(e, t) {
return t.toUpperCase();
});
},
toDashed: function(e) {
return e.toLowerCase().replace(/[-\s _](.)/g, "-$1");
},
capitaliseFirstLetter: function(e) {
return e.charAt(0).toUpperCase() + e.slice(1);
}
}
});

// slider.js

enyo.kind({
name: "educate.Slider",
classes: "slider",
published: {
minValue: 0,
maxValue: 100,
value: 50,
step: 1
},
components: [ {
name: "track",
classes: "slider__track",
ondrag: "trackHandler",
ondown: "trackHandler",
components: [ {
name: "thumb",
classes: "slider__thumb"
} ]
} ],
events: {
onValueChanged: "onValueChanged"
},
create: function() {
this.inherited(arguments), this.calculate();
},
minValueChanged: function() {
this.calculate();
},
maxValueChanged: function() {
this.calculate();
},
valueChanged: function() {
this.calculate();
},
stepDown: function() {
this.setValue(this.getValue() - this.getStep());
},
stepUp: function() {
this.setValue(this.getValue() + this.getStep());
},
calculate: function() {
this.getValue() < this.getMinValue() ? this.value = this.getMinValue() : this.getValue() > this.getMaxValue() && (this.value = this.getMaxValue());
var e = this.getValue() / (this.getMaxValue() - this.getMinValue()) * 100;
this.$.thumb.applyStyle("left", e + "%;"), this.doValueChanged();
},
trackHandler: function(e, t) {
var n = 0;
e.hasNode() && t.srcEvent.target.id === e.id ? (n = t.srcEvent.layerX / e.hasNode().offsetWidth, this.setValue(n * (this.getMaxValue() - this.getMinValue()) + this.getMinValue())) : e.hasNode() && t.srcEvent.target.id.search("slider") > -1 && (n = (t.srcEvent.layerX + t.srcEvent.target.offsetLeft) / e.hasNode().offsetWidth, this.setValue(n * (this.getMaxValue() - this.getMinValue()) + this.getMinValue()));
}
});

// ContextObjectenMenu.js

enyo.kind({
kind: enyo.Control,
name: "educate.hulpklassen.contextMenus.ContextObjectenMenu",
tag: "div",
classes: "contextObjectenMenu icon-plus-sign-alt",
published: {},
handlers: {},
events: {
onObjAddedToRaster: ""
},
components: [ {
tag: "ul",
components: [ {
tag: "li",
content: "sjabloon",
classes: "disabled"
}, {
tag: "li",
components: [ {
content: "statisch"
}, {
tag: "ul",
components: [ {
tag: "li",
name: "svgImage",
content: "svg",
linked: "svgImage",
ontap: "loadObjectHandler"
}, {
tag: "li",
name: "image",
content: "afbeelding",
linked: "image",
ontap: "loadObjectHandler"
}, {
tag: "li",
name: "tekst",
content: "tekst",
linked: "tekst",
ontap: "loadObjectHandler"
}, {
tag: "li",
name: "raster",
content: "raster",
linked: "raster",
ontap: "loadObjectHandler"
} ]
} ]
}, {
tag: "li",
components: [ {
content: "bediening"
}, {
tag: "ul",
components: [ {
tag: "li",
content: "knop",
linked: "button",
ontap: "loadObjectHandler"
}, {
tag: "li",
content: "photoknop",
linked: "photoIcon",
ontap: "loadObjectHandler"
}, {
tag: "li",
content: "infoknop",
linked: "infoIcon",
ontap: "loadObjectHandler"
} ]
} ]
}, {
tag: "li",
components: [ {
content: "invoer"
}, {
tag: "ul",
components: [ {
tag: "li",
content: "cijferveld",
linked: "cijferveld",
ontap: "loadObjectHandler"
} ]
} ]
}, {
tag: "li",
content: "animatie",
linked: "sprite",
ontap: "loadObjectHandler"
}, {
tag: "li",
content: "video",
linked: "video",
ontap: "loadObjectHandler"
}, {
tag: "li",
content: "3D",
classes: "disabled"
}, {
tag: "li",
content: "bibliotheek",
classes: "disabled"
} ]
} ],
create: function() {
this.inherited(arguments);
},
rendered: function() {
this.inherited(arguments);
},
loadObjectHandler: function(e, t) {
!e.hasClass("disabled") && this.doObjAddedToRaster({
type: t.originator.linked,
con: this.parent
});
}
});

// NumberInput.js

enyo.kind({
name: "educate.hulpklassen.numberInput.NumberInput",
kind: "enyo.Control",
tag: "div",
classes: "numberInput",
published: {
type: "float",
value: "",
number: 0,
inputVeld: "",
afronding: 2
},
components: [ {
classes: "dragger",
components: [ {
tag: "i",
classes: "fill-icon icon-move"
} ],
ondrag: "ondragHandler"
}, {
classes: "row",
components: [ {
kind: "enyo.Input",
name: "txtNumber",
classes: "txtNumber",
type: "text"
} ]
}, {
classes: "row",
components: [ {
kind: enyo.Button,
name: "zeven",
content: "7",
ontap: "numberTapped"
}, {
kind: enyo.Button,
name: "acht",
content: "8",
ontap: "numberTapped"
}, {
kind: enyo.Button,
name: "negen",
content: "9",
ontap: "numberTapped"
}, {
kind: enyo.Button,
name: "close",
content: '<i class="icon-remove"></i>',
allowHtml: !0,
classes: "action",
ontap: "closeTapped"
} ]
}, {
classes: "row",
components: [ {
kind: enyo.Button,
name: "vier",
content: "4",
ontap: "numberTapped"
}, {
kind: enyo.Button,
name: "vijf",
content: "5",
ontap: "numberTapped"
}, {
kind: enyo.Button,
name: "zes",
content: "6",
ontap: "numberTapped"
}, {
kind: enyo.Button,
name: "backspace",
content: '<i class="icon-arrow-left"></i>',
allowHtml: !0,
classes: "action",
ontap: "backspaceTapped"
} ]
}, {
classes: "row",
components: [ {
kind: enyo.Button,
name: "een",
content: "1",
ontap: "numberTapped"
}, {
kind: enyo.Button,
name: "twee",
content: "2",
ontap: "numberTapped"
}, {
kind: enyo.Button,
name: "drie",
content: "3",
ontap: "numberTapped"
}, {
kind: enyo.Button,
name: "plusmin",
content: '<i class="icon-plus"></i>/<i class="icon-minus"></i>',
allowHtml: !0,
classes: "plusmin action",
ontap: "plusminTapped"
} ]
}, {
classes: "row",
components: [ {
kind: enyo.Button,
name: "nul",
content: "0",
classes: "span2",
ontap: "numberTapped"
}, {
kind: enyo.Button,
name: "komma",
content: ",",
classes: "comma",
ontap: "commaTapped"
}, {
kind: enyo.Button,
name: "enter",
content: '<i class="icon-ok"></i>',
allowHtml: !0,
classes: "action",
ontap: "enterTapped"
} ]
}, {
kind: "Signals",
onNumpadVisible: "onNumpadVisibleHandler"
} ],
create: function() {
this.inherited(arguments), this.valueChanged(), enyo.Signals.send("onNumpadVisible", {
originator: this
});
},
rendered: function() {
this.inherited(arguments), this.checkPosition();
},
onNumpadVisibleHandler: function(e, t) {
return this.getShowing() ? (t.originator && t.originator.owner !== this.owner && this.close(), !1) : !0;
},
showingChanged: function() {
this.inherited(arguments), this.getShowing() && enyo.Signals.send("onNumpadVisible", {
originator: this
});
},
selectText: function() {
if (!this.$.txtNumber.hasNode()) {
var e = this;
return window.setTimeout(e.selectText(), 10), !1;
}
this.$.txtNumber.node.select();
},
valueChanged: function() {
this.$.txtNumber.setValue(this.getValue());
},
numberTapped: function(e, t) {
var n = this.getValue().toString(), r = t.originator.content, i = this.$.txtNumber.hasNode(), s, o, u;
return i.selectionStart === 0 && i.selectionEnd === n.length && (n = "", u = 0, i.setSelectionRange(u, u)), i.selectionStart !== i.selectionEnd ? (s = n.substring(0, i.selectionStart), o = n.substring(i.selectionEnd, n.length), u = i.selectionStart + 1, this.setValue(s + r + o), i.setSelectionRange(u, u), !0) : (s = n.substring(0, i.selectionStart), o = n.substring(i.selectionStart, n.length), u = i.selectionStart + 1, this.setValue(s + r + o), i.setSelectionRange(u, u), !0);
},
getNumber: function() {
if (this.getValue() === "") return "";
var e = this.getValue().toString().split(",");
e.push("");
var t, n = this.getAfronding() - e[1].length;
for (t = 0; t < n; t++) e[1] += "0";
var r = parseFloat(e[0] + "." + e[1]), i = Math.pow(10, this.getAfronding());
return r *= i, r = r + .5 >> 0, r /= i, r;
},
getValue: function() {
return this.value.toString();
},
numberChanged: function() {
this.setValue(this.number.toString().replace(".", ","));
},
commaTapped: function(e, t) {
this.setValue(this.getValue() + ",");
},
plusminTapped: function(e, t) {
this.setValue(this.changePlusMin(this.getValue()));
},
changePlusMin: function(e) {
return -1 * parseFloat(e);
},
enterTapped: function(e, t) {
switch (this.getInputVeld().name) {
case "txtNumber":
this.getInputVeld().parent.setValue(this.getNumber());
break;
case "txtNumber2":
this.getInputVeld().parent.setValue2(this.getNumber());
break;
case "txtNumber3":
this.getInputVeld().parent.setValue3(this.getNumber());
}
this.close();
},
closeTapped: function(e, t) {
this.close();
},
close: function() {
this.getInputVeld() && this.getInputVeld().removeClass("active"), this.setShowing(!1);
},
backspaceTapped: function(e, t) {
var n = this.getValue().toString(), r = this.$.txtNumber.hasNode(), i, s, o;
return r.selectionStart === 0 && r.selectionEnd === n.length ? (o = 0, this.setValue(""), r.setSelectionRange(o, o), !0) : r.selectionStart !== r.selectionEnd ? (i = n.substring(0, r.selectionStart), s = n.substring(r.selectionEnd, n.length), o = r.selectionStart, this.setValue(i + s), r.setSelectionRange(o, o), !0) : (i = n.substring(0, r.selectionStart - 1), s = n.substring(r.selectionStart, n.length), o = r.selectionStart - 1, this.setValue(n.length > 1 ? i + s : ""), r.setSelectionRange(o, o), !0);
},
ondragHandler: function(e, t) {
var n = parseFloat(this.getComputedStyleValue("left")), r = parseFloat(this.getComputedStyleValue("top"));
isNaN(n) && (n = 0), isNaN(r) && (r = 0), this.applyStyle("left", n + t.ddx + "px"), this.applyStyle("top", r + t.ddy + "px"), this.checkPosition();
},
checkPosition: function() {
if (!this.hasNode()) return !1;
var e = parseFloat(this.getComputedStyleValue("left")), t = parseFloat(this.getComputedStyleValue("top")), n = this.node.offsetWidth, r = this.node.offsetHeight, i = this.parent.node.offsetWidth, s = this.parent.node.offsetHeight;
switch (!0) {
case isNaN(e):
case e < 0:
e = 0;
break;
case e > i - n:
e = i - n;
}
switch (!0) {
case isNaN(t):
case t < 0:
t = 0;
break;
case t > s - r:
t = s - r;
}
this.applyStyle("left", e + "px"), this.applyStyle("top", t + "px");
}
});

// linkeigenschap.js

enyo.kind({
name: "educate.Linkeigenschap",
kind: enyo.Component,
published: {
linkeigenschapName: "",
linkeigenschapID: "",
eigenschap: "",
formule: "",
offset: "",
field: null,
databaseId: ""
},
create: function() {
this.inherited(arguments), this.linkeigenschapID = (new Date).getTime();
}
});

// globalVariableLinkeigenschap.js

enyo.kind({
name: "educate.GlobalVariableLinkeigenschap",
kind: enyo.Component,
published: {
name: "",
answered: "",
carrier: window.settings.CARRIERS.GLOBALVARLINKEIGENSCHAP,
finalObject: !0,
databaseId: "",
objectId: ""
},
create: function() {
this.inherited(arguments), this.setCarrier(window.settings.CARRIERS.GLOBALVARLINKEIGENSCHAP);
}
});

// Radiobuttons.js

enyo.kind({
name: "educate.Radiobuttons",
kind: enyo.Control,
classes: "control-group",
published: {
label: "",
items: [],
selected: 0
},
events: {
onSelectionChanged: ""
},
handlers: {},
components: [ {
tag: "label",
name: "lbl",
content: this.label + ": ",
classes: "control-label"
}, {
classes: "controls radiolist",
name: "controls"
} ],
create: function() {
this.inherited(arguments), this.labelChanged(), this.itemsChanged(), this.selectedChanged();
},
labelChanged: function() {
this.$.lbl.setContent(this.getLabel() + ": ");
},
itemsChanged: function() {
this.$.controls.destroyComponents();
var e = this.getItems(), t, n = e.length, r = this.getLabel().replace(/[\s!\?,\.;:]+/g, "");
for (t = 0; t < n; t++) {
var i = this.$.controls.createComponent({
tag: "label",
classes: "radio"
});
i.createComponent({
kind: enyo.Checkbox,
content: " " + e[t].label,
onActivate: "selectionChanged",
checked: t === this.getSelected(),
type: "radio",
attributes: {
name: r
}
}, {
owner: this
});
}
},
selectedChanged: function() {
this.$.controls.getClientControls()[this.getSelected()].children[0].setActive(!0);
},
getSelection: function() {
return this.getItems()[this.getSelected()];
},
selectionChanged: function(e, t) {
var n = e, r = n.parent, i = this.$.controls.children.indexOf(r), s, o = this.$.controls.children.length;
for (s = 0; s < o; s++) this.$.controls.children[s].children[0].active = s === i;
this.selected !== i && (this.selected = i, this.doSelectionChanged());
}
});

// databaseInterface.js

enyo.kind({
name: "educate.components.DatabaseInterface",
kind: enyo.Control,
published: {
objectId: "",
databaseId: "",
layername: "",
value: "",
solution: "",
answered: "",
css_class: "",
position_x: 0,
position_y: 0,
position_z: 0,
width: -1,
height: -1,
inLayerHolder: !1,
layerHolderDefault: !1,
position: 0,
fontSize: 1,
carrier: -1,
isPosLimiet: !1,
position_x_min: Number.NEGATIVE_INFINITY,
position_x_max: Number.POSITIVE_INFINITY,
position_y_min: Number.NEGATIVE_INFINITY,
position_y_max: Number.POSITIVE_INFINITY,
position_z_min: Number.NEGATIVE_INFINITY,
position_z_max: Number.POSITIVE_INFINITY,
isRotLimiet: !1,
rotation_x_min: Number.NEGATIVE_INFINITY,
rotation_x_max: Number.POSITIVE_INFINITY,
rotation_y_min: Number.NEGATIVE_INFINITY,
rotation_y_max: Number.POSITIVE_INFINITY,
rotation_z_min: Number.NEGATIVE_INFINITY,
rotation_z_max: Number.POSITIVE_INFINITY,
origin: "50 50",
origin_x: 50,
origin_y: 50,
rotation: "0 0 0",
rotation_x: 0,
rotation_y: 0,
rotation_z: 0,
options: {
visible: !0,
alpha: 1
},
visible: !0,
open: !1,
alpha: 1,
collection: null,
active: !0
},
events: {
onValueChanged: "onValueChanged",
onSolutionChanged: "onSolutionChanged",
onAnsweredChanged: "onAnsweredChanged",
onCss_classChanged: "onCss_classChanged",
onPosition_xChanged: "onPosition_xChanged",
onPosition_yChanged: "onPosition_yChanged",
onPosition_zChanged: "onPosition_zChanged",
onWidthChanged: "onWidthChanged",
onHeightChanged: "onHeightChanged",
onOriginChanged: "onOriginChanged",
onOrigin_xChanged: "onOrigin_xChanged",
onOrigin_yChanged: "onOrigin_yChanged",
onRotationChanged: "onRotationChanged",
onRotation_xChanged: "onRotation_xChanged",
onRotation_yChanged: "onRotation_yChanged",
onRotation_zChanged: "onRotation_zChanged",
onVisibleChanged: "onVisibleChanged",
onActiveChanged: "onActiveChanged"
},
create: function() {
this.inherited(arguments);
},
rotationChanged: function() {
var e = this.rotation.split(" "), t = isNaN(parseFloat(e[0])) ? 0 : parseFloat(e[0]), n = isNaN(parseFloat(e[1])) ? 0 : parseFloat(e[1]), r = isNaN(parseFloat(e[2])) ? 0 : parseFloat(e[2]);
if (this.getIsRotLimiet()) {
var i = isNaN(parseFloat(this.rotation_x_min)) ? Number.NEGATIVE_INFINITY : this.rotation_x_min, s = isNaN(parseFloat(this.rotation_x_max)) ? Number.POSITIVE_INFINITY : this.rotation_x_max, o = isNaN(parseFloat(this.rotation_y_min)) ? Number.NEGATIVE_INFINITY : this.rotation_y_min, u = isNaN(parseFloat(this.rotation_y_max)) ? Number.POSITIVE_INFINITY : this.rotation_y_max, a = isNaN(parseFloat(this.rotation_z_min)) ? Number.NEGATIVE_INFINITY : this.rotation_z_min, f = isNaN(parseFloat(this.rotation_z_max)) ? Number.POSITIVE_INFINITY : this.rotation_z_max;
t < i ? t = i : t > s && (t = s), n < o ? n = o : n > u && (n = u), r < a ? r = a : r > f && (r = f);
}
this.rotation_x = t, this.rotation_y = n, this.rotation_z = r;
},
rotation_xChanged: function() {
var e = isNaN(parseInt(this.getRotation_x())) ? 0 : parseInt(this.getRotation_x()), t = isNaN(parseInt(this.getRotation_y())) ? 0 : parseInt(this.getRotation_y()), n = isNaN(parseInt(this.getRotation_z())) ? 0 : parseInt(this.getRotation_z());
this.setRotation(e + " " + t + " " + n);
},
rotation_yChanged: function() {
var e = isNaN(parseInt(this.getRotation_x())) ? 0 : parseInt(this.getRotation_x()), t = isNaN(parseInt(this.getRotation_y())) ? 0 : parseInt(this.getRotation_y()), n = isNaN(parseInt(this.getRotation_z())) ? 0 : parseInt(this.getRotation_z());
this.setRotation(e + " " + t + " " + n);
},
rotation_zChanged: function() {
var e = isNaN(parseInt(this.getRotation_x())) ? 0 : parseInt(this.getRotation_x()), t = isNaN(parseInt(this.getRotation_y())) ? 0 : parseInt(this.getRotation_y()), n = isNaN(parseInt(this.getRotation_z())) ? 0 : parseInt(this.getRotation_z());
this.setRotation(e + " " + t + " " + n);
},
originChanged: function() {
var e = this.origin.split(" ");
this.origin_x = isNaN(parseInt(e[0])) ? 50 : parseInt(e[0]), this.origin_y = isNaN(parseInt(e[1])) ? 50 : parseInt(e[1]);
},
origin_xChanged: function() {
var e = isNaN(parseInt(this.getOrigin_x())) ? 50 : parseInt(this.getOrigin_x()), t = isNaN(parseInt(this.getOrigin_y())) ? 50 : parseInt(this.getOrigin_y());
this.setOrigin(e + " " + t);
},
origin_yChanged: function() {
var e = isNaN(parseInt(this.getOrigin_x())) ? 50 : parseInt(this.getOrigin_x()), t = isNaN(parseInt(this.getOrigin_y())) ? 50 : parseInt(this.getOrigin_y());
this.setOrigin(e + " " + t);
},
setMinMax: function(e, t, n) {
switch (e) {
case "position_x":
this.position_x_min = t, this.position_x_max = n;
break;
case "position_y":
this.position_y_min = t, this.position_y_max = n;
break;
case "position_z":
this.position_z_min = t, this.position_z_max = n;
break;
case "rotation_x":
this.rotation_x_min = t, this.rotation_x_max = n;
break;
case "rotation_y":
this.rotation_y_min = t, this.rotation_y_max = n;
break;
case "rotation_z":
this.rotation_z_min = t, this.rotation_z_max = n;
break;
default:
this.options[e + "_min"] = t, this.options[e + "_max"] = n;
}
this.getMinMax(e);
},
getMinMax: function(e) {
var t = {
property: e,
minimum: null,
maximum: null
};
switch (e) {
case "position_x":
t.minimum = this.position_x_min, t.maximum = this.position_x_max;
break;
case "position_y":
t.minimum = this.position_y_min, t.maximum = this.position_y_max;
break;
case "position_z":
t.minimum = this.position_z_min, t.maximum = this.position_z_max;
break;
case "rotation_x":
t.minimum = this.rotation_x_min, t.maximum = this.rotation_x_max;
break;
case "rotation_y":
t.minimum = this.rotation_y_min, t.maximum = this.rotation_y_max;
break;
case "rotation_z":
t.minimum = this.rotation_z_min, t.maximum = this.rotation_z_max;
break;
default:
t.minimum = this.options[e + "_min"], t.maximum = this.options[e + "_max"];
}
return t;
},
setIsRandom: function(e, t) {
this.options["rnd_" + e] = t;
},
getIsRandom: function(e) {
return this.options["rnd_" + e] === !0;
},
setIsLimit: function(e, t) {
switch (e) {
case "position_x":
this.isPosLimiet = t;
break;
case "position_y":
this.isPosLimiet = t;
break;
case "position_z":
this.isPosLimiet = t;
break;
case "rotation_x":
this.isRotLimiet = t;
break;
case "rotation_y":
this.isRotLimiet = t;
break;
case "rotation_z":
this.isRotLimiet = t;
break;
default:
this.options["isLim_" + e] = t;
}
},
getIsLimit: function(e) {
var t = !1;
switch (e) {
case "position_x":
t = this.isPosLimiet;
break;
case "position_y":
t = this.isPosLimiet;
break;
case "position_z":
t = this.isPosLimiet;
break;
case "rotation_x":
t = this.isRotLimiet;
break;
case "rotation_y":
t = this.isRotLimiet;
break;
case "rotation_z":
t = this.isRotLimiet;
break;
default:
t = this.options["isLim_" + e];
}
return t;
},
doRandom: function(e) {
if (this.getIsRandom(e)) {
var t = this.getMinMax(e);
this[e] = Math.random() * (t.maximum - t.minimum) + t.minimum;
}
}
});

// actionHandler.js

enyo.kind({
name: "educate.components.ActionHandler",
kind: "educate.components.DatabaseInterface",
published: {
actions: [],
objectHandlers: [],
linkedEigenschappen: [],
linkEigenschappenOptions: [],
eventOptions: [],
reactieOptions: [],
clickX: "",
clickY: "",
viewId: "",
preventDefaultEvent: !0,
links: [],
startRotation: 0,
boundingBox: {
x: 0,
y: 0,
width: 30,
height: 30
},
absoluteOrigin: {
x: 0,
y: 0
}
},
handlers: {
ondown: "downHandler",
ontap: "ontapHandler",
applyLinkEigenschappen: "applyLinkEigenschappenHandler"
},
create: function() {
this.inherited(arguments), this.setObjectHandlers([]), this.setLinkedEigenschappen([]), this.setActions([]), this.setLinks([]), this.initEventsReactiesOptions(), this.initLinkEigenschappenOptions();
},
rendered: function() {
this.inherited(arguments);
var e = this.hasNode();
if (e) {
this.boundingBox = {
x: e.offsetLeft,
y: e.offsetTop,
width: e.offsetWidth,
height: e.offsetHeight
};
var t = $(e).css("transform-origin");
this.absoluteOrigin = {
x: this.boundingBox.x + parseInt(t.split(" ")[0]),
y: this.boundingBox.y + parseInt(t.split(" ")[1])
};
}
},
initEventsReactiesOptions: function() {
this.setEventOptions({
KLIK: {
label: "klik",
action: "ontap"
},
MOUSE_DOWN: {
label: "mouseDown",
action: "ondown"
},
MOUSE_UP: {
label: "mouseUp",
action: "onup"
},
DRAG: {
label: "sleep",
action: "ondrag"
},
START_DRAG: {
label: "start sleep",
action: "ondragstart"
},
STOP_DRAG: {
label: "stop sleep",
action: "ondragfinish"
}
}), this.setReactieOptions({
SHOW: {
label: "toon",
action: "makeVisible"
},
HIDE: {
label: "verberg",
action: "makeInvisible"
},
TOGGLE_VISIBLE: {
label: "wissel zichtbaar",
action: "toggleVisible"
},
INTERACTIVATE: {
label: "interactiveer",
action: "makeInteractive"
},
DEINTERACTIVATE: {
label: "deinteractiveer",
action: "makeNotInteractive"
},
TOGGLE_INTERACTIVE: {
label: "wissel interactief",
action: "toggleInteractive"
},
ACTIVATE: {
label: "activeer",
action: "makeActive"
},
DEACTIVATE: {
label: "deactiveer",
action: "makeInactive"
},
TOGGLE_ACTIVE: {
label: "wissel actief",
action: "toggleActive"
},
OPEN: {
label: "open",
action: "openUp"
},
CLOSE: {
label: "sluit",
action: "closeDown"
},
TOGGLE_OPEN: {
label: "wissel open",
action: "toggle"
},
MOVE: {
label: "verplaats",
action: "move"
},
ROTATE: {
label: "roteer",
action: "rotate"
}
});
},
initLinkEigenschappenOptions: function() {
this.setLinkEigenschappenOptions({
posx: "position_x",
posy: "position_y",
posz: "position_z",
width: "width",
height: "height",
rotx: "rotation_x",
roty: "rotation_y",
rotz: "rotation_z",
alpha: "alpha"
});
},
getView: function() {
var e = enyo.$["frame_view" + this.viewId];
return e ? e : enyo.$["create_view" + this.viewId];
},
getStage: function() {
return this.getView().$.stage;
},
makeVisible: function() {
this.setVisible(!0);
},
makeInvisible: function() {
this.setVisible(!1);
},
toggleVisible: function() {
this.setVisible(!this.getVisible());
},
makeActive: function() {
this.setActive(!0), this.setVisible(!0);
},
makeInactive: function() {
this.setActive(!1), this.setVisible(!1);
},
toggleActive: function() {
var e = !this.getActive() || !this.getVisible();
this.setActive(e), this.setVisible(e);
},
makeInteractive: function() {
this.setActive(!0);
},
makeNotInteractive: function() {
this.setActive(!1);
},
toggleInteractive: function() {
this.setActive(!this.getActive());
},
openUp: function() {
this.setOpen(!0);
},
closeDown: function() {
this.setOpen(!1);
},
toggle: function() {
this.setOpen(this.getOpen());
},
downHandler: function(e, t) {
this.preventDefaultEvent && t.preventDefault();
if (!this.locked || !this.getLocked()) {
var n, r, i = $(e.hasNode()).offset();
t.type === "touchmove" ? (n = t.touches[0].clientX, r = t.touches[0].clientY) : (n = t.clientX, r = t.clientY), this.setClickX(n - i.left), this.setClickY(r - i.top);
var s = n - $(this.getStage().hasNode()).offset().left, o = r - $(this.getStage().hasNode()).offset().top, u = s - this.absoluteOrigin.x, a = o - this.absoluteOrigin.y;
this.startRotation = Math.atan2(a, u) * 180 / Math.PI - this.rotation_z, $(document).on("mousemove", enyo.bind(this, "muisMoveEvent")), $(document).on("mouseup", enyo.bind(this, "upHandler")), document.ontouchmove = enyo.bind(this, "dragObjectHandler"), document.ontouchend = enyo.bind(this, "upHandler");
}
},
muisMoveEvent: function(e) {
console.warn("muisMoveEvents is now deprecated, use window.touchToMouse to convert your touch-events to mouse-events."), e.touches = [ {
clientX: e.clientX,
clientY: e.clientY
} ], this.dragObjectHandler(e);
},
dragObjectHandler: function(e) {},
upHandler: function() {
$(document).off("mousemove"), $(document).off("mouseup"), document.ontouchmove = null, document.ontouchend = null;
},
ontapHandler: function() {
this.inherited(arguments), this.actionsChanged();
},
objectHandlersChanged: function() {
this.inherited(arguments);
},
actionsChanged: function() {
this.inherited(arguments);
var e = this.actions;
for (var t in e) {
var n = this, r = e[t];
this[this.getEventOptions()[r.value].action + "ActionHandler"] = function(e, t) {
var i = t.action !== undefined ? t.action : r.value;
switch (t.type) {
case "tap":
case "click":
i = "KLIK";
break;
case "ondown":
i = "MOUSE_DOWN";
break;
case "onup":
i = "MOUSE_UP";
break;
case "ondrag":
i = "DRAG";
break;
case "drag":
i = "DRAG";
break;
case "ondragstart":
i = "START_DRAG";
break;
case "ondragfinish":
i = "STOP_DRAG";
break;
default:
t.type !== undefined && console.log('case "' + t.type + '": av = ' + t.type.toUpperCase() + "; break;");
}
n.signalTargets(i, t);
};
}
},
signalTargets: function(e, t) {
undefined !== t.preventDefault && t.preventDefault();
var n = this.getView(), r;
for (var i in this.getActions()) if (this.actions[i].value === e && this.actions[i].parent === this.objectId) {
for (var s in this.actions[i].collection) {
r = n.getChildById(parseInt(s));
var o = this.actions[i].collection[s][window.settings.EVENTS[this.viewId][this.actions[i].id]].split(",");
for (var u in o) {
var a = r.getReactieOptions()[o[u]];
r && a && a.action !== "" && r[a.action] && r[a.action](t);
}
}
window.settings.EVENTS[this.viewId][this.actions[i].id]++, this.actions[i].collection[s] ? window.settings.EVENTS[this.viewId][this.actions[i].id] > Object.keys(this.actions[i].collection[s]).length - 1 && (window.settings.EVENTS[this.viewId][this.actions[i].id] = 0) : alert("er is een fout ingeslopen bij het opslaan van de acties. \nDit is niet uw fout, maar de onze. \nGelieve ons dit te laten weten.");
}
},
signalLinkTargets: function() {
var e = this.getView();
for (var t in this.getLinks()) {
var n = this.links[t].css_class ? this.links[t].css_class : "nooffset", r = n && n === "nooffset" ? this.links[t].answered : this.links[t].answered + "+" + n, i = "set" + this.links[t].solution.substr(0, 1).toUpperCase() + this.links[t].solution.substr(1), s = e.getChildById(this.links[t].parent);
s[i](this.calculateFormule(r)), s.resizeComponent();
}
},
applyLinkEigenschappenHandler: function(e, t) {
this.handleLinkEigenschappen();
},
addLinkEigenschap: function(e) {
!this.updateLinkEigenschap(e) && this.getLinkedEigenschappen().push(e), this.handleLinkEigenschappen();
},
updateLinkEigenschap: function(e) {
var t = this.getLinkedEigenschappen();
for (var n in t) if (t[n].eigenschap === e.eigenschap) return t[n].databaseId = e.databaseId, e.databaseId && (t[n].linkeigenschapID = e.databaseId), t[n].linkeigenschapName = e.linkeigenschapName, t[n].eigenschap = e.eigenschap, t[n].formule = e.formule, t[n].offset = e.offset, !0;
return !1;
},
handleLinkEigenschappen: function() {
var e = this.getLinkedEigenschappen();
for (var t in e) {
var n = e[t].offset ? e[t].offset : "nooffset", r = n === "nooffset" ? e[t].formule : e[t].formule + "+" + n;
this[e[t].eigenschap] = this.calculateFormule(r);
}
},
calculateFormule: function(e) {
var t = /{\w+\.\w+}/g, n = /\[\d+\.\d+\]/g;
e = this.addGlobalsToFormule(e);
var r = e.match(t), i = this.calculateObjs(r), s = e.match(n), o = this.calculateRnds(s), u = this.variablenSamenvoegen(i, o);
e = this.replaceSpecialCharsInFormule(e);
var a = math.eval(e, u);
return a;
},
replaceSpecialCharsInFormule: function(e) {
var t = /\{(\w+)\.(\w+)\}/g, n = /\[(\d+)\.(\d+)\]/g;
return e = e.replace(t, "x$1x$2x").replace(n, "x$1x$2x"), e;
},
variablenSamenvoegen: function(e, t) {
var n = new Object, r = e.concat(t), i = r.length;
for (var s = 0; s < i; s++) n[r[s].varnaam] = r[s].value;
return n;
},
calculateObjs: function(e) {
var t = [];
if (e) {
var n = e.length;
for (var r = 0; r < n; r++) {
var i = e[r].replace(/[.{}]/g, "x");
e[r] = e[r].replace(/({|})/g, "");
var s = e[r].split("."), o = this.getView(), u = o.getChildByName(s[0]), a = u[u.getLinkEigenschappenOptions()[s[1]]];
t.push({
varnaam: i,
value: a
});
}
}
return t;
},
calculateRnds: function(e) {
var t = [];
if (e) {
var n = e.length;
for (var r = 0; r < n; r++) {
var i = e[r].replace(/[.\[\]]/g, "x");
e[r] = e[r].replace(/(\[|\])/g, "");
var s = e[r].split("."), o = s[0], u = s[1], a = this.makeRandom(o, u);
t.push({
varnaam: i,
value: a
});
}
}
return t;
},
addGlobalsToFormule: function(e) {
var t = this.getView(), n = t.getGlobalLinkEigenschapVariables(), r = t.getGlobalLinkEigenschapVariables().length;
for (var i = 0; i < r; i++) {
var s = new RegExp("\\" + n[i].name, "g");
s.test(e) && (e = e.replace(s, this.addGlobalsToFormule(n[i].answered)));
}
return e;
},
makeRandom: function(e, t) {
return e = e ? parseInt(e) : 0, t = t ? parseInt(t) : 100, Math.floor(Math.random() * (t - e + 1) + e);
}
});

// ObjectInterface.js

enyo.kind({
name: "educate.components.ObjectInterface",
kind: "educate.components.ActionHandler",
published: {
laag: "",
locked: !1,
selected: !1,
objType: "",
display: !0,
bIsInGroup: !1,
calculatedPosX: 0,
calculatedPosY: 0,
calculatedPosZ: 0,
calculatedWidth: 0,
calculatedHeight: 0,
removeAndResize: !0
},
handlers: {
layerSelected: "layerSelectedHandler",
deselectedObjects: "deselectedObjectsHandler",
viewsComplete: "viewsCompleteHandler",
actionSended: "actionSendedHandler",
layerVisibilityClicked: "layerVisibilityClickedHandler",
sublayerVisibilityClicked: "sublayerVisibilityClickedHandler",
layerLockClicked: "layerLockClickedHandler",
onAddLayerInLayerHolder: "onAddLayerInLayerHolderHandler",
onRemoveLayerInLayerHolder: "onRemoveLayerInLayerHolderHandler",
groupIsChanged: "groupIsChangedHandler"
},
objectActions: [ {
label: "toggle",
action: "toggle"
}, {
label: "toggleVisible",
action: "toggleVisible"
}, {
label: "zichtbaar",
action: "makeVisible"
}, {
label: "onzichtbaar",
action: "makeInvisible"
} ],
create: function() {
this.inherited(arguments), this.initLayername(), this.initOptions();
},
initOptions: function() {
var e = {};
for (var t in this.options) e[t] = this.options[t];
this.setOptions(e);
},
addOption: function(e, t) {
this.options || (this.options = {}), this.options[e] = t;
},
rendered: function() {
this.inherited(arguments), this.calculatedPosXChanged(), this.calculatedPosYChanged(), this.calculatedPosZChanged(), this.calculatedHeightChanged(), this.calculatedWidthChanged(), this.originChanged(), this.rotationChanged(), this.alphaChanged(), this.visibleChanged();
},
setPropertyValue: function(e, t, n) {
this.inherited(arguments);
switch (e) {
case "options":
case "modus":
case "mapType":
break;
default:
n && this.bubble("on" + e.substr(0, 1).toUpperCase() + e.substr(1) + "Changed");
}
},
ontapHandler: function() {
this.selectObject();
},
layerSelectedHandler: function(e, t) {
t.linked == this ? this.selectObject() : this.deselectObject();
},
initLayername: function() {
this.setLayername(this.getObjType() + this.getName());
},
deselectedObjectsHandler: function(e, t) {
this.deselectObject();
},
selectObject: function() {
!this.getLocked() && this.setSelected(!0);
},
deselectObject: function() {
this.setSelected(!1);
},
openChanged: function() {
this.addOption("open", this.getOpen());
},
toggleDisplay: function() {
this.setDisplay(!this.getDisplay());
},
displayChanged: function() {
this.applyStyle("display", this.getDisplay() ? "block" : "none");
},
visibleChanged: function() {
this.applyStyle("opacity", this.getVisible() !== !1 ? this.getAlpha() : 0), this.addOption("visible", this.getVisible()), this.laag && this.laag.setLaagOpen(this.getVisible());
},
alphaChanged: function() {
this.getVisible() !== !1 && this.applyStyle("opacity", this.getAlpha()), this.addOption("alpha", this.getAlpha());
},
getAlpha: function() {
return this.alpha !== null && this.alpha !== undefined ? this.alpha : 1;
},
lockedChanged: function() {
this.setSelected(!this.getLocked()), this.bubble("objectLockChange", this);
},
selectedChanged: function(e) {
this.addRemoveClass("selected", this.getSelected() && !this.getLocked()), this.getSelected();
},
layerVisibilityClickedHandler: function(e, t) {
this == t.linked && (this.displayChanged(), this.linked && this.linked.setDisplay(this.getDisplay()));
},
layerLockClickedHandler: function(e, t) {
this == t.linked && (this.setLocked(!this.getLocked()), this.linked && this.linked.setLocked(!this.linked.getLocked()));
},
onAddLayerInLayerHolderHandler: function(e, t) {
this == t.linked && this.setInLayerHolder(!0);
},
onRemoveLayerInLayerHolderHandler: function(e, t) {
this == t && this.setInLayerHolder(!1);
},
calculatedPosXChanged: function() {
this.applyStyle("left", this.calculatedPosX + "px");
},
calculatedPosYChanged: function() {
this.applyStyle("top", this.calculatedPosY + "px");
},
calculatedPosZChanged: function() {
this.applyStyle("transform", "translateZ(" + this.calculatedPosZ + "px)"), this.applyStyle("-webkit-transform", "translateZ(" + this.calculatedPosZ + "px)"), this.applyStyle("-ms-transform", "translateZ(" + this.calculatedPosZ + "px)");
},
calculatedWidthChanged: function() {
isNaN(this.calculatedWidth) ? this.applyStyle("width", "") : this.applyStyle("width", this.calculatedWidth + "px");
},
calculatedHeightChanged: function() {
isNaN(this.calculatedHeight) ? this.applyStyle("height", "") : this.applyStyle("height", this.calculatedHeight + "px");
},
rotationChanged: function() {
this.inherited(arguments), this.applyStyle("transform", "rotateX(" + this.rotation_x + "deg) rotateY(" + this.rotation_y + "deg) rotateZ(" + this.rotation_z + "deg)"), this.applyStyle("-webkit-transform", "rotateX(" + this.rotation_x + "deg) rotateY(" + this.rotation_y + "deg) rotateZ(" + this.rotation_z + "deg) perspective(1000)"), this.applyStyle("-ms-transform", "rotateX(" + this.rotation_x + "deg) rotateY(" + this.rotation_y + "deg) rotateZ(" + this.rotation_z + "deg) perspective(1000)");
},
originChanged: function() {
this.inherited(arguments), this.applyStyle("transform-origin", this.origin_x + "% " + this.origin_y + "%"), this.applyStyle("-webkit-transform-origin", this.origin_x + "% " + this.origin_y + "%"), this.applyStyle("-ms-transform-origin", this.origin_x + "% " + this.origin_y + "%");
},
groupIsChangedHandler: function(e, t) {
var n = t.opx - t.px, r = t.opy - t.py;
return this.setPosition_x(this.getPosition_x() + n), this.setPosition_y(this.getPosition_y() + r), this.resizeComponent(), !0;
},
changeOfGroup: function(e, t) {
e !== "stage" ? (this.setBIsInGroup(!0), t ? (this.setPosition_x(this.getPosition_x() + (t.getPosition_x() - this.container.getPosition_x())), this.setPosition_y(this.getPosition_y() + (t.getPosition_y() - this.container.getPosition_y()))) : (this.setPosition_x(this.getPosition_x() - this.container.getPosition_x()), this.setPosition_y(this.getPosition_y() - this.container.getPosition_y()))) : (this.setBIsInGroup(!1), this.setPosition_x(this.getPosition_x() + t.getPosition_x()), this.setPosition_y(this.getPosition_y() + t.getPosition_y())), t && t.handleGroupPosDimension();
},
downHandler: function(e, t) {
this.inherited(arguments);
if (!this.getLocked()) return !this.getSelected() && this.bubble("objectSelected", this), !0;
},
dragObjectHandler: function(e) {
this.inherited(arguments), this.calculatedPosX = e.touches[0].clientX - $(this.parent.hasNode()).offset().left - this.getClickX(), this.calculatedPosY = e.touches[0].clientY - $(this.parent.hasNode()).offset().top - this.getClickY(), this.render();
},
upHandler: function() {
this.inherited(arguments), this.setPosition_x(this.calculatedPosX / window.settings.SCALE + .5 >> 0), this.setPosition_y(this.calculatedPosY / window.settings.SCALE + .5 >> 0), this.getBIsInGroup() && this.container.handleGroupPosDimension(), this.bubble("updateProperties", this);
},
resizeComponent: function() {
this.render();
},
rotate: function(e) {
var t, n;
e.type === "touchmove" ? (t = e.touches[0].clientX, n = e.touches[0].clientY) : (t = e.clientX, n = e.clientY);
var r = t - $(this.getStage().hasNode()).offset().left, i = n - $(this.getStage().hasNode()).offset().top, s = r - this.absoluteOrigin.x, o = i - this.absoluteOrigin.y, u = Math.atan2(o, s) * 180 / Math.PI - this.startRotation;
this.setRotation_z(u), this.resizeComponent();
},
move: function(e) {
var t, n;
e.type === "touchmove" ? (t = e.touches[0].clientX, n = e.touches[0].clientY) : (t = e.clientX, n = e.clientY), this.calculatedPosX = t - $(this.parent.hasNode()).offset().left - this.getClickX(), this.calculatedPosY = n - $(this.parent.hasNode()).offset().top - this.getClickY(), this.setPosition_x(this.calculatedPosX / window.settings.SCALE + .5 >> 0), this.setPosition_y(this.calculatedPosY / window.settings.SCALE + .5 >> 0), this.resizeComponent();
},
position_xChanged: function() {
this.bubble("onPosition_xChanged");
},
position_yChanged: function() {
this.bubble("onPosition_yChanged");
},
position_zChanged: function() {
this.bubble("onPosition_zChanged");
},
setPosition_x: function(e) {
e = this.checkPosXLimiet(e), this.position_x = parseInt(e), this.position_xChanged && this.position_xChanged();
},
setPosition_y: function(e) {
e = this.checkPosYLimiet(e), this.position_y = parseInt(e), this.position_yChanged && this.position_yChanged();
},
setPosition_z: function(e) {
e = this.checkPosZLimiet(e), this.position_z = parseInt(e), this.position_zChanged && this.position_zChanged();
},
checkPosXLimiet: function(e) {
if (this.getIsPosLimiet()) switch (this.checkLimiet(this.getPosition_x_min(), this.getPosition_x_max(), e)) {
case "groter":
return this.getPosition_x_max();
case "kleiner":
return this.getPosition_x_min();
default:
return e;
}
return e;
},
checkPosYLimiet: function(e) {
if (this.getIsPosLimiet()) switch (this.checkLimiet(this.getPosition_y_min(), this.getPosition_y_max(), e)) {
case "groter":
return this.getPosition_y_max();
case "kleiner":
return this.getPosition_y_min();
default:
return e;
}
return e;
},
checkPosZLimiet: function(e) {
if (this.getIsPosLimiet()) switch (this.checkLimiet(this.getPosition_z_min(), this.getPosition_z_max(), e)) {
case "groter":
return this.getPosition_z_max();
case "kleiner":
return this.getPosition_z_min();
default:
return e;
}
return e;
},
checkLimiet: function(e, t, n) {
return e = parseFloat(e), t = parseFloat(t), n = parseFloat(n), this.isNumeric(e) && n < e ? "kleiner" : this.isNumeric(t) && n > t ? "groter" : "ok";
},
isNumeric: function(e) {
return !isNaN(parseFloat(e)) && isFinite(e);
},
solutionChanged: function() {
this.inherited(arguments);
},
activeChanged: function() {
this.inherited(arguments), this.addRemoveClass("no-mouse-events", !this.getActive()), this.bubble("updateProperties", this);
}
});

// OplossingButton.js

enyo.kind({
name: "educate.components.oplossing.OplossingButton",
tag: "div",
classes: "solution-btn",
published: {
isActive: !1
},
handlers: {
ontap: "toggleActive"
},
events: {
onShowSolution: "",
onHideSolution: ""
},
create: function() {
this.inherited(arguments);
},
rendered: function() {
this.inherited(arguments), this.resizeBtn();
},
toggleActive: function() {
this.setIsActive(!this.getIsActive());
},
isActiveChanged: function() {
this.addRemoveClass("active-state", this.getIsActive()), this.resizeBtnCheckFontSize(), this.getIsActive() ? this.doShowSolution() : this.doHideSolution();
},
resizeBtn: function() {
this.applyStyle("width", parseInt(46 * window.settings.SCALE) + "px"), this.applyStyle("height", parseInt(46 * window.settings.SCALE) + "px"), this.resizeBtnCheckFontSize(), this.applyStyle("line-height", parseInt(38 * window.settings.SCALE) + "px");
},
resizeBtnCheckFontSize: function() {
var e = this.getIsActive() ? 26 : 32;
this.applyStyle("font-size", parseInt(e * window.settings.SCALE) + "px");
}
});

// Knop.js

enyo.kind({
name: "educate.components.bediening.Knop",
kind: "educate.components.ObjectInterface",
fit: !1,
published: {
carrier: window.settings.CARRIERS.KNOP,
open: !1,
width: "auto",
height: "27",
linked: "",
paddingTop: "5",
marginTop: "5"
},
handlers: {},
components: [ {
tag: "p",
name: "up"
}, {
tag: "p",
classes: "solution",
name: "down"
} ],
create: function() {
this.inherited(arguments), this.css_classChanged(), this.openChanged(), this.resizeComponent();
},
rendered: function() {
this.inherited(arguments), this.valueChanged(), this.solutionChanged(), this.calculatedFontSizeChanged(), this.setOpen(this.open), this.setVisible(this.visible);
},
toggle: function() {
this.getSolution().length > 0 && this.setOpen(!this.open);
},
valueChanged: function() {
this.$.up.setContent(this.getValue());
},
solutionChanged: function() {
this.$.down.setContent(this.getSolution());
},
calculatedHeightChanged: function() {
this.inherited(arguments);
var e = this.open ? this.calculatedHeight / 2 : this.calculatedHeight;
this.applyStyle("line-height", e + "px");
},
calculatedMetricsChanged: function() {
this.$.up.applyStyle("padding-top", this.calculatedPaddingTop + "px"), this.$.down.applyStyle("margin-top", 5 + this.calculatedMarginTop + "px");
},
calculatedFontSizeChanged: function() {
this.applyStyle("font-size", this.calculatedFontSize + "rem");
},
css_classChanged: function() {
this.setClasses(this.getCss_class()), this.render();
},
resizeComponent: function() {
!isNaN(parseInt(this.getWidth())) && this.getWidth() != -1 ? this.calculatedWidth = parseInt(this.getWidth() * window.settings.SCALE) : this.calculatedWidth = "auto", (isNaN(parseInt(this.getHeight())) || parseInt(this.getHeight()) < 27) && this.setHeight(27), this.open ? this.calculatedHeight = parseInt(this.getHeight() * 2 * window.settings.SCALE * window.settings.FONTSIZEPROCENT) : this.calculatedHeight = parseInt(this.getHeight() * window.settings.SCALE * window.settings.FONTSIZEPROCENT), this.resizePosition(), this.calculatedFontSize = this.getFontSize() * window.settings.SCALE, this.calculatedPaddingTop = parseInt(this.getPaddingTop() * window.settings.SCALE), this.calculatedMarginTop = parseInt(this.getMarginTop() * window.settings.SCALE), this.render();
},
resizePosition: function() {
this.calculatedPosX = this.getPosition_x() * window.settings.SCALE + .5 >> 0, this.calculatedPosY = this.getPosition_y() * window.settings.SCALE + .5 >> 0;
},
openChanged: function(e) {
this.inherited(arguments), this.getOpen() !== e && (this.calculatedHeight = this.calculatedHeight * (this.getOpen() ? 2 : .5)), this.addRemoveClass("open", this.getOpen()), this.render();
}
});

// Icon.js

enyo.kind({
name: "educate.components.bediening.Icon",
kind: "educate.components.ObjectInterface",
fit: !1,
published: {
linked: "",
paddingTop: "5",
marginTop: "5",
open: "false",
width: "40",
height: "40",
objContent: ""
},
handlers: {
ontap: "ontapHandler"
},
rendered: function() {
this.inherited(arguments), this.calculatedFontSizeChanged();
},
calculatedFontSizeChanged: function() {
this.applyStyle("font-size", this.calculatedFontSize / 18 + "rem"), this.applyStyle("line-height", .2 + this.calculatedFontSize / 18 + "rem");
},
toggle: function() {
this.setOpen(!this.getOpen()), this.render();
},
resizeComponent: function() {
this.inherited(arguments), this.calculatedWidth = parseInt(this.getWidth() * window.settings.SCALE), this.calculatedHeight = parseInt(this.getHeight() * window.settings.SCALE), this.calculatedPosX = this.getPosition_x() * window.settings.SCALE + .5 >> 0, this.calculatedPosY = this.getPosition_y() * window.settings.SCALE + .5 >> 0, this.calculatedFontSize = parseInt(this.getFontSize() * 18 * window.settings.SCALE), this.calculatedPaddingTop = parseInt(this.getPaddingTop() * window.settings.SCALE), this.calculatedMarginTop = parseInt(this.getMarginTop() * window.settings.SCALE), this.render();
}
});

// IconContent.js

enyo.kind({
name: "educate.components.bediening.IconContent",
kind: "educate.components.ObjectInterface",
fit: !1,
classes: "",
published: {
open: !1,
showing: !1,
linked: null
},
handlers: {
onPropertiesChanged: "updateContent"
},
create: function() {
this.inherited(arguments), this.render();
},
rendered: function() {
this.inherited(arguments), this.calculatedFontSizeChanged();
},
resizeComponent: function(e) {
this.inherited(arguments), this.calculatedWidth = parseInt(this.getWidth() * window.settings.SCALE), this.calculatedHeight = parseInt(this.getHeight() * window.settings.SCALE), this.calculatedPosX = this.getPosition_x() * window.settings.SCALE + window.settings.OFFSETX + .5 >> 0, this.calculatedPosY = this.getPosition_y() * window.settings.SCALE + window.settings.OFFSETY + .5 >> 0, this.calculatedFontSize = parseInt(this.getFontSize() * 16 * window.settings.SCALE), this.render();
},
updateContent: function(e, t) {
this.resizeComponent();
},
selectedChanged: function(e) {
this.inherited(arguments), this.getLinked().setSelected(this.getSelected());
},
calculatedFontSizeChanged: function() {
this.applyStyle("font-size", this.calculatedFontSize / 18 + "rem"), this.applyStyle("line-height", .2 + this.calculatedFontSize / 18 + "rem");
}
});

// InfoIconContent.js

enyo.kind({
name: "educate.components.bediening.InfoIconContent",
kind: "educate.components.bediening.IconContent",
classes: "IconContent infoIconContent",
published: {
width: 50,
solution: "Optionele Titel",
vertPosition: "bottom",
carrier: window.settings.CARRIERS.CONTENT_ICON
},
components: [ {
name: "Header",
classes: "infoIconContentHeader",
components: [ {
components: [ {
kind: "educate.components.bediening.InfoIconI"
}, {
tag: "span",
name: "InfoIconContentTitle",
content: this.solution
}, {
tag: "span",
name: "dummy",
content: " ",
style: "display: inline-block; width: 0px"
} ],
classes: "infoIconContentTitleContainer"
}, {
tag: "i",
ontap: "closeButtonTappedHandler",
name: "InfoIconContentCloseButton",
classes: "fill-icon icon-delete-2"
} ]
}, {
tag: "div",
name: "IconContentTemplate",
classes: "infoIconContentTemplate",
allowHtml: !0
} ],
create: function() {
this.inherited(arguments), this.getCookie();
},
getCookie: function() {
var e = document.cookie.split("; "), t = e.length - 1, n = "";
for (t; t >= 0; t--) e[t].indexOf("educate_settings_infoPosition") >= 0 && (n = e[t].split("=")[1]);
n === "" && (n = "bottom", this.setCookie(n)), this.vertPosition = n;
},
setCookie: function(e) {
var t = new Date, n;
t.setDate(t.getDate() + 365), n = escape(e) + "; expires=" + t.toUTCString(), document.cookie = "educate_settings_infoPosition=" + n;
},
rendered: function() {
this.inherited(arguments), this.valueChanged(), this.calculatedFontSizeChanged(), this.vertPositionChanged();
},
closeButtonTappedHandler: function() {
this.linked.setOpen(!1);
},
calculatedPosXChanged: function() {},
calculatedPosYChanged: function() {},
calculatedPosZChanged: function() {},
originChanged: function() {},
rotationChanged: function() {},
calculatedHeightChanged: function() {},
calculatedWidthChanged: function() {},
vertPositionChanged: function() {
this.setCookie(this.getVertPosition()), this.getVertPosition() === "bottom" ? (this.applyStyle("top", null), this.applyStyle("bottom", "1.4em")) : (this.applyStyle("top", "1.4em"), this.applyStyle("bottom", null));
},
dragObjectHandler: function(e) {
this.applyStyle("bottom", null);
var t = this.getStage().hasNode(), n = 0;
t && (n = t.getBoundingClientRect().top), this.applyStyle("top", e.clientY - n - this.getClickY() + "px");
},
upHandler: function(e) {
$(document).off("mousemove"), $(document).off("mouseup");
var t = this.getStage().hasNode();
t && this.setVertPosition(e.clientY < parseFloat(this.getStage().getComputedStyleValue("height").replace("px", "")) * .5 + this.getStage().hasNode().getBoundingClientRect().top ? "top" : "bottom"), this.render();
},
valueChanged: function() {
this.$.IconContentTemplate.setContent(this.getValue());
},
showingChanged: function() {
this.inherited(arguments), this.getCookie(), this.vertPositionChanged(), this.getShowing() ? (window.infoField && window.infoField !== this && window.infoField.setShowing(!1), window.infoField = this) : this.linked && this.linked.setOpen(!1);
},
solutionChanged: function() {
this.inherited(arguments), this.$.InfoIconContentTitle.setContent(this.getSolution());
},
widthChanged: function() {
this.inherited(arguments), this.applyStyle("width", this.getWidth() + "%"), this.applyStyle("margin-left", parseFloat(this.getWidth()) / -2 + "%");
}
});

// PhotoIconContent.js

enyo.kind({
name: "educate.components.bediening.PhotoIconContent",
kind: "educate.components.bediening.IconContent",
classes: "modal IconContent photoIconContent",
published: {
photos: [],
images: [],
descriptions: [],
carrier: window.settings.CARRIERS.PHOTO_ICON_IMAGE,
activeImage: 0,
position_x: 0,
position_y: 0,
width: 300,
value: "[]",
solution: "[]"
},
components: [ {
tag: "div",
name: "images",
classes: "modal-body images",
allowHtml: !0
}, {
tag: "div",
name: "buttons",
classes: "modal-footer buttons",
components: [ {
kind: enyo.Button,
name: "prevBtn",
ontap: "prevClickedHandler",
classes: "btn pull-left",
allowHtml: !0,
content: '<i class="icon-chevron-left"></i>'
}, {
kind: enyo.Button,
name: "nextBtn",
ontap: "nextClickedHandler",
classes: "btn pull-right",
allowHtml: !0,
content: '<i class="icon-chevron-right"></i>'
} ]
} ],
create: function() {
this.inherited(arguments), this.valueChanged(), this.solutionChanged();
},
rendered: function() {
this.inherited(arguments);
},
calculatedPosZChanged: function() {},
originChanged: function() {},
rotationChanged: function() {},
calculatedFontSizeChanged: function() {},
prevClickedHandler: function() {
this.activeImage--, this.activeImage < 0 && (this.activeImage = this.photos.length - 1), this.activeImageChanged();
},
nextClickedHandler: function() {
this.activeImage++, this.activeImage >= this.photos.length && (this.activeImage = 0), this.activeImageChanged();
},
valueChanged: function() {
var e = JSON.parse(this.value);
e === null && (e = [], this.value = JSON.stringify(e)), this.photos = e, this.photosChanged();
},
getValue: function() {
return this.value = JSON.stringify(this.photos), this.value;
},
solutionChanged: function() {
var e = JSON.parse(this.solution);
e === null && (e = [], this.solution = JSON.stringify(e)), this.descriptions = e, this.descriptionsChanged();
},
getSolution: function() {
return this.solution = JSON.stringify(this.descriptions), this.solution;
},
photosChanged: function() {
this.$.images.destroyClientControls(), this.$.images.destroyComponents(), this.images = [];
var e, t = this.getPhotos().length;
for (e = 0; e < t; e++) {
var n = this.createComponent({
name: "image_" + e,
kind: "educate.components.bediening.PhotoIconImage",
url: Settings.WEBAPP + "/" + this.getPhotos()[e],
description: this.getDescriptions()[e],
container: this.$.images,
showing: !1
});
this.images.push(n);
}
this.activeImage = 0, this.activeImageChanged();
},
descriptionsChanged: function() {
this.photosChanged();
},
addPhoto: function(e) {
this.getPhotos().push(e), this.photosChanged();
},
removePhoto: function(e) {
this.photos.splice(this.photos.indexOf(e), 1), this.photosChanged();
},
activeImageChanged: function() {
var e, t = this.images.length;
for (e = 0; e < t; e++) this.images[e].setShowing(!1);
var n = this.$["image_" + this.activeImage];
n && (n.setShowing(!0), this.render());
},
resizeComponent: function() {
this.redrawComponent();
},
redrawComponent: function() {
this.getPosition_x() === null && (this.position_x = 0), this.getPosition_y() === null && (this.position_y = 0), this.calculatedPosX = this.getPosition_x() * window.settings.SCALE + window.settings.OFFSETX + .5 >> 0, this.calculatedPosY = this.getPosition_y() * window.settings.SCALE + window.settings.OFFSETY + .5 >> 0, this.calculatedWidth = this.getWidth() === null ? null : this.getWidth() * window.settings.SCALE + .5 >> 0, this.calculatedHeight = this.getHeight() === null ? null : this.getHeight() * window.settings.SCALE + .5 >> 0, this.render();
}
});

// PhotoIconImage.js

enyo.kind({
name: "educate.components.bediening.PhotoIconImage",
kind: enyo.Control,
published: {
url: "",
description: ""
},
components: [ {
name: "img",
kind: enyo.Image,
src: this.url
}, {
name: "description",
content: this.description,
allowHtml: !0
} ],
create: function() {
this.inherited(arguments), this.urlChanged(), this.descriptionChanged();
},
urlChanged: function() {
this.$.img.setSrc(this.getUrl());
},
descriptionChanged: function() {
this.$.description.setContent(this.getDescription());
}
});

// Dropdown.js

enyo.kind({
name: "educate.components.bediening.Dropdown",
kind: "educate.components.ObjectInterface",
fit: !1,
published: {
carrier: window.settings.CARRIERS.DROPDOWN,
width: "auto",
height: "270",
value: 0,
selectOptions: [],
correctOptions: "",
automaticSolution: !0,
showOptions: !0,
openDirectionUp: !1,
shuffleAnswers: !0,
startWithChoose: !0
},
components: [ {
name: "selectedVal",
tag: "div",
ontap: "dropDownTapped",
components: [ {
name: "selectedOption",
tag: "span",
content: "kies ...",
correct: ""
}, {
name: "arrow",
tag: "i",
classes: "fill-icon icon-chevron-down"
} ]
}, {
name: "droplist",
tag: "ul",
components: [ {
tag: "li",
content: "woord 1"
}, {
tag: "li",
content: "woord 2"
}, {
tag: "li",
content: "woord 3"
} ]
} ],
create: function() {
this.inherited(arguments), this.addLinkEigenschappenOptions(), this.resizeComponent(), this.changeArrow(this.getOpenDirectionUp()), this.handlePositionDropdown("1.70"), this.handleChoose();
},
rendered: function() {
this.inherited(arguments), this.calculatedFontSizeChanged();
},
addLinkEigenschappenOptions: function() {
this.getLinkEigenschappenOptions().value = "value";
},
updateDropdown: function() {
this.$.droplist.destroyClientControls(), this.getSelectOptions() && this.fixSelectOptions();
},
fixSelectOptions: function() {
var e = this.selectOptions.length;
for (var t = 0; t < e; t++) {
var n = this.selectOptions[t];
if (!n.text || n.text == "" || n.text == "label") n.text = n.value, n.value = 0;
}
},
changeArrow: function(e) {
e ? (this.$.arrow.removeClass("icon-chevron-down"), this.$.arrow.addClass("icon-chevron-up")) : (this.$.arrow.removeClass("icon-chevron-up"), this.$.arrow.addClass("icon-chevron-down"));
},
handlePositionDropdown: function(e) {
this.$.droplist.applyStyle(this.getOpenDirectionUp() ? "bottom" : "top", e + "rem"), this.$.droplist.applyStyle(this.getOpenDirectionUp() ? "top" : "bottom", null);
},
handleChoose: function() {
this.$.selectedOption.setContent(this.getStartWithChoose() ? "kies ..." : "");
},
calculatedHeightChanged: function() {
isNaN(this.calculatedHeight) ? this.applyStyle("line-height", "1.70rem") : (this.applyStyle("line-height", this.calculatedHeight / 16 + "rem"), this.handlePositionDropdown(this.calculatedHeight / 16));
},
calculatedFontSizeChanged: function() {
this.applyStyle("font-size", this.calculatedFontSize + "rem");
},
resizeComponent: function() {
!isNaN(parseInt(this.getWidth())) && this.getWidth() != -1 ? this.calculatedWidth = parseInt(this.getWidth() * window.settings.SCALE) : this.calculatedWidth = "auto", (isNaN(parseInt(this.getHeight())) || parseInt(this.getHeight()) < 27) && this.setHeight(27), this.calculatedHeight = parseInt(this.getHeight() * window.settings.SCALE * window.settings.FONTSIZEPROCENT), this.calculatedPosX = this.getPosition_x() * window.settings.SCALE + .5 >> 0, this.calculatedPosY = this.getPosition_y() * window.settings.SCALE + .5 >> 0, this.calculatedFontSize = this.getFontSize() * window.settings.SCALE, this.render();
}
});

// InfoIconI.js

enyo.kind({
tag: "div",
name: "educate.components.bediening.InfoIconI",
classes: "infoIconI",
allowHtml: !0,
content: '<?xml version="1.0" encoding="utf-8"?><svg version="1.1" id="icons" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="394.2 348.7 33.9 63.8" enable-background="new 394.2 348.7 33.9 63.8" xml:space="preserve"> <g fill="#FF0000" id="info_icon"> <path d="M408.1,364.6c-2.6,0-4.6-2.1-4.6-4.7v-6.6c0-2.6,2.1-4.6,4.7-4.6h3.8c1.2,0,2.4,0.5,3.3,1.4 c0.9,0.9,1.4,2.1,1.3,3.3v6.6c0,2.6-2.1,4.6-4.7,4.6H408.1z"/> <path d="M398.9,412.5c-2.6,0-4.7-2.1-4.7-4.7v-3.7c0-2.6,2.1-4.7,4.7-4.7h5.9v-18.7h-2c-2.6,0-4.6-2.1-4.6-4.7 v-3.7c0-2.6,2.1-4.7,4.6-4.7h10.4c2.6,0,4.7,2.1,4.7,4.7v27.1h5.5c2.6,0,4.7,2.1,4.7,4.7v3.7c0,2.6-2.1,4.7-4.7,4.7L398.9,412.5 L398.9,412.5z"/> </g> </svg>'
});

// Groep.js

enyo.kind({
name: "educate.components.groep.Groep",
kind: "educate.components.ObjectInterface",
classes: "groep",
published: {},
handlers: {},
components: [],
create: function() {
this.inherited(arguments), this.setCollection([]);
},
rendered: function() {
this.inherited(arguments);
},
ontapHandler: function() {},
arrangeObjectenGroup: function() {
var e = this.children;
e.sort(enyo.bind(this, "sortObjecten"));
for (var t in e) (e[t].kindName === "educate.create.components.groep.Groep" || e[t].kindName === "educate.frame.components.groep.Groep") && e[t].arrangeObjectenGroup(), $(e[t].hasNode()).prependTo(this.hasNode());
},
sortObjecten: function(e, t) {
return e.position - t.position;
},
resizeComponent: function() {
this.redrawGroup();
},
redrawGroup: function() {
this.calculatedWidth = parseInt(this.getWidth() * window.settings.SCALE), this.calculatedHeight = parseInt(this.getHeight() * window.settings.SCALE), this.calculatedPosX = this.getPosition_x() * window.settings.SCALE + .5 >> 0, this.calculatedPosY = this.getPosition_y() * window.settings.SCALE + .5 >> 0, this.render(), this.arrangeObjectenGroup();
}
});

// Image.js

enyo.kind({
name: "educate.components.image.Image",
kind: "educate.components.ObjectInterface",
tag: "img",
classes: "image",
published: {
carrier: window.settings.CARRIERS.AFBEELDING,
linked: "",
bAchtergrond: !1
},
handlers: {},
components: [],
create: function() {
this.inherited(arguments), this.valueChanged();
},
rendered: function() {
this.inherited(arguments), this.initAchtergrond();
},
redrawImage: function() {
this.getBAchtergrond() ? (this.calculatedWidth = parseInt(window.settings.STAGEWIDTH * window.settings.SCALE), this.calculatedHeight = parseInt(window.settings.STAGEHEIGHT * window.settings.SCALE), this.calculatedPosX = 0, this.calculatedPosY = 0) : (this.calculatedWidth = parseInt(this.getWidth() * window.settings.SCALE), this.calculatedHeight = parseInt(this.getHeight() * window.settings.SCALE), this.calculatedPosX = this.getPosition_x() * window.settings.SCALE + .5 >> 0, this.calculatedPosY = this.getPosition_y() * window.settings.SCALE + .5 >> 0), this.render();
},
valueChanged: function() {
if (this.getValue() !== null) {
this.getValue().value !== undefined ? this.setProperty("src", Settings.WEBAPP + this.getValue().value) : this.setProperty("src", Settings.WEBAPP + this.getValue());
var e = this;
e.render(), this.hasNode() && (this.hasNode().onload = function() {
e.render();
});
}
},
initAchtergrond: function() {
this.setLocked(this.getBAchtergrond()), this.addOption("background", this.getBAchtergrond()), this.addRemoveClass("background", this.getBAchtergrond()), this.bubble("objectLockChange", this);
},
resizeComponent: function() {
this.redrawImage();
}
});

// Animatie.js

enyo.kind({
name: "educate.components.animatie.Animatie",
kind: "educate.components.ObjectInterface",
fit: !1,
tag: "canvas",
classes: "canvas",
attributes: {
width: "250",
height: "40"
},
published: {
width: "250",
height: "40",
linked: "",
css_class: "loop",
json: "",
easelJson: "",
easelJsonFrames: "",
easelJsonImages: "",
easelJsonAnimation: ""
},
handlers: {},
statics: {
LOOP: "loop",
ACTION_LOOP: "actionLoop",
PLAY_ONCE: "playOnce",
PLAY_ONCE_REMOVE: "playOnceRemove",
RANDOM_START: "randomStart"
},
components: [],
stage: null,
movieClip: null,
animationNames: [],
create: function() {
this.inherited(arguments), this.makeAnimation();
},
getStage: function() {
return this.stage || (this.stage = new createjs.Stage(this.node)), this.stage;
},
setStage: function(e) {
this.stage = e;
},
rendered: function() {
this.inherited(arguments), this.getValue() || this.showTemplate();
},
showTemplate: function() {
var e = this.node.getContext("2d");
e.fillStyle = "#333333", e.fillRect(0, 0, 500, 40), e.fillStyle = "#FFFFFF", e.font = "30px Verdana", e.fillText("Geen animatie", 15, 32);
},
valueChanged: function() {
this.makeAnimation();
},
makeAnimation: function() {
console.log("makeAnimation", this.value), this.getValue() && this.loadJson();
},
loadJson: function() {
this.jsonRequest = new enyo.Ajax({
cacheBust: !0,
url: Settings.WEBAPP + "/" + this.getValue().value + ".json",
handleAs: "JSON",
JSONHandler: enyo.bind(this, "jsonLoadHandler")
}), this.jsonRequest.go();
},
jsonLoadHandler: function(e) {
this.setJson(JSON && JSON.parse(e.response) || $.parseJSON(e.response));
},
jsonChanged: function() {
this.getStage().removeAllChildren(), this.animationNames = [], this.parseJson();
var e = new createjs.SpriteSheet(this.easelJson);
this.movieClip = new createjs.BitmapAnimation(e), this.movieClip.gotoAndPlay("all"), this.getStage().addChild(this.movieClip), createjs.Ticker.setFPS(16), createjs.Ticker.addListener(this.getStage());
},
parseJson: function() {
this.easelJson = [], this.easelJsonFrames = [], this.easelJsonImages = [], this.easelJsonAnimation = [], this.easelJsonAnimation.all = {
frames: []
}, this.animationNames.push("all");
var e = 0;
for (var t in this.json.frames) {
e == 0 && this.setWidthHeight(this.json.frames[t].sourceSize.w, this.json.frames[t].sourceSize.h);
var n = [ this.json.frames[t].frame.x, this.json.frames[t].frame.y, this.json.frames[t].frame.w, this.json.frames[t].frame.h, this.json.frames[t].spriteSourceSize.x, this.json.frames[t].spriteSourceSize.y ];
this.easelJsonFrames.push(n);
var r = t.replace(/\d/g, "");
this.easelJsonAnimation[r] ? this.easelJsonAnimation[r].frames.push(e) : (this.animationNames.push(r), this.easelJsonAnimation[r] = {
frames: [ e ]
}), this.easelJsonAnimation.all.frames.push(e), e++;
}
this.easelJsonAnimation.all.next = "all", this.easelJsonImages = [ Settings.WEBAPP + "/" + this.getValue().value + ".png" ], this.easelJson.frames = this.easelJsonFrames, this.easelJson.images = this.easelJsonImages, this.easelJson.animations = this.easelJsonAnimation;
},
setWidthHeight: function(e, t) {
this.setWidth(e), this.setHeight(t), this.applyStyle("max-width", e + "px"), this.applyStyle("max-height", t + "px"), this.attributes.width = e, this.attributes.height = t;
},
resizeComponent: function() {
this.calculatedWidth = parseInt(this.getWidth() * window.settings.SCALE), this.calculatedHeight = parseInt(this.getHeight() * window.settings.SCALE), this.calculatedPosX = this.getPosition_x() * window.settings.SCALE + .5 >> 0, this.calculatedPosY = this.getPosition_y() * window.settings.SCALE + .5 >> 0, this.render();
},
css_classChanged: function() {
switch (this.getCss_class()) {
case educate.components.animatie.Animatie.LOOP:
this.movieClip.spriteSheet.getAnimation("all").next = "all", this.movieClip.gotoAndPlay("all");
break;
case educate.components.animatie.Animatie.ACTION_LOOP:
var e = this.animationNames[this.animationNames.length - 1];
this.movieClip.spriteSheet.getAnimation(e).next = e, this.movieClip.spriteSheet.getAnimation("all").next = e, this.movieClip.gotoAndPlay("all");
break;
case educate.components.animatie.Animatie.PLAY_ONCE:
this.movieClip.spriteSheet.getAnimation("all").next = null, this.movieClip.gotoAndPlay("all");
break;
case educate.components.animatie.Animatie.PLAY_ONCE_REMOVE:
this.movieClip.spriteSheet.getAnimation("all").next = null, this.movieClip.gotoAndPlay("all");
break;
case educate.components.animatie.Animatie.RANDOM_START:
this.movieClip.gotoAndStop(1);
var t = 1e3, n = 9e3, r = this, i = Math.random() * (n - t) + t;
setTimeout(function() {
r.movieClip.spriteSheet.getAnimation("all").next = null, r.movieClip.gotoAndPlay("all");
}, i);
}
this.onPropertiesChangedHandler();
}
});

// AnimatiePreview.js

enyo.kind({
name: "educate.components.animatie.AnimatiePreview",
kind: "educate.components.animatie.Animatie",
classes: "animatiePreviewCanvas",
published: {},
handlers: {},
components: [],
create: function() {
this.inherited(arguments), this.redrawCanvas();
},
jsonLoadHandler: function(e) {
this.inherited(arguments), enyo.Signals.send("onPreviewLoaded");
},
setWidthHeight: function(e, t) {
this.inherited(arguments), this.redrawCanvas();
},
downHandler: function(e, t) {
t.preventDefault();
},
dragObjectHandler: function(e) {},
upHandler: function() {},
resizeComponent: function() {
this.redrawCanvas();
},
redrawCanvas: function() {
this.calculatedWidth = parseInt(this.getWidth() * window.settings.SCALE), this.calculatedHeight = parseInt(this.getHeight() * window.settings.SCALE), this.calculatedPosX = parseInt(this.getPosition_x() * window.settings.SCALE), this.calculatedPosY = parseInt(this.getPosition_y() * window.settings.SCALE), this.render();
}
});

// SvgParser.js

"use strict";

enyo.kind({
name: "educate.components.svg.SvgParser",
kind: "educate.components.ObjectInterface",
classes: "svgParser",
published: {
collection: [],
allowHtml: !0,
svgString: "",
dbCollection: {},
isBackground: !1,
isTemplate: !0
},
components: [ {
tag: "div",
name: "svgContainer",
allowHtml: !0
} ],
constructor: function() {
this.inherited(arguments), this.setOptions({});
},
create: function() {
this.inherited(arguments);
},
rendered: function() {
this.inherited(arguments), this.updateNodes(), this.handleFonts();
},
initEventsReactiesOptions: function() {
this.inherited(arguments), delete this.getReactieOptions().OPEN, delete this.getReactieOptions().CLOSE, delete this.getReactieOptions().TOGGLE_OPEN;
},
optionsChanged: function() {
this.setShowArea(this.options.showArea != undefined ? this.options.showArea === !0 : !1), this.setIsBackground(this.options.background != undefined ? this.options.background === !0 : !1);
},
initAchtergrond: function() {
this.setLocked(this.getIsBackground()), this.addOption("background", this.getIsBackground()), this.addRemoveClass("background", this.getIsBackground()), this.bubble("objectLockChange", this);
},
valueChanged: function() {
this.inherited(arguments), this.setShowing(!1);
var e, t = this;
this.getValue() === "" ? (e = Settings.WEBAPP + "svnAssets/template.svg", this.isTemplate = !0) : typeof this.getValue() == "string" ? (e = Settings.WEBAPP + this.getValue(), this.isTemplate = !1) : (e = Settings.WEBAPP + this.getValue().value, this.isTemplate = !1);
var n = {
url: e
};
Ginkgo.ajax(n).then(function(e) {
t.svgAjaxLoaded(e);
}).fail(function(e) {
console.error(e);
});
},
svgAjaxLoaded: function(e) {
this.isTemplate ? this.collection = this.dbCollection : (this.dbCollection = this.collection, this.isTemplate = !0), this.collection = this.dbCollection;
var t = e.getElementsByTagName("svg")[0];
t.id = this.id + "_svg", t = this.handleSVG(t);
var n = new XMLSerializer, r = n.serializeToString(t);
this.$.svgContainer.setContent(r), this.doLayers(this.getLayerClass()), this.setShowing(!0), this.render(), this.redrawSvg(), this.bubble("svgLoaded", this);
},
getLayerClass: function() {
return educate.components.svg.svgzone;
},
handleSVG: function(e) {
return e;
},
doLayers: function(e) {
var t = document.getElementById(this.id + "_svg"), n = t.childNodes, r = [], i = [], s = 0, o = this;
for (s = 0; s < n.length; s++) {
if (n[s].nodeName == "path" || n[s].nodeName == "g" || n[s].nodeName == "polygon") r.push(n[s].id), i.push(n[s]);
this.zones = i;
}
var u = [], a, f, l, c, h;
i = {};
for (s = 0; s < this.zones.length; s++) {
var p = !1;
l = this.zones[s], c = this.getZoneInfo(l.id);
switch (c.zoneType) {
case "legende":
a = new e.SvgZoneLegende;
break;
default:
a = new e.SvgZone;
}
a.setOwner(this);
for (var d in this.collection) f = this.collection[d], l.id === f.value && (p = !0, a.layername = f.name, a.type = f.type, a.objectId = f.id, a.databaseId = f.id, a.value = f.value, a.carrier = f.carrier, a.css_class = f.css_class, a.position_x = f.position_x, a.position_y = f.position_y, a.position_z = f.position_z, a.width = f.width, a.height = f.height, a.origin = f.origin, a.rotation = f.rotation, a.solution = f.solution, a.answered = f.answered, a.parent = f.parent, a.finalObject = f.finalObject, a.inLayerHolder = f.inLayerHolder, a.layerHolderDefault = f.layerHolderDefault, a.position = f.position, a.options = f.options, a.active = parseInt(f.active), a.isPosLimiet = f.isPosLimiet, a.isRotLimiet = f.isRotLimiet, a.position_x_min = f.position_x_min, a.position_x_max = f.position_x_max, a.position_y_min = f.position_y_min, a.position_y_max = f.position_y_max, a.position_z_min = f.position_z_min, a.position_z_max = f.position_z_max, a.rotation_x_min = f.rotation_x_min, a.rotation_x_max = f.rotation_x_max, a.rotation_y_min = f.rotation_y_min, a.rotation_y_max = f.rotation_y_max, a.rotation_z_min = f.rotation_z_min, a.rotation_z_max = f.rotation_z_max, a.collection = [], a.type = c.zoneType, typeof f.options == "string" && (f.options = JSON.parse(f.options)), a.options = f.options);
c && (a.value = l.id, a.svgparser = this, a.viewId = this.getViewId(), a.node = l, p || (a.type = c.zoneType, a.layername = c.zoneName, this.getView().countViewObjectsId && (a.objectId = this.getView().countViewObjectsId())), c.zoneType === "legende" && (a = this.doLegende(a)), u.push(a), i[l.id] = a, a.init());
}
return this.zones = i, this.collection = u, t;
},
doLegende: function(e) {
var t = [], n = [], r = 0, i = this.getLayerClass(), s, o = this;
if (e.collection.length > 0) {
t = e.collection, e.collection = [];
for (r = 0; r < e.node.childNodes.length; r++) (e.node.childNodes[r].nodeName == "path" || e.node.childNodes[r].nodeName == "g" || e.node.childNodes[r].nodeName == "polygon") && n.push(e.node.childNodes[r]), e.zones = n;
for (r = 0; r < t.length; r++) {
var u = t[r];
u && (s = new i.SvgZoneLegendeItem, s.layername = u.name, s.value = u.value, s.type = "legendeItem", s.svgparser = this, s.viewId = this.getViewId(), s.node = e.node.children[u.value], e.collection.push(s));
}
} else {
t = e.node.childNodes;
for (r = 0; r < t.length; r++) (t[r].nodeName == "path" || t[r].nodeName == "g" || t[r].nodeName == "polygon") && n.push(t[r]), e.zones = n;
for (r = 0; r < e.zones.length; r++) {
var a = e.zones[r];
s = new i.SvgZoneLegendeItem, s.layername = a.id.replace(/_/g, " "), s.value = a.id, s.type = "legendeItem", s.svgparser = this, s.viewId = this.getViewId(), s.node = a, e.collection.push(s);
}
}
return e;
},
ontapHandler: function(e, t) {
this.inherited(arguments);
var n = this.getZoneByTarget(t.target);
n && n.bubble("ontap", t, n);
},
getZoneByTarget: function(e) {
var t = e;
while (t !== undefined && t.id !== undefined && this.zones[t.id] === undefined && t.id !== this.id) t = t.parentNode;
return this.zones[t.id];
},
getZoneInfo: function(e) {
var t = /_x24_/;
if (t.test(e)) {
var n = new Object, r = e.split("_x24_");
return n.zoneType = r[0], n.zoneName = this.replaceCharsInString(r[1]).replace(/_/g, " "), n;
}
return !1;
},
replaceCharsInString: function(e) {
var t = e.match(/_x[0-9a-f]+_/gi);
return t === null ? e : (t.forEach(function(t) {
e = e.replace(t, String.fromCharCode("0" + t.substr(1, t.length - 2)));
}), e);
},
downHandler: function(e, t) {
this.preventDefaultEvent && t.preventDefault();
if (!this.locked || !this.getLocked()) {
var n, r;
t.type === "touchmove" ? (n = t.touches[0].clientX, r = t.touches[0].clientY) : (n = t.clientX, r = t.clientY);
var i = $(this.getStage().hasNode()).offset(), s = $(this.hasNode()).offset(), o = n - i.left, u = r - i.top, a = o - this.absoluteOrigin.x, f = u - this.absoluteOrigin.y;
this.setClickX(n - s.left), this.setClickY(r - s.top), this.startRotation = Math.atan2(f, a) * 180 / Math.PI - this.rotation_z;
}
},
resizeComponent: function() {
this.redrawSvg();
},
redrawSvg: function() {
this.calculatedPosX = this.position_x * window.settings.SCALE, this.calculatedPosY = this.position_y * window.settings.SCALE;
var e = this.hasNode();
e && (this.boundingBox = {
x: parseInt(this.calculatedPosX) + .5 >> 0,
y: parseInt(this.calculatedPosY) + .5 >> 0,
width: parseInt(this.width * window.settings.SCALE),
height: parseInt(this.height * window.settings.SCALE)
}, this.absoluteOrigin = {
x: this.boundingBox.x + this.getOrigin_x() / 100 * this.boundingBox.width,
y: this.boundingBox.y + this.getOrigin_y() / 100 * this.boundingBox.height
}, $(e).css({
left: parseInt(this.calculatedPosX) + .5 >> "0px",
top: parseInt(this.calculatedPosY) + .5 >> "0px",
height: parseInt(this.height * window.settings.SCALE) + "px",
width: parseInt(this.width * window.settings.SCALE) + "px",
opacity: this.getVisible() !== !1 ? this.getAlpha() : 0,
display: this.getDisplay() ? "block" : "none"
}));
},
selectZone: function(e) {
this.bubble("objectSelected", e);
},
displayChanged: function() {
this.redrawSvg();
},
visibleChanged: function() {
this.redrawSvg(), this.laag && this.laag.setLaagOpen(this.getVisible());
},
updateNodes: function() {
if (this.collection.length > 0) {
var e = this.getCollection().length - 1;
for (e; e >= 0; e--) this.getCollection()[e].init && this.getCollection()[e].init();
}
},
handleFonts: function() {
var e = $("#" + this.id + " text"), t = e.length, n = [], r = 0;
if (t === 0 || typeof WebFont == "undefined") return !1;
for (r = 0; r < t; r++) {
var i = e[r];
if (!$(i).attr("font-family")) continue;
var s = $(i).attr("font-family").match(/[\w\-]+/)[0], o = s.split("-")[0].replace(/([A-Z][a-z]+)/g, "$1 ").trim().replace(/ ?MT ?/g, ""), u = s.split("-")[1] ? ":" + s.split("-")[1].replace(/([A-Z][a-z]+)/g, "$1 ").trim() : "", a = 400, f = "inherit";
if (u !== "") {
switch (!0) {
case u.toLowerCase().indexOf("extralight") !== -1:
a = 200;
break;
case u.toLowerCase().indexOf("light") !== -1:
a = 300;
break;
case u.toLowerCase().indexOf("medium") !== -1:
a = 500;
break;
case u.toLowerCase().indexOf("semibold") !== -1:
a = 600;
break;
case u.toLowerCase().indexOf("bold") !== -1:
a = 700;
break;
case u.toLowerCase().indexOf("extrabold") !== -1:
a = 800;
break;
default:
a = 400;
}
u.toLowerCase().indexOf("italic") !== -1 && (u = u.replace(" Italic", "Italic"), f = "italic");
}
o !== "Arial" && n.indexOf(o + u) === -1 && n.push(o + u), $(i).css("font-family", o), $(i).css("font-weight", a), $(i).css("font-style", f), $(i).css("font-size", $(i).attr("font-size") + "px"), $(i).attr("font-family", null), $(i).attr("font-size", null);
}
n.length > 0 && WebFont.load({
google: {
families: n
}
});
}
});

// SvgZone.js

enyo.kind({
name: "educate.components.svg.svgzone.SvgZone",
kind: "educate.components.ObjectInterface",
published: {
layername: "",
value: "",
laag: "",
active: 1,
svgparser: "",
objectId: "",
databaseId: "",
popupZoneName: !1
},
handlers: {},
objectActions: [ {
label: "togglezone",
action: "togglezone"
} ],
create: function() {
this.inherited(arguments);
},
render: function() {
this.inherited(arguments), this.updateNode();
},
initEventsReactiesOptions: function() {
this.inherited(arguments), delete this.getReactieOptions().OPEN, delete this.getReactieOptions().CLOSE, delete this.getReactieOptions().TOGGLE_OPEN;
},
init: function() {
this.initOptions(), this.options ? (this.visible = this.options["visible"] != 0 ? 1 : 0, this.popupZoneName = this.options.popupzonename === !0) : (this.options = {}, this.addOption("visible", 1), this.visible = 1), this.updateNode();
},
getNode: function() {
return this.node ? this.node : !1;
},
updateNode: function() {
this.svgparser && (this.node = $("#" + this.svgparser.id + "_svg #" + this.getValue())[0], this.visibleChanged(), this.activeChanged());
},
initLayername: function() {},
visibleChanged: function() {
this.node && (this.node.style.opacity = this.getVisible() ? this.getAlpha() : 0, this.addOption("visible", this.getVisible()));
},
displayChanged: function() {
this.node && (this.node.style.display = this.getDisplay() ? "block" : "none");
},
activeChanged: function() {
this.hasNode() && (this.node.style.pointerEvents = this.getActive() ? "auto" : "none");
},
alphaChanged: function() {
this.getVisible() !== !1 && (this.node.style.opacity = this.getAlpha()), this.addOption("alpha", this.getAlpha());
},
resizeComponent: function() {}
});

// radiobutton.js

enyo.kind({
name: "educate.components.selection.Radiobutton",
kind: enyo.Input,
classes: "enyo-radiobutton",
events: {
onActivate: ""
},
published: {
checked: !1,
active: !1,
type: "radio"
},
kindClasses: "",
handlers: {
onchange: "change",
onclick: "click"
},
create: function() {
this.inherited(arguments);
},
rendered: function() {
this.inherited(arguments), this.active && this.activeChanged(), this.checkedChanged();
},
getChecked: function() {
return Boolean(this.getNodeProperty("checked", this.checked));
},
checkedChanged: function() {
this.setNodeProperty("checked", this.checked), this.setAttribute("checked", this.checked ? "checked" : ""), this.setActive(this.checked);
},
activeChanged: function() {
this.active = Boolean(this.active), this.setChecked(this.active), this.bubble("onActivate");
},
setValue: function(e) {
this.setChecked(Boolean(e));
},
getValue: function() {
return this.getChecked();
},
valueChanged: function() {},
change: function() {
this.setActive(this.getChecked());
},
click: function(e, t) {
enyo.platform.ie <= 8 && this.bubble("onchange", t);
}
});

// labeledRadiobutton.js

enyo.kind({
name: "educate.components.selection.LabeledRadiobutton",
kind: enyo.Control,
components: [ {
kind: "educate.components.selection.Radiobutton",
name: "rbt"
}, {
tag: "label",
ontap: "onLabelTapHandler",
name: "lbl"
} ],
published: {
checked: !1,
label: "",
group: "group"
},
events: {
onStateChanged: ""
},
handlers: {
ontap: "ontapHandler"
},
create: function() {
this.inherited(arguments), this.labelChanged(), this.groupChanged(), this.checkedChanged();
},
rendered: function() {
this.inherited(arguments);
},
onLabelTapHandler: function(e, t) {},
getChecked: function() {
return this.checked = this.$.rbt.getChecked(), this.checked;
},
checkedChanged: function() {
this.$.rbt.setChecked(this.checked);
},
labelChanged: function() {
this.$.lbl.content = this.label;
},
groupChanged: function() {
this.$.rbt.setAttribute("name", this.group);
},
ontapHandler: function(e, t) {
this.bubble("onStateChanged", t, e);
}
});

// radiobuttongroup.js

enyo.kind({
name: "educate.components.selection.RadiobuttonGroup",
kind: enyo.Control,
tag: "div",
published: {
groupname: "group",
buttons: []
},
events: {
onStateChanged: "",
onSelectionChange: ""
},
handlers: {
onStateChanged: "onStateChangedHandler"
},
create: function() {
this.inherited(arguments), this.groupnameChanged(), this.buttonsChanged();
},
rendered: function() {
this.inherited(arguments);
},
groupnameChanged: function() {
for (var e in this.components) this.components[e].setGroup(this.groupname);
},
buttonsChanged: function() {
this.destroyClientControls(), this.destroyComponents();
for (var e in this.buttons) this.createComponent({
kind: "educate.components.selection.LabeledRadiobutton",
label: this.buttons[e].label,
group: this.groupname,
classes: this.buttons[e].classes,
checked: this.buttons[e].checked,
container: this
});
},
onStateChangedHandler: function(e, t) {
if (!e.getChecked()) {
for (var n in this.components) this.components[n].setChecked(!1);
e.setChecked(!0), this.bubble("onSelectionChange", {
value: e.label
});
}
},
setValue: function(e) {
var t = -1;
for (var n in this.buttons) this.buttons[n].label === e && (t = n);
if (t !== -1) {
for (var n in this.buttons) this.buttons[n].checked = !1;
this.buttons[t].checked = !0, this.bubble("onSelectionChange", {
value: this.buttons[t].label
}), this.buttonsChanged();
}
}
});

// Tekst.js

enyo.kind({
name: "educate.components.tekst.Tekst",
kind: "educate.components.ObjectInterface",
classes: "Tekst",
published: {},
handlers: {},
components: [],
rendered: function() {
this.inherited(arguments), this.valueChanged(), this.calculatedFontSizeChanged(), this.calculatedMetricsChanged();
},
resizeComponent: function() {
this.redraw();
},
redraw: function() {
!isNaN(parseInt(this.getWidth())) && this.getWidth() != -1 ? this.calculatedWidth = parseInt(this.getWidth() * window.settings.SCALE) : this.calculatedWidth = "auto", !isNaN(parseInt(this.getHeight())) && this.getHeight() != -1 ? this.calculatedHeight = parseInt(this.getHeight() * window.settings.SCALE) : this.calculatedHeight = "auto", this.calculatedPosX = this.getPosition_x() * window.settings.SCALE + .5 >> 0, this.calculatedPosY = this.getPosition_y() * window.settings.SCALE + .5 >> 0, this.calculatedFontSize = parseInt(this.getFontSize() * 18 * window.settings.SCALE), this.calculatedPaddingTop = parseInt(this.getPaddingTop() * window.settings.SCALE), this.render();
}
});

// video.js

enyo.kind({
name: "educate.components.video.Video",
kind: "educate.components.ObjectInterface",
classes: "videoplayer bordered",
published: {
bordered: !0,
moreinfo: !0,
timeline: !0,
playable: !0,
skipable: !0,
windable: !0,
loopable: !0,
fullscreenable: !1,
closeable: !1,
autoClose: !1,
carrier: window.settings.CARRIERS.VIDEO,
keyframes: {},
title: "",
label: "",
description: "",
showDescription: !1,
currentTime: 0,
duration: 0,
playbackRate: 1,
options: {
visible: !0,
bordered: !0,
controlable: !0,
skipable: !0,
windable: !0,
loopable: !0,
timeline: !0,
moreinfo: !0,
timelined: !1,
fullscreenable: !1,
closeable: !1,
autoClose: !1,
currentFrame: null,
currentTime: null,
percentage: null,
playable: !0,
keyframes: {},
alpha: 1,
title: "",
label: "",
playbackRate: 1
}
},
components: [ {
kind: "educate.components.video.Player",
name: "player"
} ],
events: {
onActionPlay: "",
onActionPause: "",
onActionEnd: "",
onActionProgress: "",
onActionKeyframe: ""
},
handlers: {
onPropertiesChanged: "onPropertiesChangedHandler",
onHasPlayableChanged: "onHasPlayableChangedHandler",
onHasSkippingChanged: "onHasSkippingChangedHandler",
onHasWindingChanged: "onHasWindingChangedHandler",
onHasLoopingChanged: "onHasLoopingChangedHandler",
onHasFullscreenChanged: "onHasFullscreenChangedHandler",
onHasMoreinfoChanged: "onHasMoreinfoChangedHandler",
onCurrentTimeChanged: "onCurrentTimeChangedHandler",
onDurationChanged: "onDurationChangedHandler",
onPlay: "onPlayHandler",
onPause: "onPauseHandler",
onProgress: "onProgressHandler",
onKeyframe: "onKeyframeHandler",
onCloseTapped: "onCloseTappedHandler"
},
create: function() {
this.inherited(arguments), this.resizeComponent();
},
initEventsReactiesOptions: function() {
this.inherited(arguments), this.getEventOptions().ON_PLAY = {
label: "onPlay",
action: "onActionPlay"
}, this.getEventOptions().ON_PAUSE = {
label: "onPause",
action: "onActionPause"
}, this.getEventOptions().ON_END = {
label: "onEnd",
action: "onActionEnd"
}, this.getEventOptions().ON_PROGRESS = {
label: "onProgress",
action: "onActionProgress"
}, this.getEventOptions().ON_KEYFRAME = {
label: "onKeyframe",
action: "onActionKeyframe"
}, this.getReactieOptions().PLAY = {
label: "play",
action: "play"
}, this.getReactieOptions().PAUSE = {
label: "pause",
action: "pause"
}, this.getReactieOptions().SKIP = {
label: "volgende",
action: "skip"
}, this.getReactieOptions().PREVIOUS = {
label: "vorige",
action: "rewind"
};
},
initLinkEigenschappenOptions: function() {
this.setLinkEigenschappenOptions({
posx: "position_x",
posy: "position_y",
posz: "position_z",
width: "width",
height: "height",
rotx: "rotation_x",
roty: "rotation_y",
rotz: "rotation_z",
alpha: "alpha",
time: "currentTime",
percentage: "percentage",
playbackRate: "playbackRate"
});
},
valueChanged: function() {
if (this.getValue() === null || this.getValue() === "") return;
if (typeof this.getValue() == "string") {
this.addClass("loading");
var e = this.getValue(), t = e.substr(8), n = new enyo.Ajax({
url: Settings.WEBAPP + "/vimeo/getVideo",
handleAs: "json"
});
n.response(enyo.bind(this, "completeGetVimeoHandler")), n.go({
id: t
});
} else this.removeClass("loading"), this.$.player.setSource(this.getValue()), this.setKeyframes({});
},
completeGetVimeoHandler: function(e, t) {
this.setValue(t);
},
solutionChanged: function() {
this.inherited(arguments), this.getSolution() !== undefined && this.getSolution() !== null && this.getSolution() !== "" && (this.setDescription(this.getSolution()), this.solution = null);
},
optionsChanged: function() {
this.inherited(arguments);
var e = this.getOptions();
e.fullscreenAble !== undefined && (e.fullscreenable = e.fullscreenAble, delete e.fullscreenAble), this.setBordered(e.bordered), this.setMoreinfo(e.moreinfo), this.setTimeline(e.timeline), this.setPlayable(e.playable), this.setSkipable(e.skipable), this.setWindable(e.windable), this.setLoopable(e.loopable), this.setFullscreenable(e.fullscreenable), this.setCloseable(e.closeable), this.setAutoClose(e.autoClose), this.setShowDescription(e.showDescription), this.setKeyframes(e.keyframes || {}), this.setTitle(e.title || ""), this.setLabel(e.label || ""), this.setDescription(e.description || ""), this.setPlaybackRate(e.playbackRate);
},
borderedChanged: function(e) {
this.addRemoveClass("bordered", this.getBordered()), this.addOption("bordered", this.getBordered()), this.optionsChanged();
},
moreinfoChanged: function(e) {
this.$.player.setMoreinfo(this.getMoreinfo()), this.addOption("moreinfo", this.getMoreinfo()), this.optionsChanged();
},
timelineChanged: function(e) {
this.$.player.setTimeline(this.getTimeline()), this.addOption("timeline", this.getTimeline()), this.optionsChanged();
},
playableChanged: function(e) {
if (this.getPlayable() === undefined || this.getPlayable() === null) this.playable = !0;
this.$.player.setPlayable(this.getPlayable()), this.addOption("playable", this.getPlayable()), this.optionsChanged();
},
skipableChanged: function(e) {
this.$.player.setSkipable(this.getSkipable()), this.addOption("skipable", this.getSkipable()), this.optionsChanged();
},
windableChanged: function(e) {
this.$.player.setWindable(this.getWindable()), this.addOption("windable", this.getWindable()), this.optionsChanged();
},
loopableChanged: function(e) {
this.$.player.setLoopable(this.getLoopable()), this.addOption("loopable", this.getLoopable()), this.optionsChanged();
},
fullscreenableChanged: function(e) {
this.$.player.setFullscreenable(this.getFullscreenable()), this.addOption("fullscreenable", this.getFullscreenable()), this.optionsChanged();
},
closeableChanged: function(e) {
this.$.player.setCloseable(this.getCloseable()), this.addOption("closeable", this.getCloseable()), this.optionsChanged();
},
autoCloseChanged: function() {
this.autoClose === undefined && (this.autoClose = !1);
if (this.autoClose) {
var e = new educate.Actie;
e.event = "ON_END", e.eventName = "ON_END.DEACTIVATE", e.targets = [ this.getObjectId() ], e.reactions = [ [ [ "DEACTIVATE" ] ] ], this.objectHandlers.push(e), this.objectHandlersChanged();
} else {
var t = this.objectHandlers.length - 1, n = [];
for (t; t >= 0; t--) this.objectHandlers[t].eventName === "ON_END.DEACTIVATE" && n.push(t);
while (n.length > 0) this.objectHandlers.splice(n.pop(), 1);
}
this.addOption("autoClose", this.getAutoClose()), this.optionsChanged();
},
objectHandlersChanged: function() {
var e = this.objectHandlers.length - 1, t = [];
for (e; e >= 0; e--) this.objectHandlers[e].eventName === "ON_END.DEACTIVATE" && t.push(e);
while (t.length > 1) this.objectHandlers.splice(t.pop(), 1);
this.inherited(arguments);
},
keyframesChanged: function() {
this.$.player.keyframes = this.getKeyframes(), this.addOption("keyframes", this.getKeyframes()), this.$.player.keyframesChanged(), this.optionsChanged();
},
titleChanged: function(e) {
this.$.player.setTitle(this.getTitle()), this.addOption("title", this.getTitle()), this.optionsChanged();
},
labelChanged: function(e) {
this.$.player.setLabel(this.getLabel()), this.addOption("label", this.getLabel()), this.optionsChanged();
},
descriptionChanged: function() {
this.$.player.setDescription(this.getDescription()), this.addOption("description", this.getDescription()), this.optionsChanged();
},
showDescriptionChanged: function() {
this.addOption("showDescription", this.getShowDescription()), this.$.player.setShowDescription(this.getShowDescription());
},
playbackRateChanged: function() {
return undefined === this.getPlaybackRate() ? (this.setPlaybackRate(1), this) : (this.addOption("playbackRate", this.getPlaybackRate()), this.$.player.setPlaybackRate(this.getPlaybackRate()), this);
},
getPercentage: function() {
return this.$.player.getPercentage();
},
setPercentage: function(e) {
if (isNaN(parseFloat(e))) return;
this.$.player.setPercentage(parseFloat(e));
},
getCurrentTime: function() {
return this.$.player.getCurrentTime();
},
setCurrentTime: function(e) {
this.$.player.setCurrentTime(e);
},
resizeComponent: function() {
this.redrawVideo();
},
redrawVideo: function() {
this.setCalculatedWidth(this.getWidth() !== null && this.getWidth() !== -1 ? parseFloat(this.getWidth() * window.settings.SCALE) : "auto"), this.setCalculatedHeight(this.getHeight() !== null && this.getHeight() !== -1 ? parseFloat(this.getHeight() * window.settings.SCALE) : "auto"), this.setCalculatedPosX(this.getPosition_x() * window.settings.SCALE + .5 >> 0), this.setCalculatedPosY(this.getPosition_y() * window.settings.SCALE + .5 >> 0);
},
onHasPlayableChangedHandler: function(e, t) {
this.setPlayable(this.$.player.getPlayable());
},
onHasSkippingChangedHandler: function(e, t) {
this.setSkipable(this.$.player.getSkipable());
},
onHasWindingChangedHandler: function(e, t) {
this.setWindable(this.$.player.getWindable());
},
onHasLoopingChangedHandler: function(e, t) {
this.setLoopable(this.$.player.getLoopable());
},
onHasFullscreenChangedHandler: function(e, t) {
this.setFullscreenable(this.$.player.getFullscreenable());
},
onHasCloseButtonChangedHandler: function(e, t) {
this.setCloseable(this.$.player.getHasCloseButton());
},
onHasMoreinfoChangedHandler: function(e, t) {
this.setMoreinfo(this.$.player.getMoreinfo());
},
addKeyframe: function(e, t, n) {
this.keyframes[e] = {
label: t,
description: n
}, this.keyframesChanged();
},
removeKeyframe: function(e) {
if (this.keyframes[e] === undefined) return;
delete this.keyframes[e], this.keyframesChanged();
},
onCurrentTimeChangedHandler: function(e, t) {
this.setCurrentTime(this.$.player.getCurrentTime());
},
currentTimeChanged: function(e) {
this.$.player.setCurrentTime(this.getCurrentTime());
},
onDurationChangedHandler: function(e, t) {
this.setDuration(this.$.player.getDuration());
},
durationChanged: function(e) {
this.$.player.setDuration(this.getDuration());
},
jumpTo: function(e) {
this.$.player.jumpTo(e);
},
play: function() {
this.$.player.play();
},
pause: function() {
this.$.player.pause();
},
skip: function() {
this.$.player.skip();
},
rewind: function() {
this.$.player.rewind();
},
onPlayHandler: function(e, t) {
return this.doActionPlay({
originator: this,
action: "ON_PLAY"
}), !0;
},
onPauseHandler: function(e, t) {
return this.getPercentage() === 1 ? this.doActionEnd({
originator: this,
action: "ON_END"
}) : this.doActionPause({
originator: this,
action: "ON_PAUSE"
}), !0;
},
onProgressHandler: function(e, t) {
return this.doActionProgress({
originator: e,
action: "ON_PROGRESS"
}), !0;
},
onKeyframeHandler: function(e, t) {
return this.doActionKeyframe({
originator: e,
action: "ON_KEYFRAME"
}), !0;
},
onCloseTappedHandler: function(e, t) {
this.makeInactive();
},
activeChanged: function() {
this.inherited(arguments), this.$.player.pause();
},
visibleChanged: function() {
this.inherited(arguments), this.$.player.pause();
}
});

// player.js

enyo.kind({
name: "educate.components.video.Player",
kind: enyo.Control,
classes: "player",
components: [ {
kind: "educate.components.video.player.Video",
name: "video",
onCurrentTimeChanged: "videoCurrentTimeChangedHandler",
onDurationChanged: "videoDurationChangedHandler",
onPlay: "videoPlayHandler",
onPause: "videoPauseHandler",
onEnded: "videoEndedHandler"
}, {
kind: "educate.components.video.player.Timeline",
name: "timeline",
onCurrentTimeChanged: "videoCurrentTimeChangedHandler",
onIsKeyframe: "videoIsKeyframeHandler"
}, {
kind: "educate.components.video.player.Controls",
name: "controls",
onHasPlayableChanged: "onHasPlayableChangedHandler",
onHasSkippingChanged: "onHasSkippingChangedHandler",
onHasWindingChanged: "onHasWindingChangedHandler",
onHasLoopingChanged: "onHasLoopingChangedHandler",
onHasFullscreenChanged: "onHasFullscreenChangedHandler",
onHasCloseButtonChanged: "onHasCloseButtonChangedHandler",
onHasMoreinfoChanged: "onHasMoreinfoChangedHandler",
onIsPlayingChanged: "onIsPlayingChangedHandler",
onIsLoopingChanged: "onIsLoopingChangedHandler",
onIsWindingForwardChanged: "onIsWindingForwardChangedHandler",
onIsWindingBackwardChanged: "onIsWindingBackwardChangedHandler",
onRwdTapped: "onRwdTappedHandler",
onFwdTapped: "onFwdTappedHandler",
onMoreinfoTapped: "onMoreinfoTappedHandler",
onFullscreenTapped: "onFullscreenTappedHandler"
}, {
kind: "educate.components.video.player.Content",
name: "content",
label: this.label,
description: this.description,
open: this.showDescription
} ],
events: {
onPlay: "",
onPause: "",
onProgress: "",
onKeyframe: ""
},
handlers: {},
published: {
source: null,
moreinfo: !0,
timeline: !0,
playable: !0,
skipable: !0,
windable: !0,
loopable: !0,
fullscreenable: !1,
closeable: !1,
duration: 0,
currentTime: 0,
hasVideo: !1,
keyframes: {},
title: "",
label: "",
description: "",
visibleLabel: "",
visibleDescription: "",
showDescription: !1,
currentKeyframe: 0,
playbackRate: 1
},
create: function() {
this.inherited(arguments);
},
playableChanged: function(e) {
this.$.controls.setHasPlayable(this.getPlayable());
},
moreinfoChanged: function(e) {
this.$.controls.setHasMoreinfo(this.getMoreinfo());
},
timelineChanged: function(e) {
this.$.timeline.setShowing(this.getTimeline());
},
skipableChanged: function(e) {
this.$.controls.setHasSkipping(this.getSkipable());
},
windableChanged: function(e) {
this.$.controls.setHasWinding(this.getWindable());
},
loopableChanged: function(e) {
this.$.controls.setHasLooping(this.getLoopable());
},
fullscreenableChanged: function(e) {
this.$.controls.setHasFullscreen(this.getFullscreenable());
},
closeableChanged: function(e) {
this.$.video.setHasCloseButton(this.getCloseable());
},
durationChanged: function(e) {
this.$.timeline.setDuration(this.getDuration());
if (e !== 0) {
var t = this.getDuration();
this.setKeyframes({
0: {
label: "",
description: ""
},
duration: {
label: "",
description: ""
}
});
}
},
currentTimeChanged: function(e) {
if (isNaN(this.getCurrentTime())) return !1;
this.$.timeline.setCurrentTime(this.getCurrentTime()), this.$.video.setCurrentTime(this.getCurrentTime());
},
sourceChanged: function(e) {
this.$.video.setSource(this.getSource()), this.setHasVideo(this.getSource() !== null && this.getSource() !== "");
},
hasVideoChanged: function() {
this.$.video.setHasVideo(!0), this.$.timeline.setHasVideo(!0), this.$.controls.setHasVideo(!0);
},
keyframesChanged: function() {
this.$.timeline.keyframes = this.getKeyframes(), this.$.timeline.keyframesChanged();
},
titleChanged: function() {
this.$.video.setCurrentTitle(this.getTitle());
},
labelChanged: function() {
this.setVisibleLabel(this.getLabel());
},
descriptionChanged: function() {
this.setVisibleDescription(this.getDescription());
},
showDescriptionChanged: function() {
this.$.content.setOpen(this.getShowDescription());
},
visibleLabelChanged: function() {
this.$.content.setLabel(this.getVisibleLabel());
},
visibleDescriptionChanged: function() {
this.$.content.setDescription(this.getVisibleDescription());
},
playbackRateChanged: function() {
this.$.video.setPlaybackRate(this.getPlaybackRate());
},
onHasPlayableChangedHandler: function(e, t) {
this.setPlayable(this.$.controls.getHasPlayable());
},
onHasSkippingChangedHandler: function(e, t) {
this.setSkipable(this.$.controls.getHasSkipping());
},
onHasWindingChangedHandler: function(e, t) {
this.setWindable(this.$.controls.getHasWinding());
},
onHasLoopingChangedHandler: function(e, t) {
this.setLoopable(this.$.controls.getHasLooping());
},
onHasFullscreenChangedHandler: function(e, t) {
this.setFullscreenable(this.$.controls.getHasFullscreen());
},
onHasCloseableChangedHandler: function(e, t) {
this.$.video.setHasCloseButton(this.$.controls.getHasCloseButton());
},
onHasMoreinfoChangedHandler: function(e, t) {
this.setMoreinfo(this.$.controls.getHasMoreinfo());
},
onIsPlayingChangedHandler: function(e, t) {
this.$.video.setIsPlaying(this.$.controls.getIsPlaying());
},
onIsLoopingChangedHandler: function(e, t) {
this.$.video.setIsLooping(this.$.controls.getIsLooping());
},
onIsWindingForwardChangedHandler: function(e, t) {
this.$.video.setIsWindingForward(this.$.controls.getIsWindingForward());
},
onIsWindingBackwardChangedHandler: function(e, t) {
this.$.video.setIsWindingBackward(this.$.controls.getIsWindingBackward());
},
getPercentage: function() {
return this.getCurrentTime() / this.getDuration();
},
setPercentage: function(e) {
this.setCurrentTime(e * this.getDuration());
},
videoCurrentTimeChangedHandler: function(e, t) {
this.setCurrentTime(this.$[e.name].getCurrentTime());
},
videoIsKeyframeHandler: function(e, t) {
this.setCurrentKeyframe(t.time);
},
setCurrentKeyframe: function(e) {
var t = parseFloat(e), n = this.getCurrentKeyframe();
undefined === e && (t = 0);
if (isNaN(t)) throw new Error("The currentKeyframe has to be numerical.");
t !== n && (this.currentKeyframe = t, this.currentKeyframeChanged(n));
},
currentKeyframeChanged: function(e) {
!this.$.video.getIsLooping() && this.$.video.getIsPlaying() && (this.$.video.setIsPlaying(!1), this.setCurrentTime(this.getCurrentKeyframe()));
var t = this.getKeyframes()[this.getCurrentKeyframe()], n = this.getLabel(), r = this.getDescription();
undefined !== t && (n = t.label === "" ? n : t.label, r = t.description === "" ? r : t.description), this.setVisibleLabel(n), this.setVisibleDescription(r);
},
videoDurationChangedHandler: function(e, t) {
var n = this.$.video.getDuration();
if (isNaN(n)) return;
this.setDuration(n);
},
videoPlayHandler: function(e, t) {
switch (!0) {
case this.$.video.getPlaybackRate() === 1:
this.$.controls.setIsPlaying(!0);
break;
case this.$.video.getPlaybackRate() > 0:
this.$.controls.setIsWindingForward(!0);
break;
case this.$.video.getPlaybackRate() < 0:
this.$.controls.setIsWindingBackward(!0);
}
},
videoPauseHandler: function(e, t) {
this.$.controls.setIsPlaying(!1), this.$.controls.isPlayingChanged();
},
videoEndedHandler: function(e, t) {},
onFwdTappedHandler: function(e, t) {
this.skip();
},
onRwdTappedHandler: function(e, t) {
this.rewind();
},
onMoreinfoTappedHandler: function(e, t) {
this.parent.setShowDescription(this.$.controls.getShowDescription());
},
onFullscreenTappedHandler: function(e, t) {
var n = this.$.video.$.video.hasNode();
n && (!document.mozFullScreen && !document.webkitFullScreen ? n.mozRequestFullScreen ? n.mozRequestFullScreen() : n.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT) : document.mozCancelFullScreen ? document.mozCancelFullScreen() : document.webkitCancelFullScreen());
},
jumpTo: function(e) {
this.$.video.jumpTo(e), this.$.timeline.jumpTo(e);
},
play: function() {
this.$.video.play();
},
pause: function() {
this.$.video.pause();
},
skip: function() {
this.$.video.gotoAndStop(this.$.timeline.getNextKeyframe());
},
rewind: function() {
var e = this.$.timeline.getCurrentKeyframe();
e === this.getCurrentTime() && (e = this.$.timeline.getPreviousKeyframe());
if (this.getCurrentTime() === this.getDuration()) {
var t = Object.keys(this.getKeyframes());
e = t.length === 0 ? 0 : t[t.length - 1];
}
this.$.video.gotoAndStop(e);
}
});

// video.js

enyo.kind({
name: "educate.components.video.player.Video",
kind: enyo.Control,
classes: "video-wrapper",
published: {
source: null,
keyFrames: [],
isPlaying: !1,
isLooping: !1,
isWindingForward: !1,
isWindingBackward: !1,
hasVideo: !1,
hasTitle: !0,
hasCloseButton: !1,
currentTitle: "",
playbackRate: 1,
currentTime: 0
},
events: {
onCloseTapped: "",
onCurrentTimeChanged: "",
onDurationChanged: "",
onPlay: "",
onPause: "",
onEnded: ""
},
components: [ {
components: [ {
name: "title",
tag: "h1",
content: this.currentTitle,
showing: this.hasTitle && this.currentTitle !== "" || this.hasCloseButton
}, {
kind: enyo.Button,
name: "close",
ontap: "closeTapped",
classes: "close",
components: [ {
tag: "i",
classes: "fill-icon icon-delete-2"
} ],
showing: this.hasCloseButton
} ]
}, {
name: "video",
tag: "video"
}, {
name: "template",
tag: "img",
attributes: {
src: Settings.WEBAPP + "/images/videoTemplate.png"
}
}, {
name: "shield",
classes: "shield"
} ],
_intervalId: null,
_intervalTimeout: 30,
_noEvent: !1,
create: function() {
this.inherited(arguments), this.sourceChanged(), this.hasCloseButtonChanged(), this.hasTitleChanged();
},
rendered: function() {
this.inherited(arguments);
var e = this.$.video.hasNode(), t = this;
e && (e.onplaying = function() {
t.doPlay();
}, e.onpause = function() {
t.isPlaying = !1, t.doPause();
}, e.ontimeupdate = function() {
t._noEvent || (t.currentTime = e.currentTime, t.doCurrentTimeChanged()), t._noEvent = !1;
}, e.ondurationchange = function() {
t.doDurationChanged();
}, e.ended = function() {
t.doEnded();
});
},
sourceChanged: function() {
if (this.getSource() === null || this.getSource() === "") return;
var e = "";
this.$.video.destroyComponents(), this.$.video.setAttribute("preload", "preload");
if (this.getSource().id !== undefined) {
e = this.getSource().value, e = (e.indexOf("http://") === -1 ? Settings.WEBAPP : "") + "/" + e, this.$.video.createComponents([ {
tag: "source",
attributes: {
src: e + ".mp4"
}
}, {
tag: "source",
attributes: {
src: e + ".webm"
}
}, {
tag: "source",
attributes: {
src: e + ".ogv"
}
} ]);
if (this.getSource().answered === undefined || this.getSource().answered === null) return !1;
var t = this.getSource().answered.indexOf("http://") === -1 ? Settings.WEBAPP : "";
t += "/" + this.getSource().answered, this.$.video.setAttribute("poster", t);
} else {
var n = this.getSource().thumb[1280] || this.getSource().thumb[960] || this.getSource().thumb[640];
n.link !== undefined && this.$.video.setAttribute("poster", n.link), e = this.getSource().source.hd !== undefined ? this.getSource().source.hd.link : this.getSource().source.sd.link, this.$.video.setAttribute("src", e);
}
},
isPlayingChanged: function(e) {
this.getIsPlaying() ? this.play() : this.pause();
},
isWindingForwardChanged: function(e) {
this.getIsWindingForward() ? this.ffwd() : this.getIsPlaying() ? this.play() : this.pause();
},
isWindingBackwardChanged: function(e) {
this.getIsWindingBackward() ? this.frwd() : this.getIsPlaying() ? this.play() : this.pause();
},
isLoopingChanged: function(e) {
var t = this.$.video.hasNode();
t && (t.loop = this.getIsLooping());
},
closeTapped: function() {
this.doCloseTapped();
},
play: function() {
var e = this.$.video.hasNode();
e && (e.playbackRate = 1, e.play()), this.setIsPlaying(!0), this.setIsWindingForward(!1), this.setIsWindingBackward(!1), window.clearInterval(this._intervalId);
},
pause: function() {
var e = this.$.video.hasNode();
e && (e.playbackRate = 1, e.pause()), this.setIsPlaying(!1), this.setIsWindingForward(!1), this.setIsWindingBackward(!1), window.clearInterval(this._intervalId);
},
ffwd: function() {
var e = this.$.video.hasNode();
window.clearInterval(this._intervalId), e && (e.playbackRate = 3, e.play()), this.setIsWindingForward(!0), this.setIsWindingBackward(!1);
},
frwd: function() {
var e = this.$.video.hasNode(), t = this;
window.clearInterval(this._intervalId), e && (this._intervalId = window.setInterval(function() {
t.progress(-0.1);
}, this._intervalTimeout)), this.setIsWindingForward(!1), this.setIsWindingBackward(!0);
},
rewind: function() {
this.pause();
var e, t = this.getKeyFrames().length;
if (t === 0) {
this.setCurrentTime(0);
return;
}
for (e = t - 1; e >= 0; e--) this.getKeyFrames()[e].value >= this.getCurrentTime() && this.getKeyFrames()[e - 1].value < this.getCurrentTime() && (this.setCurrentTime(this.getKeyFrames()[e - 1].value), this.setcurrentTitle(this.getKeyFrames()[e - 1].label));
},
skip: function() {
this.pause();
var e, t = this.getKeyFrames().length;
if (t === 0) {
this.setCurrentTime(this.getDuration());
return;
}
for (e = 0; e < t; e++) e + 1 === t ? this.setCurrentTime(this.getDuration()) : this.getKeyFrames()[e].value <= this.getCurrentTime() && this.getKeyFrames()[e + 1].value > this.getCurrentTime() && (this.setCurrentTime(this.getKeyFrames()[e + 1].value), this.setcurrentTitle(this.getKeyFrames()[e + 1].label));
},
progress: function(e) {
var t = this.$.video.hasNode();
if (t) {
var n = t.duration, r = t.currentTime + e;
this.getIsLooping() ? r %= n : r >= n ? (r = n, t.pause()) : r <= 0 && (r = 0, t.pause()), this.setCurrentTime(r);
}
},
currentTimeChanged: function() {
var e = this.$.video.hasNode();
e && e.currentTime !== this.getCurrentTime() && (e.currentTime = this.getCurrentTime(), this.doCurrentTimeChanged());
},
getDuration: function() {
var e = this.$.video.hasNode();
return e ? e.duration : 0;
},
getPlaybackRate: function() {
var e = this.$.video.hasNode();
return e ? e.playbackRate : 0;
},
setPlaybackRate: function(e) {
var t = this.$.video.hasNode();
this.playbackRate = e, t && (t.playbackRate = this.playbackRate);
},
hasVideoChanged: function() {
this.$.template.setShowing(!this.getHasVideo());
},
hasTitleChanged: function() {
this.$.title.setShowing(this.getHasTitle() && this.getCurrentTitle() !== "" || this.hasCloseButton);
},
currentTitleChanged: function() {
this.$.title.setShowing(this.getHasTitle() && this.getCurrentTitle() !== "" || this.hasCloseButton), this.$.title.setContent(this.getCurrentTitle() !== "" ? this.getCurrentTitle() : " ");
},
hasCloseButtonChanged: function() {
this.$.close.setShowing(this.getHasCloseButton()), this.currentTitleChanged();
},
jumpTo: function(e) {
var t = this.$.video.hasNode();
return t ? (this._noEvent = !0, t.currentTime = e, t.currentTime) : !1;
},
gotoAndStop: function(e) {
this.setIsPlaying(!1), this.setCurrentTime(e);
},
gotoAndPlay: function(e) {
this.setIsPlaying(!0), this.setCurrentTime(e);
}
});

// Controls.js

enyo.kind({
name: "educate.components.video.player.Controls",
kind: enyo.Control,
classes: "controls controlable",
components: [ {
kind: enyo.Button,
name: "rwd",
ontap: "rwdTapped",
classes: "btn",
components: [ {
tag: "i",
classes: "icon-step-backward"
} ],
disabled: !0
}, {
kind: enyo.Button,
name: "frwd",
ontap: "frwdTapped",
classes: "btn",
components: [ {
tag: "i",
classes: "icon-backward"
} ],
disabled: !0
}, {
kind: enyo.Button,
name: "play",
ontap: "playTapped",
classes: "btn",
components: [ {
tag: "i",
name: "playIcon",
classes: "icon-play"
} ],
disabled: !0
}, {
kind: enyo.Button,
name: "ffwd",
ontap: "ffwdTapped",
classes: "btn",
components: [ {
tag: "i",
classes: "icon-forward"
} ],
disabled: !0
}, {
kind: enyo.Button,
name: "fwd",
ontap: "fwdTapped",
classes: "btn",
components: [ {
tag: "i",
classes: "icon-step-forward"
} ],
disabled: !0
}, {
tag: "span",
name: "spacer"
}, {
kind: enyo.Button,
name: "loop",
ontap: "loopTapped",
classes: "btn",
components: [ {
tag: "i",
classes: "icon-retweet"
} ],
disabled: !0
}, {
kind: enyo.Button,
name: "fullscreen",
ontap: "fullscreenTapped",
classes: "btn",
components: [ {
tag: "i",
classes: "icon-fullscreen"
} ],
disabled: !0
}, {
kind: enyo.Button,
name: "moreinfo",
ontap: "moreinfoTapped",
classes: "btn",
components: [ {
tag: "i",
classes: "icon-info"
} ],
disabled: !0
} ],
events: {
onHasPlayableChanged: "onHasPlayableChanged",
onHasSkippingChanged: "onHasSkippingChanged",
onHasWindingChanged: "onHasWindingChanged",
onHasLoopingChanged: "onHasLoopingChanged",
onHasFullscreenChanged: "onHasFullscreenChanged",
onHasMoreinfoChanged: "onHasMoreinfoChanged",
onIsPlayingChanged: "onIsPlayingChanged",
onIsLoopingChanged: "onIsLoopingChanged",
onIsWindingForwardChanged: "onIsWindingForwardChanged",
onIsWindingBackwardChanged: "onIsWindingBackwardChanged",
onRwdTapped: "onRwdTapped",
onFwdTapped: "onFwdTapped",
onMoreinfoTapped: "onMoreinfoTapped",
onFullscreenTapped: "onFullscreenTapped"
},
published: {
hasPlayable: !0,
hasSkipping: !0,
hasWinding: !0,
hasLooping: !0,
hasMoreinfo: !0,
hasFullscreen: !1,
hasVideo: !1,
isPlaying: !1,
isLooping: !1,
isWindingForward: !1,
isWindingBackward: !1,
showDescription: !1
},
create: function() {
this.inherited(arguments);
},
rwdTapped: function(e, t) {
this.doRwdTapped();
},
frwdTapped: function(e, t) {
this.setIsWindingBackward(!this.getIsWindingBackward()), this.setIsWindingForward(!1);
},
playTapped: function(e, t) {
this.setIsWindingBackward(!1), this.setIsPlaying(!this.getIsPlaying()), this.setIsWindingForward(!1);
},
pauseTapped: function(e, t) {
this.setIsWindingBackward(!1), this.setIsPlaying(!1), this.setIsWindingForward(!1);
},
ffwdTapped: function(e, t) {
this.setIsWindingBackward(!1), this.setIsWindingForward(!this.getIsWindingForward());
},
fwdTapped: function(e, t) {
this.doFwdTapped();
},
loopTapped: function(e, t) {
this.setIsLooping(!this.getIsLooping());
},
fullscreenTapped: function(e, t) {
this.doFullscreenTapped();
},
moreinfoTapped: function(e, t) {
this.setShowDescription(!this.getShowDescription());
},
hasPlayableChanged: function(e) {
this.$.play.setShowing(this.getHasPlayable()), this.doHasPlayableChanged();
},
hasSkippingChanged: function(e) {
this.$.fwd.setShowing(this.getHasSkipping()), this.$.rwd.setShowing(this.getHasSkipping()), this.doHasSkippingChanged();
},
hasWindingChanged: function(e) {
this.$.ffwd.setShowing(this.getHasWinding()), this.$.frwd.setShowing(this.getHasWinding()), this.doHasWindingChanged();
},
hasLoopingChanged: function(e) {
this.$.loop.setShowing(this.getHasLooping()), this.doHasLoopingChanged();
},
hasFullscreenChanged: function(e) {
this.$.fullscreen.setShowing(this.getHasFullscreen()), this.doHasFullscreenChanged();
},
hasMoreinfoChanged: function(e) {
this.$.moreinfo.setShowing(this.getHasMoreinfo()), this.doHasMoreinfoChanged();
},
showDescriptionChanged: function(e) {
this.$.moreinfo.addRemoveClass("active", this.getShowDescription()), this.doMoreinfoTapped();
},
isPlayingChanged: function(e) {
this.$.play.addRemoveClass("active", this.getIsPlaying()), this.$.playIcon.addRemoveClass("icon-play", !this.getIsPlaying()), this.$.playIcon.addRemoveClass("icon-pause", this.getIsPlaying()), this.getIsPlaying() || (this.setIsWindingForward(!1), this.setIsWindingBackward(!1)), this.doIsPlayingChanged();
},
isLoopingChanged: function(e) {
this.$.loop.addRemoveClass("active", this.getIsLooping()), this.doIsLoopingChanged();
},
isWindingForwardChanged: function(e) {
this.$.ffwd.addRemoveClass("active", this.getIsWindingForward()), this.getIsWindingForward() && this.setIsWindingBackward(!1), this.doIsWindingForwardChanged();
},
isWindingBackwardChanged: function(e) {
this.$.frwd.addRemoveClass("active", this.getIsWindingBackward()), this.getIsWindingBackward() && this.setIsWindingForward(!1), this.doIsWindingBackwardChanged();
},
hasVideoChanged: function() {
this.$.rwd.setDisabled(!this.getHasVideo()), this.$.frwd.setDisabled(!this.getHasVideo()), this.$.play.setDisabled(!this.getHasVideo()), this.$.ffwd.setDisabled(!this.getHasVideo()), this.$.fwd.setDisabled(!this.getHasVideo()), this.$.loop.setDisabled(!this.getHasVideo()), this.$.fullscreen.setDisabled(!this.getHasVideo()), this.$.moreinfo.setDisabled(!this.getHasVideo()), this.hasSkippingChanged(), this.hasWindingChanged(), this.hasPlayableChanged(), this.hasLoopingChanged(), this.hasFullscreenChanged(), this.hasMoreinfoChanged();
}
});

// Timeline.js

enyo.kind({
name: "educate.components.video.player.Timeline",
kind: enyo.Control,
classes: "timeline",
published: {
duration: 0,
currentTime: 0,
keyframes: {},
hasVideo: !1,
previousKeyframe: -1,
currentKeyframe: 0,
nextKeyframe: 0
},
components: [ {
name: "track",
classes: "track"
}, {
name: "thumb",
classes: "thumb"
}, {
name: "keyframes",
classes: "keyframes"
} ],
handlers: {
ondown: "ondownHandler"
},
events: {
onCurrentTimeChanged: "",
onIsKeyframe: ""
},
_isdragging: !1,
create: function() {
this.inherited(arguments);
},
draw: function() {
this.$.thumb.applyStyle("width", 100 * this.getPercentage() + "%"), this.render();
},
getPercentage: function() {
return this.getCurrentTime() / this.getDuration();
},
setPercentage: function(e) {
this.setCurrentTime(e * this.getDuration());
},
durationChanged: function(e) {
this.keyframesChanged();
},
currentTimeChanged: function(e) {
var t = this.getCurrentTime();
undefined !== e && t >= this.getNextKeyframe() && e > this.getCurrentKeyframe() && e < this.getNextKeyframe() ? this.setCurrentKeyframe(this.getNextKeyframe()) : (t >= this.getNextKeyframe() || t < this.getCurrentKeyframe()) && this.findKeyframes(), this.draw();
},
currentKeyframeChanged: function(e) {
var t = this.getCurrentKeyframe(), n = this.getKeyframes(), r = Object.keys(n).map(parseFloat), i = r.indexOf(t), s = n[t], o = undefined, u = undefined;
-1 === i && (i = this.getCurrentTime() > 0 ? r.length - 2 : 0), i = parseFloat(i) + 1, undefined === s && (s = {
label: "",
description: ""
}), o = r[i - 2], u = r[i], undefined === u && (u = this.getDuration()), undefined === o && (o = 0), undefined === t && (t = 0), this.setPreviousKeyframe(o), this.setNextKeyframe(u), this.doIsKeyframe({
time: t,
data: s
});
},
jumpTo: function(e) {
this.currentTime = e, this.draw();
},
ondownHandler: function(e, t) {
var n = this;
return this._isdragging = !0, document.addEventListener("mouseup", function(e) {
n.onupHandler(n, e), this.removeEventListener("mouseup", arguments.callee, !1), this.removeEventListener("mousemove", n.documentMoveHandler, !1);
}), document.addEventListener("mousemove", n.documentMoveHandler), !0;
},
documentMoveHandler: function(e) {
var t = e.target.id.trim(), n = t.search("player") + 6, r;
t = t.substr(0, n), r = enyo.$[t + "_timeline"], r !== undefined && r.onmoveHandler !== undefined && r.onmoveHandler(r, e);
},
onmoveHandler: function(e, t) {
return this._isdragging && this.positionToTime(t.layerX), !0;
},
onupHandler: function(e, t) {
return this._isdragging = !1, this.positionToTime(t.layerX), !0;
},
positionToTime: function(e) {
var t = this.hasNode() ? this.hasNode().offsetWidth : 1;
this.setPercentage(e / t), this.doCurrentTimeChanged();
},
keyframesChanged: function() {
var e = this.getKeyframes();
this.$.keyframes.destroyComponents();
for (var t in e) {
var n = e[t], r = 100 * (t / this.getDuration()), i = r.toFixed(2);
this.$.keyframes.createComponent({
name: "keyframe_" + t,
attributes: {
"data-label": n.label,
"data-description": n.description,
"data-time": t,
"data-percent": i,
"data-frame": t * 30 + .5 >> 0
},
style: "width:" + r + "%;",
classes: "keyframe"
});
}
this.findKeyframes(), this.draw();
},
findKeyframes: function(e) {
undefined === e && (e = !0);
var t, n, r, i = this.getKeyframes();
t = this.getCurrentTime(), n = Object.keys(i), n.indexOf(0) === -1 && n.push(0), n.indexOf(this.getDuration()) === -1 && n.push(this.getDuration()), n = orderNumericalArray(n), r = findPreviousIndex(t, n);
var s = parseFloat(n[r]), o = parseFloat(n[r + 1]);
undefined === s && (s = 0), undefined === o && (o = this.getDuration()), e ? (this.setCurrentKeyframe(s), this.setNextKeyframe(o)) : (this.currentKeyframe = s, this.nextKeyframe = o);
}
});

// Content.js

enyo.kind({
name: "educate.components.video.player.Content",
kind: enyo.Control,
published: {
label: "",
description: "",
open: !1
},
classes: "content",
components: [ {
name: "label",
content: this.label,
tag: "h1"
}, {
name: "description",
classes: "description",
content: this.description,
allowHtml: !0
} ],
create: function() {
this.inherited(arguments), this.descriptionChanged(), this.openChanged();
},
descriptionChanged: function() {
this.$.description.setContent(this.getDescription());
},
labelChanged: function() {
this.$.label.setContent(this.getLabel());
},
openChanged: function() {
this.addRemoveClass("open", this.getOpen());
},
open: function() {
this.setOpen(!0);
},
close: function() {
this.setOpen(!1);
},
toggle: function() {
this.setOpen(!this.getOpen());
},
updateTitleAndDescription: function(e, t) {
for (var n in t.arr) t.arr[n].time == t.time && (this.setTitle(t.arr[n].title), this.setDescription(t.arr[n].description));
}
});

// Cijferveld.js

enyo.kind({
name: "educate.components.input.Cijferveld",
kind: "educate.components.ObjectInterface",
classes: "cijferveld",
published: {
carrier: window.settings.CARRIERS.CIJFERVELD,
position_x: 600,
position_y: 400,
width: "auto",
height: "auto",
editable: !0,
sleepbaar: !1,
opmaak: !0,
round: 0,
random: !1,
css_class: !1,
talstelsel: 10,
teller: !1,
bgkleur: "",
hasValue1: !0,
value: "",
solution: "",
answered: "",
minimum1: "",
maximum1: "",
spinner1: !1,
hasValue2: !1,
value2: "",
solution2: "",
answered2: "",
minimum2: "",
maximum2: "",
spinner2: !1,
hasValue3: !1,
value3: "",
solution3: "",
answered3: "",
minimum3: "",
maximum3: "",
spinner3: !1
},
handlers: {
onPropertiesChanged: "onPropertiesChangedHandler",
ontap: "ontapHandler"
},
components: [ {
tag: "div",
name: "txtNumber",
classes: "inputNumber",
content: this.value,
showing: this.hasValue1,
ontap: "onTapHandlerWaarde",
ondown: "onDownHandlerWaarde"
}, {
tag: "div",
name: "txtNumber2",
classes: "inputNumber",
content: this.value2,
showing: this.hasValue2,
ontap: "onTapHandlerWaarde",
ondown: "onDownHandlerWaarde"
}, {
tag: "div",
name: "txtNumber3",
classes: "inputNumber",
content: this.value3,
showing: this.hasValue3,
ontap: "onTapHandlerWaarde",
ondown: "onDownHandlerWaarde"
}, {
tag: "span",
classes: "oplossing hidden",
name: "oplossing",
components: [ {
tag: "span",
name: "oplossing1",
classes: "last",
showing: !1,
content: this.solution
}, {
tag: "span",
name: "oplossing2",
showing: !1,
content: this.solution2
}, {
tag: "span",
name: "oplossing3",
showing: !1,
content: this.solution3
} ]
}, {
kind: "Signals",
onSolution: "onSolutionHandler"
} ],
create: function() {
this.inherited(arguments), this.addLinkEigenschappenOptions(), this.answeredChanged(), this.optionsChanged(), this.valueChanged(), this.handleSleepbaar(), this.handleOpmaak(), this.redraw(), this.hasValue1Changed(), this.hasValue2Changed(), this.hasValue3Changed(), this.randomChanged();
},
rendered: function() {
this.inherited(arguments), this.calculatedFontSizeChanged();
},
initEventsReactiesOptions: function() {
this.inherited(arguments), this.getReactieOptions().TOON_OPLOSSING = {
label: "toon oplossing",
action: "toonOplossing"
}, this.getReactieOptions().VERBERG_OPLOSSING = {
label: "verberg oplossing",
action: "verbergOplossing"
}, this.getReactieOptions().WISSEL_OPLOSSING = {
label: "wissel oplossing",
action: "toggleOplossing"
}, this.getReactieOptions().CONTROLEER_OPLOSSING = {
label: "controleer oplossing",
action: "controleerOplossing"
};
},
addLinkEigenschappenOptions: function() {
this.getLinkEigenschappenOptions().waarde1 = "value", this.getLinkEigenschappenOptions().waarde2 = "value2", this.getLinkEigenschappenOptions().waarde3 = "value3";
},
optionsChanged: function() {
this.optionsInladen();
},
optionsInladen: function() {
this.setEditable(this.options.editable != undefined ? this.options.editable === !0 : !0), this.setSleepbaar(this.options.sleepbaar != undefined ? this.options.sleepbaar === !0 : !1), this.setOpmaak(this.options.opmaak != undefined ? this.options.opmaak === !0 : !0), this.setMinimum1(this.options.value_min != undefined ? this.options.value_min : ""), this.setMaximum1(this.options.value_max != undefined ? this.options.value_max : ""), this.setSpinner1(this.options.spinner1 != undefined ? this.options.spinner1 === !0 : !1), this.setHasValue1(this.options.hasValue1 != undefined ? this.options.hasValue1 === !0 : !1), this.setMinimum2(this.options.value2_min != undefined ? this.options.value2_min : ""), this.setMaximum2(this.options.value2_max != undefined ? this.options.value2_max : ""), this.setValue2(this.options.value2 != undefined ? this.options.value2 : ""), this.setSolution2(this.options.solution2 != undefined ? this.options.solution2 : ""), this.setAnswered2(this.options.answered2 != undefined ? this.options.answered2 : ""), this.setSpinner2(this.options.spinner2 != undefined ? this.options.spinner2 === !0 : !1), this.setHasValue2(this.options.hasValue2 != undefined ? this.options.hasValue2 === !0 : !1), this.setMinimum3(this.options.value3_min != undefined ? this.options.value3_min : ""), this.setMaximum3(this.options.value3_max != undefined ? this.options.value3_max : ""), this.setValue3(this.options.value3 != undefined ? this.options.value3 : ""), this.setSolution3(this.options.solution3 != undefined ? this.options.solution3 : ""), this.setAnswered3(this.options.answered3 != undefined ? this.options.answered3 : ""), this.setSpinner3(this.options.spinner3 != undefined ? this.options.spinner3 === !0 : !1), this.setHasValue3(this.options.hasValue3 != undefined ? this.options.hasValue3 === !0 : !1), this.setRound(this.options.afronding != undefined ? this.options.afronding : this.round), this.setRandom(this.options.random != undefined ? this.options.random : this.random), this.setTalstelsel(this.options.talstelsel != undefined ? this.options.talstelsel : ""), this.setTeller(this.options.teller != undefined ? this.options.teller === !0 : !1), this.setBgkleur(this.options.bgkleur != undefined ? this.options.bgkleur : "");
},
replacePointByComma: function(e) {
e.setContent(e.getContent().replace(".", ","));
},
valueChanged: function(e) {
this.inherited(arguments);
var t = parseFloat(this.getValue());
return isNaN(t) ? (this.$.txtNumber.setContent("???"), !0) : (t = this.checkLimiet(t, this.getMinimum1(), this.getMaximum1()), this.$.txtNumber.setContent(t.toFixed(this.getRound())), this.replacePointByComma(this.$.txtNumber), !0);
},
value2Changed: function(e) {
this.inherited(arguments);
var t = parseFloat(this.getValue2());
return isNaN(t) ? (this.$.txtNumber2.setContent("???"), !0) : (t = this.checkLimiet(t, this.getMinimum2(), this.getMaximum2()), this.$.txtNumber2.setContent(t.toFixed(this.getRound())), this.replacePointByComma(this.$.txtNumber2), !0);
},
value3Changed: function(e) {
this.inherited(arguments);
var t = parseFloat(this.getValue3());
return isNaN(t) ? (this.$.txtNumber3.setContent("???"), !0) : (t = this.checkLimiet(t, this.getMinimum3(), this.getMaximum3()), this.$.txtNumber3.setContent(t.toFixed(this.getRound())), this.replacePointByComma(this.$.txtNumber3), !0);
},
hasSolutions: function() {
return this.getSolution() !== "" || this.getSolution2() !== "" && this.getHasValue2() || this.getSolution3() !== "" && this.getHasValue3();
},
checkLimiet: function(e, t, n) {
return e = parseFloat(e), t && e < t ? t : n && e > n ? n : e;
},
answeredChanged: function() {
this.inherited(arguments), this.$.txtNumber.setAttribute("data-unit", "" + this.getAnswered()), this.updateSolutionContent();
},
answered2Changed: function() {
this.inherited(arguments), this.$.txtNumber2.setAttribute("data-unit", "" + this.getAnswered2()), this.updateSolution2Content();
},
answered3Changed: function() {
this.inherited(arguments), this.$.txtNumber3.setAttribute("data-unit", "" + this.getAnswered3()), this.updateSolution3Content();
},
solutionChanged: function() {
this.inherited(arguments), this.$.oplossing.setShowing(this.getSolution() !== "" || this.getSolution2() !== "" || this.getSolution3() !== ""), this.$.oplossing1.setShowing(this.getSolution() !== ""), this.updateSolutionContent();
},
updateSolutionContent: function() {
var e = parseFloat(this.getSolution()), t = e.toFixed(this.getRound()), n = this.getAnswered() ? this.getAnswered() : "";
if (isNaN(e)) return this.$.oplossing1.setContent(""), !1;
n !== "" && (t += " " + n), this.$.oplossing1.setContent(t), this.replacePointByComma(this.$.oplossing1);
},
solution2Changed: function() {
this.inherited(arguments), this.$.oplossing.setShowing(this.getSolution() !== "" || this.getSolution2() !== "" || this.getSolution3() !== ""), this.$.oplossing2.setShowing(this.getSolution2() !== ""), this.$.oplossing1.addRemoveClass("last", this.getSolution2() === ""), this.updateSolution2Content();
},
updateSolution2Content: function() {
var e = parseFloat(this.getSolution2()), t = e.toFixed(this.getRound()), n = this.getAnswered2() ? this.getAnswered2() : "";
if (isNaN(e)) return this.$.oplossing2.setContent(""), !1;
n !== "" && (t += " " + n), this.$.oplossing2.setContent(t), this.replacePointByComma(this.$.oplossing2);
},
solution3Changed: function() {
this.inherited(arguments), this.$.oplossing.setShowing(this.getSolution() !== "" || this.getSolution2() !== "" || this.getSolution3() !== ""), this.$.oplossing3.setShowing(this.getSolution3() !== ""), this.$.oplossing2.addRemoveClass("last", this.getSolution3() === ""), this.updateSolution3Content();
},
updateSolution3Content: function() {
var e = parseFloat(this.getSolution3()), t = e.toFixed(this.getRound()), n = this.getAnswered3() ? this.getAnswered3() : "";
if (isNaN(e)) return this.$.oplossing3.setContent(""), !1;
n !== "" && (t += " " + n), this.$.oplossing3.setContent(t), this.replacePointByComma(this.$.oplossing3);
},
selectObject: function() {
this.inherited(arguments), this.getShowing() && this.toonOplossing();
},
deselectObject: function() {
this.inherited(arguments), this.verbergOplossing();
},
toonOplossing: function() {
this.getSolution() && this.$.oplossing.removeClass("hidden");
},
verbergOplossing: function() {
this.$.oplossing.addClass("hidden");
},
toggleOplossing: function() {
this.getSolution() !== "" || this.getSolution2() !== "" || this.getSolution3() !== "" ? this.$.oplossing.addRemoveClass("hidden", !this.$.oplossing.hasClass("hidden")) : this.$.oplossing.addClass("hidden");
},
editableChanged: function() {
this.handleBackground();
},
setRound: function(e) {
if (this.round === e) return !0;
var t = this.round;
this.round = e, this.roundChanged(t);
},
getRound: function() {
return this.round;
},
roundChanged: function(e) {
this.round = parseInt(this.getRound()), this.options.afronding = this.getRound(), this.getHasValue1() && this.valueChanged(), this.getHasValue2() && this.value2Changed(), this.getHasValue3() && this.value3Changed(), this.getSolution() !== "" && this.solutionChanged(), this.getSolution2() !== "" && this.solution2Changed(), this.getSolution3() !== "" && this.solution3Changed();
},
minimum1Changed: function() {
this.getHasValue1() && this.setValue(this.checkLimiet(this.getValue(), this.getMinimum1(), this.getMaximum1()));
},
maximum1Changed: function() {
this.getHasValue1() && this.setValue(this.checkLimiet(this.getValue(), this.getMinimum1(), this.getMaximum1()));
},
minimum2Changed: function() {
this.getHasValue2() && this.setValue2(this.checkLimiet(this.getValue2(), this.getMinimum2(), this.getMaximum2()));
},
maximum2Changed: function() {
this.getHasValue2() && this.setValue2(this.checkLimiet(this.getValue2(), this.getMinimum2(), this.getMaximum2()));
},
minimum3Changed: function() {
this.getHasValue3() && this.setValue3(this.checkLimiet(this.getValue3(), this.getMinimum3(), this.getMaximum3()));
},
maximum3Changed: function() {
this.getHasValue3() && this.setValue3(this.checkLimiet(this.getValue3(), this.getMinimum3(), this.getMaximum3()));
},
bgkleurChanged: function() {
this.handleOpmaak();
},
opmaakChanged: function() {
this.handleOpmaak();
},
handleOpmaak: function() {
this.handleBackground();
},
sleepbaarChanged: function() {
this.handleSleepbaar();
},
handleSleepbaar: function() {
this.addRemoveClass("sleepbaar", this.getSleepbaar());
},
handleBackground: function() {
this.addRemoveClass("nostyle", !this.getOpmaak()), this.addRemoveClass("readonly", !this.getEditable()), this.getOpmaak() && this.getBgkleur() ? this.applyStyle("background", this.getBgkleur()) : this.applyStyle("background", null);
},
talstelselChanged: function() {
this.handleTalstelsel();
},
handleTalstelsel: function(e) {
var t;
e == 2 ? (t = this.berekenStelsel(this.getValue2()), this.setValue2(t.val1), this.setValue(this.getValue() + t.val2)) : e == 3 ? (t = this.berekenStelsel(this.getValue3()), this.setValue3(t.val1), this.setValue2(this.getValue2() + t.val2)) : (this.getValue2() && (t = this.berekenStelsel(this.getValue2()), this.setValue2(t.val1), this.setValue(this.getValue() + t.val2)), this.getValue3() && (t = this.berekenStelsel(this.getValue3()), this.setValue3(t.val1), this.setValue2(this.getValue2() + t.val2)));
},
berekenStelsel: function(e) {
var t = {}, n = parseInt(this.getTalstelsel());
return t.val1 = e % n, t.val2 = (e - t.val1) / n, t;
},
onPropertiesChangedHandler: function(e, t) {
t.linked == this && (this.layername = t.linked.layername, this.resizeComponent());
},
resizeComponent: function() {
this.redraw();
},
calculatedFontSizeChanged: function() {
this.applyStyle("font-size", this.calculatedFontSize + "rem");
},
redraw: function() {
!isNaN(parseInt(this.getWidth())) && this.getWidth() != -1 ? this.calculatedWidth = parseInt(this.getWidth() * window.settings.SCALE) : this.calculatedWidth = "auto", !isNaN(parseInt(this.getHeight())) && this.getHeight() != -1 ? this.calculatedHeight = parseInt(this.getHeight() * window.settings.SCALE) : this.calculatedHeight = "auto", this.calculatedPosX = this.getPosition_x() * window.settings.SCALE + .5 >> 0, this.calculatedPosY = this.getPosition_y() * window.settings.SCALE + .5 >> 0, this.calculatedFontSize = this.getFontSize() * window.settings.SCALE, this.render();
},
hasValue1Changed: function() {
this.hasValue1 || this.setHasValue1(!0), this.options.hasValue1 = !0;
},
hasValue2Changed: function() {
this.$.txtNumber2.setShowing(this.hasValue2), this.$.oplossing2.setShowing(this.hasValue2), this.value2Changed(), this.options.hasValue2 = this.hasValue2;
},
hasValue3Changed: function() {
this.$.txtNumber3.setShowing(this.hasValue3), this.$.oplossing3.setShowing(this.hasValue3), this.value3Changed(), this.options.hasValue3 = this.hasValue3;
},
onSolutionHandler: function() {
return !0;
},
randomChanged: function() {
this.options.random = this.getRandom();
if (this.getRandom()) {
var e, t = isNaN(parseFloat(this.getMinimum1())) ? 0 : parseFloat(this.getMinimum1()), n = isNaN(parseFloat(this.getMinimum2())) ? 0 : parseFloat(this.getMinimum2()), r = isNaN(parseFloat(this.getMinimum3())) ? 0 : parseFloat(this.getMinimum3()), i = isNaN(parseFloat(this.getMaximum1())) ? 1 : parseFloat(this.getMaximum1()), s = isNaN(parseFloat(this.getMaximum2())) ? 1 : parseFloat(this.getMaximum2()), o = isNaN(parseFloat(this.getMaximum3())) ? 1 : parseFloat(this.getMaximum3());
e = t + Math.random() * (i - t), this.setValue(e), this.getHasValue2() && (e = n + Math.random() * (s - n), this.setValue2(e)), this.getHasValue3() && (e = r + Math.random() * (o - r), this.setValue3(e));
}
}
});

// InputField.js

enyo.kind({
name: "educate.components.input.InputField",
kind: "educate.components.ObjectInterface",
tag: "div",
classes: "inputFieldCon",
published: {
carrier: window.settings.CARRIERS.INPUTFIELD,
maxCharacters: 100
},
components: [ {
kind: "enyo.TextArea",
name: "inputField",
value: this.value,
onblur: "onblurHandler",
classes: "inputField"
} ],
create: function() {
this.inherited(arguments);
},
rendered: function() {
this.inherited(arguments), this.valueChanged(), this.calculatedFontSizeChanged(), this.maxCharactersChanged();
},
optionsChanged: function() {
this.setMaxCharacters(this.options.maxCharacters != undefined ? this.options.maxCharacters : this.getMaxCharacters());
},
calculatedFontSizeChanged: function() {
this.$.inputField.applyStyle("font-size", this.calculatedFontSize + "rem");
},
maxCharactersChanged: function() {
this.$.inputField.setAttribute("maxlength", this.getMaxCharacters());
},
redrawInputField: function() {
this.calculatedWidth = parseInt(this.getWidth() * window.settings.SCALE), this.calculatedHeight = parseInt(this.getHeight() * window.settings.SCALE), this.calculatedPosX = this.getPosition_x() * window.settings.SCALE + .5 >> 0, this.calculatedPosY = this.getPosition_y() * window.settings.SCALE + .5 >> 0, this.calculatedFontSize = this.getFontSize() * window.settings.SCALE, this.render();
},
resizeComponent: function() {
this.redrawInputField();
}
});

// lijnstuk.js

enyo.kind({
name: "educate.components.input.Lijnstuk",
kind: "educate.components.ObjectInterface",
classes: "lijnstuk",
tag: "canvas",
statics: {
NONE: 0,
LINE: 1,
SQUARE: 2,
CIRCLE: 3,
ARROW_LTR: 4,
ARROW_RTL: 5,
ARROW_OUT: 6,
ARROW_IN: 7
},
published: {
carrier: window.settings.CARRIERS.LIJNSTUK,
position_x: 0,
position_y: 0,
width: 0,
height: 0,
value: null,
rotation: null,
css_class: 0,
options: {
style: "solid",
color: "#000000",
weight: 1,
visible: !0,
dragable: !0,
start_point_dragable: !0,
end_point_dragable: !0
},
drag_position: "center",
padding: 10,
lastChange: "coords"
},
create: function() {
this.inherited(arguments), this.render();
},
initLinkEigenschappenOptions: function() {
this.setLinkEigenschappenOptions({
beginpuntx: "position_x",
beginpunty: "position_y",
eindpuntx: "width",
eindpunty: "height",
rot: "rotation",
lengte: "value"
});
},
resizeComponent: function() {
this.draw();
},
rendered: function() {
arguments.callee._inherited._inherited.apply(this, arguments), this.width !== 0 && this.height !== 0 ? this.coordsChanged() : this.value !== null && (this.rotation = this.rotation !== null ? this.rotation : 0, this.to = {}, this.valueChanged());
},
draw: function() {
if (this.getContext()) {
var e = {
position_x: this.position_x,
position_y: this.position_y,
width: this.width,
height: this.height,
value: this.value,
rotation: this.rotation
};
this.padding = 5 + 2.5 * parseFloat(this.getOptions().weight), this.doRandom("position_x"), this.doRandom("position_y"), this.doRandom("width"), this.doRandom("height"), this.doRandom("value"), this.doRandom("rotation");
var t = parseFloat(this.value * Math.cos(this.rotation * (Math.PI / 180))), n = parseFloat(this.value * Math.sin(this.rotation * (Math.PI / 180))), r = parseFloat(t > 0 && n > 0 ? this.position_x : this.position_x + t), i = parseFloat(t > 0 && n > 0 ? this.position_y : this.position_y + n), s = parseFloat(t > 0 && n > 0 ? this.position_x + t : this.position_x), o = parseFloat(t > 0 && n > 0 ? this.position_y + n : this.position_y), u = {
x: parseFloat(r < s ? r : s),
y: parseFloat(i < o ? i : o),
w: parseFloat(t > 0 ? t : -t),
h: parseFloat(n > 0 ? n : -n)
};
this.applyStyle("left", window.settings.SCALE * (u.x - this.padding) + "px"), this.applyStyle("top", window.settings.SCALE * (u.y - this.padding) + "px"), this.applyStyle("width", null), this.applyStyle("height", null), this.setAttribute("width", window.settings.SCALE * (u.w + this.padding + this.padding) + "px"), this.setAttribute("height", window.settings.SCALE * (u.h + this.padding + this.padding) + "px"), this.getContext().fillStyle = this.getOptions().color, this.getContext().strokeStyle = this.getOptions().color, this.getContext().lineWidth = this.getOptions().weight, this.getOptions().style === "dashed" ? this.getContext().setLineDash([ this.getOptions().weight * 5, this.getOptions().weight * 3 ]) : this.getOptions().style === "dotted" && this.getContext().setLineDash([ this.getOptions().weight ]), this.getContext().beginPath(), this.getContext().moveTo(window.settings.SCALE * (r - u.x + this.padding), window.settings.SCALE * (i - u.y + this.padding)), this.getContext().lineTo(window.settings.SCALE * (s - u.x + this.padding), window.settings.SCALE * (o - u.y + this.padding)), this.getContext().stroke(), this.getContext().closePath(), this.drawEndPoints(), this.bubble("updateProperties", this), this.widthChangedHandler && this.widthChangedHandler(), this.heightChangedHandler && this.heightChangedHandler(), this.position_xChangedHandler && this.position_xChangedHandler(), this.position_yChangedHandler && this.position_yChangedHandler(), this.valueChangedHandler && this.valueChangedHandler(), this.rotationChangedHandler && this.rotationChangedHandler();
}
},
drawEndPoints: function() {
var e = this.value * Math.cos(this.rotation * (Math.PI / 180)), t = this.value * Math.sin(this.rotation * (Math.PI / 180)), n = this.position_x, r = this.position_y, i = this.position_x + e, s = this.position_y + t, o = {
x: n < i ? n : i,
y: r < s ? r : s,
w: e > 0 ? e : -e,
h: t > 0 ? t : -t
};
this.getContext().setLineDash([ 0 ]), this.getCss_class() === educate.components.input.Lijnstuk.LINE ? (this.getContext().save(), this.getContext().translate(window.settings.SCALE * (n - o.x + this.padding), window.settings.SCALE * (r - o.y + this.padding)), this.getContext().rotate(Math.PI * this.getRotation() / 180), this.getContext().beginPath(), this.getContext().moveTo(0, 2.5 * this.getOptions().weight), this.getContext().lineTo(0, -2.5 * this.getOptions().weight), this.getContext().stroke(), this.getContext().closePath(), this.getContext().restore(), this.getContext().save(), this.getContext().translate(window.settings.SCALE * (i - o.x + this.padding), window.settings.SCALE * (s - o.y + this.padding)), this.getContext().rotate(Math.PI * this.getRotation() / 180), this.getContext().beginPath(), this.getContext().moveTo(0, 2.5 * this.getOptions().weight), this.getContext().lineTo(0, -2.5 * this.getOptions().weight), this.getContext().stroke(), this.getContext().closePath(), this.getContext().restore()) : this.getCss_class() === educate.components.input.Lijnstuk.SQUARE ? (this.getContext().save(), this.getContext().translate(window.settings.SCALE * (n - o.x + this.padding), window.settings.SCALE * (r - o.y + this.padding)), this.getContext().rotate(Math.PI * this.getRotation() / 180), this.getContext().beginPath(), this.getContext().fillRect(-5 * this.getOptions().weight, -2.5 * this.getOptions().weight, 5 * this.getOptions().weight, 5 * this.getOptions().weight), this.getContext().fill(), this.getContext().closePath(), this.getContext().restore(), this.getContext().save(), this.getContext().translate(window.settings.SCALE * (i - o.x + this.padding), window.settings.SCALE * (s - o.y + this.padding)), this.getContext().rotate(Math.PI * this.getRotation() / 180), this.getContext().beginPath(), this.getContext().fillRect(0, -2.5 * this.getOptions().weight, 5 * this.getOptions().weight, 5 * this.getOptions().weight), this.getContext().fill(), this.getContext().closePath(), this.getContext().restore()) : this.getCss_class() === educate.components.input.Lijnstuk.CIRCLE ? (this.getContext().save(), this.getContext().translate(window.settings.SCALE * (n - o.x + this.padding), window.settings.SCALE * (r - o.y + this.padding)), this.getContext().rotate(Math.PI * this.getRotation() / 180), this.getContext().beginPath(), this.getContext().arc(-2 * this.getOptions().weight, 0, 3 * this.getOptions().weight, 0, Math.PI * 2, !0), this.getContext().fill(), this.getContext().closePath(), this.getContext().restore(), this.getContext().save(), this.getContext().translate(window.settings.SCALE * (i - o.x + this.padding), window.settings.SCALE * (s - o.y + this.padding)), this.getContext().rotate(Math.PI * this.getRotation() / 180), this.getContext().beginPath(), this.getContext().arc(2 * this.getOptions().weight, 0, 3 * this.getOptions().weight, 0, Math.PI * 2, !0), this.getContext().fill(), this.getContext().closePath(), this.getContext().restore()) : this.getCss_class() === educate.components.input.Lijnstuk.ARROW_OUT ? (this.getContext().save(), this.getContext().translate(window.settings.SCALE * (n - o.x + this.padding), window.settings.SCALE * (r - o.y + this.padding)), this.getContext().rotate(Math.PI * this.getRotation() / 180), this.getContext().beginPath(), this.getContext().moveTo(2.5 * this.getOptions().weight, 2.5 * this.getOptions().weight), this.getContext().lineTo(0, 0), this.getContext().lineTo(2.5 * this.getOptions().weight, -2.5 * this.getOptions().weight), this.getContext().closePath(), this.getContext().stroke(), this.getContext().fill(), this.getContext().restore(), this.getContext().save(), this.getContext().translate(window.settings.SCALE * (i - o.x + this.padding), window.settings.SCALE * (s - o.y + this.padding)), this.getContext().rotate(Math.PI * this.getRotation() / 180), this.getContext().beginPath(), this.getContext().moveTo(-2.5 * this.getOptions().weight, 2.5 * this.getOptions().weight), this.getContext().lineTo(0, 0), this.getContext().lineTo(-2.5 * this.getOptions().weight, -2.5 * this.getOptions().weight), this.getContext().closePath(), this.getContext().stroke(), this.getContext().fill(), this.getContext().restore()) : this.getCss_class() === educate.components.input.Lijnstuk.ARROW_IN ? (this.getContext().save(), this.getContext().translate(window.settings.SCALE * (n - o.x + this.padding), window.settings.SCALE * (r - o.y + this.padding)), this.getContext().rotate(Math.PI * this.getRotation() / 180), this.getContext().beginPath(), this.getContext().moveTo(-2.5 * this.getOptions().weight, 2.5 * this.getOptions().weight), this.getContext().lineTo(0, 0), this.getContext().lineTo(-2.5 * this.getOptions().weight, -2.5 * this.getOptions().weight), this.getContext().closePath(), this.getContext().stroke(), this.getContext().fill(), this.getContext().restore(), this.getContext().save(), this.getContext().translate(window.settings.SCALE * (i - o.x + this.padding), window.settings.SCALE * (s - o.y + this.padding)), this.getContext().rotate(Math.PI * this.getRotation() / 180), this.getContext().beginPath(), this.getContext().moveTo(2.5 * this.getOptions().weight, 2.5 * this.getOptions().weight), this.getContext().lineTo(0, 0), this.getContext().lineTo(2.5 * this.getOptions().weight, -2.5 * this.getOptions().weight), this.getContext().closePath(), this.getContext().stroke(), this.getContext().fill(), this.getContext().restore()) : this.getCss_class() === educate.components.input.Lijnstuk.ARROW_LTR ? (this.getContext().save(), this.getContext().translate(window.settings.SCALE * (i - o.x + this.padding), window.settings.SCALE * (s - o.y + this.padding)), this.getContext().rotate(Math.PI * this.getRotation() / 180), this.getContext().beginPath(), this.getContext().moveTo(-2.5 * this.getOptions().weight, 2.5 * this.getOptions().weight), this.getContext().lineTo(0, 0), this.getContext().lineTo(-2.5 * this.getOptions().weight, -2.5 * this.getOptions().weight), this.getContext().closePath(), this.getContext().stroke(), this.getContext().fill(), this.getContext().restore()) : this.getCss_class() === educate.components.input.Lijnstuk.ARROW_RTL && (this.getContext().save(), this.getContext().translate(window.settings.SCALE * (n - o.x + this.padding), window.settings.SCALE * (r - o.y + this.padding)), this.getContext().rotate(Math.PI * this.getRotation() / 180), this.getContext().beginPath(), this.getContext().moveTo(2.5 * this.getOptions().weight, 2.5 * this.getOptions().weight), this.getContext().lineTo(0, 0), this.getContext().lineTo(2.5 * this.getOptions().weight, -2.5 * this.getOptions().weight), this.getContext().stroke(), this.getContext().closePath(), this.getContext().fill(), this.getContext().restore());
},
getContext: function() {
var e = !1;
return this.hasNode() && this.hasNode().getContext("2d") && (e = this.hasNode().getContext("2d")), e;
},
position_xChanged: function() {
this.inherited(arguments), this.lastChange == "coords" ? this.coordsChanged() : this.rotValChanged();
},
position_yChanged: function() {
this.inherited(arguments), this.lastChange == "coords" ? this.coordsChanged() : this.rotValChanged();
},
widthChanged: function() {
this.inherited(arguments), this.coordsChanged(), this.lastChange = "coords";
},
heightChanged: function() {
this.inherited(arguments), this.coordsChanged(), this.lastChange = "coords";
},
coordsChanged: function() {
this.checkValues();
var e = this.width - this.position_x, t = this.height - this.position_y;
this.value = Math.sqrt(e * e + t * t), e >= 0 ? this.rotation = Math.atan(t / e) / (Math.PI / 180) : this.rotation = 180 + Math.atan(t / e) / (Math.PI / 180), this.draw();
},
valueChanged: function() {
this.inherited(arguments), this.rotValChanged(), this.lastChange = "rot", this.valueChangedHandler && this.valueChangedHandler();
},
rotationChanged: function() {
this.rotValChanged(), this.lastChange = "rot", this.bubble("onRotationChanged");
},
rotValChanged: function() {
this.checkValues();
var e = parseFloat(this.value * Math.cos(this.rotation * (Math.PI / 180))), t = parseFloat(this.value * Math.sin(this.rotation * (Math.PI / 180)));
this.width = parseFloat(this.position_x + e), this.height = parseFloat(this.position_y + t), this.draw();
},
checkValues: function() {
this.position_x = parseFloat(this.position_x), this.position_y = parseFloat(this.position_y), this.width = parseFloat(this.width), this.height = parseFloat(this.height), this.value = parseFloat(this.value), this.rotation = parseFloat(this.rotation);
},
css_classChanged: function() {
this.inherited(arguments), this.draw();
},
downHandler: function(e, t) {
this.inherited(arguments);
var n = $(this.getView().$.stage.hasNode()).offset(), r, i;
t.type === "touchmove" ? (r = t.touches[0].clientX, i = t.touches[0].clientY) : (r = t.clientX, i = t.clientY);
var s = (r - n.left) / window.settings.SCALE + .5 >> 0, o = (i - n.top) / window.settings.SCALE + .5 >> 0;
this.setClickX(s - this.position_x), this.setClickY(o - this.position_y), s - this.getPosition_x() >= -this.padding && s - this.getPosition_x() <= this.padding && o - this.getPosition_y() >= -this.padding && o - this.getPosition_y() <= this.padding ? (this.drag_position = "begin", this.lastChange = "coords") : s - this.getWidth() >= -this.padding && s - this.getWidth() <= this.padding && o - this.getHeight() >= -this.padding && o - this.getHeight() <= this.padding ? (this.drag_position = "end", this.lastChange = "coords") : (this.drag_position = "normal", this.lastChange = "rot");
},
dragObjectHandler: function(e) {
this.inherited(arguments);
var t = $(this.getView().$.stage.hasNode()).offset(), n = (e.touches[0].clientX - t.left) / window.settings.SCALE + .5 >> 0, r = (e.touches[0].clientY - t.top) / window.settings.SCALE + .5 >> 0;
this.drag_position === "begin" ? (this.position_x = n, this.position_y = r, this.coordsChanged()) : this.drag_position === "end" ? (this.width = n, this.height = r, this.coordsChanged()) : (this.position_x = n - this.getClickX(), this.position_y = r - this.getClickY(), this.rotValChanged());
},
upHandler: function() {
$(document).off("mousemove"), $(document).off("mouseup"), document.ontouchmove = null, document.ontouchend = null, this.bubble("updateProperties", this);
},
calculatedPosXChanged: function() {},
calculatedPosYChanged: function() {},
calculatedPosZChanged: function() {},
calculatedWidthChanged: function() {},
calculatedHeightChanged: function() {},
originChanged: function() {}
});

// Raster.js

enyo.kind({
name: "educate.components.raster.Raster",
kind: "educate.components.ObjectInterface",
tag: "div",
classes: "raster",
published: {},
handlers: {},
components: [],
rendered: function() {
this.inherited(arguments);
},
resizeComponent: function() {
this.redrawRaster();
},
redrawRaster: function() {
this.calculatedWidth = parseInt(this.getWidth() * window.settings.SCALE), this.calculatedHeight = parseInt(this.getHeight() * window.settings.SCALE), this.calculatedPosX = this.getPosition_x() * window.settings.SCALE + .5 >> 0, this.calculatedPosY = this.getPosition_y() * window.settings.SCALE + .5 >> 0, this.render();
}
});

// Square.js

enyo.kind({
name: "educate.components.tekendoos.Square",
kind: "educate.components.ObjectInterface",
published: {
carrier: window.settings.CARRIERS.SQUARE,
linked: ""
},
attributes: {
xmlns: "http://www.w3.org/2000/svg",
version: "1.1",
viewbox: "0 0 1280 800"
},
create: function() {
this.inherited(arguments), this.setOptions({});
},
rendered: function() {
this.inherited(arguments);
},
redrawSquare: function(e) {
this.addPropertiesToOptions(e), this.calculatedPosX = this.getPosition_x() * window.settings.SCALE + .5 >> 0, this.calculatedPosY = this.getPosition_y() * window.settings.SCALE + .5 >> 0, this.calculatedWidth = parseInt(this.getWidth()), this.calculatedHeight = parseInt(this.getHeight()), this.applyStyle("border-radius", e == undefined ? this.radius + "px" : e.radius.toString() + "px"), this.applyStyle("background-color", "rgba(" + (e == undefined ? this.fillColor : e.fillColor).toString() + "," + (e == undefined ? this.opacity : e.opacity).toString() + ")"), this.applyStyle("border", (e == undefined ? this.lineColor : e.lineColor) + " " + (e == undefined ? this.lineThickness : e.lineThickness).toString() + "px " + (e == undefined ? this.lineType : e.lineType).toString()), this.render();
},
addPropertiesToOptions: function(e) {
this.addOption("beginP", e == undefined ? this.beginP : e.beginP), this.addOption("endP", e == undefined ? this.endP : e.endP), this.addOption("opacity", e == undefined ? this.opacity : e.opacity), this.addOption("lineColor", e == undefined ? this.lineColor : e.lineColor), this.addOption("lineType", e == undefined ? this.lineType : e.lineType), this.addOption("lineThickness", e == undefined ? this.lineThickness : e.lineThickness), this.addOption("fillColor", e == undefined ? this.fillColor : e.fillColor), this.addOption("radius", e == undefined ? this.radius : e.radius), this.addOption("opacity", e == undefined ? this.opacity : e.opacity);
},
resizeComponent: function() {
this.calculatedPosX = this.getPosition_x() * window.settings.SCALE + .5 >> 0, this.calculatedPosY = this.getPosition_y() * window.settings.SCALE + .5 >> 0, this.calculatedWidth = parseInt(this.getWidth() * window.settings.SCALE), this.calculatedHeight = parseInt(this.getHeight() * window.settings.SCALE), this.render();
}
});

// Ellipse.js

enyo.kind({
name: "educate.components.tekendoos.Ellipse",
kind: "educate.components.ObjectInterface",
published: {
carrier: window.settings.CARRIERS.ELLIPSE,
linked: ""
},
attributes: {
xmlns: "http://www.w3.org/2000/svg",
version: "1.1",
viewbox: "0 0 1280 800"
},
create: function() {
this.inherited(arguments), this.setOptions({});
},
rendered: function() {
this.inherited(arguments);
},
redrawEllipse: function(e) {
this.addPropertiesToOptions(e), e == undefined && (this.calculatedPosX = this.getPosition_x() * window.settings.SCALE + .5 >> 0, this.calculatedPosY = this.getPosition_y() * window.settings.SCALE + .5 >> 0), this.calculatedWidth = parseInt(this.getWidth()), this.calculatedHeight = parseInt(this.getHeight()), this.applyStyle("background-color", "rgba(" + (e == undefined ? this.fillColor : e.fillColor).toString() + "," + (e == undefined ? this.opacity : e.opacity).toString() + ")"), this.applyStyle("border", (e == undefined ? this.lineColor : e.lineColor) + " " + (e == undefined ? this.lineThickness : e.lineThickness).toString() + "px " + (e == undefined ? this.lineType : e.lineType).toString()), this.applyStyle("box-sizing", "border-box"), this.applyStyle("border-radius", this.calculatedWidth.toString() + "px / " + this.calculatedHeight.toString() + "px"), this.render();
},
addPropertiesToOptions: function(e) {
this.addOption("beginP", e == undefined ? this.beginP : e.beginP), this.addOption("endP", e == undefined ? this.endP : e.endP), this.addOption("opacity", e == undefined ? this.opacity : e.opacity), this.addOption("lineColor", e == undefined ? this.lineColor : e.lineColor), this.addOption("lineType", e == undefined ? this.lineType : e.lineType), this.addOption("lineThickness", e == undefined ? this.lineThickness : e.lineThickness), this.addOption("fillColor", e == undefined ? this.fillColor : e.fillColor), this.addOption("opacity", e == undefined ? this.opacity : e.opacity);
},
resizeComponent: function() {
this.calculatedPosX = this.getPosition_x() * window.settings.SCALE + .5 >> 0, this.calculatedPosY = this.getPosition_y() * window.settings.SCALE + .5 >> 0, this.calculatedWidth = parseInt(this.getWidth() * window.settings.SCALE), this.calculatedHeight = parseInt(this.getHeight() * window.settings.SCALE), this.render();
}
});

// Free.js

enyo.kind({
name: "educate.components.tekendoos.Free",
kind: "educate.components.ObjectInterface",
published: {
carrier: window.settings.CARRIERS.FREE,
linked: ""
},
attributes: {
xmlns: "http://www.w3.org/2000/svg",
version: "1.1",
preserveAspectRatio: "xMinYMin meet",
viewbox: "0 0 1280 800"
},
create: function() {
this.inherited(arguments);
},
rendered: function() {
this.inherited(arguments);
},
redrawLine: function(e) {
this.applyStyle("height", this.height.toString() + "px"), this.applyStyle("width", this.width.toString() + "px"), this.calculatedWidth = parseInt(this.getWidth() * window.settings.SCALE), this.calculatedHeight = parseInt(this.getHeight() * window.settings.SCALE), this.$.svg.applyStyle("height", this.height.toString() + "px"), this.$.svg.applyStyle("width", this.width.toString() + "px"), this.addPropertiesToOptions(e), this.applyStyle("left", this.tmpX + "px"), this.applyStyle("top", this.tmpY + "px");
if (e == undefined) {
var t = document.createElementNS("http://www.w3.org/2000/svg", "path");
t.setAttribute("class", "tekenpath" + this.iPaths), this.fill ? t.setAttribute("fill", "rgb(" + this.fillColor + ")") : t.setAttribute("fill", "none"), t.setAttribute("stroke-linejoin", "round"), t.setAttribute("stroke-linecap", "round"), this.$.svg.applyStyle("opacity", this.opacity), this.applyStyle("stroke", this.lineColor), this.applyStyle("stroke-width", this.lineThickness);
switch (this.lineType) {
case "solid":
this.applyStyle("stroke-dasharray", "none");
break;
case "dotted":
this.applyStyle("stroke-dasharray", "1," + parseInt(this.lineThickness + 5));
break;
case "dashed":
this.applyStyle("stroke-dasharray", "10," + parseInt(this.lineThickness + 10));
break;
case "double":
this.applyStyle("stroke-dasharray", "20," + parseInt(this.lineThickness + 10) + ",1," + parseInt(this.lineThickness + 5) + ",1," + parseInt(this.lineThickness + 10));
}
var n = "M " + Math.abs(this.offsetLeft) + "," + Math.abs(this.offsetTop);
if (this.pathString != "") {
var r = this.pathString.split("/");
for (var i = 1; i <= r.length - 1; i++) {
var s = parseInt(r[i - 1].split(",")[0]), o = parseInt(r[i - 1].split(",")[1]);
n += " L " + (s - this.beginP.x + Math.abs(this.offsetLeft)) + "," + (o - this.beginP.y + Math.abs(this.offsetTop));
}
} else for (var i = 0; i < this.pathPointsA.length; i++) n += " L " + (this.pathPointsA[i].x - this.beginP.x + Math.abs(this.offsetLeft)) + "," + (this.pathPointsA[i].y - this.beginP.y + Math.abs(this.offsetTop));
t.setAttribute("d", n), this.$.svg.hasNode().appendChild(t);
} else {
switch (e.lineType) {
case "solid":
this.applyStyle("stroke-dasharray", "none");
break;
case "dotted":
this.applyStyle("stroke-dasharray", "1," + parseInt(e.lineThickness + 5));
break;
case "dashed":
this.applyStyle("stroke-dasharray", "10," + parseInt(e.lineThickness + 10));
break;
case "double":
this.applyStyle("stroke-dasharray", "20," + parseInt(e.lineThickness + 10) + ",1," + parseInt(e.lineThickness + 5) + ",1," + parseInt(e.lineThickness + 10));
}
this.$.svg.applyStyle("opacity", e.opacity), this.applyStyle("stroke", e.lineColor), this.applyStyle("stroke-width", e.lineThickness + "px"), this.fill ? this.$.svg.node.lastChild.style.fill = "rgb(" + e.fillColor + ")" : this.$.svg.node.lastChild.style.fill = "none";
}
},
addPropertiesToOptions: function(e) {
this.addOption("opacity", e == undefined ? this.opacity : e.opacity), this.addOption("lineColor", e == undefined ? this.lineColor : e.lineColor), this.addOption("lineType", e == undefined ? this.lineType : e.lineType), this.addOption("lineThickness", e == undefined ? this.lineThickness : e.lineThickness), this.addOption("fillColor", e == undefined ? this.fillColor : e.fillColor), this.addOption("fill", e == undefined ? this.fill : e.fill), this.addOption("opacity", e == undefined ? this.opacity : e.opacity);
},
resizeComponent: function() {
this.calculatedWidth = parseInt(this.getWidth() * window.settings.SCALE), this.calculatedHeight = parseInt(this.getHeight() * window.settings.SCALE), this.$.svg.applyStyle("height", this.calculatedHeight.toString() + "px"), this.$.svg.applyStyle("width", this.calculatedWidth.toString() + "px"), this.applyStyle("left", (this.tmpX * window.settings.SCALE + .5 >> 0) + "px"), this.applyStyle("top", (this.tmpY * window.settings.SCALE + .5 >> 0) + "px");
}
});

// Multi.js

enyo.kind({
name: "educate.components.tekendoos.Multi",
kind: "educate.components.ObjectInterface",
published: {
carrier: window.settings.CARRIERS.MULTI,
linked: ""
},
attributes: {
xmlns: "http://www.w3.org/2000/svg",
version: "1.1",
viewbox: "0 0 1280 800"
},
create: function() {
this.inherited(arguments);
},
redrawMulti: function(e) {
this.applyStyle("height", this.height.toString() + "px"), this.applyStyle("width", this.width.toString() + "px"), this.addPropertiesToOptions(e), this.applyStyle("left", this.tmpX + "px"), this.applyStyle("top", this.tmpY + "px");
if (e == undefined || e == "stretch") {
if (e != "stretch") {
this.applyStyle("left", this.tmpX + "px"), this.applyStyle("top", this.tmpY + "px");
var t = document.createElementNS("http://www.w3.org/2000/svg", "polygon");
t.style.fill = "rgb(" + this.fillColor + ")", t.style.fillOpacity = this.opacity, t.style.stroke = this.lineColor, t.style.strokeWidth = this.lineThickness, t.style.strokeLinecap = "round";
switch (this.lineType) {
case "solid":
this.applyStyle("stroke-dasharray", "none");
break;
case "dotted":
this.applyStyle("stroke-dasharray", "1," + parseInt(this.lineThickness + 5));
break;
case "dashed":
this.applyStyle("stroke-dasharray", "10," + parseInt(this.lineThickness + 10));
break;
case "double":
this.applyStyle("stroke-dasharray", "20," + parseInt(this.lineThickness + 10) + ",1," + parseInt(this.lineThickness + 5) + ",1," + parseInt(this.lineThickness + 10));
}
var n = "";
if (this.pathString != "") {
var r = this.pathString.split("/");
for (var i = 1; i <= r.length - 1; i++) {
var s = parseInt(r[i - 1].split(",")[0]), o = parseInt(r[i - 1].split(",")[1]);
n += s - this.beginP.x + Math.abs(this.offsetLeft) + "," + (o - this.beginP.y + Math.abs(this.offsetTop)) + " ";
}
} else for (var i = 0; i < this.pathPoints.length; i++) n += this.pathPoints[i].split(",")[0] - this.beginP.x + Math.abs(this.offsetLeft) + "," + (this.pathPoints[i].split(",")[1] - this.beginP.y + Math.abs(this.offsetTop)) + " ";
t.setAttribute("points", n), this.$.svg.hasNode().appendChild(t);
}
} else {
switch (e.lineType) {
case "solid":
this.applyStyle("stroke-dasharray", "none");
break;
case "dotted":
this.applyStyle("stroke-dasharray", "1," + parseInt(e.lineThickness + 5));
break;
case "dashed":
this.applyStyle("stroke-dasharray", "10," + parseInt(e.lineThickness + 10));
break;
case "double":
this.applyStyle("stroke-dasharray", "20," + parseInt(e.lineThickness + 10) + ",1," + parseInt(e.lineThickness + 5) + ",1," + parseInt(e.lineThickness + 10));
}
this.node.children[0].children[0].style.strokeWidth = e.lineThickness + "px", this.node.children[0].children[0].style.fill = "rgb(" + this.fillColor + ")", this.node.children[0].children[0].style.fillOpacity = this.opacity, this.node.children[0].children[0].style.stroke = this.lineColor;
}
},
addPropertiesToOptions: function(e) {
this.addOption("opacity", e == undefined ? this.opacity : e.opacity), this.addOption("lineColor", e == undefined ? this.lineColor : e.lineColor), this.addOption("lineType", e == undefined ? this.lineType : e.lineType), this.addOption("lineThickness", e == undefined ? this.lineThickness : e.lineThickness), this.addOption("fillColor", e == undefined ? this.fillColor : e.fillColor), this.addOption("opacity", e == undefined ? this.opacity : e.opacity);
},
resizeComponent: function() {
this.calculatedWidth = parseInt(this.getWidth() * window.settings.SCALE), this.calculatedHeight = parseInt(this.getHeight() * window.settings.SCALE), this.$.svg.applyStyle("height", this.calculatedHeight.toString() + "px"), this.$.svg.applyStyle("width", this.calculatedWidth.toString() + "px"), this.applyStyle("left", (this.tmpX * window.settings.SCALE + .5 >> 0) + "px"), this.applyStyle("top", (this.tmpY * window.settings.SCALE + .5 >> 0) + "px");
}
});

// Meetlat.js

enyo.kind({
name: "educate.components.meetlat.Meetlat",
kind: "educate.components.ObjectInterface",
tag: "div",
classes: "meetlat",
published: {
carrier: window.settings.CARRIERS.MEETLAT,
linked: ""
},
create: function() {
this.inherited(arguments);
},
rendered: function() {
this.inherited(arguments);
},
redrawRuler: function() {
this.$.ruler.destroyClientControls(), this.addPropertiesToOptions(), this.width = (this.unit == "cm" ? this.originalLength : this.originalLength / 10) * this.pixelPerCm + this.pixelPerCm - 10 + this.stretch, this.calculatedWidth = this.width * window.settings.SCALE, this.calculatedHeight = 55 * window.settings.SCALE, this.calculatedPosX = this.getPosition_x() * window.settings.SCALE + window.settings.OFFSETX + .5 >> 0, this.calculatedPosY = this.getPosition_y() * window.settings.SCALE + window.settings.OFFSETY + .5 >> 0, this.$.unit.setContent(this.unit);
for (var e = 0; e <= (this.unit == "cm" ? this.lengte : this.lengte / 10); e++) {
this.createComponent({
container: this.$.ruler,
name: "stripe" + e,
tag: "li",
classes: "big",
content: this.unit == "mm" && e != 0 ? e + "0" : e,
style: "padding-left: " + (e == 0 ? 15 * window.settings.SCALE : this.pixelPerCm * window.settings.SCALE) + "px;"
});
if (e != (this.unit == "cm" ? this.lengte : this.lengte / 10)) for (var t = 1; t < this.divide; t++) this.createComponent({
container: this.$.ruler,
name: "stripe" + e + "." + t,
tag: "li",
classes: "small",
style: "padding-left: " + this.pixelPerCm / this.divide * t * window.settings.SCALE + "px;"
});
}
this.render();
},
extraPropertiesChanged: function(e) {
this.lengte = e.lengte, this.originalLength = e.lengte, this.unit = e.unit, this.divide = e.divide, this.redrawRuler();
},
resizeComponent: function() {
this.redrawRuler();
}
});

// PickAndPlace.js

enyo.kind({
name: "educate.components.pickAndPlace.PickAndPlace",
kind: "educate.components.ObjectInterface",
tag: "div",
classes: "pick-and-place",
published: {
width: window.settings.STAGEWIDTH,
height: window.settings.STAGEHEIGHT,
linked: "",
modus: "",
disabledModus: "",
disableActions: !0,
originalDropZoneList: "",
filteredDropZoneList: "",
dropZoneList: "",
unusedDropZoneList: "",
unusedDropZoneShowing: !1,
valueFromProperties: "",
defaultNumberOfQuizItems: 4,
numberOfQuizItems: 4,
arrTestMode: "",
currentTestItem: 0,
highlightZone: !1,
totalPickItems: 0,
alphaZones: 0,
removePickObjectsByTest: !1,
removeTestItemTimeout: null,
removePickObjectsByPractise: !1,
removePractiseItemTimeout: null,
alphaZonesObjCol: {}
},
handlers: {
onSvgChanged: "onSvgChangedHandler",
onPickItemCheckTapped: "onPickItemCheckTappedHandler",
onPickItemLabelTapped: "onPickItemLabelTappedHandler",
ondragstart: "dragstartHandler",
onTestModeItemPlaced: "testModeItemPlacedHandler",
onPractiseModeItemPlaced: "practiseModeItemPlacedHandler"
},
create: function() {
this.inherited(arguments), this.createComponent({
kind: "Signals",
onAnswerSended: "answerSendedHandler"
}), this.valueChanged(), enyo.Signals.send("hideZoomTool", this), this.alphaZonesObjCol = {};
},
rendered: function() {
this.inherited(arguments), this.$.pickAndPlaceMenu.updatePickList(this.getDropZoneList());
var e = this.hasNode();
e && e.addEventListener("touchstart", window.touchToMouse, !0);
},
optionsChanged: function() {
this.setOriginalDropZoneList(this.options.dropZoneList !== undefined ? this.options.dropZoneList : ""), this.setDefaultNumberOfQuizItems(this.options.numberOfQuizItems !== undefined ? this.options.numberOfQuizItems : 4), this.setHighlightZone(this.options.highlightZone !== undefined ? this.options.highlightZone === !0 : !1), this.setAlphaZones(this.options.alphaZones !== undefined ? this.options.alphaZones : 0), this.setRemovePickObjectsByTest(this.options.removePickObjectsByTest !== undefined ? this.options.removePickObjectsByTest === !0 : !1), this.setRemovePickObjectsByPractise(this.options.removePickObjectsByPractise !== undefined ? this.options.removePickObjectsByPractise === !0 : !1), this.setUnusedDropZoneShowing(this.options.unusedDropZoneShowing !== undefined ? this.options.unusedDropZoneShowing === !0 : !1), this.setDisabledModus(this.options.disabledModus !== undefined ? this.options.disabledModus : {
practise: !1,
test: !1,
quiz: !1
}), this.handleDisabledQuizTypes();
},
handleDisabledQuizTypes: function() {
for (var e in this.getDisabledModus()) this.$.pickAndPlaceMenu.disabledQuizType(e, this.getDisabledModus()[e]);
},
handleModusFrame: function() {
var e = this.options.modus || "practise";
return this.getDisabledModus().practise = this.getHighlightZone() || this.getDisabledModus().practise, this.getDisabledModus()[e] === !1 ? e : this.getDisabledModus().practise ? this.getDisabledModus().test ? this.getDisabledModus().quiz ? "practise" : "quiz" : "test" : "practise";
},
valueChanged: function() {
var e = /frame/.test(this.kindName) ? "frame" : "create";
this.$.pickAndPlaceSvg.setValue(this.getValue() || e);
},
modusChanged: function() {
this.options || (this.options = {}), this.options.modus = this.getModus();
},
defaultNumberOfQuizItemsChanged: function() {
this.options || (this.options = {}), this.options.numberOfQuizItems = this.getDefaultNumberOfQuizItems(), this.setNumberOfQuizItems(this.getDefaultNumberOfQuizItems());
},
highlightZoneChanged: function() {
this.options || (this.options = {}), this.options.highlightZone = this.getHighlightZone();
},
alphaZonesChanged: function() {
this.options || (this.options = {}), this.options.alphaZones = this.getAlphaZones();
},
removePickObjectsByTestChanged: function() {
this.options || (this.options = {}), this.options.removePickObjectsByTest = this.getRemovePickObjectsByTest();
},
removePickObjectsByPractiseChanged: function() {
this.options || (this.options = {}), this.options.removePickObjectsByPractise = this.getRemovePickObjectsByPractise();
},
unusedDropZoneShowingChanged: function() {
this.options || (this.options = {}), this.options.unusedDropZoneShowing = this.getUnusedDropZoneShowing();
},
valueFromPropertiesChanged: function() {
this.$.pickAndPlaceSvg.setIsValueFromProperties(!0), this.setValue(this.getValueFromProperties());
},
onSvgChangedHandler: function(e, t) {
this.setOriginalDropZoneList(t);
},
originalDropZoneListChanged: function() {
this.setFilteredDropZoneList(this.getOriginalDropZoneList()), this.filteredDropZoneListChanged(), this.options || (this.options = {}), this.options.dropZoneList = this.getOriginalDropZoneList(), this.setAlphaZonesInCollection();
},
filteredDropZoneListChanged: function() {
this.setDropZoneList(this.getFilteredDropZoneList()), this.setNumberOfQuizItems(this.getFilteredDropZoneList().length < this.getDefaultNumberOfQuizItems() ? this.getFilteredDropZoneList().length : this.getDefaultNumberOfQuizItems());
switch (this.getModus()) {
case "practise":
this.setPractiseMode();
break;
case "test":
this.setTestMode();
break;
case "quiz":
this.setQuizMode();
}
},
dropZoneListChanged: function() {
this.setTotalPickItems(this.getDropZoneList().length), this.$.pickAndPlaceMenu.updatePickList(this.getDropZoneList());
},
unusedDropZoneListChanged: function() {
this.handleVisibilityUnusedDropZones();
},
handleVisibilityUnusedDropZones: function() {
this.$.pickAndPlaceSvg.setMultipleZonesAlpha(this.getUnusedDropZoneShowing() ? 1 : 0, this.getUnusedDropZoneList());
},
removeUnusedDropZonesFromList: function() {
var e = this.getOriginalDropZoneList().length, t = [];
while (--e >= 0) {
var n = this.getOriginalDropZoneList()[e];
n && !n.isZoneActief && (t.push(n), this.getOriginalDropZoneList().splice(e, 1));
}
this.originalDropZoneListChanged(), this.setUnusedDropZoneList(t);
},
setAlphaZonesInCollection: function(e) {
var t = e === null ? this.getAlphaZones() : e, n = this.getOriginalDropZoneList().length;
while (--n >= 0) {
var r = this.getOriginalDropZoneList()[n];
this.alphaZonesObjCol[r.zoneId] = parseFloat(t);
}
},
onPickItemLabelTappedHandler: function(e, t) {
this.setZoneLabel(t.zone, t.label);
},
setZoneLabel: function(e, t) {
var n = this.getOriginalDropZoneList().length;
for (var r = 0; r < n; r++) this.getOriginalDropZoneList()[r] === e && (this.getOriginalDropZoneList()[r].zoneLabel = t, this.originalDropZoneListChanged());
},
onPickItemCheckTappedHandler: function(e, t) {
this.setZoneActive(t.zone, !t.zone.isZoneActief);
},
setZoneActive: function(e, t) {
var n = this.getOriginalDropZoneList().length;
for (var r = 0; r < n; r++) this.getOriginalDropZoneList()[r] === e && (this.getOriginalDropZoneList()[r].isZoneActief = t, this.originalDropZoneListChanged());
},
setPractiseMode: function() {
this.setDropZoneList(shuffleArray(this.getFilteredDropZoneList())), this.dropZoneListChanged();
},
setTestMode: function() {
this.getHighlightZone() ? this.setHighlightTestMode() : this.setNormalTestMode();
},
setNormalTestMode: function() {
this.setCurrentTestItem(0), this.setArrTestMode(shuffleArray(this.getFilteredDropZoneList())), this.showTestModeItem();
},
setHighlightTestMode: function() {
this.$.pickAndPlaceMenu.setIsTestAndHighlight(!0), this.setCurrentTestItem(0), this.setDropZoneList(shuffleArray(this.getFilteredDropZoneList())), this.dropZoneListChanged(), this.setArrTestMode(shuffleArray(this.getFilteredDropZoneList())), this.showTestModeHighlight();
},
setQuizMode: function() {
this.getHighlightZone() ? this.setHighlightQuizMode() : this.setNormalQuizMode();
},
setNormalQuizMode: function() {
var e = shuffleArray(this.getFilteredDropZoneList()).slice(0, this.getNumberOfQuizItems());
this.setDropZoneList(e), this.dropZoneListChanged();
},
setHighlightQuizMode: function() {
this.removeAllHighlightZones();
var e = shuffleArray(this.getFilteredDropZoneList()).slice(0, this.getNumberOfQuizItems());
this.setDropZoneList(shuffleArray(this.getFilteredDropZoneList())), this.dropZoneListChanged();
var t = this.getAlphaZones() > 0 ? this.getAlphaZones() : 1;
this.$.pickAndPlaceSvg.setMultipleZonesAlpha(t, e);
},
removeAllHighlightZones: function() {
this.$.pickAndPlaceSvg.setMultipleZonesAlpha(0, this.getOriginalDropZoneList()), this.setAlphaZonesInCollection(0);
},
practiseModeCompleted: function() {
this.showResultModal("Alles staat op de juiste plaats", "Opnieuw beginnen?", "ja", "nee", "practise");
},
showTestModeItem: function() {
this.setDropZoneList([ this.getArrTestMode()[this.getCurrentTestItem()] ]);
},
showNextTestModeItem: function() {
window.clearTimeout(this.removeTestItemTimeout), this.setCurrentTestItem(this.getCurrentTestItem() + 1), this.getArrTestMode()[this.getCurrentTestItem()] ? this.showTestModeItem() : this.testModeCompleted(), this.getRemovePickObjectsByTest() ? this.clearPickObjectsOnStageAfterTest() : this.clearWrongPickObjectsOnStage();
},
showTestModeHighlight: function() {
window.clearTimeout(this.removeTestItemTimeout), this.removeAllHighlightZones();
var e = this.getArrTestMode()[this.getCurrentTestItem()], t = this.getAlphaZones() > 0 ? this.getAlphaZones() : 1;
this.$.pickAndPlaceSvg.setZoneAlpha(e, t), this.flashingHighligtedZone(this.getArrTestMode()[this.getCurrentTestItem()]), this.alphaZonesObjCol[e.zoneId] = parseFloat(t);
},
showNextTestModeHighlight: function() {
this.removeAllHighlightZones(), this.setCurrentTestItem(this.getCurrentTestItem() + 1), this.getArrTestMode()[this.getCurrentTestItem()] ? this.showTestModeHighlight() : this.testModeCompleted(), this.getRemovePickObjectsByTest() ? this.clearPickObjectsOnStageAfterTest() : this.clearWrongPickObjectsOnStage();
},
flashingHighligtedZone: function(e) {
var t = this.getAlphaZones() > 0 ? this.getAlphaZones() : 1;
this.$.pickAndPlaceSvg.flashZoneAlpha(e, t);
},
testModeCompleted: function() {
this.setDropZoneList([]), this.showResultModal("Alles staat op de juiste plaats", "Opnieuw beginnen?", "ja", "nee", "test");
},
testModeItemPlacedHandler: function(e, t) {
t.isPlacementCorrect && (this.getRemovePickObjectsByTest() && $(t.originator.hasNode()).css("opacity", 0), this.removeTestItemTimeout = window.setTimeout(t.highlightZone ? enyo.bind(this, "showNextTestModeHighlight") : enyo.bind(this, "showNextTestModeItem"), this.getRemovePickObjectsByTest() ? 700 : 400));
},
practiseModeItemPlacedHandler: function(e, t) {
this.getRemovePickObjectsByPractise() && t.originator.getState() === "correct" && $(t.originator.hasNode()).delay(500).queue(function(e) {
$(this).css({
opacity: 0,
"pointer-events": "none"
}), e();
});
},
quizCompleted: function() {
var e = this.countPickItemsPlacedCorrect(), t = e === this.getNumberOfQuizItems() ? "Alles juist. Proficiat!" : e + " van de " + this.getNumberOfQuizItems() + " staan op de juiste plaats";
this.showResultModal(t, "Opnieuw beginnen?", "ja", "nee", "quiz");
},
checkPickAndPlaceCompleted: function() {
this.getModus() === "practise" && this.countPickItemsPlaced() === this.getTotalPickItems() && this.countPickItemsPlacedCorrect() === this.getTotalPickItems() && this.practiseModeCompleted();
},
countPickItemsPlaced: function() {
var e = this.$.pickObjectContainer.children.length, t = 0;
while (--e >= 0) this.$.pickObjectContainer.children[e].hasClass("pick-object") && t++;
return t;
},
countPickItemsPlacedCorrect: function() {
var e = this.$.pickObjectContainer.children.length, t = 0;
while (--e >= 0) this.$.pickObjectContainer.children[e].hasClass("pick-object") && this.$.pickObjectContainer.children[e].getState() === "correct" && t++;
return t;
},
showResultModal: function(e, t, n, r, i) {
this.hideResultModal(), this.createComponent({
name: "resultModal",
kind: "educate.frame.components.pickAndPlace.PickAndPlaceModal",
title: e,
question: t,
posAnswer: n,
negAnswer: r,
modus: i,
container: this.parent
}, {
owner: this
}), this.$.resultModal.render();
},
hideResultModal: function() {
this.$.resultModal && this.$.resultModal.destroy();
},
answerSendedHandler: function(e, t) {
this.modus = t.answer ? t.modus : this.options.modus != undefined ? this.getHighlightZone() && this.options.modus === "practise" ? "test" : this.options.modus : this.getHighlightZone() ? "test" : "practise", this.modusChanged();
},
initStartPickAndPlaceModus: function() {
this.clearPickObjectsOnStage(), this.hideResultModal(), this.$.pickAndPlaceMenu.setIsTestAndHighlight(!1), this.$.pickAndPlaceMenu.makeQuizTypeActive(this.getModus()), this.$.pickAndPlaceMenu.showQuizResultsBtn(!1);
},
clearPickObjectsOnStage: function() {
this.$.pickObjectContainer.destroyClientControls();
},
clearPickObjectsOnStageAfterTest: function() {
var e = this.$.pickObjectContainer.children.length;
while (--e >= 0) {
var t = this.$.pickObjectContainer.children[e];
t.getState() === "wrong" && t.getLinkedItem().setState("none");
}
this.clearPickObjectsOnStage();
},
clearWrongPickObjectsOnStage: function() {
var e = this.$.pickObjectContainer.children.length;
while (--e >= 0) {
var t = this.$.pickObjectContainer.children[e];
t.getState() === "wrong" && this.destroyPickObject(t);
}
},
onPickItemClickedHandler: function(e, t) {
this.getModus() === "test" && this.getHighlightZone() && this.pickItemClicked(t);
},
pickItemClicked: function(e) {
if (e.getState() === "correct") return !1;
this.currentPickObj = this.getCurrentPickObject(e);
if (this.currentPickObj && this.currentPickObj.getMovable()) {
this.currentPickObj.linkedItem.removeClass("dimmed"), $(this.currentPickObj.hasNode()).appendTo($(this.$.pickObjectContainer.hasNode())).css("display", "none");
var t = e.linkedZone.zoneId, n = this.getArrTestMode()[this.getCurrentTestItem()];
this.currentPickObj.handlePickItemClicked(t === n.zoneId, this.getHighlightZone());
}
},
handleDrop: function(e) {
var t = this.$.pickAndPlaceSvg.getZoneByTarget(e);
this.currentPickObj.handlePlacement(t, this.getModus(), this.getHighlightZone()), this.checkPickAndPlaceCompleted();
},
destroyPickObject: function(e) {
e.getLinkedItem().setState("none"), e.destroy();
},
downHandler: function(e, t) {},
resizeComponent: function() {
this.redrawPickAndPlace(), this.$.pickAndPlaceMenu.pickAndPlaceMenuFontHandler();
},
redrawPickAndPlace: function() {
this.calculatedWidth = parseInt(this.getWidth() * window.settings.SCALE), this.calculatedHeight = parseInt(this.getHeight() * window.settings.SCALE), this.calculatedPosX = this.getPosition_x() * window.settings.SCALE + .5 >> 0, this.calculatedPosY = this.getPosition_y() * window.settings.SCALE + .5 >> 0, this.render(), this.alphaZonesChanged(), this.resetAlphaZones();
},
resetAlphaZones: function() {
for (var e in this.getAlphaZonesObjCol()) this.$.pickAndPlaceSvg.setZoneAlpha({
zoneId: e
}, this.getAlphaZonesObjCol()[e]);
}
});

// PickAndPlaceMenu.js

enyo.kind({
name: "educate.components.pickAndPlace.PickAndPlaceMenu",
kind: "enyo.Control",
classes: "pick-and-place-menu",
published: {
pickItems: "",
isHighlightZoneMode: !1,
isTestAndHighlight: !1
},
handlers: {},
events: {
onModusChanged: ""
},
components: [ {
tag: "ul",
name: "quizTypes",
classes: "quiz-types",
components: [ {
tag: "li",
name: "practise",
content: "Oefenen",
ontap: "modusTapped"
}, {
tag: "li",
name: "test",
content: "Test jezelf",
ontap: "modusTapped"
}, {
tag: "li",
name: "quiz",
content: "Doe de quiz",
ontap: "modusTapped"
} ]
}, {
tag: "div",
name: "filterBtn",
classes: "filter-btn Button",
content: "Selectie maken",
ontap: "filterBtnTapped",
showing: !1
}, {
tag: "div",
classes: "pick-list-container",
components: [ {
tag: "ul",
name: "pickList",
classes: "pick-list"
} ]
}, {
tag: "div",
name: "quizResultsBtn",
classes: "quiz-results-btn Button",
content: "Toon resultaat",
ontap: "quizResultsBtnTapped",
showing: !1
} ],
create: function() {
this.inherited(arguments), this.render();
},
rendered: function() {
this.inherited(arguments);
},
isHighlightZoneModeChanged: function() {
this.disabledQuizType("practise", this.getIsHighlightZoneMode());
},
modusTapped: function(e, t) {
var n = e.name;
this.doModusChanged({
modus: n
});
},
makeQuizTypeActive: function(e) {
for (var t = 0; t < this.$.quizTypes.children.length; t++) this.$.quizTypes.children[t].removeClass("active");
this.$[e].addClass("active");
},
showQuizResultsBtn: function(e) {
this.$.quizResultsBtn.setShowing(e);
},
quizResultsBtnTapped: function(e, t) {
enyo.Signals.send("onCheckQuizResults"), this.parent.quizCompleted();
},
updatePickList: function(e) {
this.clearPickList();
},
clearPickList: function() {
this.$.pickList.destroyClientControls();
},
pickAndPlaceMenuFontHandler: function() {
var e = window.settings.FONTSIZE * window.settings.SCALE + .5 >> 0, t = {
"font-size": e + "px",
"line-height": e + "px"
};
$(".pick-list, .quiz-types li").css(t);
},
filterBtnTapped: function(e, t) {
this.parent.filterBtnTapped();
}
});

// PickAndPlaceSvg.js

enyo.kind({
name: "educate.components.pickAndPlace.PickAndPlaceSvg",
kind: "educate.components.svg.SvgParser",
classes: "pick-and-place-svg",
published: {
ajaxGetSvg: "",
isValueFromProperties: !1
},
handlers: {},
events: {
onSvgChanged: ""
},
isRendered: !1,
create: function() {
this.inherited(arguments), this.createComponent({
tag: "div",
name: "svgCon",
classes: "svg-container",
allowHtml: !0
}), this.removeClass("svgParser"), this.valueChanged();
},
rendered: function() {
this.inherited(arguments);
},
setPropertyValue: function(e, t, n) {
if (this[n]) {
var r = this[e];
this[e] = t, this[n](r);
} else this[e] = t;
},
valueChanged: function() {
this.isRendered = !1, this.setShowing(!1);
var e = "", t = this;
this.getValue() === "" ? (e = "", this.isTemplate = !0) : this.getValue() === "create" ? (e = Settings.WEBAPP + "svnAssets/template.svg", this.isTemplate = !0) : this.getValue() === "frame" ? (e = "", this.isTemplate = !0) : typeof this.getValue() == "string" ? (e = Settings.WEBAPP + this.getValue(), this.isTemplate = !1) : (e = Settings.WEBAPP + this.getValue().value, this.isTemplate = !1);
if (e !== "") {
var n = {
url: e
};
Ginkgo.ajax(n).then(function(e) {
t.svgAjaxLoaded(e);
}).fail(function(e) {
console.error(e);
});
}
},
svgAjaxLoaded: function(e) {
var t = e.getElementsByTagName("svg")[0];
t.id = this.id + "_svg", t = this.handleSVG(t);
var n = new XMLSerializer, r = n.serializeToString(t);
this.$.svgCon.setContent(r), this.setShowing(!0), this.render(), this.redrawSvg(), this.handleSvgLayers(), this.isRendered = !0;
},
handleSvgLayers: function() {
this.updateZones(), this.bubble("onSvgImagesLoaded");
},
updateZones: function() {
var e = document.getElementById(this.id + "_svg"), t = e.childNodes, n = [], r = [], i = 0, s = this;
for (i = 0; i < t.length; i++) {
if (t[i].nodeName == "path" || t[i].nodeName == "g" || t[i].nodeName == "polygon") n.push(t[i].id), r.push(t[i]);
this.zones = r;
}
var o = [], r = {};
for (i = 0; i < this.zones.length; i++) {
var u = this.makeDropZoneObject(this.zones[i]);
u.zoneType === "laag" && (o.push(u), r[this.zones[i].id] = this.zones[i]);
}
this.zones = r, o.length > 0 && (this.getIsValueFromProperties() && this.doSvgChanged(o), this.setIsValueFromProperties(!1), this.parent.alphaZonesChanged(), this.parent.modusChanged());
},
makeDropZoneObject: function(e) {
var t = this.getZoneInfo(e.id), n = {};
return n.zoneId = e.id, n.zoneName = t.zoneName, n.zoneLabel = t.zoneName, n.zoneType = t.zoneType, n.isZoneActief = !0, n;
},
setMultipleZonesAlpha: function(e, t) {
var n = t.length;
for (; --n >= 0; ) this.setZoneAlpha(t[n], e);
},
setZoneAlpha: function(e, t) {
var n = document.getElementById(this.id + "_svg");
if (n) {
var r = n.getElementById(e.zoneId);
r.style.opacity = t;
}
},
flashZoneAlpha: function(e, t) {
var n = document.getElementById(this.id + "_svg");
if (n) {
var r = n.getElementById(e.zoneId);
$(r).delay(500).fadeOut(200).fadeIn(200).fadeOut(200).fadeIn(200).fadeOut(200).fadeIn(200);
}
},
getZoneByZoneId: function(e) {
var t = document.getElementById(this.id + "_svg");
if (t) return t.getElementById(e);
},
getOriginalWidthAndHeight: function() {
var e = document.getElementById(this.id + "_svg"), t = e.getAttribute("viewBox").split(/ /), n = {};
return n.width = t[2], n.height = t[3], n;
},
getActualWidthAndHeight: function() {
var e = {};
return e.width = $(this.hasNode()).width(), e.height = $(this.hasNode()).height(), e;
},
optionsChanged: function() {},
ontapHandler: function(e, t) {},
redrawSvg: function() {
this.isRendered && this.updateZones();
},
rotationChanged: function() {},
originChanged: function() {},
downHandler: function(e, t) {},
calculatedPosXChanged: function() {},
calculatedPosYChanged: function() {},
calculatedPosZChanged: function() {},
calculatedWidthChanged: function() {},
calculatedHeightChanged: function() {}
});

// PickObject.js

enyo.kind({
name: "educate.components.pickAndPlace.PickObject",
kind: "enyo.Control",
tag: "div",
classes: "pick-object",
published: {
position_x: 0,
position_y: 0,
state: "none",
linkedZone: "",
linkedItem: "",
showArea: !0,
movable: !0,
targetZone: "",
inHighlightMode: !1,
pickAndPlaceSvg: "",
pickAndPlaceMenu: ""
},
events: {
onTestModeItemPlaced: "",
onPractiseModeItemPlaced: ""
},
create: function() {
this.inherited(arguments), this.render(), this.createComponent({
kind: "Signals",
onCheckQuizResults: "checkQuizResultHandler"
}), this.movableChanged();
},
rendered: function() {
this.inherited(arguments);
},
destroy: function() {
this.inherited(arguments);
},
movableChanged: function() {
this.addRemoveClass("movable", this.getMovable());
},
position_xChanged: function() {
this.applyPositionX(this.getPosition_x());
},
position_yChanged: function() {
this.applyPositionY(this.getPosition_y());
},
applyPositionX: function(e) {
this.applyStyle("left", e + "px");
},
applyPositionY: function(e) {
this.applyStyle("top", e + "px");
},
calculatePercentageSvgFromOriginal: function() {
var e = this.getPickAndPlaceSvg().getActualWidthAndHeight(), t = this.getPickAndPlaceSvg().getOriginalWidthAndHeight();
return e.width / t.width;
},
handlePlacement: function(e, t, n) {
switch (t) {
case "practise":
this.checkPlacement(e), this.doPractiseModeItemPlaced();
break;
case "test":
var r = this.checkPlacement(e, n);
this.doTestModeItemPlaced({
isPlacementCorrect: r,
highlightZone: n
});
break;
case "quiz":
this.setTargetZone(e), this.setInHighlightMode(n), this.getLinkedItem().setState("used");
}
},
handlePickItemClicked: function(e, t) {
this.setState(e ? "correct" : "wrong"), this.doTestModeItemPlaced({
isPlacementCorrect: e,
highlightZone: t
});
},
checkQuizResultHandler: function(e, t) {
this.checkPlacement(this.getTargetZone(), this.getInHighlightMode()), this.setMovable(!1);
},
checkPlacement: function(e, t) {
var n = this.isZoneCorrect(e, t);
return this.setState(n ? "correct" : "wrong"), n;
},
isZoneCorrect: function(e, t) {
return e ? t && e.style.opacity === "0" ? !1 : e.id === this.linkedZone.zoneId : !1;
},
isDroppedInDeleteZone: function(e, t) {
var n = $(this.getPickAndPlaceMenu().hasNode()).offset(), r = n.left, i = n.left + $(this.getPickAndPlaceMenu().hasNode()).outerWidth(), s = n.top, o = n.top + $(this.getPickAndPlaceMenu().hasNode()).outerHeight();
return !(e < r || e > i || t < s || t > o);
},
stateChanged: function() {
switch (this.getState()) {
case "none":
this.setNone();
break;
case "correct":
this.setCorrect();
break;
case "wrong":
this.setWrong();
break;
default:
this.setNone();
}
this.getLinkedItem().setState(this.getState());
},
setNone: function() {
this.removeStateClasses();
},
setCorrect: function() {
this.removeStateClasses(), this.addClass("correct");
},
setWrong: function() {
this.removeStateClasses(), this.addClass("wrong");
},
removeStateClasses: function() {
this.removeClass("wrong"), this.removeClass("correct");
},
resizeHandler: function() {
this.inherited(arguments), this.redrawPickObject(), this.pickObjectFontHandler();
},
redrawPickObject: function() {
var e = this.calculatePercentageSvgFromOriginal();
this.applyPositionX(this.getPosition_x() * e), this.applyPositionY(this.getPosition_y() * e);
},
pickObjectFontHandler: function() {
var e = window.settings.FONTSIZE * window.settings.SCALE + .5 >> 0, t = {
"font-size": e + "px",
"line-height": e + "px"
};
$(".pick-object").css(t);
var n = window.settings.FONTSIZE / 16 * 10 * window.settings.SCALE + .5 >> 0, r = window.settings.FONTSIZE / 16 * 15 * window.settings.SCALE + .5 >> 0;
$(".pick-object-inner").css("padding", n + "px " + r + "px"), $(".pick-object-inner i").css("margin-left", r + "px");
}
});

// PickItem.js

enyo.kind({
name: "educate.components.pickAndPlace.PickItem",
kind: "enyo.Control",
tag: "li",
published: {
linkedZone: "",
isPickIcon: !1,
state: "none"
},
handlers: {
ontap: "ontapHandler"
},
events: {
onPickItemClicked: ""
},
create: function() {
this.inherited(arguments);
},
rendered: function() {
this.inherited(arguments);
},
removeClassesFromPickItem: function(e, t) {
var n = t.length;
while (--n >= 0) e.removeClass(t[n]);
},
removeStateClassesFromPickItem: function() {
this.removeClassesFromPickItem(this, [ "wrong-item", "correct-item", "used-item" ]);
},
removeIconClassesFromPickItem: function() {
this.removeClassesFromPickItem(this.$.pickItemIcon, [ "fill-icon", "icon-delete-2", "icon-check-2", "icon-move", "icon-hand-up" ]);
},
ontapHandler: function(e, t) {
this.doPickItemClicked(this);
}
});

// PickAndPlaceFilter.js

enyo.kind({
name: "educate.components.pickAndPlace.PickAndPlaceFilter",
kind: enyo.Control,
classes: "pickAndPlaceFilter",
published: {
pickList: []
},
handlers: {},
components: [ {
tag: "div",
classes: "close-filter Button",
name: "cancelFilter",
content: "Annuleren",
ontap: "cancelFilter"
}, {
tag: "div",
classes: "apply-filter Button",
name: "applyFilter",
content: "Bevestigen",
ontap: "applyFilter"
}, {
tag: "div",
name: "filterText",
classes: "filter-text",
content: "Maak een selectie van de begrippen die je wilt oefenen."
}, {
tag: "div",
classes: "filter-list-container",
name: "filterListContainer"
} ],
create: function() {
this.inherited(arguments), this.show(), this.render();
},
rendered: function() {
this.inherited(arguments);
},
applyFilter: function() {
var e = this.getPickList().filter(function(e) {
return e.isZoneActief;
});
this.parent.setFilteredDropZoneList(e), this.destroy();
},
cancelFilter: function() {
this.destroy();
}
});

// FilterItem.js

enyo.kind({
name: "educate.components.pickAndPlace.FilterItem",
tag: "div",
classes: "filter-item",
published: {
pickListItem: "",
isChecked: !0
},
handlers: {
ontap: "filterItemTapped"
},
create: function() {
this.inherited(arguments), this.render(), this.setIsChecked(this.getPickListItem().isZoneActief), this.handleCheck();
},
rendered: function() {
this.inherited(arguments);
},
isCheckedChanged: function() {
this.handleCheck();
},
handleCheck: function() {
this.$.filterItemCheck.addRemoveClass("icon-check-2", this.getIsChecked()), this.$.filterItemCheck.addRemoveClass("icon-delete-2", !this.getIsChecked()), this.getPickListItem().isZoneActief = this.getIsChecked();
},
filterItemTapped: function(e, t) {
this.setIsChecked(!this.getIsChecked());
}
});

// PickAndPlaceImages.js

enyo.kind({
name: "educate.components.pickAndPlace.pickAndPlaceImages.PickAndPlaceImages",
kind: "educate.components.pickAndPlace.PickAndPlace",
tag: "div",
published: {
carrier: window.settings.CARRIERS.PICKPLACEIMAGES,
dropMargin: 20
},
create: function() {
this.inherited(arguments);
},
rendered: function() {
this.inherited(arguments);
},
optionsChanged: function() {
this.inherited(arguments), this.setDropMargin(this.options.dropMargin != undefined ? parseInt(this.options.dropMargin) : 20);
},
dropMarginChanged: function() {
this.options || (this.options = {}), this.options.dropMargin = this.getDropMargin();
}
});

// PickObjectImage.js

enyo.kind({
name: "educate.components.pickAndPlace.pickAndPlaceImages.PickObjectImage",
kind: "educate.components.pickAndPlace.PickObject",
classes: "pick-object-image",
published: {
linkedZoneNode: "",
refPointX: "",
refPointY: "",
dropMargin: 20
},
components: [ {
tag: "svg",
name: "pickObjectSvg",
classes: "no-mouse-events",
allowHtml: !0,
attributes: {
xmlns: "http://www.w3.org/2000/svg",
"xmlns:xlink": "http://www.w3.org/1999/xlink"
}
} ],
create: function() {
this.inherited(arguments), this.getLinkedZoneNode() && this.setSvg(), this.render();
},
rendered: function() {
this.inherited(arguments);
},
linkedZoneNodeChanged: function() {
this.setSvg();
},
setSvg: function() {
var e = this.getLinkedZoneNode().cloneNode(!0);
e.style.opacity = 1;
var t = new XMLSerializer, n = t.serializeToString(e);
this.$.pickObjectSvg.setContent(n), this.initSvg();
},
initSvg: function() {
var e = this.getDimensionsOfZone();
this.setReferencePoint(e.x, e.y), this.setViewBox(e.x, e.y, e.width, e.height), this.handleScaleSvg(e.width, e.height);
},
getDimensionsOfZone: function() {
return this.getLinkedZoneNode().getBBox();
},
setReferencePoint: function(e, t) {
var n = $(this.getPickAndPlaceSvg().hasNode()).offset(), r = this.calculatePercentageSvgFromOriginal();
this.setRefPointX(e * r + n.left + .5 >> 0), this.setRefPointY(t * r + n.top + .5 >> 0);
},
setViewBox: function(e, t, n, r) {
this.$.pickObjectSvg.setAttribute("viewBox", e + " " + t + " " + n + " " + r);
},
handleScaleSvg: function(e, t) {
var n = this.calculatePercentageSvgFromOriginal();
this.$.pickObjectSvg.applyStyle("width", e * n + "px"), this.$.pickObjectSvg.applyStyle("height", t * n + "px");
},
handlePlacement: function(e, t, n) {
this.setDropMargin(t);
switch (e) {
case "practise":
this.checkPlacement(), this.doPractiseModeItemPlaced();
break;
case "test":
var r = this.checkPlacement(n);
this.doTestModeItemPlaced({
isPlacementCorrect: r,
highlightZone: n
});
break;
case "quiz":
this.setInHighlightMode(n), this.getLinkedItem().setState("used");
}
},
handlePickItemClicked: function(e, t) {
e && this.snapPosition(), this.inherited(arguments);
},
checkQuizResultHandler: function(e, t) {
this.checkPlacement(this.getInHighlightMode()), this.setMovable(!1);
},
checkPlacement: function(e) {
var t = this.isZoneCorrect(e);
return t && this.snapPosition(), this.setState(t ? "correct" : "wrong"), t;
},
isZoneCorrect: function(e) {
var t = this.getPickAndPlaceSvg().getZoneByZoneId(this.getLinkedZone().zoneId).style.opacity;
if (e && t == 0) return !1;
var n = $(this.hasNode()).offset(), r = n.left + .5 >> 0, i = n.top + .5 >> 0, s = this.getRefPointX() - this.getDropMargin(), o = this.getRefPointX() + this.getDropMargin(), u = this.getRefPointY() - this.getDropMargin(), a = this.getRefPointY() + this.getDropMargin();
return r >= s && r <= o && i >= u && i <= a ? !0 : !1;
},
snapPosition: function() {
var e = $(this.getPickAndPlaceSvg().hasNode()).offset();
this.setPosition_x(this.getRefPointX() - e.left), this.setPosition_y(this.getRefPointY() - e.top);
},
setWrong: function() {
this.inherited(arguments), this.$.pickObjectSvg.addClass("wrong-img");
},
removeStateClasses: function() {
this.inherited(arguments), this.$.pickObjectSvg.removeClass("wrong-img");
}
});

// PickItemImage.js

enyo.kind({
name: "educate.components.pickAndPlace.pickAndPlaceImages.PickItemImage",
kind: "educate.components.pickAndPlace.PickItem",
classes: "pick-item-image",
published: {
linkedZoneNode: "",
src: ""
},
linkedZoneNodeChanged: function() {
var e = this.getLinkedZoneNode().cloneNode(!0);
e.style.opacity = 1;
var t = new XMLSerializer, n = t.serializeToString(e);
this.$.pickItemSvg.setContent(n), this.setViewBox();
},
setViewBox: function() {
var e = this.getLinkedZoneNode().getBBox();
this.$.pickItemSvg.setAttribute("viewBox", e.x + " " + e.y + " " + e.width + " " + e.height);
}
});

// PickAndPlaceMenuImages.js

enyo.kind({
name: "educate.components.pickAndPlace.pickAndPlaceImages.PickAndPlaceMenuImages",
kind: "educate.components.pickAndPlace.PickAndPlaceMenu",
published: {},
handlers: {},
create: function() {
this.inherited(arguments), this.render();
},
rendered: function() {
this.inherited(arguments);
}
});

// PickAndPlaceWords.js

enyo.kind({
name: "educate.components.pickAndPlace.pickAndPlaceWords.PickAndPlaceWords",
kind: "educate.components.pickAndPlace.PickAndPlace",
tag: "div",
published: {
carrier: window.settings.CARRIERS.PICKPLACEWORDS
},
create: function() {
this.inherited(arguments);
},
rendered: function() {
this.inherited(arguments);
}
});

// PickObjectWord.js

enyo.kind({
name: "educate.components.pickAndPlace.pickAndPlaceWords.PickObjectWord",
kind: "educate.components.pickAndPlace.PickObject",
classes: "pick-object-word",
published: {
word: ""
},
components: [ {
tag: "div",
name: "pickObjectInner",
classes: "pick-object-inner",
components: [ {
tag: "p",
name: "ppWord",
content: this.word,
classes: "no-mouse-events"
}, {
tag: "i",
name: "ppCheck",
classes: "PPcheck no-mouse-events"
} ]
} ],
create: function() {
this.inherited(arguments), this.$.ppWord.setContent(this.getWord()), this.render();
},
rendered: function() {
this.inherited(arguments);
},
setCorrect: function() {
this.inherited(arguments), this.$.ppCheck.addClass("fill-icon icon-check-2");
},
setWrong: function() {
this.inherited(arguments), this.$.ppCheck.addClass("fill-icon icon-delete-2");
},
removeStateClasses: function() {
this.inherited(arguments), this.$.ppCheck.removeClass("fill-icon icon-delete-2"), this.$.ppCheck.removeClass("fill-icon icon-check-2");
}
});

// PickItemWord.js

enyo.kind({
name: "educate.components.pickAndPlace.pickAndPlaceWords.PickItemWord",
kind: "educate.components.pickAndPlace.PickItem",
classes: "pick-item-word"
});

// PickAndPlaceMenuWords.js

enyo.kind({
name: "educate.components.pickAndPlace.pickAndPlaceWords.PickAndPlaceMenuWords",
kind: "educate.components.pickAndPlace.PickAndPlaceMenu",
published: {},
handlers: {},
create: function() {
this.inherited(arguments), this.render();
},
rendered: function() {
this.inherited(arguments);
}
});

// ZoomImage.js

enyo.kind({
name: "educate.components.zoomImage.ZoomImage",
kind: "educate.components.ObjectInterface",
tag: "img",
classes: "image",
published: {
carrier: window.settings.CARRIERS.ZOOMIMAGE,
linked: "",
bAchtergrond: !1
},
handlers: {},
components: [ {
kind: enyo.Signals,
changeZoomImage: "changeZoomImageHandler"
} ],
create: function() {
this.inherited(arguments), this.valueChanged(), enyo.Signals.send("changeZoomTool", this);
},
rendered: function() {
this.inherited(arguments), this.initAchtergrond();
},
redrawImage: function() {
this.getBAchtergrond() ? (this.calculatedWidth = parseInt(window.settings.STAGEWIDTH * window.settings.SCALE), this.calculatedHeight = parseInt(window.settings.STAGEHEIGHT * window.settings.SCALE), this.calculatedPosX = 0, this.calculatedPosY = 0) : (this.calculatedWidth = parseInt(this.getWidth() * window.settings.SCALE), this.calculatedHeight = parseInt(this.getHeight() * window.settings.SCALE), this.calculatedPosX = this.getPosition_x() * window.settings.SCALE + .5 >> 0, this.calculatedPosY = this.getPosition_y() * window.settings.SCALE + .5 >> 0), this.render();
},
changeZoomImageHandler: function(e, t) {
this.setProperty("src", Settings.WEBAPP + "/" + this.zoomSteps[t].split("&zoom=")[0]), this.render();
},
valueChanged: function() {
this.getValue() !== null && (this.getValue().value !== undefined ? this.setProperty("src", Settings.WEBAPP + "/" + this.getValue().value) : this.getValue() == "svnAssets/imagetemplate.png" ? this.setProperty("src", Settings.WEBAPP + "/" + this.getValue()) : this.getValue() != "" && this.setProperty("src", Settings.WEBAPP + "/" + this.zoomSteps[0].split("&zoom=")[0]), this.render());
},
initAchtergrond: function() {
this.setLocked(this.getBAchtergrond()), this.addOption("background", this.getBAchtergrond()), this.addRemoveClass("background", this.getBAchtergrond()), this.bubble("objectLockChange", this);
},
resizeComponent: function() {
this.redrawImage();
}
});

// KolomWoorden.js

enyo.kind({
name: "educate.components.kolomOefening.KolomWoorden",
kind: "educate.components.ObjectInterface",
tag: "div",
published: {
carrier: window.settings.CARRIERS.KOLOMWOORDEN,
linked: "",
placedObjects: [],
placedWordObjects: [],
totalObjectsWidth: [],
addedOffset: [],
getSolution: !1,
ifFromCreate: !1
},
handlers: {
onup: "removeDrag",
checkKolomOefening: "checkKolomOefeningHandler"
},
create: function() {
this.inherited(arguments), this.placeIcon();
var e = JSON.parse(this.splitCols);
for (var t = 0; t < this.columns; t++) {
this.placedObjects[t] = 0, this.addedOffset[t] = 0, this.totalObjectsWidth[t] = 0, this.placedWordObjects[t] = "";
if (e[t]) for (var n = 0; n < e[t].splits; n++) this.placedObjects[t + "/" + n] = 0, this.addedOffset[t + "/" + n] = 0, this.totalObjectsWidth[t + "/" + n] = 0, this.placedWordObjects[t + "/" + n] = "";
}
},
rendered: function() {
this.inherited(arguments);
},
placeIcon: function() {
this.$.pp_icon.setSrc(Settings.WEBAPP + "/svnAssets/p&p_icon.png");
},
redrawPicker: function(e) {
e == "create" && (this.ifFromCreate = !0), this.calculatedWidth = parseInt(this.getWidth() * window.settings.SCALE), this.calculatedHeight = parseInt(this.getHeight() * window.settings.SCALE), this.calculatedPosX = this.getPosition_x() * window.settings.SCALE + .5 >> 0, this.calculatedPosY = this.getPosition_y() * window.settings.SCALE + .5 >> 0, this.render();
},
resizeComponent: function() {
this.calculatedHeight = parseInt(this.getHeight() * window.settings.SCALE), this.calculatedWidth = parseInt(this.getWidth() * window.settings.SCALE), this.calculatedPosX = this.getPosition_x() * window.settings.SCALE + .5 >> 0, this.calculatedPosY = this.getPosition_y() * window.settings.SCALE + .5 >> 0, this.render();
for (var e in this.$.wordList.$) {
var t = this.$.wordList.$[e];
t.calculatedWidth = parseInt(t.getWidth() * window.settings.SCALE), t.calculatedHeight = parseInt(t.getHeight() * window.settings.SCALE), t.calculatedPosX = t.getPosition_x() * window.settings.SCALE, t.calculatedPosY = t.getPosition_y() * window.settings.SCALE, t.render();
}
$("li.ColumnPickObj").css("font-size", .9 * window.settings.SCALE + "rem"), $("li.ColumnPickObj").css("line-height", .9 * window.settings.SCALE + "rem");
var n = $(".picker").height();
$(".splitPicker").css("height", n - 50 + "px");
},
removeDrag: function(e, t) {
if (!this.ifFromCreate) if (t.target.className == "wordList ori") {
var n, r = this.$.wordList.$;
for (var i in r) r[i].selectedObj && (n = r[i]), r[i].removeClass("removePointerEvents");
for (var s in this.placedWordObjects) this.placedWordObjects[s].indexOf(n.name) != -1 && (n.removeClass("draggable"), n.removeClass("ColumnPickObjCorrect"), n.removeClass("ColumnPickObjFalse"), n.checkCorrect = !1, n.selectedObj = !1, this.replaceObjectsInColumn(n.name, r, this.calculatedWidth, this.$["wordList_" + s].parent.eventNode.clientWidth, this.$["wordList_" + s].parent.eventNode.clientHeight));
$(document).off("mousemove");
} else if (t.target.className == "wordList") {
var o = t.target.attributes.indexNumber.value, r = this.$.wordList.$, u = JSON.parse(this.splitCols), a;
if (o.split("/")[1]) {
var f = parseInt(o.split("/")[0]), l = parseInt(o.split("/")[1]), c = f, h = 100 / this.columns, p = c + f * h, d = h / u[o.split("/")[0]].splits, v = p + d * l;
a = e.parent.calculatedWidth / 100 * v;
} else a = e.parent.calculatedWidth / 100 * (o * (101 / this.columns) + o * (1 / (o == 0 ? 1 : o)));
var m = t.target.clientHeight, g = t.target.clientWidth;
for (var i in r) {
if (r[i].selectedObj) {
r[i].checkCorrect && this.replaceObjectsInColumn(i, r, e.parent.calculatedWidth, t.target.clientWidth, t.target.clientHeight);
var y = m;
y -= this.addedOffset[o] * 40 * window.settings.SCALE, this.placedObjects[o] = this.placedObjects[o] + 1, this.totalObjectsWidth[o] + r[i].node.offsetWidth >= g && (this.placedObjects[o] = 1, this.addedOffset[o] = this.addedOffset[o] + (y < 65 * window.settings.SCALE ? 0 : 1), this.totalObjectsWidth[o] = 0), m -= this.addedOffset[o] * 40 * window.settings.SCALE, m >= 65 * window.settings.SCALE && (this.placedWordObjects[o] = this.placedWordObjects[o] + i + ";"), r[i].checkCorrect = !0, o.split("/")[1] ? (u[o.split("/")[0]].words[o.split("/")[1]].indexOf(r[i].word + ";") != -1 ? (r[i].correct = !0, this.getSolution && r[i].addClass("ColumnPickObjCorrect")) : (r[i].correct = !1, this.getSolution && r[i].addClass("ColumnPickObjFalse")), r[i].selectedObj = !1) : (this.words[o].indexOf(r[i].word + ";") != -1 ? (r[i].correct = !0, this.getSolution && r[i].addClass("ColumnPickObjCorrect")) : (r[i].correct = !1, this.getSolution && r[i].addClass("ColumnPickObjFalse")), r[i].selectedObj = !1), this.snapInPlace(a, m, g, r[i], o);
}
r[i].removeClass("removePointerEvents");
}
$(document).off("mousemove");
}
},
snapInPlace: function(e, t, n, r, i) {
if (t < 65 * window.settings.SCALE) {
var s = this;
$(this.$["messagebox" + i].hasNode()).slideDown("fast", function() {
var e = setTimeout(enyo.bind(s, "hideMessageBox", i), 2e3);
}), this.$["pickColumn_" + i].addClass("tooManyObjects"), r.removeClass("draggable"), r.removeClass("ColumnPickObjCorrect"), r.removeClass("ColumnPickObjFalse"), r.checkCorrect = !1, r.selectedObj = !1;
}
var o = r.node.offsetWidth, u = 10 * window.settings.SCALE;
r.calculatedPosX = e + this.totalObjectsWidth[i], i.split("/")[1] ? r.calculatedPosY = -20 - t : r.calculatedPosY = -10 - t, r.render(), r.position_x = r.calculatedPosX / window.settings.SCALE, r.position_y = r.calculatedPosY / window.settings.SCALE, $("li.ColumnPickObj").css("font-size", .9 * window.settings.SCALE + "rem"), $("li.ColumnPickObj").css("line-height", .9 * window.settings.SCALE + "rem"), this.totalObjectsWidth[i] = this.totalObjectsWidth[i] + o + u;
},
hideMessageBox: function(e) {
$(this.$["messagebox" + e].hasNode()).slideUp("fast"), this.$["pickColumn_" + e].removeClass("tooManyObjects");
},
replaceObjectsInColumn: function(e, t, n, r, i) {
for (var s in this.placedWordObjects) if (this.placedWordObjects[s].indexOf(e) != -1) {
var o = JSON.parse(this.splitCols), u;
if (s.split("/")[1]) {
var a = parseInt(s.split("/")[0]), f = parseInt(s.split("/")[1]), l = a, c = 100 / this.columns, h = l + a * c, p = c / o[s.split("/")[0]].splits, d = h + p * f;
u = n / 100 * d, i = $(".splitPicker .wordList").height(), r = $(".splitPicker .wordList").width();
} else u = n / 100 * (s * (101 / this.columns) + s * (1 / (s == 0 ? 1 : s))), i = this.$["wordList_" + s].parent.eventNode.clientHeight, r = this.$["wordList_" + s].parent.eventNode.clientWidth;
this.addedOffset[s] = 0, this.totalObjectsWidth[s] = 0;
var v = this.placedWordObjects[s].replace(e + ";", "");
this.placedWordObjects[s] = v, v = v.split(";");
for (var m = 0; m < v.length - 1; m++) {
var g = i, y = t[v[m]];
this.totalObjectsWidth[s] + y.node.offsetWidth >= r && (this.placedObjects[s] = 1, this.addedOffset[s] = this.addedOffset[s] + 1, this.totalObjectsWidth[s] = 0), g -= this.addedOffset[s] * 40 * window.settings.SCALE, this.snapInPlace(u, g, r, y, s);
}
}
},
checkKolomOefeningHandler: function(e, t) {
var n = this.$.wordList.$;
if (this.getSolution) {
for (var r in n) n[r].removeClass("ColumnPickObjCorrect"), n[r].removeClass("ColumnPickObjFalse");
this.getSolution = !1;
} else if (!this.getSolution) {
for (var r in n) n[r].checkCorrect && (n[r].correct ? (n[r].addClass("ColumnPickObjCorrect"), n[r].removeClass("ColumnPickObjFalse")) : (n[r].addClass("ColumnPickObjFalse"), n[r].removeClass("ColumnPickObjCorrect")));
this.getSolution = !0;
}
}
});

// KolomAfbeeldingen.js

enyo.kind({
name: "educate.components.kolomOefening.KolomAfbeeldingen",
kind: "educate.components.ObjectInterface",
tag: "div",
published: {
carrier: window.settings.CARRIERS.KOLOMAFBEELDINGEN,
linked: "",
placedObjects: [],
placedWordObjects: [],
totalObjectsWidth: [],
addedOffset: [],
getSolution: !1,
ifFromCreate: !1
},
handlers: {
onup: "removeDrag",
checkKolomOefening: "checkKolomOefeningHandler"
},
create: function() {
this.inherited(arguments), this.placeIcon();
for (var e = 0; e < this.columns; e++) this.placedObjects[e] = 0, this.addedOffset[e] = 0, this.totalObjectsWidth[e] = 0, this.placedWordObjects[e] = "";
},
rendered: function() {
this.inherited(arguments);
},
placeIcon: function() {
this.$.pp_icon.setSrc(Settings.WEBAPP + "/svnAssets/p&p_icon.png");
},
redrawPicker: function(e) {
e == "create" && (this.ifFromCreate = !0), this.calculatedWidth = parseInt(this.getWidth() * window.settings.SCALE), this.calculatedHeight = parseInt(this.getHeight() * window.settings.SCALE), this.calculatedPosX = this.getPosition_x() * window.settings.SCALE + .5 >> 0, this.calculatedPosY = this.getPosition_y() * window.settings.SCALE + .5 >> 0, this.render();
},
resizeComponent: function() {
this.calculatedHeight = parseInt(this.getHeight() * window.settings.SCALE), this.calculatedWidth = parseInt(this.getWidth() * window.settings.SCALE), this.calculatedPosX = this.getPosition_x() * window.settings.SCALE + .5 >> 0, this.calculatedPosY = this.getPosition_y() * window.settings.SCALE + .5 >> 0, this.render();
for (var e in this.$.wordList.$) {
var t = this.$.wordList.$[e];
t.calculatedWidth = parseInt(t.getWidth() * window.settings.SCALE), t.calculatedHeight = parseInt(t.getHeight() * window.settings.SCALE), t.calculatedPosX = t.getPosition_x() * window.settings.SCALE, t.calculatedPosY = t.getPosition_y() * window.settings.SCALE, t.render();
}
$("li.ColumnPickObj").css("font-size", .9 * window.settings.SCALE + "rem"), $("li.ColumnPickObj").css("line-height", .9 * window.settings.SCALE + "rem");
},
removeDrag: function(e, t) {
if (!this.ifFromCreate) if (t.target.className == "ori imageList") {
var n, r = this.$.wordList.$;
for (var i in r) r[i].selectedObj && (n = r[i]), r[i].removeClass("removePointerEvents");
for (var s in this.placedWordObjects) this.placedWordObjects[s].indexOf(n.name) != -1 && (n.setOriginalSize(), n.removeClass("draggable"), n.removeClass("ColumnPickObjCorrect"), n.removeClass("ColumnPickObjFalse"), n.checkCorrect = !1, n.selectedObj = !1, this.replaceObjectsInColumn(n.name, r, this.calculatedWidth, this.$["wordList_" + s].parent.eventNode.clientWidth, this.$["wordList_" + s].parent.eventNode.clientHeight));
$(document).off("mousemove");
} else if (t.target.className == "wordList") {
var o = t.target.attributes.indexNumber.value, r = this.$.wordList.$, u = e.parent.calculatedWidth / 100 * o * (101 / this.columns), a = t.target.clientHeight, f = t.target.clientWidth;
for (var i in r) {
if (r[i].selectedObj) {
r[i].checkCorrect && this.replaceObjectsInColumn(i, r, e.parent.calculatedWidth, t.target.clientWidth, t.target.clientHeight);
var l = a;
l -= this.addedOffset[o] * 40 * window.settings.SCALE, this.placedObjects[o] = this.placedObjects[o] + 1, this.totalObjectsWidth[o] + r[i].node.offsetWidth >= f && (this.placedObjects[o] = 1, this.addedOffset[o] = this.addedOffset[o] + (l < 65 * window.settings.SCALE ? 0 : 1), this.totalObjectsWidth[o] = 0);
var c = r[i].node.clientHeight;
a -= this.addedOffset[o] * c * window.settings.SCALE, a >= 65 * window.settings.SCALE && (this.placedWordObjects[o] = this.placedWordObjects[o] + i + ";"), r[i].checkCorrect = !0, this.words[o].indexOf(r[i].word + ";") != -1 ? (r[i].correct = !0, this.getSolution && (r[i].addClass("ColumnPickObjCorrect"), r[i].$.icon.removeClass("fill-icon fill-icon-delete"), r[i].$.icon.addClass("fill-icon icon-ok"))) : (r[i].correct = !1, this.getSolution && (r[i].addClass("ColumnPickObjFalse"), r[i].$.icon.removeClass("fill-icon icon-ok"), r[i].$.icon.addClass("fill-icon fill-icon-delete"))), r[i].selectedObj = !1, this.snapInPlace(u, a, f, r[i], o);
}
r[i].removeClass("removePointerEvents");
}
$(document).off("mousemove");
}
},
snapInPlace: function(e, t, n, r, i) {
if (t < 65 * window.settings.SCALE) {
var s = this;
$(this.$["messagebox" + i].hasNode()).slideDown("fast", function() {
var e = setTimeout(enyo.bind(s, "hideMessageBox", i), 2e3);
}), this.$["pickColumn_" + i].addClass("tooManyObjects"), r.removeClass("draggable"), r.removeClass("ColumnPickObjCorrect"), r.removeClass("ColumnPickObjFalse"), r.checkCorrect = !1, r.selectedObj = !1;
}
var o = r.node.offsetWidth, u = 10 * window.settings.SCALE;
r.calculatedPosX = e + this.totalObjectsWidth[i], r.calculatedPosY = 40 - t, r.render(), r.position_x = r.calculatedPosX / window.settings.SCALE, r.position_y = r.calculatedPosY / window.settings.SCALE, $("li.ColumnPickObj").css("font-size", .9 * window.settings.SCALE + "rem"), $("li.ColumnPickObj").css("line-height", .9 * window.settings.SCALE + "rem"), this.totalObjectsWidth[i] = this.totalObjectsWidth[i] + o + u;
},
hideMessageBox: function(e) {
$(this.$["messagebox" + e].hasNode()).slideUp("fast"), this.$["pickColumn_" + e].removeClass("tooManyObjects");
},
replaceObjectsInColumn: function(e, t, n, r, i) {
for (var s in this.placedWordObjects) if (this.placedWordObjects[s].indexOf(e) != -1) {
var o = n / 100 * s * (101 / this.columns);
this.addedOffset[s] = 0, this.totalObjectsWidth[s] = 0;
var u = this.placedWordObjects[s].replace(e + ";", "");
this.placedWordObjects[s] = u, u = u.split(";");
for (var a = 0; a < u.length - 1; a++) {
var f = i, l = t[u[a]];
this.totalObjectsWidth[s] + l.node.offsetWidth >= r && (this.placedObjects[s] = 1, this.addedOffset[s] = this.addedOffset[s] + 1, this.totalObjectsWidth[s] = 0);
var c = l.node.clientHeight + 15;
f -= this.addedOffset[s] * c * window.settings.SCALE, this.snapInPlace(o, f, r, l, s);
}
}
},
checkKolomOefeningHandler: function(e, t) {
var n = this.$.wordList.$;
if (this.getSolution) {
for (var r in n) n[r].removeClass("ColumnPickObjCorrect"), n[r].removeClass("ColumnPickObjFalse"), n[r].$.icon.removeClass("fill-icon fill-icon-delete"), n[r].$.icon.removeClass("fill-icon icon-ok");
this.getSolution = !1;
} else if (!this.getSolution) {
for (var r in n) n[r].checkCorrect && (n[r].correct ? (n[r].addClass("ColumnPickObjCorrect"), n[r].removeClass("ColumnPickObjFalse"), n[r].$.icon.removeClass("fill-icon fill-icon-delete"), n[r].$.icon.addClass("fill-icon icon-ok")) : (n[r].addClass("ColumnPickObjFalse"), n[r].removeClass("ColumnPickObjCorrect"), n[r].$.icon.removeClass("fill-icon icon-ok"), n[r].$.icon.addClass("fill-icon fill-icon-delete")));
this.getSolution = !0;
}
}
});

// PickWordObject.js

enyo.kind({
name: "educate.components.kolomOefening.PickWordObject",
kind: "educate.components.ObjectInterface",
tag: "li",
classes: "ColumnPickObj",
published: {
width: 100,
height: 17,
position_x: 0,
position_y: 0,
word: "",
selectedObj: !1,
checkCorrect: !1,
correct: !1
},
handlers: {
ondown: "pickObject"
},
create: function() {
this.inherited(arguments), this.calculatedWidth = parseInt(this.getWidth() * window.settings.SCALE), this.calculatedHeight = parseInt(this.getHeight() * window.settings.SCALE), this.calculatedPosX = this.getPosition_x() * window.settings.SCALE + .5 >> 0, this.calculatedPosY = this.getPosition_y() * window.settings.SCALE + .5 >> 0, this.setContent(this.word), this.render();
},
rendered: function() {
this.inherited(arguments);
},
pickObject: function() {
this.selectedObj = !0, this.removeClass("ColumnPickObjCorrect"), this.removeClass("ColumnPickObjFalse"), $(document).on("mousemove", enyo.bind(this, "dragObjectMuisEvent")), document.ontouchmove = enyo.bind(this, "dragObject");
},
dragObjectMuisEvent: function(e) {
e.touches = [ {
clientX: e.clientX,
clientY: e.clientY
} ], this.dragObject(e, null);
},
dragObject: function(e, t) {
this.inherited(arguments), this.addClass("draggable"), this.addClass("removePointerEvents");
for (var n in this.parent.$) this.parent.$[n].addClass("removePointerEvents");
var r = parseInt($(".stage").css("margin-left").replace("px", "")), i = parseInt($(".stage").css("margin-top").replace("px", "")), s = $(".columnFrame").height();
e.touches[0].clientX != undefined && (this.oldClientX = e.touches[0].clientX, this.oldClientY = e.touches[0].clientY), this.position_x = this.oldClientX - r - 40, this.position_y = this.oldClientY - i - s / 100 * 60 - 50, this.calculatedPosX = this.position_x, this.calculatedPosY = this.position_y, this.render(), $("li.ColumnPickObj").css("font-size", .9 * window.settings.SCALE + "rem"), $("li.ColumnPickObj").css("line-height", .9 * window.settings.SCALE + "rem");
}
});

// PickImageObject.js

enyo.kind({
name: "educate.components.kolomOefening.PickImageObject",
kind: "educate.components.ObjectInterface",
tag: "li",
classes: "ColumnPickObjImage",
published: {
width: 100,
height: 17,
position_x: 0,
position_y: 0,
word: "",
selectedObj: !1,
checkCorrect: !1,
correct: !1,
oriWidth: 0
},
style: "",
handlers: {
ondown: "pickObject",
onenter: "onMouseOver"
},
components: [ {
tag: "img",
name: this.word,
style: "width: 100%;position: relative;margin-left: 0px;display: block;"
}, {
name: "icon",
tag: "i",
classes: ""
} ],
create: function() {
this.inherited(arguments), this.calculatedWidth = parseInt(this.getWidth() * window.settings.SCALE), this.calculatedHeight = parseInt(this.getHeight() * window.settings.SCALE), this.calculatedPosX = this.getPosition_x() * window.settings.SCALE + .5 >> 0, this.calculatedPosY = this.getPosition_y() * window.settings.SCALE + .5 >> 0, this.oriWidth = this.calculatedWidth, this.$.control.setProperty("src", Settings.WEBAPP + "/" + this.word), this.render();
},
rendered: function() {
this.inherited(arguments);
},
pickObject: function() {
this.selectedObj = !0, this.removeClass("ColumnPickObjCorrect"), this.removeClass("ColumnPickObjFalse");
var e = ($(".picker").width() - 20) / window.settings.SCALE;
this.width = e, this.calculatedWidth = parseInt(this.getWidth() * window.settings.SCALE), this.calculateImageWidth(), $(document).on("mousemove", enyo.bind(this, "dragObjectMuisEvent")), document.ontouchmove = enyo.bind(this, "dragObject");
},
dragObjectMuisEvent: function(e) {
e.touches = [ {
clientX: e.clientX,
clientY: e.clientY
} ], this.dragObject(e, null);
},
dragObject: function(e, t) {
this.inherited(arguments), this.addClass("draggable"), this.addClass("removePointerEvents");
for (var n in this.parent.$) this.parent.$[n].addClass("removePointerEvents");
var r = parseInt($(".stage").css("margin-left").replace("px", "")), i = parseInt($(".stage").css("margin-top").replace("px", "")), s = $(".columnFrame").height();
e.touches[0].clientX != undefined && (this.oldClientX = e.touches[0].clientX, this.oldClientY = e.touches[0].clientY), this.position_x = this.oldClientX - r - 40, this.position_y = this.oldClientY - i - s / 100 * 60 - 50, this.calculatedPosX = this.position_x, this.calculatedPosY = this.position_y, this.render(), $("li.ColumnPickObj").css("font-size", .9 * window.settings.SCALE + "rem"), $("li.ColumnPickObj").css("line-height", .9 * window.settings.SCALE + "rem");
},
calculateImageWidth: function() {
var e = ($(".picker").height() - $(".quizTypes").height()) / 2 - 25;
this.render();
do this.width = this.width - 5, this.calculatedWidth = parseInt(this.getWidth() * window.settings.SCALE), this.render(); while (this.node.clientHeight >= e);
},
setOriginalSize: function() {
this.width = this.oriWidth, this.calculatedWidth = parseInt(this.getWidth() * window.settings.SCALE), this.render();
},
onMouseOver: function(e, t) {
this.bubble("setImageDetail", {
image: e.tag == "li" ? Settings.WEBAPP + "/" + e.word : e.src
});
}
});

// ColumnExercise.js

enyo.kind({
name: "educate.components.columnExercise.ColumnExercise",
kind: "educate.components.ObjectInterface",
published: {
carrier: window.settings.CARRIERS.COLUMN_WORDS,
optionList: [],
columns: [],
optionListHeader: "Klik om aan te passen"
},
components: [ {
kind: "educate.components.columnExercise.ColumnHolder",
name: "columns",
columns: this.columns,
viewId: this.viewId
}, {
kind: "educate.components.columnExercise.OptionContainer",
name: "options",
options: this.optionList,
viewId: this.viewId
} ],
handlers: {
onColumnsChanged: "onColumnsChangedHandler"
},
classes: "column-exercise",
create: function() {
this.inherited(arguments), this.optionsChanged();
},
downHandler: function() {
return !0;
},
resizeComponent: function() {
this.inherited(arguments), this.applyStyle("font-size", window.settings.SCALE * window.settings.FONTSIZE + "px"), this.$.options.resizeComponent && this.$.options.resizeComponent(), this.$.columns.resizeComponent && this.$.columns.resizeComponent();
},
onColumnsChangedHandler: function() {
this.setColumns(this.$.columns.getColumns());
},
columnsChanged: function() {
this.inherited(arguments);
if (typeof this.columns == "undefined") return;
this.$.columns.setColumns(this.getColumns()), this.options.columns = this.getColumns(), this.render();
},
optionListChanged: function() {
this.inherited(arguments), typeof this.$.options != "undefined" && this.$.options.setOptions(this.getOptionList());
},
optionListHeaderChanged: function() {
this.inherited(arguments), typeof this.$.options != "undefined" && this.$.options.setHeader(this.getOptionListHeader()), this.options.optionListHeader = this.optionListHeader;
},
optionsChanged: function(e) {
this.inherited(arguments), this.optionListHeader = this.options.optionListHeader || "Klik om aan te passen", this.optionList = this.options.optionList, this.columns = this.options.columns, this.optionListHeaderChanged(), this.optionListChanged(), this.columnsChanged(), this.render();
}
});

// ColumnHolder.js

enyo.kind({
name: "educate.components.columnExercise.ColumnHolder",
kind: enyo.Control,
published: {
columns: [],
viewId: null
},
classes: "column-columns-holder",
create: function() {
this.inherited(arguments), this.columnsChanged();
},
columnsChanged: function() {
this.inherited(arguments), this.destroyComponents(), this.destroyClientControls();
var e, t = this.getColumns().length, n = [];
for (e = 0; e < t; e++) {
var r = this.getColumns()[e];
n.push({
kind: "educate.components.columnExercise.Column",
name: "column_" + e,
header: r.header,
options: r.options,
contents: r.contents,
groupedBy: r.groupedBy
});
}
this.createComponents(n), this.owner.setColumns(this.getColumns());
}
});

// OptionContainer.js

enyo.kind({
name: "educate.components.columnExercise.OptionContainer",
kind: enyo.Control,
classes: "column-options column-column",
published: {
header: "Klik om aan te passen",
options: [],
viewId: null
},
components: [ {
name: "header",
classes: "column-header",
tag: "h1",
content: this.header
}, {
name: "container",
classes: "column-content"
} ],
create: function() {
this.inherited(arguments), this.headerChanged();
},
headerChanged: function() {
this.$.header.setContent(this.header);
},
addOption: function(e) {
this.options.push(e), this.optionsChanged();
},
removeOption: function(e) {
var t = this.options.indexOf(e);
if (t === -1) return;
this.options.splice(t, 1), this.optionsChanged();
}
});

// Column.js

enyo.kind({
name: "educate.components.columnExercise.Column",
kind: enyo.Control,
published: {
header: "Klik om aan te passen.",
options: [],
contents: [],
groupedBy: "",
viewId: null
},
components: [ {
name: "header",
classes: "column-header",
tag: "h1",
content: this.header
}, {
name: "container",
classes: "column-content"
} ],
classes: "column-column",
create: function() {
this.inherited(arguments), this.contentsChanged(), this.headerChanged(), this.groupedByChanged();
},
headerChanged: function() {
this.$.header.setContent(this.header);
},
contentsChanged: function() {
this.inherited(arguments), this.$.container.destroyComponents();
var e, t = this.getContents().length, n = [];
for (e = 0; e < t; e++) {
var r = this.getContents()[e];
n.push({
tag: "div",
name: "content-" + e,
content: r.content
});
}
this.$.container.createComponents(n), this.render();
},
addOption: function(e) {
this.options.push(e), this.optionsChanged();
},
removeOption: function(e) {
var t = this.options.indexOf(e);
if (t === -1) return;
this.options.splice(t, 1), this.optionsChanged();
},
groupedByChanged: function() {
var e = this.owner.name === "columns" ? this.owner : this.owner.owner, t = this.owner;
if (typeof this.groupedBy == "undefined" || this.groupedBy === null || this.groupedBy === "") {
if (this.owner === e) return;
this.owner.removeChild(this), e.addChild(this), this.setOwner(e), t.$.container.children.length === 0 && t.destroy(), e.render(), this.bubble("onchange");
return;
}
var n = this.groupedBy.toLowerCase().replace(/\s+/g, "_");
if (this.owner.name !== n) {
var r;
typeof e.$[n] == "undefined" ? (r = e.createComponent({
name: n,
classes: "column-group"
}), r.createComponents([ {
name: "header",
classes: "column-header",
tag: "h1",
content: this.groupedBy
}, {
name: "container",
classes: "column-content"
} ], {
owner: r
})) : r = e.$[n], this.owner.removeChild(this), r.$.container.addChild(this), this.setOwner(r), t.$.container && t.$.container.children.length === 0 && t.destroy(), e.render(), this.bubble("onchange");
}
}
});

// Flipcard.js

enyo.kind({
name: "educate.components.flipcard.Flipcard",
kind: "educate.components.ObjectInterface",
classes: "flip-component",
published: {
carrier: window.settings.CARRIERS.FLIPCARD,
autoWidth: !1,
position_x: 300,
position_y: 200,
width: 400,
height: 250,
currentBackSide: "",
backText: "",
backImage: "",
flipped: !1
},
handlers: {},
components: [ {
tag: "div",
classes: "flip-container",
ontap: "doFlip",
components: [ {
tag: "div",
name: "flipper",
classes: "flipper",
components: [ {
tag: "div",
name: "front",
classes: "front",
components: [ {
tag: "p",
name: "frontTitle",
classes: "frontTitle",
content: "?"
} ]
}, {
tag: "div",
name: "back",
classes: "back",
components: [ {
tag: "p",
name: "backTitle",
classes: "backTitle",
content: "Default"
}, {
tag: "img",
name: "backImage",
classes: "backImage"
} ]
} ]
} ]
}, {
tag: "p",
name: "backTitleWidth",
classes: "backTitle",
style: "position: absolute;top: -1210px;z-index: -999999;left: -745px;",
content: "Default"
} ],
create: function() {
this.inherited(arguments), this.redraw();
},
rendered: function() {
this.inherited(arguments), $("#" + this.id + "_front").css("line-height", this.calculatedHeight + "px");
},
initEventsReactiesOptions: function() {
this.inherited(arguments), this.getReactieOptions().FLIP = {
label: "flip",
action: "doFlip"
};
},
setFlipSpeed: function(e) {
this.$.front.applyStyle("transition", e + "s"), this.$.front.applyStyle("-moz-transition", e + "s"), this.$.front.applyStyle("-o-transition", e + "s"), this.$.front.applyStyle("-ms-transition", e + "s"), this.$.back.applyStyle("transition", e + "s"), this.$.back.applyStyle("-moz-transition", e + "s"), this.$.back.applyStyle("-o-transition", e + "s"), this.$.back.applyStyle("-ms-transition", e + "s");
},
changeBackSide: function() {
switch (this.currentBackSide) {
case "Tekst":
this.$.backImage.hide(), this.$.backTitle.show(), this.$.backTitle.setContent(this.backText), this.$.backTitleWidth.setContent(this.backText), this.setAutoWidth();
break;
case "Afbeelding":
this.$.backTitle.hide(), this.$.backImage.show(), this.$.backImage.setSrc(Settings.WEBAPP + "/" + this.backImage);
break;
default:
console.log("Something went wrong");
}
},
setAutoWidth: function() {
if (isNaN(this.getWidth()) || this.autoWidth) {
this.autoWidth = !0;
var e = this.$.backTitleWidth.id;
this.setWidth($("#" + e).width());
}
this.calculatedWidth = parseInt(this.getWidth() * window.settings.SCALE);
},
resizeComponent: function() {
this.redraw();
},
resizeBorder: function() {
var e = window.settings.SCALE * 4 + .5 >> 0;
e = e <= 4 ? e : 4, this.$.front.applyStyle("border-width", e + "px"), this.$.back.applyStyle("border-width", e + "px");
},
redraw: function() {
this.setAutoWidth(), this.calculatedHeight = parseInt(this.getHeight() * window.settings.SCALE * window.settings.FONTSIZEPROCENT), this.calculatedPosX = this.getPosition_x() * window.settings.SCALE + .5 >> 0, this.calculatedPosY = this.getPosition_y() * window.settings.SCALE + .5 >> 0, this.currentBackSide == "Tekst" ? (this.$.frontTitle.applyStyle("font-size", 1.5 * window.settings.SCALE + "rem"), this.$.backTitle.applyStyle("font-size", 1 * window.settings.SCALE + "rem"), this.$.backTitle.applyStyle("line height", this.calculatedHeight / 2 + "px"), this.$.back.applyStyle("line-height", this.calculatedHeight + "px")) : this.currentBackSide == "Afbeelding" && this.$.frontTitle.applyStyle("font-size", 3 * window.settings.SCALE + "rem"), this.resizeBorder(), this.render();
}
});

// Website.js

enyo.kind({
name: "educate.components.website.Website",
kind: "educate.components.ObjectInterface",
published: {
carrier: window.settings.CARRIERS.WEBSITE
},
handlers: {},
create: function() {
this.inherited(arguments), this.resizeComponent();
},
rendered: function() {
this.inherited(arguments);
},
setUrl: function() {
this.$.iframe.setSrc(this.url);
},
resizeComponent: function() {
this.calculatedWidth = parseInt(this.getWidth() * window.settings.SCALE), this.calculatedHeight = parseInt(this.getHeight() * window.settings.SCALE * window.settings.FONTSIZEPROCENT), this.calculatedPosX = this.getPosition_x() * window.settings.SCALE + .5 >> 0, this.calculatedPosY = this.getPosition_y() * window.settings.SCALE + .5 >> 0, this.render();
}
});

// Map.js

enyo.kind({
name: "educate.components.map.Map",
kind: "educate.components.ObjectInterface",
tag: "div",
classes: "map",
published: {
carrier: window.settings.CARRIERS.MAP,
tmpX: 0,
tmpY: 0,
map: "",
geocoder: "",
infowindow: "",
marker: "",
adres: "",
bHuidigeLocatie: !1,
mapType: ""
},
components: [ {
tag: "div",
name: "mapCanvas",
classes: "map-canvas"
} ],
constructor: function() {
this.inherited(arguments), this.setOptions({});
},
create: function() {
this.inherited(arguments), this.addClass("map" + this.getObjectId()), this.render(), this.redrawMap();
},
rendered: function() {
this.inherited(arguments), this.map == "" && this.initialize(), this.redrawMap();
},
optionsChanged: function() {
this.optionsInladen();
},
optionsInladen: function() {
this.setAdres(this.options.adres != undefined ? this.options.adres : ""), this.setBHuidigeLocatie(this.options.isHuidigeLocatie != undefined ? this.options.isHuidigeLocatie === !0 : !1), this.setMapType(this.options.mapType != undefined ? this.options.mapType : "roadmap");
},
bHuidigeLocatieChanged: function() {
this.getBHuidigeLocatie() ? this.showHuidigeLocatie() : (this.marker != "" && this.clearMarker(), this.infowindow != "" && this.infowindow.close());
},
convertMapTypeStringToMapType: function() {
var e;
switch (this.getMapType()) {
case "roadmap":
e = google.maps.MapTypeId.ROADMAP;
break;
case "satellite":
e = google.maps.MapTypeId.SATELLITE;
break;
case "hybrid":
e = google.maps.MapTypeId.HYBRID;
break;
case "terrain":
e = google.maps.MapTypeId.TERRAIN;
break;
default:
e = google.maps.MapTypeId.ROADMAP;
}
return e;
},
initialize: function() {
this.geocoder = new google.maps.Geocoder, this.infowindow = new google.maps.InfoWindow;
var e = {
center: new google.maps.LatLng(51, 3),
mapTypeId: this.convertMapTypeStringToMapType(),
zoom: 8
};
this.map = new google.maps.Map(this.$.mapCanvas.hasNode(), e), this.zoekLocatieOpMap();
},
zoekLocatieOpMap: function() {
this.getBHuidigeLocatie() ? this.showHuidigeLocatie() : this.getAdres() != "" && this.showLocationByAddress(this.getAdres());
},
showLocationByAddress: function(e) {
var t = this;
this.geocoder.geocode({
address: e
}, function(n, r) {
r == google.maps.GeocoderStatus.OK ? (t.map.setCenter(n[0].geometry.location), t.marker != "" && t.clearMarker(), t.marker = new google.maps.Marker({
map: t.map,
position: n[0].geometry.location
}), t.marker.set("location", n[0].geometry.location), t.map.setZoom(15), google.maps.event.addListener(t.marker, "click", function() {
t.infowindow && t.infowindow.close(), t.infowindow.open(t.map, t.marker), t.infowindow.setContent(e);
})) : r === "ZERO_RESULTS" ? (t.marker != "" && t.clearMarker(), t.infowindow && t.infowindow.close(), t.map.setZoom(3)) : console.log("Geocode was not successful for the following reason: " + r);
});
},
showHuidigeLocatie: function() {
if (navigator.geolocation) {
var e = this;
navigator.geolocation.getCurrentPosition(function(t) {
var n = new google.maps.LatLng(t.coords.latitude, t.coords.longitude);
e.infowindow && e.infowindow.close(), e.infowindow.setPosition(n), e.infowindow.setContent("U bevindt zich hier!"), e.infowindow.open(e.map), e.map.setCenter(n), e.map.setZoom(15);
}, function() {
e.handleNoGeolocation(!0);
});
} else this.handleNoGeolocation(!1);
},
handleNoGeolocation: function(e) {
e ? console.log("Error: The Geolocation service failed.") : console.log("Error: Your browser doesn't support geolocation.");
},
clearMarker: function() {
this.marker.setMap(null);
},
dragObjectHandler: function(e) {
this.tmpX = e.clientX - $(this.parent.hasNode()).offset().left - this.getClickX(), this.tmpY = e.clientY - $(this.parent.hasNode()).offset().top - this.getClickY(), $(".map" + this.getObjectId()).css({
left: this.tmpX,
top: this.tmpY
});
},
upHandler: function() {
$(document).off("mousemove"), $(document).off("mouseup"), this.setPosition_x(this.tmpX / window.settings.SCALE + .5 >> 0), this.setPosition_y(this.tmpY / window.settings.SCALE + .5 >> 0), this.bubble("updateProperties", this);
},
resizeComponent: function() {
this.redrawMap();
},
redrawMap: function() {
this.tmpX = parseInt(this.position_x * window.settings.SCALE) + .5 >> "0px", this.tmpY = parseInt(this.position_y * window.settings.SCALE) + .5 >> "0px", $(".map" + this.getObjectId()).css({
height: parseInt(this.height * window.settings.SCALE) + "px",
width: parseInt(this.width * window.settings.SCALE) + "px",
left: this.tmpX,
top: this.tmpY
}), $(".map-canvas").css({
height: "100%",
width: "100%",
top: "0",
left: "0"
});
}
});

// Youtube.js

enyo.kind({
name: "educate.components.youtube.Youtube",
kind: "educate.components.ObjectInterface",
tag: "div",
classes: "youtubevideo",
published: {
carrier: window.settings.CARRIERS.YOUTUBE,
tmpX: 0,
tmpY: 0,
videoId: "",
videoUrl: ""
},
components: [ {
tag: "iframe",
name: "youtubePlayer",
classes: "youtube-player",
attributes: {
src: "//www.youtube.com/embed/"
}
} ],
constructor: function() {
this.inherited(arguments), this.setOptions({});
},
create: function() {
this.inherited(arguments), this.addClass("youtubevideo" + this.getObjectId()), this.render(), this.redrawVid();
},
rendered: function() {
this.inherited(arguments), this.initialize(), this.redrawVid();
},
optionsChanged: function() {
this.optionsInladen();
},
optionsInladen: function() {
this.setVideoId(this.options.videoId != undefined ? this.options.videoId : ""), this.setVideoUrl(this.options.videoUrl != undefined ? this.options.videoUrl : "");
},
initialize: function() {
this.getVideoId() != "" && this.loadYoutubeVideo(this.getVideoId());
},
loadYoutubeVideo: function(e) {
this.$.youtubePlayer.setAttribute("height", this.getHeight()), this.$.youtubePlayer.setAttribute("width", this.getWidth()), this.$.youtubePlayer.setAttribute("src", "//www.youtube.com/embed/" + e + "?enablejsapi=1");
},
dragObjectHandler: function(e) {
this.tmpX = e.clientX - $(this.parent.hasNode()).offset().left - this.getClickX(), this.tmpY = e.clientY - $(this.parent.hasNode()).offset().top - this.getClickY(), $(".youtubevideo" + this.getObjectId()).css({
left: this.tmpX,
top: this.tmpY
});
},
upHandler: function() {
$(document).off("mousemove"), $(document).off("mouseup"), this.setPosition_x(this.tmpX / window.settings.SCALE + .5 >> 0), this.setPosition_y(this.tmpY / window.settings.SCALE + .5 >> 0), this.bubble("updateProperties", this);
},
resizeComponent: function() {
this.redrawVid();
},
redrawVid: function() {
this.tmpX = parseInt(this.position_x * window.settings.SCALE) + .5 >> "0px", this.tmpY = parseInt(this.position_y * window.settings.SCALE) + .5 >> "0px", $(".youtubevideo" + this.getObjectId()).css({
height: parseInt(this.height * window.settings.SCALE) + "px",
width: parseInt(this.width * window.settings.SCALE) + "px",
left: this.tmpX,
top: this.tmpY
}), $(".youtube-player").css({
height: "100%",
width: "100%",
top: "0",
left: "0"
});
}
});

// 3DObject.js

enyo.kind({
name: "educate.components.3DObject.3DObject",
kind: "educate.components.ObjectInterface",
published: {
carrier: window.settings.CARRIERS.THREEDOBJECT,
meshObjects: [],
camera: [],
liveCameraPosition: [],
liveCameraCenter: [],
controls: [],
ground: [],
spotLight: [],
hemiLight: [],
scene: [],
renderer: undefined,
dae: [],
projector: [],
selectedObject: [],
objectToDrag: undefined,
intersected: [],
plane: [],
selectionBox: [],
transformControls: [],
offset: new THREE.Vector3,
mouse: new THREE.Vector2,
sceneInit: !1,
resizing: !1,
listItem: undefined
},
handlers: {},
create: function() {
this.inherited(arguments), this.resizeComponent();
},
rendered: function() {
this.inherited(arguments), this.init();
},
createMaterialList: function() {
if (this.fromCreate && !this.resizing) {
var e;
if (this.listItem == undefined) for (var t in this.owner.owner.$.lijstPanel.$) {
var n = this.owner.owner.$.lijstPanel.$[t];
n.linked != undefined && n.linked.kind == "educate.create.components.3DObject.3DObject" && (this.listItem = n, e = n);
} else e = this.listItem;
e.$[this.modelName + "%" + this.modelId] == undefined && (e.createComponent({
tag: "div",
classes: "zoneLijst",
style: "width: 100%;",
name: this.modelName + "%" + this.modelId,
components: [ {
tag: "p",
content: this.modelName + " - " + this.modelId,
style: "width: 90%;",
linked: this.dae,
tap: this.clickParentList,
parentInstance: this
}, {
tag: "div",
name: "delete%" + this.modelId,
classes: "lijstItemIcon icon-trash",
tap: this.deleteMaterial,
parentInstance: this,
style: "position:absolute;"
} ]
}, {
owner: this
}), e.createComponent({
tag: "ul",
classes: "zoneLijst",
style: "border: none!important;padding: 0px!important;",
name: "3DZoneList%" + this.modelId
}, {
owner: this
}), e.render());
}
},
deleteMaterialList: function() {
if (this.fromCreate) {
var e = this.owner.owner.$.lijstPanel.$.lijstitemObject;
for (var t = 0; t < e.children.length; t++) e.children[t].classes == "zoneLijst";
}
},
addMaterialToList: function(e) {
if (this.fromCreate && !this.resizing) {
var t = this.listItem, n = t.linked.$;
n["3DZoneList%" + this.modelId].createComponent({
tag: "li",
name: e.name,
content: e.name.split("%")[0],
classes: "zoneLijstItem",
linked: e,
parentInstance: this,
tap: this.clickMaterialList
}, {
owner: this
}), t.render();
}
},
deleteMaterial: function(e, t) {
var n = e.parentInstance, r = e.parent.parent, i = e.name.split("%")[1], s = 0, o = 0, u = n.getView();
for (var a in n.meshObjects) {
var f = n.meshObjects[a].owner;
f.name.split("%")[1] == i && (o == 0 && (s = a), o++, f.mesh.parent instanceof THREE.Object3D && n.scene.remove(f.mesh.parent), n.scene.remove(f.mesh), n.transformControls.detach(f.mesh), f.getDatabaseId() && u.addObjectToArrDeleted(f.getDatabaseId()), u.$[f.name].destroy(), u.deleteObjectInView(f), f.destroy());
}
for (var l = 0; l < r.children.length; l++) r.children[l].name.split("%")[1] == i && (r.children[l].destroy(), l--);
n.selectionBox.visible = !1, n.meshObjects.splice(s, o), n.modelUrls[i - 1] = "deleted", n.addOption("modelUrls", n.modelUrls), n.renderScene();
},
clickMaterialList: function(e, t) {
t.preventDefault();
var n = e.parentInstance, r = e.eventNode, i = r.parentNode, s = i.parentNode, o = n.listItem, u = o.linked.$;
for (var a in u) u[a].tag == "li" && $(u[a].eventNode).removeClass("open"), $(s).hasClass("open") && ($(e.eventNode).addClass("open"), n.bubble("threeDLayerSelected", e), n.selectedObject = e.linked, n.selectionBox.update(n.selectedObject.mesh), n.selectionBox.material.color.setRGB(1, 1, 0), n.selectionBox.visible = !0, n.transformControls.detach(), n.selectedObject.mesh instanceof THREE.PerspectiveCamera == 0 && n.transformControls.attach(n.selectedObject.mesh));
n.renderScene();
},
setMaterial: function(e, t) {
if (e instanceof THREE.Mesh == 1) {
var n = this.getView(), r = this.meshOptions[e.name + "%" + this.modelId];
if (r == undefined) {
var i = this.owner.createComponent({
container: n.$.panelMiddle,
kind: "educate.components.3DObject.3DMesh",
layername: e.name + "%" + this.modelId,
viewId: n.getViewId(),
objectId: n.countViewObjectsId(),
name: e.name + "%" + this.modelId,
visible: !0,
pPosX: e.position.x,
pPosY: e.position.y,
pPosZ: e.position.z,
pRotX: e.rotation.x,
pRotY: e.rotation.y,
pRotZ: e.rotation.z,
pScale: e.scale.x,
texture: "svnAssets/workareabg.png",
material: t,
mesh: e
});
i.setDatabaseId(""), this.fromCreate && (n.addLayer(i), this.bubble("onHideLayer", {
name: e.name + "%" + this.modelId
})), this.addChild(i), this.addMaterialToList(i);
} else {
var i = this.owner.meshes[r.objectId];
i.prepareMesh(r, e, t), this.addChild(i), this.addMaterialToList(i);
}
}
if (e.children) for (var s = 0; s < e.children.length; s++) this.setMaterial(e.children[s], t), this.meshObjects.push(e.children[s]);
},
updateLighting: function() {
this.spotLightOn ? (this.scene.add(this.spotLight), this.renderer.shadowMapEnabled = !0) : (this.scene.remove(this.spotLight), this.renderer.shadowMapEnabled = !1), this.hemiLightOn ? this.scene.add(this.hemiLight) : this.scene.remove(this.hemiLight), this.renderScene();
},
updateGround: function() {
this.groundOn ? this.scene.add(this.ground) : this.scene.remove(this.ground), this.renderScene();
},
updateControls: function(e, t, n) {
this.controls.noZoom = !e, this.controls.noRotate = !t, this.controls.noPan = !n;
},
updateControlLimits: function(e, t, n, r, i, s) {
this.controls.minPolarAngle = e / 180 * Math.PI, this.controls.maxPolarAngle = t / 180 * Math.PI, this.controls.minAzimuthalAngle = n / 180 * Math.PI, this.controls.maxAzimuthalAngle = r / 180 * Math.PI, this.controls.minDistance = i, this.controls.maxDistance = s;
},
renderScene: function() {
this.renderer.clear(), this.controls.update(), this.transformControls.update(), this.renderer.render(this.scene, this.camera);
},
init: function() {
for (var e in this.children) {
var t = this.children[e];
t.destroy();
}
this.meshObjects = [], this.selectedObject = null, this.container = document.getElementById("3dobj"), this.scene = new THREE.Scene, this.projector = new THREE.Projector, this.plane = new THREE.Mesh(new THREE.PlaneGeometry(500, 500, 75, 75), new THREE.MeshBasicMaterial({
color: 16711680,
wireframe: !0
})), this.plane.visible = !1, this.scene.add(this.plane), this.scene.add(this.dae), this.spotLight = new THREE.SpotLight(16777215, .6, 0, 1.5, 10), this.spotLight.position.set(200, 200, 200), this.spotLight.target.position.set(0, 0, 0), this.spotLight.castShadow = !0, this.spotLight.shadowCameraVisible = !0, this.spotLight.shadowCameraNear = 50, this.spotLight.shadowCameraFar = 2e3, this.spotLight.shadowMapWidth = 2048, this.spotLight.shadowMapHeight = 1024, this.spotLight.shadowCameraFov = 30, this.spotLight.shadowBias = 1e-4, this.spotLight.shadowDarkness = .8, this.spotLightOn && this.scene.add(this.spotLight), this.hemiLight = new THREE.HemisphereLight(16777215, 16777215, .4), this.hemiLight.color.setHSL(.6, 1, .75), this.hemiLight.groundColor.setHSL(.1, .8, .7), this.hemiLight.position.y = 500, this.hemiLightOn && this.scene.add(this.hemiLight);
var n = new THREE.PlaneGeometry(1e4, 1e4), r = new THREE.MeshPhongMaterial({
ambient: 16777215,
color: 16777215,
specular: 328965
});
this.ground = new THREE.Mesh(n, r), this.ground.rotation.x = -Math.PI / 2, this.ground.position.y = -7.5, this.groundOn && this.scene.add(this.ground), this.ground.receiveShadow = !0, this.camera = new THREE.PerspectiveCamera(45, this.calculatedWidth / this.calculatedHeight, .1, 5e3);
var i = JSON.parse(this.cameraPosition);
this.camera.position.set(i.x, i.y, i.z), this.controls = new THREE.OrbitControls(this.camera, $("#3dobj")[0]);
var s = JSON.parse(this.cameraCenter), o = new THREE.Vector3(s.x, s.y, s.z);
this.controls.target = o;
var u = this.getView();
if (u && !u.$["3DCamera"]) {
var a = u.createComponent({
container: u.$.panelMiddle,
kind: "educate.components.3DObject.3DCamera",
layername: "camera 3D",
viewId: u.getViewId(),
objectId: this.fromCreate ? u.countViewObjectsId() : "",
instance: this,
liveCameraCenter: this.controls.target,
liveCameraPosition: this.camera.position,
lockCamera: this.options.lockCamera,
rotateCamera: this.options.rotateCamera,
zoomCamera: this.options.zoomCamera,
panCamera: this.options.panCamera,
limitRotYMin: this.options.ymin,
limitRotYMax: this.options.ymax,
limitRotXMin: this.options.xmin,
limitRotXMax: this.options.xmax,
limitZoomMin: this.options.zoomMin,
limitZoomMax: this.options.zoomMax
});
this.fromCreate && u.addLayer(a), a.camPropertyChanged();
}
this.controls.noZoom = !this.options.zoomCamera, this.controls.noRotate = !this.options.rotateCamera, this.controls.noPan = !this.options.panCamera, this.controls.enabled = !0, this.controls.setLimits(this.options.zoomMin, this.options.zoomMax, this.options.ymin, this.options.ymax, this.options.xmin, this.options.xmax), this.renderer || (this.renderer = new THREE.WebGLRenderer({
antialias: !1,
alpha: !0
})), this.renderer.setSize(this.calculatedWidth, this.calculatedHeight), this.spotLightOn && (this.renderer.shadowMapEnabled = !0, this.renderer.shadowMapSoft = !0, this.renderer.shadowMapCullFrontFaces = !1), this.renderer.setClearColor(0, 0), this.container.appendChild(this.renderer.domElement), this.selectionBox = new THREE.BoxHelper, this.selectionBox.material.depthTest = !0, this.selectionBox.material.transparent = !0, this.selectionBox.visible = !1, this.scene.add(this.selectionBox);
var f = this;
this.transformControls = new THREE.TransformControls(this.camera, this.renderer.domElement), this.transformControls.addEventListener("change", function() {
f.renderScene();
}), this.scene.add(this.transformControls), $(document).on("mousemove", enyo.bind(this, "onDocumentMouseMove")), $("#3dobj").on("mouseup", enyo.bind(this, "onDocumentMouseUp")), $("#3dobj").on("mousedown", enyo.bind(this, "onDocumentMouseDown")), $("#3dobj").on("mousewheel", enyo.bind(this, "onDocumentMouseWheel")), this.renderScene();
},
addModelToScene: function() {
this.selectedObject = null;
var e = this;
Detector.webgl || Detector.addGetWebGLMessage();
var t = new THREE.ColladaLoader;
t.load(Settings.WEBAPP + "/" + e.modelUrl, function(n) {
e.dae = n.scene, e.createMaterialList(), e.dae.scale.x = e.dae.scale.y = e.dae.scale.z = 1, e.dae.updateMatrix();
if (e.modelUrl == "svnAssets/uploads/10_5343b07928f4a.dae") {
var r = new THREE.Mesh(new THREE.SphereGeometry(5, 100, 100));
r.name = "wereldbol", e.setMaterial(r, new THREE.MeshPhongMaterial({
map: THREE.ImageUtils.loadTexture(Settings.WEBAPP + "/svnAssets/workareabg.png"),
specular: 16777215,
emissive: 16777215,
shininess: 5
})), e.meshObjects.push(r), e.scene.add(r);
}
e.scene.add(e.dae), e.setMaterial(e.dae, new THREE.MeshPhongMaterial({
map: THREE.ImageUtils.loadTexture(Settings.WEBAPP + "/svnAssets/workareabg.png"),
specular: 16777215,
emissive: 16777215,
shininess: 5
})), e.renderScene(), e.loadOtherUrls();
});
},
onDocumentMouseDown: function(e) {
e.preventDefault(), e.stopImmediatePropagation();
var t = new THREE.Vector3(this.mouse.x, this.mouse.y, .5);
this.projector.unprojectVector(t, this.camera);
var n = new THREE.Raycaster(this.camera.position, t.sub(this.camera.position).normalize()), r = n.intersectObjects(this.meshObjects);
if (r.length > 0) {
var i = r[0].object;
if (!this.fromCreate && i.owner.actions.length > 0) for (var s = 0; s < i.owner.actions.length; s++) {
var o = i.owner.actions[s].value;
if (o == "KLIK") {
i.owner.ontapActionHandler();
break;
}
o == "DRAG" && (this.controls.enabled = !1, this.objectToDrag = i.owner);
}
}
this.renderScene();
},
onDocumentMouseMove: function(e) {
e.preventDefault();
if (this.objectToDrag) this.container.style.cursor = "move", this.objectToDrag.ondragActionHandler(), this.objectToDrag.pPosXChangedHandler && this.objectToDrag.pPosXChangedHandler(), this.objectToDrag.pPosYChangedHandler && this.objectToDrag.pPosYChangedHandler(); else {
var t = this.owner.$.panelConLeft != undefined ? this.owner.$.panelConLeft.node.clientWidth : 0;
this.mouse.x = (e.clientX - (this.calculatedPosX + t)) / this.calculatedWidth * 2 - 1, this.mouse.y = -((e.clientY - this.calculatedPosY) / this.calculatedHeight) * 2 + 1;
var n = new THREE.Vector3(this.mouse.x, this.mouse.y, .5);
this.projector.unprojectVector(n, this.camera);
var r = new THREE.Raycaster(this.camera.position, n.sub(this.camera.position).normalize()), i = r.intersectObjects(this.meshObjects);
if (i.length > 0) if (i[0].object.owner.actions.length > 0) {
if (this.intersected != i[0].object) {
this.intersected = i[0].object, this.plane.position.copy(this.intersected.position);
var s = this.controls.target.x - this.camera.position.x, o = this.controls.target.z - this.camera.position.z, u = new THREE.Vector3(this.intersected.position.x - s, this.intersected.position.y, this.intersected.position.z - o);
this.plane.lookAt(u);
}
this.container.style.cursor = "pointer";
} else this.container.style.cursor = "auto"; else this.intersected = null, this.container.style.cursor = "auto";
}
this.renderScene();
},
onDocumentMouseUp: function(e) {
e.preventDefault(), this.selectedObject && (this.selectedObject.pPosX = parseInt(this.selectedObject.mesh.position.x), this.selectedObject.pPosY = parseInt(this.selectedObject.mesh.position.y), this.selectedObject.pPosZ = parseInt(this.selectedObject.mesh.position.z), this.selectedObject.saveMeshOptions(), this.bubble("changeMeshPosition", this.selectedObject)), this.liveCameraPosition = this.camera.position, this.liveCameraCenter = this.controls.target, this.bubble("changeCameraPosition", this), this.controls.enabled = !0, this.objectToDrag = undefined, this.container.style.cursor = "auto", this.renderScene();
},
onDocumentMouseWheel: function(e) {
this.liveCameraPosition = this.camera.position, this.liveCameraCenter = this.controls.target, this.bubble("changeCameraPosition", this), this.renderScene();
},
resizeComponent: function() {
this.calculatedWidth = parseInt(this.getWidth() * window.settings.SCALE), this.calculatedHeight = parseInt(this.getHeight() * window.settings.SCALE), this.calculatedPosX = this.getPosition_x() * window.settings.SCALE + .5 >> 0, this.calculatedPosY = this.getPosition_y() * window.settings.SCALE + .5 >> 0, this.render(), this.sceneInit && (this.modelId = 0, this.newRendering = !0, this.loadFirstUrl(), this.resizing = !0);
}
});

// 3DMesh.js

enyo.kind({
name: "educate.components.3DObject.3DMesh",
kind: "educate.components.ActionHandler",
published: {
carrier: window.settings.CARRIERS.THREEDMESH,
name: "",
visible: !0,
pPosLimit: !1,
pPosX: 0,
pPosY: 0,
pPosZ: 0,
pRotX: 0,
pRotY: 0,
pRotZ: 0,
pScale: 0,
texture: "",
reaction: "",
options: "",
material: undefined,
mesh: undefined,
scaleX: 0
},
create: function() {
this.inherited(arguments), this.material != undefined && (this.setMeshMaterial(this.mesh), this.setMeshProperties(this.mesh)), this.initEventsReactiesOptions(), this.initLinkEigenschappenOptions();
},
rendered: function() {
this.inherited(arguments);
},
prepareMesh: function(e, t, n) {
this.name = e.name, this.visible = e.visible, this.pPosX = e.position_x, this.pPosY = e.position_y, this.pPosZ = e.position_z, this.pRotX = e.rotation_x, this.pRotY = e.rotation_y, this.pRotZ = e.rotation_z, this.pScale = e.pScale, this.texture = e.texture, this.mesh = t, this.material = n, this.setMeshMaterial(this.mesh), this.setMeshProperties(this.mesh), this.saveMeshOptions();
},
setMeshMaterial: function(e) {
var t = this;
e.material = this.material, e.material.map = THREE.ImageUtils.loadTexture(Settings.WEBAPP + "/" + this.texture, new THREE.UVMapping, function() {
t.parent.renderScene();
}), e.owner = this, this.saveMeshOptions();
},
setMeshProperties: function(e) {
e.visible = this.visible, e.limitPosition = this.pPosLimit, e.position.x = this.pPosX, e.position.y = this.pPosY, e.position.z = this.pPosZ, e.rotation.x = this.pRotX, e.rotation.y = this.pRotY, e.rotation.z = this.pRotZ, e.scale.x = e.scale.y = e.scale.z = this.pScale, e.reaction = this.reaction, this.saveMeshOptions();
},
saveMeshOptions: function() {
this.options || (this.options = {});
var e = {};
e.name = this.name, e.visible = this.visible, e.texture = this.texture, e.position_x = this.pPosX, e.position_y = this.pPosY, e.position_z = this.pPosZ, e.rotation_x = this.pRotX, e.rotation_y = this.pRotY, e.rotation_z = this.pRotZ, e.pScale = this.pScale, this.setOptions(e);
},
initEventsReactiesOptions: function() {
this.inherited(arguments), delete this.getReactieOptions().OPEN, delete this.getReactieOptions().CLOSE, delete this.getReactieOptions().TOGGLE_OPEN, this.getReactieOptions().SCALE = {
label: "schalen",
action: "scale"
};
},
initLinkEigenschappenOptions: function() {
this.setLinkEigenschappenOptions([ {
value: "novalue",
content: "Maak een keuze"
}, {
value: "pPosX",
content: "x positie"
}, {
value: "pPosY",
content: "y positie"
} ]);
},
makeVisible: function() {
this.mesh.visible = !0, this.parent.renderScene();
},
makeInvisible: function() {
this.mesh.visible = !1, this.parent.renderScene();
},
toggleVisible: function() {
this.mesh.visible = !this.mesh.visible, this.parent.renderScene();
},
move: function() {
this.parent.mouse.x = (event.clientX - this.parent.calculatedPosX) / this.parent.calculatedWidth * 2 - 1, this.parent.mouse.y = -((event.clientY - this.parent.calculatedPosY - $(".w" + this.getViewId()).offset().top) / this.parent.calculatedHeight) * 2 + 1;
var e = new THREE.Vector3(this.parent.mouse.x, this.parent.mouse.y, .5), t = new THREE.Projector;
t.unprojectVector(e, this.parent.camera);
var n = this.parent.camera.position, r = new THREE.Raycaster(n, e.sub(n).normalize()), i = r.intersectObject(this.parent.plane);
this.mesh.position.copy(i[0].point.sub(this.parent.offset)), this.pPosX = this.mesh.position.x, this.pPosY = -this.mesh.position.y;
},
rotate: function() {
this.mesh.rotation.x = event.clientY / 100 - 3, this.mesh.rotation.y = event.clientX / 150;
},
scale: function() {
var e = this.owner.$.panelConLeft != undefined ? this.owner.$.panelConLeft.node.clientWidth : 0, t = (event.clientX - (this.parent.calculatedPosX + e)) / this.parent.calculatedWidth * 2 - 1;
this.pScale > 0 ? t > this.scaleX ? this.pScale = this.pScale + .05 : t < this.scaleX && (this.pScale = this.pScale - .05) : this.pScale = .1, this.scaleX = t, this.mesh.scale.x = this.mesh.scale.y = this.mesh.scale.z = this.pScale;
},
resizeComponent: function() {
this.mesh && (this.mesh.position.x = this.pPosX, this.mesh.position.y = this.pPosY, this.mesh.position.z = this.pPosZ, this.mesh.rotation.x = this.pRotX, this.mesh.rotation.y = this.pRotY, this.mesh.rotation.z = this.pRotZ, this.parent.renderScene());
}
});

// 3DCamera.js

enyo.kind({
name: "educate.components.3DObject.3DCamera",
kind: "educate.components.ActionHandler",
handlers: {
changeCameraPosition: "changeCameraPositionHandler",
centerOnObject: "centerOnObjectHandler"
},
published: {
carrier: -1,
instance: undefined,
liveCameraCenter: [],
liveCameraPosition: [],
lockCamera: !1,
rotateCamera: !0,
zoomCamera: !0,
panCamera: !0,
limitRotYMin: 0,
limitRotYMax: 180,
limitRotXMin: -180,
limitRotXMax: 180,
limitZoomMin: 0,
limitZoomMax: 2e3,
disableActions: !0
},
create: function() {
this.inherited(arguments);
},
rendered: function() {
this.inherited(arguments);
},
changeCameraPositionHandler: function(e, t) {
this.liveCameraCenter = t.liveCameraCenter, this.liveCameraPosition = t.liveCameraPosition;
},
centerOnObjectHandler: function(e, t) {
this.liveCameraCenter = t.cen, this.liveCameraPosition = t.pos;
},
previewLiveCamera: function() {
var e = this.liveCameraPosition;
this.instance.camera.position.set(e.x, e.y, e.z), this.instance.controls.target = this.liveCameraCenter, this.instance.renderScene();
},
camPropertyChanged: function() {
this.instance.fromCreate && this.instance.storeCameraOptions(this.zoomCamera, this.rotateCamera, this.panCamera);
},
limitsChanged: function(e, t, n, r, i, s) {
this.limitRotYMin = e, this.limitRotYMax = t, this.limitRotXMin = n, this.limitRotXMax = r, this.limitZoomMin = i, this.limitZoomMax = s, this.instance.fromCreate && this.instance.storeCameraLimits(e, t, n, r, i, s);
}
});

// ZelfstandigLeren.js

enyo.kind({
name: "educate.components.zelfstandigleren.ZelfstandigLeren",
kind: "educate.components.ObjectInterface",
classes: "begeleidZelfstandigLeren",
published: {
layername: "",
value: "",
css_class: "",
solution: "",
answered: "",
timerId: -1,
time: 0,
preventDefaultEvent: !1
},
components: [ {
tag: "h1",
content: "begeleid zelfstandig leren"
}, {
classes: "rij headers",
components: [ {
classes: "header opdracht",
content: "opdracht"
}, {
classes: "header materiaal",
content: "materialen"
}, {
classes: "header tijd",
content: "tijd"
}, {
classes: "header vorm",
content: "werkvorm"
}, {
classes: "header verbetering",
content: "verbetering"
} ]
}, {
classes: "rij cells",
components: [ {
kind: "educate.components.zelfstandigleren.Editable",
classes: "cell opdracht",
name: "opdracht",
allowHtml: !0,
value: this.layername
}, {
kind: "educate.components.zelfstandigleren.Editable",
classes: "cell materiaal",
name: "materiaal",
allowHtml: !0,
value: this.value
}, {
classes: "cell tijd",
name: "tijd",
components: [ {
name: "klok",
content: "00:00",
classes: "clock"
}, {
classes: "updown",
components: [ {
kind: enyo.Button,
ontap: "changeTime",
name: "btnUp",
classes: "Button up",
allowHtml: !0,
content: '<i class="line-icon icon-chevron-up"></i>'
}, {
kind: enyo.Button,
ontap: "changeTime",
name: "btnDown",
classes: "Button down",
allowHtml: !0,
content: '<i class="line-icon icon-chevron-down"></i>'
} ]
}, {
classes: "startButtons",
components: [ {
kind: enyo.Button,
name: "btnStart",
classes: "Button start",
allowHtml: !0,
content: '<i class="line-icon icon-play"></i> start',
ontap: "startStopTheClock"
}, {
kind: enyo.Button,
name: "btnReset",
classes: "Button reset hidden",
allowHtml: !0,
content: '<i class="line-icon icon-refresh"></i>',
ontap: "resetTheClock"
} ]
} ]
}, {
kind: "educate.components.zelfstandigleren.Editable",
classes: "cell vorm",
name: "vorm",
allowHtml: !0,
value: this.solution
}, {
kind: "educate.components.zelfstandigleren.Editable",
classes: "cell verbetering",
name: "verbetering",
allowHtml: !0,
value: this.answered
} ]
} ],
create: function() {
this.inherited(arguments);
},
layernameChanged: function() {
this.$.opdracht.setValue(this.getLayername());
},
valueChanged: function() {
this.$.materiaal.setValue(this.getValue());
},
css_classChanged: function() {
this.time = this.getCss_class(), this.showTime();
},
solutionChanged: function() {
this.$.vorm.setValue(this.getSolution());
},
answeredChanged: function() {
this.$.verbetering.setValue(this.getAnswered());
},
changeTime: function(e, t) {
var n = this.getTime(), r = n % 60;
t.originator.name === "btnUp" ? (r = 60 - r, n = n < 5939 ? n + r : n + r - 5999) : (r = r > 0 ? r : 60, n = n > 60 ? n - r : 5999 - n + r), this.timerId === -1 ? (this.setCss_class(n), this.css_classChanged()) : this.setTime(n), this.showTime();
},
showTime: function() {
var e = this.getTime(), t = e % 60, n = (e - t) / 60, r = ("" + t).length > 1 ? "" + t : "0" + t, i = ("" + n).length > 1 ? "" + n : "0" + n;
this.$.klok.setContent(i + ":" + r);
},
startStopTheClock: function(e, t) {
this.timerId === -1 ? (this.time++, this.tick(), this.$.btnStart.setContent('<i class="line-icon icon-stop"></i> stop'), this.$.btnReset.removeClass("hidden"), this.$.btnStart.addClass("started")) : this.timerEnd();
},
resetTheClock: function(e, t) {
this.$.btnReset.addClass("hidden"), this.$.btnStart.removeClass("started"), this.time = this.getCss_class(), this.showTime(), this.timerEnd();
},
tick: function() {
var e = this.getTime();
if (e > 1) {
this.time = e - 1, this.showTime();
var t = this;
this.timerId = setTimeout(function() {
t.tick();
}, 1e3);
} else this.time = 0, this.$.klok.setContent("00:00"), this.timerEnd(), this.$.btnReset.addClass("hidden"), this.$.btnStart.removeClass("started");
},
timerEnd: function() {
clearTimeout(this.timerId), this.timerId = -1, this.$.btnStart.setContent('<i class="line-icon icon-play"></i> start');
},
dragObjectHandler: function() {}
});

// Editable.js

enyo.kind({
name: "educate.components.zelfstandigleren.Editable",
tag: "textarea",
classes: "editable",
published: {
value: "",
active: !1
},
create: function() {
this.inherited(arguments);
},
valueChanged: function() {
this.setContent(this.getValue());
}
});

// Klimatogram.js

enyo.kind({
name: "educate.components.bibliotheek.Klimatogram",
kind: "educate.components.ObjectInterface",
tag: "div",
classes: "klimatogram",
published: {
carrier: window.settings.CARRIERS.KLIMATOGRAM,
width: "auto",
height: "auto",
editable: !1,
warmMonths: [],
wetMonths: [],
place: "",
breedtegraad: 0,
lengtegraad: 0,
hoogte: 0,
temperatureScaleMax: 100,
temperatureScaleMin: -40,
autoScaling: !1,
temperaturePlot: null,
rainfallPlot: null,
temperatureAxis: null,
rainfallAxis: null,
temperatureScaleY: null,
rainfallScaleY: null,
chart: null,
gridlinesScaleX: null,
staggerRender: !1,
t1: 0,
t2: 0,
t3: 0,
t4: 0,
t5: 0,
t6: 0,
t7: 0,
t8: 0,
t9: 0,
t10: 0,
t11: 0,
t12: 0,
n1: 0,
n2: 0,
n3: 0,
n4: 0,
n5: 0,
n6: 0,
n7: 0,
n8: 0,
n9: 0,
n10: 0,
n11: 0,
n12: 0,
options: {
editable: !1,
temperatureData: [ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ],
rainfallData: [ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ],
place: "",
breedtegraad: 0,
lengtegraad: 0,
hoogte: 0,
temperatureScaleMax: 100,
temperatureScaleMin: -40,
autoScaling: !1
}
},
_chartRefreshTimeout: null,
handlers: {
onPropertiesChanged: "onPropertiesChangedHandler",
ondragstart: "onDragStartHandler",
ondragfinish: "onDragFinishHandler"
},
components: [ {
name: "header",
classes: "header klimatogram-row",
components: [ {
classes: "klimatogram-left temperature",
components: [ {
tag: "span",
content: "Tj"
}, {
tag: "span",
name: "Tj",
content: "0"
} ]
}, {
classes: "klimatogram-center title",
components: [ {
tag: "span",
name: "place",
classes: "place",
content: ""
}, {
tag: "span",
name: "coordinates",
classes: "coordinates",
content: "0\u00b0N - 0\u00b0E"
}, {
tag: "span",
name: "hoogte",
classes: "hoogte",
content: "0m"
} ]
}, {
classes: "klimatogram-right rainfall",
components: [ {
tag: "span",
content: "Nj"
}, {
tag: "span",
name: "Nj",
content: "0"
} ]
} ]
}, {
name: "dataVisualization",
classes: "data-visualization klimatogram-row",
components: [ {
classes: "klimatogram-left temperature",
components: [ {
name: "temperatureAxis",
classes: "temperature-axis",
tag: "svg"
} ]
}, {
name: "graph",
classes: "klimatogram-center graph",
components: [ {
name: "chart",
classes: "chart",
tag: "svg"
} ]
}, {
classes: "klimatogram-right rainfall",
components: [ {
name: "rainfallAxis",
classes: "rainfall-axis",
tag: "svg"
} ]
} ]
}, {
name: "temperatureData",
classes: "data temperature-data klimatogram-row",
components: [ {
classes: "klimatogram-left temperature",
components: [ {
tag: "span",
content: "T"
} ]
}, {
kind: "Repeater",
name: "temperatureFields",
count: 12,
onSetupItem: "setupTemperatureField",
classes: "klimatogram-center fields",
components: [ {
kind: "enyo.Input",
type: "number",
name: "TemperatureInput",
onchange: "temperatureFieldChanged"
} ]
}, {
classes: "klimatogram-right units",
components: [ {
tag: "span",
content: "C\u00b0"
} ]
} ]
}, {
name: "rainfallData",
classes: "data rainfall-data klimatogram-row",
components: [ {
classes: "klimatogram-left rainfall",
components: [ {
tag: "span",
content: "N"
} ]
}, {
kind: "Repeater",
name: "rainfallFields",
count: 12,
onSetupItem: "setupRainfallField",
classes: "klimatogram-center fields",
components: [ {
kind: "enyo.Input",
type: "number",
name: "RainfallInput",
onchange: "rainfallFieldChanged"
} ]
}, {
classes: "klimatogram-right units",
components: [ {
tag: "span",
content: "mm"
} ]
} ]
}, {
name: "months",
classes: "months klimatogram-row",
components: [ {
classes: "klimatogram-left spacer",
components: [ {} ]
}, {
name: "monthLabels",
classes: "klimatogram-center months",
components: []
}, {
classes: "klimatogram-right spacer",
components: [ {} ]
} ]
} ],
create: function() {
this.inherited(arguments);
var e = [ "J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D" ], t = 0;
for (t = 0; t < e.length; t++) this.$.monthLabels.createComponent({
tag: "span",
content: e[t]
});
this.addLinkEigenschappenOptions(), this.optionsChanged(), this.temperatureDataChanged(), this.rainfallDataChanged(), this.render();
},
render: function() {
this.inherited(arguments), this.renderAllRowsForRepeater(this.$.temperatureFields.render()), this.renderAllRowsForRepeater(this.$.rainfallFields.render());
},
rendered: function() {
this.inherited(arguments), this.calculatedFontSizeChanged(), this._chartRefreshTimeout && clearTimeout(this._chartRefreshTimeout), this.getStaggerRender() ? this._chartRefreshTimeout = setTimeout(this.refreshChart.bind(this), 200) : this.refreshChart();
},
onDragStartHandler: function(e, t) {
this.setStaggerRender(!0);
},
onDragFinishHandler: function(e, t) {
this.setStaggerRender(!1);
},
addLinkEigenschappenOptions: function() {
for (var e = 1; e <= 12; e++) this.getLinkEigenschappenOptions()["T" + e] = "T" + e, this.getLinkEigenschappenOptions()["N" + e] = "N" + e;
},
setupTemperatureField: function(e, t) {
var n = t.index, r = t.item;
return typeof r != "undefined" && (r.$.TemperatureInput.setValue(this["getT" + (t.index + 1)]()), r.$.TemperatureInput.setDisabled(!0)), !0;
},
setupRainfallField: function(e, t) {
var n = t.index, r = t.item;
return typeof r != "undefined" && (r.$.RainfallInput.setValue(this["getN" + (t.index + 1)]()), r.$.RainfallInput.setDisabled(!0)), !0;
},
refreshChart: function() {
if (this.hasNode()) {
this.getChart() && this.getChart().remove();
var e = this.convertTemperatureDataForChartUse(), t = this.convertRainfallDataForChartUse(), n = (new Plottable.Scale.Category).innerPadding(0).outerPadding(.5), r = $("#" + this.hasNode().id + " .graph"), i = $("#" + this.hasNode().id + " .graph svg");
this.setGridlinesScaleX((new Plottable.Scale.Linear).domain([ 0, 12 ]).range([ (i.width() - r.width()) / 2, r.width() + (i.width() - r.width()) / 2 ]));
var s = (new Plottable.Scale.Linear).domain([ 0, 13 ]);
this.setTemperatureScaleY(new Plottable.Scale.Linear), this.setRainfallScaleY(new Plottable.Scale.Linear), this.setTemperaturePlot((new Plottable.Plot.Line(s, this.getTemperatureScaleY())).addDataset(e).project("x", function(e) {
return e.month;
}, s).project("y", function(e) {
return e.value;
}, this.getTemperatureScaleY()).project("stroke", "#e84c0a").interpolate("monotone")), this.setRainfallPlot((new Plottable.Plot.Bar(n, this.getRainfallScaleY())).addDataset(t).project("x", function(e) {
return e.month;
}, n).project("y", function(e) {
return e.value;
}, this.getRainfallScaleY()).project("fill", "#439dd7")), this.setTemperatureAxis((new Plottable.Axis.Numeric(this.getTemperatureScaleY(), "left")).tickLength(0).endTickLength(0).gutter(0)), this.setRainfallAxis((new Plottable.Axis.Numeric(this.getRainfallScaleY(), "right")).tickLength(0).endTickLength(0).gutter(0)), this.setChart(new Plottable.Component.Group([ this.getRainfallPlot(), new Plottable.Component.Gridlines(this.getGridlinesScaleX(), this.getTemperatureScaleY()), this.getTemperaturePlot() ])), this.correctAxisOffsets(), this.getChart().renderTo("#" + this.hasNode().id + " .chart"), this.getTemperatureAxis().renderTo("#" + this.hasNode().id + " .temperature-axis"), this.getRainfallAxis().renderTo("#" + this.hasNode().id + " .rainfall-axis"), this.updateDataVisualization(), this.updateChartScales();
}
},
correctAxisOffsets: function() {
this.hasNode() && this.getTemperatureAxis() && (this.getTemperatureAxis().xOffset(5 * window.settings.SCALE), this.getRainfallAxis().xOffset(-5 * window.settings.SCALE));
},
convertTemperatureDataForChartUse: function(e) {
var t = [];
t.push({
month: 0,
value: this.getT12()
});
for (var n = 1; n <= 12; n++) t.push({
month: n,
value: this["getT" + n]()
});
return t.push({
month: 13,
value: this.getT1()
}), t;
},
convertRainfallDataForChartUse: function(e) {
var t = [];
for (var n = 1; n <= 12; n++) t.push({
month: n,
value: this["getN" + n]()
});
return t;
},
editableChanged: function(e) {
this.addOption("editable", this.getEditable());
},
calculatedFontSizeChanged: function() {
this.applyStyle("font-size", this.calculatedFontSize + "rem");
},
temperatureFieldChanged: function(e, t) {
var n = "setT" + (t.index + 1);
return isNaN(+t.originator.getValue()) ? this[n](0) : this[n](parseFloat(+t.originator.getValue())), this.$.temperatureFields.renderRow(t.index), !0;
},
temperatureDataChanged: function(e) {
this.inherited(arguments);
var t = this.getOptions().temperatureData;
for (var n = 0; n < 12; n++) t[n] = this["getT" + (n + 1)]();
var r = 0;
for (n = 1; n <= 12; n++) this.$.temperatureFields.renderRow(n - 1), r += parseFloat(+this["getT" + n]());
r /= 12, this.$.Tj.setContent(r.toFixed(1).replace(".", ",")), this.getTemperaturePlot() && (this.updateTemperaturePlot(), this.updateChartScales(), this.getTemperaturePlot().redraw());
},
rainfallFieldChanged: function(e, t) {
var n = "setN" + (t.index + 1);
return isNaN(+t.originator.getValue()) ? this[n](0) : this[n](Math.max(0, parseFloat(+t.originator.getValue()))), this.$.rainfallFields.renderRow(t.index), !0;
},
rainfallDataChanged: function(e) {
this.inherited(arguments);
var t = this.getOptions().rainfallData;
for (var n = 0; n < 12; n++) t[n] = this["getN" + (n + 1)]();
var r = 0;
for (n = 1; n <= 12; n++) this.$.temperatureFields.renderRow(n - 1), r += parseFloat(+this["getN" + n]());
this.$.Nj.setContent(r), this.getRainfallPlot() && (this.updateRainfallPlot(), this.updateChartScales(), this.getRainfallPlot().redraw());
},
updateChartScales: function() {
if (this.hasNode() && this.getTemperatureScaleY()) {
var e = this.getTemperatureScaleY(), t = this.getRainfallScaleY();
if (this.getAutoScaling()) {
var n = this.getTemperatureDataAsArray(), r = this.getRainfallDataAsArray(), i = arrayMax(n), s = arrayMin(n), o = arrayMax(r), u = Math.max(o, i * 2), a = Math.min(0, s * 2);
u += 10, a -= 10, e.domain([ a / 2, u / 2 ]), t.domain([ a, u ]);
} else e.domain([ this.getTemperatureScaleMin(), this.getTemperatureScaleMax() ]), t.domain([ this.getTemperatureScaleMin() * 2, this.getTemperatureScaleMax() * 2 ]);
this.getTemperatureAxis().redraw(), this.getRainfallAxis().redraw(), this.updateGridlines();
}
},
updateDataVisualization: function() {
if (this.hasNode()) {
var e = this.getChart();
e && (this.updateTemperaturePlot(), this.updateRainfallPlot(), e.redraw());
}
},
updateTemperaturePlot: function() {
if (this.hasNode() && this.getChart()) {
var e = this.getTemperaturePlot();
e.removeDataset(e.datasets()[0]);
var t = this.convertTemperatureDataForChartUse();
e.addDataset(t);
}
},
updateRainfallPlot: function() {
if (this.hasNode() && this.getChart()) {
var e = this.getRainfallPlot();
e.removeDataset(e.datasets()[0]);
var t = this.convertRainfallDataForChartUse();
e.addDataset(t);
}
},
updateGridlines: function() {
if (this.hasNode() && this.getChart()) {
var e = $("#" + this.hasNode().id + " .graph"), t = $("#" + this.hasNode().id + " .graph svg");
this.getGridlinesScaleX().domain([ 0, 12 ]).range([ (t.width() - e.width()) / 2, e.width() + (t.width() - e.width()) / 2 ]);
}
},
breedtegraadChanged: function(e) {
this.addOption("breedtegraad", this.getBreedtegraad()), this.updateCoordinates();
},
lengtegraadChanged: function(e) {
this.addOption("lengtegraad", this.getLengtegraad()), this.updateCoordinates();
},
updateCoordinates: function() {
var e = this.getLengtegraad(), t = this.getBreedtegraad();
this.$.coordinates.setContent(Math.abs(t) + "\u00b0 " + (t < 0 ? "S" : "N") + " - " + Math.abs(e) + "\u00b0 " + (e < 0 ? "W" : "E"));
},
placeChanged: function() {
this.addOption("place", this.getPlace()), this.$.place.setContent(this.getPlace());
},
hoogteChanged: function() {
this.addOption("hoogte", this.getHoogte()), this.$.hoogte.setContent(this.getHoogte() + "m");
},
temperatureScaleMaxChanged: function() {
this.addOption("temperatureScaleMax", this.getTemperatureScaleMax()), this.getTemperaturePlot() && (this.updateChartScales(), this.updateDataVisualization());
},
temperatureScaleMinChanged: function() {
this.addOption("temperatureScaleMin", this.getTemperatureScaleMin()), this.getTemperaturePlot() && (this.updateChartScales(), this.updateDataVisualization());
},
autoScalingChanged: function() {
this.addOption("autoScaling", this.getAutoScaling()), this.hasNode() && this.getTemperaturePlot() && (this.updateChartScales(), this.updateDataVisualization());
},
resizeComponent: function() {
this.inherited(arguments), this.setCalculatedWidth(this.getWidth() !== null && this.getWidth() !== "auto" && this.getWidth() !== -1 ? parseFloat(this.getWidth() * window.settings.SCALE) : "auto"), this.setCalculatedHeight(this.getHeight() !== null && this.getHeight() !== "auto" && this.getHeight() !== -1 ? parseFloat(this.getHeight() * window.settings.SCALE) : "auto"), this.setCalculatedPosX(this.getPosition_x() * window.settings.SCALE + .5 >> 0), this.setCalculatedPosY(this.getPosition_y() * window.settings.SCALE + .5 >> 0), this.calculatedFontSize = this.getFontSize() * window.settings.SCALE, this.correctAxisOffsets(), this.calculatedFontSizeChanged(), this.updateDataVisualization(), this.updateChartScales();
},
onPropertiesChangedHandler: function() {
this.resizeComponent(), this.renderAllRowsForRepeater(this.$.temperatureFields.render()), this.renderAllRowsForRepeater(this.$.rainfallFields.render());
},
renderAllRowsForRepeater: function(e) {
for (var t = 0; t < e.getCount(); t++) e.renderRow(t);
},
optionsChanged: function() {
this.inherited(arguments);
var e = this.getOptions();
for (var t = 0; t < 12; t++) this["setT" + (t + 1)](e.temperatureData[t]);
for (var t = 0; t < 12; t++) this["setN" + (t + 1)](e.rainfallData[t]);
this.setAutoScaling(e.autoScaling), this.setPlace(e.place), this.setBreedtegraad(e.breedtegraad), this.setLengtegraad(e.lengtegraad), this.setHoogte(e.hoogte), this.setEditable(e.editable), this.temperatureDataChanged(), this.rainfallDataChanged(), this.setTemperatureScaleMax(e.temperatureScaleMax), this.setTemperatureScaleMin(e.temperatureScaleMin);
},
t1Changed: function(e) {
this.setT1(this.formatTemperature(this.getT1())), this.temperatureDataChanged();
},
t2Changed: function(e) {
this.setT2(this.formatTemperature(this.getT2())), this.temperatureDataChanged();
},
t3Changed: function(e) {
this.setT3(this.formatTemperature(this.getT3())), this.temperatureDataChanged();
},
t4Changed: function(e) {
this.setT4(this.formatTemperature(this.getT4())), this.temperatureDataChanged();
},
t5Changed: function(e) {
this.setT5(this.formatTemperature(this.getT5())), this.temperatureDataChanged();
},
t6Changed: function(e) {
this.setT6(this.formatTemperature(this.getT6())), this.temperatureDataChanged();
},
t7Changed: function(e) {
this.setT7(this.formatTemperature(this.getT7())), this.temperatureDataChanged();
},
t8Changed: function(e) {
this.setT8(this.formatTemperature(this.getT8())), this.temperatureDataChanged();
},
t9Changed: function(e) {
this.setT9(this.formatTemperature(this.getT9())), this.temperatureDataChanged();
},
t10Changed: function(e) {
this.setT10(this.formatTemperature(this.getT10())), this.temperatureDataChanged();
},
t11Changed: function(e) {
this.setT11(this.formatTemperature(this.getT11())), this.temperatureDataChanged();
},
t12Changed: function(e) {
this.setT12(this.formatTemperature(this.getT12())), this.temperatureDataChanged();
},
n1Changed: function(e) {
this.rainfallDataChanged(), this.setN1(this.formatRainfall(this.getN1()));
},
n2Changed: function(e) {
this.rainfallDataChanged(), this.setN2(this.formatRainfall(this.getN2()));
},
n3Changed: function(e) {
this.rainfallDataChanged(), this.setN3(this.formatRainfall(this.getN3()));
},
n4Changed: function(e) {
this.rainfallDataChanged(), this.setN4(this.formatRainfall(this.getN4()));
},
n5Changed: function(e) {
this.setN5(this.formatRainfall(this.getN5())), this.rainfallDataChanged();
},
n6Changed: function(e) {
this.rainfallDataChanged(), this.setN6(this.formatRainfall(this.getN6()));
},
n7Changed: function(e) {
this.rainfallDataChanged(), this.setN7(this.formatRainfall(this.getN7()));
},
n8Changed: function(e) {
this.setN8(this.formatRainfall(this.getN8())), this.rainfallDataChanged();
},
n9Changed: function(e) {
this.rainfallDataChanged(), this.setN9(this.formatRainfall(this.getN9()));
},
n10Changed: function(e) {
this.rainfallDataChanged(), this.setN10(this.formatRainfall(this.getN10()));
},
n11Changed: function(e) {
this.rainfallDataChanged(), this.setN11(this.formatRainfall(this.getN11()));
},
n12Changed: function(e) {
this.rainfallDataChanged(), this.setN12(this.formatRainfall(this.getN12()));
},
getTemperatureDataAsArray: function() {
var e = [];
for (var t = 0; t < 12; t++) e[t] = this["getT" + (t + 1)]();
return e;
},
getRainfallDataAsArray: function() {
var e = [];
for (var t = 0; t < 12; t++) e[t] = this["getN" + (t + 1)]();
return e;
},
formatTemperature: function(e) {
return +(+e).toFixed(1);
},
formatRainfall: function(e) {
return Math.max(0, +(+e).toFixed(0));
}
});

// MultipleChoice.js

enyo.kind({
name: "educate.components.multipleChoice.MultipleChoice",
kind: "educate.components.ObjectInterface",
tag: "div",
classes: "multiple-choice",
published: {
carrier: window.settings.CARRIERS.MULTIPLECHOICE,
width: "auto",
height: "270",
value: 0,
selectOptions: [],
correctOptions: "",
solutionFromFrame: !1,
shuffleAnswers: !0,
question: "",
fontSize: 1.5,
lineHeight: 2.5
},
components: [ {
tag: "div",
name: "multipleChoiceHead",
classes: "multiple-choice-head",
components: [ {
kind: "educate.components.oplossing.OplossingButton",
name: "btnCheckMultipleChoice"
}, {
tag: "div",
name: "multipleChoiceQuestion",
classes: "multiple-choice-question",
content: this.question
} ]
}, {
name: "choiceList",
tag: "ul",
components: [ {
tag: "li",
components: [ {
tag: "i",
content: "correctfalse"
}, {
tag: "span",
content: "checkbox"
}, {
tag: "span",
content: "label"
} ]
} ]
} ],
create: function() {
this.inherited(arguments), this.$.multipleChoiceQuestion.setContent(this.getQuestion()), this.resizeComponent();
},
rendered: function() {
this.inherited(arguments), this.calculatedFontSizeChanged();
},
updateMultipleChoice: function() {
this.$.choiceList.destroyClientControls();
},
calculatedFontSizeChanged: function() {
this.applyStyle("font-size", this.calculatedFontSize + "rem");
var e = this.getLineHeight() * window.settings.SCALE;
this.applyStyle("line-height", e + "rem"), $(".multiple-choice ul li i").css("font-size", 1 * window.settings.SCALE + "rem"), $(".multiple-choice ul li i").css("min-width", 16 * window.settings.SCALE + "px");
},
resizeComponent: function() {
!isNaN(parseInt(this.getWidth())) && this.getWidth() != -1 ? this.calculatedWidth = parseInt(this.getWidth() * window.settings.SCALE) : this.calculatedWidth = "auto", !isNaN(parseInt(this.getHeight())) && this.getHeight() != -1 ? this.calculatedHeight = parseInt(this.getHeight() * window.settings.SCALE * window.settings.FONTSIZEPROCENT) : this.calculatedHeight = "auto", this.calculatedPosX = this.getPosition_x() * window.settings.SCALE + .5 >> 0, this.calculatedPosY = this.getPosition_y() * window.settings.SCALE + .5 >> 0, this.calculatedFontSize = this.getFontSize() * window.settings.SCALE, this.render();
}
});

// 3DObject.js

enyo.kind({
name: "educate.frame.components.3DObject.3DObject",
kind: "educate.components.3DObject.3DObject",
tag: "div",
classes: "3DObject",
style: "position: absolute;",
published: {
position_x: 0,
position_y: 1,
width: 1e3,
height: 550,
modelUrl: "/svnAssets/vb3bis.dae",
modelUrls: [],
modelName: "",
modelNames: [],
modelId: 0,
meshOptions: [],
lockCamera: !1,
groundOn: !0,
spotLightOn: !0,
hemiLightOn: !0,
fromCreate: !1,
newRendering: !0
},
id: "3dobj",
create: function() {
this.inherited(arguments), this.resizeComponent();
},
rendered: function() {
this.inherited(arguments), this.loadFirstUrl();
},
loadFirstUrl: function() {
this.modelUrls.length > 0 && this.newRendering && (this.newRendering = !1, this.loadOtherUrls());
},
loadOtherUrls: function() {
this.modelUrls[this.modelId] ? this.modelUrls[this.modelId] == "deleted" ? (this.modelId++, this.loadOtherUrls()) : (this.modelUrl = this.modelUrls[this.modelId], this.modelName = this.modelNames[this.modelId], this.modelId++, this.addModelToScene()) : (console.log("done loading"), this.sceneInit = !0);
},
downHandler: function(e, t) {},
ontapHandler: function() {}
});

// Animatie.js

enyo.kind({
name: "educate.frame.components.animatie.Animatie",
kind: "educate.components.animatie.Animatie",
create: function() {
this.inherited(arguments);
},
downHandler: function(e, t) {
t.preventDefault(), this.setClickX(t.clientX - $(e.hasNode()).offset().left), this.setClickY(t.clientY - $(e.hasNode()).offset().top);
},
ontapHandler: function() {
event.preventDefault();
}
});

// Knop.js

enyo.kind({
name: "educate.frame.components.bediening.Knop",
kind: "educate.components.bediening.Knop",
fit: !1,
tag: "div",
classes: "Button",
published: {},
handlers: {
ontap: "ontapHandler"
},
components: [ {
kind: "Signals",
onFontSizeProcentChanged: "fontSizeProcentChangedHandler"
}, {
tag: "p",
name: "up"
}, {
tag: "p",
classes: "solution",
name: "down"
} ],
startdrag: function() {
this.setClickX(this.width), this.setClickY(this.height), this.handlers.dragButton = "dragHandler";
},
dragHandler: function(e, t) {
this.calculatedPosX = t.clientX - this.getClickX() / 4, this.calculatedPosY = t.clientY - this.getClickY() / 4, this.render();
},
stopdrag: function(e, t) {
this.handlers.dragButton = null, this.setPosition_x(parseInt(this.calculatedPosX / window.settings.SCALE)), this.setPosition_y(parseInt(this.calculatedPosY / window.settings.SCALE));
},
visibleChanged: function() {
this.applyStyle("display", this.getVisible() !== !1 ? "block" : "none"), this.addOption("visible", this.getVisible()), this.laag && this.laag.setLaagOpen(this.getVisible());
},
downHandler: function(e, t) {
t.preventDefault();
var n, r, i = $(e.hasNode()).offset(), s = $(this.getStage().hasNode()).offset();
t.type === "touchmove" ? (n = t.touches[0].clientX, r = t.touches[0].clientY) : (n = t.clientX, r = t.clientY), this.setClickX(n - i.left), this.setClickY(r - i.top);
var o = n - s.left, u = r - s.top, a = o - this.absoluteOrigin.x, f = u - this.absoluteOrigin.y;
this.startRotation = Math.atan2(f, a) * 180 / Math.PI - this.rotation_z;
},
ontapHandler: function(e, t) {
t.preventDefault(), this.getAnswered() && this.checkWhereToGo();
},
checkWhereToGo: function() {
var e = /^\d\d\d\d-\d+-\d+-\d+-\d+$/, t = this.getAnswered();
e.test(t) ? this.goToScene(t) : this.goToUrl(t);
},
goToScene: function(e) {
window.location = Settings.LES + "#/" + e;
},
goToUrl: function(e) {
var t = /^https?:\/\//;
window.open(t.test(e) ? e : "http://" + e, "_blank");
},
fontSizeProcentChangedHandler: function(e, t) {
this.resizeComponent();
}
});

// Icon.js

enyo.kind({
name: "educate.frame.components.bediening.Icon",
kind: "educate.components.bediening.Icon",
classes: "interactive Icon",
published: {},
handlers: {},
components: [],
downHandler: function(e, t) {
t.preventDefault(), this.setClickX(t.clientX - $(e.hasNode()).offset().left), this.setClickY(t.clientY - $(e.hasNode()).offset().top);
},
ontapHandler: function(e, t) {
t.preventDefault(), this.toggle();
}
});

// IconContent.js

enyo.kind({
name: "educate.frame.components.bediening.IconContent",
kind: "educate.components.bediening.IconContent",
classes: "IconContent",
published: {
paddingTop: 5,
marginTop: 5,
photos: "",
photoNr: 0,
photoCollection: "",
activePhoto: 0
},
handlers: {},
components: [ {
tag: "div",
name: "IconContent",
allowHtml: !0
}, {
tag: "div",
name: "prevNextButtons",
showing: !1,
controlClasses: "prevnextbtn",
components: [ {
tag: "div",
name: "prevBtn",
classes: "prev",
ontap: "prevClickedHandler"
}, {
tag: "div",
name: "nextBtn",
classes: "next",
ontap: "nextClickedHandler"
} ]
} ],
create: function() {
this.inherited(arguments), this.photos = [], this.makePhotoComponents(), this.handlePhotos();
},
rendered: function() {
this.inherited(arguments);
},
makePhotoComponents: function() {
if (this.getType() == "photo") for (var e in this.getPhotoCollection()) {
this.photoNr++;
var t = this.$.IconContent.createComponent({
kind: "educate.components.bediening.PhotoIconImage",
name: "photoHolder" + this.photoNr,
layername: "photoIconImage" + this.photoNr,
value: this.getPhotoCollection()[e].value,
src: Settings.WEBAPP + "/" + this.getPhotoCollection()[e].value
});
this.getPhotos().push(t);
}
},
valueChanged: function() {
this.getType() != "photo" && this.$.IconContent.setContent(this.getValue());
},
calculatedMetricsChanged: function() {
this.$.IconContent.applyStyle("padding-top", this.calculatedPaddingTop + "px");
},
handlePhotos: function() {
this.hidePhotos(), this.getPhotos().length > 0 && this.getPhotos()[0].setShowing(!0), this.checkMultiplePhotos();
},
prevClickedHandler: function() {
this.activePhoto = this.getActivePhoto() > 0 ? this.activePhoto - 1 : this.getPhotos().length - 1, this.hidePhotos(), this.getPhotos()[this.getActivePhoto()].setShowing(!0);
},
nextClickedHandler: function() {
this.activePhoto = this.getActivePhoto() < this.getPhotos().length - 1 ? this.activePhoto + 1 : 0, this.hidePhotos(), this.getPhotos()[this.getActivePhoto()].setShowing(!0);
},
hidePhotos: function() {
for (var e in this.getPhotos()) this.getPhotos()[e].setShowing(!1);
},
checkMultiplePhotos: function() {
this.$.prevNextButtons.setShowing(this.getPhotos().length > 1 ? !0 : !1);
},
downHandler: function(e, t) {
t.preventDefault(), this.getType() != "photo" && (this.getLocked() || (this.bubble("objectSelected", this), this.setClickX(t.clientX - $(e.hasNode()).offset().left), this.setClickY(t.clientY - $(e.hasNode()).offset().top), $(document).on("mousemove", enyo.bind(this, "dragObjectHandler")), $(document).on("mouseup", enyo.bind(this, "upHandler"))));
},
dragObjectHandler: function(e) {
this.getType() != "photo" && (this.calculatedPosY = e.clientY - $(".w" + this.getViewId()).offset().top - this.getClickY() + window.settings.OFFSETY, this.applyStyle("bottom", null), this.applyStyle("top", this.calculatedPosY + "px"));
},
upHandler: function() {
this.getType() != "photo" && this.stopDragHandler();
},
stopDragHandler: function() {
$(document).off("mousemove"), $(document).off("mouseup");
var e = ($(".w" + this.getViewId()).height() - this.getHeight()) / 2;
this.setVertPosition(this.calculatedPosY < e ? "top" : "bottom"), this.render();
},
selectedChanged: function(e) {
this.getSelected();
}
});

// InfoIconContent.js

enyo.kind({
name: "educate.frame.components.bediening.InfoIconContent",
kind: "educate.components.bediening.InfoIconContent",
create: function() {
this.inherited(arguments);
},
selectedChanged: function(e) {}
});

// PhotoIconContent.js

enyo.kind({
name: "educate.frame.components.bediening.PhotoIconContent",
kind: "educate.components.bediening.PhotoIconContent",
create: function() {
this.inherited(arguments);
},
selectedChanged: function(e) {},
downHandler: function(e, t) {
t.preventDefault(), this.setClickX(t.clientX - $(e.hasNode()).offset().left), this.setClickY(t.clientY - $(e.hasNode()).offset().top), this.linked.getVerplaatsbaar() && ($(document).on("mousemove", enyo.bind(this, "dragObjectHandler")), $(document).on("mouseup", enyo.bind(this, "upHandler")));
}
});

// InfoIcon.js

enyo.kind({
name: "educate.frame.components.bediening.InfoIcon",
kind: "educate.frame.components.bediening.Icon",
fit: !1,
published: {},
handlers: {},
components: [ {
kind: "educate.components.bediening.InfoIconI"
} ],
create: function() {
this.inherited(arguments);
},
rendered: function() {
this.inherited(arguments);
},
openChanged: function() {
this.objContent.setShowing(this.getOpen() ? !0 : !1), this.addRemoveClass("active", this.getOpen());
}
});

// PhotoIcon.js

enyo.kind({
name: "educate.frame.components.bediening.PhotoIcon",
kind: "educate.frame.components.bediening.Icon",
fit: !1,
published: {
linked: "",
verplaatsbaar: !1
},
handlers: {},
components: [ {
tag: "i",
classes: "icon-camera-retro photoIcon"
} ],
create: function() {
this.inherited(arguments);
},
rendered: function() {
this.inherited(arguments), this.options.verplaatsbaar !== !0 && this.addOption("verplaatsbaar", !1), this.setVerplaatsbaar(this.options.verplaatsbaar);
},
openChanged: function() {
this.collection && this.collection[0].setShowing(this.getOpen() ? !0 : !1), this.addRemoveClass("active", this.getOpen());
},
verplaatsbaarChanged: function() {
this.addOption("verplaatsbaar", this.getVerplaatsbaar());
}
});

// Dropdown.js

enyo.kind({
name: "educate.frame.components.bediening.Dropdown",
kind: "educate.components.bediening.Dropdown",
tag: "div",
classes: "dropdownObj",
style: "position: absolute;",
published: {
checkSolution: !1,
checked: !1
},
handlers: {
checkDropdown: "checkDropdownHandler"
},
create: function() {
this.inherited(arguments), this.$.droplist.setShowing(!1), this.updateDropdown();
},
rendered: function() {
this.inherited(arguments);
},
dropDownTapped: function(e, t) {
this.toggleDropDown();
},
toggleDropDown: function() {
this.$.droplist.setShowing(!this.$.droplist.getShowing()), this.$.droplist.getShowing() ? (this.checked && (this.$.selectedVal.removeClass("correct"), this.$.selectedVal.removeClass("false"), this.$.arrow.removeClass("fill-icon icon-check-2"), this.$.arrow.removeClass("fill-icon icon-delete-2"), this.$.arrow.addClass(this.getOpenDirectionUp() ? "icon-chevron-up" : "icon-chevron-down")), this.$.selectedVal.addClass("opened"), this.$.arrow.addClass("opened"), this.applyStyle("z-index", 999)) : (this.$.selectedVal.removeClass("opened"), this.$.arrow.removeClass("opened"), this.applyStyle("z-index", 1));
},
putSelectedOption: function(e, t) {
this.$.selectedOption.setContent(e), this.setValue(parseFloat(t));
},
updateDropdown: function() {
this.inherited(arguments);
var e = this.getShuffleAnswers() ? shuffleArray(this.selectOptions) : this.selectOptions;
!this.getStartWithChoose() && this.putSelectedOption(e[0].text, e[0].value);
for (var t in e) this.$.droplist.createComponent({
tag: "li",
content: e[t].text,
ontap: "checkDropDown",
value: e[t].value,
correct: e[t].correct
}, {
owner: this
});
this.$.droplist.render();
},
checkDropDown: function(e, t) {
if (this.automaticSolution || this.checkSolution) e.correct ? (this.$.arrow.removeClass(this.getOpenDirectionUp() ? "icon-chevron-up" : "icon-chevron-down"), this.$.selectedVal.addClass("correct"), this.$.arrow.addClass("fill-icon icon-check-2")) : (this.$.arrow.removeClass(this.getOpenDirectionUp() ? "icon-chevron-up" : "icon-chevron-down"), this.$.selectedVal.addClass("false"), this.$.arrow.addClass("fill-icon icon-delete-2"));
this.toggleDropDown();
if (this.automaticSolution || this.checkSolution) this.checked = !0;
this.putSelectedOption(e.content, e.value), this.$.selectedOption.correct = e.correct;
},
checkDropdownHandler: function(e, t) {
if (!this.automaticSolution) {
this.checkSolution = !this.checkSolution;
var n = this.$.selectedOption.correct;
this.checkSolution ? (n ? (this.$.selectedVal.addClass("correct"), this.$.arrow.removeClass(this.getOpenDirectionUp() ? "icon-chevron-up" : "icon-chevron-down"), this.$.arrow.addClass("fill-icon icon-check-2")) : (this.$.selectedVal.addClass("false"), this.$.arrow.removeClass(this.getOpenDirectionUp() ? "icon-chevron-up" : "icon-chevron-down"), this.$.arrow.addClass("fill-icon icon-delete-2")), this.checked = !0) : (this.$.selectedVal.removeClass("correct"), this.$.selectedVal.removeClass("false"), this.$.arrow.removeClass("fill-icon icon-check-2"), this.$.arrow.removeClass("fill-icon icon-delete-2"), this.$.arrow.addClass(this.getOpenDirectionUp() ? "icon-chevron-up" : "icon-chevron-down"), this.checked = !1);
}
},
downHandler: function(e, t) {
this.setClickX(t.clientX - $(e.hasNode()).offset().left), this.setClickY(t.clientY - $(e.hasNode()).offset().top);
},
ontapHandler: function() {}
});

// Klimatogram.js

enyo.kind({
name: "educate.frame.components.bibliotheek.Klimatogram",
kind: "educate.components.bibliotheek.Klimatogram",
create: function() {
this.inherited(arguments), this.resizeComponent();
},
ontapHandler: function(e, t) {
return this.eventOriginatesFromInput(t) || t.preventDefault(), !0;
},
setupTemperatureField: function(e, t) {
this.inherited(arguments);
var n = t.item;
return n.$.TemperatureInput.setDisabled(!this.getEditable()), !0;
},
setupRainfallField: function(e, t) {
this.inherited(arguments);
var n = t.item;
return n.$.RainfallInput.setDisabled(!this.getEditable()), !0;
},
temperatureFieldChanged: function(e, t) {
this.getEditable() && this.inherited(arguments);
},
rainfallFieldChanged: function(e, t) {
this.getEditable() && this.inherited(arguments);
},
downHandler: function(e, t) {
this.eventOriginatesFromInput(t) || t.preventDefault();
var n, r, i = $(e.hasNode()).offset(), s = $(this.getStage().hasNode()).offset();
t.type === "touchmove" ? (n = t.touches[0].clientX, r = t.touches[0].clientY) : (n = t.clientX, r = t.clientY), this.setClickX(n - i.left), this.setClickY(r - i.top);
var o = n - s.left, u = r - s.top, a = o - this.absoluteOrigin.x, f = u - this.absoluteOrigin.y;
this.startRotation = Math.atan2(f, a) * 180 / Math.PI - this.rotation_z;
},
eventOriginatesFromInput: function(e) {
return this.$.temperatureFields == e.originator.parent.parent || this.$.rainfallFields == e.originator.parent.parent;
}
});

// ColumnExercise.js

enyo.kind({
name: "educate.frame.components.columnExercise.ColumnExercise",
kind: "educate.components.columnExercise.ColumnExercise",
components: [ {
kind: "educate.frame.components.columnExercise.ColumnHolder",
name: "columns",
columns: this.columns
}, {
kind: "educate.frame.components.columnExercise.OptionContainer",
name: "options",
options: this.optionList
} ],
handlers: {
onShowSolution: "onShowSolutionHandler",
onHideSolution: "onHideSolutionHandler",
onChange: "onChangeHandler"
},
onShowSolutionHandler: function() {
this.$.columns.showSolution();
},
onHideSolutionHandler: function() {
this.$.columns.hideSolution();
},
onChangeHandler: function(e, t) {
return !0;
}
});

// ColumnHolder.js

enyo.kind({
name: "educate.frame.components.columnExercise.ColumnHolder",
kind: "educate.components.columnExercise.ColumnHolder",
columnsChanged: function() {
this.inherited(arguments), this.destroyComponents();
var e, t = this.getColumns().length, n = [];
for (e = 0; e < t; e++) {
var r = this.getColumns()[e];
n.push({
kind: "educate.frame.components.columnExercise.Column",
name: "column_" + e,
header: r.header,
options: r.options,
contents: r.contents,
groupedBy: r.groupedBy
});
}
this.createComponents(n);
},
showSolution: function() {
var e = this.columns.length - 1, t;
for (e; e >= 0; e--) {
t = enyo.$[this.getId() + "_column_" + e];
if (typeof t == "undefined") continue;
t.showSolution();
}
},
hideSolution: function() {
var e = this.columns.length - 1, t;
for (e; e >= 0; e--) {
t = enyo.$[this.getId() + "_column_" + e];
if (typeof t == "undefined") continue;
t.hideSolution();
}
}
});

// OptionContainer.js

enyo.kind({
name: "educate.frame.components.columnExercise.OptionContainer",
kind: "educate.components.columnExercise.OptionContainer",
components: [ {
name: "headerGroup",
classes: "column-header column-header-group",
components: [ {
kind: educate.components.oplossing.OplossingButton,
name: "solutionButton"
}, {
tag: "h1",
name: "header",
content: this.header
} ]
}, {
name: "container",
classes: "column-content"
} ],
disableSolutions: function() {
this.$.solutionButton.setIsActive(!1);
},
resizeComponent: function() {
this.inherited(arguments), this.$.header.applyStyle("font-size", window.settings.SCALE * window.settings.FONTSIZE + "px");
}
});

// Column.js

enyo.kind({
name: "educate.frame.components.columnExercise.Column",
kind: "educate.components.columnExercise.Column",
published: {
correctValues: [],
solutionVisible: !1
},
events: {
onChange: ""
},
create: function() {
var e = [].concat(this.options);
this.options = [], this.correctValues = e, this.inherited(arguments);
},
headerChanged: function() {
this.$.header.setContent(this.header);
},
showSolution: function() {
this.solutionVisible = !0;
var e, t, n = this.$.container.getControls(), r = n.length;
for (e = 0; e < r; e++) {
t = n[e];
var i = this.getCorrectValues().indexOf(t.getOption()) === -1 ? "wrong" : "solved";
t.setState(i), t.render();
}
},
hideSolution: function() {
this.solutionVisible = !1;
var e, t, n = this.$.container.getControls(), r = n.length;
for (e = 0; e < r; e++) t = n[e], t.setState("neutral");
},
optionsChanged: function() {
this.inherited(arguments), this.doChange(), this.solutionVisibleChanged();
},
solutionVisibleChanged: function() {
this.getSolutionVisible() ? this.showSolution() : this.hideSolution();
}
});

// Option.js

enyo.kind({
name: "educate.frame.components.columnExercise.Option",
kind: enyo.Control,
handlers: {
onmousedown: "downHandler"
},
published: {
state: "neutral",
position: {
x: null,
y: null
}
},
offset: {
x: 0,
y: 0
},
dragging: !1,
fromColumn: null,
eventHandlers: {},
rendered: function() {
this.inherited(arguments);
var e = this.hasNode();
e && (e.addEventListener("touchstart", this.touchHandler, !0), document.addEventListener("touchend", this.touchHandler, !0), document.addEventListener("touchmove", this.touchHandler, !0), document.addEventListener("touchcancel", this.touchHandler, !0));
},
touchHandler: function(e) {
var t = e.changedTouches[0], n = {
touchstart: "mousedown",
touchmove: "mousemove",
touchend: "mouseup"
}[e.type], r = {
screenX: t.screenX,
screenY: t.screenY,
clientX: t.clientX,
clientY: t.clientY,
ctrlKey: t.ctrlKey,
altKey: t.altKey,
shiftKey: t.shiftKey,
metaKey: t.metaKey,
relatedTarget: null
}, i = new MouseEvent(n, r), s = enyo.$[this.id];
this === document ? this.dispatchEvent(i) : typeof s != "undefined" && s !== null && s.bubble("on" + n, i, s), e.preventDefault();
},
downHandler: function(e, t) {
var n = $(this.hasNode()).position();
this.offset.x = n.left - t.clientX, this.offset.y = n.top - t.clientY, this.setPosition({
x: t.clientX,
y: t.clientY
}), this.eventHandlers.mousemove = enyo.bind(this, "moveHandler", this), this.eventHandlers.mouseup = enyo.bind(this, "upHandler", this), document.addEventListener("mousemove", this.eventHandlers.mousemove), document.addEventListener("mouseup", this.eventHandlers.mouseup), this.addClass("dragging"), this.fromColumn = this.owner, this.dragging = !0;
},
upHandler: function(e, t) {
document.removeEventListener("mousemove", this.eventHandlers.mousemove), document.removeEventListener("mouseup", this.eventHandlers.mouseup);
var n = document.elementFromPoint(t.clientX, t.clientY).id, r = n.match(/(frame_view\d_stage_\w+_columns_column_\d+|frame_view\d_stage_\w+_options)/);
if (r !== null && this.owner.id !== r[0]) {
var i = enyo.$[r[0]];
i.addOption(this.option), this.fromColumn.removeOption(this.option);
}
this.offset.x = null, this.offset.y = null, this.setPosition(null), this.removeClass("dragging"), this.dragging = !1;
},
moveHandler: function(e, t) {
this.setPosition({
x: t.clientX,
y: t.clientY
});
},
positionChanged: function() {
var e = this.getPosition();
if (e === null || e.x === null || e.y === null) {
this.applyStyle("left", null), this.applyStyle("top", null);
return;
}
this.applyStyle("left", e.x + this.offset.x + "px"), this.applyStyle("top", e.y + this.offset.y + "px");
},
stateChanged: function() {
this.addRemoveClass("correct", this.getState() === "solved"), this.addRemoveClass("wrong", this.getState() === "wrong");
}
});

// words/ColumnExercise.js

enyo.kind({
name: "educate.frame.components.columnExercise.ColumnExerciseWords",
kind: "educate.frame.components.columnExercise.ColumnExercise",
components: [ {
kind: "educate.frame.components.columnExercise.ColumnHolderWords",
name: "columns",
columns: this.columns
}, {
kind: "educate.frame.components.columnExercise.OptionContainerWords",
name: "options",
options: this.optionList
} ],
create: function() {
this.inherited(arguments);
},
columnsChanged: function() {
if (typeof this.getColumns() == "undefined") return;
this.inherited(arguments);
var e = [], t, n = this.getColumns().length;
for (t = 0; t < n; t++) e = e.concat(this.getColumns()[t].options || []);
this.optionList = shuffleArray(e), this.optionListChange();
},
optionListChange: function() {
if (typeof this.$.options == "undefined") return;
this.inherited(arguments), this.$.options.setOptions(this.getOptionList());
}
});

// words/ColumnHolder.js

enyo.kind({
name: "educate.frame.components.columnExercise.ColumnHolderWords",
kind: "educate.frame.components.columnExercise.ColumnHolder",
columnsChanged: function() {
this.inherited(arguments), this.destroyComponents(), this.destroyClientControls();
var e, t = this.getColumns().length, n = [];
for (e = 0; e < t; e++) {
var r = this.getColumns()[e];
n.push({
kind: "educate.frame.components.columnExercise.ColumnWords",
name: "column_" + e,
header: r.header,
options: r.options,
contents: r.contents,
groupedBy: r.groupedBy,
onchange: "onchangeHandler"
});
}
this.createComponents(n);
},
onchangeHandler: function(e) {
var t = e.getName().split("_")[1];
this.getColumns()[t].header = e.header, this.getColumns()[t].options = e.options, this.getColumns()[t].contents = e.contents;
},
resizeComponent: function() {
var e = this.getColumns().length - 1;
for (e; e >= 0; e--) {
var t = this.getColumns()[e], n = t.groupedBy.trim().replace(/\s+/g, "_"), r = this.$[n], i = this.$["column_" + e];
typeof r != "undefined" && (i = r.$["column_" + e]);
}
}
});

// words/OptionContainer.js

enyo.kind({
name: "educate.frame.components.columnExercise.OptionContainerWords",
kind: "educate.frame.components.columnExercise.OptionContainer",
optionsChanged: function() {
if (typeof this.options == "undefined") return;
this.$.container.destroyComponents(), this.$.container.destroyClientControls();
var e = this.getOptions(), t, n = e.length, r = [], i;
for (t = 0; t < n; t++) i = e[t], r.push({
kind: "educate.frame.components.columnExercise.OptionWord",
name: "word_" + t,
option: i,
parentElement: this
});
this.$.container.createComponents(r, {
owner: this
}), this.$.container.render();
}
});

// words/Column.js

enyo.kind({
name: "educate.frame.components.columnExercise.ColumnWords",
kind: "educate.frame.components.columnExercise.Column",
create: function() {
this.inherited(arguments), this.optionsChanged();
},
rendered: function() {
this.inherited(arguments), this.optionsChanged();
},
optionsChanged: function() {
this.$.container.destroyComponents(), this.$.container.destroyClientControls();
var e = this.getOptions(), t, n = e.length, r = [], i;
for (t = 0; t < n; t++) i = e[t], r.push({
kind: "educate.frame.components.columnExercise.OptionWord",
name: "word_" + t,
option: i,
parentElement: this
});
this.$.container.createComponents(r, {
owner: this
}), this.$.container.render(), this.inherited(arguments);
}
});

// words/Option.js

enyo.kind({
name: "educate.frame.components.columnExercise.OptionWord",
kind: "educate.frame.components.columnExercise.Option",
published: {
option: null,
parentElement: null
},
classes: "column-option",
components: [ {
tag: "span",
name: "spanOption",
content: this.option
} ],
create: function() {
this.inherited(arguments), this.optionChanged();
},
optionChanged: function() {
this.$.spanOption.setContent(this.getOption());
}
});

// images/ColumnExercise.js

enyo.kind({
name: "educate.frame.components.columnExercise.ColumnExerciseImages",
kind: "educate.frame.components.columnExercise.ColumnExercise",
components: [ {
kind: "educate.frame.components.columnExercise.ColumnHolderImages",
name: "columns",
columns: this.columns
}, {
kind: "educate.frame.components.columnExercise.OptionContainerImages",
name: "options",
options: this.optionList
} ],
classes: "column-exercise-images",
published: {
carrier: window.settings.CARRIERS.COLUMN_IMAGES
},
create: function() {
this.inherited(arguments);
},
columnsChanged: function() {
if (typeof this.getColumns() == "undefined") return;
this.inherited(arguments);
var e = [], t, n = this.getColumns().length;
for (t = 0; t < n; t++) e = e.concat(this.getColumns()[t].options || []);
this.optionList = shuffleArray(e), this.optionListChange();
},
optionListChange: function() {
if (typeof this.$.options == "undefined") return;
this.inherited(arguments), this.$.options.setOptions(this.getOptionList());
}
});

// images/ColumnHolder.js

enyo.kind({
name: "educate.frame.components.columnExercise.ColumnHolderImages",
kind: "educate.frame.components.columnExercise.ColumnHolder",
columnsChanged: function() {
this.inherited(arguments), this.destroyComponents(), this.destroyClientControls();
var e, t = this.getColumns().length, n = [];
for (e = 0; e < t; e++) {
var r = this.getColumns()[e];
n.push({
kind: "educate.frame.components.columnExercise.ColumnImages",
name: "column_" + e,
header: r.header,
options: r.options,
contents: r.contents,
groupedBy: r.groupedBy,
onchange: "onchangeHandler"
});
}
this.createComponents(n);
},
onchangeHandler: function(e) {
var t = e.getName().split("_")[1];
this.getColumns()[t].header = e.header, this.getColumns()[t].options = e.options, this.getColumns()[t].contents = e.contents;
},
resizeComponent: function() {
var e = this.getColumns().length - 1;
for (e; e >= 0; e--) {
var t = this.getColumns()[e], n = t.groupedBy.trim().replace(/\s+/g, "_"), r = this.$[n], i = this.$["column_" + e];
typeof r != "undefined" && (i = r.$["column_" + e]);
}
}
});

// images/OptionContainer.js

enyo.kind({
name: "educate.frame.components.columnExercise.OptionContainerImages",
kind: "educate.frame.components.columnExercise.OptionContainer",
components: [ {
name: "headerGroup",
classes: "column-header column-header-group",
components: [ {
kind: educate.components.oplossing.OplossingButton,
name: "solutionButton"
}, {
tag: "h1",
name: "header",
content: this.header
} ]
}, {
name: "container",
classes: "column-content"
} ],
classes: "column-options-images",
published: {
previewImage: null
},
optionsChanged: function() {
if (typeof this.options == "undefined") return;
this.$.container.destroyComponents(), this.$.container.destroyClientControls();
var e = this.getOptions(), t, n = e.length, r = [], i;
for (t = 0; t < n; t++) i = e[t], r.push({
kind: "educate.frame.components.columnExercise.OptionImage",
name: "image_" + t,
option: i,
parentElement: this
});
this.$.container.createComponents(r, {
owner: this
}), this.$.container.render();
}
});

// images/Column.js

enyo.kind({
name: "educate.frame.components.columnExercise.ColumnImages",
kind: "educate.frame.components.columnExercise.Column",
create: function() {
this.inherited(arguments), this.optionsChanged();
},
rendered: function() {
this.inherited(arguments), this.optionsChanged();
},
optionsChanged: function() {
this.$.container.destroyComponents(), this.$.container.destroyClientControls();
var e = this.getOptions(), t, n = e.length, r = [], i;
for (t = 0; t < n; t++) i = e[t], r.push({
kind: "educate.frame.components.columnExercise.OptionImage",
name: "image_" + t,
option: i,
parentElement: this
});
this.$.container.createComponents(r, {
owner: this
}), this.$.container.render(), this.inherited(arguments);
}
});

// images/Option.js

enyo.kind({
name: "educate.frame.components.columnExercise.OptionImage",
kind: "educate.frame.components.columnExercise.Option",
published: {
option: null,
parentElement: null
},
fullscreen: !1,
handlers: {
ontap: "ontapHandler"
},
classes: "column-option column-option-image",
components: [ {
kind: enyo.Image,
name: "imgOption"
} ],
create: function() {
this.inherited(arguments), this.optionChanged();
},
rendered: function() {
this.inherited(arguments), this.applyStyle("max-width", parseInt(window.settings.SCALE * 175) + "px");
},
optionChanged: function() {
this.$.imgOption.setSrc(Settings.WEBAPP + this.getOption().value);
},
ontapHandler: function() {
return this.fullscreen = !this.fullscreen, this.addRemoveClass("fullscreen", this.fullscreen), !0;
}
});

// Flipcard.js

enyo.kind({
name: "educate.frame.components.flipcard.Flipcard",
kind: "educate.components.flipcard.Flipcard",
tag: "div",
published: {},
create: function() {
this.inherited(arguments), this.resizeComponent(), this.changeBackSide();
},
doFlip: function() {
this.setFlipSpeed(this.getFlipped() ? 0 : .6), this.node.children[0].classList.add("flip"), this.setFlipped(!0), this.resizeBorder();
},
downHandler: function(e, t) {
t.preventDefault();
var n, r, i = $(e.hasNode()).offset(), s = $(this.getStage().hasNode()).offset();
t.type === "touchmove" ? (n = t.touches[0].clientX, r = t.touches[0].clientY) : (n = t.clientX, r = t.clientY), this.setClickX(n - i.left), this.setClickY(r - i.top);
var o = n - s.left, u = r - s.top, a = o - this.absoluteOrigin.x, f = u - this.absoluteOrigin.y;
this.startRotation = Math.atan2(f, a) * 180 / Math.PI - this.rotation_z;
},
ontapHandler: function() {
event.preventDefault();
},
move: function(e) {
this.inherited(arguments), this.getFlipped() && this.doFlip();
},
redraw: function() {
this.inherited(arguments), this.getFlipped() && this.doFlip();
}
});

// Groep.js

enyo.kind({
name: "educate.frame.components.groep.Groep",
kind: "educate.components.groep.Groep",
published: {},
create: function() {
this.inherited(arguments), this.redrawGroup();
},
downHandler: function(e, t) {
t.preventDefault(), this.setClickX(t.clientX - $(e.hasNode()).offset().left), this.setClickY(t.clientY - $(e.hasNode()).offset().top);
}
});

// Image.js

enyo.kind({
name: "educate.frame.components.image.Image",
kind: "educate.components.image.Image",
published: {},
create: function() {
this.inherited(arguments), this.valueChanged(), this.redrawImage();
},
downHandler: function(e, t) {
t.preventDefault();
var n, r, i = $(e.hasNode()).offset(), s = $(this.getStage().hasNode()).offset();
t.type === "touchmove" ? (n = t.touches[0].clientX, r = t.touches[0].clientY) : (n = t.clientX, r = t.clientY), this.setClickX(n - i.left), this.setClickY(r - i.top);
var o = n - s.left, u = r - s.top, a = o - this.absoluteOrigin.x, f = u - this.absoluteOrigin.y;
this.startRotation = Math.atan2(f, a) * 180 / Math.PI - this.rotation_z;
},
ontapHandler: function() {
event.preventDefault();
}
});

// Cijferveld.js

enyo.kind({
name: "educate.frame.components.input.Cijferveld",
kind: "educate.components.input.Cijferveld",
published: {
allowSleepChange: !1,
startPosX: "",
startPosY: "",
dX: "",
dY: ""
},
handlers: {
ontap: "ontapHandler",
inputNumberAdded: "inputNumberAddedHandler",
onEnterClick: "inputNumberAddedHandler"
},
create: function() {
this.inherited(arguments);
},
willekeurig1Changed: function() {
this.getWillekeurig1() && this.getRandom("w1");
},
willekeurig2Changed: function() {
this.getWillekeurig2() && this.getRandom("w2");
},
willekeurig3Changed: function() {
this.getWillekeurig3() && this.getRandom("w3");
},
valueChanged: function() {
this.inherited(arguments), this.checkOplossing();
},
value2Changed: function() {
this.inherited(arguments), this.checkOplossing();
},
value3Changed: function() {
this.inherited(arguments), this.checkOplossing();
},
ontapHandler: function(e, t) {
var n = null;
switch (!0) {
case !this.getHasValue2() && !this.getHasValue3():
n = this.$.txtNumber;
break;
case this.getHasValue2() && !this.getHasValue3():
n = t.srcEvent.layerX < this.node.offsetWidth * .5 ? this.$.txtNumber : this.$.txtNumber2;
break;
case !this.getHasValue2() && this.getHasValue3():
n = t.srcEvent.layerX < this.node.offsetWidth * .5 ? this.$.txtNumber : this.$.txtNumber3;
break;
case this.getHasValue2() && this.getHasValue3():
n = t.srcEvent.layerX < this.node.offsetWidth * .33 ? this.$.txtNumber : t.srcEvent.layerX < this.node.offsetWidth * .66 ? this.$.txtNumber2 : this.$.txtNumber3;
}
return this.activateField(n);
},
onTapHandlerWaarde: function(e, t) {
return this.activateField(t.originator);
},
activateField: function(e) {
var t = this.hasNode();
if (!t || !e || !this.getEditable()) return !1;
this.$.txtNumber.removeClass("active"), this.$.txtNumber2.removeClass("active"), this.$.txtNumber3.removeClass("active");
if (this.$.numberInput && this.$.numberInput.inputVeld === e && this.$.numberInput.getShowing()) return this.$.numberInput.close(), !0;
e.addClass("active");
var n = "", r = t.clientHeight + this.calculatedPosY + 5, i = t.clientWidth * .5 + this.calculatedPosX - 120, s = "width: 240px; top: " + r + "px; left: " + i + "px;";
this.$.numberInput || this.createComponent({
kind: "educate.hulpklassen.numberInput.NumberInput",
name: "numberInput",
container: this.container,
onEnterClick: "inputNumberAddedHandler",
afronding: this.getRound(),
style: s
});
var o = parseFloat(e.content.replace(",", "."));
return this.$.numberInput.inputVeld = e, this.$.numberInput.number = isNaN(o) ? "" : o, this.$.numberInput.setClasses("numberInput " + n), this.$.numberInput.render(), this.$.numberInput.numberChanged(), this.$.numberInput.selectText(), this.$.numberInput.setShowing(!0), !0;
},
inputNumberAddedHandler: function(e, t) {
return t.inputVeld == "txtNumber" ? this.setValue(t.nr) : t.inputVeld == "txtNumber2" ? this.setValue2(t.nr) : t.inputVeld == "txtNumber3" && this.setValue3(t.nr), !0;
},
downHandler: function(e, t) {
t.preventDefault(), this.setClickX(t.clientX - $(e.hasNode()).offset().left), this.setClickY(t.clientY - $(e.hasNode()).offset().top);
},
onDownHandlerWaarde: function(e, t) {
t.preventDefault(), this.getSleepbaar() && (this.setAllowSleepChange(!0), this.setStartPosY(t.pageY), $(document).on("mousemove", {
numberField: e.name
}, enyo.bind(this, "onMoveHandler")), $(document).on("mouseup", enyo.bind(this, "onUpHandler")));
},
onMoveHandler: function(e) {
if (this.getAllowSleepChange()) {
this.dY = this.getStartPosY() - e.pageY, this.setStartPosY(e.pageY);
if (e.data.numberField == "txtNumber") {
var t = this.getValue() + this.dY / Math.pow(10, this.getRound());
this.setValue(this.checkDraaiDoor(t, this.getMinimum1(), this.getMaximum1(), this.getSpinner1(), 1));
} else if (e.data.numberField == "txtNumber2") {
var t = this.getValue2() + this.dY / Math.pow(10, this.getRound());
this.setValue2(this.checkDraaiDoor(t, this.getMinimum2(), this.getMaximum2(), this.getSpinner2(), 2));
} else if (e.data.numberField == "txtNumber3") {
var t = this.getValue3() + this.dY / Math.pow(10, this.getRound());
this.setValue3(this.checkDraaiDoor(t, this.getMinimum3(), this.getMaximum3(), this.getSpinner3(), 3));
}
}
},
onUpHandler: function(e) {
this.setAllowSleepChange(!1), $(document).off("mousemove"), $(document).off("mouseup");
},
checkDraaiDoor: function(e, t, n, r, i) {
e = parseFloat(e);
if (r) {
if (t && e < t) return this.getTeller() && i != 1 && this.valueMin(i - 1), n;
if (n && e > n) return this.getTeller() && i != 1 && this.valuePlus(i - 1), t;
}
return e;
},
valuePlus: function(e) {
e == 1 ? this.setValue(this.getValue() + 1) : e == 2 && this.setValue2(this.getValue2() + 1);
},
valueMin: function(e) {
e == 1 ? this.setValue(this.getValue() - 1) : e == 2 && this.setValue2(this.getValue2() - 1);
},
calculatedFontSizeChanged: function() {
this.applyStyle("font-size", this.calculatedFontSize + "rem"), this.applyStyle("line-height", 1.7 * this.calculatedFontSize + "rem");
},
onSolutionHandler: function(e, t) {
this.inherited(arguments), this.toggleOplossing();
},
toggleOplossing: function() {
this.$.oplossing1.setContent(this.getValue() !== "" ? parseFloat(this.getSolution()).toFixed(this.getRound()) : "???"), this.$.oplossing2.setContent(this.getValue2() !== "" ? parseFloat(this.getSolution2()).toFixed(this.getRound()) : "???"), this.$.oplossing3.setContent(this.getValue3() !== "" ? parseFloat(this.getSolution3()).toFixed(this.getRound()) : "???"), this.replacePointByComma(this.$.oplossing1), this.replacePointByComma(this.$.oplossing2), this.replacePointByComma(this.$.oplossing3), this.checkOplossing(), (this.getValue() !== "" || this.getHasValue2() && this.getValue2() !== "" || this.getHasValue3() && this.getValue3() !== "") && this.getSolution() !== "" && this.getSolution2() !== "" && this.getSolution3() !== "" ? this.$.oplossing.addRemoveClass("hidden", !this.$.oplossing.hasClass("hidden")) : this.$.oplossing.addClass("hidden");
},
checkOplossing: function() {
var e, t;
this.getSolution() !== "" && this.getValue() !== "" ? (e = parseFloat(this.getSolution()).toFixed(this.getRound()).trim().toLowerCase(), t = parseFloat(this.getValue()).toFixed(this.getRound()).trim().toLowerCase(), this.$.oplossing1.addRemoveClass("correct", e === t), this.$.oplossing1.addRemoveClass("wrong", e !== t)) : (this.$.oplossing1.removeClass("correct"), this.$.oplossing1.removeClass("wrong")), this.getSolution2() !== "" && this.getValue2() !== "" ? (e = parseFloat(this.getSolution2()).toFixed(this.getRound()).trim().toLowerCase(), t = parseFloat(this.getValue2()).toFixed(this.getRound()).trim().toLowerCase(), this.$.oplossing2.addRemoveClass("correct", e === t), this.$.oplossing2.addRemoveClass("wrong", e !== t)) : (this.$.oplossing2.removeClass("correct"), this.$.oplossing2.removeClass("wrong")), this.getSolution3() !== "" && this.getValue3() !== "" ? (e = parseFloat(this.getSolution3()).toFixed(this.getRound()).trim().toLowerCase(), t = parseFloat(this.getValue3()).toFixed(this.getRound()).trim().toLowerCase(), this.$.oplossing3.addRemoveClass("correct", e === t), this.$.oplossing3.addRemoveClass("wrong", e !== t)) : (this.$.oplossing3.removeClass("correct"), this.$.oplossing3.removeClass("wrong"));
}
});

// InputField.js

enyo.kind({
name: "educate.frame.components.input.InputField",
kind: "educate.components.input.InputField",
create: function() {
this.inherited(arguments);
},
rendered: function() {
this.inherited(arguments);
},
onblurHandler: function() {
this.setValue(this.$.inputField.getValue());
},
valueChanged: function() {
this.$.inputField.setValue(this.getValue());
},
downHandler: function(e, t) {
var n, r, i = $(e.hasNode()).offset(), s = $(this.getStage().hasNode()).offset();
t.type === "touchmove" ? (n = t.touches[0].clientX, r = t.touches[0].clientY) : (n = t.clientX, r = t.clientY), this.setClickX(n - i.left), this.setClickY(r - i.top);
var o = n - s.left, u = r - s.top, a = o - this.absoluteOrigin.x, f = u - this.absoluteOrigin.y;
this.startRotation = Math.atan2(f, a) * 180 / Math.PI - this.rotation_z;
},
ontapHandler: function() {}
});

// lijnstuk.js

enyo.kind({
name: "educate.frame.components.input.Lijnstuk",
kind: "educate.components.input.Lijnstuk",
published: {
position_x: 20,
position_y: 50,
width: 220,
height: 50,
value: null,
rotation: null,
css_class: educate.components.input.Lijnstuk.LINE
},
downHandler: function(e, t) {
var n = $(this.getView().$.stage.hasNode()).offset(), r, i;
t.type === "touchmove" ? (r = t.touches[0].clientX, i = t.touches[0].clientY) : (r = t.clientX, i = t.clientY);
var s = (r - n.left) / window.settings.SCALE + .5 >> 0, o = (i - n.top) / window.settings.SCALE + .5 >> 0;
this.setClickX(s - this.position_x), this.setClickY(o - this.position_y);
var u = r - $(this.getStage().hasNode()).offset().left, a = i - $(this.getStage().hasNode()).offset().top, f = u - this.absoluteOrigin.x, l = a - this.absoluteOrigin.y;
this.startRotation = Math.atan2(l, f) * 180 / Math.PI - this.rotation, this.getOptions().dragable || this.getOptions().begin_point_dragable || this.getOptions().end_point_dragable ? (this.inherited(arguments), s - this.getPosition_x() >= -this.padding && s - this.getPosition_x() <= this.padding && o - this.getPosition_y() >= -this.padding && o - this.getPosition_y() <= this.padding && this.getOptions().begin_point_dragable ? (this.drag_position = "begin", this.lastChange = "coords") : s - this.getWidth() >= -this.padding && s - this.getWidth() <= this.padding && o - this.getHeight() >= -this.padding && o - this.getHeight() <= this.padding && this.getOptions().end_point_dragable ? (this.drag_position = "end", this.lastChange = "coords") : this.getOptions().dragable && (this.drag_position = "normal", this.lastChange = "rot")) : t.preventDefault();
},
dragObjectHandler: function(e) {
var t = $(this.getView().$.stage.hasNode()).offset(), n = (e.touches[0].clientX - t.left) / window.settings.SCALE + .5 >> 0, r = (e.touches[0].clientY - t.top) / window.settings.SCALE + .5 >> 0;
this.drag_position === "begin" && this.getOptions().begin_point_dragable ? (this.position_x = n, this.position_y = r, this.coordsChanged()) : this.drag_position === "end" && this.getOptions().end_point_dragable ? (this.width = n, this.height = r, this.coordsChanged()) : this.getOptions().dragable && (this.position_x = n - this.getClickX(), this.position_y = r - this.getClickY(), this.rotValChanged());
},
upHandler: function() {
$(document).off("mousemove"), $(document).off("mouseup"), document.ontouchmove = null, document.ontouchend = null;
},
rotate: function(e) {
var t = this.hasNode();
t && (this.boundingBox = {
x: t.offsetLeft,
y: t.offsetTop,
width: t.offsetWidth,
height: t.offsetHeight
}, this.absoluteOrigin = {
x: window.settings.SCALE * this.getPosition_x(),
y: window.settings.SCALE * this.getPosition_y()
});
var n, r;
e.type === "touchmove" ? (n = e.touches[0].clientX, r = e.touches[0].clientY) : (n = e.clientX, r = e.clientY);
var i = n - $(this.getStage().hasNode()).offset().left, s = r - $(this.getStage().hasNode()).offset().top, o = i - this.absoluteOrigin.x, u = s - this.absoluteOrigin.y;
this.rotation = Math.atan2(u, o) * 180 / Math.PI - this.startRotation, this.rotValChanged(), this.setClickX(n), this.setClickY(r);
},
ontapHandler: function(e, t) {
t.preventDefault();
}
});

// KolomWoorden.js

enyo.kind({
name: "educate.frame.components.kolomOefening.KolomWoorden",
kind: "educate.components.kolomOefening.KolomWoorden",
published: {
width: 1200,
height: 730,
position_x: 0,
position_y: 0,
objType: "div_",
classes: "columnFrame",
words: [],
columns: 3,
splitCols: "{}",
titles: [],
maxWords: 40
},
classes: "kolomOefening",
handlers: {
onPropertiesChanged: "onPropertiesChangedHandler",
ondown: "downHandler"
},
components: [ {
tag: "div",
name: "placeColumns",
classes: "placeColumns"
}, {
tag: "div",
name: "pickColumn",
classes: "wordColumn picker",
components: [ {
tag: "img",
name: "pp_icon",
classes: "smallImg",
src: ""
}, {
tag: "div",
name: "quizTypes",
classes: "columnQuestion",
components: [ {
tag: "p",
name: "quiz",
classes: "viewQuestion"
} ]
}, {
tag: "ul",
name: "wordList",
classes: "wordList ori"
} ]
} ],
create: function() {
this.inherited(arguments), this.redrawPicker("view"), this.$.quiz.setContent(this.titles[this.columns]), this.drawPlaceColumns();
},
rendered: function() {
this.inherited(arguments);
},
drawPlaceColumns: function() {
var e = 1, t = e * (this.columns - 1), n = (100 - t) / this.columns, r = [], i = JSON.parse(this.splitCols);
this.$.placeColumns.destroyClientControls();
for (var s = 0; s < this.columns; s++) {
t = e * (this.columns - 1), n = (100 - t) / this.columns, this.$.placeColumns.createComponent({
tag: "div",
name: "pickColumn_" + s,
style: "width:" + n + "%;top:0%;left:" + s * (n + e) + "%;",
classes: "picker",
components: [ {
tag: "div",
classes: "columnMessagebox",
name: "messagebox" + s,
showing: !1,
components: [ {
tag: "p",
name: "message" + s,
content: "Opgelet! Teveel woorden in kolom!"
} ]
}, {
tag: "div",
name: "quizTypes" + s,
classes: "quizTypes",
components: [ {
tag: "p",
name: "title" + s,
content: this.titles[s],
classes: "viewQuestion"
} ]
}, {
tag: "div",
name: "words_" + s,
classes: "wordList",
attributes: {
indexNumber: s
},
components: [ {
tag: "div",
name: "wordList_" + s,
style: "-moz-column-count: 3;-moz-column-gap: 20px;-webkit-column-count: 3;-webkit-column-gap: 20px;"
} ]
} ]
}, {
owner: this
});
if (i[s]) {
var o = i[s].column, u = this.$["pickColumn_" + o], a = u.children.length;
s = o;
for (var f = 0; f < a; f++) u.children[f] && u.children[f].name != "quizTypes" + s && (u.children[f].destroy(), f--);
a = i[s].splits, e = 1, t = e * (a - 1), n = (100 - t) / a;
for (var l = 0; l < a; l++) {
u.createComponent({
tag: "div",
name: "pickColumn_" + s + "/" + l,
style: "width:" + n + "%;left:" + l * (n + e) + "%;",
classes: "splitPicker",
components: [ {
tag: "div",
classes: "columnMessagebox",
name: "messagebox" + s + "/" + l,
showing: !1,
components: [ {
tag: "p",
name: "message" + s + "/" + l,
content: "Opgelet! Teveel woorden in kolom!"
} ]
}, {
tag: "div",
name: "quizTypes" + s + "/" + l,
classes: "quizTypes",
components: [ {
tag: "p",
name: "title" + s + "/" + l,
content: i[s].titles[l],
classes: "viewQuestion"
} ]
}, {
tag: "div",
name: "words_" + s + "/" + l,
classes: "wordList",
attributes: {
indexNumber: s + "/" + l
},
components: [ {
tag: "div",
name: "wordList_" + s + "/" + l,
style: "-moz-column-count: 3;-moz-column-gap: 20px;-webkit-column-count: 3;-webkit-column-gap: 20px;"
} ]
} ]
}, {
owner: this
});
var c = i[s].words[l].split(";");
for (var h = 0; h < c.length - 1; h++) r.push(c[h]);
}
}
}
var p = 0, d = 0;
for (var l = 0; l < this.words.length; l++) if (this.words[l] != null) {
var c = this.words[l].split(";");
for (var h = 0; h < c.length - 1; h++) r.push(c[h]);
}
r = shuffleArray(r);
for (var v = 0; v < (r.length - 1 >= this.maxWords ? this.maxWords : r.length); v++) this.$.wordList.createComponent({
kind: "educate.components.kolomOefening.PickWordObject",
viewId: this.viewId,
position_x: 10 + p * 120,
position_y: 70 + d,
word: r[v],
name: r[v] + "_" + v
}), p++, p == 10 && (p = 0, d += 70);
this.$.placeColumns.render();
},
downHandler: function(e, t) {
t.preventDefault();
},
ontapHandler: function() {
event.preventDefault();
}
});

// KolomAfbeeldingen.js

enyo.kind({
name: "educate.frame.components.kolomOefening.KolomAfbeeldingen",
kind: "educate.components.kolomOefening.KolomAfbeeldingen",
published: {
width: 1200,
height: 730,
position_x: 0,
position_y: 0,
objType: "div_",
classes: "columnFrame",
words: [],
columns: 3,
titles: [],
maxWords: 12
},
style: "position: absolute;",
handlers: {
onPropertiesChanged: "onPropertiesChangedHandler",
ondown: "downHandler",
setImageDetail: "setImageDetailHandler"
},
components: [ {
tag: "div",
name: "placeColumns"
}, {
tag: "div",
name: "pickColumn",
style: "width:100%;height:40%;top:60%;",
classes: "picker",
components: [ {
tag: "img",
name: "pp_icon",
classes: "smallImg",
src: ""
}, {
tag: "div",
name: "quizTypes",
classes: "columnQuestion",
components: [ {
tag: "p",
name: "quiz",
classes: "viewQuestion"
} ]
}, {
tag: "ul",
name: "wordList",
classes: "ori imageList"
}, {
tag: "div",
name: "zoomOnImage",
classes: "zoomOnImage",
components: [ {
tag: "span",
style: "display: inline-block;height: 100%;vertical-align: middle;"
}, {
tag: "img",
name: "imageDetail"
} ]
} ]
} ],
create: function() {
this.inherited(arguments), this.redrawPicker("view"), this.$.quiz.setContent(this.titles[this.columns]), this.drawPlaceColumns();
},
rendered: function() {
this.inherited(arguments);
},
drawPlaceColumns: function() {
this.$.placeColumns.destroyClientControls();
for (var e = 0; e < this.columns; e++) this.$.placeColumns.createComponent({
tag: "div",
name: "pickColumn_" + e,
style: "width:" + 96 / this.columns + "%;height:58%;top:0%;left:" + e * (101 / this.columns) + "%;",
classes: "picker",
components: [ {
tag: "div",
classes: "columnMessagebox",
name: "messagebox" + e,
showing: !1,
components: [ {
tag: "p",
name: "message" + e,
content: "Opgelet! Teveel woorden in kolom!"
} ]
}, {
tag: "div",
name: "quizTypes" + e,
classes: "quizTypes",
components: [ {
tag: "p",
name: "title" + e,
content: this.titles[e],
classes: "viewQuestion"
} ]
}, {
tag: "div",
name: "words_" + e,
classes: "wordList",
attributes: {
indexNumber: e
},
components: [ {
tag: "div",
name: "wordList_" + e,
style: "-moz-column-count: 3;-moz-column-gap: 20px;-webkit-column-count: 3;-webkit-column-gap: 20px;"
} ]
} ]
}, {
owner: this
});
var t = 0, n = 0, r = [];
for (var i = 0; i < this.words.length; i++) if (this.words[i] != null) {
var s = this.words[i].split(";");
for (var o = 0; o < s.length - 1; o++) r.push(s[o]);
}
r = shuffleArray(r);
for (var u = 0; u < r.length; u++) this.$.wordList.createComponent({
kind: "educate.components.kolomOefening.PickImageObject",
viewId: this.viewId,
position_x: 10 + t * 120,
position_y: 70 + n,
word: r[u],
name: r[u] + "_" + u
}), t++, t == 10 && (t = 0, n += 70);
this.$.placeColumns.render();
},
setImageDetailHandler: function(e, t) {
this.$.imageDetail.setProperty("src", t.image);
},
downHandler: function(e, t) {
t.preventDefault();
},
ontapHandler: function() {
event.preventDefault();
}
});

// Map.js

enyo.kind({
name: "educate.frame.components.map.Map",
kind: "educate.components.map.Map",
published: {},
components: [ {
kind: "enyo.Input",
name: "txtAdresInput",
placeholder: "Adres",
classes: "adresInputMaps",
type: "text",
onkeydown: "inputKeyHandler",
ontap: "adresInputTapped"
}, {
tag: "div",
name: "mapCanvas",
classes: "map-canvas"
} ],
create: function() {
this.inherited(arguments);
},
rendered: function() {
this.inherited(arguments), this.initialize();
},
downHandler: function(e, t) {
t.preventDefault(), this.setClickX(t.clientX - $(e.hasNode()).offset().left), this.setClickY(t.clientY - $(e.hasNode()).offset().top);
},
ontapHandler: function() {
event.preventDefault();
},
adresInputTapped: function(e, t) {
this.$.txtAdresInput.focus();
},
inputKeyHandler: function(e, t) {
t.keyCode === 13 && this.$.txtAdresInput.getValue() !== "" && this.showLocationByAddress(this.$.txtAdresInput.getValue());
}
});

// Meetlat.js

enyo.kind({
name: "educate.frame.components.meetlat.Meetlat",
kind: "educate.components.meetlat.Meetlat",
classes: "meetlatView",
published: {
width: 0,
height: 70,
position_x: 150,
position_y: 100,
rotation_z: "0",
rotation_x: "0",
rotation_y: "0",
objType: "div_",
stretch: 0,
rotateN: 0,
originalWidth: 0,
lengte: 10,
originalLength: 0,
unit: "",
divide: 10,
cmPerPixel: .025,
pixelPerCm: 40,
shiftY: !1,
shiftX: !1,
overstaande: 0,
aanliggende: 0
},
handlers: {
onPropertiesChanged: "onPropertiesChangedHandler"
},
components: [ {
tag: "div",
id: "rotateL",
classes: "rotate",
ondown: "downHandler",
components: [ {
tag: "i",
classes: "icon-refresh"
} ]
}, {
tag: "ul",
name: "ruler",
classes: "ruler"
}, {
tag: "p",
name: "unit"
}, {
tag: "div",
id: "stretch",
ondown: "downHandler",
components: [ {
tag: "i",
classes: "icon-resize-horizontal"
} ]
}, {
tag: "div",
id: "rotateR",
classes: "rotate",
ondown: "downHandler",
components: [ {
tag: "i",
classes: "icon-refresh"
} ]
} ],
create: function() {
this.inherited(arguments), this.width = (this.unit == "cm" ? this.lengte : this.lengte / 10) * this.pixelPerCm + this.pixelPerCm - 20, this.originalWidth = this.width, this.originalLength = this.lengte, this.render(), this.redrawRuler();
},
rendered: function() {
this.inherited(arguments), this.applyStyle("-webkit-transform", "rotateX(0deg) rotateY(0deg) rotateZ(" + this.rotateN.toString() + "deg) perspective(1000);");
},
visibleChanged: function() {
this.applyStyle("opacity", this.getVisible() !== !1 ? 1 : .25), this.addOption("visible", this.getVisible());
},
addPropertiesToOptions: function() {
this.addOption("lengte", this.lengte), this.addOption("unit", this.unit), this.addOption("divide", this.divide);
},
onPropertiesChangedHandler: function(e, t) {
t.linked == this && (this.layername = t.linked.layername, this.value != "" && this.setValue(t.linked.value), this.resizeComponent());
},
downHandler: function(e, t) {
if (e.tag == "ul") {
this.inherited(arguments);
if (!this.getLocked()) return $(document).on("mousemove", enyo.bind(this, "dragObjectHandler")), !0;
} else switch (e.id) {
case "stretch":
$(document).on("mousemove", enyo.bind(this, "stretchObject"));
break;
case "rotateR":
$(document).on("mousemove", enyo.bind(this, "rotateObjectR"));
break;
case "rotateL":
$(document).on("mousemove", enyo.bind(this, "rotateObjectL"));
}
$(document).on("mouseup", enyo.bind(this, "upHandler"));
},
dragObjectHandler: function(e) {
this.inherited(arguments), this.removeClass("meetlatR"), this.addClass("meetlatL"), this.calculatedPosX = e.clientX - $(".w" + this.getViewId()).offset().left - this.getClickX() + window.settings.OFFSETX, this.calculatedPosY = e.clientY - $(".w" + this.getViewId()).offset().top - this.getClickY() + window.settings.OFFSETY, this.rotateN >= 0 ? (this.removeClass("meetlatL"), this.addClass("meetlatR")) : (this.removeClass("meetlatR"), this.addClass("meetlatL")), this.render();
},
stretchObject: function(e) {
this.removeClass("meetlatL"), this.addClass("meetlatR");
var t = math.round(parseInt($(".stage").css("margin-left").replace("px", 0))), n = {
x: this.position_x,
y: this.position_y
}, r = {
x: math.round((e.clientX - t) / window.settings.SCALE),
y: (e.clientY - 55) / window.settings.SCALE - window.settings.OFFSETY / window.settings.SCALE
};
this.stretch = math.sqrt(math.pow(math.abs(n.x - r.x), 2) + math.pow(math.abs(n.y - r.y), 2)) - this.originalWidth;
var i = math.floor(this.stretch / this.pixelPerCm);
this.unit == "mm" && (i *= 10), this.lengte = this.originalLength + i;
if (this.lengte < 1) return !1;
this.redrawRuler();
},
rotateObjectR: function(e) {
this.removeClass("meetlatL"), this.addClass("meetlatR"), this.removeClass("meetlatM"), this.overstaande > 0 && this.shiftY && (this.shiftY = !1, this.position_x += this.stretch + this.originalWidth - this.aanliggende, this.rotateN > 0 ? this.position_y -= this.overstaande : this.position_y += this.overstaande);
var t = 0, n = math.round(parseInt($(".stage").css("margin-left").replace("px", 0))), r = {
x: this.position_x,
y: this.position_y
}, i = {
x: math.round((e.clientX - n) / window.settings.SCALE),
y: (e.clientY - 55) / window.settings.SCALE - window.settings.OFFSETY / window.settings.SCALE
};
i.x > r.x ? t = math.atan(math.abs(r.y - i.y) / math.abs(i.x - r.x)) * 180 / Math.PI : t = 90;
var s = t / 180 * Math.PI;
this.overstaande = math.sin(s) * (this.stretch + this.originalWidth), this.aanliggende = math.cos(s) * (this.stretch + this.originalWidth), this.shiftX = !0, t > 3 ? i.y <= r.y ? this.rotateN = -t : this.rotateN = t : this.rotateN = 0, this.redrawRuler();
},
rotateObjectL: function(e) {
this.removeClass("meetlatR"), this.removeClass("meetlatM"), this.addClass("meetlatL");
var t = 0, n = math.round(parseInt($(".stage").css("margin-left").replace("px", 0)));
this.overstaande > 0 && this.shiftX && (this.shiftX = !1, this.rotateN > 0 ? (this.position_x -= this.stretch + this.originalWidth - this.aanliggende - 2, this.position_y += this.overstaande + 5) : (this.position_x -= this.stretch + this.originalWidth - this.aanliggende + 6, this.position_y -= this.overstaande + 9));
var r = {
x: this.position_x + this.width,
y: this.position_y
}, i = {
x: math.round((e.clientX - n) / window.settings.SCALE),
y: (e.clientY - 55) / window.settings.SCALE - window.settings.OFFSETY / window.settings.SCALE
};
i.x < r.x ? t = math.atan(math.abs(r.y - i.y) / math.abs(i.x - r.x)) * 180 / Math.PI : t = 90;
var s = t / 180 * Math.PI;
this.overstaande = math.sin(s) * (this.stretch + this.originalWidth), this.aanliggende = math.cos(s) * (this.stretch + this.originalWidth), this.shiftY = !0, t > 3 ? i.y <= r.y ? this.rotateN = t : this.rotateN = -t : this.rotateN = 0, this.redrawRuler();
}
});

// MultipleChoice.js

enyo.kind({
name: "educate.frame.components.multipleChoice.MultipleChoice",
kind: "educate.components.multipleChoice.MultipleChoice",
handlers: {
checkMultipleChoice: "checkMultipleChoiceHandler",
onShowSolution: "showSolutionHandler",
onHideSolution: "hideSolutionHandler"
},
create: function() {
this.inherited(arguments), this.updateMultipleChoice(), this.getSolutionFromFrame() && this.$.btnCheckMultipleChoice.setShowing(!1);
},
rendered: function() {
this.inherited(arguments);
},
updateMultipleChoice: function() {
this.inherited(arguments);
var e = this.getShuffleAnswers() ? shuffleArray(this.selectOptions) : this.selectOptions;
for (var t in e) this.$.choiceList.createComponents([ {
tag: "li",
correct: e[t].correct,
ontap: "mulitpleChoiceItemClicked",
components: [ {
tag: "i",
classes: "fill-icon"
}, {
kind: "enyo.Checkbox",
id: "chkMultipleChoiceItem_" + this.getName() + t,
checked: !1
}, {
tag: "label",
classes: "checkbox-multiple-choice",
content: e[t].text,
attributes: {
"for": "chkMultipleChoiceItem_" + t
}
} ]
} ], {
owner: this
});
this.$.choiceList.render();
},
checkMultipleChoiceHandler: function(e, t) {
this.solutionFromFrame && this.checkMultipleChoice();
},
showSolutionHandler: function(e, t) {
this.solutionFromFrame || this.checkMultipleChoice();
},
hideSolutionHandler: function(e, t) {
this.removeFeedback();
},
checkMultipleChoice: function() {
this.removeFeedback();
var e = this.$.choiceList.children.length;
while (--e >= 0) {
var t = this.$.choiceList.children[e];
if (t.children[1].getChecked() || t.correct) t.children[1].getChecked() === t.correct ? (t.children[0].addClass("fill-icon icon-check-2"), t.addClass("correct")) : (t.children[0].addClass("fill-icon icon-delete-2"), t.addClass("wrong"));
}
},
removeFeedback: function() {
this.removeClassesFromMultipleChoiceItems();
},
removeClassesFromMultipleChoiceItems: function() {
var e = this.$.choiceList.children.length;
while (--e >= 0) {
var t = this.$.choiceList.children[e];
t.removeClass("correct"), t.removeClass("wrong"), t.children[0].removeClass("icon-check-2"), t.children[0].removeClass("icon-delete-2");
}
},
mulitpleChoiceItemClicked: function(e, t) {
var n = e.children[1];
n.setValue(!n.getChecked()), this.chkMultipleChoiceItemChanged(n);
},
chkMultipleChoiceItemChanged: function(e) {
this.$.btnCheckMultipleChoice.setIsActive(!1), e.parent.addRemoveClass("checkbox-checked", e.getChecked());
},
downHandler: function(e, t) {
this.setClickX(t.clientX - $(e.hasNode()).offset().left), this.setClickY(t.clientY - $(e.hasNode()).offset().top);
},
ontapHandler: function() {}
});

// PickAndPlaceWords.js

enyo.kind({
name: "educate.frame.components.pickAndPlace.PickAndPlaceWords",
kind: "educate.components.pickAndPlace.pickAndPlaceWords.PickAndPlaceWords",
published: {
position_x: 0,
position_y: 0,
objType: "ppw_",
showTimer: !0,
showArea: !1,
currentPickObj: ""
},
handlers: {
onPropertiesChanged: "onPropertiesChangedHandler",
ondown: "downHandler",
onModusChanged: "onModusChangedHandler",
onPickItemClicked: "onPickItemClickedHandler"
},
components: [ {
kind: "educate.components.pickAndPlace.PickAndPlaceSvg",
name: "pickAndPlaceSvg",
components: [ {
tag: "div",
name: "pickObjectContainer",
classes: "pick-object-container"
} ]
}, {
kind: "educate.frame.components.pickAndPlace.PickAndPlaceMenuWords",
name: "pickAndPlaceMenu"
} ],
create: function() {
this.inherited(arguments), this.redrawPickAndPlace();
},
rendered: function() {
this.inherited(arguments);
},
optionsChanged: function() {
this.inherited(arguments), this.$.pickAndPlaceMenu.setIsHighlightZoneMode(this.getHighlightZone()), this.removeUnusedDropZonesFromList(), this.modus = this.handleModusFrame(), this.modusChanged();
},
alphaZonesChanged: function() {
this.inherited(arguments), this.$.pickAndPlaceSvg.setMultipleZonesAlpha(this.getAlphaZones(), this.getOriginalDropZoneList()), this.handleVisibilityUnusedDropZones();
},
dragstartHandler: function(e, t) {
if (!this.getHighlightZone() || this.getModus() !== "test") {
var n = t.originator.parent.kindName === "educate.components.pickAndPlace.pickAndPlaceWords.PickObjectWord" ? t.originator.parent : t.originator;
if (n.kind !== "educate.frame.components.pickAndPlace.PickItemWord" && n.kind !== "educate.components.pickAndPlace.pickAndPlaceWords.PickObjectWord") return;
if (n.getState() === "correct") return !1;
this.$.pickAndPlaceSvg.$.svgCon.applyStyle("pointer-events", "auto"), this.$.pickObjectContainer.applyStyle("pointer-events", "none"), this.currentPickObj = this.getCurrentPickObject(n), this.currentPickObj && this.currentPickObj.getMovable() && ($(this.currentPickObj.hasNode()).appendTo($(this.$.pickObjectContainer.hasNode())), $(document).on("mousemove", enyo.bind(this, "dragObjectHandler")), $(document).on("mouseup", enyo.bind(this, "upHandler")), document.addEventListener("touchmove", window.touchToMouse, !0), document.addEventListener("touchend", window.touchToMouse, !0)), this.dragObjectHandler(t);
}
},
getCurrentPickObject: function(e) {
return this.$["pickObj_" + e.linkedZone.zoneId] ? this.$["pickObj_" + e.linkedZone.zoneId] : this.getHighlightZone() && this.getModus() === "quiz" && this.countPickItemsPlaced() >= this.getNumberOfQuizItems() ? !1 : (e.addClass("dimmed"), this.createCurrentPickObject(e));
},
createCurrentPickObject: function(e) {
var t = this.createComponent({
name: "pickObj_" + e.linkedZone.zoneId,
kind: "educate.components.pickAndPlace.pickAndPlaceWords.PickObjectWord",
container: this.$.pickObjectContainer,
linkedZone: e.linkedZone,
linkedItem: e,
word: e.linkedZone.zoneLabel,
pickAndPlaceSvg: this.$.pickAndPlaceSvg,
pickAndPlaceMenu: this.$.pickAndPlaceMenu
});
return t;
},
dragObjectHandler: function(e) {
this.currentPickObj.setPosition_x(e.clientX - $(this.$.pickAndPlaceSvg.hasNode()).offset().left), this.currentPickObj.setPosition_y(e.clientY - $(this.$.pickAndPlaceSvg.hasNode()).offset().top);
},
upHandler: function(e) {
this.inherited(arguments), $(".pickObject").css("pointer-events", "none"), this.currentPickObj.linkedItem.removeClass("dimmed");
var t = document.elementFromPoint(e.clientX, e.clientY);
this.currentPickObj.isDroppedInDeleteZone(e.clientX, e.clientY) && this.getModus() !== "test" ? this.destroyPickObject(this.currentPickObj) : this.handleDrop(t), $(".pickObject").css("pointer-events", "auto"), this.$.pickAndPlaceSvg.$.svgCon.applyStyle("pointer-events", "none"), this.$.pickObjectContainer.applyStyle("pointer-events", "auto"), document.removeEventListener("touchmove", window.touchToMouse), document.removeEventListener("touchend", window.touchToMouse);
},
onModusChangedHandler: function(e, t) {
this.setModus(t.modus);
},
modusChanged: function() {
this.initStartPickAndPlaceModus();
switch (this.getModus()) {
case "practise":
this.setPractiseMode();
break;
case "test":
this.setTestMode();
break;
case "quiz":
this.$.pickAndPlaceMenu.showQuizResultsBtn(!0), this.setQuizMode();
break;
default:
this.setPractiseMode();
}
},
downHandler: function(e, t) {
t.preventDefault();
},
ontapHandler: function() {
event.preventDefault();
},
filterBtnTapped: function() {
this.$.pickAndPlaceFilter && this.$.pickAndPlaceFilter.destroy(), this.createComponent({
kind: "educate.frame.components.pickAndPlace.PickAndPlaceFilterWords",
name: "pickAndPlaceFilter"
}), this.$.pickAndPlaceFilter.setPickList(this.getOriginalDropZoneList());
}
});

// PickAndPlaceImages.js

enyo.kind({
name: "educate.frame.components.pickAndPlace.PickAndPlaceImages",
kind: "educate.components.pickAndPlace.pickAndPlaceImages.PickAndPlaceImages",
published: {
width: 200,
height: 500,
position_x: 0,
position_y: 0,
objType: "ppi_",
showTimer: !0,
showArea: !1,
currentPickObj: ""
},
handlers: {
onPropertiesChanged: "onPropertiesChangedHandler",
ondown: "downHandler",
onModusChanged: "onModusChangedHandler",
onPickItemClicked: "onPickItemClickedHandler"
},
components: [ {
kind: "educate.components.pickAndPlace.PickAndPlaceSvg",
name: "pickAndPlaceSvg",
components: [ {
tag: "div",
name: "pickObjectContainer",
classes: "pick-object-container"
} ]
}, {
kind: "educate.frame.components.pickAndPlace.PickAndPlaceMenuImages",
name: "pickAndPlaceMenu"
} ],
create: function() {
this.inherited(arguments), this.redrawPickAndPlace();
},
rendered: function() {
this.inherited(arguments);
},
optionsChanged: function() {
this.inherited(arguments), this.$.pickAndPlaceMenu.setIsHighlightZoneMode(this.getHighlightZone()), this.removeUnusedDropZonesFromList(), this.modus = this.handleModusFrame(), this.modusChanged();
},
alphaZonesChanged: function() {
this.inherited(arguments), this.$.pickAndPlaceSvg.setMultipleZonesAlpha(this.getAlphaZones(), this.getOriginalDropZoneList()), this.handleVisibilityUnusedDropZones();
},
dragstartHandler: function(e, t) {
if (!this.getHighlightZone() || this.getModus() !== "test") {
var n = t.originator.parent.kindName === "educate.components.pickAndPlace.pickAndPlaceImages.PickObjectImage" ? t.originator.parent : t.originator;
if (n.getState() === "correct") return !1;
this.$.pickObjectContainer.applyStyle("pointer-events", "none"), this.currentPickObj = this.getCurrentPickObject(n), this.currentPickObj && this.currentPickObj.getMovable() && ($(this.currentPickObj.hasNode()).appendTo($(this.$.pickObjectContainer.hasNode())), $(".pickObject").css("pointer-events", "none"), $(document).on("mousemove", enyo.bind(this, "muisMoveEvent")), $(document).on("mouseup", enyo.bind(this, "upHandler")), document.ontouchmove = enyo.bind(this, "dragObjectHandler"), document.ontouchend = enyo.bind(this, "upHandler"));
}
},
getCurrentPickObject: function(e) {
return this.$["pickObj_" + e.linkedZone.zoneId] ? this.$["pickObj_" + e.linkedZone.zoneId] : this.getHighlightZone() && this.getModus() === "quiz" && this.countPickItemsPlaced() >= this.getNumberOfQuizItems() ? !1 : (e.addClass("dimmed"), this.createCurrentPickObject(e));
},
createCurrentPickObject: function(e) {
var t = this.createComponent({
name: "pickObj_" + e.linkedZone.zoneId,
kind: "educate.components.pickAndPlace.pickAndPlaceImages.PickObjectImage",
container: this.$.pickObjectContainer,
linkedZone: e.linkedZone,
linkedZoneNode: e.linkedZoneNode,
linkedItem: e,
pickAndPlaceSvg: this.$.pickAndPlaceSvg,
pickAndPlaceMenu: this.$.pickAndPlaceMenu
});
return t;
},
dragObjectHandler: function(e) {
this.currentPickObj.setPosition_x(e.touches[0].clientX - $(this.$.pickAndPlaceSvg.hasNode()).offset().left - $(this.currentPickObj.hasNode()).outerWidth() / 2), this.currentPickObj.setPosition_y(e.touches[0].clientY - $(this.$.pickAndPlaceSvg.hasNode()).offset().top - $(this.currentPickObj.hasNode()).outerHeight() / 2);
},
upHandler: function(e) {
this.inherited(arguments), this.currentPickObj.linkedItem.removeClass("dimmed"), this.currentPickObj.isDroppedInDeleteZone(e.clientX, e.clientY) && this.getModus() != "test" ? this.destroyPickObject(this.currentPickObj) : this.handleDrop(), $(".pickObject").css("pointer-events", "auto"), this.$.pickObjectContainer.applyStyle("pointer-events", "auto");
},
handleDrop: function() {
this.currentPickObj.handlePlacement(this.getModus(), this.getDropMargin(), this.getHighlightZone()), this.checkPickAndPlaceCompleted();
},
onModusChangedHandler: function(e, t) {
this.setModus(t.modus);
},
modusChanged: function() {
this.initStartPickAndPlaceModus();
switch (this.getModus()) {
case "practise":
this.setPractiseMode();
break;
case "test":
this.setTestMode();
break;
case "quiz":
this.$.pickAndPlaceMenu.showQuizResultsBtn(!0), this.setQuizMode();
break;
default:
this.setPractiseMode();
}
},
testModeItemPlacedHandler: function(e, t) {
t.isPlacementCorrect && ($(t.originator.hasNode()).css("opacity", 0), this.getRemovePickObjectsByTest() || (t.originator.getLinkedZoneNode().style.opacity = this.getAlphaZones() > 0 ? this.getAlphaZones() : 1), this.removeTestItemTimeout = window.setTimeout(t.highlightZone ? enyo.bind(this, "showNextTestModeHighlight") : enyo.bind(this, "showNextTestModeItem"), this.getRemovePickObjectsByTest() ? 700 : 400));
},
practiseModeItemPlacedHandler: function(e, t) {
t.originator.getState() === "correct" && ($(t.originator.hasNode()).delay(500).queue(function(e) {
$(this).css({
opacity: 0,
"pointer-events": "none"
}), e();
}), this.getRemovePickObjectsByPractise() || (t.originator.getLinkedZoneNode().style.opacity = this.getAlphaZones() > 0 ? this.getAlphaZones() : 1));
},
downHandler: function(e, t) {
t.preventDefault();
},
ontapHandler: function() {
event.preventDefault();
},
filterBtnTapped: function() {
this.$.pickAndPlaceFilter && this.$.pickAndPlaceFilter.destroy(), this.createComponent({
kind: "educate.frame.components.pickAndPlace.PickAndPlaceFilterImages",
name: "pickAndPlaceFilter"
}), this.$.pickAndPlaceFilter.setPickList(this.getOriginalDropZoneList());
}
});

// PickAndPlaceMenuWords.js

enyo.kind({
name: "educate.frame.components.pickAndPlace.PickAndPlaceMenuWords",
kind: "educate.components.pickAndPlace.pickAndPlaceWords.PickAndPlaceMenuWords",
published: {},
handlers: {},
create: function() {
this.inherited(arguments), this.$.filterBtn.setShowing(!0), this.render();
},
rendered: function() {
this.inherited(arguments);
},
disabledQuizType: function(e, t) {
this.$[e].setShowing(!t);
},
updatePickList: function(e) {
this.inherited(arguments);
var t = e.length, n = [];
for (var r = 0; r < t; r++) e[r].zoneType === "laag" && e[r].isZoneActief && n.push({
kind: "educate.frame.components.pickAndPlace.PickItemWord",
container: this.$.pickList,
linkedZone: e[r],
attributes: {
linkedZoneId: e[r].zoneId
},
isPickIcon: this.getIsTestAndHighlight()
});
n = shuffleArray(n), this.createComponents(n), this.$.pickList.render();
}
});

// PickAndPlaceMenuImages.js

enyo.kind({
name: "educate.frame.components.pickAndPlace.PickAndPlaceMenuImages",
kind: "educate.components.pickAndPlace.pickAndPlaceImages.PickAndPlaceMenuImages",
published: {},
handlers: {},
create: function() {
this.inherited(arguments), this.$.filterBtn.setShowing(!0), this.render();
},
rendered: function() {
this.inherited(arguments);
},
disabledQuizType: function(e, t) {
this.$[e].setShowing(!t);
},
updatePickList: function(e) {
this.inherited(arguments);
var t = e.length, n = [];
for (var r = 0; r < t; r++) e[r].zoneType === "laag" && e[r].isZoneActief && n.push({
kind: "educate.frame.components.pickAndPlace.PickItemImage",
container: this.$.pickList,
linkedZone: e[r],
linkedZoneNode: this.parent.$.pickAndPlaceSvg.getZoneByZoneId(e[r].zoneId),
isPickIcon: this.getIsTestAndHighlight()
});
n = shuffleArray(n), this.createComponents(n), this.$.pickList.render();
}
});

// PickItemImage.js

enyo.kind({
name: "educate.frame.components.pickAndPlace.PickItemImage",
kind: "educate.components.pickAndPlace.pickAndPlaceImages.PickItemImage",
components: [ {
tag: "i",
name: "pickItemIcon",
classes: "no-mouse-events"
}, {
tag: "svg",
name: "pickItemSvg",
classes: "no-mouse-events",
allowHtml: !0,
style: "width:151px; height:93px;",
attributes: {
width: "151px",
height: "93px",
viewBox: "0 0 1210 745",
xmlns: "http://www.w3.org/2000/svg",
"xmlns:xlink": "http://www.w3.org/1999/xlink"
}
} ],
create: function() {
this.inherited(arguments), this.getLinkedZoneNode() && this.linkedZoneNodeChanged();
},
rendered: function() {
this.inherited(arguments), this.placeDefaultIcon();
},
stateChanged: function() {
switch (this.getState()) {
case "none":
this.setNone();
break;
case "correct":
this.setCorrect();
break;
case "wrong":
this.setWrong();
break;
case "used":
this.setUsed();
break;
default:
this.setNone();
}
},
setNone: function() {
this.removeStateClassesFromPickItem(), this.removeIconClassesFromPickItem(), this.placeDefaultIcon();
},
setCorrect: function() {
this.removeStateClassesFromPickItem(), this.addClass("correct-item"), this.removeIconClassesFromPickItem(), this.$.pickItemIcon.addClass("fill-icon icon-check-2");
},
setWrong: function() {
this.removeStateClassesFromPickItem(), this.addClass("wrong-item"), this.removeIconClassesFromPickItem(), this.$.pickItemIcon.addClass("fill-icon icon-delete-2");
},
setUsed: function() {
this.removeStateClassesFromPickItem(), this.addClass("used-item"), this.removeIconClassesFromPickItem();
},
placeDefaultIcon: function() {
var e = this.getIsPickIcon() ? "icon-hand-up" : "fill-icon icon-move";
this.$.pickItemIcon.addClass(e);
}
});

// PickItemWord.js

enyo.kind({
name: "educate.frame.components.pickAndPlace.PickItemWord",
kind: "educate.components.pickAndPlace.pickAndPlaceWords.PickItemWord",
components: [ {
tag: "i",
name: "pickItemIcon",
classes: "no-mouse-events"
}, {
tag: "p",
name: "pickItemLabel",
classes: "no-mouse-events"
} ],
create: function() {
this.inherited(arguments), this.$.pickItemLabel.setContent(this.getLinkedZone().zoneLabel);
},
rendered: function() {
this.inherited(arguments), this.placeDefaultIcon();
},
stateChanged: function() {
switch (this.getState()) {
case "none":
this.setNone();
break;
case "correct":
this.setCorrect();
break;
case "wrong":
this.setWrong();
break;
case "used":
this.setUsed();
break;
default:
this.setNone();
}
},
setNone: function() {
this.removeStateClassesFromPickItem(), this.removeIconClassesFromPickItem(), this.placeDefaultIcon();
},
setCorrect: function() {
this.removeStateClassesFromPickItem(), this.addClass("correct-item"), this.removeIconClassesFromPickItem(), this.$.pickItemIcon.addClass("fill-icon icon-check-2");
},
setWrong: function() {
this.removeStateClassesFromPickItem(), this.addClass("wrong-item"), this.removeIconClassesFromPickItem(), this.$.pickItemIcon.addClass("fill-icon icon-delete-2");
},
setUsed: function() {
this.removeStateClassesFromPickItem(), this.addClass("used-item"), this.removeIconClassesFromPickItem();
},
placeDefaultIcon: function() {
var e = this.getIsPickIcon() ? "icon-hand-up" : "fill-icon icon-move";
this.$.pickItemIcon.addClass(e);
}
});

// PickAndPlaceModal.js

enyo.kind({
name: "educate.frame.components.pickAndPlace.PickAndPlaceModal",
kind: "enyo.Control",
tag: "div",
classes: "pick-and-place-modal",
published: {
position_x: 400,
position_y: 200,
clickX: "",
clickY: "",
title: "",
question: "",
posAnswer: "",
negAnswer: "",
modus: ""
},
events: {},
handlers: {
ondrag: "ondragHandler",
ondown: "ondownHandler"
},
components: [ {
tag: "div",
name: "pickAndPlaceModalHead",
classes: "pick-and-place-modal-head",
components: [ {
tag: "p",
name: "title"
} ]
}, {
tag: "div",
name: "pickAndPlaceModalBody",
classes: "pick-and-place-modal-body",
components: [ {
tag: "p",
name: "question"
}, {
tag: "div",
classes: "answer answer-positive",
ontap: "positiveAnswerTapped",
components: [ {
tag: "i",
classes: "fill-icon icon-check-2"
}, {
tag: "span",
name: "answerPositive"
} ]
}, {
tag: "div",
classes: "answer answer-negative",
ontap: "negativeAnswerTapped",
components: [ {
tag: "i",
classes: "fill-icon icon-delete-2"
}, {
tag: "span",
name: "answerNegative"
} ]
} ]
} ],
create: function() {
this.inherited(arguments), this.$.title.setContent(this.getTitle()), this.$.question.setContent(this.getQuestion()), this.$.answerPositive.setContent(this.getPosAnswer()), this.$.answerNegative.setContent(this.getNegAnswer()), this.render();
},
rendered: function() {
this.inherited(arguments), this.setPosition_x(($(this.parent.hasNode()).width() - $(this.hasNode()).width()) / 2), this.setPosition_y(($(this.parent.hasNode()).height() - $(this.hasNode()).height()) / 2);
},
position_xChanged: function() {
this.applyStyle("left", this.getPosition_x() + "px");
},
position_yChanged: function() {
this.applyStyle("top", this.getPosition_y() + "px");
},
ondownHandler: function(e, t) {
this.preventDefaultEvent && t.preventDefault();
var n, r, i = $(this.hasNode()).offset();
t.type === "touchmove" ? (n = t.touches[0].clientX, r = t.touches[0].clientY) : (n = t.clientX, r = t.clientY), this.setClickX(n - i.left), this.setClickY(r - i.top);
},
ondragHandler: function(e, t) {
var n, r;
t.type === "touchmove" ? (n = t.touches[0].clientX, r = t.touches[0].clientY) : (n = t.clientX, r = t.clientY);
var i = n - $(this.parent.hasNode()).offset().left - this.getClickX(), s = r - $(this.parent.hasNode()).offset().top - this.getClickY();
this.setPosition_x(i / window.settings.SCALE + .5 >> 0), this.setPosition_y(s / window.settings.SCALE + .5 >> 0);
},
positiveAnswerTapped: function(e, t) {
this.sendAnswer(!0);
},
negativeAnswerTapped: function(e, t) {
this.sendAnswer(!1);
},
sendAnswer: function(e) {
enyo.Signals.send("onAnswerSended", {
answer: e,
modus: this.getModus()
}), this.destroy();
}
});

// PickAndPlaceFilterWords.js

enyo.kind({
name: "educate.frame.components.pickAndPlace.PickAndPlaceFilterWords",
kind: "educate.components.pickAndPlace.PickAndPlaceFilter",
pickListChanged: function() {
var e = this, t = this.getPickList().map(function(t) {
return {
kind: "educate.frame.components.pickAndPlace.FilterItemWords",
container: e.$.filterListContainer,
pickListItem: t
};
});
this.createComponents(t);
}
});

// PickAndPlaceFilterImages.js

enyo.kind({
name: "educate.frame.components.pickAndPlace.PickAndPlaceFilterImages",
kind: "educate.components.pickAndPlace.PickAndPlaceFilter",
pickListChanged: function() {
var e = this, t = this.getPickList().map(function(t) {
return {
kind: "educate.frame.components.pickAndPlace.FilterItemImages",
container: e.$.filterListContainer,
pickListItem: t,
linkedZoneNode: e.parent.$.pickAndPlaceSvg.getZoneByZoneId(t.zoneId)
};
});
this.createComponents(t);
}
});

// FilterItemWords.js

enyo.kind({
name: "educate.frame.components.pickAndPlace.FilterItemWords",
kind: "educate.components.pickAndPlace.FilterItem",
components: [ {
tag: "i",
name: "filterItemCheck",
classes: "fill-icon"
}, {
tag: "span",
name: "filterItemLabel"
} ],
create: function() {
this.inherited(arguments), this.$.filterItemLabel.setContent(this.getPickListItem().zoneLabel);
},
rendered: function() {
this.inherited(arguments);
}
});

// FilterItemImages.js

enyo.kind({
name: "educate.frame.components.pickAndPlace.FilterItemImages",
kind: "educate.components.pickAndPlace.FilterItem",
published: {
linkedZoneNode: ""
},
components: [ {
tag: "i",
name: "filterItemCheck",
classes: "fill-icon"
}, {
tag: "svg",
name: "filterItemSvg",
classes: "no-mouse-events",
allowHtml: !0,
style: "width:151px; height:93px;",
attributes: {
width: "151px",
height: "93px",
viewBox: "0 0 1210 745",
xmlns: "http://www.w3.org/2000/svg",
"xmlns:xlink": "http://www.w3.org/1999/xlink"
}
} ],
create: function() {
this.inherited(arguments), this.getLinkedZoneNode() && this.linkedZoneNodeChanged();
},
rendered: function() {
this.inherited(arguments);
},
linkedZoneNodeChanged: function() {
var e = this.getLinkedZoneNode().cloneNode(!0);
e.style.opacity = 1;
var t = new XMLSerializer, n = t.serializeToString(e);
this.$.filterItemSvg.setContent(n), this.setViewBox();
},
setViewBox: function() {
var e = this.getLinkedZoneNode().getBBox();
this.$.filterItemSvg.setAttribute("viewBox", e.x + " " + e.y + " " + e.width + " " + e.height);
}
});

// Raster.js

enyo.kind({
name: "educate.frame.components.raster.Raster",
kind: "educate.components.raster.Raster",
published: {
kolommen: "2",
rijen: "4",
kolomBreedte: "",
rijHoogte: "",
Huitlijning: "",
Vuitlijning: "",
repeatLastKolom: !1
},
handlers: {},
components: [ {
tag: "table",
name: "table",
classes: "rasterTable",
attributes: {
border: "1"
}
} ],
create: function() {
this.inherited(arguments), this.createTable(), this.redrawRaster();
},
createTable: function() {
for (var e = 0; e < this.rijen; e++) {
var t = this.createRow();
for (var n = 0; n < this.kolommen; n++) this.createKolom(t);
}
},
createKolom: function(e, t) {
var n = this.createComponent({
tag: "td",
container: e,
content: t || "aa"
});
},
createRow: function() {
var e = this.createComponent({
tag: "tr",
container: this.$.table
});
return e;
},
downHandler: function(e, t) {
t.preventDefault(), this.setClickX(t.clientX - $(e.hasNode()).offset().left), this.setClickY(t.clientY - $(e.hasNode()).offset().top);
},
ontapHandler: function() {
event.preventDefault();
}
});

// SvgParser.js

enyo.kind({
name: "educate.frame.components.svg.SvgParser",
kind: "educate.components.svg.SvgParser",
published: {
carrier: window.settings.CARRIERS.SVG,
oldvalue: "",
width: 500,
height: 300,
position_x: 0,
position_y: 0,
objType: "svg_",
tmpX: 0,
tmpY: 0,
renderedFromPickPlace: !1,
renderedFromPickPlaceImages: !1,
showArea: !1,
colorOptions: [],
istouchmove: !1,
zones: []
},
handlers: {
onPropertiesChanged: "onPropertiesChangedHandler"
},
create: function() {
this.inherited(arguments), this.createComponent({
tag: "div",
name: "popupZone",
classes: "popupZone",
content: "default name",
showing: !1,
isZoneTouched: !1
}), this.init();
},
rendered: function() {
this.inherited(arguments), this.initAchtergrond(), this.resizeComponent();
},
init: function() {
var e = this;
document.addEventListener("touchstart", function(t) {
e.documentTouch(t);
});
},
documentTouch: function(e) {
this.$.popupZone.isZoneTouched || this.$.popupZone.setShowing(!1), this.$.popupZone.isZoneTouched = !1;
},
handleSVG: function(e) {
var t = e.childNodes, n = [], r = [];
for (var i = 0; i < t.length; i++) {
if (t[i].nodeName == "path" || t[i].nodeName == "g" || t[i].nodeName == "polygon") n.push(t[i].id), r.push(t[i]);
this.zones = r;
}
return e;
},
doLayers: function() {},
getLayerClass: function() {
return educate.frame.components.svg.svgzone;
},
downHandler: function(e, t) {
this.inherited(arguments);
},
onPropertiesChangedHandler: function(e, t) {
t.linked == this && (this.layername = t.linked.layername, this.renderedFromPickPlace && (this.showArea = t.linked.options.showArea, this.colorOptions = t.linked.options.colorOptions, this.addOption("showArea", this.showArea), this.addOption("fill", this.colorOptions.fill), this.addOption("stroke", this.colorOptions.stroke), this.addOption("opacity", this.colorOptions.opacity), this.bubble("onShowAreaChanged", {
showArea: this.showArea,
colorOptions: this.colorOptions
})), this.value != "" && this.value != this.oldvalue && (this.value = t.linked.value, this.oldvalue = this.value), this.resizeComponent());
}
});

// SvgZone.js

enyo.kind({
name: "educate.frame.components.svg.svgzone.SvgZone",
kind: "educate.components.svg.svgzone.SvgZone",
published: {},
create: function() {
this.inherited(arguments), this.setCollection([]);
},
render: function() {},
addZoneMouseOver: function() {
var e = this;
this.node.addEventListener("mouseover", function(t) {
e.zoneMouseOver(t);
}), this.node.addEventListener("mouseout", function(t) {
e.zoneMouseOut();
}), this.node.addEventListener("touchstart", function(t) {
e.zoneTouch(t);
});
},
zoneMouseOver: function(e) {
this.showPopupZone(e);
},
zoneMouseOut: function() {
this.hidePopupZone();
},
showPopupZone: function(e) {
this.getSvgparser().$.popupZone.setContent(this.getLayername());
const t = e.clientX || e.touches[0].clientX, n = e.clientY || e.touches[0].clientY;
this.getSvgparser().$.popupZone.applyStyle("left", t - $(this.getSvgparser().node).offset().left + 5 + "px"), this.getSvgparser().$.popupZone.applyStyle("top", n - $(this.getSvgparser().node).offset().top + 5 + "px"), this.getSvgparser().$.popupZone.setShowing(!0);
},
hidePopupZone: function() {
this.getSvgparser().$.popupZone.setShowing(!1);
},
zoneTouch: function(e) {
this.getSvgparser().$.popupZone.isZoneTouched = !0, this.getSvgparser().$.popupZone.getShowing() && this.getSvgparser().$.popupZone.getContent() === this.getLayername() ? this.hidePopupZone() : this.showPopupZone(e);
},
updateNode: function() {
this.inherited(arguments), this.actionsChanged(), this.getPopupZoneName() && this.addZoneMouseOver();
},
actionsChanged: function() {
if (this.actions.length === 0) return !1;
if (!this.node) return !1;
this.inherited(arguments);
var e, t = this.actions.length, n = this;
for (e = 0; e < t; e++) switch (this.actions[e].value) {
case "KLIK":
this.node.addEventListener("click", function(e) {
n.bubble("ontap", e, n);
}), this.node.addEventListener("touchstart", function(e) {
n.onClickStart(e);
});
break;
case "MOUSE_DOWN":
this.node.addEventListener("mousedown", function(e) {
n.bubble("ondown", e, n);
}), this.node.addEventListener("touchstart", function(e) {
n.bubble("ondown", e, n);
});
break;
case "MOUSE_UP":
this.node.addEventListener("mouseup", function(e) {
n.bubble("onup", e, n);
}), this.node.addEventListener("touchend", function(e) {
n.bubble("onup", e, n);
});
break;
case "DRAG":
this.node.addEventListener("ondrag", function(e) {
n.bubble("ondrag", e, n);
}), this.node.addEventListener("touchstart", function(e) {
n.onDragStart(e);
});
break;
case "START_DRAG":
this.node.addEventListener("ondragstart", function(e) {
n.bubble("ondragstart", e, n);
}), this.node.addEventListener("touchstart", function(e) {
n.onDragStart(e);
});
break;
case "STOP_DRAG":
this.node.addEventListener("ondragfinish", function(e) {
n.bubble("ondragfinish", e, n);
}), this.node.addEventListener("touchend", function(e) {
n.bubble("ondragfinish", e, n);
});
}
},
onClickStart: function(e) {
var t = this;
this.node.addEventListener("touchend", function(e) {
t.node.removeEventListener("touchend", arguments.callee), t.isTarget(t.findTarget(e), t.node) && t.bubble("ontap", e, t);
});
},
onDragStart: function(e) {
var t = this;
t.bubble("ondragstart", e, t);
var n = function(e) {
t.bubble("ondrag", e, t);
};
this.node.addEventListener("touchmove", n), this.node.addEventListener("touchend", function(e) {
t.node.removeEventListener("touchend", arguments.callee), t.node.removeEventListener("touchmove", n), t.bubble("ondrag", e, t), t.bubble("ondragfinish", e, t);
});
},
visibleChanged: function() {
this.inherited(arguments), this.laag && this.laag.setLaagOpen(this.getVisible());
},
hasNode: function() {
return this.node ? this.node : !1;
},
isTarget: function(e, t) {
var n = this;
if (e === t) return !0;
var r = Array.prototype.slice.call(t.children).find(function(t) {
return n.isTarget(e, t);
});
return typeof r != "undefined";
},
findTarget: function(e) {
return e.touches.length > 0 ? (e.clientX = e.touches[0].clientX, e.clientY = e.touches[0].clientY) : (e.clientX = e.changedTouches[0].clientX, e.clientY = e.changedTouches[0].clientY), document.elementFromPoint(e.clientX, e.clientY);
},
bubble: function(e, t, n) {
this.inherited(arguments);
}
});

// Square.js

enyo.kind({
name: "educate.frame.components.tekendoos.Square",
kind: "educate.components.tekendoos.Square",
classes: "rectangles onScreen",
published: {
width: 500,
height: 300,
position_x: 150,
position_y: 100,
objType: "div_",
opacity: .5,
lineColor: "#222",
fillColor: "34, 34, 34",
lineThickness: 5,
lineType: "solid",
radius: 0,
beginP: 0,
endP: 0
},
handlers: {
onmouseup: "checkHandler"
},
create: function() {
this.inherited(arguments), this.redrawSquare();
},
downHandler: function(e, t) {
t.preventDefault(), this.setClickX(t.clientX - $(e.hasNode()).offset().left), this.setClickY(t.clientY - $(e.hasNode()).offset().top);
},
ontapHandler: function() {
event.preventDefault();
},
checkHandler: function(e, t) {
var n = {
x: t.x + 2,
y: t.y - 20,
obj: this.layername
};
enyo.Signals.send("checkPlacement", n);
}
});

// Ellipse.js

enyo.kind({
name: "educate.frame.components.tekendoos.Ellipse",
kind: "educate.components.tekendoos.Ellipse",
classes: "ellipses onScreen",
published: {
width: 500,
height: 300,
position_x: 150,
position_y: 100,
objType: "div_",
opacity: .5,
lineColor: "#222",
fillColor: "34, 34, 34",
lineThickness: 5,
lineType: "solid",
beginP: 0,
endP: 0
},
handlers: {
onmouseup: "checkHandler"
},
create: function() {
this.inherited(arguments), this.redrawEllipse();
},
downHandler: function(e, t) {
t.preventDefault(), this.setClickX(t.clientX - $(e.hasNode()).offset().left), this.setClickY(t.clientY - $(e.hasNode()).offset().top);
},
ontapHandler: function() {
event.preventDefault();
},
checkHandler: function(e, t) {
var n = {
x: t.x + 2,
y: t.y - 20,
obj: this.layername
};
enyo.Signals.send("checkPlacement", n);
}
});

// Free.js

enyo.kind({
name: "educate.frame.components.tekendoos.Free",
kind: "educate.components.tekendoos.Free",
classes: "lines onScreen",
attributes: {
xmlns: "http://www.w3.org/2000/svg",
version: "1.1",
viewbox: "0 0 1280 800"
},
published: {
width: 500,
height: 300,
position_x: 150,
position_y: 100,
objType: "div_",
tmpX: 0,
tmpY: 0,
beginP: 0,
endP: 0,
lineColor: "#222",
fill: !1,
fillColor: "#222",
opacity: 1,
lineThickness: 5,
lineType: "",
offsetLeft: 0,
offsetTop: 0,
pathPointsA: [],
pathString: ""
},
components: [ {
name: "svg",
tag: "svg",
attributes: {
xmlns: "http://www.w3.org/2000/svg",
preserveAspectRatio: "xMinYMin meet",
viewbox: "0 0 200 200"
},
style: "padding: 5px;"
} ],
create: function() {
this.inherited(arguments), this.calculateDimensions(), this.$.svg.attributes.viewbox = "0 0 " + this.width.toString() + " " + this.height.toString(), this.render();
},
rendered: function() {
this.inherited(arguments), this.redrawLine();
},
calculateDimensions: function() {
var e = 99999999, t = 0, n = 99999999, r = 0;
if (this.pathString != "") {
var i = this.pathString.split("/");
for (var s = 0; s < i.length; s++) {
var o = parseInt(i[s].split(",")[0]), u = parseInt(i[s].split(",")[1]);
o < e && (e = o), o > t && (t = o), u < n && (n = u), u > r && (r = u), o - this.beginP.x < 0 && o - this.beginP.x < this.offsetLeft && (this.offsetLeft = o - this.beginP.x), u - this.beginP.y < 0 && u - this.beginP.y < this.offsetTop && (this.offsetTop = u - this.beginP.y);
}
} else for (var s = 0; s < this.pathPointsA.length; s++) this.pathPointsA[s].x < e && (e = this.pathPointsA[s].x), this.pathPointsA[s].x > t && (t = this.pathPointsA[s].x), this.pathPointsA[s].y < n && (n = this.pathPointsA[s].y), this.pathPointsA[s].y > r && (r = this.pathPointsA[s].y), this.pathPointsA[s].x - this.beginP.x < 0 && this.pathPointsA[s].x - this.beginP.x < this.offsetLeft && (this.offsetLeft = this.pathPointsA[s].x - this.beginP.x), this.pathPointsA[s].y - this.beginP.y < 0 && this.pathPointsA[s].y - this.beginP.y < this.offsetTop && (this.offsetTop = this.pathPointsA[s].y - this.beginP.y);
this.width = Math.abs(t - e), this.height = Math.abs(r - n);
},
downHandler: function(e, t) {
t.preventDefault(), this.setClickX(t.clientX - $(e.hasNode()).offset().left), this.setClickY(t.clientY - $(e.hasNode()).offset().top);
},
ontapHandler: function() {
event.preventDefault();
}
});

// Multi.js

enyo.kind({
name: "educate.frame.components.tekendoos.Multi",
kind: "educate.components.tekendoos.Multi",
classes: "lines onScreen",
attributes: {
xmlns: "http://www.w3.org/2000/svg",
version: "1.1",
viewbox: "0 0 1280 800"
},
published: {
width: 500,
height: 300,
position_x: 150,
position_y: 100,
objType: "div_",
tmpX: 0,
tmpY: 0,
beginP: 0,
endP: 0,
lineColor: "#222",
fill: !1,
fillColor: "#222",
opacity: .5,
lineThickness: 5,
lineType: "",
offsetLeft: 0,
offsetTop: 0,
pathPoints: [],
pathString: ""
},
components: [ {
name: "svg",
tag: "svg",
attributes: {
xmlns: "http://www.w3.org/2000/svg",
preserveAspectRatio: "xMinYMin meet",
viewbox: "0 0 200 200"
},
style: "padding: 10px;"
} ],
create: function() {
this.inherited(arguments), this.calculateDimensions(), this.$.svg.attributes.viewbox = "0 0 " + this.width.toString() + " " + this.height.toString(), this.render();
},
rendered: function() {
this.inherited(arguments), this.redrawMulti();
},
calculateDimensions: function() {
var e = 99999999, t = 0, n = 99999999, r = 0;
if (this.pathString != "") {
var i = this.pathString.split("/");
for (var s = 0; s < i.length; s++) {
var o = parseInt(i[s].split(",")[0]), u = parseInt(i[s].split(",")[1]);
o < e && (e = o), o > t && (t = o), u < n && (n = u), u > r && (r = u), o - this.beginP.x < 0 && o - this.beginP.x < this.offsetLeft && (this.offsetLeft = o - this.beginP.x), u - this.beginP.y < 0 && u - this.beginP.y < this.offsetTop && (this.offsetTop = u - this.beginP.y);
}
} else for (var s = 0; s < this.pathPoints.length; s++) {
var a = parseInt(this.pathPoints[s].split(",")[0]), f = parseInt(this.pathPoints[s].split(",")[1]);
a < e && (e = a), a > t && (t = a), f < n && (n = f), f > r && (r = f), a - this.beginP.x < 0 && a - this.beginP.x < this.offsetLeft && (this.offsetLeft = a - this.beginP.x), f - this.beginP.y < 0 && f - this.beginP.y < this.offsetTop && (this.offsetTop = f - this.beginP.y);
}
this.width = Math.abs(t - e), this.height = Math.abs(r - n);
},
downHandler: function(e, t) {
t.preventDefault(), this.setClickX(t.clientX - $(e.hasNode()).offset().left), this.setClickY(t.clientY - $(e.hasNode()).offset().top);
},
ontapHandler: function() {
event.preventDefault();
}
});

// Tekst.js

enyo.kind({
name: "educate.frame.components.tekst.Tekst",
kind: "educate.components.tekst.Tekst",
published: {
paddingTop: 5,
marginTop: 5
},
handlers: {},
components: [ {
tag: "div",
name: "Tekst",
allowHtml: !0
} ],
create: function() {
this.inherited(arguments), delete this.handlers.ondrag;
},
rendered: function() {
this.inherited(arguments);
},
valueChanged: function() {
this.$.Tekst.setContent(this.getValue());
},
calculatedFontSizeChanged: function() {
this.applyStyle("font-size", this.calculatedFontSize / 18 + "rem"), this.applyStyle("line-height", .2 + this.calculatedFontSize / 18 + "rem");
},
calculatedMetricsChanged: function() {
this.$.Tekst.applyStyle("padding-top", this.calculatedPaddingTop + "px");
},
downHandler: function(e, t) {
t.preventDefault();
var n, r, i = $(e.hasNode()).offset(), s = $(this.getStage().hasNode()).offset();
t.type === "touchmove" ? (n = t.touches[0].clientX, r = t.touches[0].clientY) : (n = t.clientX, r = t.clientY), this.setClickX(n - i.left), this.setClickY(r - i.top);
var o = n - s.left, u = r - s.top, a = o - this.absoluteOrigin.x, f = u - this.absoluteOrigin.y;
this.startRotation = Math.atan2(f, a) * 180 / Math.PI - this.rotation_z;
},
ontapHandler: function() {
event.preventDefault();
},
rotate: function(e) {
var t, n;
e.type === "touchmove" ? (t = e.touches[0].clientX, n = e.touches[0].clientY) : (t = e.clientX, n = e.clientY);
var r = t - $(this.getStage().hasNode()).offset().left, i = n - $(this.getStage().hasNode()).offset().top, s = r - this.absoluteOrigin.x, o = i - this.absoluteOrigin.y, u = Math.atan2(o, s) * 180 / Math.PI - this.startRotation;
this.setRotation_z(u);
},
ondragActionHandler: function(e, t) {
this.signalTargets("DRAG", t);
},
moveHandler: function(e, t) {
t.preventDefault(), this.signalTargets("DRAG", t);
},
upHandler: function(e, t) {
delete this.handlers.onmove, delete this.handlers.onup;
}
});

// video.js

enyo.kind({
name: "educate.frame.components.video.Video",
kind: "educate.components.video.Video",
create: function() {
this.inherited(arguments), this.valueChanged();
},
downHandler: function(e, t) {
t.preventDefault(), this.setClickX(t.clientX - $(e.hasNode()).offset().left), this.setClickY(t.clientY - $(e.hasNode()).offset().top);
},
ontapHandler: function(e, t) {
t.preventDefault();
}
});

// Website.js

enyo.kind({
name: "educate.frame.components.website.Website",
kind: "educate.components.website.Website",
tag: "div",
classes: "webFrame",
style: "position: absolute;",
published: {
position_x: 300,
position_y: 200,
width: 900,
height: 500,
url: ""
},
components: [ {
name: "iframe",
tag: "iframe",
classes: "enyo-fill",
style: "border: none;"
} ],
create: function() {
this.inherited(arguments), this.resizeComponent(), this.setUrl();
},
rendered: function() {
this.inherited(arguments);
}
});

// Youtube.js

enyo.kind({
name: "educate.frame.components.youtube.Youtube",
kind: "educate.components.youtube.Youtube",
published: {},
create: function() {
this.inherited(arguments);
},
rendered: function() {
this.inherited(arguments);
},
downHandler: function(e, t) {
t.preventDefault(), this.setClickX(t.clientX - $(e.hasNode()).offset().left), this.setClickY(t.clientY - $(e.hasNode()).offset().top);
},
ontapHandler: function() {
event.preventDefault();
}
});

// ZelfstandigLeren.js

enyo.kind({
name: "educate.frame.components.zelfstandigleren.ZelfstandigLeren",
kind: "educate.components.zelfstandigleren.ZelfstandigLeren",
create: function() {
this.inherited(arguments);
}
});

// ZoomImage.js

enyo.kind({
name: "educate.frame.components.zoomImage.ZoomImage",
kind: "educate.components.zoomImage.ZoomImage",
published: {
zoomSteps: []
},
create: function() {
this.inherited(arguments), this.valueChanged(), this.redrawImage();
},
downHandler: function(e, t) {
t.preventDefault();
},
ontapHandler: function() {
event.preventDefault();
}
});

// MessageBox.js

enyo.kind({
kind: enyo.Control,
name: "educate.frame.dialoogvensters.MessageBox",
tag: "div",
classes: "messagebox",
showing: !1,
published: {
message: "",
duration: 1e3
},
handlers: {},
components: [ {
tag: "p",
name: "message"
} ],
create: function() {
this.inherited(arguments);
},
rendered: function() {
this.inherited(arguments);
},
messageChanged: function() {
this.$.message.setContent(this.getMessage());
},
showMessageBox: function(e, t) {
t && this.setDuration(t), this.setMessage(e ? e : "Geen tekst");
var n = this;
$(this.hasNode()).slideDown("fast", function() {
var e = setTimeout(enyo.bind(n, "hideMessageBox"), n.getDuration());
});
},
hideMessageBox: function() {
$(this.hasNode()).slideUp("fast"), this.setDuration(1e3);
}
});

// MailDrawingDialoog.js

enyo.kind({
name: "educate.frame.dialoogvensters.MailDrawingDialoog",
kind: "enyo.Popup",
classes: "mailDrawingDialoog modal",
floating: !0,
scrim: !0,
autoDismiss: !1,
modal: !0,
published: {
formdata: "",
me: !1,
mailTekst: "",
klassen: []
},
handlers: {},
components: [ {
tag: "div",
classes: "modal-header",
components: [ {
tag: "button",
classes: "close",
content: "&times",
allowHtml: !0,
ontap: "cancelHandler"
}, {
tag: "h3",
content: "Mail aantekening"
} ]
}, {
tag: "div",
name: "mailDrawingBody",
classes: "modal-body form-horizontal",
components: [ {
tag: "label",
classes: "checkbox-label",
components: [ {
kind: enyo.Checkbox,
content: "Verzend deze aantekening ook naar mezelf.",
name: "chkZendToMe",
onchange: "chkZendToMeChanged",
checked: this.me
} ]
}, {
tag: "hr"
}, {
tag: "label",
classes: "control-label",
content: "Selecteer de klassen om aantekening naar te verzenden:"
}, {
tag: "select",
name: "selectKlassen",
attributes: {
multiple: "multiple",
size: 6
},
onchange: "selectKlassenChanged",
components: [ {
tag: "option",
attributes: {
value: ""
},
content: "\u2026"
} ]
}, {
tag: "hr"
}, {
tag: "label",
classes: "control-label",
content: "Tekst die u bij de aantekening wilt bijvoegen:"
}, {
kind: "enyo.TextArea",
name: "mailTekst",
classes: "mailTekst"
} ]
}, {
tag: "div",
name: "openSceneFooter",
classes: "modal-footer",
components: [ {
tag: "button",
name: "btnMail",
classes: "btn btn-primary",
content: "Zend",
ontap: "zendMailHandler",
attributes: {
disabled: !0
}
}, {
tag: "button",
name: "btnClose",
classes: "btn",
content: "annuleer",
ontap: "cancelHandler"
} ]
} ],
create: function() {
this.inherited(arguments), this.getKlassenLeerkracht(), this.show();
},
zendMailHandler: function() {
this.setMailTekst(this.$.mailTekst.getValue()), this.bubble("mailDrawingModalSubmitted", this), this.hide();
},
cancelHandler: function() {
this.hide();
},
controleerBtnZendMail: function() {
this.$.btnMail.setAttribute("disabled", this.getMe() || this.getKlassen().length > 0 ? null : "true");
},
chkZendToMeChanged: function(e, t) {
this.setMe(this.$.chkZendToMe.checked), this.controleerBtnZendMail();
},
getKlassenLeerkracht: function() {
$.ajax({
url: Settings.SERVER + "getKlassenLeerkracht",
type: "GET",
dataType: "json",
success: enyo.bind(this, "getKlassenLeerkrachtCompleteHandler"),
error: this.errorHandler
});
},
getKlassenLeerkrachtCompleteHandler: function(e, t) {
e && this.vulKlassenLijst(e);
},
vulKlassenLijst: function(e) {
this.$.selectKlassen && this.$.selectKlassen.destroyClientControls(), this.createComponent({
tag: "option",
attributes: {
value: "noklas"
},
content: "\u2026",
container: this.$.selectKlassen
});
for (var t in e) this.createComponent({
tag: "option",
attributes: {
value: t
},
content: e[t],
container: this.$.selectKlassen
});
this.$.selectKlassen.render();
},
selectKlassenChanged: function(e, t) {
var n = t.target.selectedOptions;
this.setKlassen([]);
for (var r = 0; r < n.length; r++) n[r].value != "noklas" && this.getKlassen().push(n[r].value);
this.controleerBtnZendMail();
},
errorHandler: function(e, t) {
console.log("Error", e, t);
}
});

// Frame.js

enyo.kind({
name: "Frame",
kind: enyo.Control,
handlers: {
frameTabClicked: "frameTabClickedHandler",
onMessage: "onMessageHandler",
viewBtnClicked: "viewBtnClickedHandler",
drawColorSelected: "drawColorSelectedHandler",
toggleDrawing: "toggleDrawingHandler",
toggleErasing: "toggleErasingHandler",
clearDrawing: "clearDrawingHandler",
saveDrawing: "saveDrawingHandler",
brushSizeChanged: "brushSizeChangedHandler",
refreshClicked: "refreshClickedHandler",
changeScene: "changeSceneHandler",
checkKolomOefening: "checkKolomOefeningHandler",
checkDropdown: "checkDropdownHandler",
checkMultipleChoice: "checkMultipleChoiceHandler"
},
published: {
sceneId: "",
sceneParent: "",
scenePosition: "",
views: [],
tabs: [],
objsForViews: [],
loadView: 0,
activeView: ""
},
components: [ {
kind: "educate.frame.dialoogvensters.MessageBox",
name: "messageBox"
}, {
kind: "educate.frame.titelbalk.Titelbalk",
name: "titelbalk"
}, {
name: "columns",
classes: "frameBody"
}, {
kind: "educate.frame.onderbalk.Onderbalk",
name: "onderbalk"
} ],
rendered: function() {
this.inherited(arguments), this.newScene();
},
newScene: function(e) {
this.initNewScene(), previewScene ? this.loadPreviewScene() : this.loadScene(window.scene), e != undefined && this.loadComponentSettings(e);
},
loadComponentSettings: function(e) {
e.quizTypes != undefined && this.$.view1.$.pickAndPlace.drawPickObjects(e.quizTypes);
},
initNewScene: function() {
this.sceneObject = {}, this.setObjsForViews([]), this.setViews([]), this.setTabs([]);
},
loadScene: function(e) {
this.sceneObject = e, window.sceneId = e.id, this.$.titelbalk.setTitle(this.sceneObject.name), this.$.titelbalk.setValue(this.sceneObject.value), this.setSceneId(this.sceneObject.id), this.setSceneParent(this.sceneObject.parent), this.setScenePosition(this.sceneObject.position), this.parseCollection(this.sceneObject.collection), this.createViews(), this.viewLoadedHandler(), this.reflow();
},
loadPreviewScene: function() {
this.sceneObject = previewScene, this.$.titelbalk.setTitle(this.sceneObject.name), this.parseCollection(this.sceneObject.collection), this.createViews(), this.reflow();
},
changeSceneHandler: function(e, t) {
this.setLoadView(0), this.clearScene(), this.newScene();
},
parseCollection: function(e) {
var t = this;
for (var n in e) {
var r = e[n];
switch (r.carrier.name) {
case "sceneTab":
t.makeFrameTab(r);
break;
case "sceneView":
this.getObjsForViews().push(r);
}
}
},
createViews: function() {
this.getObjsForViews().sort(enyo.bind(this, "sortViews")), this.deleteAllViews();
var e = this;
this.getObjsForViews().forEach(function(t) {
e.makeView(t);
});
},
sortViews: function(e, t) {
return e.value - t.value;
},
deleteAllViews: function() {
var e = this.getViews();
for (var t in e) e[t].destroy();
},
deleteAllTabs: function() {
var e = this.getTabs();
for (var t in e) e[t].destroy();
},
makeView: function(e) {
var t = this.createComponent({
container: this.$.columns,
kind: "educate.frame.view.View",
name: e.name,
layername: e.name,
collection: e.collection,
objectId: e.id,
viewId: e.value
});
this.getViews().push(t);
},
refreshClickedHandler: function(e, t) {
this.setLoadView(this.getActiveView()), this.clearScene(), this.newScene(t.componentSettings);
},
clearScene: function() {
this.deleteAllViews(), this.deleteAllTabs();
},
makeFrameTab: function(e) {
this.getTabs().push(this.$.onderbalk.makeFrameTab(e));
},
hideAllViews: function() {
var e = this.getViews();
for (var t in e) e[t].setShowing(!1);
},
viewLoadedHandler: function() {
this.getViews().length === 0 && this.makeView({
value: 1,
name: "view1"
}), this.hideAllViews(), this.getViews()[this.getLoadView()].setShowing(!0), this.waterfallDown("viewsComplete", {
arrViews: this.getViews()
}), this.waterfallDown("viewIconSelected", {
icon: "icon-" + (this.getLoadView() + 1)
}), this.setActiveView(this.getLoadView()), this.getViews()[this.getLoadView()].arrangeObjecten(), this.resized();
},
viewBtnClickedHandler: function(e, t) {
this.getViews()[t.viewnr] && this.activeView != t.viewnr && (this.hideAllViews(), this.waterfallDown("viewIconSelected", {
icon: t.icon.name
}), this.getViews()[t.viewnr].setShowing(!0), this.setActiveView(t.viewnr), this.resized(), this.reflow(), this.getViews()[t.viewnr].rendered());
},
drawColorSelectedHandler: function(e, t) {
this.waterfallDown("drawColorSelected", t);
},
toggleDrawingHandler: function(e, t) {
this.waterfallDown("toggleDrawing");
},
toggleErasingHandler: function(e, t) {
this.waterfallDown("toggleErasing");
},
clearDrawingHandler: function(e, t) {
this.waterfallDown("clearDrawing");
},
saveDrawingHandler: function(e, t) {
this.waterfallDown("saveDrawing", t);
},
brushSizeChangedHandler: function(e, t) {
this.waterfallDown("brushSizeChanged", t);
},
checkKolomOefeningHandler: function() {
this.waterfallDown("checkKolomOefening");
},
onMessageHandler: function(e, t) {
this.showMessage(t.message, t.duration && t.duration);
},
showMessage: function(e, t) {
this.$.messageBox.showMessageBox(e, t && t);
},
checkDropdownHandler: function() {
this.waterfallDown("checkDropdown");
},
checkMultipleChoiceHandler: function() {
this.waterfallDown("checkMultipleChoice");
}
});

// Onderbalk.js

enyo.kind({
name: "educate.frame.onderbalk.Onderbalk",
kind: enyo.Control,
tag: "div",
classes: "bottombar",
components: [ {
classes: "bottombar__body"
}, {
name: "tabHolder",
classes: "tabs"
}, {
kind: "educate.frame.onderbalk.Pijltjes",
classes: "arrowButtons arrowButtons-left"
}, {
kind: "educate.frame.onderbalk.tabbladen.Tabknoppen",
name: "tabKnoppen"
}, {
kind: "educate.frame.onderbalk.tekenpallet.Tekenpallet"
}, {
kind: "educate.frame.onderbalk.Pijltjes",
classes: "arrowButtons arrowButtons-right"
} ],
handlers: {
onTabClicked: "onTabClickedHandler"
},
makeFrameTab: function(e) {
var t = this.createComponent({
kind: "educate.frame.onderbalk.tabbladen.Tabblad",
name: e.name,
value: e.value,
objectId: e.id,
container: this.$.tabHolder,
onClosetab: "closetabHandler"
});
return t;
},
onTabClickedHandler: function(e, t) {
for (var n in this.$.tabHolder.children) this.$.tabHolder.children[n].removeClass("active");
switch (t.tab) {
case "tabInfo":
this.$.info && this.$.info.addRemoveClass("active", t.open);
break;
case "tabLeerdoelen":
this.$.leerdoel && this.$.leerdoel.addRemoveClass("active", t.open);
break;
case "tabLeerinhoud":
this.$.leerinhoud && this.$.leerinhoud.addRemoveClass("active", t.open);
break;
case "tabBegrippen":
this.$.begrippen && this.$.begrippen.addRemoveClass("active", t.open);
break;
case "tabLinks":
this.$.links && this.$.links.addRemoveClass("active", t.open);
}
this.$.tabHolder.addRemoveClass("active", t.open);
},
closetabHandler: function(e, t) {
this.$.tabKnoppen.closeAll();
}
});

// Pijltjes.js

enyo.kind({
name: "educate.frame.onderbalk.Pijltjes",
kind: enyo.Control,
tag: "div",
classes: "arrows",
components: [ {
name: "btnPrev",
tag: "a",
classes: "fill-icon icon-chevron-left"
}, {
name: "btnNext",
tag: "a",
classes: "fill-icon icon-chevron-right"
}, {
classes: "spacer"
} ],
rendered: function() {
this.inherited(arguments);
if (typeof window.previous == "undefined" || typeof window.next == "undefined") {
this.hide();
return;
}
this.$.btnPrev.setAttribute("href", Settings.LES + "#/" + window.previous), this.$.btnNext.setAttribute("href", Settings.LES + "#/" + window.next);
}
});

// Tekenpallet.js

enyo.kind({
kind: enyo.Control,
name: "educate.frame.onderbalk.tekenpallet.Tekenpallet",
classes: "drawing",
tag: "div",
components: [ {
kind: "educate.frame.onderbalk.tekenpallet.Tools"
}, {
classes: "spacer"
}, {
kind: "educate.frame.onderbalk.tekenpallet.Kleuren"
}, {
classes: "spacer"
}, {
kind: "educate.frame.onderbalk.tekenpallet.Lijndikte"
}, {
classes: "spacer"
} ]
});

// kleurenpalet.js

enyo.kind({
kind: enyo.Control,
name: "educate.frame.onderbalk.tekenpallet.Kleuren",
classes: "colors",
components: [ {
name: "color1",
classes: "color color-1 colorSelected",
ontap: "colorSelected"
}, {
name: "color2",
classes: "color color-2",
ontap: "colorSelected"
}, {
name: "color3",
classes: "color color-3",
ontap: "colorSelected"
}, {
name: "color4",
classes: "color color-4",
ontap: "colorSelected"
}, {
name: "color5",
classes: "color color-5",
ontap: "colorSelected"
}, {
name: "color6",
classes: "color color-6",
ontap: "colorSelected"
} ],
rendered: function() {
this.inherited(arguments);
for (var e = 6; e > 0; e--) {
var t = this.$["color" + e].getId(), n = $("#" + t).css("background-color");
this.$["color" + e].setAttribute("color", n);
}
},
colorSelected: function(e, t) {
this.$.color1.removeClass("colorSelected"), this.$.color2.removeClass("colorSelected"), this.$.color3.removeClass("colorSelected"), this.$.color4.removeClass("colorSelected"), this.$.color5.removeClass("colorSelected"), this.$.color6.removeClass("colorSelected"), t.originator.addClass("colorSelected"), this.bubble("drawColorSelected", t.originator);
}
});

// brushsize.js

enyo.kind({
kind: enyo.Control,
name: "educate.frame.onderbalk.tekenpallet.Lijndikte",
classes: "brushsize",
published: {
drawSize: 5
},
components: [ {
kind: enyo.Button,
classes: "brushsize__down",
ontap: "sizeDownHandler"
}, {
kind: "educate.Slider",
name: "slider",
onValueChanged: "sliderValueChangedHandler",
minValue: 1,
maxValue: 30,
value: 5
}, {
kind: enyo.Button,
classes: "brushsize__up",
ontap: "sizeUpHandler"
} ],
create: function() {
this.inherited(arguments), this.drawSizeChanged();
},
sliderValueChangedHandler: function(e, t) {
this.setDrawSize(e.getValue());
},
drawSizeChanged: function() {
this.bubble("brushSizeChanged", {
brushsize: this.getDrawSize()
});
},
sizeDownHandler: function() {
this.$.slider.stepDown();
},
sizeUpHandler: function() {
this.$.slider.stepUp();
}
});

// tools.js

enyo.kind({
kind: enyo.Control,
name: "educate.frame.onderbalk.tekenpallet.Tools",
classes: "tools",
components: [ {
kind: enyo.Button,
name: "trash",
classes: "button",
ontap: "clearDrawing",
components: [ {
tag: "i",
classes: "fill-icon icon-trash"
} ]
}, {
kind: enyo.Button,
name: "eraser",
classes: "button button-eraser",
ontap: "toggleErasing",
components: [ {
tag: "i",
classes: "fill-icon icon-eraser"
} ]
}, {
kind: enyo.Button,
name: "pencil",
classes: "button button-pencil",
ontap: "toggleDrawing",
components: [ {
tag: "i",
classes: "fill-icon icon-pencil"
} ]
}, {
kind: enyo.Button,
name: "saveDrawing",
classes: "button",
ontap: "toggleSaveDrawingLijst",
components: [ {
tag: "i",
classes: "line-icon line-icon-save"
}, {
tag: "ul",
name: "saveDrawingKeuzeLijst",
showing: !1,
classes: "saveDrawingKeuzeLijst",
components: [ {
tag: "li",
content: "Opslaan op pc",
type: "pc",
ontap: "saveDrawing"
}, {
tag: "li",
content: "Verzenden via mail",
type: "mail",
ontap: "saveDrawing"
} ]
} ]
} ],
toggleDrawing: function(e, t) {
this.bubble("toggleDrawing"), this.$.pencil.addRemoveClass("active", !this.$.pencil.hasClass("active")), this.$.trash.removeClass("active"), this.$.eraser.removeClass("active");
},
toggleErasing: function(e, t) {
this.bubble("toggleErasing"), this.$.pencil.removeClass("active"), this.$.trash.removeClass("active"), this.$.eraser.addRemoveClass("active", !this.$.eraser.hasClass("active"));
},
clearDrawing: function(e, t) {
this.bubble("clearDrawing");
},
toggleSaveDrawingLijst: function(e, t) {
this.$.saveDrawingKeuzeLijst.setShowing(!this.$.saveDrawingKeuzeLijst.getShowing());
},
saveDrawing: function(e, t) {
this.bubble("saveDrawing", {
type: t.originator.type
});
}
});

// Tabblad.js

enyo.kind({
kind: enyo.Control,
name: "educate.frame.onderbalk.tabbladen.Tabblad",
tag: "div",
classes: "tab",
published: {
value: "",
objectId: ""
},
components: [ {
tag: "div",
classes: "tab__background",
components: [ {
tag: "button",
ontap: "ontapHandler",
components: [ {
tag: "i",
classes: "icon-chevron-down"
} ]
} ]
}, {
tag: "div",
name: "tabContent",
content: "Inhoud",
classes: "tab__body",
allowHtml: !0
} ],
handlers: {
frameTabClicked: "frameTabClickedHandler"
},
events: {
onClosetab: "onClosetab"
},
create: function() {
this.inherited(arguments), this.render();
},
rendered: function() {
this.inherited(arguments), this.valueChanged();
},
valueChanged: function() {
this.$.tabContent.setContent(this.getValue());
},
ontapHandler: function(e, t) {
this.removeClass("active"), this.parent.removeClass("active"), this.bubble("onClosetab");
}
});

// Tabknoppen.js

enyo.kind({
kind: enyo.Control,
name: "educate.frame.onderbalk.tabbladen.Tabknoppen",
classes: "tab-buttons",
tag: "ul",
components: [ {
classes: "spacer"
}, {
kind: "educate.frame.onderbalk.tabbladen.Tabknop",
name: "tabInfo",
content: "info",
ontap: "onTabTapHandler"
}, {
kind: "educate.frame.onderbalk.tabbladen.Tabknop",
name: "tabLeerdoelen",
content: "leerdoelen",
ontap: "onTabTapHandler"
}, {
kind: "educate.frame.onderbalk.tabbladen.Tabknop",
name: "tabLeerinhoud",
content: "leerinhoud",
ontap: "onTabTapHandler"
}, {
kind: "educate.frame.onderbalk.tabbladen.Tabknop",
name: "tabBegrippen",
content: "begrippen",
ontap: "onTabTapHandler"
}, {
kind: "educate.frame.onderbalk.tabbladen.Tabknop",
name: "tabLinks",
content: "links",
ontap: "onTabTapHandler"
} ],
events: {
onTabClicked: ""
},
onTabTapHandler: function(e, t) {
var n = e.hasClass("active");
this.closeAll(), e.addRemoveClass("active", !n), this.bubble("onTabClicked", {
tab: e.name,
open: e.hasClass("active")
});
},
closeAll: function() {
this.$.tabInfo.removeClass("active"), this.$.tabLeerdoelen.removeClass("active"), this.$.tabLeerinhoud.removeClass("active"), this.$.tabBegrippen.removeClass("active"), this.$.tabLinks.removeClass("active");
}
});

// Tabknop.js

enyo.kind({
kind: enyo.Control,
name: "educate.frame.onderbalk.tabbladen.Tabknop",
classes: "tab-button",
tag: "li",
published: {
content: "tab-button"
},
components: [ {
tag: "span",
name: "span",
content: "tab-button",
attributes: {
"data-hover": "tab-button"
}
} ],
create: function() {
this.inherited(arguments);
},
contentChanged: function() {
this.$.span.setContent(this.getContent()), this.$.span.setAttribute("data-hover", this.getContent());
}
});

// FrameButton.js

enyo.kind({
name: "educate.frame.buttons.Button",
kind: enyo.Control,
tag: "div",
attributes: "",
classes: "edu-icon",
create: function() {
this.inherited(arguments), this.setAttribute("aria-hidden", "true");
}
});

// Settings.js

enyo.kind({
name: "educate.frame.buttons.Settings",
kind: enyo.Control,
classes: "toggle",
components: [ {
tag: "i",
classes: "fill-icon icon-settings-1"
} ],
create: function() {
this.inherited(arguments), this.setAttribute("aria-hidden", "true");
}
});

// Zijbalk.js

"use strict";

enyo.kind({
name: "educate.frame.zijbalk.Zijbalk",
kind: enyo.Control,
tag: "div",
classes: "sidebar",
components: [ {
tag: "div",
classes: "logoholder",
components: [ {
tag: "i",
classes: "edu-icon edu-logo"
}, {
tag: "span",
content: "e-ducate.me"
}, {
tag: "a",
classes: "contact",
content: "contact",
attributes: {
href: Settings.WEBAPP + "site/contact/",
target: "_blank"
}
}, {
classes: "spacer"
} ]
}, {
kind: "educate.frame.zijbalk.zoomTool.ZoomTool"
}, {
tag: "div",
name: "frameButtons",
classes: "frameButtons",
components: [ {
tag: "div",
classes: "spacer"
}, {
tag: "div",
classes: "frameBtn",
name: "icon-1",
ontap: "oneClicked",
attributes: {
disabled: "disabled"
},
components: [ {
tag: "i",
classes: "edu-icon edu-1"
}, {
tag: "span",
content: "eerste beeld"
} ]
}, {
tag: "div",
classes: "frameBtn",
name: "icon-2",
ontap: "twoClicked",
attributes: {
disabled: "disabled"
},
components: [ {
tag: "i",
classes: "edu-icon edu-2"
}, {
tag: "span",
content: "tweede beeld"
} ]
}, {
tag: "div",
classes: "frameBtn",
name: "icon-3",
ontap: "threeClicked",
attributes: {
disabled: "disabled"
},
components: [ {
tag: "i",
classes: "edu-icon edu-3"
}, {
tag: "span",
content: "derde beeld"
} ]
}, {
tag: "div",
classes: "frameBtn",
name: "icon-4",
ontap: "fourClicked",
attributes: {
disabled: "disabled"
},
components: [ {
tag: "i",
classes: "edu-icon edu-4"
}, {
tag: "span",
content: "vierde beeld"
} ]
}, {
tag: "div",
classes: "spacer"
}, {
tag: "div",
classes: "frameBtn",
name: "icon-refresh",
ontap: "refreshClicked",
components: [ {
tag: "i",
classes: "edu-icon edu-refresh"
}, {
tag: "span",
content: "ververs inhoud"
} ]
}, {
tag: "div",
classes: "frameBtn",
name: "icon-oef",
ontap: "oefeningClicked",
attributes: {
disabled: "disabled"
},
components: [ {
tag: "i",
classes: "edu-icon edu-oef"
}, {
tag: "span",
content: "oefeningen"
} ]
}, {
tag: "div",
classes: "spacer",
name: "spacer"
}, {
tag: "div",
classes: "frameBtn",
name: "line-icon icon-fullscreen",
ontap: "fullscreenClicked",
components: [ {
tag: "i",
classes: "edu-icon edu-fullscreen"
}, {
tag: "span",
content: "schermvullend"
} ]
}, {
tag: "a",
classes: "frameBtn",
name: "btnExit",
components: [ {
tag: "i",
classes: "edu-icon edu-menu"
}, {
tag: "span",
content: "terug naar het menu"
} ]
}, {
classes: "spacer"
} ]
} ],
handlers: {
viewsComplete: "viewsCompleteHandler",
viewIconSelected: "viewIconSelectedHandler",
allViewsDeleted: "allViewsDeletedHandler"
},
published: {
isFullScreen: !1,
viewId: "",
componentSettings: [],
hasSolution: !1
},
create: function() {
this.inherited(arguments), this.render();
var e = window.scene.slugData, t = Settings.WEBAPP + "admin/dashboard";
window.scene !== null && (t = Settings.SPRUCE + "#/modules/" + e.publication + "/" + e.theme + "/" + e.chapter + "/" + e.topic), this.$.btnExit.setAttribute("href", t);
},
rendered: function() {
this.inherited(arguments), this.owner.$.pickAndPlace != undefined && this.$["icon-oef"].setAttribute("disabled", "disabled");
},
viewsCompleteHandler: function(e, t) {
var n = t.arrViews.length;
for (var r = 0; r < n; r++) this.$["icon-" + (r + 1)].setAttribute("disabled", null);
},
createHand: function() {
var e = this.createComponent({
kind: "educate.frame.zijbalk.knoppen.KnopHand",
name: "icon-hand",
container: this.$.frameButtons,
addBefore: this.$["icon-1"],
viewId: this.getViewId()
});
return this.$.frameButtons.render(), e;
},
createOplossing: function() {
var e = this.createComponent({
kind: "educate.frame.zijbalk.knoppen.KnopOplossing",
name: "icon-oplossing",
container: this.$.frameButtons,
addBefore: this.$.spacer,
viewId: this.getViewId(),
ontap: "onOplossingTap",
attributes: {
disabled: this.getHasSolution()
}
});
return this.$.frameButtons.render(), this.$.oplossing = e, e;
},
refreshClicked: function() {
this.saveComponentSettings(), window.location.reload();
},
saveComponentSettings: function() {
var e = this.owner.$;
e.pickAndPlace !== undefined && (this.componentSettings.quizTypes = e.pickAndPlace.type);
},
oefeningClicked: function() {
this.bubble("frameOefeningClicked", this);
},
fullscreenClicked: function() {
this.getIsFullScreen() ? this.cancelFullScreen() : this.goFullScreen(), this.setIsFullScreen(!this.getIsFullScreen());
},
oneClicked: function(e, t) {
this.bubble("viewBtnClicked", {
viewnr: 0,
icon: e
});
},
twoClicked: function(e, t) {
this.bubble("viewBtnClicked", {
viewnr: 1,
icon: e
});
},
threeClicked: function(e, t) {
this.bubble("viewBtnClicked", {
viewnr: 2,
icon: e
});
},
fourClicked: function(e, t) {
this.bubble("viewBtnClicked", {
viewnr: 3,
icon: e
});
},
viewIconSelectedHandler: function(e, t) {
this.selectViewIcon(t.icon);
},
selectViewIcon: function(e) {
this.deselectViewIcons(), this.$[e].addClass("active");
},
deselectViewIcons: function() {
this.$["icon-1"].removeClass("active"), this.$["icon-2"].removeClass("active"), this.$["icon-3"].removeClass("active"), this.$["icon-4"].removeClass("active");
},
allViewsDeletedHandler: function(e, t) {
this.hideAllViewIcons();
},
hideAllViewIcons: function() {
var e = this.$.viewsIconCon.children;
for (var t in e) e[t].destroy();
},
goFullScreen: function() {
var e = document.documentElement;
e.requestFullscreen ? e.requestFullscreen() : e.mozRequestFullScreen ? e.mozRequestFullScreen() : e.webkitRequestFullScreen && e.webkitRequestFullScreen();
},
cancelFullScreen: function() {
document.exitFullscreen ? document.exitFullscreen() : document.mozCancelFullScreen ? document.mozCancelFullScreen() : document.webkitCancelFullScreen && document.webkitCancelFullScreen();
},
checkFullScreen: function() {
return document.fullscreen || document.webkitIsFullScreen || document.mozFullScreen ? !0 : !1;
},
hasSolutionChanged: function() {
this.$.oplossing && this.$.oplossing.setAttribute("disabled", this.getHasSolution() ? "disabled" : null);
}
});

// KnopFrame.js

enyo.kind({
name: "educate.frame.zijbalk.knoppen.KnopFrame",
kind: "enyo.Control",
classes: "frameBtn",
tag: "div",
published: {
viewId: "",
databaseId: "",
objectId: "",
value: !1,
solution: !1,
answered: !0,
css_class: "",
layername: "",
objectHandlers: [],
options: null,
position_x: 0,
position_y: 0,
position_z: 0,
width: 0,
height: 0,
origin: "50 50",
rotation: "0 0 0",
position: "",
isPosLimiet: !1,
isRotLimiet: !1,
actions: [],
visible: !0,
open: !1,
eventOptions: [],
reactieOptions: []
},
handlers: {},
components: [],
create: function() {
this.inherited(arguments), this.initEventsReactiesOptions();
},
initEventsReactiesOptions: function() {
this.inherited(arguments), delete this.getEventOptions().MOUSE_DOWN, delete this.getEventOptions().MOUSE_UP, delete this.getEventOptions().DRAG, delete this.getEventOptions().START_DRAG, delete this.getEventOptions().STOP_DRAG;
},
actionsChanged: function() {
var e = this.actions;
for (var t in e) {
var n = this;
e[t].value !== "CHANGE" ? this[this.getEventOptions()[e[t].value].action + "ActionHandler"] = function(r, s) {
n.signalTargets(e[t].value);
} : (n[e[t].solution + "Changed"] || (this[e[t].solution + "Changed"] = function() {
n.signalTargets(e[t].value);
}), this[e[t].solution + "Changed"]());
}
},
signalTargets: function(e) {
for (var t in this.getActions()) if (this.actions[t].value === e && this.actions[t].parent === this.objectId) {
var n = this.getView();
if (this.actions[t].value !== "CHANGE") {
for (var r in this.actions[t].collection) {
var i = n.getChildById(parseInt(r)), s = this.actions[t].collection[r][window.settings.EVENTS[this.actions[t].id]].split(",");
for (var o in s) {
var u = i.getReactieOptions()[s[o]];
i && u && u.action !== "" && i[u.action] && i[u.action]();
}
}
window.settings.EVENTS[this.actions[t].id]++, this.actions[t].collection[r] ? window.settings.EVENTS[this.actions[t].id] > Object.keys(this.actions[t].collection[r]).length - 1 && (window.settings.EVENTS[this.actions[t].id] = 0) : alert("er is een fout ingeslopen bij het opslaan van de acties. \nDit is niet uw fout, maar de onze. \nGelieve ons dit te laten weten.");
} else {
var a = this.actions[t].answered, f = this.actions[t].solution, l = new Object;
for (var r in this.actions[t].collection) {
var i = n.getChildById(this.actions[t].collection[r].solution), c = i[this.actions[t].collection[r].value];
l[this.actions[t].collection[r].answered] = c;
}
this[f] = math.eval(a, l);
}
}
},
getView: function() {
var e = enyo.$["frame_view" + this.viewId];
return e ? e : enyo.$["create_view" + this.viewId];
}
});

// KnopHand.js

enyo.kind({
name: "educate.frame.zijbalk.knoppen.KnopHand",
kind: "educate.frame.zijbalk.knoppen.KnopFrame",
published: {},
handlers: {},
components: [ {
tag: "i",
classes: "edu-icon edu-hand"
}, {
tag: "span",
content: "help"
} ],
create: function() {
this.inherited(arguments);
},
rendered: function() {
this.inherited(arguments), this.initHand(), this.owner.owner.$.pickAndPlace != undefined && this.setDisabled();
},
initHand: function() {
this.setAttribute("disabled", this.getValue() ? "disabled" : null), this.getSolution() && this.bubble("ontap", this);
},
setDisabled: function() {
this.setAttribute("disabled", "disabled");
}
});

// KnopOplossing.js

enyo.kind({
name: "educate.frame.zijbalk.knoppen.KnopOplossing",
kind: "educate.frame.zijbalk.knoppen.KnopFrame",
published: {
enabled: !0
},
handlers: {
onclick: "checkAnswer"
},
components: [ {
tag: "i",
classes: "edu-icon edu-oplossing",
ontap: "iconTapHandler"
}, {
tag: "span",
content: "oplossing"
} ],
create: function() {
this.inherited(arguments);
},
rendered: function() {
this.inherited(arguments), this.initOplossing(), this.owner.owner.$.pickAndPlace != undefined && this.setDisabled();
},
initOplossing: function() {
this.setAttribute("disabled", this.getValue() ? null : "disabled");
},
checkAnswer: function(e, t) {
this.bubble("checkKolomOefening"), this.bubble("checkDropdown"), this.bubble("checkMultipleChoice");
},
setDisabled: function() {
this.setEnabled(!1);
},
enabledChanged: function() {
this.setAttribute("disabled", this.getEnabled());
},
iconTapHandler: function(e, t) {
this.getEnabled() && enyo.Signals.send("onSolution");
}
});

// ZoomTool.js

enyo.kind({
name: "educate.frame.zijbalk.zoomTool.ZoomTool",
kind: enyo.Control,
classes: "zoom",
published: {
max: 95,
min: 0,
currentPos: 0,
stageWidth: 0,
stageHeight: 0,
regionX: 0,
regionY: 0,
regionWidth: 0,
regionHeight: 0,
zoomLevel: 0,
scale: 1,
offsetX: 0,
offsetY: 0,
originalScale: 1,
originalOffsetX: 0,
originalOffsetY: 0,
fromZoomImage: !1,
zoomSteps: [],
stepsAmount: 0,
currentStep: 0
},
handlers: {
updateScale: "updateScaleHandler"
},
components: [ {
tag: "div",
classes: "zoomfield",
ondblclick: "setToFull",
components: [ {
tag: "div",
classes: "region",
name: "region",
components: [ {
tag: "i",
classes: "icon-zoom-in",
name: "regionIcon"
} ],
ondrag: "moveRegion",
onclick: "selectZoomRegion"
} ]
}, {
tag: "div",
classes: "slider",
components: [ {
tag: "div",
classes: "zoom-btn zoom-in",
components: [ {
tag: "i",
classes: "fill-icon icon-add"
} ],
onclick: "zoomIn"
}, {
tag: "div",
classes: "track",
name: "track"
}, {
tag: "div",
classes: "thumb",
ondrag: "dragSlider",
dragfinish: "stopSlider"
}, {
tag: "div",
classes: "zoom-btn zoom-out",
components: [ {
tag: "i",
classes: "fill-icon icon-minus"
} ],
onclick: "zoomOut"
} ]
}, {
kind: enyo.Signals,
changeZoomTool: "changeZoomToolHandler"
}, {
kind: enyo.Signals,
hideZoomTool: "hideZoomToolHandler"
} ],
create: function() {
this.inherited(arguments), $(document).on("mouseup", enyo.bind(this, "setParametersOnUp"));
},
rendered: function() {
this.inherited(arguments), this.updateScaleHandler(), this.$.regionIcon.hide(), this.setParametersOnUp(), this.stageWidth = parseInt($(".stage").css("width").replace("px", "")), this.stageHeight = parseInt($(".stage").css("height").replace("px", "")), this.regionWidth = parseInt($(".region").css("width").replace("px", "")), this.regionHeight = parseInt($(".region").css("height").replace("px", ""));
},
updateScaleHandler: function() {
this.originalScale = window.settings.SCALE, this.originalOffsetX = window.settings.OFFSETX, this.originalOffsetY = window.settings.OFFSETY;
},
changeZoomToolHandler: function(e, t) {
this.fromZoomImage = !0, this.$.region.parent.hide(), this.zoomSteps = t.zoomSteps, this.stepsAmount = t.zoomSteps.length - 1, this.currentStep = 0;
var n = 95 / this.stepsAmount, r = 2;
for (var i = 0; i <= this.stepsAmount; i++) this.$.track.createComponent({
tag: "div",
name: "step" + i,
style: "top: " + r + "px;height: 1px;width: 9px;background-color: white;position: absolute;left: -2px;"
}), r += n;
},
setParametersOnUp: function(e, t) {
this.currentPos = parseInt($(".thumb").css("top").replace("px", "")), this.min = this.min - (this.currentPos + this.min - 35), this.max = 95 - math.abs(this.min), this.setRegionXY();
},
setToFull: function(e, t) {
this.zoomLevel > 0 && ($(".thumb").css("top", "130px"), this.zoomLevel = 0, this.min = 0, this.max = 95, this.handleZoom());
},
selectZoomRegion: function(e, t) {
this.zoomLevel == 0 && (this.owner.owner.$.zoomSvg ? (this.owner.owner.$.zoomSvg.destroy(), this.$.regionIcon.hide()) : (this.owner.owner.createComponent({
name: "zoomSvg",
kind: "educate.frame.zijbalk.zoomTool.ZoomSvg",
zoomInstance: this
}), this.$.regionIcon.show()));
},
zoomInFromRegion: function(e, t, n) {
var r = parseInt($(".region").css("height").replace("px", "")), i = parseInt($(".region").css("width").replace("px", "")), s = parseInt($(".inner-box").css("width").replace("px", "")) / i - 2, o = parseInt($(".inner-box").css("height").replace("px", "")) / r + 1;
this.zoomLevel = (parseInt($(".inner-box").css("width").replace("px", "")) / e - 1) * 23, $(".thumb").css("top", math.abs(this.zoomLevel - 130) + "px"), $(".region").css("top", n / o + "px"), $(".region").css("left", t / s + "px"), this.currentPos = parseInt($(".thumb").css("top").replace("px", "")), this.min = this.min - (this.currentPos + this.min - 35), this.max = 95 - math.abs(this.min), this.owner.owner.$.zoomSvg && (this.owner.owner.$.zoomSvg.destroy(), this.$.regionIcon.hide()), this.handleZoom(t, n);
},
zoomIn: function(e, t) {
this.zoomLevel >= 0 && this.zoomLevel < 95 && (this.fromZoomImage ? (this.zoomLevel += 95 / this.stepsAmount, this.currentStep++, $(".thumb").css("top", math.abs(this.zoomLevel - 130) + "px"), enyo.Signals.send("changeZoomImage", this.currentStep), this.currentPos = parseInt($(".thumb").css("top").replace("px", "")), this.min = this.min - (this.currentPos + this.min - 35), this.max = 95 - math.abs(this.min)) : (this.zoomLevel++, isNaN(parseInt($(".thumb").css("top").replace("px", ""))) ? $(".thumb").css("top", "130px") : $(".thumb").css("top", parseInt($(".thumb").css("top").replace("px", "")) - 1 + "px"), this.handleZoom()));
},
zoomOut: function(e, t) {
this.zoomLevel > 0 && this.zoomLevel <= 95 && (this.fromZoomImage ? (this.zoomLevel -= 95 / this.stepsAmount, this.currentStep--, $(".thumb").css("top", math.abs(this.zoomLevel - 130) + "px"), enyo.Signals.send("changeZoomImage", this.currentStep), this.currentPos = parseInt($(".thumb").css("top").replace("px", "")), this.min = this.min - (this.currentPos + this.min - 35), this.max = 95 - math.abs(this.min)) : (this.zoomLevel--, isNaN(parseInt($(".thumb").css("top").replace("px", ""))) ? $(".thumb").css("top", "130px") : $(".thumb").css("top", parseInt($(".thumb").css("top").replace("px", "")) + 1 + "px"), this.currentPos = parseInt($(".thumb").css("top").replace("px", "")), this.handleZoom()));
},
dragSlider: function(e, t) {
t.dy >= this.min && t.dy <= this.max && this.currentPos != 0 && $(".thumb").css("top", t.dy + this.currentPos + "px");
if (this.fromZoomImage) {
var n = t.dy + this.currentPos, r = math.round(130 - 95 / this.stepsAmount * (this.currentStep + 1)), i = math.round(130 - 95 / this.stepsAmount * (this.currentStep - 1));
if (n == r || n == r - 1 || n == r + 1) this.zoomLevel += 95 / this.stepsAmount, this.currentStep++, enyo.Signals.send("changeZoomImage", this.currentStep); else if (n == i || n == i - 1 || n == i + 1) this.zoomLevel -= 95 / this.stepsAmount, this.currentStep--, enyo.Signals.send("changeZoomImage", this.currentStep);
} else this.zoomLevel = math.abs(parseInt($(".thumb").css("top").replace("px", "")) - 130), this.handleZoom();
},
moveRegion: function(e, t) {
var n = parseInt($(".region").css("height").replace("px", "")), r = parseInt($(".region").css("width").replace("px", "")), i = parseInt($(".inner-box").css("width").replace("px", "")) / r - 2, s = parseInt($(".inner-box").css("height").replace("px", "")) / n + 1, o = t.dy + this.regionY, u = t.dx + this.regionX;
$(".region").css("top", (o >= 0 ? o + n <= 33 ? o : 33 - n : 0) + "px"), $(".region").css("left", (u >= 0 ? u + r <= 41 ? u : 41 - r : 0) + "px"), $(".inner-box").scrollLeft((u >= 0 ? u : 0) * i), $(".inner-box").scrollTop((o >= 0 ? o : 0) * s);
},
handleZoom: function(e, t) {
var n = this.zoomLevel / 23 + 1;
if (this.zoomLevel > 0) {
$(".inner-box").css("overflow", "scroll"), this.zoomTest(n);
var r = this.regionX + parseInt($(".region").css("width").replace("px", "")) + 6, i = parseInt($(".zoomfield").css("width").replace("px", "")), s = this.regionY + parseInt($(".region").css("height").replace("px", "")) + 6, o = parseInt($(".zoomfield").css("height").replace("px", ""));
$(".region").css("width", this.regionWidth * (1 / n) + "px"), $(".region").css("height", this.regionHeight * (1 / n) + "px"), r >= i && $(".region").css("left", parseInt($(".region").css("left").replace("px", "")) - 2), s >= o && $(".region").css("top", parseInt($(".region").css("top").replace("px", "")) - 1.5), this.setRegionXY();
} else $(".inner-box").css("overflow", "visible"), this.zoomTest(1 / n), $(".region").css("width", "100%"), $(".region").css("height", "100%"), $(".region").css("top", "0px"), $(".region").css("left", "0px");
e != undefined && ($(".inner-box").scrollLeft(e * n), $(".inner-box").scrollTop(t * n));
},
setRegionXY: function() {
this.regionX = parseInt($(".region").css("left").replace("px", "")), isNaN(this.regionX) && (this.regionX = 0), this.regionY = parseInt($(".region").css("top").replace("px", "")), isNaN(this.regionY) && (this.regionY = 0);
},
zoomTest: function(e) {
this.scale = this.originalScale * e, this.offsetX = this.originalOffsetX * e, this.offsetY = this.originalOffsetY * e, this.bubble("resizeFunction", this);
},
hideZoomToolHandler: function() {
this.hide();
}
});

// ZoomSvg.js

enyo.kind({
name: "educate.frame.zijbalk.zoomTool.ZoomSvg",
kind: enyo.Control,
tag: "div",
classes: "zoomSvg",
published: {
width: window.settings.STAGEWIDTH,
height: window.settings.STAGEHEIGHT,
beginP: 0,
endP: 0,
drawMove: !0,
opacity: .5,
fillColor: "230,230,230",
mouseDown: !1,
cursorShape: undefined,
widthHeightRatio: 1,
zoomInstance: {}
},
handlers: {
ondragfinish: "onDragEndHandler",
ondrag: "onMoveHandler",
ondown: "onDownHandler"
},
components: [ {
name: "svg",
tag: "svg",
attributes: {
xmlns: "http://www.w3.org/2000/svg"
}
} ],
create: function() {
this.inherited(arguments), this.render();
},
onDragEndHandler: function(e, t) {
this.endP = this.getPositionInSvg(t), this.mouseDown = !1, this.drawMove || this.$.svg.hasNode().removeChild(this.cursorShape), this.cursorShape.width.baseVal.value <= $(".stage").width() / 5.1 ? this.zoomInstance.zoomInFromRegion($(".stage").width() / 5.1, this.cursorShape.x.baseVal.value - 70, this.cursorShape.y.baseVal.value - 24) : this.zoomInstance.zoomInFromRegion(this.cursorShape.width.baseVal.value, this.cursorShape.x.baseVal.value - 70, this.cursorShape.y.baseVal.value - 24), this.cursorShape = undefined;
},
onMoveHandler: function(e, t) {
var n = this.getPositionInSvg(t);
this.cursorShape == undefined && (this.cursorShape = document.createElementNS("http://www.w3.org/2000/svg", "rect"), this.cursorShape.width.baseVal.value = Math.abs(n.x - this.beginP.x), this.cursorShape.height.baseVal.value = Math.abs(n.y - this.beginP.y), this.cursorShape.style.fill = "white", this.cursorShape.style.fillOpacity = this.opacity, this.$.svg.hasNode().appendChild(this.cursorShape), this.cursorShape.x.baseVal.value = n.x < this.beginP.x ? n.x : this.beginP.x + 70, this.cursorShape.y.baseVal.value = n.y < this.beginP.y ? n.y : this.beginP.y + 24), this.cursorShape.width.baseVal.value = Math.abs(n.x - this.beginP.x), this.cursorShape.height.baseVal.value = this.cursorShape.width.baseVal.value / this.widthHeightRatio, this.cursorShape.x.baseVal.value = n.x < this.beginP.x ? n.x : this.beginP.x + 70, this.cursorShape.y.baseVal.value = n.y < this.beginP.y ? n.y : this.beginP.y + 24;
},
onDownHandler: function(e, t) {
this.beginP = this.getPositionInSvg(t), this.widthHeightRatio = $(".stage").width() / $(".stage").height();
},
getPositionInSvg: function(e) {
var t = this.parent.node.offsetLeft, n = new Object;
return n.x = e.clientX - t, n.y = e.clientY - 55, n;
},
resizeComponent: function() {
this.inherited(arguments);
}
});

// Titelbalk.js

enyo.kind({
kind: enyo.Control,
name: "educate.frame.titelbalk.Titelbalk",
classes: "titlebar",
style: "z-index: 2;",
components: [ {
kind: "educate.frame.titelbalk.Titel",
name: "title"
}, {
kind: "educate.frame.titelbalk.Value",
name: "value"
}, {
kind: "educate.frame.titelbalk.Klok"
} ],
published: {
title: "",
value: ""
},
create: function() {
this.inherited(arguments), this.titleChanged(), this.valueChanged();
},
titleChanged: function() {
this.$.title.setTitle(this.title), this.render();
},
valueChanged: function() {
this.$.value.setValue(this.getValue()), this.render();
},
toggleSettings: function(e, t) {
this.$.toggleSettings.addRemoveClass("open", !this.$.toggleSettings.hasClass("open"));
}
});

// Titel.js

enyo.kind({
kind: enyo.Control,
name: "educate.frame.titelbalk.Titel",
tag: "div",
classes: "titleField",
components: [ {
tag: "input",
name: "chkTitle",
attributes: {
type: "checkbox"
}
}, {
tag: "label",
name: "lblTitle",
components: [ {
tag: "span",
name: "spanTitle",
content: "title"
} ]
} ],
published: {
titleHidable: !1,
title: ""
},
create: function() {
this.inherited(arguments), this.titleHidableChanged(), this.titleChanged(), this.$.lblTitle.setAttribute("for", this.$.chkTitle.getId());
},
titleHidableChanged: function() {
this.$.chkTitle.addRemoveClass("hidable", this.getTitleHidable()), this.getTitleHidable() || this.$.chkTitle.setAttribute("checked");
},
titleChanged: function() {
this.$.spanTitle.content = this.title;
}
});

// Klok.js

enyo.kind({
kind: enyo.Control,
name: "educate.frame.titelbalk.Klok",
tag: "div",
classes: "clock",
components: [ {
tag: "p",
name: "date",
classes: "date",
content: "dinsdag 19 maart 2013"
}, {
tag: "p",
name: "time",
classes: "time",
content: "16:41:37"
} ],
create: function() {
this.inherited(arguments), this.updateTime(), this.updateDate();
},
rendered: function() {
window.setInterval(enyo.bind(this, "updateTime"), 500), window.setInterval(enyo.bind(this, "updateDate"), 54e5);
},
updateTime: function() {
var e = new Date, t = e.getHours(), n = e.getMinutes(), r = e.getSeconds(), i = t <= 9 ? "0" : "";
i += t + ":", i += n <= 9 ? "0" : "", i += n + ":", i += r <= 9 ? "0" : "", i += r, this.$.time.setContent(i);
},
updateDate: function() {
var e = new Date, t = e.getDay(), n = e.getDate(), r = e.getMonth(), i = e.getFullYear(), s = new Array("januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"), o = new Array("zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"), u = o[t] + " ";
u += n <= 9 ? "0" : "", u += n + " ", u += s[r] + " " + i + " ", this.$.date.setContent(u);
}
});

// Value.js

enyo.kind({
kind: enyo.Control,
name: "educate.frame.titelbalk.Value",
tag: "div",
classes: "valueField",
components: [ {
tag: "label",
content: "ID: ",
classes: "lblGoToSceneByValue",
name: "lblGoToSceneByValue"
}, {
kind: "enyo.Input",
name: "txtValue",
classes: "txtGoToSceneByValue hidden",
value: "value",
type: "text",
onfocus: "txtValueFocused",
onblur: "txtValueFocusEnd",
onchange: "txtValueChanged",
onsubmit: "txtValueChanged",
attributes: {
"data-toggle": "popover"
}
}, {
tag: "span",
name: "spanValue",
classes: "spanGoToSceneByValue",
content: "value",
ontap: "focusOnTxt"
}, {
tag: "div",
classes: "btnGoToSceneByValue",
name: "btnGoToSceneByValue",
ontap: "btnGoToSceneByValueTapped",
allowHtml: !0,
content: "&nbsp;"
} ],
published: {
valueHidable: !0,
value: ""
},
create: function() {
this.inherited(arguments), this.valueHidableChanged(), this.valueChanged();
},
valueHidableChanged: function() {},
valueChanged: function() {
this.$.txtValue.setValue(this.getValue()), this.$.spanValue.setContent(this.getValue());
},
btnGoToSceneByValueTapped: function() {
$(".txtGoToSceneByValue").popover("destroy");
var e = this.checkValueInput();
e === !0 ? this.checkValueExist() : e === "leeg" ? this.showValueFieldPopup("Geen id", "Gelieve een id van een les in te vullen.") : e === "same" ? this.showValueFieldPopup("Huidige les", "Dit is de huidige les.") : e === "pattern" && this.showValueFieldPopup("Fout formaat", "Sorry, het id moet het volgende formaat hebben: xxxx-x-x-x-x.");
},
checkValueInput: function() {
var e = /^\d\d\d\d-\d+-\d+-\d+-\d+$/, t = this.$.txtValue.getValue();
return t === "" ? "leeg" : t === this.getValue() ? "same" : e.test(t) ? !0 : "pattern";
},
checkValueExist: function() {
var e = "value=" + this.$.txtValue.getValue();
$.ajax({
url: Settings.SERVER + "hasSceneByValue",
type: "GET",
data: e,
dataType: "json",
success: enyo.bind(this, "completeCheckValueExistHandler"),
error: enyo.bind(this, "errorCheckValueExistHandler"),
xhrFields: {
withCredentials: !0
}
});
},
completeCheckValueExistHandler: function(e, t) {
e.status === "success" ? (window.location = Settings.LES + "#/" + e.data, window.location.reload()) : this.showValueFieldPopup("Geen les gevonden", "Sorry, deze les werd niet teruggevonden.");
},
errorCheckValueExistHandler: function(e, t) {
this.showValueFieldPopup("Er liep iets mis", "Gelieve de pagina te refreshen.");
},
txtValueFocused: function() {
this.destroyValueFieldPopup();
},
txtValueFocusEnd: function() {
this.$.spanValue.setContent(this.$.txtValue.getValue()), this.$.txtValue.addClass("hidden"), this.$.spanValue.removeClass("hidden"), this.btnGoToSceneByValueTapped();
},
focusOnTxt: function() {
this.$.txtValue.removeClass("hidden"), this.$.spanValue.addClass("hidden"), this.$.txtValue.focus();
},
txtValueChanged: function() {
this.$.spanValue.setContent(this.$.txtValue.getValue()), this.btnGoToSceneByValueTapped();
},
showValueFieldPopup: function(e, t) {
$(".txtGoToSceneByValue").popover({
title: e,
content: t,
placement: "bottom"
}).popover("show"), $(".popover").click(function() {
this.remove();
});
},
destroyValueFieldPopup: function() {
$(".txtGoToSceneByValue").popover("destroy");
}
});

// View.js

enyo.kind({
kind: enyo.Control,
name: "educate.frame.view.View",
classes: "view",
handlers: {
onObjectAdded: "onObjectAddedHandler",
svgLoaded: "svgLoadedHandler",
actionSended: "actionSendedHandler",
mouseMoveStage: "mouseMoveStageHandler",
updateZoomToolScale: "updateZoomToolScaleHandler",
onSendSvgObjects: "onSendSvgObjectsHandler",
resizeFunction: "resizeComponents"
},
published: {
carrier: "",
value: "",
layername: "",
solution: "",
answered: "",
width: 0,
height: 0,
position_x: 0,
position_y: 0,
inLayerHolder: 0,
objectsForLayerHolder: [],
objectId: "",
viewId: "",
collection: "",
viewReady: !1,
objectsReady: 0,
hasCanvas: !1,
hasBrowserSupportModal: !1,
hasBadBrowserSupport: {
video: !1,
pickandplace: !1
},
unParsedActionHandlers: [],
unParsedLinkHandlers: [],
viewChildren: {},
unParsedGlobalvarLinkeigenschappen: [],
globalLinkEigenschapVariables: [],
count: 0,
hasSolution: !1
},
components: [ {
content: "fits",
name: "panelMiddle",
fit: !0,
classes: "inner-box",
components: [ {
name: "stage",
kind: "educate.frame.view.stage.Stage"
} ]
}, {
name: "lagenPalet",
kind: "educate.frame.view.lagenPalet.LagenPalet"
}, {
name: "zijbalk",
kind: "educate.frame.zijbalk.Zijbalk"
}, {
kind: "Signals",
onSendSvgObjects: "onSendSvgObjectsHandler"
} ],
create: function() {
window.settings.EVENTS[this.viewId] = {}, this.inherited(arguments), this.createDrawCanvas(), this.initView(), this.handleView(), this.render();
},
rendered: function() {
this.inherited(arguments), this.arrangeObjecten(), this.browserDetection();
},
resizeComponents: function(e, t) {
this.$.stage.handleResizeFromZoom(t);
},
resizeHandler: function(e, t) {
this.inherited(arguments), this.$.drawCanvas && this.$.drawCanvas.resizeComponent();
},
createDrawCanvas: function() {
this.hasCanvas || (this.hasCanvas = !0, this.createComponent({
container: this.$.panelMiddle,
kind: "educate.frame.view.draw.Draw",
name: "drawCanvas",
viewId: this.getViewId(),
removeAndResize: !0
}));
},
initView: function() {
this.$.zijbalk.setViewId(this.getViewId()), this.$.lagenPalet.setViewId(this.getViewId()), this.$.stage.setViewId(this.getViewId());
},
handleView: function() {
this.setUnParsedActionHandlers([]), this.setUnParsedLinkHandlers([]), this.setObjectsForLayerHolder([]), this.setUnParsedGlobalvarLinkeigenschappen([]), this.setGlobalLinkEigenschapVariables([]), this.parseCollection(this.getCollection()), this.afterParseCollection();
},
clearView: function() {
this.$.panelMiddle.destroyClientControls(), this.$.lagenPalet.destroyClientControls(), this.$.frameRight.destroyClientControls();
},
parseCollection: function(e, t) {
t = t ? t : this.$.stage;
var n = this;
for (var r in e) {
var i = e[r];
switch (i.carrier.name) {
case "oplossing":
this.handleOplossing(i), i.collection && n.parseCollection(i.collection), this.objectReady();
break;
case "hand":
this.handleHand(i), i.collection && n.parseCollection(i.collection), this.objectReady();
break;
case "groep":
this.$.stage.addGroep(i, t), i.collection && n.parseCollection(i.collection, this.$.stage.getObjectFromStage(i.name)), this.objectReady();
break;
case "svgImage":
this.$.stage.addSvg(i, t), i.collection && n.parseCollection(i.collection);
break;
case "image":
this.$.stage.addImage(i, t), i.collection && n.parseCollection(i.collection), this.objectReady();
break;
case "tekst":
this.$.stage.addTekst(i, t), i.collection && n.parseCollection(i.collection), this.objectReady();
break;
case "button":
this.$.stage.addKnop(i, t), i.collection && n.parseCollection(i.collection), this.objectReady();
break;
case "infoIcon":
this.$.stage.addInfoIcon(i, t), i.collection && n.parseCollection(i.collection), this.objectReady();
break;
case "photoIcon":
this.$.stage.addPhotoIcon(i, t), i.collection && n.parseCollection(i.collection), this.objectReady();
break;
case "sprite":
this.$.stage.addAnimatie(i, t), i.collection && n.parseCollection(i.collection), this.objectReady();
break;
case "raster":
this.$.stage.addRaster(i, t), i.collection && n.parseCollection(i.collection), this.objectReady();
break;
case "cijferveld":
this.$.stage.addCijferveld(i, t), i.collection && n.parseCollection(i.collection), this.objectReady();
break;
case "zones":
i.collection && n.parseCollection(i.collection);
break;
case "video":
this.getHasBadBrowserSupport().video = !0, this.$.stage.addVideo(i, t), i.collection && n.parseCollection(i.collection), this.objectReady();
break;
case "laag":
n.objectsForLayerHolder.push(i), this.objectReady();
break;
case "linkeigenschap":
n.unParsedLinkHandlers.push(i);
break;
case "eventActionHandler":
n.unParsedActionHandlers.push(i);
break;
case "globalvarlinkeigenschap":
n.unParsedGlobalvarLinkeigenschappen.push(i), this.objectReady();
break;
case "square":
this.$.stage.addSquareHandler(i, t), i.collection && n.parseCollection(i.collection), this.objectReady();
break;
case "ellipse":
this.$.stage.addEllipseHandler(i, t), i.collection && n.parseCollection(i.collection), this.objectReady();
break;
case "free":
this.$.stage.addFreeHandler(i, t), i.collection && n.parseCollection(i.collection), this.objectReady();
break;
case "multi":
this.$.stage.addMultiHandler(i, t), i.collection && n.parseCollection(i.collection), this.objectReady();
break;
case "meetlat":
this.$.stage.addMeetlat(i, t), i.collection && n.parseCollection(i.collection), this.objectReady();
break;
case "lijnstuk":
this.$.stage.addLijnstuk(i, t), i.collection && n.parseCollection(i.collection), this.objectReady();
break;
case "inputfield":
this.$.stage.addInputField(i, t), i.collection && n.parseCollection(i.collection), this.objectReady();
break;
case "pickplacewords":
this.getHasBadBrowserSupport().pickandplace = !0, this.$.stage.addPickAndPlace(i, t), i.collection && n.parseCollection(i.collection), this.objectReady();
break;
case "zoomImage":
this.$.stage.addZoomImage(i, t), i.collection && n.parseCollection(i.collection), this.objectReady();
break;
case "kolomwoorden":
this.$.stage.addKolomOefeningWoorden(i, t), i.collection && n.parseCollection(i.collection), this.objectReady();
break;
case "kolomafbeeldingen":
this.$.stage.addKolomOefeningAfbeeldingen(i, t), i.collection && n.parseCollection(i.collection), this.objectReady();
break;
case "pickplaceimages":
this.getHasBadBrowserSupport().pickandplace = !0, this.$.stage.addPickAndPlaceAfbeeldingen(i, t), i.collection && n.parseCollection(i.collection), this.objectReady();
break;
case "dropdown":
this.$.stage.addDropdown(i, t), i.collection && n.parseCollection(i.collection), this.objectReady();
break;
case "flipcard":
this.$.stage.addFlipcard(i, t), i.collection && n.parseCollection(i.collection), this.objectReady();
break;
case "website":
this.$.stage.addWebFrame(i, t), i.collection && n.parseCollection(i.collection), this.objectReady();
break;
case "map":
this.$.stage.addMap(i, t), i.collection && n.parseCollection(i.collection), this.objectReady();
break;
case "youtube":
this.$.stage.addYoutube(i, t), i.collection && n.parseCollection(i.collection), this.objectReady();
break;
case "threedobject":
this.$.stage.add3DObject(i, t), i.collection && n.parseCollection(i.collection), this.objectReady();
break;
case "threedmesh":
this.$.stage.add3DMesh(i, t), i.collection && n.parseCollection(i.collection), this.objectReady();
break;
case "begeleidZelfstandigLeren":
this.$.stage.addBegeleidZelfstandigLeren(i, t), i.collection && n.parseCollection(i.collection);
break;
case "klimatogram":
this.$.stage.addKlimatogram(i, t), i.collection && n.parseCollection(i.collection), this.objectReady();
break;
case "multipleChoice":
this.$.stage.addMultipleChoice(i, t), i.collection && n.parseCollection(i.collection), this.objectReady();
break;
case "columnExerciseWords":
this.$.stage.addColumnExerciseWords(i, t), i.collection && n.parseCollection(i.collection), this.objectReady();
break;
case "columnExerciseImages":
this.$.stage.addColumnExerciseImages(i, t), i.collection && n.parseCollection(i.collection), this.objectReady();
break;
default:
console.log('case "' + i.carrier.name + '": break;');
}
}
},
afterParseCollection: function() {
this.reflow(), this.$.panelMiddle.render();
},
objectReady: function() {
this.setObjectsReady(this.getObjectsReady() + 1), this.count = 0, this.countAllObjectsToLoad(this.getCollection()) === this.getObjectsReady() && (this.handleLagen(), this.loadGlobalvarLinkEigenschappen(), this.doActionHandlers(), this.doLinkHandlers());
},
countAllObjectsToLoad: function(e) {
for (var t in e) e[t].carrier.name != "eventActionHandler" && e[t].carrier.name != "linkeigenschap" && this.count++, e[t].carrier.name === "groep" && this.countAllObjectsToLoad(e[t].collection);
return this.count;
},
handleLagen: function() {
if (this.getObjectsForLayerHolder().length > 0) {
this.getObjectsForLayerHolder().sort(enyo.bind(this, "sorteerLagen"));
var e = this.getObjectsForLayerHolder().length;
for (var t = 0; t < e; t++) if (this.getObjectsForLayerHolder()[t].inLayerHolder) {
var n = this.$.lagenPalet.addLaag(this.getObjectsForLayerHolder()[t]);
this.$.stage.applyPropertiesToObject(n, this.getObjectsForLayerHolder()[t]), this.getObjectsForLayerHolder()[t].collection && this.handleLaagCollection(this.getObjectsForLayerHolder()[t].collection, n);
var r = this.getChildById(n.solution);
r.laag = n;
}
this.$.lagenPalet.render();
}
},
handleLaagCollection: function(e, t) {
t.setCollection([]);
var n = [];
for (var r in e) e[r].carrier.code == window.settings.CARRIERS.EVENTACTIONHANDLER ? this.unParsedActionHandlers.push(e[r]) : n.push(e[r]);
n.sort(enyo.bind(this, "sorteerLagen"));
var i = n.length;
for (var r = 0; r < i; r++) {
var s = this.$.lagenPalet.addLaag(n[r]);
this.$.stage.applyPropertiesToObject(s, n[r]), t.getCollection().push(s), s.setToGroup(t), t.checkIsGroup(), t.handleChildBorderKleur(), n[r].collection && this.handleLaagCollection(n[r].collection, s);
}
this.$.lagenPalet.render();
},
sorteerLagen: function(e, t) {
return e.position - t.position;
},
loadGlobalvarLinkEigenschappen: function() {
var e = this.unParsedGlobalvarLinkeigenschappen, t = this.unParsedGlobalvarLinkeigenschappen.length;
for (var n = 0; n < t; n++) {
var r = new educate.GlobalVariableLinkeigenschap;
r.name = e[n].name, r.answered = e[n].answered, r.objectId = e[n].id, r.databaseId = e[n].id, this.getGlobalLinkEigenschapVariables().push(r);
}
},
doActionHandlers: function() {
var e, t = this.getUnParsedActionHandlers().length, n, r, i = [], s = [];
for (e = 0; e < t; e++) {
var o = this.getUnParsedActionHandlers()[e], u = {
id: o.id,
name: o.name,
value: o.value,
answered: o.answered,
solution: o.solution,
css_class: o.css_class,
parent: o.parent
};
r !== this.getChildById(o.parent) && i.push(this.getChildById(o.parent)), r = this.getChildById(o.parent);
if (r) {
var a = o.collection;
u.collection = {};
try {
r.handlers[r.getEventOptions()[o.value].action] = r.getEventOptions()[o.value].action + "ActionHandler";
for (n in a) u.collection[a[n].solution] || (u.collection[a[n].solution] = {}), u.collection[a[n].solution][a[n].position] = a[n].value;
r.getActions().push(u), window.settings.EVENTS[this.viewId][u.id] = 0;
} catch (f) {
var l = "Er liep iets fout in de actie met naam: \n" + o.name;
l += ".\n\nDeze actie hangt vast aan de component met naam: " + r.layername, alert(l);
}
} else s.push(o), console.log("no action parent found with ID: " + u.parent);
}
this.unParsedActionHandlers = s, t = i.length;
for (e = 0; e < t; e++) i[e].actionsChanged();
},
doLinkHandlers: function() {
var e, t = this.getUnParsedLinkHandlers().length, n, r;
for (e = 0; e < t; e++) {
var i = this.getUnParsedLinkHandlers()[e], s = {
id: i.id,
name: i.name,
answered: i.answered,
solution: i.solution,
css_class: i.css_class,
parent: i.parent
};
r = this.getChildById(i.parent);
if (r) {
var o = /{\w+\.\w+}/g;
s.answered = this.addGlobalsToFormule(s.answered);
var u = s.answered.match(o);
if (u) {
var a = u.length;
for (var f = 0; f < a; f++) {
u[f] = u[f].replace(/({|})/g, "");
var l = u[f].split("."), c = this.getChildByName(l[0]), h = c.getLinkEigenschappenOptions()[l[1]];
c.handlers["on" + h.substr(0, 1).toUpperCase() + h.substr(1) + "Changed"] = h + "ChangedHandler", c[h + "ChangedHandler"] || (c[h + "ChangedHandler"] = function() {
this.signalLinkTargets();
}), c[h + "ChangedHandler"](), c.getLinks().push(s);
}
}
} else console.log("no action parent found with ID: " + s.parent);
}
},
addGlobalsToFormule: function(e) {
var t = this.getGlobalLinkEigenschapVariables(), n = this.getGlobalLinkEigenschapVariables().length;
for (var r = 0; r < n; r++) {
var i = new RegExp("\\" + t[r].name, "g");
i.test(e) && (e = e.replace(i, this.addGlobalsToFormule(t[r].answered)));
}
return e;
},
browserDetection: function() {
(this.getHasBadBrowserSupport().video && $.browser.msie || this.getHasBadBrowserSupport().pickandplace && $.browser.msie) && this.showBadBrowserSupport();
},
showBadBrowserSupport: function() {
this.hasBrowserSupportModal || (this.hasBrowserSupportModal = !0, this.createComponent({
container: this.$.panelMiddle,
kind: "educate.frame.view.browserSupport.BrowserSupportModal",
name: "browserSupportModal",
viewId: this.getViewId()
}), this.$.panelMiddle.render());
},
getChildById: function(e) {
return this.viewChildren[e];
},
getChildByName: function(e) {
for (var t in this.getViewChildren()) if (this.getViewChildren()[t].layername === e) return this.getViewChildren()[t];
return null;
},
handleOplossing: function(e) {
var t = this.$.zijbalk.createOplossing();
t = this.$.stage.applyPropertiesToObject(t, e);
},
handleHand: function(e) {
var t = this.$.zijbalk.createHand();
t = this.$.stage.applyPropertiesToObject(t, e);
},
svgLoadedHandler: function(e, t) {
var n = this.handleZones(t.collection, t);
t.setCollection(n), t.resizeComponent(), t.updateNodes(), this.objectReady();
},
handleZones: function(e, t) {
var n = [];
for (var r in e) {
var i = e[r];
if (i.carrier.name == "zones") {
var s = this.createSvgZone(i, t);
i.collection && s.setCollection(this.handleZones(i.collection, t)), n.push(s);
}
}
return n;
},
createSvgZone: function(e, t) {
var n, r = JSON.parse(!e.options || e.options === "" ? "{}" : e.options);
return this.$[e.name] ? (n = this.$[e.name], n.value = e.value, n.active = e.active, n.svgparser = t, n.viewId = this.getViewId(), n.objectId = e.id) : n = this.createComponent({
kind: t.getLayerClass().SvgZone,
name: e.name,
value: e.value,
active: e.active,
svgparser: t,
viewId: this.getViewId(),
objectId: e.id
}, {
owner: t
}), n.node = document.getElementById(e.value), n = this.$.stage.applyPropertiesToObject(n, e), n;
},
onObjectAddedHandler: function(e, t) {
this.viewChildren[t.obj.getObjectId()] = t.obj;
},
onSendSvgObjectsHandler: function(e, t) {
this.waterfall("sendSvgObjects", {
svgObjects: t.svgObjects
});
},
actionSendedHandler: function(e, t) {
this.waterfallDown("actionSended", t);
},
mouseMoveStageHandler: function(e, t) {
this.waterfall("dragButton", t);
},
updateZoomToolScaleHandler: function(e, t) {
this.waterfallDown("updateScale");
},
arrangeObjecten: function() {
this.$.stage.arrangeObjecten();
},
hasSolutionChanged: function() {
this.$.zijbalk.setHasSolution(this.getHasSolution());
}
});

// LagenPalet.js

enyo.kind({
name: "educate.frame.view.lagenPalet.LagenPalet",
classes: "lagenholder",
handlers: {
ontap: "toggleLagenPalet",
onUniekLaagClicked: "uniekLaagClickedHandler"
},
components: [ {
tag: "ul",
name: "list"
} ],
style: "z-index: 2;",
published: {
open: !1,
showing: !1,
lagen: [],
viewId: ""
},
create: function() {
this.inherited(arguments), this.openChanged();
},
rendered: function() {
this.inherited(arguments);
},
toggleLagenPalet: function(e, t) {
t.originator === this && this.setOpen(!this.getOpen());
},
openChanged: function() {
this.addRemoveClass("open", this.getOpen());
},
addLaag: function(e) {
var t = {};
e && (t = JSON.parse(!e.options || e.options === "" ? "{}" : e.options));
var n = this.createComponent({
container: this.$.list,
kind: "educate.frame.view.lagenPalet.Laag",
name: e.name + "_laag_" + Date.now(),
layername: e.name,
solution: e.solution,
uniek: t.uniek,
viewId: this.getViewId()
});
return this.lagen.push(n), this.lagenChanged(), n;
},
lagenChanged: function() {
this.setShowing(this.getLagen().length > 0);
},
uniekLaagClickedHandler: function(e, t) {
var n = this.$.list.children.length;
for (var r = 0; r < n; r++) t.name !== this.$.list.children[r].name && this.$.list.children[r].zetLaagUit();
}
});

// Laag.js

enyo.kind({
name: "educate.frame.view.lagenPalet.Laag",
kind: "educate.components.ActionHandler",
tag: "li",
classes: "laagFrame",
handlers: {
ondown: "downLaagHandler"
},
events: {
onUniekLaagClicked: ""
},
components: [ {
classes: "colour",
name: "color",
style: "background-color: #EF2E26;"
}, {
tag: "i",
name: "img",
classes: "imgicon line-icon"
}, {
tag: "label",
name: "lbl"
} ],
published: {
width: "100%",
height: "30",
value: "",
answered: "",
solution: "",
position: "",
objectId: "",
databaseId: "",
actions: [],
viewId: "",
collection: [],
toGroup: "",
isGroup: !1,
isGroupOpen: !0,
linked: null,
uniek: !1,
laagOpen: ""
},
create: function() {
this.inherited(arguments), this.handleInitOpen(), this.render();
},
rendered: function() {
this.inherited(arguments), this.layernameChanged(), this.valueChanged();
},
initEventsReactiesOptions: function() {
this.inherited(arguments), this.getReactieOptions().LAAGACTIES = {
label: "laag acties",
action: "laagActies"
};
},
handleInitOpen: function() {
var e = this.getView().getChildById(this.getSolution());
this.setLaagOpen(e.visible);
},
downLaagHandler: function() {
this.toggle();
},
getView: function() {
var e = enyo.$["frame_view" + this.viewId];
return e ? e : enyo.$["create_view" + this.viewId];
},
valueChanged: function() {
this.$.color.applyStyle("background-color", this.getValue());
},
laagOpenChanged: function() {
this.$.img.addRemoveClass("icon-hide", !this.getLaagOpen()), this.$.img.addRemoveClass("icon-preview", this.getLaagOpen());
},
layernameChanged: function() {
this.$.lbl.setContent(this.layername);
},
laagActies: function() {
this.bubble("ontap", this);
},
toggle: function() {
this.getUniek() && this.doUniekLaagClicked(this);
},
zetLaagUit: function() {
this.setLaagOpen(!1);
var e = this.getView().getChildById(this.getSolution());
e.makeInvisible();
},
handleChildBorderKleur: function() {
console.log("handleChildBorderKleur");
},
handleBorderLaag: function() {
console.log("handleBorderLaag");
},
isGroupChanged: function() {
console.log("isGroupChanged");
},
checkIsGroup: function() {
console.log("checkIsGroup");
},
toggleGroup: function(e, t) {
console.log("toggleGroup");
},
handleIconGroup: function() {
console.log("handleIconGroup");
}
});

// Draw.js

enyo.kind({
name: "educate.frame.view.draw.Draw",
kind: enyo.Control,
tag: "canvas",
classes: "drawCanvas",
published: {
width: window.settings.STAGEWIDTH,
height: window.settings.STAGEHEIGHT,
position_x: "",
position_y: "",
isDrawing: !1,
isErasing: !1,
paint: "",
oldX: "",
oldY: "",
drawSize: 5,
drawType: "round",
selectedColor: "#333333",
oldDrawing: "",
viewId: ""
},
handlers: {
drawColorSelected: "drawColorSelectedHandler",
toggleDrawing: "toggleDrawingHandler",
toggleErasing: "toggleErasingHandler",
clearDrawing: "clearDrawingHandler",
saveDrawing: "saveDrawingHandler",
brushSizeChanged: "brushSizeChangedHandler",
ondown: "onDownHandler",
onmove: "onMoveHandler",
onup: "onUpHandler",
onleave: "onLeaveHandler",
onenter: "onEnterHandler",
mailDrawingModalSubmitted: "mailDrawingModalSubmittedHandler"
},
create: function() {
this.inherited(arguments), this.render();
},
rendered: function() {
this.inherited(arguments), this.calculatedPosXChanged(), this.calculatedPosYChanged(), this.calculatedHeightChanged(), this.calculatedWidthChanged(), this.initDrawing();
},
calculatedPosXChanged: function() {
this.applyStyle("left", this.calculatedPosX + "px");
},
calculatedPosYChanged: function() {
this.applyStyle("top", this.calculatedPosY + "px");
},
calculatedWidthChanged: function() {
this.hasNode().setAttribute("width", this.calculatedWidth);
},
calculatedHeightChanged: function() {
this.hasNode().setAttribute("height", this.calculatedHeight);
},
resizeComponent: function() {
this.calculatedWidth = parseInt(this.getWidth() * window.settings.SCALE), this.calculatedHeight = parseInt(this.getHeight() * window.settings.SCALE), this.calculatedPosX = parseInt(this.getPosition_x() * window.settings.SCALE + window.settings.OFFSETX), this.calculatedPosY = parseInt(this.getPosition_y() * window.settings.SCALE + window.settings.OFFSETY), this.render(), this.scaleDrawingUpdate();
},
scaleDrawingUpdate: function() {
this.getOldDrawing() && (this.createComponent({
tag: "img",
name: "tempimg",
src: this.getOldDrawing()
}), this.render(), this.context.drawImage(this.$.tempimg.hasNode(), 0, 0, this.width, this.height), this.$.tempimg.destroy());
},
drawColorSelectedHandler: function(e, t) {
this.setSelectedColor(t.getAttribute("color"));
},
selectedColorChanged: function() {
var e = this.getSelectedColor(), t = "", n, r, i;
e.charAt(0) === "#" && (e.substr(1).length === 6 ? (n = e.substr(1, 2), r = e.substr(3, 2), i = e.substr(5, 2)) : (n = e.substr(1, 1) + e.substr(1, 1), r = e.substr(3, 1) + e.substr(3, 1), i = e.substr(5, 1) + e.substr(5, 1)), e = "rgb(" + parseInt(n, 16) + "," + parseInt(r, 16) + "," + parseInt(i, 16) + ")");
if (e.substr(0, 3) === "rgb") {
var s = /rgba?\((\d+) ?, ?(\d+) ?, ?(\d+) ?,? ?([\d\.]+)?\)/, o = s.exec(e);
n = o[1], r = o[2], i = o[3], t = "rgba(" + n + "," + r + "," + i + ",0.5)";
}
this.$.cursorCon && this.$.cursorCon.applyStyle("color", e), this.$.drawCursor && this.$.drawCursor.addStyles("background-color: " + t + "; "), this.$.eraseCursor && this.$.eraseCursor.addStyles("background-color: rgba(255,255,255,0.5); border: 1px solid #CCC; border-radius: 50%;");
},
toggleDrawingHandler: function() {
this.getIsErasing() && this.toggleErasingHandler(), this.setIsDrawing(!this.getIsDrawing()), this.applyStyle("pointer-events", this.getIsDrawing() ? "auto" : "none"), this.applyStyle("cursor", this.getIsDrawing() ? "none" : "auto"), this.createCursorHandler();
},
toggleErasingHandler: function() {
this.getIsDrawing() && this.toggleDrawingHandler(), this.setIsErasing(!this.getIsErasing()), this.applyStyle("pointer-events", this.getIsErasing() ? "auto" : "none"), this.applyStyle("cursor", this.getIsErasing() ? "none" : "auto"), this.createCursorHandler();
},
brushSizeChangedHandler: function(e, t) {
this.setDrawSize(t.brushsize + .9 >> 0);
},
drawSizeChanged: function() {
this.$.drawCursor && this.$.drawCursor.addStyles("width: " + (this.drawSize + 4) + "px; height: " + (this.drawSize + 4) + "px; left: -" + this.drawSize * .5 + "px; bottom: " + (7 - this.drawSize * .5) + "px;"), this.$.eraseCursor && this.$.eraseCursor.addStyles("width: " + (this.drawSize + 4) + "px; height: " + (this.drawSize + 4) + "px; left: -" + this.drawSize * .5 + "px; bottom: " + (7 - this.drawSize * .5) + "px;");
},
initDrawing: function() {
this.context = this.hasNode().getContext("2d"), this.context.scale(window.settings.SCALE, window.settings.SCALE);
},
setDrawOptions: function() {
this.context.lineWidth = this.getDrawSize(), this.context.strokeStyle = this.getSelectedColor(), this.context.lineJoin = this.context.lineCap = this.getDrawType(), this.context.globalCompositeOperation = this.getIsErasing() ? "destination-out" : "source-over";
},
onDownHandler: function(e, t) {
if (this.getIsDrawing() || this.getIsErasing()) {
var n = this.getPositionInCanvas(t);
this.setPaint(!0), this.setDrawOptions(), this.setOldX(n.x), this.setOldY(n.y), this.drawLine(this.getOldX(), this.getOldY(), !0);
}
},
onMoveHandler: function(e, t) {
var n = this.getPositionInCanvas(t);
this.getPaint() && this.drawLine(n.x, n.y, !1), this.setOldX(n.x), this.setOldY(n.y), this.handleCursor(e, t);
},
getPositionInCanvas: function(e) {
var t = new Object;
return t.x = (e.pageX - this.hasNode().offsetLeft) / window.settings.SCALE, t.y = (e.pageY - $(this.hasNode()).offset().top) / window.settings.SCALE, t;
},
drawLine: function(e, t, n) {
n && (this.context.beginPath(), this.context.moveTo(this.getOldX() + .01, this.getOldY())), this.context.lineTo(e, t), this.context.stroke();
},
onUpHandler: function(e, t) {
this.setPaint(!1), this.setOldDrawing(this.hasNode().toDataURL());
},
onLeaveHandler: function(e, t) {
this.setPaint(!1), this.$.cursorCon && this.$.cursorCon.setShowing(!1);
},
onEnterHandler: function(e, t) {
this.$.cursorCon && this.$.cursorCon.setShowing(!0);
},
clearDrawingHandler: function() {
this.context.clearRect(0, 0, this.width, this.height), this.context.width = this.context.width, this.setOldDrawing("");
},
saveDrawingHandler: function(e, t) {
var n = window.settings.ROLE;
if (n === 6 || n === 5 || n === 4 || n === 2 || n === 1) {
var r = this.getDrawingData();
t.type === "pc" ? this.saveDrawingOnPc(r) : this.mailDrawing(r);
}
},
getDrawingData: function() {
var e = this.hasNode().toDataURL(), t = new FormData, n = new Blob([ e ], {
type: "image/png"
});
return t.append("drawingfile", n), t;
},
saveDrawingOnPc: function(e) {
$.ajax({
url: Settings.SERVER + "saveDrawing",
type: "POST",
data: e,
complete: enyo.bind(this, "completeSaveDrawingHandler"),
error: this.errorHandler,
cache: !1,
contentType: !1,
processData: !1,
headers: {
location: Settings.SERVER + "saveDrawing"
}
});
},
completeSaveDrawingHandler: function(e, t) {
e ? location.href = "data:application/zip;base64," + e.responseText : this.bubble("onMessage", {
message: "Er is iets fout gelopen tijdens het opslaan van de tekening.",
duration: 3e3
});
},
mailDrawing: function(e) {
var t = window.settings.ROLE;
t === 5 || t === 4 ? (this.$.mailDrawingModal && this.$.mailDrawingModal.destroy(), this.createComponent({
kind: "educate.frame.dialoogvensters.MailDrawingDialoog",
name: "mailDrawingModal",
formdata: e
})) : this.zendMail(e, {
me: !0,
klassen: []
}, "In bijlage vindt u uw aantekening terug.");
},
mailDrawingModalSubmittedHandler: function(e, t) {
this.zendMail(t.formdata, {
me: t.me,
klassen: t.klassen
}, t.mailTekst);
},
zendMail: function(e, t, n) {
t.me && e.append("me", t.me), n && e.append("tekst", n);
var r, i = t.klassen.length;
for (r = 0; r < i; r++) e.append("klassen[]", t.klassen[r]);
$.ajax({
url: Settings.SERVER + "mailDrawing",
type: "POST",
data: e,
complete: enyo.bind(this, "completeMailDrawingHandler"),
error: this.errorHandler,
cache: !1,
contentType: !1,
processData: !1
});
},
completeMailDrawingHandler: function(e, t) {
e.responseText === "success" ? this.bubble("onMessage", {
message: "Email is succesvol verzonden.",
duration: 3e3
}) : this.bubble("onMessage", {
message: "Er is iets fout gelopen tijdens het verzenden van de email.",
duration: 3e3
});
},
errorHandler: function(e, t) {
console.log("Error", e, t);
},
createCursorHandler: function() {
this.removeCursor(), this.createComponent({
tag: "div",
name: "cursorCon",
showing: !1,
container: this.parent,
classes: "cursorCon",
style: "color: " + this.getSelectedColor() + "; text-shadow: 1px 1px 0 #FFF, -1px 1px 0 #FFF, 1px -1px 0 #FFF, -1px -1px 0 #FFF;"
}), this.getIsDrawing() ? (this.createComponent({
classes: "icon-pencil",
style: "color: inherit; background-color: " + this.getSelectedColor() + ";",
name: "drawCursor",
container: this.$.cursorCon
}), this.$.drawCursor.render()) : this.getIsErasing() && (this.createComponent({
classes: "icon-eraser",
style: "background-color: rgba(255,255,255,0.5);",
name: "eraseCursor",
container: this.$.cursorCon
}), this.$.eraseCursor.render()), this.$.cursorCon.render(), this.selectedColorChanged(), this.drawSizeChanged();
},
removeCursor: function() {
this.$.cursorCon && this.$.cursorCon.destroy(), this.$.drawCursor && this.$.drawCursor.destroy(), this.$.eraseCursor && this.$.eraseCursor.destroy();
},
handleCursor: function(e, t) {
if (this.getIsDrawing() || this.getIsErasing()) {
var n = t.clientX - $(this.$.cursorCon.hasNode()).width(), r = t.clientY - ($(this.$.cursorCon.hasNode()).height() + 32);
this.$.cursorCon.applyStyle("left", n + 25 + "px"), this.$.cursorCon.applyStyle("top", r + 12 + "px");
}
}
});

// Stage.js

enyo.kind({
name: "educate.frame.view.stage.Stage",
kind: "enyo.Control",
tag: "div",
classes: "stage",
published: {
viewId: "",
width: 0,
height: 0,
originalImgWidth: window.settings.STAGEWIDTH,
originalImgHeight: window.settings.STAGEHEIGHT,
position_x: 0,
position_y: 0,
meshOptions: [],
meshes: []
},
handlers: {
onmousemove: "onMouseMoveHandler"
},
events: {
onObjectAdded: ""
},
create: function() {
this.inherited(arguments);
},
rendered: function() {
this.inherited(arguments), this.resizeHandler();
},
onMouseMoveHandler: function(e, t) {
var n = new Object, r = typeof t.target.offsetLeft == "undefined" ? 0 : t.target.offsetLeft, i = typeof t.target.offsetLeft == "undefined" ? 0 : t.target.offsetTop;
n.clientX = t.layerX - r, n.clientY = t.layerY - i, this.bubble("mouseMoveStage", n);
},
resizeHandler: function(e, t) {
this.inherited(arguments);
var n = $("#frame_" + this.parent.owner.name + "_panelMiddle").height(), r = $("#frame_" + this.parent.owner.name + "_panelMiddle").width(), i = this.originalImgHeight, s = this.originalImgWidth;
this.scale = Math.min(n / i, r / s), this.offsetX = (r - s * this.scale) * .5, this.offsetY = (n - i * this.scale) * .5, $(".stage").css({
height: i * this.scale,
width: s * this.scale,
"margin-top": this.offsetY,
"margin-left": this.offsetX
}), this.resizeComponents(), this.bubble("updateZoomToolScale");
},
resizeComponents: function() {
window.settings.SCALE = this.scale, window.settings.OFFSETX = this.offsetX, window.settings.OFFSETY = this.offsetY;
for (var e in this.$) {
var t = this.$[e];
t.removeAndResize && t.resizeComponent();
}
},
handleResizeFromZoom: function(e) {
this.scale = e.scale, this.offsetX = e.offsetX, this.offsetY = e.offsetY, $(".stage").css({
height: this.originalImgHeight * this.scale,
width: this.originalImgWidth * this.scale,
"margin-top": this.offsetY,
"margin-left": this.offsetX
}), this.resizeComponents();
},
addGroep: function(e, t) {
var n = this.createComponent({
kind: "educate.frame.components.groep.Groep",
name: e.name,
container: t,
value: e.value,
position_x: e.position_x,
position_y: e.position_y,
width: e.width,
height: e.height,
linked: e.name + "_layer",
viewId: this.getViewId(),
objectId: e.id
});
e && (n = this.applyPropertiesToObject(n, e));
},
addSvg: function(e, t) {
var n = JSON.parse(!e.options || e.options === "" ? "{}" : e.options), r = this.createComponent({
kind: "educate.frame.components.svg.SvgParser",
name: e.name,
container: t,
isBackground: n.background === !0,
position_x: e.position_x,
position_y: e.position_y,
width: e.width,
height: e.height,
collection: [],
viewId: this.getViewId(),
renderedFromPickPlace: n.renderedFromPickPlace,
renderedFromPickPlaceImages: n.renderedFromPickPlaceImages,
showArea: n.showArea,
objectId: e.id
});
r.setValue(e.value), e && (r = this.applyPropertiesToObject(r, e));
},
addImage: function(e, t) {
var n = JSON.parse(!e.options || e.options === "" ? "{}" : e.options), r = this.createComponent({
kind: "educate.frame.components.image.Image",
name: e.name,
container: t,
value: e.value,
bAchtergrond: n.background === !0,
position_x: e.position_x,
position_y: e.position_y,
width: e.width,
height: e.height,
linked: e.name + "_layer",
viewId: this.getViewId(),
objectId: e.id
});
e && (r = this.applyPropertiesToObject(r, e));
},
addTekst: function(e, t) {
var n = this.createComponent({
kind: "educate.frame.components.tekst.Tekst",
name: e.name,
container: t,
value: e.value,
position_x: e.position_x,
position_y: e.position_y,
width: e.width,
height: e.height,
linked: e.name + "_layer",
viewId: this.getViewId(),
objectId: e.id
});
e && (n = this.applyPropertiesToObject(n, e));
},
addRaster: function(e, t) {
var n = this.createComponent({
kind: "educate.frame.components.raster.Raster",
name: e.name,
container: t,
value: e.value,
position_x: e.position_x,
position_y: e.position_y,
width: e.width,
height: e.height,
linked: e.name + "_layer",
viewId: this.getViewId(),
objectId: e.id
});
e && (n = this.applyPropertiesToObject(n, e));
},
addKnop: function(e, t) {
var n = this.createComponent({
container: t,
kind: "educate.frame.components.bediening.Knop",
name: e.name,
value: e.value,
solution: e.solution,
position_x: e.position_x,
position_y: e.position_y,
css_class: e.css_class,
width: e.width,
height: e.height,
linked: e.name + "_layer",
viewId: this.getViewId(),
objectId: e.id
});
e && (n = this.applyPropertiesToObject(n, e));
},
addInfoIcon: function(e, t) {
var n = this.createComponent({
container: t,
kind: "educate.frame.components.bediening.InfoIcon",
name: e.name,
position_x: e.position_x,
position_y: e.position_y,
width: "40",
height: "40",
linked: e.name + "_layer",
viewId: this.getViewId(),
objectId: e.id,
open: !1
});
for (var r in e.collection) e.collection[r].carrier.code === window.settings.CARRIERS.CONTENT_ICON && this.addInfoIconContent(n, e.collection[r]);
e && (n = this.applyPropertiesToObject(n, e));
},
addPhotoIcon: function(e, t) {
var n = this.createComponent({
container: t,
kind: "educate.frame.components.bediening.PhotoIcon",
name: e.name,
position_x: e.position_x,
position_y: e.position_y,
width: "40",
height: "40",
viewId: this.getViewId(),
objectId: e.id,
open: !1
});
e && (n = this.applyPropertiesToObject(n, e)), this.addPhotoIconContent(n, e && e.collection);
},
addInfoIconContent: function(e, t) {
var n = this.createComponent({
container: this,
kind: "educate.frame.components.bediening.InfoIconContent",
value: t.value,
linked: e,
viewId: this.getViewId()
});
e.objContent = n, e.toggle(), t && (n = this.applyPropertiesToObject(n, t));
},
addPhotoIconContent: function(e, t) {
var n = this.createComponent({
container: this,
kind: "educate.frame.components.bediening.PhotoIconContent",
position_x: t.position_x,
position_y: t.position_y,
width: t.width,
height: t.height,
value: t.value,
linked: e,
viewId: this.getViewId()
}), r = 0;
for (var i in t) n = this.applyPropertiesToObject(n, t[i]), e.collection[i] = n, r++;
r === 0 && (e.collection = [ n ]);
},
addAnimatie: function(e, t) {
var n = this.createComponent({
container: t,
kind: "educate.frame.components.animatie.Animatie",
name: e.name,
value: e.value,
solution: e.solution,
position_x: e.position_x,
position_y: e.position_y,
width: e.width,
height: e.height,
linked: e.name + "_layer",
viewId: this.getViewId(),
objectId: e.id
});
e && (n = this.applyPropertiesToObject(n, e));
},
addCijferveld: function(e, t) {
var n = this.createComponent({
container: t,
kind: "educate.frame.components.input.Cijferveld",
name: e.name,
value: e.value,
position_x: e.position_x,
position_y: e.position_y,
width: e.width,
height: e.height,
linked: e.name + "_layer",
viewId: this.getViewId(),
objectId: e.id
});
e && (n = this.applyPropertiesToObject(n, e));
},
addVideo: function(e, t) {
var n = {};
e && (n = JSON.parse(!e.options || e.options === "" ? "{}" : e.options));
var r = this.createComponent({
container: t,
kind: "educate.frame.components.video.Video",
name: e.name,
value: e.value,
solution: e.solution,
answered: e.answered,
css_class: e.css_class,
position_x: e.position_x,
position_y: e.position_y,
width: e.width,
height: e.height,
linked: e.name + "_layer",
keyframes: n.keyframes,
viewId: this.getViewId(),
objectId: e.id
});
e && (r = this.applyPropertiesToObject(r, e));
},
addSquareHandler: function(e, t) {
var n = {};
e && (n = JSON.parse(!e.options || e.options === "" ? "{}" : e.options));
var r = this.createComponent({
container: t,
kind: "educate.frame.components.tekendoos.Square",
width: e.width,
height: e.height,
position_x: e.position_x,
position_y: e.position_y,
beginP: n.beginP,
endP: n.endP,
lineColor: n.lineColor,
lineThickness: n.lineThickness,
lineType: n.lineType,
fillColor: n.fillColor,
radius: n.radius,
opacity: n.opacity,
layername: "square",
removeAndResize: !0,
viewId: this.getViewId(),
objectId: e.objectId
});
e && (r = this.applyPropertiesToObject(r, e));
},
addEllipseHandler: function(e, t) {
var n = {};
e && (n = JSON.parse(!e.options || e.options === "" ? "{}" : e.options));
var r = this.createComponent({
container: t,
kind: "educate.frame.components.tekendoos.Ellipse",
width: e.width,
height: e.height,
position_x: e.position_x,
position_y: e.position_y,
beginP: n.beginP,
endP: n.endP,
lineColor: n.lineColor,
lineThickness: n.lineThickness,
lineType: n.lineType,
fillColor: n.fillColor,
opacity: n.opacity,
layername: "square",
removeAndResize: !0,
viewId: this.getViewId(),
objectId: e.objectId
});
e && (r = this.applyPropertiesToObject(r, e));
},
addFreeHandler: function(e, t) {
var n = {};
e && (n = JSON.parse(!e.options || e.options === "" ? "{}" : e.options));
var r = this.createComponent({
container: t,
kind: "educate.frame.components.tekendoos.Free",
width: e.width,
height: e.height,
position_x: e.position_x,
position_y: e.position_y,
pathString: n.pathString,
tmpX: e ? n.tmpX : "100",
tmpY: e ? n.tmpY : "100",
beginP: n.beginP,
endP: n.endP,
pathPointsA: n.pathPointsA,
lineColor: n.lineColor,
lineThickness: n.lineThickness,
lineType: n.lineType,
fillColor: n.fillColor,
opacity: n.opacity,
layername: "free",
removeAndResize: !0,
viewId: this.getViewId(),
objectId: e.objectId
});
e && (r = this.applyPropertiesToObject(r, e));
},
addMultiHandler: function(e, t) {
var n = {};
e && (n = JSON.parse(!e.options || e.options === "" ? "{}" : e.options));
var r = this.createComponent({
container: t,
kind: "educate.frame.components.tekendoos.Multi",
width: e.width,
height: e.height,
position_x: e.position_x,
position_y: e.position_y,
pathString: n.pathString,
tmpX: e ? n.tmpX : "100",
tmpY: e ? n.tmpY : "100",
beginP: n.beginP,
endP: n.endP,
lineColor: n.lineColor,
lineThickness: n.lineThickness,
lineType: n.lineType,
fillColor: n.fillColor,
pathPoints: n.pathPoints,
opacity: n.opacity,
layername: "square",
removeAndResize: !0,
viewId: this.getViewId(),
objectId: e.objectId
});
e && (r = this.applyPropertiesToObject(r, e));
},
addMeetlat: function(e, t) {
var n = {};
e && (n = JSON.parse(!e.options || e.options === "" ? "{}" : e.options));
var r = this.createComponent({
container: t,
kind: "educate.frame.components.meetlat.Meetlat",
position_x: e.position_x,
position_y: e.position_y,
width: e.width,
lengte: n.lengte,
unit: n.unit,
divide: n.divide,
layername: "Meetlat name",
removeAndResize: !0,
viewId: this.getViewId(),
objectId: e.objectId
});
e && (r = this.applyPropertiesToObject(r, e));
},
addLijnstuk: function(e, t) {
var n = this.createComponent({
container: t,
kind: "educate.frame.components.input.Lijnstuk",
name: e.name,
value: e.value,
solution: e.solution,
position_x: e.position_x,
position_y: e.position_y,
width: e.width,
height: e.height,
linked: e.name + "_layer",
viewId: this.getViewId(),
objectId: e.id
});
e && (n = this.applyPropertiesToObject(n, e));
},
addInputField: function(e, t) {
var n = this.createComponent({
container: t,
kind: "educate.frame.components.input.InputField",
name: e.name,
position_x: e.position_x,
position_y: e.position_y,
width: e.width,
height: e.height,
linked: e.name + "_layer",
viewId: this.getViewId(),
objectId: e.id
});
e && (n = this.applyPropertiesToObject(n, e));
},
addPickAndPlace: function(e, t) {
var n = {};
e && (n = JSON.parse(!e.options || e.options === "" ? "{}" : e.options));
var r = this.createComponent({
container: t,
kind: "educate.frame.components.pickAndPlace.PickAndPlaceWords",
layername: "Pickandplace name",
dropZoneList: n.dropZoneList,
removeAndResize: !0,
showArea: n.showArea,
viewId: this.getViewId(),
objectId: e.objectId
});
e && (r = this.applyPropertiesToObject(r, e));
},
addPickAndPlaceAfbeeldingen: function(e, t) {
var n = {};
e && (n = JSON.parse(!e.options || e.options === "" ? "{}" : e.options));
var r = this.createComponent({
container: t,
kind: "educate.frame.components.pickAndPlace.PickAndPlaceImages",
layername: "Pickandplace name",
removeAndResize: !0,
showArea: n.showArea,
viewId: this.getViewId(),
objectId: e.objectId
});
e && (r = this.applyPropertiesToObject(r, e));
},
addZoomImage: function(e, t) {
var n = JSON.parse(!e.options || e.options === "" ? "{}" : e.options), r = this.createComponent({
kind: "educate.frame.components.zoomImage.ZoomImage",
name: e.name,
container: t,
value: e.value,
bAchtergrond: n.background === !0,
position_x: e.position_x,
position_y: e.position_y,
width: e.width,
height: e.height,
linked: e.name + "_layer",
viewId: this.getViewId(),
objectId: e.id,
zoomSteps: n.zoomSteps
});
e && (r = this.applyPropertiesToObject(r, e));
},
addColumnExerciseWords: function(e, t) {
var n = this.createComponent({
container: t,
kind: "educate.frame.components.columnExercise.ColumnExerciseWords",
layername: e.name,
viewId: this.getViewId(),
objectId: e.id
});
e && (n = this.applyPropertiesToObject(n, e)), n.optionsChanged();
},
addColumnExerciseImages: function(e, t) {
var n = this.createComponent({
container: t,
kind: "educate.frame.components.columnExercise.ColumnExerciseImages",
layername: e.name,
viewId: this.getViewId(),
objectId: e.id
});
e && (n = this.applyPropertiesToObject(n, e)), n.optionsChanged();
},
addKolomOefeningWoorden: function(e, t) {
var n = JSON.parse(!e.options || e.options === "" ? "{}" : e.options), r = this.createComponent({
container: t,
kind: "educate.frame.components.kolomOefening.KolomWoorden",
viewId: this.getViewId(),
words: n.words,
columns: n.columns,
splitCols: n.splitCols,
titles: n.titles,
maxWords: n.maxWords,
objectId: e.id
});
e && (r = this.applyPropertiesToObject(r, e));
},
addKolomOefeningAfbeeldingen: function(e, t) {
var n = JSON.parse(!e.options || e.options === "" ? "{}" : e.options), r = this.createComponent({
container: t,
kind: "educate.frame.components.kolomOefening.KolomAfbeeldingen",
viewId: this.getViewId(),
words: n.images,
columns: n.columns,
titles: n.titles,
maxWords: n.maxWords,
objectId: e.id
});
e && (r = this.applyPropertiesToObject(r, e));
},
addDropdown: function(e, t) {
var n = JSON.parse(!e.options || e.options === "" ? "{}" : e.options), r = this.createComponent({
kind: "educate.frame.components.bediening.Dropdown",
name: e.name,
container: t,
selectOptions: n.selectOptions,
automaticSolution: n.automaticSolution,
showOptions: n.showOptions,
openDirectionUp: n.openDirectionUp,
shuffleAnswers: n.shuffleAnswers,
startWithChoose: n.startWithChoose,
position_x: e.position_x,
position_y: e.position_y,
width: e.width,
height: e.height,
linked: e.name + "_layer",
viewId: this.getViewId(),
objectId: e.id
});
e && (r = this.applyPropertiesToObject(r, e));
},
addMultipleChoice: function(e, t) {
var n = JSON.parse(!e.options || e.options === "" ? "{}" : e.options), r = this.createComponent({
kind: "educate.frame.components.multipleChoice.MultipleChoice",
name: e.name,
container: t,
selectOptions: n.selectOptions,
solutionFromFrame: n.solutionFromFrame,
shuffleAnswers: n.shuffleAnswers,
question: n.question,
position_x: e.position_x,
position_y: e.position_y,
width: e.width,
height: e.height,
linked: e.name + "_layer",
viewId: this.getViewId(),
objectId: e.id
});
e && (r = this.applyPropertiesToObject(r, e));
},
addFlipcard: function(e, t) {
var n = JSON.parse(!e.options || e.options === "" ? "{}" : e.options), r = this.createComponent({
kind: "educate.frame.components.flipcard.Flipcard",
name: e.name,
container: t,
position_x: e.position_x,
position_y: e.position_y,
width: e.width,
height: e.height,
linked: e.name + "_layer",
currentBackSide: n.currentBackSide,
backText: n.backText,
backImage: n.backImage,
viewId: this.getViewId(),
objectId: e.id
});
e && (r = this.applyPropertiesToObject(r, e));
},
addWebFrame: function(e, t) {
var n = JSON.parse(!e.options || e.options === "" ? "{}" : e.options), r = this.createComponent({
kind: "educate.frame.components.website.Website",
name: e.name,
container: t,
position_x: e.position_x,
position_y: e.position_y,
width: e.width,
height: e.height,
linked: e.name + "_layer",
url: n.url,
viewId: this.getViewId(),
objectId: e.id
});
e && (r = this.applyPropertiesToObject(r, e));
},
addMap: function(e, t) {
var n = JSON.parse(!e.options || e.options === "" ? "{}" : e.options), r = this.createComponent({
container: t,
kind: "educate.frame.components.map.Map",
name: e.name,
value: e.value,
position_x: e.position_x,
position_y: e.position_y,
width: e.width,
height: e.height,
linked: e.name + "_layer",
adres: n.adres,
bHuidigeLocatie: n.isHuidigeLocatie,
viewId: this.getViewId(),
objectId: e.id
});
e && (r = this.applyPropertiesToObject(r, e));
},
addYoutube: function(e, t) {
var n = JSON.parse(!e.options || e.options === "" ? "{}" : e.options), r = this.createComponent({
container: t,
kind: "educate.frame.components.youtube.Youtube",
name: e.name,
value: e.value,
position_x: e.position_x,
position_y: e.position_y,
width: e.width,
height: e.height,
linked: e.name + "_layer",
videoId: n.videoId,
videoUrl: n.videoUrl,
viewId: this.getViewId(),
objectId: e.id
});
e && (r = this.applyPropertiesToObject(r, e));
},
add3DObject: function(e, t) {
var n = JSON.parse(!e.options || e.options === "" ? "{}" : e.options), r = this.createComponent({
kind: "educate.frame.components.3DObject.3DObject",
name: e.name,
container: t,
position_x: e.position_x,
position_y: e.position_y,
width: e.width,
height: e.height,
linked: e.name + "_layer",
meshOptions: this.meshOptions,
lockCamera: n.lockCamera,
cameraPosition: n.cameraPosition,
cameraCenter: n.cameraCenter,
spotLightOn: n.spotLightOn,
hemiLightOn: n.hemiLightOn,
groundOn: n.groundOn,
modelUrls: n.modelUrls,
modelNames: n.modelNames,
viewId: this.getViewId(),
objectId: e.id
});
e && (r = this.applyPropertiesToObject(r, e));
},
add3DMesh: function(e, t) {
var n = JSON.parse(!e.options || e.options === "" ? "{}" : e.options);
this.meshOptions[n.name] = n, this.meshOptions[n.name].objectId = e.id;
var r = this.createComponent({
container: t,
kind: "educate.components.3DObject.3DMesh",
viewId: this.getViewId(),
objectId: e.id
});
e && (r = this.applyPropertiesToObject(r, e)), this.meshes[e.id] = r;
},
addBegeleidZelfstandigLeren: function(e, t) {
var n = this.createComponent({
container: t,
kind: "educate.frame.components.zelfstandigleren.ZelfstandigLeren",
viewId: this.getViewId(),
objectId: e.id
});
n.setLayername(e.name), n.setValue(e.value), n.setCss_class(e.css_class), n.setSolution(e.solution), n.setAnswered(e.answered);
},
addKlimatogram: function(e, t) {
var n = {};
e && (n = JSON.parse(!e.options || e.options === "" ? "{}" : e.options));
var r = this.createComponent({
container: t,
kind: "educate.frame.components.bibliotheek.Klimatogram",
name: e.name,
value: e.value,
solution: e.solution,
answered: e.answered,
css_class: e.css_class,
position_x: e.position_x,
position_y: e.position_y,
width: e.width,
height: e.height,
linked: e.name + "_layer",
viewId: this.getViewId(),
objectId: e.id
});
e && (r = this.applyPropertiesToObject(r, e)), r.optionsChanged();
},
applyPropertiesToObject: function(e, t) {
return e.setLayername(t.name), e.setValue(t.value), e.setSolution(t.solution), e.setAnswered(t.answered), e.setCss_class(t.css_class), e.setWidth(t.width), e.setHeight(t.height), e.setPosition_x(t.position_x), e.setPosition_y(t.position_y), e.setOptions(JSON.parse(!t.options || t.options === "" ? "{}" : t.options)), e.setVisible(e.options.visible), e.setAlpha && e.setAlpha(e.options.alpha), e.setOpen(e.options.open), e.setDatabaseId(t.id), e.setObjectId(t.id), e.collection = t.collection, e.setPosition(t.position), e.setRotation(t.rotation || "0 0 0"), e.setOrigin(t.origin || "50 50"), typeof e.setActive != "undefined" && e.setActive(t.active == 0 ? !1 : !0), e.setIsPosLimiet(t.isPosLimiet), t.isPosLimiet && (e.setPosition_x_min(t.position_x_min === null ? Number.NEGATIVE_INFINITY : t.position_x_min), e.setPosition_x_max(t.position_x_max === null ? Number.POSITIVE_INFINITY : t.position_x_max), e.setPosition_y_min(t.position_y_min === null ? Number.NEGATIVE_INFINITY : t.position_y_min), e.setPosition_y_max(t.position_y_max === null ? Number.POSITIVE_INFINITY : t.position_y_max), e.setPosition_z_min(t.position_z_min === null ? Number.NEGATIVE_INFINITY : t.position_z_min), e.setPosition_z_max(t.position_z_max === null ? Number.POSITIVE_INFINITY : t.position_z_max)), e.setIsRotLimiet(t.isRotLimiet), t.isRotLimiet && (e.setRotation_x_min(t.rotation_x_min === null ? Number.NEGATIVE_INFINITY : t.rotation_x_min), e.setRotation_x_max(t.rotation_x_max === null ? Number.POSITIVE_INFINITY : t.rotation_x_max), e.setRotation_y_min(t.rotation_y_min === null ? Number.NEGATIVE_INFINITY : t.rotation_y_min), e.setRotation_y_max(t.rotation_y_max === null ? Number.POSITIVE_INFINITY : t.rotation_y_max), e.setRotation_z_min(t.rotation_z_min === null ? Number.NEGATIVE_INFINITY : t.rotation_z_min), e.setRotation_z_max(t.rotation_z_max === null ? Number.POSITIVE_INFINITY : t.rotation_z_max)), this.addObjectToViewChildren(e), e;
},
addObjectToViewChildren: function(e) {
this.doObjectAdded({
obj: e
});
},
getObjectFromStage: function(e) {
return this.$[e];
},
arrangeObjecten: function() {
var e = this.children;
e.sort(enyo.bind(this, "sortObjecten"));
for (var t in e) e[t].kindName === "educate.frame.components.groep.Groep" && e[t].arrangeObjectenGroup(), $(e[t].hasNode()).prependTo(this.hasNode());
},
sortObjecten: function(e, t) {
var n = e.position - t.position;
return isNaN(n) ? 0 : n;
}
});

// BrowserSupportModal.js

enyo.kind({
name: "educate.frame.view.browserSupport.BrowserSupportModal",
kind: enyo.Control,
tag: "div",
classes: "browser-support-modal-overlay",
published: {
viewId: "",
content: "Het spijt ons, deze module kan niet correct weergegeven worden in deze browser. Gelieve over te schakelen naar een geschikte browser."
},
handlers: {},
components: [ {
tag: "div",
name: "browserSupportModal",
classes: "browser-support-modal",
components: [ {
tag: "h1",
content: "Browser compatibiliteitsprobleem!"
}, {
tag: "p",
name: "browserSupportModalContent"
}, {
tag: "p",
classes: "browser-support-modal-footer",
allowHtml: !0,
content: 'Wij adviseren om <a href="https://www.google.nl/chrome/browser/desktop/" target="_blank">chrome</a> te gebruiken voor de beste ervaring.'
} ]
} ],
create: function() {
this.inherited(arguments), this.render();
},
rendered: function() {
this.inherited(arguments);
},
contentChanged: function() {
this.$.browserSupportModalContent.setContent(this.getContent());
}
});

// settings.js

enyo.kind({
name: "educate.frame.settings.Settings",
kind: enyo.Control,
classes: "settings",
components: [ {
name: "radiobuttonGroup",
kind: "educate.components.selection.RadiobuttonGroup",
onSelectionChange: "onSelectionChangedHandler"
} ],
published: {
fontSizes: [ 100, 125, 150, 175, 200, 250 ]
},
create: function() {
this.inherited(arguments), this.fontSizesChanged(), this.getCookie();
},
fontSizesChanged: function() {
var e = [], t, n = this.fontSizes.length;
for (t = 0; t < n; t++) e.push({
label: this.fontSizes[t] + "%",
checked: !1,
classes: "setting"
});
this.$.radiobuttonGroup.setButtons(e), this.render();
},
onSelectionChangedHandler: function(e, t) {
var n = t.value.substring(0, 3);
$("html").css({
"font-size": n + "%",
"line-height": n + n / 8 + "%"
}), this.setCookie(n), window.settings.FONTSIZEPROCENT = n / 100, enyo.Signals.send("onFontSizeProcentChanged");
},
getCookie: function() {
var e = document.cookie.split("; "), t = e.length - 1, n = "";
for (t; t >= 0; t--) e[t].indexOf("educate_settings_fontSize") >= 0 && (n = e[t].split("=")[1]);
n === "" && (n = "100", this.setCookie(n)), this.$.radiobuttonGroup.setValue(n + "%");
},
setCookie: function(e) {
var t = new Date, n;
t.setDate(t.getDate() + 365), n = escape(e) + "; expires=" + t.toUTCString(), document.cookie = "educate_settings_fontSize=" + n;
}
});

// option.js

enyo.kind({
kind: enyo.Control,
name: "educate.frame.settings.Option",
classes: "option",
tag: "li",
published: {
label: "label",
fontSize: 100,
group: "options"
},
components: [ {
kind: "educate.components.Radiobutton",
name: "rbt",
attributes: {
name: "options"
},
onActivate: "onActivateHandler"
}, {
tag: "label",
name: "lbl",
content: "label"
} ],
create: function() {
this.inherited(arguments), this.$.lbl.setAttribute("for", this.$.rbt.getAttribute("id")), this.labelChanged(), this.fontSizeChanged(), this.groupChanged(), this.checkStyle() === "16px" ? ($("html").css({
"font-size": "100%",
"line-height": "112%"
}), this.fontSize == 100 && this.$.rbt.setAttribute("checked", "")) : this.fontSize == this.checkStyle() && this.$.rbt.setAttribute("checked", "");
},
labelChanged: function() {
this.$.lbl.content = this.label;
},
fontSizeChanged: function() {
this.$.lbl.applyStyle("font-size", this.fontSize + "%");
},
groupChanged: function() {
this.$.rbt.setAttribute("name", this.group);
},
checkStyle: function() {
var e = window.document.getElementsByTagName("html")[0], t = "";
if (e.style.fontSize === "") {
var n = "font-size";
document.defaultView && document.defaultView.getComputedStyle ? t = document.defaultView.getComputedStyle(e, "").getPropertyValue(n) : e.currentStyle && (n = n.replace(/\-(\w)/g, function(e, t) {
return t.toUpperCase();
}), t = e.currentStyle[n]);
} else t = e.style.fontSize;
return t;
},
onActivateHandler: function(e, t) {
console.log(this.$.rbt.getChecked());
}
});

// Knop.js

enyo.kind({
name: "educate.create.components.bediening.Knop",
kind: "educate.components.bediening.Knop",
fit: !1,
tag: "div",
classes: "Button",
published: {
objType: "btn_"
},
handlers: {
onPropertiesChanged: "updateButton"
},
create: function() {
this.inherited(arguments);
},
addObjectEvents: function() {
this.inherited(arguments);
var e = {
ev1: {
event: "ondragstart",
label: "Start drag"
},
ev2: {
event: "ondragfinish",
label: "Stop drag"
}
};
for (var t in e) this.objectEvents.push(e[t]);
},
updateButton: function(e, t) {
t.linked == this && (this.layername = t.linked.layername, this.resizeComponent());
},
visibleChanged: function() {
this.applyStyle("opacity", this.getVisible() !== !1 ? this.getAlpha() : .25), this.addOption("visible", this.getVisible());
}
});

// KnopRaster.js

enyo.kind({
name: "educate.create.components.bediening.KnopRaster",
kind: "educate.create.components.bediening.Knop",
classes: "knopRaster",
fit: !1,
tag: "div",
published: {},
handlers: {},
downHandler: function(e, t) {
t.preventDefault();
}
});

// Icon.js

enyo.kind({
name: "educate.create.components.bediening.Icon",
kind: "educate.components.bediening.Icon",
tag: "div",
classes: "Icon",
published: {},
handlers: {
onPropertiesChanged: "updateButton"
},
components: [],
create: function() {
this.inherited(arguments);
},
destroy: function() {
for (var e in this.collection) this.collection[e].destroy();
this.inherited(arguments);
},
updateButton: function(e, t) {
t.linked == this && (this.layername = t.linked.layername, this.resizeComponent());
},
selectObject: function() {
this.inherited(arguments), this.getShowing() && this.getCollection()[0].setShowing(!0);
},
deselectObject: function() {
this.inherited(arguments), this.getCollection()[0].setShowing(!1);
},
visibleChanged: function() {
this.applyStyle("opacity", this.getVisible() !== !1 ? this.getAlpha() : .25), this.addOption("visible", this.getVisible());
}
});

// IconContent.js

enyo.kind({
name: "educate.create.components.bediening.IconContent",
kind: "educate.components.bediening.IconContent",
classes: "IconContent",
published: {
carrier: window.settings.CARRIERS.CONTENT_ICON,
paddingTop: 10,
photo: "",
photoNr: 0,
collection: [],
activePhoto: 0,
photosLoaded: !1
},
handlers: {
onPropertiesChanged: "onPropertiesChangedHandler",
heightChanged: "heightChangedHandler"
},
components: [ {
tag: "div",
name: "IconContentTemplate",
allowHtml: !0
}, {
tag: "div",
name: "prevNextButtons",
showing: !1,
controlClasses: "prevnextbtn",
components: [ {
tag: "div",
name: "prevBtn",
classes: "prev",
ontap: "prevClickedHandler"
}, {
tag: "div",
name: "nextBtn",
classes: "next",
ontap: "nextClickedHandler"
} ]
} ],
create: function() {
this.inherited(arguments), this.getType() != "photo" && this.initInfoComponent(), this.redraw();
},
rendered: function() {
this.inherited(arguments), this.getType() == "photo" && this.getCollection() && !this.getPhotosLoaded() && this.loadPhotos(), this.getType() != "photo" && this.setCollection([]);
},
initInfoComponent: function() {
this.setValue("Hier komt meer info."), this.zetPositie();
},
zetPositie: function() {
this.setPosition_x((window.settings.STAGEWIDTH - this.getWidth()) / 2 + .5 >> 0), this.setPosition_y(window.settings.STAGEHEIGHT - (parseInt(this.getHeight()) + 20));
},
valueChanged: function() {
this.getType() != "photo" && this.$.IconContentTemplate.setContent(this.getValue());
},
loadPhotos: function() {
var e = this.getCollection();
this.setCollection([]);
for (var t in e) {
this.photoNr++;
var n = this.createComponent({
kind: "educate.components.bediening.PhotoIconImage",
name: "photoHolder" + this.photoNr,
layername: e[t].name,
value: e[t].value,
label: e[t].css_class,
css_class: e[t].css_class,
link: e[t].value + this.photoNr,
src: Settings.WEBAPP + "/" + e[t].value
});
this.getCollection().push(n);
}
this.setPhotosLoaded(!0), this.handlePhotos();
},
photoChanged: function() {
this.photoNr++;
var e = this.createComponent({
kind: "educate.components.bediening.PhotoIconImage",
name: "photoHolder" + this.photoNr,
layername: "photoIconImage" + this.photoNr,
value: this.getPhoto().value,
label: this.getPhoto().css_class,
css_class: this.getPhoto().css_class,
link: this.getPhoto().value + this.photoNr,
src: Settings.WEBAPP + "/" + this.getPhoto().value
});
this.getCollection().push(e);
},
heightChangedHandler: function(e, t) {
this.changeHeight();
},
changeHeight: function() {
var e = this.getBounds(), t = e.height;
this.setHeight(parseInt(t / window.settings.SCALE));
},
calculatedHeightChanged: function() {
this.inherited(arguments);
},
calculatedFontSizeChanged: function() {
this.applyStyle("font-size", this.calculatedFontSize + "px"), this.applyStyle("line-height", 2 + this.calculatedFontSize + "px");
},
calculatedMetricsChanged: function() {
this.applyStyle("padding-top", this.calculatedPaddingTop + "px");
},
prevClickedHandler: function() {
this.activePhoto = this.getActivePhoto() > 0 ? this.activePhoto - 1 : this.getCollection().length - 1, this.hidePhotos(), this.getCollection()[this.getActivePhoto()].setShowing(!0);
},
nextClickedHandler: function() {
this.activePhoto = this.getActivePhoto() < this.getCollection().length - 1 ? this.activePhoto + 1 : 0, this.hidePhotos(), this.getCollection()[this.getActivePhoto()].setShowing(!0);
},
hidePhotos: function() {
for (var e in this.getCollection()) this.getCollection()[e].setShowing(!1);
},
onPropertiesChangedHandler: function(e, t) {
t.linked.linked == this && (this.getType() == "photo" && this.handlePhotos(), this.getType() != "photo" && this.zetPositie(), this.resizeComponent());
},
handlePhotos: function() {
this.hidePhotos(), this.getCollection().length > 0 && this.getCollection()[this.getCollection().length - 1].setShowing(!0), this.checkMultiplePhotos();
},
checkMultiplePhotos: function() {
this.$.prevNextButtons.setShowing(this.getCollection().length > 1 ? !0 : !1);
},
resizeComponent: function() {
this.redraw();
},
visibleChanged: function() {
this.applyStyle("opacity", this.getVisible() !== !1 ? this.getAlpha() : .25), this.addOption("visible", this.getVisible());
},
redraw: function() {
this.calculatedWidth = parseInt(this.getWidth() * window.settings.SCALE), this.calculatedHeight = parseInt(this.getHeight() * window.settings.SCALE), this.calculatedPosX = this.getPosition_x() * window.settings.SCALE + .5 >> 0, this.calculatedPosY = this.getPosition_y() * window.settings.SCALE + .5 >> 0, this.calculatedFontSize = parseInt(this.getFontSize() * 18 * window.settings.SCALE), this.calculatedPaddingTop = parseInt(this.getPaddingTop() * window.settings.SCALE), this.render();
}
});

// InfoIconContent.js

enyo.kind({
name: "educate.create.components.bediening.InfoIconContent",
kind: "educate.components.bediening.InfoIconContent",
published: {
carrier: window.settings.CARRIERS.CONTENT_ICON,
value: "Hier komt de extra info."
},
create: function() {
this.inherited(arguments);
}
});

// PhotoIconContent.js

enyo.kind({
name: "educate.create.components.bediening.PhotoIconContent",
kind: "educate.components.bediening.PhotoIconContent",
create: function() {
this.inherited(arguments);
}
});

// InfoIcon.js

enyo.kind({
name: "educate.create.components.bediening.InfoIcon",
kind: "educate.create.components.bediening.Icon",
fit: !1,
published: {
carrier: window.settings.CARRIERS.INFO_ICON,
objType: "info_"
},
handlers: {},
components: [ {
kind: "educate.components.bediening.InfoIconI"
} ],
create: function() {
this.inherited(arguments);
},
rendered: function() {
this.inherited(arguments);
},
visibleChanged: function() {
this.applyStyle("opacity", this.getVisible() !== !1 ? this.getAlpha() : .25), this.addOption("visible", this.getVisible());
}
});

// InfoIconRaster.js

enyo.kind({
name: "educate.create.components.bediening.InfoIconRaster",
kind: "educate.create.components.bediening.InfoIcon",
classes: "infoIconRaster",
fit: !1,
published: {},
handlers: {},
downHandler: function(e, t) {
t.preventDefault();
}
});

// PhotoIcon.js

enyo.kind({
name: "educate.create.components.bediening.PhotoIcon",
kind: "educate.create.components.bediening.Icon",
fit: !1,
published: {
carrier: window.settings.CARRIERS.PHOTO_ICON,
linked: "",
objType: "pho_",
verplaatsbaar: !1
},
handlers: {},
components: [ {
tag: "i",
classes: "icon-camera-retro photoIcon"
} ],
create: function() {
this.inherited(arguments);
},
rendered: function() {
this.inherited(arguments), this.options.verplaatsbaar !== !0 && this.addOption("verplaatsbaar", !1), this.setVerplaatsbaar(this.options.verplaatsbaar);
},
visibleChanged: function() {
this.applyStyle("opacity", this.getVisible() !== !1 ? this.getAlpha() : .25), this.addOption("visible", this.getVisible());
},
verplaatsbaarChanged: function() {
this.addOption("verplaatsbaar", this.getVerplaatsbaar());
}
});

// PhotoIconRaster.js

enyo.kind({
name: "educate.create.components.bediening.PhotoIconRaster",
kind: "educate.create.components.bediening.PhotoIcon",
classes: "photoIconRaster",
fit: !1,
published: {},
handlers: {},
downHandler: function(e, t) {
t.preventDefault();
}
});

// Dropdown.js

enyo.kind({
name: "educate.create.components.bediening.Dropdown",
kind: "educate.components.bediening.Dropdown",
tag: "div",
classes: "dropdownObj",
style: "position: absolute;",
published: {
width: "",
height: "",
position_x: 150,
position_y: 100
},
create: function() {
this.inherited(arguments), this.showOptionsChanged(), this.resizeComponent();
},
rendered: function() {
this.inherited(arguments), this.updateDropdown();
},
updateDropdown: function() {
this.inherited(arguments);
for (var e in this.selectOptions) this.$.droplist.createComponent({
tag: "li",
content: this.selectOptions[e].text,
value: this.selectOptions[e].value
}, {
owner: this
});
this.$.droplist.render(), this.addPropertiesToOptions();
},
addPropertiesToOptions: function() {
this.addOption("selectOptions", this.selectOptions), this.addOption("automaticSolution", this.automaticSolution), this.addOption("showOptions", this.showOptions), this.addOption("openDirectionUp", this.openDirectionUp), this.addOption("shuffleAnswers", this.shuffleAnswers), this.addOption("startWithChoose", this.startWithChoose);
},
visibleChanged: function() {
this.applyStyle("opacity", this.getVisible() !== !1 ? this.getAlpha() : .25), this.addOption("visible", this.getVisible());
},
showOptionsChanged: function() {
this.openCloseDropdown(this.getShowOptions());
},
openCloseDropdown: function(e) {
this.$.droplist.setShowing(e);
},
openDirectionUpChanged: function() {
this.changeArrow(this.getOpenDirectionUp()), this.handlePositionDropdown(this.calculatedHeight / 16);
},
startWithChooseChanged: function() {
this.handleChoose();
},
widthChanged: function() {
this.width = parseInt(this.width), this.resizeComponent();
},
heightChanged: function() {
this.height = parseInt(this.height), this.resizeComponent();
},
position_xChanged: function() {
this.position_x = parseInt(this.position_x);
},
position_yChanged: function() {
this.position_y = parseInt(this.position_y), this.resizeComponent();
}
});

// Groep.js

enyo.kind({
name: "educate.create.components.groep.Groep",
kind: "educate.components.groep.Groep",
classes: "groupStyle",
published: {
carrier: window.settings.CARRIERS.GROEP,
collection: [],
objType: "grp_"
},
handlers: {
ontap: "ontapHandler",
onPropertiesChanged: "onPropertiesChangedHandler"
},
create: function() {
this.inherited(arguments), this.redrawGroup();
},
onPropertiesChangedHandler: function(e, t) {
t.linked == this && (this.layername = t.linked.layername, this.resizeComponent());
},
addObjToGroup: function(e, t) {
e.addBefore = undefined, e.setContainer(this), e.changeOfGroup(this, t), this.render(), this.handleGroupPosDimension(), this.bubble("updateProperties", this);
},
handleGroupPosDimension: function() {
if (this.children.length > 0) {
var e = this.getPosition_x(), t = this.getPosition_y(), n = this.getPropertiesFromChilds(), r = Math.min.apply(Math, n.valsX), i = Math.min.apply(Math, n.valsY), s = Math.max.apply(Math, n.valsXW), o = Math.max.apply(Math, n.valsYH);
this.setPosition_x(this.getPosition_x() + r), this.setPosition_y(this.getPosition_y() + i), this.setWidth(e + s - this.getPosition_x()), this.setHeight(t + o - this.getPosition_y()), this.redrawGroup(), this.waterfallDown("groupIsChanged", {
grp: this,
opx: e,
opy: t,
px: this.getPosition_x(),
py: this.getPosition_y()
}), this.getBIsInGroup() && this.container.handleGroupPosDimension();
}
},
getPropertiesFromChilds: function() {
var e = [], t = [], n = [], r = [], i = this.children.length;
for (var s = 0; s < i; s++) e.push(this.children[s].getPosition_x()), t.push(this.children[s].getPosition_y()), n.push(this.children[s].getPosition_x() + $(this.children[s].hasNode()).outerWidth() / window.settings.SCALE), r.push(this.children[s].getPosition_y() + $(this.children[s].hasNode()).outerHeight() / window.settings.SCALE);
var o = {
valsX: e,
valsY: t,
valsXW: n,
valsYH: r
};
return o;
},
dragObjectHandler: function(e) {
this.inherited(arguments), this.arrangeObjectenGroup();
},
upHandler: function() {
this.inherited(arguments), this.arrangeObjectenGroup();
},
visibleChanged: function() {
this.applyStyle("opacity", this.getVisible() !== !1 ? this.getAlpha() : .25), this.addOption("visible", this.getVisible());
},
lockedChanged: function() {
this.inherited(arguments), this.changeLockFromChilds(this.getLocked());
},
changeLockFromChilds: function(e) {
var t = this.children, n = this.children.length;
for (var r = 0; r < n; r++) t[r].kindName === "educate.create.components.groep.Groep" && t[r].changeLockFromChilds(e), t[r].setLocked(e);
}
});

// Image.js

enyo.kind({
name: "educate.create.components.image.Image",
kind: "educate.components.image.Image",
published: {
width: 500,
height: 300,
position_x: 150,
position_y: 100,
objType: "img_"
},
handlers: {
ontap: "ontapHandler",
onPropertiesChanged: "onPropertiesChangedHandler"
},
attributes: {
src: "/svnAssets/imagetemplate.png"
},
create: function() {
this.inherited(arguments), !this.getValue() && this.setValue("svnAssets/imagetemplate.png"), this.redrawImage();
},
visibleChanged: function() {
this.applyStyle("opacity", this.getVisible() !== !1 ? this.getAlpha() : .25), this.addOption("visible", this.getVisible());
},
widthChanged: function() {
this.redrawImage();
},
heightChanged: function() {
this.redrawImage();
},
bAchtergrondChanged: function(e) {
this.setLocked(this.getBAchtergrond()), this.getBAchtergrond() ? this.deselectObject() : this.selectObject(), this.addOption("background", this.getBAchtergrond()), this.addRemoveClass("background", this.getBAchtergrond()), this.setPosition_x(this.getBAchtergrond() ? 0 : this.getPosition_x()), this.setPosition_y(this.getBAchtergrond() ? 0 : this.getPosition_y()), this.setWidth(this.getBAchtergrond() ? window.settings.STAGEWIDTH : this.getWidth()), this.setHeight(this.getBAchtergrond() ? window.settings.STAGEHEIGHT : this.getHeight()), this.bubble("objectLockChange", this);
},
onPropertiesChangedHandler: function(e, t) {
t.linked == this && (this.layername = t.linked.layername, this.value != "" && this.setValue(t.linked.value), this.resizeComponent());
}
});

// ImageRaster.js

enyo.kind({
name: "educate.create.components.image.ImageRaster",
kind: "educate.create.components.image.Image",
classes: "imageRaster",
published: {},
handlers: {},
downHandler: function(e, t) {
t.preventDefault();
}
});

// Animatie.js

enyo.kind({
name: "educate.create.components.animatie.Animatie",
kind: "educate.components.animatie.Animatie",
published: {
carrier: window.settings.CARRIERS.ANIMATIE,
spritePngObj: "",
objType: "ani_"
},
handlers: {
ontap: "ontapHandler",
onPropertiesChanged: "onPropertiesChangedHandler"
},
components: [],
create: function() {
this.inherited(arguments), this.resizeComponent();
},
setWidthHeight: function(e, t) {
this.inherited(arguments), this.resizeComponent();
},
onPropertiesChangedHandler: function(e, t) {
t && t.linked == this && (this.layername = t.linked.layername, this.resizeComponent());
},
visibleChanged: function() {
this.applyStyle("opacity", this.getVisible() !== !1 ? this.getAlpha() : .25), this.addOption("visible", this.getVisible());
}
});

// AnimatieRaster.js

enyo.kind({
name: "educate.create.components.animatie.AnimatieRaster",
kind: "educate.create.components.animatie.Animatie",
classes: "animatieRaster",
published: {},
handlers: {},
downHandler: function(e, t) {
t.preventDefault();
}
});

// SvgParser.js

enyo.kind({
name: "educate.create.components.svg.SvgParser",
kind: "educate.components.svg.SvgParser",
published: {
carrier: window.settings.CARRIERS.SVG,
oldvalue: "",
width: 500,
height: 300,
position_x: 0,
position_y: 0,
objType: "svg_",
tmpX: 0,
tmpY: 0,
renderedFromPickPlace: !1,
renderedFromPickPlaceImages: !1,
showArea: !1,
colorOptions: [],
istouchmove: !1,
zones: []
},
handlers: {
onPropertiesChanged: "onPropertiesChangedHandler"
},
create: function() {
this.inherited(arguments), this.valueChanged();
},
rendered: function() {
this.inherited(arguments), this.initAchtergrond(), this.resizeComponent();
},
isBackgroundChanged: function(e) {
this.setSelected(!this.getIsBackground()), this.initAchtergrond();
},
svgAjaxLoaded: function(e, t) {
this.getCollection() && this.getView().checkLagenToRemoveSvgZones(this), this.inherited(arguments);
},
handleSVG: function(e) {
return e;
},
getLayerClass: function() {
return educate.create.components.svg.svgzone;
},
handleZoneDisplay: function(e) {
e && $("#" + e.value).css("opacity", e.getDisplay() ? "1" : "0");
},
sublayerVisibilityClickedHandler: function(e, t) {
this === t.svg && this.handleZoneDisplay(t.zone);
},
visibleChanged: function() {
this.applyStyle("opacity", this.getVisible() !== !1 ? this.getAlpha() : .25), this.addOption("visible", this.getVisible()), this.inherited(arguments);
},
dragObjectHandler: function(e) {
this.calculatedPosX = e.touches[0].clientX - $(this.parent.hasNode()).offset().left - this.getClickX(), this.calculatedPosY = e.touches[0].clientY - $(this.parent.hasNode()).offset().top - this.getClickY(), this.position_x = this.calculatedPosX / window.settings.SCALE, this.position_y = this.calculatedPosY / window.settings.SCALE, this.resizeComponent();
},
downHandler: function(e, t) {
this.inherited(arguments), this.getLocked() || ($(document).on("mousemove", enyo.bind(this, "muisMoveEvent")), $(document).on("mouseup", enyo.bind(this, "upHandler")), document.ontouchmove = enyo.bind(this, "dragObjectHandler"), document.ontouchend = enyo.bind(this, "upHandler"), !this.getSelected() && this.bubble("objectSelected", this));
},
onPropertiesChangedHandler: function(e, t) {
t.linked == this && (this.layername = t.linked.layername, this.renderedFromPickPlace && (this.showArea = t.linked.options.showArea, this.colorOptions = t.linked.options.colorOptions, this.addOption("showArea", this.showArea), this.addOption("fill", this.colorOptions.fill), this.addOption("stroke", this.colorOptions.stroke), this.addOption("opacity", this.colorOptions.opacity), this.bubble("onShowAreaChanged", {
showArea: this.showArea,
colorOptions: this.colorOptions
})), this.value != "" && this.value != this.oldvalue && (this.value = t.linked.value, this.oldvalue = this.value), this.resizeComponent());
},
redrawSvg: function() {
this.inherited(arguments);
var e = this.hasNode();
e && $(e).css({
opacity: this.getVisible() !== !1 ? this.getAlpha() : .25
});
}
});

// SvgZone.js

enyo.kind({
name: "educate.create.components.svg.svgzone.SvgZone",
kind: "educate.components.svg.svgzone.SvgZone",
published: {
carrier: window.settings.CARRIERS.ZONES,
laag: "",
type: ""
},
visibleChanged: function() {
this.getNode() && (this.getNode().style.opacity = this.getVisible() ? this.getAlpha() : .3, this.addOption("visible", this.getVisible()));
},
activeChanged: function() {
this.getNode() && (this.getActive() ? this.getNode().classList.remove("zoneDeactive") : this.node.classList.add("zoneDeactive"));
},
ontapHandler: function(e, t) {
return this.getLocked() || this.getSvgparser().selectZone(this), !0;
},
popupZoneNameChanged: function() {
this.addOption("popupzonename", this.getPopupZoneName());
}
});

// SvgZoneLegende.js

enyo.kind({
name: "educate.create.components.svg.svgzone.SvgZoneLegende",
kind: "educate.create.components.svg.svgzone.SvgZone",
published: {},
handlers: {},
create: function() {
this.inherited(arguments), this.setCollection([]);
}
});

// SvgZoneLegendeItem.js

enyo.kind({
name: "educate.create.components.svg.svgzone.SvgZoneLegendeItem",
kind: "educate.create.components.svg.svgzone.SvgZone"
});

// Tekst.js

enyo.kind({
name: "educate.create.components.tekst.Tekst",
kind: "educate.components.tekst.Tekst",
published: {
carrier: window.settings.CARRIERS.TEKST,
paddingTop: 10,
objType: "txt_"
},
handlers: {
onPropertiesChanged: "propertiesChangedHandler"
},
components: [ {
tag: "div",
name: "TekstTemplate",
allowHtml: !0
} ],
create: function() {
this.inherited(arguments), this.redraw();
},
valueChanged: function() {
this.$.TekstTemplate.setContent(this.getValue());
},
changeHeight: function() {
var e = this.getBounds(), t = e.height;
this.setHeight(parseInt(t * window.settings.SCALE));
},
calculatedHeightChanged: function() {
this.inherited(arguments);
},
calculatedFontSizeChanged: function() {
this.applyStyle("font-size", this.calculatedFontSize + "px"), this.applyStyle("line-height", 2 + this.calculatedFontSize + "px");
},
calculatedMetricsChanged: function() {
this.applyStyle("padding-top", this.calculatedPaddingTop + "px");
},
propertiesChangedHandler: function(e, t) {
t.linked == this && (this.layername = t.linked.layername, this.setValue(t.linked.value), this.resizeComponent());
},
visibleChanged: function() {
this.applyStyle("opacity", this.getVisible() !== !1 ? this.getAlpha() : .25), this.addOption("visible", this.getVisible());
}
});

// TekstRaster.js

enyo.kind({
name: "educate.create.components.tekst.TekstRaster",
kind: "educate.create.components.tekst.Tekst",
classes: "tekstRaster",
published: {},
handlers: {},
downHandler: function(e, t) {
t.preventDefault();
}
});

// video.js

enyo.kind({
name: "educate.create.components.video.Video",
kind: "educate.components.video.Video",
create: function() {
this.inherited(arguments), this.render(), this.moreinfoChanged();
},
visibleChanged: function() {
this.applyStyle("opacity", this.getVisible() !== !1 ? this.getAlpha() : .25), this.addOption("visible", this.getVisible());
},
widthChanged: function() {
this.resizeComponent();
},
heightChanged: function() {
this.resizeComponent();
},
onPropertiesChangedHandler: function(e, t) {
t.linked == this && (this.layername = t.linked.layername, this.solution != "" && this.setSolution(t.linked.solution), this.resizeComponent());
},
closeHandler: function(e, t) {},
moreinfoChanged: function(e) {
this.inherited(arguments), this.setShowDescription(this.getMoreinfo());
},
showDescriptionChanged: function() {
this.$.player.setShowDescription(this.getMoreinfo());
},
onCloseTappedHandler: function(e, t) {
this.$.player.pause();
}
});

// VideoRaster.js

enyo.kind({
name: "educate.create.components.video.VideoRaster",
kind: "educate.create.components.video.Video",
classes: "videoRaster",
downHandler: function(e, t) {
t.preventDefault();
}
});

// Cijferveld.js

enyo.kind({
name: "educate.create.components.input.Cijferveld",
kind: "educate.components.input.Cijferveld",
visibleChanged: function() {
this.applyStyle("opacity", this.getVisible() !== !1 ? this.getAlpha() : .25), this.addOption("visible", this.getVisible());
},
hasValue1Changed: function() {
this.inherited(arguments), this.sendSignal(), enyo.Signals.send("onUpdate", {
originator: this
});
},
hasValue2Changed: function() {
this.inherited(arguments), this.sendSignal(), enyo.Signals.send("onUpdate", {
originator: this
});
},
hasValue3Changed: function() {
this.inherited(arguments), this.sendSignal(), enyo.Signals.send("onUpdate", {
originator: this
});
},
solutionChanged: function() {
this.inherited(arguments), this.toonOplossing(), this.sendSignal(), enyo.Signals.send("onUpdate", {
originator: this
});
},
solution2Changed: function() {
this.inherited(arguments), this.addOption("solution2", this.getSolution2()), this.sendSignal(), enyo.Signals.send("onUpdate", {
originator: this
});
},
solution3Changed: function() {
this.inherited(arguments), this.addOption("solution3", this.getSolution3()), this.sendSignal(), enyo.Signals.send("onUpdate", {
originator: this
});
},
sendSignal: function() {
enyo.Signals.send("onToggleSolution", {
originator: this
});
},
spinner1Changed: function() {
this.addOption("spinner1", this.getSpinner1()), enyo.Signals.send("onUpdate", {
originator: this
});
},
spinner2Changed: function() {
this.addOption("spinner2", this.getSpinner2()), enyo.Signals.send("onUpdate", {
originator: this
});
},
spinner3Changed: function() {
this.addOption("spinner3", this.getSpinner3()), enyo.Signals.send("onUpdate", {
originator: this
});
},
tellerChanged: function() {
this.addOption("teller", this.getTeller()), enyo.Signals.send("onUpdate", {
originator: this
});
},
valueChanged: function() {
this.inherited(arguments), enyo.Signals.send("onUpdate", {
originator: this
});
},
value2Changed: function() {
this.inherited(arguments), this.addOption("value2", this.getValue2()), enyo.Signals.send("onUpdate", {
originator: this
});
},
value3Changed: function() {
this.inherited(arguments), this.addOption("value3", this.getValue3()), enyo.Signals.send("onUpdate", {
originator: this
});
},
answered2Changed: function() {
this.inherited(arguments), this.addOption("answered2", this.getAnswered2());
},
answered3Changed: function() {
this.inherited(arguments), this.addOption("answered3", this.getAnswered3()), enyo.Signals.send("onUpdate", {
originator: this
});
},
editableChanged: function() {
this.inherited(arguments), this.addOption("editable", this.getEditable()), enyo.Signals.send("onUpdate", {
originator: this
});
},
roundChanged: function() {
this.inherited(arguments), this.addOption("afronding", this.getRound()), enyo.Signals.send("onUpdate", {
originator: this
});
},
minimum1Changed: function() {
this.inherited(arguments), this.addOption("value_min", this.getMinimum1()), enyo.Signals.send("onUpdate", {
originator: this
});
},
maximum1Changed: function() {
this.inherited(arguments), this.addOption("value_max", this.getMaximum1()), enyo.Signals.send("onUpdate", {
originator: this
});
},
minimum2Changed: function() {
this.inherited(arguments), this.addOption("value2_min", this.getMinimum2()), enyo.Signals.send("onUpdate", {
originator: this
});
},
maximum2Changed: function() {
this.inherited(arguments), this.addOption("value2_max", this.getMaximum2()), enyo.Signals.send("onUpdate", {
originator: this
});
},
minimum3Changed: function() {
this.inherited(arguments), this.addOption("value3_min", this.getMinimum3()), enyo.Signals.send("onUpdate", {
originator: this
});
},
maximum3Changed: function() {
this.inherited(arguments), this.addOption("value3_max", this.getMaximum3()), enyo.Signals.send("onUpdate", {
originator: this
});
},
opmaakChanged: function() {
this.inherited(arguments), this.addOption("opmaak", this.getOpmaak()), enyo.Signals.send("onUpdate", {
originator: this
});
},
bgkleurChanged: function() {
this.inherited(arguments), this.addOption("bgkleur", this.getBgkleur()), enyo.Signals.send("onUpdate", {
originator: this
});
},
sleepbaarChanged: function() {
this.inherited(arguments), this.addOption("sleepbaar", this.getSleepbaar()), enyo.Signals.send("onUpdate", {
originator: this
});
},
talstelselChanged: function() {
this.inherited(arguments), this.addOption("talstelsel", this.getTalstelsel()), enyo.Signals.send("onUpdate", {
originator: this
});
},
calculatedFontSizeChanged: function() {
this.applyStyle("font-size", this.calculatedFontSize + "rem"), this.applyStyle("line-height", 1.7 * this.calculatedFontSize + "rem");
}
});

// CijferveldRaster.js

enyo.kind({
name: "educate.create.components.input.CijferveldRaster",
kind: "educate.create.components.input.Cijferveld",
classes: "cijferveldRaster",
downHandler: function(e, t) {
t.preventDefault();
}
});

// InputField.js

enyo.kind({
name: "educate.create.components.input.InputField",
kind: "educate.components.input.InputField",
published: {
width: "500",
height: "300",
position_x: 150,
position_y: 100,
objType: "ipf_"
},
create: function() {
this.inherited(arguments);
},
rendered: function() {
this.inherited(arguments);
},
widthChanged: function() {
this.redrawInputField();
},
heightChanged: function() {
this.redrawInputField();
},
maxCharactersChanged: function() {
this.inherited(arguments), this.addOption("maxCharacters", this.getMaxCharacters());
}
});

// lijnstuk.js

enyo.kind({
name: "educate.create.components.input.Lijnstuk",
kind: "educate.components.input.Lijnstuk",
published: {
position_x: 20,
position_y: 50,
width: 220,
height: 50,
value: null,
rotation: null,
css_class: educate.components.input.Lijnstuk.LINE
},
visibleChanged: function() {
this.applyStyle("opacity", this.getVisible() !== !1 ? this.getAlpha() : .25), this.addOption("visible", this.getVisible());
}
});

// Raster.js

enyo.kind({
name: "educate.create.components.raster.Raster",
kind: "educate.components.raster.Raster",
published: {
carrier: window.settings.CARRIERS.RASTER,
width: 500,
height: 300,
position_x: 150,
position_y: 100,
kolommen: 4,
rijen: 2,
rows: [],
kolomBreedte: "25%",
rijHoogte: "",
horUitlijning: "left",
verUitlijning: "top",
repeatLastKolom: !1,
objType: "rst_"
},
handlers: {
onPropertiesChanged: "onPropertiesChangedHandler",
rowSelected: "rowSelectedHandler"
},
components: [ {
tag: "table",
name: "table",
attributes: {
border: "1"
}
} ],
create: function() {
this.inherited(arguments), this.setRows([]), this.createTable(), this.redrawRaster();
},
horUitlijningChanged: function() {
for (var e in this.$.table.children) for (var t in this.$.table.children[e].children) this.$.table.children[e].children[t].applyStyle("text-align", this.getHorUitlijning());
},
verUitlijningChanged: function() {
for (var e in this.$.table.children) for (var t in this.$.table.children[e].children) this.$.table.children[e].children[t].applyStyle("vertical-align", this.getVerUitlijning());
},
createTable: function() {
for (var e = 0; e < this.rijen; e++) var t = this.createRow(e, this.getKolommen());
},
createRow: function(e, t) {
var n = this.createComponent({
kind: "educate.create.components.raster.Rij",
classes: "rij" + e,
name: "rij" + e,
kolommen: t,
rijnr: e,
viewId: this.getViewId(),
container: this.$.table
});
return this.getRows().push(n), n;
},
addRij: function() {
var e = this.createRow(this.getRijen(), this.getKolommen());
this.setRijen(this.getRijen() + 1), this.$.table.render();
},
addKolom: function() {
this.waterfallDown("addKolom", this), this.setKolommen(this.getKolommen() + 1);
},
rowSelectedHandler: function(e, t) {
this.deselectRows(), this.selectRow(t);
},
deselectObject: function() {
this.inherited(arguments), this.deselectRows();
},
deselectRows: function() {
var e = this.getRows().length;
for (var t = 0; t < e; t++) this.getRows()[t].deselectRow();
},
selectRow: function(e) {
e.selectRow();
},
onPropertiesChangedHandler: function(e, t) {
t.linked == this && (this.layername = t.linked.layername, this.value != "" && this.setValue(t.linked.value), this.resizeComponent());
},
visibleChanged: function() {
this.applyStyle("opacity", this.getVisible() !== !1 ? this.getAlpha() : .25), this.addOption("visible", this.getVisible());
}
});

// RasterInRaster.js

enyo.kind({
name: "educate.create.components.raster.RasterInRaster",
kind: "educate.create.components.raster.Raster",
classes: "rasterInRaster",
published: {},
handlers: {},
downHandler: function(e, t) {
t.preventDefault();
}
});

// Rij.js

enyo.kind({
name: "educate.create.components.raster.Rij",
kind: "enyo.Control",
tag: "tr",
handlers: {
addKolom: "addKolomHandler",
ontap: "ontapHandler"
},
published: {
viewId: "",
kolommen: "",
rijnr: "",
viewId: "",
selected: !1
},
create: function() {
this.inherited(arguments), this.createKolommen(), this.render();
},
createKolommen: function() {
for (var e = 0; e < this.getKolommen(); e++) this.createKolomCel(this.getRijnr() + "-" + e);
},
createKolomCel: function(e) {
var t = this.createComponent({
kind: "educate.create.components.raster.KolomCel",
classes: e,
name: e,
viewId: this.getViewId()
});
},
addKolomHandler: function() {
var e = this.getRijnr() + "-" + this.getKolommen();
this.createKolomCel(e), this.setKolommen(this.getKolommen() + 1), this.render();
},
ontapHandler: function(e, t) {
this.bubble("rowSelected", this);
},
selectRow: function() {
this.setSelected(!0), this.applyStyle("border-color", "#FF0000");
},
deselectRow: function() {
this.setSelected(!1), this.applyStyle("border-color", "#000000");
}
});

// KolomCel.js

enyo.kind({
name: "educate.create.components.raster.KolomCel",
kind: "enyo.Control",
tag: "td",
classes: "",
published: {
viewId: ""
},
handlers: {
ontap: "ontapHandler",
onObjAddedToRaster: "onObjAddedToRasterHandler"
},
components: [ {
kind: "educate.hulpklassen.contextMenus.ContextObjectenMenu",
name: "objectenMenu"
} ],
create: function() {
this.inherited(arguments);
},
ontapHandler: function(e, t) {
log(e, t, "uksjoizjsoi");
},
getView: function() {
var e = enyo.$["frame_view" + this.viewId];
return e ? e : enyo.$["create_view" + this.viewId];
},
onObjAddedToRasterHandler: function(e, t) {
if (t.con == this) {
var n = this;
switch (t.type) {
case "svgImage":
n.addSvg();
break;
case "image":
n.addImage();
break;
case "tekst":
n.addTekst();
break;
case "button":
n.addKnop();
break;
case "infoIcon":
n.addInfoIcon();
break;
case "photoIcon":
n.addPhotoIcon();
break;
case "sprite":
n.addAnimatie();
break;
case "cijferveld":
n.addCijferveld();
break;
case "video":
n.addVideo();
break;
case "raster":
n.addRaster();
break;
default:
}
}
},
addImage: function(e) {
var t = this.getView().countViewObjectsId(), n = {};
e && (n = JSON.parse(!e.options || e.options === "" ? "{}" : e.options));
var r = this.createComponent({
container: this,
kind: "educate.create.components.image.ImageRaster",
layername: "Image name",
removeAndResize: !0,
viewId: this.getViewId(),
position_x: 0,
position_y: 0,
bAchtergrond: n.background === !0,
objectId: t
});
e && (r = this.applyPropertiesToObject(r, e));
},
addSvg: function(e) {
var t = this.getView().countViewObjectsId(), n = {};
e && (n = JSON.parse(!e.options || e.options === "" ? "{}" : e.options));
var r = this.createComponent({
container: this,
kind: "educate.create.components.svg.SvgParser",
layername: "Svg name",
removeAndResize: !0,
viewId: this.getViewId(),
position_x: 0,
position_y: 0,
bAchtergrond: n.background === !0,
objectId: t
});
e && (r = this.applyPropertiesToObject(r, e));
},
addTekst: function(e) {
var t = this.getView().countViewObjectsId(), n = this.createComponent({
container: this,
kind: "educate.create.components.tekst.TekstRaster",
layername: "Tekst naam",
position_x: 0,
position_y: 0,
width: "200",
height: "100",
value: "Hier komt uw tekst.",
removeAndResize: !0,
viewId: this.getViewId(),
objectId: t
});
e && (n = this.applyPropertiesToObject(n, e));
},
addRaster: function(e) {
var t = this.getView().countViewObjectsId(), n = this.createComponent({
container: this,
kind: "educate.create.components.raster.RasterInRaster",
layername: "Raster naam",
position_x: 0,
position_y: 0,
width: "500",
height: "200",
removeAndResize: !0,
viewId: this.getViewId(),
objectId: t
});
e && (n = this.applyPropertiesToObject(n, e));
},
addKnop: function(e) {
var t = this.getView().countViewObjectsId(), n = this.createComponent({
container: this,
kind: "educate.create.components.bediening.KnopRaster",
value: "default",
solution: "",
position_x: 0,
position_y: 0,
layername: "button",
removeAndResize: !0,
viewId: this.getViewId(),
objectId: t
});
e && (n = this.applyPropertiesToObject(n, e));
},
addInfoIcon: function(e) {
var t = this.getView().countViewObjectsId(), n = this.createComponent({
container: this,
kind: "educate.create.components.bediening.InfoIconRaster",
position_x: 0,
position_y: 0,
width: "40",
height: "40",
layername: "InfoIconLayer",
removeAndResize: !0,
viewId: this.getViewId(),
objectId: t
});
e && (n = this.applyPropertiesToObject(n, e)), this.addIconContentTemplate(n, "info", e && e.collection);
},
addPhotoIcon: function(e) {
var t = this.getView().countViewObjectsId(), n = this.createComponent({
container: this,
kind: "educate.create.components.bediening.PhotoIconRaster",
position_x: 0,
position_y: 0,
width: "40",
height: "40",
layername: "PhotoIconLayer",
removeAndResize: !0,
viewId: this.getViewId(),
objectId: t
});
e && (n = this.applyPropertiesToObject(n, e)), this.addIconContentTemplate(n, "photo", e && e.collection);
},
addIconContentTemplate: function(e, t, n) {
var r = this.createComponent({
container: this,
kind: "educate.create.components.bediening.IconContent",
position_x: 0,
position_y: 0,
width: "200",
height: "100",
layername: e.layername + "Content",
removeAndResize: !0,
viewId: this.getViewId(),
type: t
});
for (var i in n) n[i].carrier.code == window.settings.CARRIERS.CONTENT_ICON && (r = this.applyPropertiesToObject(r, n[i]));
e.linked = r;
},
addAnimatie: function(e) {
var t = this.getView().countViewObjectsId(), n = this.createComponent({
container: this,
kind: "educate.create.components.animatie.AnimatieRaster",
layername: "Animatie naam",
position_x: 0,
position_y: 0,
removeAndResize: !0,
viewId: this.getViewId(),
objectId: t
});
e && (n = this.applyPropertiesToObject(n, e));
},
addCijferveld: function(e) {
var t = this.getView().countViewObjectsId(), n = this.createComponent({
container: this,
kind: "educate.components.input.CijferveldRaster",
value: 0,
layername: "cijferveld",
viewId: this.getViewId(),
position_x: 0,
position_y: 0,
objectId: t
});
e && (n = this.applyPropertiesToObject(n, e)), console.log(n);
},
addVideo: function(e) {
var t = this.getView().countViewObjectsId(), n = this.createComponent({
container: this,
kind: "educate.create.components.video.VideoRaster",
layername: "video",
viewId: this.getViewId(),
position_x: 0,
position_y: 0,
objectId: t
});
e && (n = this.applyPropertiesToObject(n, e));
}
});

// Draw.js

enyo.kind({
name: "educate.create.components.tekendoos.Draw",
kind: enyo.Control,
tag: "div",
classes: "drawSvg",
published: {
width: window.settings.STAGEWIDTH,
height: window.settings.STAGEHEIGHT,
beginP: 0,
endP: 0,
drawShape: "",
drawMove: !0,
setPaint: !1,
opacity: .5,
lineColor: "#222",
fillColor: "34, 34, 34",
lineThickness: 5,
radius: 0,
lineType: "solid",
mouseDown: !1,
cursorShape: undefined,
iPaths: 0,
snapShape: !1,
pathPointsTemp: [],
pathPoints: []
},
handlers: {
toggleDrawing: "toggleDrawingHandler",
lineColorSelected: "lineColorSelectedHandler",
fillColorSelected: "fillColorSelectedHandler",
disableDrawing: "disableDrawingHandler",
ondragstart: "onDragStartHandler",
ondragfinish: "onDragEndHandler",
onmove: "onMoveHandler",
ondown: "onDownHandler",
onup: "onUpHandler"
},
components: [ {
name: "svg",
tag: "svg",
attributes: {
xmlns: "http://www.w3.org/2000/svg"
}
}, {
kind: enyo.Signals,
onkeypress: "handleKeyPress",
onkeyup: "handleKeyUp",
onkeydown: "keypressedHandler"
} ],
create: function() {
this.inherited(arguments), this.render();
},
toggleDrawingHandler: function(e, t) {
this.drawMove = e.originator.move, this.setObjectsToMove(), this.drawShape = e.originator.shape;
},
lineColorSelectedHandler: function(e, t) {
this.lineColor = e.originator.lineColor;
},
fillColorSelectedHandler: function(e, t) {
this.fillColor = e.originator.fillColor;
},
onDragStartHandler: function(e, t) {
this.setPaint || (this.mouseDown = !0);
},
onDragEndHandler: function(e, t) {
this.endP = this.getPositionInSvg(t), this.mouseDown = !1, this.drawMove || this.$.svg.hasNode().removeChild(this.cursorShape), this.cursorShape = undefined, this.snapShape && (this.endP.y = this.beginP.y + Math.abs(this.endP.x - this.beginP.x));
if (!this.drawMove && this.drawShape != "free") switch (this.drawShape) {
case "rect":
enyo.Signals.send("onCarrierAddedToStage", {
type: "square"
});
break;
case "ellipse":
enyo.Signals.send("onCarrierAddedToStage", {
type: "ellipse"
});
break;
case "triangle":
this.pathPoints = this.pathPointsTemp, enyo.Signals.send("onCarrierAddedToStage", {
type: "multi"
});
break;
case "pentagon":
this.pathPoints = this.pathPointsTemp, enyo.Signals.send("onCarrierAddedToStage", {
type: "multi"
});
break;
case "star":
this.pathPoints = this.pathPointsTemp, enyo.Signals.send("onCarrierAddedToStage", {
type: "multi"
});
break;
case "arrow":
this.pathPoints = this.pathPointsTemp, enyo.Signals.send("onCarrierAddedToStage", {
type: "multi"
});
break;
default:
}
},
onMoveHandler: function(e, t) {
if (this.mouseDown && !this.drawMove && this.drawShape != "free") {
var n = this.getPositionInSvg(t);
switch (this.drawShape) {
case "rect":
this.cursorShape == undefined ? (this.cursorShape = document.createElementNS("http://www.w3.org/2000/svg", "rect"), this.snapShape ? (this.cursorShape.width.baseVal.value = Math.abs(n.x - this.beginP.x), this.cursorShape.height.baseVal.value = Math.abs(n.x - this.beginP.x)) : (this.cursorShape.width.baseVal.value = Math.abs(n.x - this.beginP.x), this.cursorShape.height.baseVal.value = Math.abs(n.y - this.beginP.y)), this.cursorShape.style.fill = "rgb(" + this.fillColor + ")", this.cursorShape.style.fillOpacity = this.opacity, this.cursorShape.style.stroke = this.lineColor, this.cursorShape.style.strokeWidth = this.lineThickness, this.$.svg.hasNode().appendChild(this.cursorShape), this.cursorShape.x.baseVal.value = n.x < this.beginP.x ? n.x : this.beginP.x, this.cursorShape.y.baseVal.value = n.y < this.beginP.y ? n.y : this.beginP.y) : (this.snapShape ? (this.cursorShape.width.baseVal.value = Math.abs(n.x - this.beginP.x), this.cursorShape.height.baseVal.value = Math.abs(n.x - this.beginP.x)) : (this.cursorShape.width.baseVal.value = Math.abs(n.x - this.beginP.x), this.cursorShape.height.baseVal.value = Math.abs(n.y - this.beginP.y)), this.cursorShape.x.baseVal.value = n.x < this.beginP.x ? n.x : this.beginP.x, this.cursorShape.y.baseVal.value = n.y < this.beginP.y ? n.y : this.beginP.y);
break;
case "ellipse":
this.cursorShape == undefined ? (this.cursorShape = document.createElementNS("http://www.w3.org/2000/svg", "ellipse"), this.cursorShape.setAttributeNS(null, "cx", n.x < this.beginP.x ? n.x : this.beginP.x), this.cursorShape.setAttributeNS(null, "cy", n.y < this.beginP.y ? n.y : this.beginP.y), this.snapShape ? (this.cursorShape.setAttributeNS(null, "rx", Math.abs(n.x - this.beginP.x)), this.cursorShape.setAttributeNS(null, "ry", Math.abs(n.x - this.beginP.x))) : (this.cursorShape.setAttributeNS(null, "rx", Math.abs(n.x - this.beginP.x)), this.cursorShape.setAttributeNS(null, "ry", Math.abs(n.y - this.beginP.y))), this.cursorShape.setAttributeNS(null, "fill", "rgb(" + this.fillColor + ")"), this.cursorShape.setAttributeNS(null, "fill-opacity", this.opacity), this.cursorShape.setAttributeNS(null, "stroke", this.lineColor), this.cursorShape.setAttributeNS(null, "stroke-width", this.lineThickness), this.$.svg.hasNode().appendChild(this.cursorShape)) : (this.cursorShape.setAttributeNS(null, "cx", n.x < this.beginP.x ? n.x : this.beginP.x), this.cursorShape.setAttributeNS(null, "cy", n.y < this.beginP.y ? n.y : this.beginP.y), this.snapShape ? (this.cursorShape.setAttributeNS(null, "rx", Math.abs(n.x - this.beginP.x)), this.cursorShape.setAttributeNS(null, "ry", Math.abs(n.x - this.beginP.x))) : (this.cursorShape.setAttributeNS(null, "rx", Math.abs(n.x - this.beginP.x)), this.cursorShape.setAttributeNS(null, "ry", Math.abs(n.y - this.beginP.y))));
break;
case "triangle":
this.cursorShape == undefined ? (this.cursorShape = document.createElementNS("http://www.w3.org/2000/svg", "polygon"), this.cursorShape.style.fill = "rgb(" + this.fillColor + ")", this.cursorShape.style.fillOpacity = this.opacity, this.cursorShape.style.stroke = this.lineColor, this.cursorShape.style.strokeWidth = this.lineThickness, this.cursorShape.setAttribute("points", "10,50 0,100 20,100"), this.$.svg.hasNode().appendChild(this.cursorShape)) : (this.pathPointsTemp.length = 0, this.pathPointsTemp.push(this.beginP.x + Math.abs(n.x - this.beginP.x) / 2 + "," + this.beginP.y), this.pathPointsTemp.push(this.beginP.x + "," + n.y), this.pathPointsTemp.push(n.x + "," + n.y), this.cursorShape.setAttribute("points", this.beginP.x + Math.abs(n.x - this.beginP.x) / 2 + "," + this.beginP.y + " " + this.beginP.x + "," + n.y + " " + n.x + "," + n.y));
break;
case "pentagon":
this.cursorShape == undefined ? (this.cursorShape = document.createElementNS("http://www.w3.org/2000/svg", "polygon"), this.cursorShape.style.fill = "rgb(" + this.fillColor + ")", this.cursorShape.style.fillOpacity = this.opacity, this.cursorShape.style.stroke = this.lineColor, this.cursorShape.style.strokeWidth = this.lineThickness, this.$.svg.hasNode().appendChild(this.cursorShape)) : (this.pathPointsTemp.length = 0, this.pathPointsTemp.push((this.beginP.x > n.x ? this.beginP.x - Math.abs(n.x - this.beginP.x) / 2 : this.beginP.x + Math.abs(n.x - this.beginP.x) / 2) + "," + this.beginP.y), this.pathPointsTemp.push(this.beginP.x + "," + (this.beginP.y > n.y ? parseInt(this.beginP.y - Math.round(Math.abs(n.y - this.beginP.y) * 2 / 5)) : parseInt(this.beginP.y + Math.round(Math.abs(n.y - this.beginP.y) * 2 / 5)))), this.pathPointsTemp.push((this.beginP.x > n.x ? parseInt(this.beginP.x - Math.round(Math.abs(n.x - this.beginP.x) * 1 / 5)) : parseInt(this.beginP.x + Math.round(Math.abs(n.x - this.beginP.x) * 1 / 5))) + "," + n.y), this.pathPointsTemp.push((this.beginP.x > n.x ? parseInt(this.beginP.x - Math.round(Math.abs(n.x - this.beginP.x) * 4 / 5)) : parseInt(this.beginP.x + Math.round(Math.abs(n.x - this.beginP.x) * 4 / 5))) + "," + n.y), this.pathPointsTemp.push(n.x + "," + (this.beginP.y > n.y ? parseInt(this.beginP.y - Math.round(Math.abs(n.y - this.beginP.y) * 2 / 5)) : parseInt(this.beginP.y + Math.round(Math.abs(n.y - this.beginP.y) * 2 / 5)))), this.cursorShape.setAttribute("points", (this.beginP.x > n.x ? this.beginP.x - Math.abs(n.x - this.beginP.x) / 2 : this.beginP.x + Math.abs(n.x - this.beginP.x) / 2) + "," + this.beginP.y + " " + this.beginP.x + "," + (this.beginP.y > n.y ? parseInt(this.beginP.y - Math.round(Math.abs(n.y - this.beginP.y) * 2 / 5)) : parseInt(this.beginP.y + Math.round(Math.abs(n.y - this.beginP.y) * 2 / 5))) + " " + (this.beginP.x > n.x ? parseInt(this.beginP.x - Math.round(Math.abs(n.x - this.beginP.x) * 1 / 5)) : parseInt(this.beginP.x + Math.round(Math.abs(n.x - this.beginP.x) * 1 / 5))) + "," + n.y + " " + (this.beginP.x > n.x ? parseInt(this.beginP.x - Math.round(Math.abs(n.x - this.beginP.x) * 4 / 5)) : parseInt(this.beginP.x + Math.round(Math.abs(n.x - this.beginP.x) * 4 / 5))) + "," + n.y + " " + n.x + "," + (this.beginP.y > n.y ? parseInt(this.beginP.y - Math.round(Math.abs(n.y - this.beginP.y) * 2 / 5)) : parseInt(this.beginP.y + Math.round(Math.abs(n.y - this.beginP.y) * 2 / 5)))));
break;
case "star":
this.cursorShape == undefined ? (this.cursorShape = document.createElementNS("http://www.w3.org/2000/svg", "polygon"), this.cursorShape.style.fill = "rgb(" + this.fillColor + ")", this.cursorShape.style.fillOpacity = this.opacity, this.cursorShape.style.stroke = this.lineColor, this.cursorShape.style.strokeWidth = this.lineThickness, this.$.svg.hasNode().appendChild(this.cursorShape)) : (this.pathPointsTemp.length = 0, this.pathPointsTemp.push((this.beginP.x > n.x ? this.beginP.x - Math.abs(n.x - this.beginP.x) / 2 : this.beginP.x + Math.abs(n.x - this.beginP.x) / 2) + "," + this.beginP.y), this.pathPointsTemp.push((this.beginP.x > n.x ? parseInt(this.beginP.x - Math.round(Math.abs(n.x - this.beginP.x) * 2 / 6)) : parseInt(this.beginP.x + Math.round(Math.abs(n.x - this.beginP.x) * 2 / 6))) + "," + (this.beginP.y > n.y ? parseInt(this.beginP.y - Math.round(Math.abs(n.y - this.beginP.y) * 3 / 10)) : parseInt(this.beginP.y + Math.round(Math.abs(n.y - this.beginP.y) * 3 / 10)))), this.pathPointsTemp.push(this.beginP.x + "," + (this.beginP.y > n.y ? parseInt(this.beginP.y - Math.round(Math.abs(n.y - this.beginP.y) * 3 / 10)) : parseInt(this.beginP.y + Math.round(Math.abs(n.y - this.beginP.y) * 3 / 10)))), this.pathPointsTemp.push((this.beginP.x > n.x ? parseInt(this.beginP.x - Math.round(Math.abs(n.x - this.beginP.x) * 3 / 10)) : parseInt(this.beginP.x + Math.round(Math.abs(n.x - this.beginP.x) * 3 / 10))) + "," + (this.beginP.y > n.y ? parseInt(this.beginP.y - Math.round(Math.abs(n.y - this.beginP.y) * 6 / 10)) : parseInt(this.beginP.y + Math.round(Math.abs(n.y - this.beginP.y) * 6 / 10)))), this.pathPointsTemp.push((this.beginP.x > n.x ? parseInt(this.beginP.x - Math.round(Math.abs(n.x - this.beginP.x) * 1 / 5)) : parseInt(this.beginP.x + Math.round(Math.abs(n.x - this.beginP.x) * 1 / 5))) + "," + n.y), this.pathPointsTemp.push((this.beginP.x > n.x ? this.beginP.x - Math.abs(n.x - this.beginP.x) / 2 : this.beginP.x + Math.abs(n.x - this.beginP.x) / 2) + "," + (this.beginP.y > n.y ? parseInt(this.beginP.y - Math.round(Math.abs(n.y - this.beginP.y) * 8 / 10)) : parseInt(this.beginP.y + Math.round(Math.abs(n.y - this.beginP.y) * 8 / 10)))), this.pathPointsTemp.push((this.beginP.x > n.x ? parseInt(this.beginP.x - Math.round(Math.abs(n.x - this.beginP.x) * 4 / 5)) : parseInt(this.beginP.x + Math.round(Math.abs(n.x - this.beginP.x) * 4 / 5))) + "," + n.y), this.pathPointsTemp.push((this.beginP.x > n.x ? parseInt(this.beginP.x - Math.round(Math.abs(n.x - this.beginP.x) * 7 / 10)) : parseInt(this.beginP.x + Math.round(Math.abs(n.x - this.beginP.x) * 7 / 10))) + "," + (this.beginP.y > n.y ? parseInt(this.beginP.y - Math.round(Math.abs(n.y - this.beginP.y) * 6 / 10)) : parseInt(this.beginP.y + Math.round(Math.abs(n.y - this.beginP.y) * 6 / 10)))), this.pathPointsTemp.push(n.x + "," + (this.beginP.y > n.y ? parseInt(this.beginP.y - Math.round(Math.abs(n.y - this.beginP.y) * 3 / 10)) : parseInt(this.beginP.y + Math.round(Math.abs(n.y - this.beginP.y) * 3 / 10)))), this.pathPointsTemp.push((this.beginP.x > n.x ? parseInt(this.beginP.x - Math.round(Math.abs(n.x - this.beginP.x) * 4 / 6)) : parseInt(this.beginP.x + Math.round(Math.abs(n.x - this.beginP.x) * 4 / 6))) + "," + (this.beginP.y > n.y ? parseInt(this.beginP.y - Math.round(Math.abs(n.y - this.beginP.y) * 3 / 10)) : parseInt(this.beginP.y + Math.round(Math.abs(n.y - this.beginP.y) * 3 / 10)))), this.cursorShape.setAttribute("points", (this.beginP.x > n.x ? this.beginP.x - Math.abs(n.x - this.beginP.x) / 2 : this.beginP.x + Math.abs(n.x - this.beginP.x) / 2) + "," + this.beginP.y + " " + (this.beginP.x > n.x ? parseInt(this.beginP.x - Math.round(Math.abs(n.x - this.beginP.x) * 2 / 6)) : parseInt(this.beginP.x + Math.round(Math.abs(n.x - this.beginP.x) * 2 / 6))) + "," + (this.beginP.y > n.y ? parseInt(this.beginP.y - Math.round(Math.abs(n.y - this.beginP.y) * 3 / 10)) : parseInt(this.beginP.y + Math.round(Math.abs(n.y - this.beginP.y) * 3 / 10))) + " " + this.beginP.x + "," + (this.beginP.y > n.y ? parseInt(this.beginP.y - Math.round(Math.abs(n.y - this.beginP.y) * 3 / 10)) : parseInt(this.beginP.y + Math.round(Math.abs(n.y - this.beginP.y) * 3 / 10))) + " " + (this.beginP.x > n.x ? parseInt(this.beginP.x - Math.round(Math.abs(n.x - this.beginP.x) * 3 / 10)) : parseInt(this.beginP.x + Math.round(Math.abs(n.x - this.beginP.x) * 3 / 10))) + "," + (this.beginP.y > n.y ? parseInt(this.beginP.y - Math.round(Math.abs(n.y - this.beginP.y) * 6 / 10)) : parseInt(this.beginP.y + Math.round(Math.abs(n.y - this.beginP.y) * 6 / 10))) + " " + (this.beginP.x > n.x ? parseInt(this.beginP.x - Math.round(Math.abs(n.x - this.beginP.x) * 1 / 5)) : parseInt(this.beginP.x + Math.round(Math.abs(n.x - this.beginP.x) * 1 / 5))) + "," + n.y + " " + (this.beginP.x > n.x ? this.beginP.x - Math.abs(n.x - this.beginP.x) / 2 : this.beginP.x + Math.abs(n.x - this.beginP.x) / 2) + "," + (this.beginP.y > n.y ? parseInt(this.beginP.y - Math.round(Math.abs(n.y - this.beginP.y) * 8 / 10)) : parseInt(this.beginP.y + Math.round(Math.abs(n.y - this.beginP.y) * 8 / 10))) + " " + (this.beginP.x > n.x ? parseInt(this.beginP.x - Math.round(Math.abs(n.x - this.beginP.x) * 4 / 5)) : parseInt(this.beginP.x + Math.round(Math.abs(n.x - this.beginP.x) * 4 / 5))) + "," + n.y + " " + (this.beginP.x > n.x ? parseInt(this.beginP.x - Math.round(Math.abs(n.x - this.beginP.x) * 7 / 10)) : parseInt(this.beginP.x + Math.round(Math.abs(n.x - this.beginP.x) * 7 / 10))) + "," + (this.beginP.y > n.y ? parseInt(this.beginP.y - Math.round(Math.abs(n.y - this.beginP.y) * 6 / 10)) : parseInt(this.beginP.y + Math.round(Math.abs(n.y - this.beginP.y) * 6 / 10))) + " " + n.x + "," + (this.beginP.y > n.y ? parseInt(this.beginP.y - Math.round(Math.abs(n.y - this.beginP.y) * 3 / 10)) : parseInt(this.beginP.y + Math.round(Math.abs(n.y - this.beginP.y) * 3 / 10))) + " " + (this.beginP.x > n.x ? parseInt(this.beginP.x - Math.round(Math.abs(n.x - this.beginP.x) * 4 / 6)) : parseInt(this.beginP.x + Math.round(Math.abs(n.x - this.beginP.x) * 4 / 6))) + "," + (this.beginP.y > n.y ? parseInt(this.beginP.y - Math.round(Math.abs(n.y - this.beginP.y) * 3 / 10)) : parseInt(this.beginP.y + Math.round(Math.abs(n.y - this.beginP.y) * 3 / 10)))));
break;
case "arrow":
this.cursorShape == undefined ? (this.cursorShape = document.createElementNS("http://www.w3.org/2000/svg", "polygon"), this.cursorShape.style.fill = "rgb(" + this.fillColor + ")", this.cursorShape.style.fillOpacity = this.opacity, this.cursorShape.style.stroke = this.lineColor, this.cursorShape.style.strokeWidth = this.lineThickness, this.$.svg.hasNode().appendChild(this.cursorShape)) : (this.pathPointsTemp.length = 0, this.pathPointsTemp.push((this.beginP.x > n.x ? this.beginP.x - Math.abs(n.x - this.beginP.x) / 3 : this.beginP.x + Math.abs(n.x - this.beginP.x) / 3) + "," + this.beginP.y), this.pathPointsTemp.push(this.beginP.x + "," + (this.beginP.y > n.y ? parseInt(this.beginP.y - Math.round(Math.abs(n.y - this.beginP.y) / 2)) : parseInt(this.beginP.y + Math.round(Math.abs(n.y - this.beginP.y) / 2)))), this.pathPointsTemp.push((this.beginP.x > n.x ? this.beginP.x - Math.abs(n.x - this.beginP.x) / 3 : this.beginP.x + Math.abs(n.x - this.beginP.x) / 3) + "," + n.y), this.pathPointsTemp.push((this.beginP.x > n.x ? this.beginP.x - Math.abs(n.x - this.beginP.x) / 3 : this.beginP.x + Math.abs(n.x - this.beginP.x) / 3) + "," + (this.beginP.y > n.y ? parseInt(this.beginP.y - Math.round(Math.abs(n.y - this.beginP.y) * 7 / 10)) : parseInt(this.beginP.y + Math.round(Math.abs(n.y - this.beginP.y) * 7 / 10)))), this.pathPointsTemp.push(n.x + "," + (this.beginP.y > n.y ? parseInt(this.beginP.y - Math.round(Math.abs(n.y - this.beginP.y) * 7 / 10)) : parseInt(this.beginP.y + Math.round(Math.abs(n.y - this.beginP.y) * 7 / 10)))), this.pathPointsTemp.push(n.x + "," + (this.beginP.y > n.y ? parseInt(this.beginP.y - Math.round(Math.abs(n.y - this.beginP.y) * 3 / 10)) : parseInt(this.beginP.y + Math.round(Math.abs(n.y - this.beginP.y) * 3 / 10)))), this.pathPointsTemp.push((this.beginP.x > n.x ? this.beginP.x - Math.abs(n.x - this.beginP.x) / 3 : this.beginP.x + Math.abs(n.x - this.beginP.x) / 3) + "," + (this.beginP.y > n.y ? parseInt(this.beginP.y - Math.round(Math.abs(n.y - this.beginP.y) * 3 / 10)) : parseInt(this.beginP.y + Math.round(Math.abs(n.y - this.beginP.y) * 3 / 10)))), this.cursorShape.setAttribute("points", (this.beginP.x > n.x ? this.beginP.x - Math.abs(n.x - this.beginP.x) / 3 : this.beginP.x + Math.abs(n.x - this.beginP.x) / 3) + "," + this.beginP.y + " " + this.beginP.x + "," + (this.beginP.y > n.y ? parseInt(this.beginP.y - Math.round(Math.abs(n.y - this.beginP.y) / 2)) : parseInt(this.beginP.y + Math.round(Math.abs(n.y - this.beginP.y) / 2))) + " " + (this.beginP.x > n.x ? this.beginP.x - Math.abs(n.x - this.beginP.x) / 3 : this.beginP.x + Math.abs(n.x - this.beginP.x) / 3) + "," + n.y + " " + (this.beginP.x > n.x ? this.beginP.x - Math.abs(n.x - this.beginP.x) / 3 : this.beginP.x + Math.abs(n.x - this.beginP.x) / 3) + "," + (this.beginP.y > n.y ? parseInt(this.beginP.y - Math.round(Math.abs(n.y - this.beginP.y) * 7 / 10)) : parseInt(this.beginP.y + Math.round(Math.abs(n.y - this.beginP.y) * 7 / 10))) + " " + n.x + "," + (this.beginP.y > n.y ? parseInt(this.beginP.y - Math.round(Math.abs(n.y - this.beginP.y) * 7 / 10)) : parseInt(this.beginP.y + Math.round(Math.abs(n.y - this.beginP.y) * 7 / 10))) + " " + n.x + "," + (this.beginP.y > n.y ? parseInt(this.beginP.y - Math.round(Math.abs(n.y - this.beginP.y) * 3 / 10)) : parseInt(this.beginP.y + Math.round(Math.abs(n.y - this.beginP.y) * 3 / 10))) + " " + (this.beginP.x > n.x ? this.beginP.x - Math.abs(n.x - this.beginP.x) / 3 : this.beginP.x + Math.abs(n.x - this.beginP.x) / 3) + "," + (this.beginP.y > n.y ? parseInt(this.beginP.y - Math.round(Math.abs(n.y - this.beginP.y) * 3 / 10)) : parseInt(this.beginP.y + Math.round(Math.abs(n.y - this.beginP.y) * 3 / 10)))));
break;
default:
}
} else if (!this.drawMove && this.setPaint && this.drawShape == "free" && !this.snapShape) {
var n = this.getPositionInSvg(t);
this.pathPointsTemp.push(n), $(".tekenpath" + this.iPaths).attr("d", $(".tekenpath" + this.iPaths).attr("d") + " L " + n.x + "," + n.y);
} else if (!this.drawMove && this.setPaint && this.drawShape == "free" && this.snapShape) {
var n = this.getPositionInSvg(t);
this.pathPointsTemp[1] = n, $(".tekenpath" + this.iPaths).attr("d", "M " + this.beginP.x + "," + this.beginP.y + " L " + n.x + "," + n.y);
}
},
onDownHandler: function(e, t) {
this.beginP = this.getPositionInSvg(t), !this.drawMove && this.drawShape == "free" && (this.setPaint = !0, this.iPaths++, this.beginP = this.getPositionInSvg(t), this.pathPointsTemp.length = 0, this.pathPointsTemp.push(this.beginP), this.cursorShape = document.createElementNS("http://www.w3.org/2000/svg", "path"), this.cursorShape.setAttribute("class", "tekenpath" + this.iPaths), this.cursorShape.setAttribute("fill", "none"), this.cursorShape.setAttribute("stroke", this.lineColor), this.cursorShape.setAttribute("stroke-width", 5), this.cursorShape.setAttribute("stroke-linejoin", "round"), this.cursorShape.setAttribute("stroke-linecap", "round"), this.cursorShape.setAttribute("d", "M " + this.beginP.x + "," + this.beginP.y), this.$.svg.hasNode().appendChild(this.cursorShape));
},
onUpHandler: function(e, t) {
this.setPaint = !1, this.drawShape == "free" && (this.snapShape || this.pathPointsTemp.push(this.endP), this.pathPoints = this.pathPointsTemp, enyo.Signals.send("onCarrierAddedToStage", {
type: "free"
})), this.setObjectsToMove();
},
setObjectsToMove: function() {
this.drawMove ? (this.$.svg.applyStyle("pointer-events", "none"), $(".rectangles").each(function() {
$(this).css("z-index", "1");
}), $(".ellipses").each(function() {
$(this).css("z-index", "1");
}), $(".lines").each(function() {
$(this).css("z-index", "1");
})) : this.drawMove || (this.$.svg.applyStyle("pointer-events", "auto"), $(".rectangles").each(function() {
$(this).css("z-index", "0");
}), $(".ellipses").each(function() {
$(this).css("z-index", "0");
}), $(".lines").each(function() {
$(this).css("z-index", "0");
}));
},
getPositionInSvg: function(e) {
var t = $(this.parent.node).offset().left, n = $(this.parent.node).offset().top, r = new Object;
return r.x = e.clientX - t, r.y = e.clientY - n, r;
},
keypressedHandler: function(e, t) {
t.shiftKey && (this.snapShape = !0);
},
handleKeyUp: function(e, t) {
this.snapShape = !1;
},
resizeComponent: function() {
this.inherited(arguments);
},
disableDrawingHandler: function() {
this.drawMove = !0;
}
});

// Square.js

enyo.kind({
name: "educate.create.components.tekendoos.Square",
kind: "educate.components.tekendoos.Square",
classes: "rectangles",
attributes: {
xmlns: "http://www.w3.org/2000/svg",
version: "1.1",
viewbox: "0 0 1280 800"
},
published: {
width: 500,
height: 300,
position_x: 150,
position_y: 100,
objType: "div_",
reposition: !1,
opacity: .5,
lineColor: "#222",
fillColor: "34, 34, 34",
lineThickness: 5,
lineType: "solid",
radius: 0,
beginP: 0,
endP: 0,
ori: 0,
oriY: 0,
snapShape: !1
},
handler: {
onPropertiesChanged: "onPropertiesChangedHandler"
},
components: [ {
tag: "div",
name: "rightBottom",
style: "height:10px;width:10px;background-color:blue;position:absolute;bottom:-8px;right:-8px;",
ondown: "downHandler"
}, {
tag: "div",
name: "leftBottom",
style: "height:10px;width:10px;background-color:blue;position:absolute;bottom:-8px;left:-8px;",
ondown: "downHandler"
}, {
tag: "div",
name: "leftTop",
style: "height:10px;width:10px;background-color:blue;position:absolute;top:-8px;left:-8px;",
ondown: "downHandler"
}, {
tag: "div",
name: "rightTop",
style: "height:10px;width:10px;background-color:blue;position:absolute;top:-8px;right:-8px;",
ondown: "downHandler"
}, {
tag: "div",
name: "right",
style: "height:10px;width:10px;background-color:blue;position:absolute;top:49%;right:-8px;",
ondown: "downHandler"
}, {
tag: "div",
name: "left",
style: "height:10px;width:10px;background-color:blue;position:absolute;top:49%;left:-8px;",
ondown: "downHandler"
}, {
tag: "div",
name: "bot",
style: "height:10px;width:10px;background-color:blue;position:absolute;bottom:-8px;left:48%;",
ondown: "downHandler"
}, {
tag: "div",
name: "top",
style: "height:10px;width:10px;background-color:blue;position:absolute;top:-8px;left:48%;",
ondown: "downHandler"
}, {
kind: enyo.Signals,
onkeyup: "handleKeyUp",
onkeydown: "keypressedHandler"
} ],
create: function() {
this.inherited(arguments), this.width = Math.abs(this.endP.x - this.beginP.x), this.height = Math.abs(this.endP.y - this.beginP.y), this.reposition || (this.position_x = (this.endP.x < this.beginP.x ? this.endP.x : this.beginP.x) / window.settings.SCALE, this.position_y = (this.endP.y < this.beginP.y ? this.endP.y : this.beginP.y) / window.settings.SCALE), this.addPropertiesToOptions(), this.redrawSquare(), this.saveDimensions(), this.owner.$.pickAndPlace && this.owner.$.pickAndPlace.drawExtraInput(this.layername);
},
lineColorChanged: function(e) {
this.lineColor = e, this.redrawSquare();
},
fillColorChanged: function(e) {
this.fillColor = e, this.redrawSquare();
},
visibleChanged: function() {
this.applyStyle("opacity", this.getVisible() !== !1 ? 1 : .25), this.addOption("visible", this.getVisible());
},
widthChanged: function() {
this.redrawSquare();
},
heightChanged: function() {
this.redrawSquare();
},
onPropertiesChangedHandler: function(e, t) {
t.linked == this && (this.layername = t.linked.layername, this.value != "" && this.setValue(t.linked.value), this.resizeComponent());
},
addPropertiesToOptions: function(e) {
this.addOption("beginP", e == undefined ? this.beginP : e.beginP), this.addOption("endP", e == undefined ? this.endP : e.endP), this.addOption("opacity", e == undefined ? this.opacity : e.opacity), this.addOption("lineColor", e == undefined ? this.lineColor : e.lineColor), this.addOption("lineType", e == undefined ? this.lineType : e.lineType), this.addOption("lineThickness", e == undefined ? this.lineThickness : e.lineThickness), this.addOption("fillColor", e == undefined ? this.fillColor : e.fillColor), this.addOption("radius", e == undefined ? this.radius : e.radius), this.addOption("opacity", e == undefined ? this.opacity : e.opacity);
},
downHandler: function(e, t) {
if (e.kind == "educate.create.components.tekendoos.Square") {
this.inherited(arguments);
if (!this.getLocked()) return !this.getSelected() && this.bubble("objectSelected", this), !0;
$(document).on("mousemove", enyo.bind(this, "dragObjectHandler")), $(document).on("mouseup", enyo.bind(this, "upHandler"));
} else e.name == "rightBottom" ? ($(document).on("mousemove", enyo.bind(this, "stretchObjectRightBottom")), $(document).on("mouseup", enyo.bind(this, "upHandler"))) : e.name == "leftBottom" ? (this.ori = this.position_x + this.endP.x, this.oriY = this.position_y + this.endP.y, $(document).on("mousemove", enyo.bind(this, "stretchObjectLeftBottom")), $(document).on("mouseup", enyo.bind(this, "upHandler")), $(document).on("mouseup", enyo.bind(this, "saveDimensions"))) : e.name == "leftTop" ? (this.ori = this.position_x + this.endP.x, this.oriY = this.position_y + this.endP.y, $(document).on("mousemove", enyo.bind(this, "stretchObjectLeftTop")), $(document).on("mouseup", enyo.bind(this, "upHandler")), $(document).on("mouseup", enyo.bind(this, "saveDimensions"))) : e.name == "rightTop" ? (this.ori = this.position_x + this.endP.x, this.oriY = this.position_y + this.endP.y, $(document).on("mousemove", enyo.bind(this, "stretchObjectRightTop")), $(document).on("mouseup", enyo.bind(this, "upHandler")), $(document).on("mouseup", enyo.bind(this, "saveDimensions"))) : e.name == "right" ? (this.ori = this.position_x + this.endP.x, $(document).on("mousemove", enyo.bind(this, "stretchObjectRight")), $(document).on("mouseup", enyo.bind(this, "upHandler")), $(document).on("mouseup", enyo.bind(this, "saveDimensions"))) : e.name == "left" ? (this.ori = this.position_x + this.endP.x, $(document).on("mousemove", enyo.bind(this, "stretchObjectLeft")), $(document).on("mouseup", enyo.bind(this, "upHandler")), $(document).on("mouseup", enyo.bind(this, "saveDimensions"))) : e.name == "top" ? (this.oriY = this.position_y + this.endP.y, $(document).on("mousemove", enyo.bind(this, "stretchObjectTop")), $(document).on("mouseup", enyo.bind(this, "upHandler")), $(document).on("mouseup", enyo.bind(this, "saveDimensions"))) : e.name == "bot" && (this.oriY = this.position_y + this.endP.y, $(document).on("mousemove", enyo.bind(this, "stretchObjectBot")), $(document).on("mouseup", enyo.bind(this, "upHandler")), $(document).on("mouseup", enyo.bind(this, "saveDimensions")));
},
keypressedHandler: function(e, t) {
t.shiftKey && (this.snapShape = !0);
},
handleKeyUp: function(e, t) {
this.snapShape = !1;
},
stretchObjectRightBottom: function(e) {
var t = $(this.parent.node).offset().left, n = $(this.parent.node).offset().top;
this.endP.x = e.clientX - t - this.position_x * window.settings.SCALE, this.endP.y = e.clientY - n - this.position_y * window.settings.SCALE, this.snapShape ? (this.width = math.round(this.endP.x), this.height = this.width) : (this.width = math.round(this.endP.x), this.height = math.round(this.endP.y)), this.redrawSquare();
},
stretchObjectLeftBottom: function(e) {
var t = $(this.parent.node).offset().left, n = $(this.parent.node).offset().top;
this.position_x = (e.clientX - t) / window.settings.SCALE, this.endP.y = e.clientY - n - this.position_y * window.settings.SCALE, this.snapShape ? (this.width = math.round(this.endP.x + (this.ori - this.position_x - this.endP.x) * window.settings.SCALE), this.height = this.width) : (this.width = math.round(this.endP.x + (this.ori - this.position_x - this.endP.x) * window.settings.SCALE), this.height = math.round(this.endP.y)), this.redrawSquare();
},
stretchObjectLeftTop: function(e) {
var t = $(this.parent.node).offset().left, n = $(this.parent.node).offset().top;
this.position_x = (e.clientX - t) / window.settings.SCALE, this.position_y = (e.clientY - n) / window.settings.SCALE - window.settings.SCALE, this.snapShape ? (this.height = math.round(this.endP.y + (this.oriY - this.position_y - this.endP.y) * window.settings.SCALE), this.width = this.height) : (this.width = math.round(this.endP.x + (this.ori - this.position_x - this.endP.x) * window.settings.SCALE), this.height = math.round(this.endP.y + (this.oriY - this.position_y - this.endP.y) * window.settings.SCALE)), this.redrawSquare();
},
stretchObjectRightTop: function(e) {
var t = $(this.parent.node).offset().left, n = $(this.parent.node).offset().top;
this.endP.x = e.clientX - t - this.position_x * window.settings.SCALE, this.position_y = (e.clientY - n) / window.settings.SCALE - window.settings.SCALE, this.snapShape ? (this.height = math.round(this.endP.y + (this.oriY - this.position_y - this.endP.y) * window.settings.SCALE), this.width = this.height) : (this.width = math.round(this.endP.x), this.height = math.round(this.endP.y + (this.oriY - this.position_y - this.endP.y) * window.settings.SCALE)), this.redrawSquare();
},
stretchObjectRight: function(e) {
var t = $(this.parent.node).offset().left;
this.endP.x = e.clientX - t - this.position_x * window.settings.SCALE, this.width = math.round(this.endP.x), this.height = math.round(this.endP.y), this.redrawSquare();
},
stretchObjectLeft: function(e) {
var t = $(this.parent.node).offset().left;
this.position_x = (e.clientX - t) / window.settings.SCALE, this.width = math.round(this.endP.x + (this.ori - this.position_x - this.endP.x) * window.settings.SCALE), this.height = math.round(this.endP.y), this.redrawSquare();
},
stretchObjectTop: function(e) {
var t = $(this.parent.node).offset().top;
this.position_y = (e.clientY - t) / window.settings.SCALE - window.settings.SCALE, this.width = math.round(this.endP.x), this.height = math.round(this.endP.y + (this.oriY - this.position_y - this.endP.y) * window.settings.SCALE), this.redrawSquare();
},
stretchObjectBot: function(e) {
var t = $(this.parent.node).offset().top;
this.endP.y = e.clientY - t - this.position_y * window.settings.SCALE, this.width = math.round(this.endP.x), this.height = math.round(this.endP.y), this.redrawSquare();
},
saveDimensions: function() {
this.endP.x = this.calculatedWidth, this.endP.y = this.calculatedHeight, this.width = math.round(this.calculatedWidth / window.settings.SCALE), this.height = math.round(this.calculatedHeight / window.settings.SCALE);
}
});

// Ellipse.js

enyo.kind({
name: "educate.create.components.tekendoos.Ellipse",
kind: "educate.components.tekendoos.Ellipse",
classes: "ellipses",
attributes: {
xmlns: "http://www.w3.org/2000/svg",
version: "1.1",
viewbox: "0 0 1280 800"
},
published: {
width: 500,
height: 300,
position_x: 150,
position_y: 100,
objType: "div_",
reposition: !1,
opacity: .5,
lineColor: "#222",
fillColor: "34, 34, 34",
beginP: 0,
endP: 0,
ori: 0,
oriY: 0,
snapShape: !1
},
handler: {
onPropertiesChanged: "onPropertiesChangedHandler"
},
components: [ {
tag: "div",
name: "rightBottom",
style: "height:10px;width:10px;background-color:blue;position:absolute;bottom:-8px;right:-8px;",
ondown: "downHandler"
}, {
tag: "div",
name: "leftBottom",
style: "height:10px;width:10px;background-color:blue;position:absolute;bottom:-8px;left:-8px;",
ondown: "downHandler"
}, {
tag: "div",
name: "leftTop",
style: "height:10px;width:10px;background-color:blue;position:absolute;top:-8px;left:-8px;",
ondown: "downHandler"
}, {
tag: "div",
name: "rightTop",
style: "height:10px;width:10px;background-color:blue;position:absolute;top:-8px;right:-8px;",
ondown: "downHandler"
}, {
tag: "div",
name: "right",
style: "height:10px;width:10px;background-color:blue;position:absolute;top:49%;right:-8px;",
ondown: "downHandler"
}, {
tag: "div",
name: "left",
style: "height:10px;width:10px;background-color:blue;position:absolute;top:49%;left:-8px;",
ondown: "downHandler"
}, {
tag: "div",
name: "bot",
style: "height:10px;width:10px;background-color:blue;position:absolute;bottom:-8px;left:48%;",
ondown: "downHandler"
}, {
tag: "div",
name: "top",
style: "height:10px;width:10px;background-color:blue;position:absolute;top:-8px;left:48%;",
ondown: "downHandler"
}, {
kind: enyo.Signals,
onkeyup: "handleKeyUp",
onkeydown: "keypressedHandler"
} ],
create: function() {
this.inherited(arguments), this.width = Math.abs(this.endP.x - this.beginP.x) * 2, this.height = Math.abs(this.endP.y - this.beginP.y) * 2, this.reposition || (this.position_x = ((this.endP.x < this.beginP.x ? this.endP.x : this.beginP.x) - this.width / 2) / window.settings.SCALE, this.position_y = ((this.endP.y < this.beginP.y ? this.endP.y : this.beginP.y) - this.height / 2) / window.settings.SCALE), this.render(), this.redrawEllipse(), this.saveDimensions(), this.owner.$.pickAndPlace && this.owner.$.pickAndPlace.drawExtraInput(this.layername);
},
lineColorChanged: function(e) {
this.lineColor = e, this.redrawEllipse();
},
fillColorChanged: function(e) {
this.fillColor = e, this.redrawEllipse();
},
visibleChanged: function() {
this.applyStyle("opacity", this.getVisible() !== !1 ? 1 : .25), this.addOption("visible", this.getVisible());
},
widthChanged: function() {
this.redrawEllipse();
},
heightChanged: function() {
this.redrawEllipse();
},
onPropertiesChangedHandler: function(e, t) {
t.linked == this && (this.layername = t.linked.layername, this.value != "" && this.setValue(t.linked.value), this.resizeComponent());
},
downHandler: function(e, t) {
if (e.kind == "educate.create.components.tekendoos.Ellipse") {
this.inherited(arguments);
if (!this.getLocked()) return !this.getSelected() && this.bubble("objectSelected", this), !0;
$(document).on("mousemove", enyo.bind(this, "dragObjectHandler")), $(document).on("mouseup", enyo.bind(this, "upHandler"));
} else e.name == "rightBottom" ? ($(document).on("mousemove", enyo.bind(this, "stretchObjectRightBottom")), $(document).on("mouseup", enyo.bind(this, "upHandler"))) : e.name == "leftBottom" ? (this.ori = this.position_x + this.endP.x, this.oriY = this.position_y + this.endP.y, $(document).on("mousemove", enyo.bind(this, "stretchObjectLeftBottom")), $(document).on("mouseup", enyo.bind(this, "upHandler")), $(document).on("mouseup", enyo.bind(this, "saveDimensions"))) : e.name == "leftTop" ? (this.ori = this.position_x + this.endP.x, this.oriY = this.position_y + this.endP.y, $(document).on("mousemove", enyo.bind(this, "stretchObjectLeftTop")), $(document).on("mouseup", enyo.bind(this, "upHandler")), $(document).on("mouseup", enyo.bind(this, "saveDimensions"))) : e.name == "rightTop" ? (this.ori = this.position_x + this.endP.x, this.oriY = this.position_y + this.endP.y, $(document).on("mousemove", enyo.bind(this, "stretchObjectRightTop")), $(document).on("mouseup", enyo.bind(this, "upHandler")), $(document).on("mouseup", enyo.bind(this, "saveDimensions"))) : e.name == "right" ? (this.ori = this.position_x + this.endP.x, $(document).on("mousemove", enyo.bind(this, "stretchObjectRight")), $(document).on("mouseup", enyo.bind(this, "upHandler")), $(document).on("mouseup", enyo.bind(this, "saveDimensions"))) : e.name == "left" ? (this.ori = this.position_x + this.endP.x, $(document).on("mousemove", enyo.bind(this, "stretchObjectLeft")), $(document).on("mouseup", enyo.bind(this, "upHandler")), $(document).on("mouseup", enyo.bind(this, "saveDimensions"))) : e.name == "top" ? (this.oriY = this.position_y + this.endP.y, $(document).on("mousemove", enyo.bind(this, "stretchObjectTop")), $(document).on("mouseup", enyo.bind(this, "upHandler")), $(document).on("mouseup", enyo.bind(this, "saveDimensions"))) : e.name == "bot" && (this.oriY = this.position_y + this.endP.y, $(document).on("mousemove", enyo.bind(this, "stretchObjectBot")), $(document).on("mouseup", enyo.bind(this, "upHandler")), $(document).on("mouseup", enyo.bind(this, "saveDimensions")));
},
keypressedHandler: function(e, t) {
t.shiftKey && (this.snapShape = !0);
},
handleKeyUp: function(e, t) {
this.snapShape = !1;
},
stretchObjectRightBottom: function(e) {
var t = $(this.parent.node).offset().left, n = $(this.parent.node).offset().top;
this.endP.x = e.clientX - t - this.position_x * window.settings.SCALE, this.endP.y = e.clientY - n - this.position_y * window.settings.SCALE, this.snapShape ? (this.width = math.round(this.endP.x), this.height = this.width) : (this.width = math.round(this.endP.x), this.height = math.round(this.endP.y)), this.redrawEllipse();
},
stretchObjectLeftBottom: function(e) {
var t = $(this.parent.node).offset().left, n = $(this.parent.node).offset().top;
this.position_x = (e.clientX - t) / window.settings.SCALE, this.endP.y = e.clientY - n - this.position_y * window.settings.SCALE, this.snapShape ? (this.width = math.round(this.endP.x + (this.ori - this.position_x - this.endP.x) * window.settings.SCALE), this.height = this.width) : (this.width = math.round(this.endP.x + (this.ori - this.position_x - this.endP.x) * window.settings.SCALE), this.height = math.round(this.endP.y)), this.redrawEllipse();
},
stretchObjectLeftTop: function(e) {
var t = $(this.parent.node).offset().left, n = $(this.parent.node).offset().top;
this.position_x = (e.clientX - t) / window.settings.SCALE, this.position_y = (e.clientY - n) / window.settings.SCALE - window.settings.SCALE, this.snapShape ? (this.height = math.round(this.endP.y + (this.oriY - this.position_y - this.endP.y) * window.settings.SCALE), this.width = this.height) : (this.width = math.round(this.endP.x + (this.ori - this.position_x - this.endP.x) * window.settings.SCALE), this.height = math.round(this.endP.y + (this.oriY - this.position_y - this.endP.y) * window.settings.SCALE)), this.redrawEllipse();
},
stretchObjectRightTop: function(e) {
var t = $(this.parent.node).offset().left, n = $(this.parent.node).offset().top;
this.endP.x = e.clientX - t - this.position_x * window.settings.SCALE, this.position_y = (e.clientY - n) / window.settings.SCALE - window.settings.SCALE, this.snapShape ? (this.height = math.round(this.endP.y + (this.oriY - this.position_y - this.endP.y) * window.settings.SCALE), this.width = this.height) : (this.width = math.round(this.endP.x), this.height = math.round(this.endP.y + (this.oriY - this.position_y - this.endP.y) * window.settings.SCALE)), this.redrawEllipse();
},
stretchObjectRight: function(e) {
var t = $(this.parent.node).offset().left;
this.endP.x = e.clientX - t - this.position_x * window.settings.SCALE, this.width = math.round(this.endP.x), this.height = math.round(this.endP.y), this.redrawEllipse();
},
stretchObjectLeft: function(e) {
var t = $(this.parent.node).offset().left;
this.position_x = (e.clientX - t) / window.settings.SCALE, this.width = math.round(this.endP.x + (this.ori - this.position_x - this.endP.x) * window.settings.SCALE), this.height = math.round(this.endP.y), this.redrawEllipse();
},
stretchObjectTop: function(e) {
var t = $(this.parent.node).offset().top;
this.position_y = (e.clientY - t) / window.settings.SCALE - window.settings.SCALE, this.width = math.round(this.endP.x), this.height = math.round(this.endP.y + (this.oriY - this.position_y - this.endP.y) * window.settings.SCALE), this.redrawEllipse();
},
stretchObjectBot: function(e) {
var t = $(this.parent.node).offset().top;
this.endP.y = e.clientY - t - this.position_y * window.settings.SCALE, this.width = math.round(this.endP.x), this.height = math.round(this.endP.y), this.redrawEllipse();
},
saveDimensions: function() {
this.endP.x = this.calculatedWidth, this.endP.y = this.calculatedHeight, this.width = math.round(this.calculatedWidth / window.settings.SCALE), this.height = math.round(this.calculatedHeight / window.settings.SCALE);
}
});

// Free.js

enyo.kind({
name: "educate.create.components.tekendoos.Free",
kind: "educate.components.tekendoos.Free",
classes: "lines",
attributes: {
xmlns: "http://www.w3.org/2000/svg",
version: "1.1",
preserveAspectRatio: "xMinYMin meet",
viewbox: "0 0 30 30"
},
published: {
width: 500,
height: 300,
position_x: 150,
position_y: 100,
objType: "svg_",
reposition: !1,
tmpX: 0,
tmpY: 0,
beginP: 0,
endP: 0,
lineColor: "#222",
fill: !1,
fillColor: "#222",
opacity: 1,
lineThickness: 5,
lineType: "",
offsetLeft: 0,
offsetTop: 0,
pathPointsA: [],
pathString: ""
},
handlers: {
onPropertiesChanged: "onPropertiesChangedHandler"
},
components: [ {
name: "svg",
tag: "svg",
attributes: {
xmlns: "http://www.w3.org/2000/svg",
preserveAspectRatio: "xMinYMin meet",
viewbox: "0 0 200 200"
},
style: "padding: 5px;"
} ],
create: function() {
this.inherited(arguments), this.setOptions({}), this.addClass("svgParser" + this.getObjectId()), this.calculateDimensions(), this.$.svg.attributes.viewbox = "0 0 " + this.width.toString() + " " + this.height.toString(), this.render();
},
rendered: function() {
this.inherited(arguments), this.reposition || (this.tmpX = (this.beginP.x - Math.abs(this.offsetLeft) - 5).toString(), this.tmpY = (this.beginP.y - Math.abs(this.offsetTop) - 10).toString()), this.addPropertiesToOptions(), this.redrawLine();
},
calculateDimensions: function() {
var e = 99999999, t = 0, n = 99999999, r = 0;
if (this.pathString != "") {
var i = this.pathString.split("/");
for (var s = 0; s < i.length; s++) {
var o = parseInt(i[s].split(",")[0]), u = parseInt(i[s].split(",")[1]);
o < e && (e = o), o > t && (t = o), u < n && (n = u), u > r && (r = u), o - this.beginP.x < 0 && o - this.beginP.x < this.offsetLeft && (this.offsetLeft = o - this.beginP.x), u - this.beginP.y < 0 && u - this.beginP.y < this.offsetTop && (this.offsetTop = u - this.beginP.y);
}
} else for (var s = 0; s < this.pathPointsA.length; s++) this.pathString += this.pathPointsA[s].x + "," + this.pathPointsA[s].y + "/", this.pathPointsA[s].x < e && (e = this.pathPointsA[s].x), this.pathPointsA[s].x > t && (t = this.pathPointsA[s].x), this.pathPointsA[s].y < n && (n = this.pathPointsA[s].y), this.pathPointsA[s].y > r && (r = this.pathPointsA[s].y), this.pathPointsA[s].x - this.beginP.x < 0 && this.pathPointsA[s].x - this.beginP.x < this.offsetLeft && (this.offsetLeft = this.pathPointsA[s].x - this.beginP.x), this.pathPointsA[s].y - this.beginP.y < 0 && this.pathPointsA[s].y - this.beginP.y < this.offsetTop && (this.offsetTop = this.pathPointsA[s].y - this.beginP.y);
this.width = Math.abs(t - e), this.height = Math.abs(r - n);
},
dragObjectHandler: function(e) {
this.tmpX = e.clientX - $(this.parent.hasNode()).offset().left - this.getClickX(), this.tmpY = e.clientY - $(this.parent.hasNode()).offset().top - this.getClickY(), $(".svgParser" + this.getObjectId()).css({
left: this.tmpX,
top: this.tmpY
}), this.addPropertiesToOptions();
},
addPropertiesToOptions: function(e) {
this.addOption("beginP", e == undefined ? this.beginP : e.beginP), this.addOption("endP", e == undefined ? this.endP : e.endP), this.addOption("opacity", e == undefined ? this.opacity : e.opacity), this.addOption("lineColor", e == undefined ? this.lineColor : e.lineColor), this.addOption("lineType", e == undefined ? this.lineType : e.lineType), this.addOption("lineThickness", e == undefined ? this.lineThickness : e.lineThickness), this.addOption("fillColor", e == undefined ? this.fillColor : e.fillColor), this.addOption("fill", e == undefined ? this.fill : e.fill), this.addOption("opacity", e == undefined ? this.opacity : e.opacity), this.addOption("tmpX", e == undefined ? this.tmpX : e.tmpX), this.addOption("tmpY", e == undefined ? this.tmpY : e.tmpY), this.addOption("pathString", e == undefined ? this.pathString : e.pathString);
},
onPropertiesChangedHandler: function(e, t) {
t.linked == this && (this.layername = t.linked.layername, this.value != "" && this.setValue(t.linked.value), this.resizeComponent());
}
});

// Multi.js

enyo.kind({
name: "educate.create.components.tekendoos.Multi",
kind: "educate.components.tekendoos.Multi",
classes: "lines",
attributes: {
xmlns: "http://www.w3.org/2000/svg",
version: "1.1",
viewbox: "0 0 1280 800"
},
published: {
width: 500,
height: 300,
position_x: 150,
position_y: 100,
objType: "svg_",
reposition: !1,
tmpX: 0,
tmpY: 0,
beginP: 0,
endP: 0,
lineColor: "#222",
fill: !1,
fillColor: "#222",
opacity: 1,
lineThickness: 5,
lineType: "",
offsetLeft: 0,
offsetTop: 0,
pathPoints: [],
pathString: ""
},
handlers: {
onPropertiesChanged: "onPropertiesChangedHandler"
},
components: [ {
name: "svg",
tag: "svg",
attributes: {
xmlns: "http://www.w3.org/2000/svg",
preserveAspectRatio: "xMinYMin meet",
viewbox: "0 0 200 200"
},
style: "padding: 5px;"
}, {
tag: "div",
style: "height:10px;width:10px;background-color:blue;position:absolute;bottom:-8px;right:-8px;",
ondown: "downHandler"
} ],
create: function() {
this.inherited(arguments), this.setOptions({}), this.addClass("svgParser" + this.getObjectId()), this.calculateDimensions(), this.$.svg.attributes.viewbox = "0 0 " + this.width.toString() + " " + this.height.toString(), this.render();
},
rendered: function() {
this.inherited(arguments), this.reposition || (this.tmpX = (this.beginP.x - Math.abs(this.offsetLeft) - 5).toString(), this.tmpY = (this.beginP.y - Math.abs(this.offsetTop) - 10).toString()), this.addPropertiesToOptions(), this.redrawMulti();
},
calculateDimensions: function() {
var e = 99999999, t = 0, n = 99999999, r = 0;
if (this.pathString != "") {
var i = this.pathString.split("/");
for (var s = 0; s < i.length; s++) {
var o = parseInt(i[s].split(",")[0]), u = parseInt(i[s].split(",")[1]);
o < e && (e = o), o > t && (t = o), u < n && (n = u), u > r && (r = u), o - this.beginP.x < 0 && o - this.beginP.x < this.offsetLeft && (this.offsetLeft = o - this.beginP.x), u - this.beginP.y < 0 && u - this.beginP.y < this.offsetTop && (this.offsetTop = u - this.beginP.y);
}
} else for (var s = 0; s < this.pathPoints.length; s++) {
var a = parseInt(this.pathPoints[s].split(",")[0]), f = parseInt(this.pathPoints[s].split(",")[1]);
this.pathString += a + "," + f + "/", a < e && (e = a), a > t && (t = a), f < n && (n = f), f > r && (r = f), a - this.beginP.x < 0 && a - this.beginP.x < this.offsetLeft && (this.offsetLeft = a - this.beginP.x), f - this.beginP.y < 0 && f - this.beginP.y < this.offsetTop && (this.offsetTop = f - this.beginP.y);
}
this.width = Math.abs(t - e), this.height = Math.abs(r - n);
},
dragObjectHandler: function(e) {
this.tmpX = e.clientX - $(this.parent.hasNode()).offset().left - this.getClickX(), this.tmpY = e.clientY - $(this.parent.hasNode()).offset().top - this.getClickY(), $(".svgParser" + this.getObjectId()).css({
left: this.tmpX,
top: this.tmpY
}), this.addPropertiesToOptions();
},
addPropertiesToOptions: function(e) {
this.addOption("beginP", e == undefined ? this.beginP : e.beginP), this.addOption("endP", e == undefined ? this.endP : e.endP), this.addOption("opacity", e == undefined ? this.opacity : e.opacity), this.addOption("lineColor", e == undefined ? this.lineColor : e.lineColor), this.addOption("lineType", e == undefined ? this.lineType : e.lineType), this.addOption("lineThickness", e == undefined ? this.lineThickness : e.lineThickness), this.addOption("fillColor", e == undefined ? this.fillColor : e.fillColor), this.addOption("opacity", e == undefined ? this.opacity : e.opacity), this.addOption("tmpX", e == undefined ? this.tmpX : e.tmpX), this.addOption("tmpY", e == undefined ? this.tmpY : e.tmpY), this.addOption("pathString", e == undefined ? this.pathString : e.pathString);
},
onPropertiesChangedHandler: function(e, t) {
t.linked == this && (this.layername = t.linked.layername, this.value != "" && this.setValue(t.linked.value), this.resizeComponent());
},
downHandler: function(e, t) {
if (e.tag == "svg") {
this.inherited(arguments);
if (!this.getLocked()) return !this.getSelected() && this.bubble("objectSelected", this), !0;
$(document).on("mousemove", enyo.bind(this, "dragObjectHandler")), $(document).on("mouseup", enyo.bind(this, "upHandler"));
} else $(document).on("mousemove", enyo.bind(this, "stretchObject")), $(document).on("mouseup", enyo.bind(this, "upHandler"));
},
stretchObject: function(e) {
var t = $(this.parent.node).offset().left, n = $(this.parent.node).offset().top;
this.endP.x = (e.clientX - t) / window.settings.SCALE, this.endP.y = e.clientY - n, this.width = Math.abs(this.endP.x - this.beginP.x) / window.settings.SCALE, this.height = Math.abs(this.endP.y - this.beginP.y), this.redrawMulti("stretch");
}
});

// Meetlat.js

enyo.kind({
name: "educate.create.components.meetlat.Meetlat",
kind: "educate.components.meetlat.Meetlat",
published: {
width: 0,
height: 70,
position_x: 150,
position_y: 100,
rotation_z: "0",
rotation_x: "0",
rotation_y: "0",
objType: "div_",
stretch: 0,
rotateN: 0,
originalWidth: 0,
lengte: 10,
originalLength: 0,
unit: "",
divide: 10,
cmPerPixel: .025,
pixelPerCm: 40
},
handlers: {
onPropertiesChanged: "onPropertiesChangedHandler"
},
components: [ {
tag: "ul",
name: "ruler",
classes: "ruler"
}, {
tag: "p",
name: "unit"
} ],
create: function() {
this.inherited(arguments), this.width = (this.unit == "cm" ? this.lengte : this.lengte / 10) * this.pixelPerCm + this.pixelPerCm - 20, this.originalWidth = this.width, this.originalLength = this.lengte, this.render(), this.redrawRuler();
},
rendered: function() {
this.inherited(arguments);
},
visibleChanged: function() {
this.applyStyle("opacity", this.getVisible() !== !1 ? this.getAlpha() : .25), this.addOption("visible", this.getVisible());
},
addPropertiesToOptions: function() {
this.addOption("lengte", this.lengte), this.addOption("unit", this.unit), this.addOption("divide", this.divide);
},
onPropertiesChangedHandler: function(e, t) {
t.linked == this && (this.layername = t.linked.layername, this.value != "" && this.setValue(t.linked.value), this.resizeComponent());
}
});

// PickAndPlaceWords.js

enyo.kind({
name: "educate.create.components.pickAndPlace.PickAndPlaceWords",
kind: "educate.components.pickAndPlace.pickAndPlaceWords.PickAndPlaceWords",
published: {
position_x: 0,
position_y: 0,
objType: "ppw_"
},
components: [ {
kind: "educate.components.pickAndPlace.PickAndPlaceSvg",
name: "pickAndPlaceSvg"
}, {
kind: "educate.create.components.pickAndPlace.PickAndPlaceMenuWords",
name: "pickAndPlaceMenu"
} ],
handlers: {
onPropertiesChanged: "onPropertiesChangedHandler",
onModusChanged: "onModusChangedHandler"
},
create: function() {
this.inherited(arguments), this.redrawPickAndPlace();
},
rendered: function() {
this.inherited(arguments);
},
optionsChanged: function() {
this.inherited(arguments), this.setModus(this.options.modus != undefined ? this.options.modus : this.getHighlightZone() ? "test" : "practise");
},
alphaZonesChanged: function() {
this.inherited(arguments), this.$.pickAndPlaceSvg.setMultipleZonesAlpha(this.getAlphaZones(), this.getOriginalDropZoneList());
},
onPropertiesChangedHandler: function(e, t) {
t.linked == this && (this.layername = t.linked.layername, this.resizeComponent());
},
onModusChangedHandler: function(e, t) {
this.getDisabledModus()[t.modus] = !this.getDisabledModus()[t.modus], this.disabledModusChanged(), this.handleDisabledQuizTypes();
},
disabledModusChanged: function() {
this.options || (this.options = {}), this.options.disabledModus = {
practise: this.getDisabledModus().practise,
test: this.getDisabledModus().test,
quiz: this.getDisabledModus().quiz
};
}
});

// PickAndPlaceImages.js

enyo.kind({
name: "educate.create.components.pickAndPlace.PickAndPlaceImages",
kind: "educate.components.pickAndPlace.pickAndPlaceImages.PickAndPlaceImages",
published: {
objType: "ppi_"
},
components: [ {
kind: "educate.components.pickAndPlace.PickAndPlaceSvg",
name: "pickAndPlaceSvg"
}, {
kind: "educate.create.components.pickAndPlace.PickAndPlaceMenuImages",
name: "pickAndPlaceMenu"
} ],
handlers: {
onPropertiesChanged: "onPropertiesChangedHandler",
onSvgImagesLoaded: "onSvgImagesLoadedHandler",
onModusChanged: "onModusChangedHandler"
},
create: function() {
this.inherited(arguments), this.redrawPickAndPlace();
},
rendered: function() {
this.inherited(arguments);
},
optionsChanged: function() {
this.inherited(arguments), this.setModus(this.options.modus != undefined ? this.options.modus : this.getHighlightZone() ? "test" : "practise");
},
alphaZonesChanged: function() {
this.inherited(arguments), this.$.pickAndPlaceSvg.setMultipleZonesAlpha(this.getAlphaZones(), this.getOriginalDropZoneList());
},
onPropertiesChangedHandler: function(e, t) {
t.linked == this && (this.layername = t.linked.layername, this.resizeComponent());
},
onSvgImagesLoadedHandler: function(e, t) {
this.originalDropZoneListChanged();
},
onModusChangedHandler: function(e, t) {
this.getDisabledModus()[t.modus] = !this.getDisabledModus()[t.modus], this.disabledModusChanged(), this.handleDisabledQuizTypes();
},
disabledModusChanged: function() {
this.options || (this.options = {}), this.options.disabledModus = {
practise: this.getDisabledModus().practise,
test: this.getDisabledModus().test,
quiz: this.getDisabledModus().quiz
};
}
});

// PickAndPlaceMenuWords.js

enyo.kind({
name: "educate.create.components.pickAndPlace.PickAndPlaceMenuWords",
kind: "educate.components.pickAndPlace.pickAndPlaceWords.PickAndPlaceMenuWords",
published: {},
handlers: {},
create: function() {
this.inherited(arguments);
},
rendered: function() {
this.inherited(arguments);
},
disabledQuizType: function(e, t) {
this.$[e].addRemoveClass("disabled", t);
},
updatePickList: function(e) {
this.inherited(arguments);
var t = e.length, n = [];
for (var r = 0; r < t; r++) e[r].zoneType === "laag" && n.push({
kind: "educate.create.components.pickAndPlace.PickItemWord",
container: this.$.pickList,
linkedZone: e[r]
});
this.createComponents(n), this.$.pickList.render();
}
});

// PickAndPlaceMenuImages.js

enyo.kind({
name: "educate.create.components.pickAndPlace.PickAndPlaceMenuImages",
kind: "educate.components.pickAndPlace.pickAndPlaceImages.PickAndPlaceMenuImages",
published: {},
handlers: {},
create: function() {
this.inherited(arguments), this.render();
},
rendered: function() {
this.inherited(arguments);
},
disabledQuizType: function(e, t) {
this.$[e].addRemoveClass("disabled", t);
},
updatePickList: function(e) {
this.inherited(arguments);
var t = e.length, n = [];
for (var r = 0; r < t; r++) e[r].zoneType === "laag" && n.push({
kind: "educate.create.components.pickAndPlace.PickItemImage",
container: this.$.pickList,
linkedZone: e[r],
linkedZoneNode: this.parent.$.pickAndPlaceSvg.getZoneByZoneId(e[r].zoneId)
});
this.createComponents(n), this.$.pickList.render();
}
});

// PickItemImage.js

enyo.kind({
name: "educate.create.components.pickAndPlace.PickItemImage",
kind: "educate.components.pickAndPlace.pickAndPlaceImages.PickItemImage",
components: [ {
tag: "i",
name: "pickItemCheck",
ontap: "pickItemCheckTapped"
}, {
tag: "svg",
name: "pickItemSvg",
allowHtml: !0,
style: "width:151px; height:93px;",
attributes: {
width: "151px",
height: "93px",
viewBox: "0 0 1210 745",
xmlns: "http://www.w3.org/2000/svg",
"xmlns:xlink": "http://www.w3.org/1999/xlink"
}
} ],
events: {
onPickItemCheckTapped: ""
},
create: function() {
this.inherited(arguments), this.getLinkedZone().isZoneActief ? this.$.pickItemCheck.addClass("icon-check") : (this.$.pickItemCheck.addClass("icon-check-empty"), this.addClass("pick-item-deactive")), this.getLinkedZoneNode() && this.linkedZoneNodeChanged();
},
rendered: function() {
this.inherited(arguments);
},
pickItemCheckTapped: function(e, t) {
this.doPickItemCheckTapped({
zone: t.originator.parent.linkedZone
});
}
});

// PickItemWord.js

enyo.kind({
name: "educate.create.components.pickAndPlace.PickItemWord",
kind: "educate.components.pickAndPlace.pickAndPlaceWords.PickItemWord",
components: [ {
tag: "i",
name: "pickItemCheck",
ontap: "pickItemCheckTapped"
}, {
tag: "p",
name: "pickItemLabel",
ontap: "pickItemLabelTapped"
}, {
kind: "enyo.Input",
name: "pickItemInput",
onblur: "pickItemLabelChanged",
onchange: "pickItemLabelChanged",
value: ""
} ],
events: {
onPickItemCheckTapped: "",
onPickItemLabelTapped: ""
},
create: function() {
this.inherited(arguments), this.getLinkedZone().isZoneActief ? this.$.pickItemCheck.addClass("icon-check") : (this.$.pickItemCheck.addClass("icon-check-empty"), this.addClass("pick-item-deactive")), this.$.pickItemLabel.setContent(this.getLinkedZone().zoneLabel), this.$.pickItemInput.setValue(this.getLinkedZone().zoneLabel);
},
rendered: function() {
this.inherited(arguments);
},
pickItemCheckTapped: function(e, t) {
this.doPickItemCheckTapped({
zone: t.originator.parent.linkedZone
});
},
pickItemLabelTapped: function(e, t) {
this.setPickItemEditable(e, !e.getShowing());
},
pickItemLabelChanged: function(e, t) {
this.setPickItemEditable(e, !e.getShowing()), this.doPickItemLabelTapped({
zone: t.originator.parent.linkedZone,
label: t.originator.getValue()
});
},
setPickItemEditable: function(e, t) {
e.hasNode().style.display = t ? "inline-block" : "none", e.tag === "p" ? e.hasNode().nextSibling.style.display = t ? "none" : "inline-block" : e.tag === "input" && (e.hasNode().previousSibling.style.display = t ? "none" : "inline-block");
}
});

// zoomImage.js

enyo.kind({
name: "educate.create.components.zoomImage.ZoomImage",
kind: "educate.components.zoomImage.ZoomImage",
published: {
width: 500,
height: 300,
position_x: 150,
position_y: 100,
objType: "img_",
zoomSteps: []
},
handlers: {
ontap: "ontapHandler",
onPropertiesChanged: "onPropertiesChangedHandler"
},
create: function() {
this.inherited(arguments), this.setValue("svnAssets/imagetemplate.png"), this.addOption("zoomSteps", this.zoomSteps), this.redrawImage();
},
visibleChanged: function() {
this.applyStyle("opacity", this.getVisible() !== !1 ? this.getAlpha() : .25), this.addOption("visible", this.getVisible());
},
widthChanged: function() {
this.redrawImage();
},
heightChanged: function() {
this.redrawImage();
},
bAchtergrondChanged: function(e) {
this.setLocked(this.getBAchtergrond()), this.getBAchtergrond() ? this.deselectObject() : this.selectObject(), this.addOption("background", this.getBAchtergrond()), this.addRemoveClass("background", this.getBAchtergrond()), this.setPosition_x(this.getBAchtergrond() ? 0 : this.getPosition_x()), this.setPosition_y(this.getBAchtergrond() ? 0 : this.getPosition_y()), this.setWidth(this.getBAchtergrond() ? window.settings.STAGEWIDTH : this.getWidth()), this.setHeight(this.getBAchtergrond() ? window.settings.STAGEHEIGHT : this.getHeight()), this.bubble("objectLockChange", this);
},
onPropertiesChangedHandler: function(e, t) {
t.linked == this && (this.layername = t.linked.layername, this.value != "" && this.setValue(t.linked.value), this.resizeComponent());
}
});

// KolomWoorden.js

enyo.kind({
name: "educate.create.components.kolomOefening.KolomWoorden",
kind: "educate.components.kolomOefening.KolomWoorden",
published: {
width: 1200,
height: 730,
position_x: 0,
position_y: 0,
objType: "div_",
words: [],
columns: 3,
splitCols: "{}",
titles: [ "Titel", "Titel", "Titel", "Voeg een vraag in" ],
maxWords: 40
},
classes: "kolomOefening",
handlers: {
onPropertiesChanged: "onPropertiesChangedHandler",
ondown: "downHandler"
},
components: [ {
tag: "div",
name: "placeColumns",
classes: "placeColumns"
}, {
tag: "div",
name: "pickColumn",
classes: "wordColumn picker",
components: [ {
tag: "img",
name: "pp_icon",
classes: "smallImg",
src: ""
}, {
tag: "div",
name: "quizTypes",
classes: "columnQuestion",
components: [ {
kind: enyo.Input,
name: "quiz",
value: "",
type: "text",
onchange: "changeColumnQuestion",
classes: "enyo-input questionInput"
} ]
}, {
tag: "ul",
name: "wordList",
classes: "wordList"
} ]
} ],
create: function() {
this.inherited(arguments), this.addPropertiesToOptions(), this.drawPlaceColumns(), this.drawSplitColumns(), this.$.quiz.attributes.value = this.titles[this.titles.length - 1], this.redrawPicker("create");
},
rendered: function() {
this.inherited(arguments);
},
drawPlaceColumns: function() {
this.titles = this.options.titles, this.columns = this.options.columns, this.maxWords = this.options.maxWords, this.$.placeColumns.destroyClientControls();
var e = 1, t = e * (this.columns - 1), n = (100 - t) / this.columns;
for (var r = 0; r < this.columns; r++) this.$.placeColumns.createComponent({
tag: "div",
name: "pickColumn_" + r,
style: "width:" + n + "%;top:0%;left:" + r * (n + e) + "%;",
classes: "picker",
components: [ {
tag: "div",
name: "quizTypes" + r,
classes: "quizTypes",
components: [ {
kind: enyo.Input,
name: "title_" + r,
value: this.titles[r],
type: "text",
onchange: "changeColumnTitle",
classes: "enyo-input titleInput"
}, {
tag: "i",
name: "split_" + r,
classes: "fill-icon icon-delete",
ontap: "splitColumns"
} ]
}, {
tag: "div",
name: "words_" + r,
classes: "wordList",
components: [ {
kind: enyo.Input,
name: "input_" + r,
value: "",
type: "text",
onchange: "addWordToList",
classes: "enyo-input pickInput"
}, {
tag: "div",
name: "wordList_" + r,
style: "-moz-column-count: 3;-moz-column-gap: 20px;-webkit-column-count: 3;-webkit-column-gap: 20px;"
}, {
kind: enyo.Button,
classes: "btn deleteAllWords",
name: "btn_" + r,
ontap: "deleteAllWords",
components: [ {
tag: "i",
name: "icon_" + r,
classes: "icon-trash"
} ]
} ]
} ]
}, {
owner: this
});
for (var i = 0; i < this.words.length; i++) if (this.words[i] != null) {
var s = this.words[i].split(";");
for (var o = 0; o < s.length; o++) this.$["wordList_" + i].createComponent({
tag: "p",
content: s[o],
onclick: "deleteWordFromList",
name: s[o] + "_" + i
}, {
owner: this
});
}
this.$.placeColumns.render();
},
drawSplitColumns: function() {
var e = JSON.parse(this.splitCols), t = 1, n, r, i, s, o, u;
for (var u in e) {
i = e[u].column, s = this.$["pickColumn_" + i], o = s.children.length, u = i;
for (var a = 0; a < o; a++) s.children[a] && s.children[a].name != "quizTypes" + u && (s.children[a].destroy(), a--);
o = e[u].splits, t = 1, n = t * (o - 1), r = (100 - n) / o;
for (var f = 0; f < o; f++) s.createComponent({
tag: "div",
name: "pickColumn_" + u + "/" + f,
style: "width:" + r + "%;left:" + f * (r + t) + "%;",
classes: "splitPicker",
components: [ {
tag: "div",
name: "quizTypes" + u + "/" + f,
classes: "quizTypes",
components: [ {
kind: enyo.Input,
name: "title_" + u + "/" + f,
value: e[u].titles[f],
type: "text",
onchange: "changeSplitColumnTitle",
classes: "enyo-input titleInput"
} ]
}, {
tag: "div",
name: "words_" + u + "/" + f,
classes: "wordList",
components: [ {
kind: enyo.Input,
name: "input_" + u + "/" + f,
value: "",
type: "text",
onchange: "addWordToList",
classes: "enyo-input pickInput"
}, {
tag: "div",
name: "wordList_" + u + "/" + f,
style: "-moz-column-count: 3;-moz-column-gap: 20px;-webkit-column-count: 3;-webkit-column-gap: 20px;"
}, {
kind: enyo.Button,
classes: "btn deleteAllWords",
name: "btn_" + u + "/" + f,
ontap: "deleteAllWords",
components: [ {
tag: "i",
name: "icon_" + u + "/" + f,
classes: "icon-trash"
} ]
} ]
} ]
}, {
owner: this
});
for (f = 0; f < e[u].words.length; f++) if (e[u].words[f] != null) {
var l = e[u].words[f].split(";");
for (var c = 0; c < l.length; c++) this.$["wordList_" + u + "/" + f].createComponent({
tag: "p",
content: l[c],
onclick: "deleteWordFromList",
name: l[c] + "_" + +u + "/" + f
}, {
owner: this
});
}
s.render();
}
},
deleteAllWords: function(e, t) {
var n = e.name.split("_")[1], r = this.words[n].split(";");
for (var i = 0; i < r.length; i++) this.$[r[i] + "_" + n].destroy();
this.words[n] = "", this.addPropertiesToOptions();
},
splitColumns: function(e, t) {
var n = 1, r = n * 1, i = (100 - r) / 2, s = e.name.split("_")[1], o, u, a;
if (this.$["wordList_" + s]) o = this.$["wordList_" + s].parent.parent, a = s, u = 2, this.$["wordList_" + s].parent.destroy(); else {
o = this.$["pickColumn_" + s], u = o.children.length, a = s;
for (var f = 0; f < u; f++) o.children[f] && o.children[f].name != "quizTypes" + a && (o.children[f].destroy(), f--);
n = 1, r = n * (u - 1), i = (100 - r) / u;
}
var l = [], c = [], h = JSON.parse(this.splitCols);
for (var p = 0; p < u; p++) {
l[p] = h[s] == undefined ? "Titel" : h[s].titles[p] == undefined ? "Titel" : h[s].titles[p], o.createComponent({
tag: "div",
name: "pickColumn_" + a + "/" + p,
style: "width:" + i + "%;left:" + p * (i + n) + "%;",
classes: "splitPicker",
components: [ {
tag: "div",
name: "quizTypes" + a + "/" + p,
classes: "quizTypes",
components: [ {
kind: enyo.Input,
name: "title_" + a + "/" + p,
value: l[p],
type: "text",
onchange: "changeSplitColumnTitle",
classes: "enyo-input titleInput"
} ]
}, {
tag: "div",
name: "words_" + a + "/" + p,
classes: "wordList",
components: [ {
kind: enyo.Input,
name: "input_" + a + "/" + p,
value: "",
type: "text",
onchange: "addWordToList",
classes: "enyo-input pickInput"
}, {
tag: "div",
name: "wordList_" + a + "/" + p,
style: "-moz-column-count: 3;-moz-column-gap: 20px;-webkit-column-count: 3;-webkit-column-gap: 20px;"
}, {
kind: enyo.Button,
classes: "btn deleteAllWords",
name: "btn_" + a + "/" + p,
ontap: "deleteAllWords",
components: [ {
tag: "i",
name: "icon_" + a + "/" + p,
classes: "icon-trash"
} ]
} ]
} ]
}, {
owner: this
}), c[p] = h[s] == undefined ? "" : h[s].words[p] == undefined ? "" : h[s].words[p];
var d = c[p].split(";");
for (var v = 0; v < d.length; v++) this.$["wordList_" + a + "/" + p].createComponent({
tag: "p",
content: d[v],
onclick: "deleteWordFromList",
name: d[v] + "_" + +a + "/" + p
}, {
owner: this
});
}
var m = {
column: s,
splits: u,
titles: l,
words: c
};
h[s] = m, this.splitCols = JSON.stringify(h), o.render(), this.addPropertiesToOptions(), this.resizeComponent();
},
changeColumnTitle: function(e, t) {
var n = e.name.split("_")[1];
this.titles[n] = e.node.value, this.addPropertiesToOptions();
},
changeSplitColumnTitle: function(e, t) {
var n = e.name.split("_")[1].split("/"), r = n[0], i = n[1], s = JSON.parse(this.splitCols);
s[r].titles[i] = e.node.value, this.splitCols = JSON.stringify(s), this.addPropertiesToOptions();
},
changeColumnQuestion: function(e, t) {
this.titles[this.titles.length - 1] = e.node.value, this.addPropertiesToOptions();
},
addWordToList: function(e, t) {
var n = e.name.split("_")[1], r = n.split("/")[1], i = e.node.value;
i.indexOf(";") === -1 ? this.addSingleWord(n, i, e, r != undefined) : this.addWordString(n, i, e, r != undefined);
},
addSingleWord: function(e, t, n, r) {
this.$["wordList_" + e].createComponent({
tag: "p",
content: t,
onclick: "deleteWordFromList",
name: t + "_" + e
}, {
owner: this
}), this.$["wordList_" + e].render();
if (r) {
var i = JSON.parse(this.splitCols), s = i[e.split("/")[0]].words[e.split("/")[1]];
i[e.split("/")[0]].words[e.split("/")[1]] = s == undefined ? t + ";" : s + t + ";", this.splitCols = JSON.stringify(i);
} else this.words[e] = this.words[e] == undefined ? t + ";" : this.words[e] + t + ";";
n.node.value = "", this.addPropertiesToOptions();
},
addWordString: function(e, t, n, r) {
var i = t.split(";");
for (var s = 0; s < i.length; s++) this.addSingleWord(e, i[s], n, r);
},
deleteWordFromList: function(e, t) {
var n = e.name.split("_")[1], r = n.split("/")[1], i = e.content + ";";
if (r) {
var s = JSON.parse(this.splitCols), o = s[n.split("/")[0]].words[n.split("/")[1]];
s[n.split("/")[0]].words[n.split("/")[1]] = o.replace(i, ""), this.splitCols = JSON.stringify(s);
} else this.words[n] = this.words[n].replace(i, "");
this.$[e.name].destroy(), this.addPropertiesToOptions();
},
downHandler: function(e, t) {},
addPropertiesToOptions: function() {
this.addOption("columns", this.columns), this.addOption("words", this.words), this.addOption("titles", this.titles), this.addOption("maxWords", this.maxWords), this.addOption("splitCols", this.splitCols);
}
});

// KolomAfbeeldingen.js

enyo.kind({
name: "educate.create.components.kolomOefening.KolomAfbeeldingen",
kind: "educate.components.kolomOefening.KolomAfbeeldingen",
published: {
width: 1200,
height: 730,
position_x: 0,
position_y: 0,
objType: "div_",
images: [],
columns: 2,
titles: [ "Titel", "Titel", "Titel", "Voeg een vraag in" ],
maxImages: 12,
selectedColumn: 0
},
style: "position: absolute;",
handlers: {
onPropertiesChanged: "onPropertiesChangedHandler",
ondown: "downHandler",
setImageToColumn: "setImageToColumnHandler"
},
components: [ {
tag: "div",
name: "placeColumns"
}, {
tag: "div",
name: "pickColumn",
style: "width:100%;height:40%;top:60%;",
classes: "picker",
components: [ {
tag: "img",
name: "pp_icon",
classes: "smallImg",
src: ""
}, {
tag: "div",
name: "quizTypes",
classes: "columnQuestion",
components: [ {
kind: enyo.Input,
name: "quiz",
value: "",
type: "text",
onchange: "changeColumnQuestion",
classes: "enyo-input questionInput"
} ]
}, {
tag: "ul",
name: "wordList",
classes: "wordList"
} ]
} ],
create: function() {
this.inherited(arguments), this.addPropertiesToOptions(), this.drawPlaceColumns(), this.$.quiz.attributes.value = this.titles[this.titles.length - 1], this.redrawPicker("create");
},
rendered: function() {
this.inherited(arguments);
},
drawPlaceColumns: function() {
this.titles = this.options.titles, this.columns = this.options.columns, this.$.placeColumns.destroyClientControls();
for (var e = 0; e < this.columns; e++) this.$.placeColumns.createComponent({
tag: "div",
name: "pickColumn_" + e,
style: "width:" + 96 / this.columns + "%;height:58%;top:0%;left:" + e * (101 / this.columns) + "%;",
classes: "picker",
components: [ {
tag: "div",
name: "quizTypes" + e,
classes: "quizTypes",
components: [ {
kind: enyo.Input,
name: "title_" + e,
value: this.titles[e],
type: "text",
onchange: "changeColumnTitle",
classes: "enyo-input titleInput"
} ]
}, {
tag: "div",
name: "words_" + e,
classes: "wordList",
components: [ {
kind: "enyo.Button",
classes: "btn btn-block",
name: "browseImageAsset_" + e,
ontap: "browseFoto",
content: "kies afbeelding",
style: "width:98%;"
}, {
tag: "div",
name: "wordList_" + e
}, {
kind: enyo.Button,
classes: "btn deleteAllWords",
name: "btn_" + e,
ontap: "deleteAllImages",
components: [ {
tag: "i",
name: "icon_" + e,
classes: "icon-trash"
} ]
} ]
} ]
}, {
owner: this
});
for (var t = 0; t < this.images.length; t++) if (this.images[t] != null) {
var n = this.images[t].split(";");
for (var r = 0; r < n.length - 1; r++) this.$["wordList_" + t].createComponent({
tag: "img",
classes: "dragImage",
style: "position: relative;width: 60%;margin: 0 auto;display: block;margin-top: 10px;",
src: Settings.WEBAPP + "/" + n[r],
onclick: "deleteImageFromList",
name: n[r] + "@" + t
}, {
owner: this
});
}
this.$.placeColumns.render();
},
browseFoto: function(e, t) {
this.selectedColumn = e.name.split("_")[1], this.generateLibraryPopup("Foto");
},
generateLibraryPopup: function(e) {
this.$.library && this.$.library.destroy(), this.createComponent({
name: "library",
kind: "educate.create.Assets",
viewId: this.getViewId(),
searchType: e
}), this.$.library.show();
},
setImageToColumnHandler: function(e, t) {
this.addImageToList(t.image.selectedAsset, this.selectedColumn);
},
changeColumnTitle: function(e, t) {
var n = e.name.split("_")[1];
this.titles[n] = e.node.value, this.addPropertiesToOptions();
},
changeColumnQuestion: function(e, t) {
this.titles[this.titles.length - 1] = e.node.value, this.addPropertiesToOptions();
},
addImageToList: function(e, t) {
if (this.$["wordList_" + t].children.length < 2) {
var n = e.value;
this.$["wordList_" + t].createComponent({
tag: "img",
classes: "dragImage",
style: "position: relative;width: 60%;margin: 0 auto;display: block;margin-top: 10px;",
src: Settings.WEBAPP + "/" + n,
onclick: "deleteImageFromList",
name: n + "@" + t
}, {
owner: this
}), this.$["wordList_" + t].render(), this.images[t] = this.images[t] == undefined ? n + ";" : this.images[t] + n + ";", this.addPropertiesToOptions();
}
},
deleteImageFromList: function(e, t) {
var n = e.name.split("@")[1], r = e.name.split("@")[0] + ";";
this.images[n] = this.images[n].replace(r, ""), this.$[e.name].destroy(), this.addPropertiesToOptions();
},
deleteAllImages: function(e, t) {
var n = e.name.split("_")[1], r = this.images[n].split(";");
for (var i = 0; i < r.length - 1; i++) this.$[r[i] + "@" + n].destroy();
this.images[n] = "", this.addPropertiesToOptions();
},
downHandler: function(e, t) {},
addPropertiesToOptions: function() {
this.addOption("columns", this.columns), this.addOption("images", this.images), this.addOption("titles", this.titles);
}
});

// ColumnExercise.js

enyo.kind({
name: "educate.create.components.columnExercise.ColumnExercise",
kind: "educate.components.columnExercise.ColumnExercise",
components: [ {
kind: "educate.create.components.columnExercise.ColumnHolder",
name: "columns",
columns: this.columns
}, {
kind: "educate.create.components.columnExercise.OptionContainer",
name: "options",
options: this.optionList
} ]
});

// ColumnHolder.js

enyo.kind({
name: "educate.create.components.columnExercise.ColumnHolder",
kind: "educate.components.columnExercise.ColumnHolder",
columnsChanged: function() {
this.inherited(arguments), this.destroyComponents();
var e, t = this.getColumns().length, n = [];
for (e = 0; e < t; e++) {
var r = this.getColumns()[e];
n.push({
kind: "educate.create.components.columnExercise.Column",
name: "column_" + e,
header: r.header,
options: r.options,
contents: r.contents,
groupedBy: r.groupedBy
});
}
this.createComponents(n);
}
});

// OptionContainer.js

enyo.kind({
name: "educate.create.components.columnExercise.OptionContainer",
kind: "educate.components.columnExercise.OptionContainer",
components: [ {
name: "header",
classes: "column-header",
components: [ {
kind: "enyo.Input",
name: "headerInput",
classes: "column-header-input",
onchange: "onHeaderChangeHandler",
value: this.header
} ]
}, {
name: "container",
classes: "column-content"
} ],
headerChanged: function() {
this.$.headerInput.setValue(this.header);
},
onHeaderChangeHandler: function() {
this.setHeader(this.$.headerInput.getValue());
}
});

// Column.js

enyo.kind({
name: "educate.create.components.columnExercise.Column",
kind: "educate.components.columnExercise.Column",
components: [ {
name: "header",
classes: "column-header",
components: [ {
kind: "enyo.Input",
name: "headerInput",
classes: "column-header-input",
onchange: "onHeaderChangeHandler",
value: this.header
} ]
}, {
name: "container",
classes: "column-content"
} ],
headerChanged: function() {
this.$.headerInput.setValue(this.header);
},
onHeaderChangeHandler: function() {
this.setHeader(this.$.headerInput.getValue());
}
});

// AddOption.js

enyo.kind({
name: "educate.create.components.columnExercise.AddOption",
kind: enyo.Control
});

// Option.js

enyo.kind({
name: "educate.create.components.columnExercise.Option",
kind: enyo.Control
});

// words/ColumnExercise.js

enyo.kind({
name: "educate.create.components.columnExercise.ColumnExerciseWords",
kind: "educate.create.components.columnExercise.ColumnExercise",
components: [ {
kind: "educate.create.components.columnExercise.ColumnHolderWords",
name: "columns",
columns: this.columns,
onchange: "onColumnsChangeHandler",
viewId: this.viewId
}, {
kind: "educate.create.components.columnExercise.OptionContainerWords",
name: "options",
options: this.optionList,
onchange: "onOptionContainerWordsChangeHandler",
viewId: this.viewId
} ],
create: function() {
this.inherited(arguments);
},
onColumnsChangeHandler: function(e, t) {
var n = [], r, i = this.getColumns().length;
for (r = 0; r < i; r++) n = n.concat(this.getColumns()[r].options || []);
return this.setOptionList(n), !0;
},
optionListChange: function() {
this.inherited(arguments), this.$.options.setOption(this.getOptionList());
},
onOptionContainerWordsChangeHandler: function() {
this.options.optionListHeader = this.$.options.getHeader();
}
});

// words/ColumnHolder.js

enyo.kind({
name: "educate.create.components.columnExercise.ColumnHolderWords",
kind: "educate.create.components.columnExercise.ColumnHolder",
events: {
onColumnsChanged: "onColumnsChanged"
},
handlers: {
onchange: "onchangeHandler"
},
columnsChanged: function() {
this.inherited(arguments), this.destroyComponents(), this.destroyClientControls();
var e, t = this.getColumns().length, n = [];
for (e = 0; e < t; e++) {
var r = this.getColumns()[e];
n.push({
kind: "educate.create.components.columnExercise.ColumnWords",
name: "column_" + e,
header: r.header,
options: r.options,
contents: r.contents,
groupedBy: r.groupedBy,
viewId: this.viewId
});
}
this.createComponents(n), this.bubble("onColumnsChanged");
},
onchangeHandler: function(e, t) {
var n = t.originator.getName().split("_")[1], r = this.getColumns()[n];
if (typeof r == "undefined") return;
r.header = t.originator.header, r.options = t.originator.options, r.contents = t.originator.contents, r.groupedBy = t.originator.groupedBy, this.bubble("onColumnsChanged");
},
addColumn: function(e) {
var t = {
header: "Klik om aan te passen.",
options: [],
contents: [],
groupedBy: e.groupedBy
}, n = parseInt(e.getName().split("_")[1]) + 1, r = this.getColumns().concat([]);
r.splice(n, 0, t), this.setColumns(r);
},
removeColumn: function(e) {
var t = parseInt(e.getName().split("_")[1]), n = this.getColumns().concat([]);
n.splice(t, 1), n.length === 0 && n.push({
header: "Klik om aan te passen.",
options: [],
contents: [],
groupedBy: null
}), this.setColumns(n);
}
});

// words/OptionContainer.js

enyo.kind({
name: "educate.create.components.columnExercise.OptionContainerWords",
kind: "educate.create.components.columnExercise.OptionContainer"
});

// words/Column.js

enyo.kind({
name: "educate.create.components.columnExercise.ColumnWords",
kind: "educate.create.components.columnExercise.Column",
components: [ {
name: "header",
classes: "column-header",
components: [ {
kind: "enyo.Button",
name: "btnRemoveColumn",
classes: "btn btn-default btn-remove",
allowHtml: !0,
content: '<i class="icon-trash"></i>',
ontap: "removeColumnHandler"
}, {
kind: "enyo.Input",
name: "groupedByInput",
classes: "column-header-input",
onchange: "onGroupedByChangeHandler",
value: this.groupedBy
}, {
kind: "enyo.Input",
name: "headerInput",
classes: "column-header-input",
onchange: "onHeaderChangeHandler",
value: this.header
}, {
kind: "enyo.Button",
name: "btnAddColumn",
classes: "btn btn-default btn-add",
allowHtml: !0,
content: '<i class="icon-plus-sign"></i>',
ontap: "addColumnHandler"
} ]
}, {
kind: "educate.create.components.columnExercise.AddOptionWord",
name: "columnInput",
classes: "column-add-option",
onchange: "addOption",
viewId: this.viewId
}, {
name: "container",
classes: "column-content"
} ],
create: function() {
this.inherited(arguments), this.headerChanged(), this.groupedByChanged();
},
rendered: function() {
this.inherited(arguments), this.optionsChanged(), this.$.groupedByInput.setValue(this.getGroupedBy());
},
headerChanged: function() {
this.$.headerInput.setValue(this.getHeader()), this.bubble("onchange");
},
groupedByChanged: function(e) {
this.inherited(arguments), this.render();
},
onHeaderChangeHandler: function() {
this.setHeader(this.$.headerInput.getValue());
},
onGroupedByChangeHandler: function() {
var e = this.$.groupedByInput.getValue().trim();
e = e !== "" ? e : null, this.setGroupedBy(e);
},
addOption: function(e, t) {
Array.isArray(this.getOptions()) || this.setOptions([]);
var n = t.option.split(/\s*[;,]\s*/), r = this.getOptions().concat(n);
this.setOptions(r);
},
optionsChanged: function() {
this.$.container.destroyComponents(), this.$.container.destroyClientControls();
var e = this.getOptions(), t, n = e.length, r = [], i;
for (t = 0; t < n; t++) i = e[t], r.push({
kind: "educate.create.components.columnExercise.OptionWord",
name: "word_" + t,
option: i,
parentElement: this
});
this.$.container.createComponents(r, {
owner: this
}), this.$.columnInput.setOption(""), this.$.container.render(), this.bubble("onchange");
},
removeOption: function(e) {
var t = this.getOptions().concat([]), n = e.getName().split("_")[1];
t.splice(n, 1), this.setOptions(t);
},
addColumnHandler: function() {
var e = this.owner.name === "columns" ? this.owner : this.owner.owner;
e.addColumn(this);
},
removeColumnHandler: function() {
var e = this.owner.name === "columns" ? this.owner : this.owner.owner;
e.removeColumn(this);
}
});

// words/AddOption.js

enyo.kind({
name: "educate.create.components.columnExercise.AddOptionWord",
kind: "educate.create.components.columnExercise.AddOption",
published: {
option: null,
viewId: null
},
components: [ {
kind: "enyo.Input",
name: "newWord",
placeholder: "voegt een nieuw woord toe",
onchange: "onChangeHandler"
}, {
kind: "enyo.Button",
classes: "btn btn-primary",
allowHtml: !0,
content: '<i class="icon-plus-sign"></i>',
ontap: "addOption"
} ],
addOption: function() {
this.setOption(this.$.newWord.getValue()), this.$.newWord.setValue(""), this.bubble("onchange", {
option: this.getOption()
});
},
onChangeHandler: function() {
return this.setOption(this.$.newWord.getValue()), !0;
}
});

// words/Option.js

enyo.kind({
name: "educate.create.components.columnExercise.OptionWord",
kind: "educate.create.components.columnExercise.Option",
published: {
option: null,
parentElement: null
},
classes: "column-option",
components: [ {
kind: "enyo.Input",
name: "txtOption",
value: this.option,
visible: !1
}, {
tag: "span",
name: "spanOption",
content: this.option
}, {
classes: "btn-group",
name: "btnGroupEditTrash",
components: [ {
kind: "enyo.Button",
name: "btnEdit",
classes: "btn btn-default",
allowHtml: !0,
content: '<i class="icon-pencil"></i>',
ontap: "editOption"
}, {
kind: "enyo.Button",
name: "btnRemove",
classes: "btn btn-default",
allowHtml: !0,
content: '<i class="icon-trash"></i>',
ontap: "removeOption"
} ]
}, {
classes: "btn-group",
name: "btnGroupSaveReset",
components: [ {
kind: "enyo.Button",
name: "btnSave",
classes: "btn btn-default",
allowHtml: !0,
content: '<i class="icon-ok"></i>',
ontap: "saveOption",
visible: !1
}, {
kind: "enyo.Button",
name: "btnReset",
classes: "btn btn-default",
allowHtml: !0,
content: '<i class="icon-remove"></i>',
ontap: "resetOption",
visible: !1
} ]
} ],
create: function() {
this.inherited(arguments), this.optionChanged();
},
optionChanged: function() {
this.$.txtOption.setValue(this.getOption()), this.$.spanOption.setContent(this.getOption()), this.$.txtOption.hide(), this.$.spanOption.show(), this.$.btnGroupEditTrash.show(), this.$.btnGroupSaveReset.hide();
},
editOption: function() {
this.$.txtOption.show(), this.$.spanOption.hide(), this.$.btnGroupEditTrash.hide(), this.$.btnGroupSaveReset.show();
},
removeOption: function() {
this.owner.removeOption(this);
},
saveOption: function() {
this.setOption(this.$.txtOption.getValue()), this.optionChanged();
},
resetOption: function() {
this.optionChanged();
}
});

// images/ColumnExercise.js

enyo.kind({
name: "educate.create.components.columnExercise.ColumnExerciseImages",
kind: "educate.create.components.columnExercise.ColumnExercise",
components: [ {
kind: "educate.create.components.columnExercise.ColumnHolderImages",
name: "columns",
columns: this.columns,
onchange: "onColumnsChangeHandler",
viewId: this.viewId
}, {
kind: "educate.create.components.columnExercise.OptionContainerImages",
name: "options",
options: this.optionList,
onchange: "onOptionContainerImagesChangeHandler",
viewId: this.viewId
} ],
published: {
carrier: window.settings.CARRIERS.COLUMN_IMAGES
},
classes: "column-exercise-images",
create: function() {
this.inherited(arguments);
},
onColumnsChangeHandler: function(e, t) {
var n = [], r, i = this.getColumns().length;
for (r = 0; r < i; r++) n = n.concat(this.getColumns()[r].options || []);
return this.setOptionList(n), !0;
},
optionListChange: function() {
this.inherited(arguments), this.$.options.setOption(this.getOptionList());
},
onOptionContainerImagesChangeHandler: function() {
this.options.optionListHeader = this.$.options.getHeader();
}
});

// images/ColumnHolder.js

enyo.kind({
name: "educate.create.components.columnExercise.ColumnHolderImages",
kind: "educate.create.components.columnExercise.ColumnHolder",
events: {
onColumnsChanged: "onColumnsChanged"
},
handlers: {
onchange: "onchangeHandler"
},
columnsChanged: function() {
this.inherited(arguments), this.destroyComponents(), this.destroyClientControls();
var e, t = this.getColumns().length, n = [];
for (e = 0; e < t; e++) {
var r = this.getColumns()[e];
n.push({
kind: "educate.create.components.columnExercise.ColumnImages",
name: "column_" + e,
header: r.header,
options: r.options,
contents: r.contents,
groupedBy: r.groupedBy,
viewId: this.viewId
});
}
this.createComponents(n), this.bubble("onColumnsChanged");
},
onchangeHandler: function(e, t) {
var n = t.originator.getName().split("_")[1], r = this.getColumns()[n];
if (typeof r == "undefined") return;
r.header = t.originator.header, r.options = t.originator.options, r.contents = t.originator.contents, r.groupedBy = t.originator.groupedBy, this.bubble("onColumnsChanged");
},
addColumn: function(e) {
var t = {
header: "Klik om aan te passen.",
options: [],
contents: [],
groupedBy: e.groupedBy
}, n = parseInt(e.getName().split("_")[1]) + 1, r = this.getColumns().concat([]);
r.splice(n, 0, t), this.setColumns(r);
},
removeColumn: function(e) {
var t = parseInt(e.getName().split("_")[1]), n = this.getColumns().concat([]);
n.splice(t, 1), n.length === 0 && n.push({
header: "Klik om aan te passen.",
options: [],
contents: [],
groupedBy: null
}), this.setColumns(n);
}
});

// images/OptionContainer.js

enyo.kind({
name: "educate.create.components.columnExercise.OptionContainerImages",
kind: "educate.create.components.columnExercise.OptionContainer"
});

// images/Column.js

enyo.kind({
name: "educate.create.components.columnExercise.ColumnImages",
kind: "educate.create.components.columnExercise.Column",
components: [ {
name: "header",
classes: "column-header",
components: [ {
kind: "enyo.Button",
name: "btnRemoveColumn",
classes: "btn btn-default btn-remove",
allowHtml: !0,
content: '<i class="icon-trash"></i>',
ontap: "removeColumnHandler"
}, {
kind: "enyo.Input",
name: "groupedByInput",
classes: "column-header-input",
onchange: "onGroupedByChangeHandler",
value: this.groupedBy
}, {
kind: "enyo.Input",
name: "headerInput",
classes: "column-header-input",
onchange: "onHeaderChangeHandler",
value: this.header
}, {
kind: "enyo.Button",
name: "btnAddColumn",
classes: "btn btn-default btn-add",
allowHtml: !0,
content: '<i class="icon-plus-sign"></i>',
ontap: "addColumnHandler"
} ]
}, {
kind: "educate.create.components.columnExercise.AddOptionImage",
name: "columnInput",
classes: "column-add-option",
onchange: "addOption",
viewId: this.viewId
}, {
name: "container",
classes: "column-content"
} ],
create: function() {
this.inherited(arguments), this.headerChanged(), this.groupedByChanged();
},
rendered: function() {
this.inherited(arguments), this.optionsChanged(), this.$.groupedByInput.setValue(this.getGroupedBy());
},
headerChanged: function() {
this.$.headerInput.setValue(this.getHeader()), this.bubble("onchange");
},
groupedByChanged: function(e) {
this.inherited(arguments), this.render();
},
onHeaderChangeHandler: function() {
this.setHeader(this.$.headerInput.getValue());
},
onGroupedByChangeHandler: function() {
var e = this.$.groupedByInput.getValue().trim();
e = e !== "" ? e : null, this.setGroupedBy(e);
},
addOption: function(e, t) {
Array.isArray(this.getOptions()) || this.setOptions([]);
var n = this.getOptions().concat([]);
n.push(t.option), this.setOptions(n);
},
optionsChanged: function() {
this.$.container.destroyComponents(), this.$.container.destroyClientControls();
var e = this.getOptions(), t, n = e.length, r = [], i;
for (t = 0; t < n; t++) {
i = e[t];
if (typeof i == "undefined") {
e.splice(t, 1), t++, n--, this.options = e;
continue;
}
r.push({
kind: "educate.create.components.columnExercise.OptionImage",
name: "Image_" + t,
option: i,
parentElement: this
});
}
this.$.container.createComponents(r, {
owner: this
}), this.$.columnInput.setOption(""), this.$.container.render(), this.bubble("onchange");
},
removeOption: function(e) {
var t = this.getOptions().concat([]), n = e.getName().split("_")[1];
t.splice(n, 1), this.setOptions(t);
},
addColumnHandler: function() {
var e = this.owner.name === "columns" ? this.owner : this.owner.owner;
e.addColumn(this);
},
removeColumnHandler: function() {
var e = this.owner.name === "columns" ? this.owner : this.owner.owner;
e.removeColumn(this);
}
});

// images/AddOption.js

enyo.kind({
name: "educate.create.components.columnExercise.AddOptionImage",
kind: "educate.create.components.columnExercise.AddOption",
published: {
option: null,
viewId: null
},
handlers: {
assetsLibrarySubmitted: "assetsLibrarySubmittedHandler"
},
components: [ {
kind: "enyo.Button",
name: "btnAddOtion",
classes: "btn btn-primary",
allowHtml: !0,
content: '<i class="icon-plus-sign"></i>',
ontap: "addOption"
} ],
addOption: function() {
this.$.btnAddOtion.setDisabled(!0), this.createComponent({
name: "library",
kind: "educate.create.Assets",
viewId: this.viewId,
searchType: "foto"
}), this.$.library.show();
},
assetsLibrarySubmittedHandler: function() {
var e = this.$.library.getSelectedAsset();
this.setOption(e), this.$.btnAddOtion.setDisabled(!1), this.$.library.destroy(), this.bubble("onchange", {
option: this.getOption()
});
},
onChangeHandler: function() {
return this.setOption(this.$.newImage.getValue()), !0;
}
});

// images/Option.js

enyo.kind({
name: "educate.create.components.columnExercise.OptionImage",
kind: "educate.create.components.columnExercise.Option",
published: {
option: null,
parentElement: null
},
classes: "column-option column-option-image",
components: [ {
kind: enyo.Image,
name: "imgOption",
src: this.option
}, {
kind: "enyo.Button",
name: "btnRemove",
classes: "btn btn-default",
allowHtml: !0,
content: '<i class="icon-trash"></i>',
ontap: "removeOption"
} ],
create: function() {
this.inherited(arguments), this.optionChanged();
},
optionChanged: function() {
var e = this.getOption().value;
typeof e != "undefined" && this.$.imgOption.setSrc(Settings.WEBAPP + e);
},
removeOption: function() {
this.owner.removeOption(this);
}
});

// Flipcard.js

enyo.kind({
name: "educate.create.components.flipcard.Flipcard",
kind: "educate.components.flipcard.Flipcard",
tag: "div",
create: function() {
this.inherited(arguments), this.resizeComponent(), this.addPropertiesToOptions(), this.changeBackSide();
},
rendered: function() {
this.inherited(arguments);
},
doFlipPreview: function() {
this.node.children[0].classList.toggle("flip");
},
propertyChanged: function() {
this.currentBackSide = this.getOptions().currentBackSide, this.backText = this.getOptions().backText, this.backImage = this.getOptions().backImage, this.changeBackSide();
},
addPropertiesToOptions: function() {
this.addOption("currentBackSide", this.currentBackSide), this.addOption("backText", this.backText), this.addOption("backImage", this.backImage);
},
visibleChanged: function() {
this.applyStyle("opacity", this.getVisible() !== !1 ? this.getAlpha() : .25), this.addOption("visible", this.getVisible());
},
widthChanged: function() {
this.width = parseInt(this.width), this.resizeComponent();
},
heightChanged: function() {
this.height = parseInt(this.height), this.resizeComponent();
},
position_xChanged: function() {
this.position_x = parseInt(this.position_x);
},
position_yChanged: function() {
this.position_y = parseInt(this.position_y), this.resizeComponent();
}
});

// Website.js

enyo.kind({
name: "educate.create.components.website.Website",
kind: "educate.components.website.Website",
tag: "div",
classes: "webFrame",
style: "position: absolute;",
published: {
position_x: 300,
position_y: 200,
width: 900,
height: 500,
url: ""
},
components: [ {
name: "iframe",
tag: "iframe",
classes: "enyo-fill",
style: "border: none; pointer-events: none;"
} ],
create: function() {
this.inherited(arguments), this.resizeComponent(), this.addPropertiesToOptions(), this.setUrl();
},
rendered: function() {
this.inherited(arguments);
},
visibleChanged: function() {
this.applyStyle("opacity", this.getVisible() !== !1 ? this.getAlpha() : .25), this.addOption("visible", this.getVisible());
},
propertyChanged: function() {
this.url = this.getOptions().url, this.setUrl();
},
addPropertiesToOptions: function() {
this.addOption("url", this.url);
},
widthChanged: function() {
this.width = parseInt(this.width), this.resizeComponent();
},
heightChanged: function() {
this.height = parseInt(this.height), this.resizeComponent();
},
position_xChanged: function() {
this.position_x = parseInt(this.position_x);
},
position_yChanged: function() {
this.position_y = parseInt(this.position_y), this.resizeComponent();
}
});

// Map.js

enyo.kind({
name: "educate.create.components.map.Map",
kind: "educate.components.map.Map",
published: {
width: 500,
height: 300,
position_x: 150,
position_y: 100,
objType: "map_"
},
handlers: {
onPropertiesChanged: "onPropertiesChangedHandler"
},
create: function() {
this.inherited(arguments), this.$.mapCanvas.addClass("mapCanvasCreate");
},
visibleChanged: function() {
this.applyStyle("opacity", this.getVisible() !== !1 ? this.getAlpha() : .25), this.addOption("visible", this.getVisible());
},
onPropertiesChangedHandler: function(e, t) {
t.linked == this && (this.layername = t.linked.layername, this.resizeComponent());
},
adresChanged: function() {
this.getAdres() != "" && this.getMap() != "" && this.showLocationByAddress(this.getAdres()), this.addOption("adres", this.getAdres());
},
bHuidigeLocatieChanged: function() {
this.inherited(arguments), this.addOption("isHuidigeLocatie", this.getBHuidigeLocatie());
},
mapTypeChanged: function() {
this.addOption("mapType", this.getMapType()), this.getMap() != "" && this.getMap().setMapTypeId(this.convertMapTypeStringToMapType());
}
});

// Youtube.js

enyo.kind({
name: "educate.create.components.youtube.Youtube",
kind: "educate.components.youtube.Youtube",
published: {
width: 640,
height: 390,
position_x: 150,
position_y: 100,
objType: "you_"
},
handlers: {
onPropertiesChanged: "onPropertiesChangedHandler"
},
create: function() {
this.inherited(arguments), this.$.youtubePlayer.addClass("youtubePlayerCreate");
},
visibleChanged: function() {
this.applyStyle("opacity", this.getVisible() !== !1 ? this.getAlpha() : .25), this.addOption("visible", this.getVisible());
},
onPropertiesChangedHandler: function(e, t) {
t.linked == this && (this.layername = t.linked.layername, this.resizeComponent());
},
videoIdChanged: function() {
this.getVideoId() != "" && this.loadYoutubeVideo(this.getVideoId()), this.addOption("videoId", this.getVideoId());
},
videoUrlChanged: function() {
this.setVideoId(this.getVideoIdFromUrl(this.getVideoUrl())), this.addOption("videoUrl", this.getVideoUrl());
},
getVideoIdFromUrl: function(e) {
var t = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/, n = e.match(t);
if (n && n[7].length == 11) return n[7];
this.setVideoUrl(""), console.log("foute url");
}
});

// 3DObject.js

enyo.kind({
name: "educate.create.components.3DObject.3DObject",
kind: "educate.components.3DObject.3DObject",
tag: "div",
classes: "3DObject",
style: "position: absolute;",
published: {
position_x: 0,
position_y: 0,
width: 1e3,
height: 550,
modelUrl: "/svnAssets/vb3bis.dae",
modelUrls: [],
modelName: "",
modelNames: [],
modelId: 0,
meshOptions: [],
cameraCenter: '{"x":0,"y":0,"z":0}',
cameraPosition: '{"x":20,"y":0,"z":0}',
groundOn: !0,
spotLightOn: !0,
hemiLightOn: !0,
fromCreate: !0,
newRendering: !0,
meshActions: [],
newAction: [],
disableActions: !0
},
id: "3dobj",
create: function() {
this.inherited(arguments), this.width = window.settings.STAGEWIDTH, this.height = window.settings.STAGEHEIGHT, this.addPropertiesToOptions(), this.resizeComponent(), this.setLocked(!0);
},
rendered: function() {
this.inherited(arguments), this.loadFirstUrl(), this.layername = "scene 3D";
},
loadFirstUrl: function() {
if (this.children.length > 0) {
for (var e = 0; e < this.children.length; e++) this.children[e].destroy();
this.deleteMaterialList();
}
this.modelUrls.length > 0 && this.newRendering && (this.newRendering = !1, this.loadOtherUrls());
},
loadOtherUrls: function() {
this.modelUrls[this.modelId] ? this.modelUrls[this.modelId] == "deleted" ? (this.modelId++, this.loadOtherUrls()) : (this.modelUrl = this.modelUrls[this.modelId], this.modelName = this.modelNames[this.modelId], this.modelId++, this.addModelToScene()) : (console.log("done loading"), this.sceneInit = !0);
},
propertyCamera: function() {
this.cameraCenter = JSON.stringify(this.controls.target), this.cameraPosition = JSON.stringify(this.camera.position), this.addOption("cameraCenter", this.cameraCenter), this.addOption("cameraPosition", this.cameraPosition);
},
storeCameraOptions: function(e, t, n) {
this.addOption("zoomCamera", e), this.addOption("rotateCamera", t), this.addOption("panCamera", n), this.updateControls(e, t, n);
},
storeCameraLimits: function(e, t, n, r, i, s) {
this.addOption("ymin", e), this.addOption("ymax", t), this.addOption("xmin", n), this.addOption("xmax", r), this.addOption("zoomMin", i), this.addOption("zoomMax", s), this.updateControlLimits(e, t, n, r, i, s);
},
previewCamera: function() {
var e = JSON.parse(this.cameraPosition);
this.camera.position.set(e.x, e.y, e.z);
var t = JSON.parse(this.cameraCenter), n = new THREE.Vector3(t.x, t.y, t.z);
this.controls.target = n, this.liveCameraPosition = this.camera.position, this.liveCameraCenter = this.controls.target, this.bubble("changeCameraPosition", this), this.renderScene();
},
centerOnObject: function(e, t) {
this.liveCameraPosition = e, this.liveCameraCenter = t, this.bubble("centerOnObject", {
pos: this.liveCameraPosition,
cen: this.liveCameraCenter
}), this.previewLiveCamera();
},
previewLiveCamera: function() {
var e = this.liveCameraPosition;
this.camera.position.set(e.x, e.y, e.z);
var t = this.liveCameraCenter, n = new THREE.Vector3(t.x, t.y, t.z);
this.controls.target = n, this.renderScene();
},
propertyChanged: function() {
this.groundOn = this.getOptions().groundOn, this.spotLightOn = this.getOptions().spotLightOn, this.hemiLightOn = this.getOptions().hemiLightOn, this.updateLighting(), this.updateGround();
},
modelUrlChanged: function() {
this.modelId++, this.modelUrls.push(this.modelUrl), this.modelNames.push(this.modelName), this.resizing = !1, this.addOption("modelUrls", this.modelUrls), this.addOption("modelNames", this.modelNames), this.addModelToScene();
},
addPropertiesToOptions: function() {
this.addOption("cameraCenter", this.cameraCenter), this.addOption("cameraPosition", this.cameraPosition), this.addOption("groundOn", this.groundOn), this.addOption("spotLightOn", this.spotLightOn), this.addOption("hemiLightOn", this.hemiLightOn), this.addOption("modelUrls", this.modelUrls), this.addOption("modelNames", this.modelNames);
},
widthChanged: function() {
this.width = parseInt(this.width), this.resizeComponent();
},
heightChanged: function() {
this.height = parseInt(this.height), this.resizeComponent();
},
position_xChanged: function() {
this.position_x = parseInt(this.position_x);
},
position_yChanged: function() {
this.position_y = parseInt(this.position_y), this.resizeComponent();
}
});

// Klimatogram.js

enyo.kind({
name: "educate.create.components.bibliotheek.Klimatogram",
kind: "educate.components.bibliotheek.Klimatogram",
create: function() {
this.inherited(arguments);
}
});

// MultipleChoice.js

enyo.kind({
name: "educate.create.components.multipleChoice.MultipleChoice",
kind: "educate.components.multipleChoice.MultipleChoice",
published: {
width: "",
height: "",
position_x: 250,
position_y: 200
},
create: function() {
this.inherited(arguments), this.resizeComponent();
},
rendered: function() {
this.inherited(arguments), this.updateMultipleChoice();
},
updateMultipleChoice: function() {
this.inherited(arguments);
for (var e in this.selectOptions) this.$.choiceList.createComponents([ {
tag: "li",
components: [ {
tag: "i",
classes: this.selectOptions[e].correct ? "fill-icon icon-check-2" : "fill-icon icon-delete-2"
}, {
tag: "span",
content: this.selectOptions[e].text
} ]
} ], {
owner: this
});
this.$.choiceList.render(), this.addPropertiesToOptions();
},
addPropertiesToOptions: function() {
this.addOption("selectOptions", this.selectOptions), this.addOption("solutionFromFrame", this.solutionFromFrame), this.addOption("shuffleAnswers", this.shuffleAnswers);
},
visibleChanged: function() {
this.applyStyle("opacity", this.getVisible() !== !1 ? this.getAlpha() : .25), this.addOption("visible", this.getVisible());
},
questionChanged: function() {
this.$.multipleChoiceQuestion.setContent(this.getQuestion()), this.addOption("question", this.getQuestion());
},
widthChanged: function() {
this.width = parseInt(this.width), this.resizeComponent();
},
heightChanged: function() {
this.height = parseInt(this.height), this.resizeComponent();
}
});

// CloseScene.js

enyo.kind({
name: "educate.create.dialoogvensters.CloseScene",
kind: "enyo.Popup",
classes: "closeSceneDialoog modal",
floating: !0,
scrim: !0,
autoDismiss: !1,
modal: !0,
components: [ {
tag: "div",
classes: "modal-header",
components: [ {
tag: "button",
classes: "close",
content: "&times",
allowHtml: !0,
ontap: "cancelCloseScene"
}, {
tag: "h3",
content: "Wil je de scene opslaan?"
} ]
}, {
tag: "div",
name: "closeSceneBody",
classes: "modal-body",
components: []
}, {
tag: "div",
name: "closeSceneFooter",
classes: "modal-footer",
components: [ {
tag: "button",
classes: "btn btn-primary",
name: "saveBeforeCloseScene",
content: "Opslaan",
ontap: "saveBeforeCloseScene"
}, {
tag: "button",
classes: "btn",
name: "noSaveBeforeCloseScene",
content: "Niet opslaan",
ontap: "noSaveBeforeCloseScene"
}, {
tag: "button",
classes: "btn",
name: "cancelCloseScene",
content: "Annuleer",
ontap: "cancelCloseScene"
} ]
} ],
create: function() {
this.inherited(arguments), this.show(), this.render();
},
rendered: function() {
this.inherited(arguments);
},
saveBeforeCloseScene: function() {
this.bubble("closeScenePopupSubmitted", {
result: "save"
}), this.destroy();
},
noSaveBeforeCloseScene: function() {
this.bubble("closeScenePopupSubmitted", {
result: "nosave"
}), this.destroy();
},
cancelCloseScene: function() {
this.destroy();
}
});

// OpenScene.js

enyo.kind({
name: "educate.create.dialoogvensters.OpenScene",
kind: "enyo.Popup",
classes: "openSceneDialoog modal",
floating: !0,
scrim: !0,
autoDismiss: !1,
modal: !0,
published: {
selectedScene: "",
selectedSceneNaam: "",
selectedSceneValue: ""
},
handlers: {
menuItemSelected: "menuItemSelectedHandler"
},
components: [ {
tag: "div",
classes: "modal-header",
components: [ {
tag: "button",
classes: "close",
content: "&times",
allowHtml: !0,
ontap: "cancelHandler"
}, {
tag: "h3",
content: "open scene"
} ]
}, {
tag: "div",
name: "openSceneBody",
classes: "modal-body form-horizontal",
components: [ {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: "code:"
}, {
classes: "controls",
components: [ {
kind: enyo.Input,
name: "txtCode",
placeholder: "####-#-#-#-#",
type: "text",
onchange: "onchangeHandler"
} ]
} ]
}, {
tag: "hr"
}, {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: "jaar:"
}, {
classes: "controls",
components: [ {
kind: enyo.Select,
name: "selectJaar",
attributes: {
multiple: "multiple",
size: 6
},
components: [ {
content: "\u2026",
value: ""
}, {
content: "1ste jaar",
value: "1"
}, {
content: "2de jaar",
value: "2"
}, {
content: "3de jaar",
value: "3"
}, {
content: "4de jaar",
value: "4"
}, {
content: "5de jaar",
value: "5"
}, {
content: "6de jaar",
value: "6"
} ],
onchange: "onSelectJaarChangeHandler"
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: "vakken:"
}, {
classes: "controls",
components: [ {
kind: enyo.Select,
name: "selectVak",
components: [ {
content: "selecteer eerst een jaar",
value: ""
} ],
onchange: "onSelectVakChangeHandler"
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: "hoofdstukken:"
}, {
classes: "controls",
components: [ {
kind: enyo.Select,
name: "selectHoofdstuk",
components: [ {
content: "selecteer eerst een vak",
value: ""
} ],
onchange: "onSelectHoofdstukChangeHandler"
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: "modules:"
}, {
classes: "controls",
components: [ {
kind: enyo.Select,
name: "selectModule",
components: [ {
content: "selecteer eerst een hoofdstuk",
value: ""
} ],
onchange: "onSelectModuleChangeHandler"
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: "categori\u00ebn:"
}, {
classes: "controls",
components: [ {
kind: enyo.Select,
name: "selectCategorie",
components: [ {
content: "selecteer eerst een module",
value: ""
} ],
onchange: "onSelectCategorieChangeHandler"
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: "scenes:"
}, {
classes: "controls",
components: [ {
kind: enyo.Select,
name: "selectScene",
components: [ {
content: "selecteer eerst een categorie",
value: ""
} ],
onchange: "onSelectSceneChangeHandler"
} ]
} ]
} ]
}, {
tag: "div",
name: "openSceneFooter",
classes: "modal-footer",
components: [ {
tag: "button",
name: "btnOpen",
classes: "btn btn-primary",
content: "open",
ontap: "openHandler",
attributes: {
disabled: !0
}
}, {
tag: "button",
name: "btnClose",
classes: "btn",
content: "annuleer",
ontap: "cancelHandler"
} ]
} ],
create: function() {
this.inherited(arguments), this.show();
},
openHandler: function() {
this.bubble("openScenePopupSubmitted", this), this.hide();
},
cancelHandler: function() {
this.hide();
},
errorHandler: function(e, t) {
console.log("searchSceneValueError", e, t);
},
onchangeHandler: function(e, t) {
var n = t.target.value, r = /\d\d\d\d-\d+-\d+-\d+-\d+/, i = this;
if (r.test(n)) {
var s = "value=" + n;
$.ajax({
url: Settings.SERVER + "getSceneByValue",
type: "GET",
data: s,
dataType: "json",
success: enyo.bind(this, "sceneSelected"),
error: function() {
i.$.btnOpen.setAttribute("disabled", "true"), i.$.txtCode.addClass("error"), i.setSelectedScene(null);
}
});
} else this.$.btnOpen.setAttribute("disabled", "true"), this.$.txtCode.addClass("error");
},
onSelectJaarChangeHandler: function(e, t) {
var n = e.children[e.selected].value, r = "jaarValue=" + n;
$.ajax({
url: Settings.SERVER + "getVakkenVoorJaar",
type: "GET",
data: r,
dataType: "json",
success: enyo.bind(this, "jaarSelected"),
error: this.errorHandler
});
},
onSelectVakChangeHandler: function(e, t) {
var n = e.children[e.selected].value, r = "selectedId=" + n;
$.ajax({
url: Settings.SERVER + "getHoofdstukkenById",
type: "GET",
data: r,
dataType: "json",
success: enyo.bind(this, "vakSelected"),
error: this.errorHandler
});
},
onSelectHoofdstukChangeHandler: function(e, t) {
var n = e.children[e.selected].value, r = "selectedId=" + n;
$.ajax({
url: Settings.SERVER + "getModulesById",
type: "GET",
data: r,
dataType: "json",
success: enyo.bind(this, "hoofdstukSelected"),
error: this.errorHandler
});
},
onSelectModuleChangeHandler: function(e, t) {
var n = e.children[e.selected].value, r = "selectedId=" + n;
$.ajax({
url: Settings.SERVER + "getCategorienById",
type: "GET",
data: r,
dataType: "json",
success: enyo.bind(this, "moduleSelected"),
error: this.errorHandler
});
},
onSelectCategorieChangeHandler: function(e, t) {
var n = e.children[e.selected].value, r = "selectedId=" + n;
$.ajax({
url: Settings.SERVER + "getScenesById",
type: "GET",
data: r,
dataType: "json",
success: enyo.bind(this, "categorieSelected"),
error: this.errorHandler
});
},
onSelectSceneChangeHandler: function(e, t) {
this.setSelectedScene(e.children[e.selected].attributes["data-id"]), this.setSelectedSceneNaam(e.children[e.selected].content), this.setSelectedSceneValue(e.children[e.selected].value), this.$.btnOpen.setAttribute("disabled", null);
},
jaarSelected: function(e, t) {
this.$.selectVak.destroyClientControls(), this.$.selectVak.destroyComponents(), this.$.selectVak.createComponent({
content: "\u2026",
value: ""
});
var n, r = e.length;
for (n = 0; n < r; n++) this.$.selectVak.createComponent({
content: e[n].name,
value: e[n].id
});
this.$.selectJaar.setAttribute("multiple", null), this.$.selectJaar.setAttribute("size", null), this.$.selectVak.setAttribute("multiple", "multiple"), this.$.selectVak.setAttribute("size", r), this.render();
},
vakSelected: function(e, t) {
this.$.selectHoofdstuk.destroyClientControls(), this.$.selectHoofdstuk.destroyComponents(), this.$.selectHoofdstuk.createComponent({
content: "\u2026",
value: ""
});
var n, r = e.length;
for (n = 0; n < r; n++) this.$.selectHoofdstuk.createComponent({
content: e[n].name,
value: e[n].id
});
this.$.selectVak.setAttribute("multiple", null), this.$.selectVak.setAttribute("size", null), this.$.selectHoofdstuk.setAttribute("multiple", "multiple"), this.$.selectHoofdstuk.setAttribute("size", r), this.render();
},
hoofdstukSelected: function(e, t) {
this.$.selectModule.destroyClientControls(), this.$.selectModule.destroyComponents(), this.$.selectModule.createComponent({
content: "\u2026",
value: ""
});
var n, r = e.length;
for (n = 0; n < r; n++) this.$.selectModule.createComponent({
content: e[n].name,
value: e[n].id
});
this.$.selectHoofdstuk.setAttribute("multiple", null), this.$.selectHoofdstuk.setAttribute("size", null), this.$.selectModule.setAttribute("multiple", "multiple"), this.$.selectModule.setAttribute("size", r), this.render();
},
moduleSelected: function(e, t) {
this.$.selectCategorie.destroyClientControls(), this.$.selectCategorie.destroyComponents(), this.$.selectCategorie.createComponent({
content: "\u2026",
value: ""
});
var n, r = e.length;
for (n = 0; n < r; n++) this.$.selectCategorie.createComponent({
content: e[n].name,
value: e[n].id
});
this.$.selectModule.setAttribute("multiple", null), this.$.selectModule.setAttribute("size", null), this.$.selectCategorie.setAttribute("multiple", "multiple"), this.$.selectCategorie.setAttribute("size", r), this.render();
},
categorieSelected: function(e, t) {
this.$.selectScene.destroyClientControls(), this.$.selectScene.destroyComponents(), this.$.selectScene.createComponent({
content: "\u2026",
value: ""
});
var n, r = e.length;
for (n = 0; n < r; n++) this.$.selectScene.createComponent({
content: e[n].name,
attributes: {
"data-id": e[n].id
},
value: e[n].value
});
this.$.selectCategorie.setAttribute("multiple", null), this.$.selectCategorie.setAttribute("size", null), this.$.selectScene.setAttribute("multiple", "multiple"), this.$.selectScene.setAttribute("size", r), this.render();
},
sceneSelected: function(e, t) {
this.$.btnOpen.setAttribute("disabled", null), this.$.txtCode.removeClass("error"), this.setSelectedScene(e.id), this.setSelectedSceneNaam(e.name), this.setSelectedSceneValue(e.value);
}
});

// SaveScene.js

enyo.kind({
name: "educate.create.dialoogvensters.SaveScene",
kind: "enyo.Popup",
classes: "saveSceneDialoog modal",
floating: !0,
scrim: !0,
autoDismiss: !1,
modal: !0,
published: {
sceneNaam: "",
sceneValue: "",
selectedCat: "",
typeScene: ""
},
handlers: {
menuItemSelected: "menuItemSelectedHandler"
},
components: [ {
tag: "div",
classes: "modal-header",
components: [ {
tag: "button",
classes: "close",
content: "&times",
allowHtml: !0,
ontap: "cancelSaveScenePopup"
}, {
tag: "h3",
content: "Save scene"
} ]
}, {
tag: "div",
name: "saveSceneBody",
classes: "modal-body",
components: [ {
tag: "label",
content: "Scene locatie: "
}, {
kind: "onyx.Input",
name: "txtSelectedCat"
}, {
tag: "label",
content: "Scene naam: "
}, {
kind: "onyx.Input",
name: "scenename",
type: "text",
value: "naam van de scene",
selectOnFocus: !0
}, {
tag: "label",
content: "Value scene: "
}, {
kind: "onyx.Input",
name: "txtValueScene",
type: "text"
} ]
}, {
tag: "div",
name: "saveSceneFooter",
classes: "modal-footer",
components: [ {
tag: "button",
classes: "btn btn-primary",
name: "submitSaveScene",
content: "Save",
ontap: "submitSaveScenePopup"
}, {
tag: "button",
classes: "btn",
name: "cancelSaveScene",
content: "Annuleer",
ontap: "cancelSaveScenePopup"
} ]
} ],
create: function() {
this.inherited(arguments), this.makeMenuStructuur(), this.show(), this.render();
},
makeMenuStructuur: function() {
this.createComponent({
container: this.$.saveSceneBody,
kind: "educate.hulpklassen.menuStructuur.MenuStructuur",
name: "menuStructuur",
niveau: this.getTypeScene() == "les" ? [ "categorie" ] : [ "scene" ]
});
},
rendered: function() {
this.inherited(arguments), this.sceneNaamChanged(), this.selectedCatChanged(), this.sceneValueChanged();
},
selectedCatChanged: function() {
this.$.txtSelectedCat.setValue(this.getSelectedCat());
},
sceneNaamChanged: function() {
this.$.scenename.setValue(this.getSceneNaam());
},
sceneValueChanged: function() {
this.$.txtValueScene.setValue(this.getSceneValue());
},
submitSaveScenePopup: function() {
this.$.scenename.getValue() != "" && this.$.scenename.getValue() != "naam van de scene" && this.$.txtSelectedCat.getValue() != "" && this.$.txtValueScene.getValue() != "" ? (this.setSelectedCat(this.$.txtSelectedCat.getValue()), this.setSceneNaam(this.$.scenename.getValue()), this.setSceneValue(this.$.txtValueScene.getValue()), this.bubble("saveScenePopupSubmitted", this), this.hide()) : this.bubble("onMessage", {
message: 'Gelieve alle velden in te vullen en Scene naam verschillend dan "naam van de scene".',
duration: 3e3
});
},
cancelSaveScenePopup: function() {
this.bubble("saveScenePopupCancelled", this), this.hide();
},
menuItemSelectedHandler: function(e, t) {
this.setSelectedCat(t.selectedId);
}
});

// MessageBox.js

enyo.kind({
kind: enyo.Control,
name: "educate.create.dialoogvensters.MessageBox",
tag: "div",
classes: "messagebox",
showing: !1,
published: {
message: "",
duration: 1e3
},
handlers: {},
components: [ {
tag: "p",
name: "message"
} ],
create: function() {
this.inherited(arguments);
},
rendered: function() {
this.inherited(arguments);
},
messageChanged: function() {
this.$.message.setContent(this.getMessage());
},
showMessageBox: function(e, t) {
t && this.setDuration(t), this.setMessage(e ? e : "Geen tekst");
var n = this;
$(this.hasNode()).slideDown("fast", function() {
var e = setTimeout(enyo.bind(n, "hideMessageBox"), n.getDuration());
});
},
hideMessageBox: function() {
$(this.hasNode()).slideUp("fast"), this.setDuration(1e3);
}
});

// EditNameScene.js

enyo.kind({
kind: enyo.Popup,
name: "educate.create.dialoogvensters.EditNameScene",
tag: "div",
classes: "editNameScene modal",
floating: !0,
scrim: !0,
autoDismiss: !1,
modal: !0,
published: {
sceneNaam: "",
sceneValue: ""
},
handlers: {},
components: [ {
tag: "div",
classes: "modal-header",
components: [ {
tag: "button",
classes: "close",
content: "&times",
allowHtml: !0,
ontap: "cancelEditNameScene"
}, {
tag: "h3",
content: "Naam scene"
} ]
}, {
tag: "div",
name: "editNameSceneBody",
classes: "modal-body",
components: [ {
classes: "row-fluid",
components: [ {
tag: "label",
content: "Scene naam: "
}, {
kind: "enyo.Input",
name: "txtEditNameScene",
type: "text",
selectOnFocus: !0,
classes: "span12"
}, {
tag: "label",
content: "Value scene: "
}, {
kind: "enyo.Input",
name: "txtEditValueScene",
type: "text",
classes: "span12",
placeholder: "####-#-#-#-#",
onchange: "valueChangeHandler"
} ]
} ]
}, {
tag: "div",
name: "editNameSceneFooter",
classes: "modal-footer",
components: [ {
tag: "button",
classes: "btn btn-primary",
name: "SubmitteditNameScene",
content: "Wijzig",
ontap: "SubmitteditNameScene"
}, {
tag: "button",
classes: "btn",
name: "cancelEditNameScene",
content: "Annuleer",
ontap: "cancelEditNameScene"
} ]
} ],
create: function() {
this.inherited(arguments), this.show(), this.render();
},
rendered: function() {
this.inherited(arguments), this.sceneNaamChanged(), this.sceneValueChanged();
},
sceneNaamChanged: function() {
this.$.txtEditNameScene.setValue(this.getSceneNaam());
},
sceneValueChanged: function() {
this.$.txtEditValueScene.setValue(this.getSceneValue());
},
SubmitteditNameScene: function() {
if (this.$.txtEditNameScene.getValue() !== "" && this.$.txtEditNameScene.getValue() !== "naam van de scene" && this.valueTest()) {
var e = new Object;
e.editedSceneName = this.$.txtEditNameScene.getValue(), e.editedSceneValue = this.$.txtEditValueScene.getValue(), this.bubble("editNameScenePopupSubmitted", e), this.destroy();
} else this.valueTest() ? (this.$.txtEditValueScene.removeClass("error"), this.$.txtEditValueScene.removeClass("success")) : (this.$.txtEditValueScene.addClass("error"), this.$.txtEditValueScene.removeClass("success")), this.$.txtEditNameScene.getValue() === "" || this.$.txtEditNameScene.getValue() === "naam van de scene" ? (this.$.txtEditNameScene.addClass("error"), this.$.txtEditNameScene.removeClass("success")) : (this.$.txtEditNameScene.removeClass("error"), this.$.txtEditNameScene.removeClass("success"));
},
valueChangeHandler: function() {
this.valueTest() ? (this.$.txtEditValueScene.addClass("success"), this.$.txtEditValueScene.removeClass("error")) : (this.$.txtEditValueScene.addClass("error"), this.$.txtEditValueScene.removeClass("success"));
},
valueTest: function() {
return this.$.txtEditValueScene.getValue().match(/\d\d\d\d-\d+-\d+-\d+-\d+/) !== null;
},
cancelEditNameScene: function() {
this.destroy();
}
});

// RichTexteditor.js

enyo.kind({
name: "educate.create.dialoogvensters.RichTexteditor",
kind: enyo.Control,
classes: "modal rte-modal",
components: [ {
classes: "modal-header",
components: [ {
kind: "enyo.Button",
classes: "close",
content: "\u00d7",
attributes: {
"data-dismiss": "modal",
"aria-hidden": "true"
},
ontap: "onCancelHandler"
}, {
tag: "h3",
name: "title",
content: this.title
} ]
}, {
classes: "modal-body",
components: [ {
kind: enyo.TextArea,
name: "value",
value: this.value,
type: "text",
classes: "txteditcontent",
attributes: {
name: "value"
}
} ]
}, {
classes: "modal-footer",
components: [ {
kind: "enyo.Button",
classes: "btn",
content: "Cancel",
ontap: "onCancelHandler"
}, {
kind: "enyo.Button",
classes: "btn btn-primary",
content: "Ok",
ontap: "onSubmitHandler"
} ]
} ],
published: {
showing: !1,
value: "Dit is de tekst die u moet bewerken.",
title: "bewerk tekst",
editor: !1
},
events: {
onSubmit: "onSubmit"
},
rendered: function() {
this.inherited(arguments), this.$.title.setContent(this.getTitle()), this.$.value.setValue(this.getValue()), this.editor = CKEDITOR.replace(this.$.value.getId(), {
customConfig: "config_frontend.js"
}), this.editor.setData(this.getValue());
},
showingChanged: function() {
this.inherited(arguments), this.showing && (this.editor || (this.editor = CKEDITOR.replace(this.$.value.getId(), {
customConfig: "config_frontend.js"
})), this.editor.setData(this.getValue()));
},
onSubmitHandler: function(e, t) {
this.editor ? this.setValue(this.editor.getData()) : this.setValue(this.$.value.getValue()), this.doSubmit();
},
onCancelHandler: function(e, t) {
this.setShowing(!1);
}
});

// asset.js

enyo.kind({
name: "educate.create.Asset",
kind: enyo.Control,
classes: "span4 assetLibraryItemCon",
published: {
asset: {},
title: "",
thumb: "",
tags: []
},
components: [ {
name: "txtTitle",
tag: "h4",
content: "title"
}, {
tag: "img",
name: "image",
src: "",
classes: "img-rounded img-polaroid"
}, {
tag: "div",
name: "tags",
classes: "row-fluid",
style: "margin-top: 5px;"
} ],
create: function() {
this.inherited(arguments), this.assetChanged();
},
assetChanged: function() {
this.setTitle(this.getAsset().options), this.setThumb(Settings.WEBAPP + "/" + (this.getAsset().answered !== null ? this.getAsset().answered : "images/broken_thumb.png")), this.setTags(this.getAsset().css_class.split(/ ?, ?/));
},
titleChanged: function() {
this.$.txtTitle.setContent(this.getTitle());
},
thumbChanged: function() {
this.$.image.setSrc(this.getThumb());
},
tagsChanged: function() {
this.$.tags.destroyClientControls(), this.$.tags.destroyComponents();
var e, t = this.getTags();
for (e = 0; e < t; e++) this.createComponent({
tag: "span",
content: this.getTags()[q],
classes: "label label-info",
container: this.$.tags
});
this.$.tags.render();
}
});

// Vimeo.js

enyo.kind({
name: "educate.create.Vimeo",
kind: enyo.Control,
classes: "span4 assetLibraryItemCon",
published: {
asset: {},
title: "",
thumb: "",
tags: []
},
components: [ {
name: "txtTitle",
tag: "h4",
content: "title"
}, {
tag: "img",
name: "image",
src: "",
classes: "img-rounded img-polaroid"
}, {
tag: "div",
name: "tags",
classes: "row-fluid",
style: "margin-top: 5px;"
} ],
create: function() {
this.inherited(arguments), this.assetChanged();
},
assetChanged: function() {
var e = Settings.WEBAPP + "/images/broken_thumb.png";
this.setTitle(this.getAsset().name);
for (var t in this.getAsset().thumb) if (t > 200 && t <= 640) {
e = this.getAsset().thumb[t].link;
break;
}
this.setThumb(e), this.setTags(this.getAsset().tags);
},
titleChanged: function() {
this.$.txtTitle.setContent(this.getTitle());
},
thumbChanged: function() {
this.$.image.setSrc(this.getThumb());
},
tagsChanged: function() {
this.$.tags.destroyClientControls(), this.$.tags.destroyComponents();
var e, t = this.getTags();
for (e = 0; e < t; e++) this.createComponent({
tag: "span",
content: this.getTags()[q],
classes: "label label-info",
container: this.$.tags
});
this.$.tags.render();
}
});

// assets.js

"use strict";

enyo.kind({
name: "educate.create.Assets",
kind: "educate.hulpklassen.library.Library",
classes: "",
published: {
searchType: "all",
selectedAsset: null,
viewId: "",
filter: "",
assets: [],
videos: [],
filtered: [],
filteredChildren: []
},
components: [ {
name: "modalHeader",
classes: "modal-header",
components: [ {
kind: enyo.Button,
classes: "close",
content: "\u00d7",
ontap: "cancelLibraryPopup"
}, {
tag: "h3",
name: "modalTitle",
content: "assets"
} ]
}, {
name: "modalBody",
classes: "modal-body",
components: [ {
tag: "div",
name: "searchCon",
classes: "row-fluid",
components: [ {
kind: "enyo.Input",
name: "searchTag",
classes: "searchTagInput span12",
placeholder: "zoeken op naam of kernwoorden",
onkeyup: "searchHandler",
type: "text"
} ]
}, {
name: "results",
classes: "modal-body__results"
} ]
}, {
tag: "div",
name: "modalButtonsCon",
classes: "modal-footer",
components: [ {
kind: "enyo.Button",
name: "savelibrarybtn",
content: "selecteer",
ontap: "submitLibraryPopup",
classes: "btn btn-primary"
}, {
kind: "enyo.Button",
name: "cancellibrarybtn",
content: "annuleer",
ontap: "cancelLibraryPopup",
classes: "btn"
}, {
kind: "enyo.Button",
name: "previewAssetBtn",
content: "Preview",
classes: "btn pull-left",
ontap: "previewAssetItem"
}, {
kind: "enyo.Button",
name: "btnResetVimeo",
classes: "btn pull-left",
ontap: "reloadAssets",
showing: !1,
components: [ {
tag: "span",
content: "Reload&nbsp;",
allowHtml: !0
}, {
name: "icnLoading",
tag: "i",
classes: "icon-spinner icon-spin icon-large",
showing: !1
} ]
} ]
} ],
create: function() {
this.inherited(arguments), this.retrieveAssets();
},
clearLibraryContent: function() {
this.$.results.destroyClientControls(), this.setFilteredChildren([]);
},
retrieveAssets: function() {
var e;
this.getSearchType() !== "Video" ? (e = new enyo.Ajax({
url: Settings.WEBAPP + "asset/asset/frontendAssetPicker",
method: "POST",
handleAs: "json",
xhrFields: {
withCredentials: !0
}
}), e.response(enyo.bind(this, "completeGetAssetsHandler")), e.go({
searchType: this.getSearchType()
})) : (this.$.btnResetVimeo.setShowing(!0), e = new enyo.Ajax({
url: Settings.WEBAPP + "vimeo/getvideos",
handleAs: "json",
xhrFields: {
withCredentials: !0
}
}), e.response(enyo.bind(this, "completeGetVideosHandler")), e.go({
per_page: 50,
page: 1
}));
},
reloadAssets: function() {
this.$.icnLoading.setShowing(!0), this.$.btnResetVimeo.setDisabled(!0);
var e = new enyo.Ajax({
url: Settings.WEBAPP + "vimeo/resetVideos",
handleAs: "json",
xhrFields: {
withCredentials: !0
}
});
e.response(enyo.bind(this, "completeResetVideosHandler")), e.go({
per_page: 50,
page: 1
});
},
completeGetAssetsHandler: function(e, t) {
this.setAssets(t);
},
completeGetVideosHandler: function(e, t) {
this.$.icnLoading.setShowing(!1), this.$.btnResetVimeo.setDisabled(!1), typeof t == "string" && (t = JSON.parse(t));
if (t.page < t.last_page) {
var n = t.page + 1, r = new enyo.Ajax({
url: Settings.WEBAPP + "vimeo/getVideos",
handleAs: "json",
xhrFields: {
withCredentials: !0
}
});
r.response(enyo.bind(this, "completeResetVideosHandler")), r.go({
per_page: t.per_page,
page: n
}), this.$.icnLoading.setShowing(!0), this.$.btnResetVimeo.setDisabled(!0);
}
this.setAssets(this.assets.concat(t.videos));
},
completeResetVideosHandler: function(e, t) {
this.$.icnLoading.setShowing(!1), this.$.btnResetVimeo.setDisabled(!1);
if (t.page < t.last_page) {
var n = t.page + 1, r = new enyo.Ajax({
url: Settings.WEBAPP + "vimeo/resetVideos",
handleAs: "json",
xhrFields: {
withCredentials: !0
}
});
r.response(enyo.bind(this, "completeResetVideosHandler")), r.go({
per_page: t.per_page,
page: n
}), this.$.icnLoading.setShowing(!0), this.$.btnResetVimeo.setDisabled(!0);
}
t.page === 1 ? this.setAssets(t.videos) : this.setAssets(this.assets.concat(t.videos));
},
searchHandler: function(e, t) {
this.setFilter(t.target.value);
},
assetsChanged: function() {
this.filterChanged(), this.render();
},
filterChanged: function() {
var e = [], t = this.getFilter().split(/ ?, ?/), n, r = t.length, i = this.getAssets().length;
for (n = 0; n < i; n++) (this.getSearchType() !== "Video" && this.filterChangedOther(this.getAssets()[n], t, r) || this.getSearchType() === "Video" && this.filterChangedVideo(this.getAssets()[n], t, r)) && e.push(this.getAssets()[n]);
this.setFiltered(e.length > 0 ? e : this.getAssets());
},
filterChangedOther: function(e, t, n) {
var r = !1, i = e.options !== null ? e.options : "", s, o;
for (o = 0; o < n; o++) {
s = t[o].toLowerCase();
if (i.toLowerCase().indexOf(s) > -1 || e.css_class.toLowerCase().indexOf(s) > -1) r = !0;
}
return r;
},
filterChangedVideo: function(e, t, n) {
var r = !1, i = e.options !== null ? e.options : "", s, o;
i = e.name !== null ? e.name : "";
var u = e.description !== null ? e.description : "";
for (o = 0; o < n; o++) {
s = t[o].toLowerCase();
if (i.toLowerCase().indexOf(s) > -1 || u.toLowerCase().indexOf(s) > -1 || e.tags.toString().toLowerCase().indexOf(s) > -1) r = !0;
}
return r;
},
filteredChanged: function() {
this.clearLibraryContent();
var e, t = this.getFiltered().length, n = 0;
for (e = 0; e < t; e++) {
var r = this.getFiltered()[e];
e % 3 === 0 && (n++, this.createComponent({
tag: "div",
classes: "row-fluid",
container: this.$.results,
name: "row-" + n
}));
var i = this.createComponent({
name: "asset_" + e,
kind: this.getSearchType() !== "Video" ? "educate.create.Asset" : "educate.create.Vimeo",
asset: r,
ontap: "assetLibraryItemClicked",
container: this.$["row-" + n]
});
this.filteredChildren.push(i);
}
this.$.results.render();
},
assetLibraryItemClicked: function(e) {
this.deselectAssetItems(), this.selectAssetItem(e), this.setSelectedAsset(e.getAsset());
},
selectAssetItem: function(e) {
e.addClass("assetSelected");
},
deselectAssetItems: function() {
var e, t = this.filteredChildren.length;
for (e = 0; e < t; e++) this.filteredChildren[e].removeClass("assetSelected");
},
submitLibraryPopup: function() {
if (this.getSelectedAsset() !== null || this.getSelectedAsset() !== "") this.inherited(arguments), this.bubble("assetsLibrarySubmitted", this), this.bubble("sendToColumnExercise", {
image: this
});
},
previewAssetItem: function() {
this.getSelectedAsset() !== "" && this.bubble("previewAssetBtnClicked", {
assetSrc: this.getSelectedAsset()
});
}
});

// LinkScene.js

enyo.kind({
name: "educate.create.dialoogvensters.linkscene.LinkScene",
kind: "enyo.Popup",
classes: "linkSceneDialoog modal",
floating: !0,
scrim: !0,
autoDismiss: !1,
modal: !0,
published: {
lesParent: "",
arrLinkedOef: [],
arrOefToUpdate: []
},
handlers: {
linkAdded: "linkAddedHandler"
},
components: [ {
tag: "div",
classes: "modal-header",
components: [ {
tag: "button",
classes: "close",
content: "&times",
allowHtml: !0,
ontap: "cancelLinkScenePopup"
}, {
tag: "h3",
content: "Bestand koppelen"
} ]
}, {
tag: "div",
name: "linkSceneBody",
classes: "modal-body",
components: [ {
tag: "p",
content: "Oefeningen die aan deze les gekoppeld zijn:"
}, {
kind: "educate.hulpklassen.list.List",
name: "linkedOefList",
width: "400",
height: "200",
arrList: this.arrLinkedOef
}, {
tag: "div",
name: "oefAddedCon",
classes: "oefAddedCon"
}, {
kind: "enyo.Button",
classes: "btn btn-block btn-primary",
name: "addOef",
ontap: "addOef",
components: [ {
tag: "i",
classes: "icon-plus icon-white",
content: " "
}, {
tag: "span",
content: "Oefening toevoegen",
components: []
} ]
}, {
kind: "enyo.Button",
classes: "btn btn-block btn-danger",
name: "removeOef",
ontap: "removeOef",
components: [ {
tag: "i",
classes: "icon-trash icon-white",
content: " "
}, {
tag: "span",
content: "verwijder selectie",
components: []
} ]
} ]
}, {
tag: "div",
name: "linkSceneFooter",
classes: "modal-footer",
components: [ {
tag: "button",
name: "submitLinkScene",
content: "Ok",
ontap: "submitLinkScenePopup"
}, {
tag: "button",
name: "cancelLinkScene",
content: "Annuleer",
ontap: "cancelLinkScenePopup"
} ]
} ],
create: function() {
this.inherited(arguments), this.show(), this.setArrOefToUpdate([]), this.loadOefeningen(), this.render();
},
destroy: function() {
this.inherited(arguments);
},
rendered: function() {
this.inherited(arguments);
},
loadOefeningen: function() {
var e = "parent=" + this.getLesParent();
$.ajax({
url: Settings.SERVER + "getOefeningenByParent",
type: "GET",
data: e,
dataType: "json",
success: enyo.bind(this, "completeLoadOefeningHandler"),
error: this.errorHandler
});
},
completeLoadOefeningHandler: function(e, t) {
this.makeOefeningList(e);
},
errorHandler: function(e, t) {
console.log("OefeningenError", e, t);
},
makeOefeningList: function(e) {
this.setArrLinkedOef([]);
for (var t in e) {
var n = new Object;
n.link = e[t], n.label = e[t].value + " - " + e[t].name, this.getArrLinkedOef().push(n);
}
this.$.linkedOefList.setArrList(this.getArrLinkedOef());
},
addOef: function(e, t) {
this.$.addLinkPopup || this.createComponent({
kind: "educate.create.dialoogvensters.linkscene.AddLink",
name: "addLinkPopup"
});
},
removeOef: function(e, t) {
if (this.$.linkedOefList.getSelection().link) {
var n = this.getArrLinkedOef();
for (var r in n) n[r].link == this.$.linkedOefList.getSelection().link && (this.getArrOefToUpdate().push({
id: n[r].link.id,
parent: 0
}), n.splice(r, 1));
this.$.linkedOefList.recreateList();
}
},
linkAddedHandler: function(e, t) {
this.createComponents([ {
tag: "div",
name: t.oefNaam,
container: this.$.oefAddedCon,
oefId: t.oefId,
components: [ {
tag: "div",
content: t.oefValue + " - " + t.oefNaam
}, {
tag: "div",
classes: "icon-remove",
ontap: "cancelAddOef"
} ]
} ]), this.$.oefAddedCon.render();
},
cancelAddOef: function(e, t) {
t.originator.parent.destroy();
},
submitLinkScenePopup: function() {
this.handleOefToAdd(), this.getArrOefToUpdate().length > 0 && this.updateOef();
},
handleOefToAdd: function() {
var e = this.$.oefAddedCon.children, t = this.getLesParent();
for (var n in e) this.getArrOefToUpdate().push({
id: e[n].oefId,
parent: t
});
},
updateOef: function() {
var e = {
oef: this.getArrOefToUpdate()
};
$.ajax({
url: Settings.SERVER + "updateOefeningen",
type: "POST",
data: e,
success: enyo.bind(this, "completeUpdateOefeningHandler"),
error: this.errorHandler
});
},
completeUpdateOefeningHandler: function(e, t) {
var n = "De koppelingen zijn upgedate.";
this.bubble("onMessage", {
message: n,
duration: 3e3
}), this.destroy();
},
cancelLinkScenePopup: function() {
this.destroy();
}
});

// AddLink.js

enyo.kind({
name: "educate.create.dialoogvensters.linkscene.AddLink",
kind: "enyo.Popup",
classes: "addLinkDialoog modal",
floating: !0,
scrim: !0,
autoDismiss: !1,
modal: !0,
published: {
selectedOefId: "",
selectedOefNaam: "",
selectedOefValue: ""
},
handlers: {
menuItemSelected: "menuItemSelectedHandler"
},
components: [ {
tag: "div",
classes: "modal-header",
components: [ {
tag: "button",
classes: "close",
content: "&times",
allowHtml: !0,
ontap: "cancelAddLinkPopup"
}, {
tag: "h3",
content: "Oefening toevoegen"
} ]
}, {
tag: "div",
name: "addLinkBody",
classes: "modal-body",
components: [ {
tag: "label",
content: "Oef Id: "
}, {
kind: "onyx.Input",
name: "txtSelectedOefId",
attributes: {
readOnly: "readOnly"
}
}, {
tag: "label",
content: "Oef naam: "
}, {
kind: "onyx.Input",
name: "txtSelectedOefNaam",
attributes: {
readOnly: "readOnly"
}
}, {
tag: "label",
content: "Oef value: "
}, {
kind: "onyx.Input",
name: "txtSelectedOefValue",
onchange: "searchValueOef"
}, {
tag: "div",
classes: "btnOefNoLink",
ontap: "toggleOefNoLink",
components: [ {
tag: "div",
content: "Oefeningen zonder koppeling"
}, {
tag: "div",
classes: "icon-chevron-down"
} ]
}, {
tag: "div",
name: "oefNoLinkCon",
classes: "oefNoLinkCon",
showing: !1
}, {
kind: "educate.hulpklassen.menuStructuur.MenuStructuur",
name: "menuStructuur",
niveau: [ "oefening" ],
selectNiveau: !0
} ]
}, {
tag: "div",
name: "addLinkFooter",
classes: "modal-footer",
components: [ {
tag: "button",
name: "submitAddLink",
content: "Toevoegen",
ontap: "submitAddLinkPopup"
}, {
tag: "button",
name: "cancelAddLink",
content: "Annuleer",
ontap: "cancelAddLinkPopup"
} ]
} ],
create: function() {
this.inherited(arguments), this.show(), this.getOefNoLink(), this.render();
},
destroy: function() {
this.inherited(arguments);
},
rendered: function() {
this.inherited(arguments);
},
selectedOefIdChanged: function() {
this.$.txtSelectedOefId.setValue(this.getSelectedOefId());
},
selectedOefNaamChanged: function() {
this.$.txtSelectedOefNaam.setValue(this.getSelectedOefNaam());
},
selectedOefValueChanged: function() {
this.$.txtSelectedOefValue.setValue(this.getSelectedOefValue());
},
getOefNoLink: function() {
$.ajax({
url: Settings.SERVER + "getOefeningenNoLink",
type: "GET",
dataType: "json",
success: enyo.bind(this, "completeGetOefeningNoLinkHandler"),
error: this.errorHandler
});
},
completeGetOefeningNoLinkHandler: function(e, t) {
for (var n in e) this.createComponent({
tag: "div",
container: this.$.oefNoLinkCon,
content: e[n].value + " - " + e[n].name,
oef: e[n],
ontap: "noLinkOefTappedHandler"
});
this.$.oefNoLinkCon.render();
},
searchValueOef: function(e, t) {
var n = "type=oef&searchvalue=" + this.$.txtSelectedOefValue.getValue();
$.ajax({
url: Settings.SERVER + "getSceneIdBySceneValue",
type: "GET",
data: n,
dataType: "json",
success: enyo.bind(this, "completeSearchOefHandler"),
error: this.errorHandler
});
},
completeSearchOefHandler: function(e, t) {
e != 0 ? (this.setSelectedOefId(e.id), this.setSelectedOefNaam(e.name)) : (this.setSelectedOefId(""), this.setSelectedOefNaam(""));
},
errorHandler: function(e, t) {
console.log("addLinkError", e, t);
},
toggleOefNoLink: function() {
this.$.oefNoLinkCon.setShowing(!this.$.oefNoLinkCon.getShowing());
},
noLinkOefTappedHandler: function(e, t) {
this.setSelectedOefId(t.originator.oef.id), this.setSelectedOefNaam(t.originator.oef.name), this.setSelectedOefValue(t.originator.oef.value);
},
menuItemSelectedHandler: function(e, t) {
this.clearTextFields(), this.setSelectedOefId(t.selectedId), this.setSelectedOefNaam(t.selectedNaam), this.setSelectedOefValue(t.selectedValue);
},
clearTextFields: function() {
this.$.txtSelectedOefId.setValue(""), this.$.txtSelectedOefNaam.setValue(""), this.$.txtSelectedOefValue.setValue("");
},
submitAddLinkPopup: function() {
var e = new Object;
e.oefId = this.getSelectedOefId(), e.oefNaam = this.getSelectedOefNaam(), e.oefValue = this.getSelectedOefValue(), this.bubble("linkAdded", e), this.destroy();
},
cancelAddLinkPopup: function() {
this.destroy();
}
});

// Create.js

"use strict";

enyo.kind({
name: "Create",
kind: enyo.Control,
layoutKind: "FittableRowsLayout",
classes: "onyx create",
published: {
carrier: window.settings.CARRIERS.LES,
tabBladen: "",
aantalViewsCollected: 0,
views: [],
sceneParent: "",
position: "",
value: "",
databaseId: "",
viewsToOpen: [],
tabsToOpen: [],
objectsDeleted: [],
closeSceneAfterSave: !1,
activeView: null
},
handlers: {
onkeydown: "keypressedHandler",
onMessage: "onMessageHandler",
tabContentChanged: "tabContentChangedHandler",
viewObjectenCollected: "viewObjectenCollectedHandler",
previewAssetBtnClicked: "previewAssetBtnClickedHandler",
viewBtnClicked: "viewBtnClickedHandler",
addView: "addViewHandler",
removeView: "removeViewHandler",
frameBottomIconClicked: "frameBottomIconClickedHandler",
saveScenePopupSubmitted: "saveScenePopupSubmittedHandler",
saveScenePopupCancelled: "saveScenePopupCancelledHandler",
openScenePopupSubmitted: "openScenePopupSubmittedHandler",
closeScenePopupSubmitted: "closeScenePopupSubmittedHandler",
editNameScenePopupSubmitted: "editNameScenePopupSubmittedHandler",
addObjectToArrDeleted: "addObjectToArrDeletedHandler",
frameBtnsViewCreated: "frameBtnsViewCreatedHandler",
newSceneClicked: "newSceneHandler",
openSceneClicked: "openSceneHandler",
lesClicked: "lesClickedHandler",
oefeningClicked: "oefeningClickedHandler",
previewClicked: "previewClickedHandler",
saveClicked: "saveHandler",
saveAsClicked: "saveAsHandler",
publishClicked: "publishHandler",
closeSceneClicked: "closeSceneClickedHandler",
linkSceneClicked: "linkSceneClickedHandler",
removeClicked: "removeHandler",
emptySceneClicked: "emptySceneClickedHandler",
vensterLagenClicked: "vensterLagenClickedHandler",
vensterLijstClicked: "vensterLijstClickedHandler",
vensterTekendoosClicked: "vensterTekendoosClickedHandler",
toSceneClicked: "toSceneClickedHandler",
tekendoosClicked: "tekendoosClickedHandler",
addSquare: "addSquareHandler",
toggleDrawing: "toggleDrawingHandler",
lineColorSelected: "lineColorSelectedHandler",
fillColorSelected: "fillColorSelectedHandler"
},
components: [ {
kind: "educate.create.dialoogvensters.MessageBox",
name: "messageBox"
}, {
kind: "educate.create.titelbalk.Titelbalk",
name: "titelbalk"
}, {
name: "columns",
layoutKind: "FittableColumnsLayout",
fit: !0
}, {
kind: "educate.create.onderbalk.Onderbalk",
name: "onderbalk"
}, {
kind: enyo.Signals,
onkeydown: "keypressedHandler"
} ],
create: function() {
this.inherited(arguments), this._previewWindow = "preview_window_" + (new Date).getTime();
},
rendered: function() {
this.inherited(arguments), scene ? this.loadSceneHandler(scene) : this.openNewScene();
},
newSceneHandler: function() {
window.location = Settings.CREATE;
},
openNewScene: function() {
this.updateSceneTitle("naam van de scene"), this.updateSceneValue(""), this.setSceneParent(null), this.setPosition(null), this.setDatabaseId(null), this.deleteAllViews(), this.setObjectsDeleted([]), this.setAantalViewsCollected(0), this.makeView(), this.setTabBladen(""), this.createSceneTabs(), this.enableDisableToSceneBtn();
},
updateSceneTitle: function(e) {
this.$.titelbalk.setSceneTitle(e), this.sceneName = e;
},
updateSceneValue: function(e) {
this.$.titelbalk.setSceneValue(e), this.setValue(e);
},
closeSceneHandler: function() {},
closeSceneClickedHandler: function() {
this.$.closeScenePopup && this.$.closeScenePopup.destroy(), this.createComponent({
name: "closeScenePopup",
kind: "educate.create.dialoogvensters.CloseScene"
});
},
closeScenePopupSubmittedHandler: function(e, t) {
t.result === "save" ? this.closeSceneWithSave() : this.closeSceneWithoutSave();
},
closeSceneWithSave: function() {
this.setCloseSceneAfterSave(!0), this.openSaveSceneDialoog();
},
closeSceneWithoutSave: function() {
this.returnToDashboard();
},
returnToDashboard: function() {
window.scene === null && (window.location = Settings.WEBAPP + "admin/dashboard");
var e = window.scene.slugData, t = Settings.SPRUCE + "#/settings/" + e.publication;
window.location = t;
},
editNameScenePopupSubmittedHandler: function(e, t) {
this.updateSceneTitle(t.editedSceneName), this.updateSceneValue(t.editedSceneValue);
},
openScenePopupSubmittedHandler: function(e, t) {
this.closeSceneHandler();
var n = t.getSelectedSceneValue();
window.location = Settings.CREATE + "#/" + n;
},
openSceneHandler: function() {
this.$.openScenePopup && this.$.openScenePopup.destroy(), this.createComponent({
name: "openScenePopup",
kind: "educate.create.dialoogvensters.OpenScene"
});
},
resetHash: function(e) {
var t = window.getHashParams(), n = "#";
for (var r in t) r !== "id" && (n += "&" + r + "=" + t[r]);
e ? (n += "&id=" + e, this.$.titelbalk.$.menuCreator.$.toScene.removeClass("disabled")) : this.$.titelbalk.$.menuCreator.$.toScene.addClass("disabled"), location.hash = n;
},
jsonRequestHandler: function(e) {
if (e.responseText.indexOf("error") === -1) {
var t = enyo.json.parse(e.responseText);
this.updateSceneTitle(t.name), this.setSceneParent(t.parent), this.updateSceneValue(t.value), this.setPosition(t.position), this.setDatabaseId(t.id), this.parseCollection(t.collection), this.createViewsToOpen(), this.setTabBladen(""), this.createSceneTabs(), this.openSceneTabs();
} else console.log(e.responseText), alert("we konden de gevraagde scene niet oproepen.");
},
loadSceneHandler: function(e) {
this.updateSceneTitle(e.name), this.setSceneParent(e.parent), this.updateSceneValue(e.value), this.handleCarrier(e.carrier.code), this.setPosition(e.position), this.setDatabaseId(e.id), this.parseCollection(e.collection), this.createViewsToOpen(), this.setTabBladen(""), this.createSceneTabs(), this.openSceneTabs(), this.enableDisableToSceneBtn();
},
handleCarrier: function(e) {
this.setCarrier(e);
var t = this.$.titelbalk.$.menuCreator;
e === window.settings.CARRIERS.LES ? (t.addSelectionToMenuItem(t.$.typeLes), t.removeSelectionFromMenuItem(t.$.typeOef)) : (t.addSelectionToMenuItem(t.$.typeOef), t.removeSelectionFromMenuItem(t.$.typeLes));
},
parseCollection: function(e) {
var t;
if (Array.isArray(e)) {
var n, r = e.length;
for (n = 0; n < r; n++) {
t = e[n];
switch (t.carrier.name) {
case "sceneTab":
this.getTabsToOpen().push(t);
break;
case "sceneView":
this.getViewsToOpen().push(t);
}
}
} else for (var i in e) if (e.hasOwnProperty(i)) {
t = e[i];
switch (t.carrier.name) {
case "sceneTab":
this.getTabsToOpen().push(t);
break;
case "sceneView":
this.getViewsToOpen().push(t);
}
}
},
createViewsToOpen: function() {
if (this.getViewsToOpen().length > 0) {
this.getViewsToOpen().sort(enyo.bind(this, "sortViews"));
var e = this.getViewsToOpen(), t, n = e.length;
for (t = 0; t < n; t++) this.openView(e[t]);
this.makeViewActive(this.getViews()[0]), this.getViews()[0].arrangeObjecten(), this.getViews()[0].render();
} else this.makeView();
},
sortViews: function(e, t) {
return e.value - t.value;
},
makeViewActive: function(e) {
this.hideAllViews(), this.setActiveView(e), e.setShowing(!0), e.setViewActive(!0), this.waterfallDown("viewActivated", {
view: e
});
},
openView: function(e) {
this.hideAllViews();
var t = e.value, n = this.createComponent({
container: this.$.columns,
kind: "educate.create.view.View",
name: e.name,
layername: e.name,
viewId: t,
value: t,
viewActive: !1,
collection: e.collection,
objectId: e.id,
databaseId: e.id
});
this.getViews().push(n), this.waterfallDown("viewAdded", t), this.resized();
},
enableDisableToSceneBtn: function() {
this.getDatabaseId() ? this.$.titelbalk.$.menuCreator.$.toScene.removeClass("disabled") : this.$.titelbalk.$.menuCreator.$.toScene.addClass("disabled");
},
openSceneTabs: function() {
this.$.onderbalk.openSceneTabsHandler(this, this.getTabsToOpen());
},
createSceneTabs: function() {
this.removeSceneTabs();
var e = [ "info", "leerinhoud", "leerdoel", "begrippen", "links" ];
this.$.onderbalk.createSceneTabsHandler(this, e), this.$.onderbalk.updateTabs(), this.setTabBladen(this.$.onderbalk.tabBladen);
},
removeSceneTabs: function() {
this.waterfallDown("removeSceneTabs");
},
tabContentChangedHandler: function(e, t) {
this.setTabBladen(t.tabBladen);
},
countViews: function() {
return this.getViews().length + 1;
},
addViewHandler: function() {
this.getViews().length < 4 && this.makeView();
},
makeView: function() {
this.hideAllViews();
var e = this.countViews(), t = this.createComponent({
container: this.$.columns,
kind: educate.create.view.View,
name: "view" + e,
layername: "view" + e,
viewId: e,
value: e,
viewActive: !0
});
this.getViews().push(t), this.waterfallDown("viewAdded", e), this.resized();
},
removeViewHandler: function(e, t) {},
viewBtnClickedHandler: function(e, t) {
this.hideAllViews(), this.$[t.linked].setShowing(!0), this.$[t.linked].setViewActive(!0), this.resized();
},
hideAllViews: function() {
var e = this.getViews(), t, n = e.length;
for (t = 0; t < n; t++) e[t].setShowing(!1), e[t].setViewActive(!1);
},
deleteAllViews: function() {
var e = this.getViews(), t, n = e.length;
for (t = 0; t < n; t++) e[t].kindName === "educate.create.view.View" && (e[t].deleteAllViewsHandler(), delete e[t]);
this.$.onderbalk.deleteAllViewsHandler(), this.setViews([]);
},
previewClickedHandler: function() {
window.open(Settings.LES + "#/preview/" + this.getValue(), this._previewWindow);
},
emptySceneClickedHandler: function() {
this.sceneName && this.sceneName !== "naam van de scene" && this.getSceneParent() !== "" && this.getValue() ? this.waterfallDown("colectViewObjecten", "emptyScene") : (this.saveCancelled(), this.showMessage("Gelieve eerst de scene opslaan.", 2e3));
},
saveHandler: function() {
this.sceneName && this.sceneName !== "naam van de scene" && this.getSceneParent() !== "" && this.getValue() ? this.waterfallDown("colectViewObjecten", "save") : (this.saveCancelled(), this.showMessage("Gelieve eerst naam, locatie en value te kiezen.", 2e3));
},
saveAsHandler: function() {
this.openSaveSceneDialoog();
},
publishHandler: function() {
this.sceneName && this.sceneName !== "naam van de scene" && this.getSceneParent() !== "" && this.getValue() ? this.waterfallDown("colectViewObjecten", "publish") : (this.saveCancelled(), this.showMessage("Gelieve eerst naam, locatie en value te kiezen.", 2e3));
},
openSaveSceneDialoog: function() {
this.$.saveScenePopup && this.$.saveScenePopup.destroy(), this.createComponent({
name: "saveScenePopup",
kind: "educate.create.dialoogvensters.SaveScene",
sceneNaam: this.sceneName,
sceneValue: this.getValue(),
selectedCat: this.getSceneParent(),
typeScene: this.getCarrier() === settings.CARRIERS.LES ? "les" : "oefening"
});
},
saveScenePopupSubmittedHandler: function(e, t) {
this.updateSceneTitle(t.getSceneNaam()), this.setSceneParent(t.getSelectedCat()), this.updateSceneValue(t.getSceneValue()), this.saveHandler();
},
saveScenePopupCancelledHandler: function() {
this.saveCancelled();
},
saveCancelled: function() {
this.setCloseSceneAfterSave(!1);
},
removeHandler: function() {
this.waterfallDown("removeClicked");
},
viewObjectenCollectedHandler: function(e, t) {
this.aantalViewsCollected++, this.getAantalViewsCollected() === this.getViews().length && (t.type === "emptyScene" && this.emptyScene(), this.savePreviewScene(t.type), this.setAantalViewsCollected(0));
},
emptyScene: function() {
var e = this.getViews(), t, n = e.length;
for (t = 0; t < n; t++) this.getObjectsDeleted().push(e[t].databaseId);
},
savePreviewScene: function(e) {
this.$.onderbalk.updateTabs();
var t = this.mergeObjecten(this.getViews(), this.getTabBladen()), n = {};
n.name = this.sceneName, n.carrier = this.carrier, n.parent = this.getSceneParent(), n.value = this.getValue(), n.databaseId = this.getDatabaseId() ? this.getDatabaseId() : null, n.position = this.getPosition() ? this.getPosition() : null, n.collection = this.collectObjects(t), n.objectsToDelete = this.getObjectsDeleted() ? this.getObjectsDeleted() : null;
switch (e) {
case "emptyScene":
case "save":
this.saveComponents(n, 0);
break;
case "publish":
this.saveComponents(n, 1);
break;
default:
this.previewHandler(n);
}
},
mergeObjecten: function(e, t) {
var n;
for (n in t) t.hasOwnProperty(n) && e.push(t[n]);
return e;
},
collectObjects: function(e) {
var t = [], n, r = e.length;
for (n = 0; n < r; n++) {
var i = e[n];
if (typeof i == "undefined") continue;
if (i instanceof enyo.Control == 0) {
t.push(i);
continue;
}
e[n].linked && e[n].kind !== "educate.create.components.bediening.InfoIcon" && e[n].kind !== "educate.create.components.bediening.InfoIconContent" && e[n].kind !== "educate.create.components.bediening.PhotoIcon" && e[n].kind !== "educate.create.components.bediening.PhotoIconContent" && (i = e[n].linked);
if (i.kind === "educate.components.3DObject.3DCamera") continue;
var s = {
name: i.getLayername ? i.getLayername() : i.getName ? i.getName() : null,
carrier: typeof i.getCarrier() == "number" ? i.getCarrier() : i.getCarrier().code,
value: i.getValue ? i.getValue() : null,
solution: i.getSolution ? i.getSolution() : null,
answered: i.getAnswered ? i.getAnswered() : null,
width: i.getWidth && Number(i.getWidth()) > 0 ? .5 + Number(i.getWidth()) >> 0 : null,
height: i.getHeight && Number(i.getHeight()) > 0 ? .5 + Number(i.getHeight()) >> 0 : null,
css_class: i.getCss_class ? i.getCss_class() : null,
position_x: i.getPosition_x ? .5 + i.getPosition_x() >> 0 : null,
position_y: i.getPosition_y ? .5 + i.getPosition_y() >> 0 : null,
position_z: i.getPosition_z ? .5 + i.getPosition_z() >> 0 : null,
position: i.getPosition ? i.getPosition() : null,
origin: i.getOrigin ? i.getOrigin() : null,
rotation: i.getRotation ? i.getRotation() : null,
inLayerHolder: i.getInLayerHolder && i.getInLayerHolder() ? 1 : 0
};
e[n].kindName === "educate.create.view.lijst.LijstitemGroep" ? s.collection = e[n].collection ? this.collectObjects(e[n].collection) : null : s.collection = i.getCollection && i.getCollection() ? this.collectObjects(i.getCollection()) : null, s.objHandlers = i.getObjectHandlers && i.getObjectHandlers() ? this.collectActions(i.getObjectHandlers()) : null, s.contentLink = i.getLinked && i.getLinked() && i.getLinked().carrier === window.settings.CARRIERS.CONTENT_ICON ? this.collectObjects([ i.getLinked() ]) : null, s.laag = i.getLaag && i.getLaag() ? this.collectObjects([ i.getLaag() ]) : null, s.linkedEigenschappen = i.getLinkedEigenschappen && i.getLinkedEigenschappen() ? this.collectLinkEigenschappen(i.getLinkedEigenschappen()) : null, s.globalLinkEigenschapVariables = i.globalLinkEigenschapVariables ? i.globalLinkEigenschapVariables : null, s.objectId = i.getObjectId ? i.getObjectId() : null, s.databaseId = i.getDatabaseId ? i.getDatabaseId() : null, s.options = i.getOptions && i.getOptions() ? JSON.stringify(i.getOptions()) : null, s.active = i.active ? 1 : 0, s.isPosLimiet = i.isPosLimiet ? i.isPosLimiet : null, s.isRotLimiet = i.isRotLimiet ? i.isRotLimiet : null, s.position_x_min = i.position_x_min !== null ? i.position_x_min : null, s.position_x_max = i.position_x_max !== null ? i.position_x_max : null, s.position_y_min = i.position_y_min !== null ? i.position_y_min : null, s.position_y_max = i.position_y_max !== null ? i.position_y_max : null, s.position_z_min = i.position_z_min !== null ? i.position_z_min : null, s.position_z_max = i.position_z_max !== null ? i.position_z_max : null, s.rotation_x_min = i.rotation_x_min !== null ? i.rotation_x_min : null, s.rotation_x_max = i.rotation_x_max !== null ? i.rotation_x_max : null, s.rotation_y_min = i.rotation_y_min !== null ? i.rotation_y_min : null, s.rotation_y_max = i.rotation_y_max !== null ? i.rotation_y_max : null, s.rotation_z_min = i.rotation_z_min !== null ? i.rotation_z_min : null, s.rotation_z_max = i.rotation_z_max !== null ? i.rotation_z_max : null, t.push(s);
}
return t;
},
collectActions: function(e) {
var t = [], n, r = e.length;
for (n = 0; n < r; n++) {
var i = {};
i.databaseId = e[n].eventID, i.name = e[n].eventName, i.value = e[n].event;
var s = window.settings.CARRIERS;
i.carrier = e[n].eigenschap ? s.LINKEIGENSCHAP : s.EVENTACTIONHANDLER, i.collection = [];
for (var o in e[n].targets) for (var u in e[n].reactions[o]) {
var a = {};
a.name = e[n].eventName + ".reactie." + u, a.carrier = window.settings.CARRIERS.REACTIE, a.solution = e[n].targets[o], a.value = e[n].reactions[o][u].join(), a.position = u, a.finalObject = !0, i.collection.push(a);
}
t.push(i);
}
return t;
},
collectLinkEigenschappen: function(e) {
var t = [], n, r = e.length;
for (n = 0; n < r; n++) {
var i = {};
i.databaseId = e[n].linkeigenschapID, i.name = e[n].linkeigenschapName, i.solution = e[n].eigenschap, i.answered = e[n].formule, i.css_class = e[n].offset, i.carrier = window.settings.CARRIERS.LINKEIGENSCHAP, i.collection = [], t.push(i);
}
return t;
},
saveComponents: function(e, t) {
var n = new enyo.Ajax({
url: Settings.SERVER + "saveComponents",
method: "POST",
xhrFields: {
withCredentials: !0
}
});
n.error(enyo.bind(this, "errorSaveResponse")), n.response(enyo.bind(this, "processResponse")), n.go({
scene: enyo.json.stringify(e),
publish: t
});
},
processResponse: function(e, t) {
this.setObjectsDeleted([]), this.closeSceneHandler();
var n = t;
this.getCloseSceneAfterSave() ? (this.setCloseSceneAfterSave(!1), this.returnToDashboard()) : n.search("error:") === -1 ? (this.showMessage("Opslaan van de scene is succesvol.", 2e3), setTimeout(function() {
window.location.reload();
}, 3e3)) : this.showMessage("Er is iets misgelopen.", 2e3);
},
errorSaveResponse: function() {
console.log("error bij savecomponents request"), this.saveCancelled();
},
onMessageHandler: function(e, t) {
this.showMessage(t.message, t.duration && t.duration);
},
showMessage: function(e, t) {
this.$.messageBox.showMessageBox(e, t && t);
},
addObjectToArrDeletedHandler: function(e, t) {
this.getObjectsDeleted().push(t.objDbId);
},
frameBottomIconClickedHandler: function(e, t) {
this.waterfallDown("frameBottomIconClicked", t);
},
frameBtnsViewCreatedHandler: function(e, t) {
this.waterfallDown("frameBtnsViewCreated", t);
},
previewAssetBtnClickedHandler: function(e, t) {
this.$.previewBox && this.$.previewBox.destroy(), this.createComponent({
name: "previewBox",
kind: "educate.hulpklassen.library.PreviewBox",
previewSrc: t.assetSrc
});
},
lesClickedHandler: function() {
this.setCarrier(window.settings.CARRIERS.LES);
},
oefeningClickedHandler: function() {
this.setCarrier(window.settings.CARRIERS.OEFENING);
},
linkSceneClickedHandler: function() {
this.getCarrier() === window.settings.CARRIERS.LES ? this.getDatabaseId() ? this.$.linkScenePopup || this.createComponent({
kind: "educate.create.dialoogvensters.linkscene.LinkScene",
name: "linkScenePopup",
lesParent: this.getDatabaseId()
}) : this.showMessage("Gelieve eerst de les op te slaan.") : this.showMessage("Enkel beschikbaar bij het type les.");
},
vensterLagenClickedHandler: function() {
this.waterfallDown("toggleVensterLagen");
},
vensterLijstClickedHandler: function() {
this.waterfallDown("vensterLijstClicked");
},
vensterTekendoosClickedHandler: function() {
this.waterfallDown("toggleVensterTekendoos");
},
toSceneClickedHandler: function() {
window.open(Settings.LES + "#/" + this.getValue(), this._previewWindow);
},
keypressedHandler: function(e, t) {
if (t.shiftKey) switch (t.keyCode) {
case 76:
this.waterfallDown("shiftLPressed");
} else if (t.metaKey) switch (t.keyCode) {
case 68:
this.getActiveView().deselectedObjectsHandler(), t.preventDefault();
break;
case 83:
this.saveHandler(), t.preventDefault();
break;
case 76:
t.preventDefault();
break;
case 67:
break;
case 86:
break;
default:
} else switch (t.keyCode) {
case 13:
break;
case 27:
break;
case 113:
this.newSceneHandler();
break;
case 46:
var n = t.target || t.srcElement;
n.tagName !== "INPUT" && this.removeHandler("", "");
break;
default:
}
},
tekendoosClickedHandler: function() {
this.waterfallDown("tekendoosClicked");
},
addSquareHandler: function() {
this.waterfallDown("addSquare");
},
toggleDrawingHandler: function(e, t) {
this.waterfallDown("toggleDrawing", e, t);
},
lineColorSelectedHandler: function(e, t) {
this.waterfallDown("lineColorSelected", e, t);
},
fillColorSelectedHandler: function(e, t) {
this.waterfallDown("fillColorSelected", e, t);
}
});

// Titelbalk.js

enyo.kind({
kind: enyo.Control,
name: "educate.create.titelbalk.Titelbalk",
tag: "div",
classes: "mainbarCreator",
published: {
sceneTitle: "",
sceneValue: ""
},
handlers: {},
components: [ {
kind: "educate.create.titelbalk.MenuCreator",
name: "menuCreator"
}, {
content: "Title",
classes: "sceneTitle",
tag: "p",
name: "sceneTitle",
ontap: "editNameScene"
} ],
create: function() {
this.inherited(arguments);
},
rendered: function() {
this.inherited(arguments);
},
editNameScene: function(e, t) {
this.showNameScenePopup();
},
showNameScenePopup: function() {
this.$.EditNameScenePopup && this.$.EditNameScenePopup.destroy(), this.createComponent({
name: "EditNameScenePopup",
kind: "educate.create.dialoogvensters.EditNameScene",
sceneNaam: this.getSceneTitle(),
sceneValue: this.getSceneValue()
});
},
sceneTitleChanged: function(e) {
this.$.sceneTitle.setContent(this.getSceneTitle());
},
loadOpenScenesMenu: function() {
for (var e in scenes) this.$.sceneMenu.createComponents([ {
container: this.$.sceneMenu,
content: scenes[e].name,
sceneId: scenes[e].id
} ]);
},
openSceneSelected: function(e, t) {
console.log("open scene", t.selected.sceneId);
}
});

// MenuCreator.js

enyo.kind({
kind: enyo.Control,
name: "educate.create.titelbalk.MenuCreator",
tag: "ul",
classes: "menuCreator",
published: {},
handlers: {},
components: [ {
tag: "li",
components: [ {
content: "bestand"
}, {
tag: "ul",
components: [ {
tag: "li",
name: "btnNieuw",
content: "nieuw (F2)",
ontap: "newSceneHandler"
}, {
tag: "li",
content: "open recent",
classes: "disabled"
}, {
tag: "li",
components: [ {
content: "type"
}, {
tag: "ul",
components: [ {
tag: "li",
name: "typeLes",
content: "les",
classes: "checkMenuItem",
ontap: "lesHandler"
}, {
tag: "li",
name: "typeOef",
content: "oefening",
ontap: "oefeningHandler"
} ]
} ]
}, {
tag: "li",
content: "opslaan",
ontap: "saveButtonHandler"
}, {
tag: "li",
content: "publiceren",
ontap: "publishButtonHandler"
}, {
tag: "li",
content: "afsluiten",
ontap: "closeSceneHandler"
}, {
tag: "li",
content: "bestand koppelen",
ontap: "linkSceneHandler"
} ]
} ]
}, {
tag: "li",
components: [ {
content: "bewerken"
}, {
tag: "ul",
components: [ {
tag: "li",
content: "undo",
classes: "disabled"
}, {
tag: "li",
content: "redo",
classes: "disabled"
}, {
tag: "li",
content: "kopieren",
classes: "disabled"
}, {
tag: "li",
content: "knippen",
classes: "disabled"
}, {
tag: "li",
content: "plakken",
classes: "disabled"
}, {
tag: "li",
name: "mnuVerwijderen",
content: "verwijderen",
ontap: "removeHandler"
}, {
tag: "li",
content: "Scene legen",
ontap: "emptySceneButtonHandler"
} ]
} ]
}, {
tag: "li",
components: [ {
content: "venster"
}, {
tag: "ul",
components: [ {
tag: "li",
content: "positie",
classes: "disabled"
}, {
tag: "li",
content: "limieten",
classes: "disabled"
}, {
tag: "li",
content: "lagen",
ontap: "vensterLagenHandler"
}, {
tag: "li",
content: "de lijst",
ontap: "vensterLijstHandler"
}, {
tag: "li",
content: "toolbox",
ontap: "vensterTekendoosHandler"
} ]
} ]
}, {
tag: "li",
components: [ {
content: "object laden"
}, {
tag: "ul",
components: [ {
tag: "li",
components: [ {
content: "sjabloon"
}, {
tag: "ul",
components: [ {
tag: "li",
name: "pickAndPlace",
content: "pick & place woorden",
linked: "pickAndPlace",
ontap: "loadObjectHandler"
}, {
tag: "li",
name: "pickAndPlaceImages",
content: "pick & place afbeeldingen",
linked: "pickAndPlaceAfbeeldingen",
ontap: "loadObjectHandler"
}, {
tag: "li",
name: "columnExerciseWords",
content: "kolomoefening woorden",
linked: "columnExerciseWords",
ontap: "loadObjectHandler"
}, {
tag: "li",
name: "columnExerciseImages",
content: "kolomoefening afbeeldingen",
linked: "columnExerciseImages",
ontap: "loadObjectHandler"
}, {
tag: "li",
name: "zoomImage",
content: "zoom afbeelding",
linked: "zoomImage",
ontap: "loadObjectHandler"
} ]
} ]
}, {
tag: "li",
components: [ {
content: "statisch"
}, {
tag: "ul",
components: [ {
tag: "li",
name: "svgImage",
content: "svg",
linked: "svgImage",
ontap: "loadObjectHandler"
}, {
tag: "li",
name: "image",
content: "afbeelding",
linked: "image",
ontap: "loadObjectHandler"
}, {
tag: "li",
name: "tekst",
content: "tekst",
linked: "tekst",
ontap: "loadObjectHandler"
}, {
tag: "li",
name: "raster",
content: "raster",
linked: "raster",
ontap: "loadObjectHandler"
}, {
tag: "li",
name: "meetlat",
content: "meetlat",
linked: "meetlat",
ontap: "loadObjectHandler"
} ]
} ]
}, {
tag: "li",
components: [ {
content: "bediening"
}, {
tag: "ul",
components: [ {
tag: "li",
content: "knop",
linked: "button",
ontap: "loadObjectHandler"
}, {
tag: "li",
content: "photoknop",
linked: "photoIcon",
ontap: "loadObjectHandler"
}, {
tag: "li",
content: "infoknop",
linked: "infoIcon",
ontap: "loadObjectHandler"
}, {
tag: "li",
content: "dropdown",
linked: "dropdown",
ontap: "loadObjectHandler"
}, {
tag: "li",
content: "multiple choice",
linked: "multipleChoice",
ontap: "loadObjectHandler"
} ]
} ]
}, {
tag: "li",
components: [ {
content: "website"
}, {
tag: "ul",
components: [ {
tag: "li",
name: "webFrame",
content: "frame",
linked: "webFrame",
ontap: "loadObjectHandler"
}, {
tag: "li",
name: "map",
content: "map",
linked: "map",
ontap: "loadObjectHandler"
}, {
tag: "li",
name: "youtube",
content: "youtube",
linked: "youtube",
ontap: "loadObjectHandler"
} ]
} ]
}, {
tag: "li",
components: [ {
content: "invoer"
}, {
tag: "ul",
components: [ {
tag: "li",
content: "cijferveld",
linked: "cijferveld",
ontap: "loadObjectHandler"
}, {
tag: "li",
content: "lijnstuk",
linked: "lijnstuk",
ontap: "loadObjectHandler"
}, {
tag: "li",
content: "inputveld",
linked: "inputfield",
ontap: "loadObjectHandler"
} ]
} ]
}, {
tag: "li",
content: "animatie",
linked: "sprite",
ontap: "loadObjectHandler"
}, {
tag: "li",
content: "video",
linked: "video",
ontap: "loadObjectHandler"
}, {
tag: "li",
content: "flipcard",
linked: "flipcard",
ontap: "loadObjectHandler"
}, {
tag: "li",
content: "3D",
linked: "3DObject",
ontap: "loadObjectHandler"
}, {
tag: "li",
components: [ {
content: "bibliotheek"
}, {
tag: "ul",
components: [ {
tag: "li",
content: "klimatogram",
linked: "klimatogram",
ontap: "loadObjectHandler"
} ]
} ]
} ]
} ]
}, {
tag: "li",
components: [ {
content: "naar scene"
}, {
tag: "ul",
components: [ {
tag: "li",
name: "toScene",
content: "live-view",
ontap: "toSceneHandler",
classes: "disabled"
}, {
tag: "li",
content: "preview",
ontap: "previewButtonHandler"
} ]
} ]
} ],
create: function() {
this.inherited(arguments);
},
rendered: function() {
this.inherited(arguments), this.initLists();
},
addSelectionToMenuItem: function(e) {
e.addClass("checkMenuItem");
},
removeSelectionFromMenuItem: function(e) {
e.removeClass("checkMenuItem");
},
removeSelectionType: function() {
this.removeSelectionFromMenuItem(this.$.typeLes), this.removeSelectionFromMenuItem(this.$.typeOef);
},
newSceneHandler: function(e, t) {
!e.hasClass("disabled") && this.bubble("newSceneClicked");
},
lesHandler: function(e, t) {
e.hasClass("disabled") || (this.removeSelectionType(), this.addSelectionToMenuItem(e), this.bubble("lesClicked"));
},
oefeningHandler: function(e, t) {
e.hasClass("disabled") || (this.removeSelectionType(), this.addSelectionToMenuItem(e), this.bubble("oefeningClicked"));
},
saveButtonHandler: function(e, t) {
!e.hasClass("disabled") && this.bubble("saveClicked");
},
publishButtonHandler: function(e, t) {
!e.hasClass("disabled") && this.bubble("publishClicked");
},
closeSceneHandler: function(e, t) {
!e.hasClass("disabled") && this.bubble("closeSceneClicked");
},
linkSceneHandler: function(e, t) {
!e.hasClass("disabled") && this.bubble("linkSceneClicked");
},
removeHandler: function(e, t) {
!e.hasClass("disabled") && this.bubble("removeClicked");
},
emptySceneButtonHandler: function(e, t) {
!e.hasClass("disabled") && this.bubble("emptySceneClicked");
},
vensterLagenHandler: function(e, t) {
!e.hasClass("disabled") && this.bubble("vensterLagenClicked");
},
vensterLijstHandler: function(e, t) {
!e.hasClass("disabled") && this.bubble("vensterLijstClicked");
},
vensterTekendoosHandler: function(e, t) {
!e.hasClass("disabled") && this.bubble("vensterTekendoosClicked");
},
toSceneHandler: function(e, t) {
!e.hasClass("disabled") && this.bubble("toSceneClicked");
},
previewButtonHandler: function(e, t) {
!e.hasClass("disabled") && this.bubble("previewClicked");
},
loadObjectHandler: function(e, t) {
e.hasClass("disabled") || enyo.Signals.send("onCarrierAddedToStage", {
type: t.originator.linked
});
},
initLists: function() {
$(".menuCreator li").mouseover(function() {
$(this).addClass("lihover"), $(">ul", this).addClass("hover");
}).mouseout(function() {
$(this).removeClass("lihover"), $("ul", this).removeClass("hover");
}).on("click", function() {
$("ul", this).removeClass("hover");
});
}
});

// View.js

enyo.kind({
kind: "FittableColumns",
name: "educate.create.view.View",
fit: !0,
classes: "outer-box",
published: {
carrier: window.settings.CARRIERS.VIEW,
viewObjectsId: 0,
value: "",
layername: "",
solution: "",
answered: "",
width: 0,
height: 0,
position_x: 0,
position_y: 0,
position_z: 0,
inLayerHolder: 0,
objectId: "",
databaseId: "",
viewId: "",
collection: "",
frameBtns: [],
viewActive: !1,
objectsInView: [],
objectsReady: 0,
unParsedHandlers: [],
unParsedLinkEigenschappen: [],
unParsedGlobalvarLinkeigenschappen: [],
unParsedFrameBtns: {},
viewChildren: {},
objectsForLayerHolder: [],
drawCanvasAdded: !1,
globalLinkEigenschapVariables: [],
count: 0,
properties: {}
},
handlers: {
onObjectAdded: "onObjectAddedHandler",
onHideLayer: "onHideLayerHandler",
onAddGroepTapped: "addGroepTapHandler",
onPropertiesChanged: "onPropertiesChanged",
layerSelected: "layerSelectedHandler",
threeDLayerSelected: "threeDLayerSelectedHandler",
layerZoneSelected: "layerZoneSelectedHandler",
mouseMoveStage: "mouseMoveStageHandler",
updateProperties: "updatePropertiesHandler",
objectSelected: "objectSelectedHandler",
deselectedObjects: "deselectedObjectsHandler",
frameBottomIconClicked: "frameBottomIconClickedHandler",
frameBtnsViewCreated: "frameBtnsViewCreatedHandler",
layerDeleted: "layerDeletedHandler",
sublayerVisibilityClicked: "sublayerVisibilityClickedHandler",
layerVisibilityClicked: "layerVisibilityClickedHandler",
layerLockClicked: "layerLockClickedHandler",
layerInLayerHolderClicked: "layerInLayerHolderClickedHandler",
onAddLayerInLayerHolder: "onAddLayerInLayerHolderHandler",
onRemoveLayerInLayerHolder: "onRemoveLayerInLayerHolderHandler",
svgLoaded: "svgLoadedHandler",
viewObjectenCollected: "viewObjectenCollectedHandler",
toggleVensterLagen: "toggleVensterLagenHandler",
vensterLijstClicked: "vensterLijstClickedHandler",
toggleVensterTekendoos: "toggleVensterTekendoosHandler",
shiftLPressed: "shiftLPressedHandler",
onLaagClicked: "onLaagClickedHandler",
objectLockChange: "objectLockChangeHandler",
onShowAreaChanged: "onShowAreaChangedHandler",
sendToColumnExercise: "sendToColumnExerciseHandler",
changeMeshPosition: "changeMeshPositionHandler",
changeCameraPosition: "changeCameraPositionHandler",
centerOnObject: "centerOnObjectHandler"
},
components: [ {
name: "panelConLeft",
layoutKind: "FittableRowsLayout",
classes: "pnlLijst",
components: [ {
name: "lijstPanel",
kind: "educate.create.view.lijst.Lijst"
} ]
}, {
name: "panelMiddle",
fit: !0,
classes: "relative perspective",
components: [ {
name: "stage",
kind: "educate.create.view.stage.Stage",
view: this
} ]
}, {
name: "pnlLagen",
classes: "pnlLagen",
components: [ {
name: "lagenPalet",
kind: "educate.create.view.lagenpalet.Lagenpalet"
} ]
}, {
name: "panelRight",
layoutKind: "FittableRowsLayout",
classes: "pnlEigenschappen",
components: [ {
name: "eigenschappenPanel",
kind: "educate.create.view.eigenschappen.EigenschappenPanel"
} ]
}, {
name: "panelToolbox",
layoutKind: "FittableRowsLayout",
classes: "pnlTekendoos",
components: [ {
name: "tekendoosPanel",
kind: "educate.create.view.tekendoos.Tekendoos"
} ]
} ],
create: function() {
this.viewChildren = {}, this.inherited(arguments), this.$.panelToolbox.setShowing(!1), this.setFrameBtns([]), this.unParsedFrameBtns = {}, this.setObjectsInView([]), this.setGlobalLinkEigenschapVariables([]), this.viewIdChanged(), this.getDatabaseId() && this.openView(), this.$.eigenschappenPanel.setView(this), this.render();
},
rendered: function() {
this.inherited(arguments), this.$.lijstPanel.handlePosLagen();
},
showingChanged: function() {
this.inherited(arguments), this.getShowing() && this.resized();
},
destroy: function() {
this.inherited(arguments);
},
deleteAllViewsHandler: function() {
this.destroyClientControls();
},
viewIdChanged: function() {
this.$.lijstPanel.setViewId(this.getViewId()), this.$.eigenschappenPanel.setViewId(this.getViewId()), this.$.stage.setViewId(this.getViewId());
},
clearView: function() {
this.$.panelMiddle.destroyClientControls(), this.waterfallDown("layerDeletedAll", this), this.setViewObjectsId(0), this.setObjectsReady(0);
},
openView: function() {
var e = Object.keys(this.getCollection()).length;
this.getCollection()[e] = {
carrier: {
name: "dummy"
}
}, this.parseOpenCollection(this.getCollection()), this.$.lijstPanel.sortLayers();
},
parseOpenCollection: function(e, t) {
t = t ? t : this.$.stage;
var n = this;
for (var r in e) {
var i = e[r];
switch (i.carrier.name) {
case "hand":
n.unParsedFrameBtns.hand = i, i.collection && n.parseOpenCollection(i.collection);
break;
case "oplossing":
n.unParsedFrameBtns.oplossing = i, i.collection && n.parseOpenCollection(i.collection);
break;
case "groep":
this.$.stage.addGroep(this.countViewObjectsId(), i, t), this.objectReady(), i.collection && n.parseOpenCollection(i.collection, this.$.stage.getObjectFromStageByDbId(this.$.stage.children, i.id));
break;
case "svgImage":
this.$.stage.addSvg(this.countViewObjectsId(), i, t), i.collection && n.parseOpenCollection(i.collection);
break;
case "image":
this.$.stage.addImage(this.countViewObjectsId(), i, t), this.objectReady(), i.collection && n.parseOpenCollection(i.collection);
break;
case "tekst":
this.$.stage.addTekst(this.countViewObjectsId(), i, t), this.objectReady(), i.collection && n.parseOpenCollection(i.collection);
break;
case "button":
this.$.stage.addKnop(this.countViewObjectsId(), i, t), i.collection && n.parseOpenCollection(i.collection), this.objectReady();
break;
case "infoIcon":
this.$.stage.addInfoIcon(this.countViewObjectsId(), i, t), this.objectReady(), i.collection && n.parseOpenCollection(i.collection);
break;
case "photoIcon":
this.$.stage.addPhotoIcon(this.countViewObjectsId(), i, t), this.objectReady(), i.collection && n.parseOpenCollection(i.collection);
break;
case "sprite":
this.$.stage.addAnimatie(this.countViewObjectsId(), i, t), this.objectReady(), i.collection && n.parseOpenCollection(i.collection);
break;
case "cijferveld":
this.$.stage.addCijferveld(this.countViewObjectsId(), i, t), this.objectReady(), i.collection && n.parseOpenCollection(i.collection);
break;
case "raster":
this.$.stage.addRaster(this.countViewObjectsId(), i, t), this.objectReady(), i.collection && n.parseOpenCollection(i.collection);
break;
case "zones":
i.collection && n.parseOpenCollection(i.collection);
break;
case "eventActionHandler":
n.unParsedHandlers.push(i);
break;
case "linkeigenschap":
n.unParsedLinkEigenschappen.push(i);
break;
case "globalvarlinkeigenschap":
n.unParsedGlobalvarLinkeigenschappen.push(i), this.objectReady();
break;
case "video":
this.$.stage.addVideo(this.countViewObjectsId(), i, t), this.objectReady(), i.collection && n.parseOpenCollection(i.collection);
break;
case "laag":
n.objectsForLayerHolder.push(i), this.objectReady();
break;
case "square":
this.$.stage.addSquareHandler(this.countViewObjectsId(), i, t), this.objectReady(), i.collection && n.parseOpenCollection(i.collection);
break;
case "ellipse":
this.$.stage.addEllipseHandler(this.countViewObjectsId(), i, t), this.objectReady(), i.collection && n.parseOpenCollection(i.collection);
break;
case "free":
this.$.stage.addFreeHandler(this.countViewObjectsId(), i, t), this.objectReady(), i.collection && n.parseOpenCollection(i.collection);
break;
case "multi":
this.$.stage.addMultiAngleHandler(this.countViewObjectsId(), i, t), this.objectReady(), i.collection && n.parseOpenCollection(i.collection);
break;
case "meetlat":
this.$.stage.addMeetlat(this.countViewObjectsId(), i, t), this.objectReady(), i.collection && n.parseOpenCollection(i.collection);
break;
case "lijnstuk":
this.$.stage.addLijnstuk(this.countViewObjectsId(), i, t), this.objectReady(), i.collection && n.parseOpenCollection(i.collection);
break;
case "inputfield":
this.$.stage.addInputField(this.countViewObjectsId(), i, t), this.objectReady(), i.collection && n.parseOpenCollection(i.collection);
break;
case "pickplacewords":
this.$.stage.addPickAndPlace(this.countViewObjectsId(), i, t), this.objectReady(), i.collection && n.parseOpenCollection(i.collection);
break;
case "zoomImage":
this.$.stage.addZoomImage(this.countViewObjectsId(), i, t), this.objectReady(), i.collection && n.parseOpenCollection(i.collection);
break;
case "kolomwoorden":
this.$.stage.addKolomOefeningWoorden(this.countViewObjectsId(), i, t), this.objectReady(), i.collection && n.parseOpenCollection(i.collection);
break;
case "kolomafbeeldingen":
this.$.stage.addKolomOefeningAfbeeldingen(this.countViewObjectsId(), i, t), this.objectReady(), i.collection && n.parseOpenCollection(i.collection);
break;
case "columnExerciseWords":
this.$.stage.addColumnExerciseWords(this.countViewObjectsId(), i, t), this.objectReady(), i.collection && n.parseOpenCollection(i.collection);
break;
case "pickplaceimages":
this.$.stage.addPickAndPlaceAfbeeldingen(this.countViewObjectsId(), i, t), this.objectReady(), i.collection && n.parseOpenCollection(i.collection);
break;
case "dropdown":
this.$.stage.addDropdown(this.countViewObjectsId(), i, t), this.objectReady(), i.collection && n.parseOpenCollection(i.collection);
break;
case "flipcard":
this.$.stage.addFlipcard(this.countViewObjectsId(), i, t), this.objectReady(), i.collection && n.parseOpenCollection(i.collection);
break;
case "website":
this.$.stage.addWebFrame(this.countViewObjectsId(), i, t), this.objectReady(), i.collection && n.parseOpenCollection(i.collection);
break;
case "map":
this.$.stage.addMap(this.countViewObjectsId(), i, t), this.objectReady(), i.collection && n.parseOpenCollection(i.collection);
break;
case "youtube":
this.$.stage.addYoutube(this.countViewObjectsId(), i, t), this.objectReady(), i.collection && n.parseOpenCollection(i.collection);
break;
case "threedobject":
this.$.stage.add3DObject(this.countViewObjectsId(), i, t), this.objectReady(), i.collection && n.parseOpenCollection(i.collection);
break;
case "threedmesh":
this.$.stage.add3DMesh(this.countViewObjectsId(), i, t), this.objectReady(), i.collection && n.parseOpenCollection(i.collection);
break;
case "contentIcon":
break;
case "klimatogram":
this.$.stage.addKlimatogram(this.countViewObjectsId(), i, t), this.objectReady(), i.collection && n.parseOpenCollection(i.collection);
break;
case "multipleChoice":
this.$.stage.addMultipleChoice(this.countViewObjectsId(), i, t), this.objectReady(), i.collection && n.parseOpenCollection(i.collection);
break;
case "ColumnExerciseWords":
this.$.stage.addColumnExerciseWords(this.countViewObjectsId(), i, t);
break;
case "columnExerciseImages":
this.$.stage.addColumnExerciseImages(this.countViewObjectsId(), i, t);
break;
case "dummy":
this.objectReady();
break;
default:
console.log("case '" + i.carrier.name + "': break;");
}
}
},
countViewObjectsId: function() {
return this.setViewObjectsId(this.getViewObjectsId() + 1), this.getViewId() + "-" + this.getViewObjectsId();
},
objectReady: function() {
this.setObjectsReady(this.getObjectsReady() + 1);
if (this.getCollection() != "") {
this.count = 0;
if (this.countAllObjectsToLoad(this.getCollection()) === this.getObjectsReady()) {
this.handleLagen();
for (var e in this.unParsedHandlers) this.doHandlers(this.unParsedHandlers[e]);
this.loadGlobalvarLinkEigenschappen(), this.loadLinkEigenschappen(), this.$.pnlLagen.render();
}
}
},
countAllObjectsToLoad: function(e) {
for (var t in e) e[t].carrier.name != "eventActionHandler" && e[t].carrier.name != "linkeigenschap" && this.count++, e[t].carrier.name === "groep" && this.countAllObjectsToLoad(e[t].collection);
return this.count;
},
handleLagen: function() {
this.getObjectsForLayerHolder().sort(enyo.bind(this, "sorteerLagen"));
var e = this.getObjectsForLayerHolder().length;
for (var t = 0; t < e; t++) if (this.getObjectsForLayerHolder()[t].inLayerHolder) {
var n = new Object;
n.objId = this.countViewObjectsId(), n.obj = this.getObjectsForLayerHolder()[t];
if (n.obj) {
var r = this.$.lagenPalet.openLaag(n);
r && (this.$.stage.applyPropertiesToObject(r, this.getObjectsForLayerHolder()[t]), this.viewChildren[r.objectId] = r, this.getObjectsForLayerHolder()[t].collection && this.handleLaagCollection(this.getObjectsForLayerHolder()[t].collection, r));
}
}
},
handleLaagCollection: function(e, t) {
t.setCollection([]);
var n = [];
for (var r in e) e[r].carrier.code == window.settings.CARRIERS.EVENTACTIONHANDLER ? this.unParsedHandlers.push(e[r]) : n.push(e[r]);
n.sort(enyo.bind(this, "sorteerLagen"));
var i = n.length;
for (var r = 0; r < i; r++) {
var s = new Object;
s.objId = this.countViewObjectsId(), s.obj = n[r];
var o = this.$.lagenPalet.openLaag(s);
this.$.stage.applyPropertiesToObject(o, n[r]), t.getCollection().push(o), o.setToGroup(t), t.checkIsGroup(), t.handleChildBorderKleur(), n[r].collection && this.handleLaagCollection(n[r].collection, o);
}
},
sorteerLagen: function(e, t) {
return e.position - t.position;
},
doHandlers: function(e) {
this.removeHandlerFromCollection(e, this.collection);
var t = this.getChildById(e.parent);
if (!t) return !1;
var n = new educate.Actie;
n.eventName = e.name, n.eventID = e.id, n.event = e.value, n.targets = [], n.targetComponents = [], n.reactions = [];
for (var r in e.collection) {
var i = this.getLayerById(e.collection[r].solution);
if (i === null) continue;
var s = n.targets.indexOf(i.objectId);
s === -1 ? (n.targets.push(i.objectId), n.targetComponents.push(i.objectId), n.reactions.push([ e.collection[r].value.split(",") ])) : n.reactions[s].push(e.collection[r].value.split(","));
}
return t.objectHandlers || (t.objectHandlers = []), t.objectHandlers.push(n), t.objectHandlersChanged && t.objectHandlersChanged(), !0;
},
removeHandlerFromCollection: function(e, t) {
for (var n in t) t[n].id === e.id ? delete t[n] : t[n].collection && this.removeHandlerFromCollection(e, t[n].collection);
},
loadGlobalvarLinkEigenschappen: function() {
var e = this.unParsedGlobalvarLinkeigenschappen, t = this.unParsedGlobalvarLinkeigenschappen.length;
for (var n = 0; n < t; n++) {
var r = new educate.GlobalVariableLinkeigenschap;
r.name = e[n].name, r.answered = e[n].answered, r.databaseId = e[n].id, this.getGlobalLinkEigenschapVariables().push(r), this.removeHandlerFromCollection(e[n], this.collection);
}
},
loadLinkEigenschappen: function() {
for (var e in this.unParsedLinkEigenschappen) {
var t = this.unParsedLinkEigenschappen[e], n = this.getChildById(t.parent);
if (n) {
var r = new educate.Linkeigenschap;
r.databaseId = t.id, r.linkeigenschapID = t.id, r.linkeigenschapName = t.solution + "_Link", r.eigenschap = t.solution, r.offset = t.css_class, r.formule = t.answered, !n.linkedEigenschappen && (n.linkedEigenschappen = []), n.getLinkedEigenschappen().push(r), this.removeHandlerFromCollection(t, this.collection);
}
}
this.applyLinkEigenschappen();
},
getChildById: function(e) {
if (this.viewChildren[e]) return this.viewChildren[e];
for (var t in this.getViewChildren()) if (this.getViewChildren()[t].objectId === e || this.getViewChildren()[t].databaseId === e) return this.getViewChildren()[t];
return null;
},
getLayerById: function(e) {
var t = null;
for (var n in this.getViewChildren()) this.getViewChildren()[n].databaseId === e && (t = this.getViewChildren()[n]);
return t;
},
getObjectIdByDbId: function(e) {
var t = this.$.lijstPanel.getAllLayers();
for (var n in t) if (t[n].linked.databaseId === e) return t[n].linked.objectId;
},
getChildByName: function(e) {
for (var t in this.getViewChildren()) if (this.getViewChildren()[t].layername === e) return this.getViewChildren()[t];
return null;
},
applyLinkEigenschappen: function() {
this.waterfallDown("applyLinkEigenschappen");
},
addGroepTapHandler: function(e, t) {
this.$.stage.addGroep(this.countViewObjectsId(), null, this.$.stage);
},
onObjectAddedHandler: function(e, t) {
t.objType !== "groep" ? this.addLayer(t.obj) : this.addGroep(t.obj);
},
addGroep: function(e) {
return this.getObjectsInView().push(e), this.viewChildren[e.objectId] = e, this.waterfall("addGroep", e), !0;
},
addLayer: function(e) {
return this.getObjectsInView().push(e), this.viewChildren[e.objectId] = e, this.waterfall("addLayer", e), !0;
},
onHideLayerHandler: function(e, t) {
this.waterfall("hideLayer", t.name);
},
layerSelectedHandler: function(e, t) {
this.waterfallDown("layerSelected", t), enyo.Signals.send("onObjectLayerSelect", this.getViewId());
},
threeDLayerSelectedHandler: function(e, t) {
this.waterfallDown("threeDLayerSelected", t), enyo.Signals.send("onObjectLayerSelect", this.getViewId());
},
layerZoneSelectedHandler: function(e, t) {
this.waterfallDown("layerZoneSelected", t), enyo.Signals.send("onObjectLayerSelect", this.getViewId());
},
layerDeletedHandler: function(e, t) {
this.getViewActive() && (t.linked.linked && (t.linked.linked.kindName == "educate.create.components.bediening.InfoIconContent" || t.linked.linked.kindName == "educate.create.components.bediening.PhotoIconContent") && (t.linked.linked.getDatabaseId() && this.addObjectToArrDeleted(t.linked.linked.getDatabaseId()), this.$.stage.deleteObjectFromStage(t.linked.linked.name)), this.checkLagenToRemove(t.linked), t.linked.getDatabaseId() && this.addObjectToArrDeleted(t.linked.getDatabaseId()), this.$.stage.deleteObjectFromStage(t.linked.name), this.deleteObjectInView(t.linked), this.waterfallDown("layerDeleted", t));
},
deleteObjectInView: function(e) {
var t = this.getObjectsInView().indexOf(e);
this.getObjectsInView().splice(t, 1), delete this.viewChildren[e.objectId];
},
addObjectToArrDeleted: function(e) {
this.bubble("addObjectToArrDeleted", {
objDbId: e
});
},
checkLagenToRemove: function(e) {
e.kindName === "educate.create.components.svg.SvgParser" && this.checkLagenToRemoveSvgZones(e), e.getInLayerHolder() && this.removeLayerInLayerHolder(e);
},
checkLagenToRemoveSvgZones: function(e) {
var t = e.getCollection(), n = t.length;
for (var r = 0; r < n; r++) t[r].kindName === "educate.create.components.svg.svgzone.SvgZone" && t[r].getInLayerHolder() && this.removeLayerInLayerHolder(t[r]);
},
layerVisibilityClickedHandler: function(e, t) {
this.waterfallDown("layerVisibilityClicked", t);
},
sublayerVisibilityClickedHandler: function(e, t) {
this.waterfallDown("sublayerVisibilityClicked", t);
},
layerLockClickedHandler: function(e, t) {
this.waterfallDown("layerLockClicked", t);
},
objectLockChangeHandler: function(e, t) {
this.waterfallDown("objectLockChange", t);
},
layerInLayerHolderClickedHandler: function(e, t) {
var n = this.$.lagenPalet.getLagenForView(), r = !0, i = null;
for (var s = n.length - 1; s >= 0; s--) n[s].linkedObj.objectId === t.linked.objectId && (r = !1, i = n[s]);
if (!r) this.$.lagenPalet.toggleLaag(i); else {
var o = new Object;
o.objId = this.countViewObjectsId(), o.obj = t;
var u = this.$.lagenPalet.addLaag(o);
this.viewChildren[u.objectId] = u, this.$.lagenPalet.handlePosLagen(), this.$.lagenPalet.render();
}
},
onAddLayerInLayerHolderHandler: function(e, t) {
var n = this.$.lagenPalet.getLagenForView(), r = !0, i = null;
for (var s = n.length - 1; s >= 0; s--) n[s].linkedObj.objectId === t.linked.objectId && (r = !1, i = n[s]);
if (!r) i.setInLayerHolder(!0); else {
var o = new Object;
o.objId = this.countViewObjectsId(), o.obj = t;
var u = this.$.lagenPalet.addLaag(o);
this.viewChildren[u.objectId] = u, this.$.lagenPalet.handlePosLagen(), this.$.lagenPalet.render();
}
this.waterfallDown("onAddLayerInLayerHolder", t);
},
onRemoveLayerInLayerHolderHandler: function(e, t) {
this.removeLayerInLayerHolder(t.linked);
},
removeLayerInLayerHolder: function(e) {
this.waterfallDown("onRemoveLayerInLayerHolder", e);
},
updatePropertiesHandler: function(e, t) {
this.waterfallDown("updateProperties", t);
},
objectSelectedHandler: function(e, t) {
this.waterfallDown("objectSelected", t), enyo.Signals.send("onObjectLayerSelect", this.getViewId());
},
deselectedObjectsHandler: function(e, t) {
this.waterfallDown("deselectedObjects"), enyo.Signals.send("onObjectLayerSelect", this.getViewId());
},
frameBottomIconClickedHandler: function(e, t) {
this.getViewId() == t.viewId && this.waterfallDown("deselectedObjects");
},
frameBtnsViewCreatedHandler: function(e, t) {
if (t.viewnr == this.getViewId()) {
var n = t.frameBtns[0].children;
for (var r in n) n[r].objectId = this.countViewObjectsId(), this.applyPropertiesToFrameBtn(n[r]), this.getFrameBtns().push(n[r]);
}
},
applyPropertiesToFrameBtn: function(e) {
var t;
e.kindName === "educate.create.onderbalk.knoppen.KnopHand" ? t = this.unParsedFrameBtns.hand : e.kindName === "educate.create.onderbalk.knoppen.KnopOplossing" && (t = this.unParsedFrameBtns.oplossing), t && (e.layername = t.name, e.value = t.value, e.solution = t.solution, e.answered = t.answered, e.databaseId = t.id, e.collection = t.collection), this.viewChildren[e.objectId] = e, this.objectReady();
},
onLaagClickedHandler: function(e, t) {
this.getViewActive() && this.waterfallDown("onLaagClicked", t);
},
onPropertiesChanged: function(e, t) {
this.waterfallDown("onPropertiesChanged", t);
},
changeMeshPositionHandler: function(e, t) {
this.waterfallDown("changeMeshPosition", t);
},
changeCameraPositionHandler: function(e, t) {
this.waterfallDown("changeCameraPosition", t);
},
centerOnObjectHandler: function(e, t) {
this.waterfallDown("centerOnObject", t);
},
onShowAreaChangedHandler: function(e, t) {
this.waterfall("showAreaChanged", {
showArea: t.showArea,
colorOptions: t.colorOptions
});
},
sendToColumnExerciseHandler: function(e, t) {
this.waterfall("setImageToColumn", {
image: t.image
});
},
mouseMoveStageHandler: function(e, t) {
this.waterfall("dragButton", t);
},
svgLoadedHandler: function(e, t) {
var n = t.databaseId ? !0 : !1, r, i = t.collection.length;
for (r = 0; r < i; r++) this.getObjectsInView().push(t.collection[r]), this.viewChildren[t.collection[r].objectId] = t.collection[r];
n && this.objectReady(), this.waterfallDown("svgLoaded", t);
},
viewObjectenCollectedHandler: function(e, t) {
this.setCollection([]), this.setCollection(t.viewObjecten.concat(this.getFrameBtns())), this.addLagenToCollection();
},
addLagenToCollection: function() {
var e = this.$.lagenPalet.getLagenForView(), t = e.length;
for (var n = 0; n < t; n++) e[n].getInLayerHolder() ? this.getCollection().push(e[n]) : e[n].getDatabaseId() && this.addObjectToArrDeleted(e[n].getDatabaseId());
},
arrangeObjecten: function() {
this.$.stage.arrangeObjecten();
},
vensterLijstClickedHandler: function(e, t) {
this.$.panelConLeft.setShowing(!this.$.panelConLeft.getShowing()), this.resized();
},
toggleVensterLagenHandler: function(e, t) {
return this.getViewActive() && this.toggleLayerPanel(), !0;
},
toggleLayerPanel: function() {
var e = this.$.pnlLagen.getComputedStyleValue("width"), e = parseInt(e.substr(0, e.length - 2));
e > 41 ? this.$.pnlLagen.applyStyle("width", "40px") : this.$.pnlLagen.applyStyle("width", "200px"), this.resized();
},
toggleVensterTekendoosHandler: function() {
this.$.panelToolbox.setShowing(!this.$.panelToolbox.getShowing()), this.drawCanvasAdded == 0 ? (this.$.stage.addTekenLayer(this.countViewObjectsId(), null, this.$.stage), this.drawCanvasAdded = !0) : this.waterfallDown("disableDrawing", this), this.resized();
},
shiftLPressedHandler: function(e, t) {
this.getViewActive() && this.toggleLayerPanel();
}
});

// Lijst.js

enyo.kind({
name: "educate.create.view.lijst.Lijst",
kind: enyo.Control,
tag: "div",
classes: "lijstPanel",
handlers: {
addLayer: "addLayer",
hideLayer: "hideLayer",
addGroep: "addGroep",
layerDeleted: "layerDeletedHandler",
layerDeletedAll: "layerDeletedAllHandler",
colectViewObjecten: "colectViewObjectenHandler",
ondragstart: "dragstartHandler",
ondragover: "dragoverHandler",
ondragout: "dragoutHandler",
ondrop: "dropHandler",
ondragfinish: "dragfinishHandler"
},
events: {
onAddGroepTapped: ""
},
components: [ {
kind: "Signals",
onNewObjectAdded: "newObjectAddedHandler"
}, {
tag: "div",
classes: "addGroep dropdown",
name: "btnGroupLijst",
components: [ {
tag: "div",
name: "btnLijstDropdown",
classes: "dropdown-toggle",
attributes: {
"data-toggle": "dropdown"
},
components: [ {
tag: "span",
classes: "icon-reorder"
} ]
}, {
tag: "ul",
classes: "dropdown-menu",
components: [ {
tag: "li",
name: "ctxLijstMnuItemAddGroep",
components: [ {
tag: "a",
attributes: {
href: "#"
},
ontap: "addGroepTapHandler",
components: [ {
tag: "i",
classes: "line-icon icon-folder-add",
content: " "
}, {
tag: "span",
content: "Groep toevoegen"
} ]
} ]
}, {
tag: "li",
name: "ctxLijstMnuItemVerwijder",
components: [ {
tag: "a",
attributes: {
href: "#"
},
ontap: "removeObjTapHandler",
components: [ {
tag: "i",
classes: "line-icon icon-trash",
content: " "
}, {
tag: "span",
content: "Verwijder lijstitem"
} ]
} ]
} ]
} ]
}, {
kind: "educate.create.view.Header",
content: "Lijst"
}, {
kind: "enyo.Scroller",
classes: "enyo-fit topposition",
components: [ {
kind: "enyo.Control",
name: "grpLayers",
tag: "ul",
classes: "lijst"
} ]
} ],
published: {
viewId: "",
dragLaag: "",
lastHover: ""
},
rendered: function() {
this.inherited(arguments);
},
addGroepTapHandler: function(e, t) {
this.doAddGroepTapped();
},
removeObjTapHandler: function(e, t) {
this.waterfallDown("removeClicked");
},
addLayer: function(e, t) {
var n = this.findLayerContainer(t);
this.createComponent({
container: n,
addBefore: null,
linked: t,
kind: "educate.create.view.lijst.LijstitemObject",
label: t.layername
});
},
addGroep: function(e, t) {
var n = this.findLayerContainer(t);
this.createComponent({
container: n,
addBefore: null,
linked: t,
kind: "educate.create.view.lijst.LijstitemGroep",
label: t.layername
});
},
findLayerContainer: function(e) {
var t = this.searchLayer(this.$.grpLayers.children, e);
return t ? t : this.$.grpLayers;
},
searchLayer: function(e, t) {
var n = e.length;
for (var r = 0; r < n; r++) {
if (e[r].linked === t.container) return e[r].removeClass("empty"), e[r].$.zoneLijst;
if (e[r].kindName === "educate.create.view.lijst.LijstitemGroep") return this.searchLayer(e[r].$.zoneLijst.children, t);
}
return !1;
},
sortLayers: function() {
var e = this.$.grpLayers.children.length;
for (var t = 0; t < e; t++) this.$.grpLayers.children[t].kindName === "educate.create.view.lijst.LijstitemGroep" && this.$.grpLayers.children[t].sortLayers();
this.$.grpLayers.children.sort(enyo.bind(this, "sortObjecten")), enyo.Signals.send("onListOrderChanged");
},
sortObjecten: function(e, t) {
return e.linked.position - t.linked.position;
},
hideLayer: function(e, t) {
for (var n = 0; n < this.$.grpLayers.children.length; n++) this.$.grpLayers.children[n].label == t && this.$.grpLayers.children[n].hide();
},
dragstartHandler: function(e, t) {
this.dragLaag = t.originator, this.dragLaag.applyStyle("opacity", "0.4"), this.placeholder || (this.placeholder = this.createComponent({
name: "placeHolder",
tag: "li",
classes: "placeholder",
container: this.$.grpLayers
})), this.$.grpLayers.render();
},
dragoverHandler: function(e, t) {
t.preventDefault && t.preventDefault();
if (this.placeholder === undefined || !this.placeholder.hasNode()) return !1;
var n = t.originator;
n.hasClass("lijstItem") && (n.addClass("over"), this.lastHover = n), n.hasClass("lijstitemGroup") && n.addClass("overGroup");
if (n.hasClass("over")) {
var r = this.insertBeforeItem(t.clientY, n.hasNode(), n.hasClass("lijstitemGroup") ? .25 : .5), i = n.hasNode(), s = i.parentNode, o = this.placeholder.hasNode();
s.insertBefore(o, r ? i : i.nextSibling), this.placeholder.applyStyle("display", n.hasClass("lijstitemGroup") && !r ? "none" : "block");
}
return !1;
},
insertBeforeItem: function(e, t, n) {
var r = e - $(t).offset().top, i = $(t).height();
return n = n ? n : .5, r < i * n;
},
dragoutHandler: function(e, t) {
t.originator.removeClass("over"), t.originator.removeClass("overGroup");
},
dropHandler: function(e, t) {
return this.dragLaag === this.lastHover ? !1 : (this.dragLaag.parent != this.lastHover.parent ? this.lastHover.parent.parent.parent.parent == this && !this.lastHover.hasClass("overGroup") ? this.addLaagToGroup(this, this.dragLaag) : this.addLaagToGroup(this.lastHover.hasClass("lijstitemGroup") ? this.lastHover : this.lastHover.parent.parent, this.dragLaag) : t.originator.hasClass("lijstitemGroup") && !this.insertBeforeItem(t.clientY, this.lastHover.hasNode(), .25) ? this.addLaagToGroup(this.lastHover, this.dragLaag) : this.moveLaag(t), this.$.grpLayers.render(), !1);
},
dragfinishHandler: function(e, t) {
t.originator.applyStyle("opacity", "1"), this.placeholder.destroy();
var n = this.$.grpLayers.children.length;
for (var r = 0; r < n; r++) this.$.grpLayers.children[r].removeClass("over"), this.$.grpLayers.children[r].removeClass("overGroup"), this.$.grpLayers.children[r].kindName === "educate.create.view.lijst.LijstitemGroep" && this.$.grpLayers.children[r].handlePosLagen();
this.handlePosLagen();
},
moveLaag: function(e) {
var t = this.dragLaag.getContainer();
this.dragLaag.setContainer(null);
if (this.insertBeforeItem(e.clientY, this.lastHover.hasNode())) this.dragLaag.addBefore = this.lastHover; else {
var n = this.$.grpLayers.indexOfChild(this.lastHover);
this.$.grpLayers.children[n + 1] ? this.dragLaag.addBefore = this.$.grpLayers.children[n + 1] : this.dragLaag.addBefore = undefined;
}
this.dragLaag.setContainer(t);
},
addLaagToGroup: function(e, t) {
var n = e.linked ? e.getLinked() : "stage", r = t.parent.parent.linked ? t.parent.parent.getLinked() : "";
enyo.Signals.send("onObjectGroupChange", {
grp: n,
oldgrp: r,
obj: t.getLinked()
}), e.addToGroup(t);
},
addToGroup: function(e) {
e.addBefore = null, e.setContainer(this.$.grpLayers);
},
newObjectAddedHandler: function(e, t) {
this.handlePosLagen();
},
handlePosLagen: function() {
var e = this.$.grpLayers.children.length;
for (var t = 0; t < e; t++) {
var n = this.$.grpLayers.children.indexOf(this.$.grpLayers.children[t]);
this.$.grpLayers.children[t].setPosition(n), this.$.grpLayers.children[t].getLinked().setPosition(n);
}
enyo.Signals.send("onListOrderChanged");
},
getAllLayers: function() {
return this.$.grpLayers.children;
},
getAllLayersForSave: function(e) {
var t = [], n = e.length;
for (var r = 0; r < n; r++) e[r].collection = e[r].kindName === "educate.create.view.lijst.LijstitemGroep" && this.getAllLayersForSave(e[r].$.zoneLijst.children), t.push(e[r]);
return t;
},
layerDeletedHandler: function(e, t) {
e.owner.kindName == "educate.create.view.View" && t.destroy();
},
layerDeletedAllHandler: function(e, t) {
e.owner.kindName == "educate.create.view.View" && (this.$.grpLayers.destroyClientControls(), this.render());
},
colectViewObjectenHandler: function(e, t) {
this.bubble("viewObjectenCollected", {
viewObjecten: this.getAllLayersForSave(this.getAllLayers()),
type: t
});
}
});

// Lijstitem.js

enyo.kind({
name: "educate.create.view.lijst.Lijstitem",
kind: enyo.Control,
tag: "li",
classes: "lijstItem empty",
handlers: {
ontap: "onTapHandler",
layerSelected: "layerSelectedHandler",
deselectedObjects: "deselectedObjectsHandler",
onPropertiesChanged: "onPropertiesChangedHandler",
objectLockChange: "objectLockChangeHandler",
removeClicked: "removeClickedHandler"
},
components: [ {
classes: "label",
name: "label",
components: [ {
tag: "span",
name: "tekstlabel",
content: this.label
}, {
classes: "buttons",
components: [ {
name: "visible",
classes: "lijstItemIcon icon-eye-open",
ontap: "visibilityLayer"
}, {
name: "lock",
classes: "lijstItemIcon icon-unlock",
ontap: "lockLayer"
}, {
name: "delete",
classes: "lijstItemIcon icon-trash",
ontap: "deleteLayer"
}, {
name: "toggleZoneList",
classes: "lijstItemIcon icon-folder-close",
ontap: "toggleZoneList"
} ]
} ]
}, {
tag: "ul",
name: "zoneLijst",
showing: !1,
classes: "zoneLijst"
} ],
published: {
linked: "",
width: "100%",
height: "30",
linkedProperty: "",
position: "",
isSubLayer: !1,
isEmpty: !0,
isDragable: !0
},
create: function() {
this.inherited(arguments);
},
rendered: function() {
this.inherited(arguments), this.labelChanged();
},
destroy: function() {
this.inherited(arguments);
},
labelChanged: function() {
this.$.tekstlabel.setContent(this.getLabel());
},
onTapHandler: function(e, t) {
this.linked.kind == "educate.create.components.3DObject.3DObject" && e.name == "tekstlabel" ? this.layerTapped() : (t.originator.kindName === "educate.create.view.lijst.LijstitemObject" || t.originator.kindName === "educate.create.view.lijst.LijstitemGroep") && !this.hasClass("selected") && t.originator.layerTapped();
},
layerTapped: function() {
this.bubble("layerSelected", this);
},
layerSelectedHandler: function(e, t) {
this.deselectLayer(), t == this && this.selectLayer();
},
selectLayer: function() {
this.addClass("selected");
},
deselectLayer: function() {
this.removeClass("selected");
},
deselectedObjectsHandler: function(e, t) {
this.deselectLayer();
},
onPropertiesChangedHandler: function(e, t) {
(t = this) && this.setLabel(t.linked.layername);
},
removeClickedHandler: function(e, t) {
this.deleteLayer();
},
deleteLayer: function() {
this.hasClass("selected") && this.bubble("layerDeleted", this);
},
visibilityLayer: function() {
this.linked.setDisplay(!this.linked.getDisplay()), this.isSubLayer ? this.bubble("sublayerVisibilityClicked", {
svg: this.linked.svgparser,
zone: this.linked
}) : this.bubble("layerVisibilityClicked", this), this.$.visible.addRemoveClass("icon-eye-open", this.linked.getDisplay()), this.$.visible.addRemoveClass("icon-eye-close", !this.linked.getDisplay());
},
lockLayer: function() {
this.hasClass("selected") && this.bubble("layerLockClicked", this);
},
objectLockChangeHandler: function(e, t) {
t == this.linked && this.handleLockIcon();
},
handleLockIcon: function() {
this.linked.getLocked() ? (this.$.lock.removeClass("icon-unlock"), this.$.lock.addClass("icon-lock")) : (this.$.lock.removeClass("icon-lock"), this.$.lock.addClass("icon-unlock"));
},
toggleZoneList: function(e, t) {
this.handleIconZoneLijst(), this.$.zoneLijst.setShowing(!this.$.zoneLijst.getShowing());
},
handleIconZoneLijst: function() {
this.$.toggleZoneList.hasClass("icon-folder-open") ? (this.$.toggleZoneList.removeClass("icon-folder-open"), this.$.toggleZoneList.addClass("icon-folder-close")) : (this.$.toggleZoneList.removeClass("icon-folder-close"), this.$.toggleZoneList.addClass("icon-folder-open"));
}
});

// LijstitemGroep.js

enyo.kind({
name: "educate.create.view.lijst.LijstitemGroep",
kind: "educate.create.view.lijst.Lijstitem",
classes: "lijstitemGroup",
handlers: {},
published: {
label: "Nieuwe Groep"
},
create: function() {
this.inherited(arguments), this.render();
},
addToGroup: function(e) {
e.addBefore = null, e.setContainer(this.$.zoneLijst), this.removeClass("empty");
},
visibilityLayer: function() {
this.inherited(arguments), this.changeVisibilityFromItemsInGroup(this.linked.getDisplay());
},
changeVisibilityFromItemsInGroup: function(e) {
var t = this.$.zoneLijst.children.length;
for (var n = 0; n < t; n++) this.$.zoneLijst.children[n].kindName === "educate.create.view.lijst.LijstitemGroep" && this.$.zoneLijst.children[n].changeVisibilityFromItemsInGroup(e), this.$.zoneLijst.children[n].$.visible.addRemoveClass("icon-eye-open", e), this.$.zoneLijst.children[n].$.visible.addRemoveClass("icon-eye-close", !e);
},
sortLayers: function() {
var e = this.$.zoneLijst.children.length;
for (var t = 0; t < e; t++) this.$.zoneLijst.children[t].kindName === "educate.create.view.lijst.LijstitemGroep" && this.$.zoneLijst.children[t].sortLayers();
this.$.zoneLijst.children.sort(enyo.bind(this, "sortObjecten"));
},
sortObjecten: function(e, t) {
return e.linked.position - t.linked.position;
},
handlePosLagen: function() {
var e = this.$.zoneLijst.children.length;
for (var t = 0; t < e; t++) {
var n = this.$.zoneLijst.children.indexOf(this.$.zoneLijst.children[t]);
this.$.zoneLijst.children[t].setPosition(n), this.$.zoneLijst.children[t].getLinked().setPosition(n);
}
}
});

// LijstitemObject.js

enyo.kind({
name: "educate.create.view.lijst.LijstitemObject",
kind: "educate.create.view.lijst.Lijstitem",
classes: "lijstitemObject",
handlers: {
objectSelected: "objectSelectedHandler",
svgLoaded: "svgLoadedHandler"
},
published: {
label: "New Layer"
},
create: function() {
this.inherited(arguments), this.render();
},
rendered: function() {
this.inherited(arguments);
},
objectSelectedHandler: function(e, t) {
t.objectId == this.linked.objectId && this.bubble("layerSelected", this);
},
svgLoadedHandler: function(e, t) {
this.linked.kindName === "educate.create.components.svg.SvgParser" && this.makeZonesInLijst();
},
makeZonesInLijst: function() {
this.$.tekstlabel.applyStyle("width", this.linked.collection.length > 0 ? "85px" : "100px"), this.addRemoveClass("empty", this.linked.collection.length === 0), this.$.zoneLijst && this.putZonesInLijst();
},
putZonesInLijst: function() {
this.$.zoneLijst.children.length > 0 && this.$.zoneLijst.destroyClientControls();
var e = 0, t = [];
for (var n in this.linked.collection) this.linked.collection[n].value != "" && (e++, this.linked.collection[n].type == "legende" ? this.makeLegende(this.linked.collection[n]) : this.$.zoneLijst.createComponent({
kind: "educate.create.view.lijst.LijstitemObject",
linked: this.linked.collection[n],
label: this.linked.collection[n].layername,
classes: "zoneLijstItem",
isSubLayer: !0
}, {
owner: this
}));
this.$.zoneLijst.render();
},
makeLegende: function(e) {
var t = this.$.zoneLijst.createComponent({
kind: "educate.create.view.lijst.LijstitemObject",
name: "legende_" + e.layername,
linked: e,
label: e.layername,
classes: "zoneLijstItem legende",
isSubLayer: !0,
isEmpty: !1,
isDragable: !1
}, {
owner: this
});
return this.makeLegendeItems(e.collection, t), t;
},
makeLegendeItems: function(e, t) {
var n, r = e.length, i = [];
for (n = 0; n < r; n++) i.push({
kind: "educate.create.view.lijst.LijstitemObject",
linked: e[n],
label: e[n].layername,
classes: "zoneLijstItem legendeItem",
isSubLayer: !0,
isEmpty: !0
});
t.$.zoneLijst.createComponents(i, {
owner: this
}), t.removeClass("empty");
},
zoneTappedHandler: function(e, t) {
this.hasClass("selected") ? (this.selectZoneItem(e), this.bubble("layerZoneSelected", {
linked: e.linkedZone
})) : this.layerTapped();
},
legendeTappedHandler: function(e, t) {
return this.selectZoneItem(e), this.bubble("layerZoneSelected", {
linked: e.linkedZone
}), this.$.legendeLijstZone.addClass("selected"), !0;
},
selectZoneItem: function(e) {
this.deselectZoneItems(), this.$.legendeLijst && this.deselectLegendeItems(), e.addClass("selected");
},
deselectZoneItems: function() {
var e = this.$.zoneLijst.children.length;
for (var t = 0; t < e; t++) this.$.zoneLijst.children[t].removeClass("selected");
},
deselectLayer: function() {
this.inherited(arguments), this.$.zoneLijst && this.deselectZoneItems();
},
deselectLegendeItems: function() {
var e = this.$.legendeLijst.children.length;
for (var t = 0; t < e; t++) this.$.legendeLijst.children[t].removeClass("selected");
},
onTapHandler: function(e, t) {
this.inherited(arguments), e.name != "zoneLijst" && this.$.zoneLijst && this.deselectZoneItems(), e.name != "legendeLijst" && e.name != "zoneLijst" && this.$.legendeLijst && this.deselectLegendeItems();
},
toggleLegendeLijst: function(e, t) {
this.handleIconLegendeLijst(), this.$.legendeLijst.setShowing(!this.$.legendeLijst.getShowing());
},
handleIconLegendeLijst: function() {
this.$.toggleLegendeLijst.hasClass("icon-folder-open") ? (this.$.toggleLegendeLijst.removeClass("icon-folder-open"), this.$.toggleLegendeLijst.addClass("icon-folder-close")) : (this.$.toggleLegendeLijst.removeClass("icon-folder-close"), this.$.toggleLegendeLijst.addClass("icon-folder-open"));
}
});

// ButtonStyle.js

enyo.kind({
name: "educate.create.view.eigenschappen.dialoogvensters.ButtonStyle",
kind: enyo.Control,
classes: "ButtonStyle",
components: [ {
tag: "div",
name: "normal",
classes: "normal",
components: [ {
tag: "button",
content: "een knop",
classes: "Button"
} ]
}, {
tag: "div",
name: "down",
classes: "down",
components: [ {
tag: "button",
content: "een knop",
classes: "Button down"
} ]
}, {
tag: "div",
name: "active",
classes: "active",
components: [ {
tag: "button",
content: "een knop",
classes: "Button active"
} ]
}, {
tag: "div",
name: "disabled",
classes: "disabled",
components: [ {
tag: "button",
content: "een knop",
classes: "Button disabled"
} ]
} ],
published: {
selected: !1,
"class": "Button"
},
handlers: {
ontap: "onTapHandler"
},
events: {
onSelectionChanged: ""
},
create: function() {
this.inherited(arguments), this.classChanged();
},
rendered: function() {
this.inherited(arguments);
},
onTapHandler: function() {
this.doSelectionChanged();
},
select: function() {
this.setSelected(!0), this.addRemoveClass("selected", this.getSelected());
},
deselect: function() {
this.setSelected(!1), this.addRemoveClass("selected", this.getSelected());
},
classChanged: function() {
var e, t = this.controls.length;
for (e = 0; e < t; e++) this.controls[0].destroy();
this.controls = [], this.createComponent({
tag: "div",
name: "normal",
classes: "normal",
components: [ {
tag: "button",
content: "een knop",
classes: this.getClass() + ""
} ]
}), this.createComponent({
tag: "div",
name: "down",
classes: "down",
components: [ {
tag: "button",
content: "een knop",
classes: this.getClass() + " down"
} ]
}), this.createComponent({
tag: "div",
name: "active",
classes: "active",
components: [ {
tag: "button",
content: "een knop",
classes: this.getClass() + " active"
} ]
}), this.createComponent({
tag: "div",
name: "disabled",
classes: "disabled",
components: [ {
tag: "button",
content: "een knop",
classes: this.getClass() + " disabled"
} ]
});
}
});

// ButtonStylePicker.js

enyo.kind({
name: "educate.create.view.eigenschappen.dialoogvensters.ButtonStylePicker",
kind: "enyo.Popup",
centered: !1,
modal: !0,
floating: !0,
classes: "buttonStylePicker modal",
published: {
buttonClasses: [ "Button", "Button Button-drag", "Button Button-click-drag", "Button Button-correct", "Button Button-wrong", "Button Button-flat" ],
selected: null
},
components: [ {
classes: "modal-header",
components: [ {
tag: "button",
classes: "close",
content: "\u00d7",
ontap: "closeModal"
}, {
tag: "h3",
content: "kies je knop"
} ]
}, {
name: "buttons",
classes: "modal-body"
}, {
classes: "modal-footer",
components: [ {
tag: "button",
content: "annuleer",
classes: "btn",
ontap: "closeModal"
}, {
tag: "button",
content: "kies",
classes: "btn btn-primary",
ontap: "selectStyle"
} ]
} ],
events: {
onStyleSelectionChanged: ""
},
create: function() {
this.inherited(arguments), this.buttonClassesChanged();
},
rendered: function() {
this.inherited(arguments);
},
buttonClassesChanged: function(e) {
if (this.$.buttons.controls) {
var t, n = this.$.buttons.controls.length;
for (t = 0; t < n; t++) this.$.buttons.controls[0].destroy();
this.$.buttons.controls = [];
}
n = this.getButtonClasses().length;
for (t = 0; t < n; t++) this.createComponent({
kind: "educate.create.view.eigenschappen.dialoogvensters.ButtonStyle",
"class": this.getButtonClasses()[t],
onSelectionChanged: "onSelectionChanged",
container: this.$.buttons
});
this.$.buttons.controls[0].select(), this.selected = this.$.buttons.controls[0], this.render();
},
onSelectionChanged: function(e, t) {
var n, r = this.$.buttons.controls.length;
for (n = 0; n < r; n++) this.$.buttons.controls[n].deselect();
e.select(), this.selected = e;
},
closeModal: function() {
this.hide();
},
selectStyle: function() {
this.doStyleSelectionChanged(), this.hide();
}
});

// actieDialoog.js

enyo.kind({
kind: enyo.Popup,
name: "educate.create.view.eigenschappen.dialoogvensters.ActieDialoog",
classes: "modal actieModal",
floating: !0,
modal: !0,
published: {
layer: null,
linked: null,
event: null,
customEventname: !1,
viewId: -1
},
handlers: {
onHide: "hideMe",
onDoelChange: "doelenSelectionChanged",
onRemoveDoel: "doelRemoved",
onReactieChange: "reactionSelectionChanged",
onRemoveReactie: "reactionRemoved",
onAddParallel: "parallelAdded",
onRemoveParallel: "parallelRemoved"
},
events: {
onCancelEvent: "",
onSaveEvent: ""
},
components: [ {
classes: "modal-header",
components: [ {
classes: "pull-right",
components: [ {
kind: enyo.Button,
name: "btnAddDoel",
classes: "btn",
ontap: "addDoel",
components: [ {
tag: "i",
classes: "icon-plus-sign",
content: " "
}, {
tag: "span",
content: "doel"
} ]
}, {
tag: "span",
content: " "
}, {
kind: enyo.Button,
name: "btnAddReactie",
classes: "btn",
ontap: "addReactie",
components: [ {
tag: "i",
classes: "icon-plus-sign",
content: " "
}, {
tag: "span",
content: "reactie"
} ]
} ]
}, {
kind: enyo.Button,
name: "btnEditName",
classes: "btn btnEditName",
ontap: "editName",
components: [ {
tag: "i",
classes: "icon-pencil",
content: ""
} ]
}, {
kind: enyo.Input,
name: "txtEventName",
placeholder: "naam voor de actie",
selectOnFocus: !0,
value: "",
disabled: !0,
classes: "eventName"
}, {
kind: enyo.Button,
name: "btnSaveName",
classes: "btn btn-primary btnSaveName noShow",
ontap: "saveName",
components: [ {
tag: "i",
classes: "icon-save",
content: ""
} ]
} ]
}, {
classes: "modal-body",
components: [ {
tag: "table",
classes: "table table-condensed row-fluid",
components: [ {
tag: "tbody",
components: [ {
tag: "tr",
components: [ {
tag: "td",
classes: "button-column",
components: [ {
kind: enyo.Button,
ontap: "removeAction",
classes: "btn-icon",
components: [ {
tag: "i",
classes: "icon-trash"
} ]
} ]
}, {
tag: "td",
content: "actie:"
}, {
tag: "td",
components: [ {
kind: "educate.create.view.eigenschappen.dialoogvensters.actieDialoog.EventList",
name: "lstEvents",
layer: this.layer,
onchange: "eventSelectionChanged"
} ]
}, {
tag: "td",
classes: "tableholder",
components: [ {
tag: "table",
classes: "table table-striped table-condensed",
name: "tableDoelen"
} ]
} ]
} ]
} ]
} ]
}, {
classes: "modal-footer",
components: [ {
kind: enyo.Button,
name: "btnCancel",
ontap: "annuleer",
classes: "btn",
components: [ {
tag: "i",
classes: "icon-remove",
content: " "
}, {
tag: "span",
content: "annuleer"
} ]
}, {
kind: enyo.Button,
name: "btnSave",
ontap: "opslaan",
classes: "btn btn-primary",
components: [ {
tag: "i",
classes: "icon-save",
content: " "
}, {
tag: "span",
content: "opslaan"
} ]
} ]
} ],
create: function() {
this.inherited(arguments), this.eventChanged(), this.$.lstEvents.setLayer(this.getLayer());
},
rendered: function() {
this.inherited(arguments), this.$.txtEventName.setValue(this.getEvent().eventName);
},
editName: function() {
this.$.txtEventName.setAttribute("disabled", null), this.$.btnEditName.addClass("noShow"), this.$.btnSaveName.removeClass("noShow"), this.customEventname = !0;
},
saveName: function() {
this.$.txtEventName.setAttribute("disabled", !0), this.$.btnEditName.removeClass("noShow"), this.$.btnSaveName.addClass("noShow"), this.$.txtEventName.getValue() === "" ? (this.customEventname = !1, this.updateName()) : (this.getEvent().eventName = educate.String.toCamelCase(this.$.txtEventName.getValue()), this.$.txtEventName.setValue(this.getEvent().eventName));
},
eventChanged: function() {
this.getEvent() || (this.event = new educate.Actie, this.event.event = "", this.event.targets = [ "" ], this.event.reactions = [ [ [ "" ] ] ]), this.customEventname || this.updateName(), this.$.lstEvents.event = this.event, this.$.lstEvents.setSelection(this.getEvent().event), this.createDoelen();
},
updateName: function() {
var e = this.getLinked().layername + "." + this.getEvent().event, t = enyo.$["create_view" + this.viewId];
for (var n in this.getEvent().targets) this.getEvent().targets[n] !== "" && t.viewChildren[this.getEvent().targets[n]] && (e += "." + t.viewChildren[this.getEvent().targets[n]].layername);
this.$.txtEventName.setValue(e), this.getEvent().eventName = e;
},
createDoelen: function() {
this.$.tableDoelen.destroyClientControls(), this.$.tableDoelen.destroyComponents();
var e = this.getEvent(), t = this.getEvent().targets, n = this.getEvent().reactions;
t.length === 0 && (t = [ "" ]), n.length === 0 && (n = [ "" ]);
for (var r in t) this.$.tableDoelen.createComponent({
kind: "educate.create.view.eigenschappen.dialoogvensters.actieDialoog.Doel",
event: this.getEvent(),
index: r,
layer: this.getLayer(),
viewId: this.viewId
});
this.render();
},
layerChanged: function() {
this.$.doelenTable ? this.$.doelenTable.setLayer(this.getLayer()) : this.createDoelen();
},
annuleer: function(e, t) {
this.hideMe("cancel");
},
opslaan: function(e, t) {
this.hideMe("save");
},
hideMe: function(e) {
e === "save" && this.bubble("onSaveEvent", {
event: this.getEvent()
}), this.destroy();
},
addDoel: function(e, t) {
var n, r = this.event.reactions[0].length, i = [];
for (n = 0; n < r; n++) i.push([ "" ]);
return this.event.targets.push(""), this.event.reactions.push(i), this.eventChanged(), !0;
},
addReactie: function(e, t) {
for (var n in this.event.reactions) this.event.reactions[n].push([ "" ]);
return this.eventChanged(), !0;
},
removeAction: function(e, t) {
return this.event = null, this.eventChanged(), !0;
},
eventSelectionChanged: function(e, t) {
return this.event.event = this.$.lstEvents.getValue(), this.eventChanged(), !0;
},
doelenSelectionChanged: function(e, t) {
return this.event.targets[t.index] = t.value, this.event.targetComponents[t.index] = t.value, this.eventChanged(), !0;
},
doelRemoved: function(e, t) {
return this.event.targets.splice(t.index, 1), this.event.reactions.splice(t.index, 1), this.event.targets.length === 0 && (this.event.targets.push(""), this.event.reactions.push([ [ "" ] ])), this.eventChanged(), !0;
},
reactionSelectionChanged: function(e, t) {
return this.event.reactions[t.doelIndex][t.reactieIndex][t.index] = t.value, this.eventChanged(), !0;
},
reactionRemoved: function(e, t) {
for (var n in this.event.reactions) this.event.reactions[n].splice(t.reactieIndex, 1), this.event.reactions[n].length === 0 && this.event.reactions[n].push([ "" ]);
return this.eventChanged(), !0;
},
parallelAdded: function(e, t) {
return this.event.reactions[t.doelIndex][t.reactieIndex].push(""), this.eventChanged(), !0;
},
parallelRemoved: function(e, t) {
return this.event.reactions[t.doelIndex][t.reactieIndex].splice(t.index, 1), this.event.reactions[t.doelIndex][t.reactieIndex].length === 0 && this.event.reactions[t.doelIndex][t.reactieIndex].push(""), this.eventChanged(), !0;
}
});

// eventList.js

enyo.kind({
name: "educate.create.view.eigenschappen.dialoogvensters.actieDialoog.EventList",
kind: enyo.Select,
classes: "span12",
published: {
event: null,
selection: "",
layer: null
},
create: function() {
this.inherited(arguments), this.fill();
},
layerChanged: function() {
this.fill();
},
rendered: function() {
this.inherited(arguments);
},
fill: function() {
this.destroyClientControls(), this.destroyComponents(), this.event && this.event.getEvent() == "" && this.createComponent({
tag: "option",
content: "\u2026",
attributes: {
value: ""
}
});
if (this.getLayer()) {
var e = this.getLayer().linked, t = 0, n = 0;
for (var r in e.getEventOptions()) this.event && this.event.getEvent() === r ? (this.createComponent({
tag: "option",
content: e.getEventOptions()[r].label,
value: r
}), n = t) : this.createComponent({
content: e.getEventOptions()[r].label,
value: r
}), t++;
}
this.selected = n, this.render();
},
selectionChanged: function() {
for (var e in this.getComponents()) this.getSelection() === this.getComponents()[e].getAttribute("value") && this.setSelected(e);
}
});

// doelList.js

enyo.kind({
name: "educate.create.view.eigenschappen.dialoogvensters.actieDialoog.DoelList",
kind: enyo.Select,
classes: "span12",
published: {
event: null,
layer: null,
selection: "",
viewId: -1
},
create: function() {
this.inherited(arguments), this.viewIdChanged();
},
viewIdChanged: function() {
this.fill();
},
layerChanged: function() {
this.fill();
},
fill: function() {
this.destroyClientControls(), this.destroyComponents(), this.createComponent({
tag: "option",
content: "\u2026",
attributes: {
value: ""
}
});
var e = enyo.$["create_view" + this.viewId];
if (!this.getLayer() || !e) return !1;
var t = 0, n = 0, r = e.getViewChildren();
for (var i in r) {
var s = "educate.create.onderbalk.knoppen.", o = r[i], u = this.getKindnamePrefix(o.kindName);
if (o.kindName === s + "KnopHand" || o.kindName === s + "KnopOplossing" || o.disableActions) continue;
o.getLayername() === this.getSelected() && (n = t), this.createComponent({
content: u + " - " + o.getLayername(),
value: o.objectId
});
}
this.setSelected(n);
},
getKindnamePrefix: function(e) {
var t = e.match(/(\w+\.)+(\w+)/)[2];
switch (t) {
case "SvgZone":
t = "zone";
break;
case "SvgParser":
t = " svg";
break;
case "Image":
t = " img";
break;
case "KnopHand":
t = "hand";
break;
case "KnopOplossing":
t = " opl";
break;
case "Knop":
t = " btn";
break;
case "Laag":
t = "laag";
break;
default:
console.log('case "' + t + '": break;');
}
return t;
},
selectionChanged: function() {
for (var e in this.getComponents()) this.getSelection() == this.getComponents()[e].getAttribute("value") && this.setSelected(e);
}
});

// reactieList.js

enyo.kind({
name: "educate.create.view.eigenschappen.dialoogvensters.actieDialoog.ReactieList",
kind: "Control",
tag: "tr",
published: {
event: null,
doelIndex: -1,
reactieIndex: -1,
index: -1,
viewId: -1
},
events: {
onReactieChange: "",
onRemoveParallel: ""
},
components: [ {
tag: "td",
components: [ {
kind: enyo.Button,
ontap: "removeStep",
classes: "btn-icon btn-condensed",
components: [ {
tag: "i",
classes: "icon-trash"
} ]
} ]
}, {
tag: "td",
components: [ {
kind: enyo.Select,
name: "lst",
classes: "span12",
onchange: "reactieSelectionChanged"
} ]
} ],
create: function() {
this.inherited(arguments), this.fill();
},
rendered: function() {
this.inherited(arguments);
},
fill: function() {
this.$.lst.destroyClientControls(), this.$.lst.destroyComponents(), this.$.lst.createComponent({
content: "\u2026",
value: ""
});
var e = enyo.$["create_view" + this.viewId], t = this.getEvent().targets[this.getDoelIndex()];
if (t && e) {
var n = e.getChildById(t), r = 1, i = 0;
for (var s in n.getReactieOptions()) this.getEvent() && this.getEvent().reactions[this.getDoelIndex()][this.getReactieIndex()][this.getIndex()] === s && (i = r), this.$.lst.createComponent({
content: n.getReactieOptions()[s].label,
value: s
}), r++;
}
this.$.lst.setSelected(i), this.render();
},
eventChanged: function() {
this.selectionChanged();
},
doelIndexChanged: function() {
this.selectionChanged();
},
reactieIndexChanged: function() {
this.selectionChanged();
},
indexChanged: function() {
this.selectionChanged();
},
selectionChanged: function() {
var e = this.getEvent().reactions[this.getDoelIndex()][this.getReactieIndex()][this.getIndex()];
for (var t in this.$.lst.getComponents()) console.log(e, this.$.lst.getComponents()[t].getValue()), e === this.$.lst.getComponents()[t].getValue() && this.$.lst.setSelected(t);
this.render();
},
reactieSelectionChanged: function(e, t) {
this.bubble("onReactieChange", {
doelIndex: this.getDoelIndex(),
reactieIndex: this.getReactieIndex(),
index: this.getIndex(),
value: this.$.lst.getValue()
});
},
removeStep: function(e, t) {
this.bubble("onRemoveParallel", {
doelIndex: this.getDoelIndex(),
reactieIndex: this.getReactieIndex(),
index: this.getIndex(),
value: this.$.lst.getValue()
});
}
});

// doel.js

enyo.kind({
name: "educate.create.view.eigenschappen.dialoogvensters.actieDialoog.Doel",
kind: "Control",
tag: "tr",
classes: "doel",
published: {
event: null,
layer: null,
index: -1,
viewId: -1
},
events: {
onDoelChange: ""
},
components: [ {
tag: "td",
classes: "button-column",
components: [ {
kind: enyo.Button,
ontap: "removeDoel",
classes: "btn-icon",
components: [ {
tag: "i",
classes: "icon-trash"
} ]
} ]
}, {
tag: "td",
content: "doel:"
}, {
tag: "td",
components: [ {
kind: "educate.create.view.eigenschappen.dialoogvensters.actieDialoog.DoelList",
name: "lstDoelen",
onchange: "doelenSelectionChanged",
layer: this.layer,
doel: null,
viewId: this.viewId
} ]
}, {
tag: "td",
classes: "tableholder",
components: [ {
tag: "table",
classes: "table table-striped table-condensed",
name: "reactieList"
} ]
} ],
create: function() {
this.inherited(arguments), this.viewIdChanged(), this.layerChanged(), this.eventChanged();
},
viewIdChanged: function() {
this.$.lstDoelen.setViewId(this.getViewId());
},
layerChanged: function() {
this.$.lstDoelen.setLayer(this.getLayer());
},
eventChanged: function() {
this.fill();
},
indexChanged: function() {
this.fill();
},
fill: function() {
this.$.lstDoelen.setSelection(this.getEvent().targets[this.getIndex()]), this.$.reactieList.destroyClientControls(), this.$.reactieList.destroyComponents(), this.event.reactions.length === 0 && (this.event.reactions = [ "" ]);
for (var e in this.event.reactions[this.getIndex()]) this.$.reactieList.createComponent({
kind: "educate.create.view.eigenschappen.dialoogvensters.actieDialoog.Reactie",
doelIndex: this.getIndex(),
index: e,
event: this.getEvent(),
viewId: this.viewId
});
},
doelenSelectionChanged: function(e, t) {
this.bubble("onDoelChange", {
index: this.getIndex(),
value: this.$.lstDoelen.getValue()
});
},
removeDoel: function() {
this.bubble("onRemoveDoel", {
index: this.getIndex()
});
}
});

// reactie.js

enyo.kind({
name: "educate.create.view.eigenschappen.dialoogvensters.actieDialoog.Reactie",
kind: "Control",
tag: "tr",
classes: "reactie",
published: {
event: null,
index: -1,
doelIndex: -1,
viewId: -1
},
events: {
onReactieChange: "",
onRemoveReactie: "",
onAddParallel: ""
},
components: [ {
tag: "td",
classes: "button-column",
components: [ {
kind: enyo.Button,
ontap: "removeReaction",
classes: "btn-icon btn-condensed",
components: [ {
tag: "i",
classes: "icon-trash"
} ]
} ]
}, {
tag: "td",
components: [ {
classes: "span10",
content: "reactie:"
}, {
classes: "span2",
components: [ {
kind: enyo.Button,
ontap: "addParrallel",
classes: "btn-icon",
components: [ {
tag: "i",
classes: "icon-plus-sign"
} ]
} ]
} ]
}, {
tag: "td",
classes: "tableholder",
components: [ {
tag: "table",
classes: "table table-striped table-condensed",
name: "lstReacties"
} ]
} ],
create: function() {
this.inherited(arguments), this.fill();
},
eventChanged: function() {
this.fill();
},
doelIndexChanged: function() {
this.fill();
},
indexChanged: function() {
this.fill();
},
fill: function() {
this.$.lstReacties.destroyClientControls(), this.$.lstReacties.destroyComponents();
var e = this.getEvent().reactions[this.getDoelIndex()][this.getIndex()];
for (var t in e) this.$.lstReacties.createComponent({
kind: "educate.create.view.eigenschappen.dialoogvensters.actieDialoog.ReactieList",
event: this.getEvent(),
doelIndex: this.getDoelIndex(),
reactieIndex: this.getIndex(),
index: t,
viewId: this.viewId
});
},
removeReaction: function(e, t) {
this.bubble("onRemoveReactie", {
doelIndex: this.getDoelIndex(),
reactieIndex: this.getIndex()
});
},
addParrallel: function(e, t) {
this.bubble("onAddParallel", {
doelIndex: this.getDoelIndex(),
reactieIndex: this.getIndex()
});
}
});

// LinkEigenschapDialoog.js

enyo.kind({
kind: enyo.Popup,
name: "educate.create.view.eigenschappen.dialoogvensters.LinkEigenschapDialoog",
classes: "modal linkEigenschapDialoog",
floating: !0,
modal: !0,
published: {
layer: null,
eigenschap: "",
field: null,
offset: "",
linkExist: "",
linkDbId: "",
viewId: ""
},
handlers: {},
components: [ {
classes: "modal-header",
components: [ {
tag: "button",
classes: "close",
content: "&times",
allowHtml: !0,
ontap: "annuleer"
}, {
tag: "h3",
content: "Link eigenschap"
} ]
}, {
classes: "modal-body",
components: [ {
tag: "ul",
classes: "nav nav-tabs",
components: [ {
tag: "li",
classes: "active",
components: [ {
tag: "a",
attributes: {
href: "#link"
},
content: "link"
} ]
}, {
tag: "li",
components: [ {
tag: "a",
attributes: {
href: "#glvar"
},
content: "Beheer globale variablen"
} ]
}, {
tag: "li",
components: [ {
tag: "a",
attributes: {
href: "#linkhelp"
},
content: "Help"
} ]
} ]
}, {
tag: "div",
classes: "row-fluid",
components: [ {
tag: "div",
classes: "span8",
components: [ {
tag: "div",
classes: "tab-content",
components: [ {
tag: "div",
classes: "tab-pane active",
name: "tablink",
components: [ {
tag: "div",
classes: "row-fluid",
components: [ {
tag: "div",
name: "offsetCon"
} ]
}, {
tag: "div",
name: "formuleCon",
classes: "formuleCon row-fluid",
components: [ {
tag: "div",
classes: "form-horizontal",
components: [ {
tag: "div",
classes: "control-group",
components: [ {
tag: "label",
name: "eigenschap",
classes: "control-label",
content: "Formule: "
}, {
tag: "div",
classes: "controls",
components: [ {
tag: "div",
classes: "input-prepend input-append",
components: [ {
tag: "span",
classes: "add-on",
name: "offsetAddonBefore",
content: "(",
showing: !1
}, {
kind: "enyo.Input",
name: "formule",
onkeyup: "formuleKeyPress",
onblur: "inputBlurred",
onfocus: "inputFocused",
attributes: {
autocomplete: "off"
},
type: "text"
}, {
tag: "span",
classes: "add-on",
name: "offsetAddonAfter",
showing: !1
} ]
} ]
} ]
} ]
} ]
} ]
}, {
tag: "div",
classes: "tab-pane",
name: "tabglvar",
components: [ {
tag: "div",
name: "addVariableCon",
classes: "addVariableCon row-fluid",
showing: !1
} ]
}, {
tag: "div",
classes: "tab-pane",
name: "tablinkhelp",
components: [ {
tag: "h3",
classes: "row-fluid",
content: "Help"
}, {
tag: "p",
classes: "row-fluid",
content: "Een globale variable gebruiken in een formule start altijd met een $ teken."
}, {
tag: "p",
classes: "row-fluid",
content: "Een eigenschap van een object opvragen => {naamVanObject.afkortingEigenschap}"
}, {
tag: "p",
classes: "row-fluid",
content: "Mogelijke afkortingen (afhankelijk van object) voor eigenschap:"
}, {
tag: "ul",
components: [ {
tag: "li",
content: "posx"
}, {
tag: "li",
content: "posy"
}, {
tag: "li",
content: "posz"
}, {
tag: "li",
content: "width"
}, {
tag: "li",
content: "height"
}, {
tag: "li",
content: "rotx"
}, {
tag: "li",
content: "roty"
}, {
tag: "li",
content: "rotz"
}, {
tag: "li",
content: "alpha"
} ]
}, {
tag: "p",
classes: "row-fluid",
content: "Een random is op volgende manier => [min.max]"
} ]
} ]
} ]
}, {
tag: "div",
classes: "span4",
components: [ {
tag: "ul",
name: "globalVariableCon",
classes: "variableConHolder"
} ]
} ]
} ]
}, {
classes: "modal-footer",
components: [ {
kind: enyo.Button,
name: "btnCancel",
ontap: "annuleer",
classes: "btn",
components: [ {
tag: "i",
classes: "icon-remove",
content: " "
}, {
tag: "span",
content: "annuleer"
} ]
}, {
kind: enyo.Button,
name: "btnSave",
ontap: "opslaan",
classes: "btn btn-primary",
components: [ {
tag: "i",
classes: "icon-save",
content: " "
}, {
tag: "span",
content: "opslaan"
} ]
} ]
}, {
tag: "div",
name: "autoComplete",
classes: "autoComplete",
showing: !1,
components: [ {
tag: "ul",
name: "autoCompleteList"
} ]
} ],
create: function() {
this.inherited(arguments), this.initLinkEigenschappenDialoog(), this.show(), this.render();
},
initLinkEigenschappenDialoog: function() {
this.$.eigenschap.setContent(this.getEigenschap() + " ="), this.$.tablink.setAttribute("id", "link"), this.$.tabglvar.setAttribute("id", "glvar"), this.$.tablinkhelp.setAttribute("id", "linkhelp"), this.getLinkExist() && this.$.formule.setValue(this.getLinkExist().formule), this.loadGlobalVariables(), this.handleOffsetCon(), this.showAddVariableCon();
},
rendered: function() {
this.inherited(arguments), $(".nav-tabs a").click(function(e) {
e.preventDefault(), $(this).tab("show");
});
},
loadGlobalVariables: function() {
var e = this.getView(), t = e.getGlobalLinkEigenschapVariables(), n = t.length;
if (n > 0) for (var r = 0; r < n; r++) this.createVariable(t[r]);
},
clearGlobalVariableContainer: function() {
this.$.globalVariableCon.destroyClientControls();
},
showAddVariableCon: function() {
this.$.addVariableCon.getShowing() || (this.$.addVariableCon.destroyClientControls(), this.createAddVariableCon(), this.$.addVariableCon.setShowing(!0));
},
createAddVariableCon: function() {
this.createComponents([ {
tag: "form",
classes: "form-horizontal",
container: this.$.addVariableCon,
components: [ {
tag: "div",
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: "variable naam: $"
}, {
tag: "div",
classes: "controls",
components: [ {
kind: "enyo.Input",
name: "variableName",
onkeyup: "inputVarNameKeyPress",
type: "text"
} ]
} ]
}, {
tag: "div",
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: "formule"
}, {
tag: "div",
classes: "controls",
components: [ {
kind: "enyo.Input",
name: "varFormule",
classes: "varFormuleVeld",
onkeyup: "inputVarFormuleKeyPress",
onblur: "inputBlurred",
onfocus: "inputFocused",
attributes: {
autocomplete: "off"
},
type: "text"
} ]
} ]
}, {
tag: "div",
classes: "control-group",
components: [ {
tag: "div",
classes: "controls variableButtons",
components: [ {
tag: "div",
name: "addVariable",
content: "toevoegen",
classes: "btn btn-primary",
ontap: "addVariable"
} ]
} ]
} ]
} ]), this.$.addVariableCon.render();
},
inputVarNameKeyPress: function(e, t) {
this.removeInputErrorClass(e);
},
inputVarFormuleKeyPress: function(e, t) {
this.removeInputErrorClass(e), t.keyCode === 32 ? this.hideAutoComplete() : this.checkFormuleInput(this.$.varFormule);
},
formuleKeyPress: function(e, t) {
t.keyCode === 32 ? this.hideAutoComplete() : this.checkFormuleInput(this.$.formule);
},
inputBlurred: function(e, t) {
window.autoCompleteTimeout = window.setTimeout(enyo.bind(this, "startBlurActions"), 200);
},
startBlurActions: function() {
window.clearTimeout(window.autoCompleteTimeout), this.hideAutoComplete();
},
inputFocused: function(e, t) {
this.checkFormuleInput(e);
},
removeInputErrorClass: function(e) {
e.removeClass("varInputError");
},
checkFormuleInput: function(e) {
var t = e.getValue(), n = e.name, r = t.split(/[\+\-\*\/]+/), i = [], s, o = r.length;
for (s = 0; s < o; s++) !r[s].match(/\{\w+\.\w+\}|\$\w+\s/) && r[s] !== "" && i.push(r[s]);
this.positionAutoComplete($(e.hasNode()).offset()), this.hideAutoComplete();
var u = i.length;
if (u > 0) for (var a = 0; a < u; a++) i[a].match(/\{\w+\.\w+/) ? this.fillAutoComplete(this.getEigenschapWaardenFromObject(i[a].split(".")[0]), n, i[a].split(".")[1]) : i[a].match(/\{\w+\./) ? this.fillAutoComplete(this.getEigenschapWaardenFromObject(i[a].split(".")[0]), n) : i[a].match(/\{\w+/) ? this.fillAutoComplete(this.getObjectsForAutoComplete(), n, i[a].replace(/[ \{]+/, "")) : i[a].match(/\{/) ? this.fillAutoComplete(this.getObjectsForAutoComplete(), n) : i[a].match(/\$\w+/) ? this.fillAutoComplete(this.getGlobaleVariablenForAutoComplete(), n, i[a].replace(/[ ]+/, "")) : i[a].match(/\$/) && this.fillAutoComplete(this.getGlobaleVariablenForAutoComplete(), n);
},
getObjectsForAutoComplete: function() {
var e = [], t = this.getListPanel(this.getLayer()).getAllLayers();
for (var n in t) e.push(t[n].linked.layername);
return e;
},
getListPanel: function(e) {
var t = e;
while (t.owner.kind !== "educate.create.view.lijst.Lijst") t = t.owner;
return t.owner;
},
getEigenschapWaardenFromObject: function(e) {
var t = [], n = this.getView(), r = n.getChildByName(e.replace(/[ \{]+/, "")), i = r && r.getLinkEigenschappenOptions();
for (var s in i) t.push(s);
return t;
},
getGlobaleVariablenForAutoComplete: function() {
var e = [], t = this.getView(), n = t.getGlobalLinkEigenschapVariables(), r = n.length;
if (r > 0) for (var i = 0; i < r; i++) e.push(n[i].name);
return e;
},
fillAutoComplete: function(e, t, n) {
var r = e.length;
for (var i = 0; i < r; i++) (n === undefined || e[i].indexOf(n) !== -1) && this.createComponent({
tag: "li",
container: this.$.autoCompleteList,
content: e[i],
inputName: t,
ontap: "suggestionTapped"
});
this.$.autoCompleteList.render(), this.showAutoComplete();
},
showAutoComplete: function() {
this.$.autoComplete.setShowing(!0);
},
hideAutoComplete: function() {
this.$.autoComplete && this.$.autoComplete.setShowing(!1), this.$.autoCompleteList && this.$.autoCompleteList.destroyClientControls();
},
positionAutoComplete: function(e) {
var t = (e.left + .5 >> 0) - $(".linkEigenschapDialoog").offset().left, n = (e.top + .5 >> 0) - $(".linkEigenschapDialoog").offset().top + 32;
this.$.autoComplete.applyStyle("left", t + "px"), this.$.autoComplete.applyStyle("top", n + "px");
},
suggestionTapped: function(e, t) {
this.insertSuggestionIntoInputField(this.$[e.inputName], e.getContent()), this.$[e.inputName].focus();
},
insertSuggestionIntoInputField: function(e, t) {
var n = e.hasNode().selectionStart, r = e.getValue().substring(0, n), i = e.getValue().substring(n);
t = t.replace(/\$/g, "");
var s = r.match(/\w+$/);
e.setValue(r.replace(s, "") + t + i);
},
clearAddVariableCon: function() {
this.$.addVariableCon.destroyClientControls(), this.$.addVariableCon.setShowing(!1);
},
addVariable: function(e, t) {
if (this.$.variableName.getValue() && this.$.varFormule.getValue()) if (!this.checkGlobalVarNameExist("$" + this.$.variableName.getValue()) && !this.checkVarNameHasSpecialCharacters(this.$.variableName.getValue())) {
var n = new educate.GlobalVariableLinkeigenschap;
n.name = "$" + this.$.variableName.getValue(), n.answered = this.$.varFormule.getValue(), this.createVariable(n), this.addVariableToGlobalsView(n), this.clearAddVariableCon(), this.showAddVariableCon();
} else this.$.variableName.addClass("varInputError"); else !this.$.variableName.getValue() && this.$.variableName.addClass("varInputError"), !this.$.varFormule.getValue() && this.$.varFormule.addClass("varInputError");
},
addVariableToGlobalsView: function(e) {
var t = this.getView();
t.getGlobalLinkEigenschapVariables().push(e);
},
createVariable: function(e) {
this.createComponents([ {
tag: "li",
name: "var" + e.name,
container: this.$.globalVariableCon,
varObj: e,
components: [ {
tag: "span",
components: [ {
tag: "span",
content: e.name + " = "
}, {
tag: "span",
content: e.answered
} ]
}, {
tag: "i",
classes: "icon-edit",
varObj: e,
ontap: "editGlobalVariable"
}, {
tag: "i",
classes: "icon-remove",
varObj: e,
ontap: "removeVariableClicked"
} ]
} ]), this.$.globalVariableCon.render();
},
removeVariableClicked: function(e, t) {
this.removeVariable(e.varObj);
},
removeVariable: function(e) {
this.removeVariableFromGlobal(e), this.$["var" + e.name].destroy();
},
removeVariableFromGlobal: function(e) {
var t = this.getView();
e.getDatabaseId() && t.addObjectToArrDeleted(e.getDatabaseId());
var n = t.getGlobalLinkEigenschapVariables().indexOf(e);
t.getGlobalLinkEigenschapVariables().splice(n, 1);
},
editGlobalVariable: function(e, t) {
$('.nav-tabs a[href="#glvar"]').tab("show"), this.clearAddVariableCon(), this.showEditVariableCon(e.varObj), this.$.variableName.setValue(e.varObj.name.substr(1)), this.$.varFormule.setValue(e.varObj.answered);
},
showEditVariableCon: function(e) {
this.$.addVariableCon.getShowing() || (this.$.addVariableCon.destroyClientControls(), this.createEditVariableCon(e), this.$.addVariableCon.setShowing(!0));
},
createEditVariableCon: function(e) {
this.createComponents([ {
tag: "form",
classes: "form-horizontal",
container: this.$.addVariableCon,
components: [ {
tag: "div",
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: "variable naam: $"
}, {
tag: "div",
classes: "controls",
components: [ {
kind: "enyo.Input",
name: "variableName",
onkeyup: "inputKeyPress",
type: "text"
} ]
} ]
}, {
tag: "div",
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: "formule"
}, {
tag: "div",
classes: "controls",
components: [ {
kind: "enyo.Input",
name: "varFormule",
classes: "varFormuleVeld",
onkeyup: "inputKeyPress",
type: "text"
} ]
} ]
}, {
tag: "div",
classes: "control-group",
components: [ {
tag: "div",
classes: "controls variableButtons",
components: [ {
tag: "div",
name: "editVariable",
content: "bijwerken",
varObj: e,
classes: "btn btn-primary",
ontap: "editVariable"
}, {
tag: "div",
name: "clearAddVariableCon",
content: "annuleren",
classes: "btn",
ontap: "cancelEditVariableCon"
} ]
} ]
} ]
} ]), this.$.addVariableCon.render();
},
editVariable: function(e, t) {
if (this.$.variableName.getValue() && this.$.varFormule.getValue()) if (("$" + this.$.variableName.getValue() === e.varObj.name || !this.checkGlobalVarNameExist("$" + this.$.variableName.getValue())) && !this.checkVarNameHasSpecialCharacters(this.$.variableName.getValue())) {
var n = e.varObj, r = this.getView(), i = r.getGlobalLinkEigenschapVariables().indexOf(n);
r.getGlobalLinkEigenschapVariables()[i].name = "$" + this.$.variableName.getValue(), r.getGlobalLinkEigenschapVariables()[i].answered = this.$.varFormule.getValue(), this.clearAddVariableCon(), this.showAddVariableCon(), this.clearGlobalVariableContainer(), this.loadGlobalVariables();
} else this.$.variableName.addClass("varInputError"); else !this.$.variableName.getValue() && this.$.variableName.addClass("varInputError"), !this.$.varFormule.getValue() && this.$.varFormule.addClass("varInputError");
},
cancelEditVariableCon: function(e, t) {
this.clearAddVariableCon(), this.showAddVariableCon();
},
checkGlobalVarNameExist: function(e) {
var t = this.getView(), n = t.getGlobalLinkEigenschapVariables(), r = n.length;
if (r > 0) for (var i = 0; i < r; i++) if (n[i].name === e) return !0;
return !1;
},
checkVarNameHasSpecialCharacters: function(e) {
var t = /^[\w\d]+$/;
return t.test(e) ? !1 : !0;
},
handleOffsetCon: function() {
this.createComponents([ {
tag: "form",
classes: "form-horizontal",
container: this.$.offsetCon,
components: [ {
tag: "div",
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: "Offset: "
}, {
tag: "div",
classes: "controls",
components: [ {
tag: "div",
name: "offsetWaarde",
classes: "offsetWaarde",
content: "Geen offset"
}, {
tag: "div",
classes: "btn",
name: "btnEditOffset",
ontap: "editOffsetTapped",
components: [ {
tag: "i",
name: "btnEditOffsetIcon",
classes: "icon-edit"
} ]
}, {
tag: "select",
name: "cboOffsetObjecten",
classes: "cboOffsetObjecten",
onchange: "offsetObjectChanged",
showing: !1
} ]
} ]
} ]
} ]), this.setOffset(this.getLinkExist() && this.getLinkExist().offset !== "" ? this.getLinkExist().offset : "nooffset"), this.$.offsetCon.render();
},
editOffsetTapped: function(e, t) {
this.$.cboOffsetObjecten.setShowing(!this.$.cboOffsetObjecten.getShowing()), this.$.cboOffsetObjecten.getShowing() && this.vulObjectenInOffset();
},
vulObjectenInOffset: function() {
this.$.cboOffsetObjecten && this.$.cboOffsetObjecten.destroyClientControls(), this.createComponents([ {
tag: "option",
attributes: {
value: "nooffset"
},
content: "Maak een keuze",
eigenschapValue: "nooffset",
container: this.$.cboOffsetObjecten
}, {
tag: "option",
attributes: {
value: "nooffset"
},
content: "Geen offset",
eigenschapValue: "nooffset",
container: this.$.cboOffsetObjecten
} ]);
var e = this.getLayer().owner.getAllLayers();
for (var t in e) this.createComponent({
tag: "option",
attributes: {
value: e[t].linked.objectId
},
content: e[t].linked.layername,
eigenschapValue: e[t].linked[this.getEigenschap()],
container: this.$.cboOffsetObjecten
});
this.$.cboOffsetObjecten.render();
},
offsetObjectChanged: function(e, t) {
this.$.cboOffsetObjecten.children[t.target.selectedIndex].eigenschapValue !== "nooffset" ? this.calculateOffset(this.getLayer().linked[this.getEigenschap()], this.$.cboOffsetObjecten.children[t.target.selectedIndex].eigenschapValue) : this.setOffset("nooffset"), this.$.cboOffsetObjecten.setShowing(!1);
},
calculateOffset: function(e, t) {
this.setOffset(parseInt(e) - parseInt(t));
},
offsetChanged: function() {
this.$.offsetWaarde.setContent(this.getOffset() !== "nooffset" ? this.getOffset() : "Geen offset");
var e = this.getOffset() >= 0 ? " + " : " - ";
this.$.offsetAddonAfter.setContent(")" + e + Math.abs(this.getOffset())), this.showHideOffsetAddons();
},
showHideOffsetAddons: function() {
var e = this.getOffset() !== "nooffset" ? !0 : !1;
this.$.offsetAddonBefore.setShowing(e), this.$.offsetAddonAfter.setShowing(e);
},
annuleer: function() {
this.destroy();
},
opslaan: function() {
this.$.formule.getValue() != "" && (this.makeLink(), this.bubble("updateLinks", this));
},
makeLink: function() {
var e = new educate.Linkeigenschap;
e.databaseId = this.getLinkDbId(), this.getLinkDbId() && (e.linkeigenschapID = this.getLinkDbId()), e.linkeigenschapName = this.getEigenschap() + "_Link", e.eigenschap = this.getEigenschap(), e.formule = this.$.formule.getValue(), e.offset = this.getOffset(), e.field = this.getField(), this.getLayer().linked.addLinkEigenschap(e);
},
getView: function() {
var e = enyo.$["frame_view" + this.viewId];
return e ? e : enyo.$["create_view" + this.viewId];
}
});

// IconPhotoEditor.js

enyo.kind({
name: "educate.create.view.eigenschappen.dialoogvensters.IconPhotoEditor",
kind: enyo.Control,
classes: "modal photoEditor",
published: {
url: "http://placehold.it/1280x800",
description: "",
editor: !1,
viewId: 1
},
events: {
onCancel: "onCancel",
onSave: "onSave"
},
handlers: {
assetsLibrarySubmitted: "assetsLibrarySubmittedHandler"
},
components: [ {
classes: "modal-header",
components: [ {
tag: "h3",
name: "title",
content: "bewerk afbeelding"
} ]
}, {
classes: "modal-body",
components: [ {
kind: enyo.Image,
name: "img",
src: this.url,
ontap: "btnBrowseTapHandler"
}, {
kind: enyo.Button,
name: "btnBrowse",
classes: "btn btn-block",
ontap: "btnBrowseTapHandler",
allowHtml: !0,
content: '<i class="icon-picture"></i> selecteer afbeelding'
}, {
tag: "hr"
}, {
tag: "textarea",
name: "textarea"
} ]
}, {
classes: "modal-footer",
components: [ {
kind: enyo.Button,
name: "btnSave",
classes: "btn btn-primary",
ontap: "btnSaveTapHandler",
content: "opslaan"
}, {
kind: enyo.Button,
name: "btnCancel",
classes: "btn",
ontap: "btnCancelTapHandler",
content: "annuleren"
} ]
} ],
create: function() {
this.inherited(arguments), this.urlChanged();
},
rendered: function() {
this.inherited(arguments), this.initCKEditor();
},
initCKEditor: function() {
this.editor = CKEDITOR.replace(this.$.textarea.getId(), {
customConfig: "config_frontend.js"
}), this.editor.setData(this.description);
},
descriptionChanged: function() {
this.$.textArea.setContent(this.description), this.editor && this.editor.setData(this.description);
},
urlChanged: function() {
this.$.img.setSrc(Settings.WEBAPP + "/" + this.getUrl());
},
btnBrowseTapHandler: function(e, t) {
this.$.library && this.$.library.destroy(), this.createComponent({
name: "library",
kind: "educate.create.Assets",
viewId: this.getViewId(),
searchType: "Foto"
}), this.$.library.show();
},
btnSaveTapHandler: function(e, t) {
this.doSave({
originator: this,
url: this.getUrl(),
description: this.getDescription()
});
},
btnCancelTapHandler: function(e, t) {
this.doCancel({
originator: this
});
},
assetsLibrarySubmittedHandler: function(e, t) {
this.setUrl(this.$.library.getSelectedAsset().value);
},
getDescription: function() {
return this.description = this.editor.getData(), this.description;
}
});

// acties.js

enyo.kind({
kind: enyo.Control,
name: "educate.create.view.eigenschappen.acties.Acties",
classes: "Properties",
published: {
events: [],
linked: null,
layer: null,
viewId: -1
},
handlers: {
onEditTap: "editTapped",
onDeleteTap: "deleteTapped"
},
components: [ {
tag: "h3",
content: "Acties",
classes: "page-header"
}, {
name: "eventHolder",
classes: "eventHolder"
}, {
kind: enyo.Button,
name: "btnNewAction",
classes: "btn btn-primary btn-block",
ontap: "newTapped",
components: [ {
tag: "i",
classes: "icon-plus-sign",
content: "&nbsp;",
allowHtml: !0
}, {
tag: "span",
content: "nieuwe actie"
} ]
} ],
create: function() {
this.inherited(arguments), this.linkedChanged();
},
rendered: function() {
this.inherited(arguments);
},
linkedChanged: function() {
this.events = [], this.events = this.getLinked().objectHandlers, this.eventsChanged();
},
eventsChanged: function() {
this.$.eventHolder.destroyComponents();
var e, t = this.events.length;
for (e = 0; e < t; e++) this.$.eventHolder.createComponent({
kind: "educate.create.view.eigenschappen.acties.Actie",
event: this.events[e],
layer: this.layer,
viewId: this.getViewId()
});
this.$.eventHolder.render();
},
newTapped: function(e, t) {
this.showDialog(new educate.Actie);
},
editTapped: function(e, t) {
this.showDialog(t.originator.event);
},
deleteTapped: function(e, t) {
var n;
this.getLinked().kindName === "educate.create.view.lagenpalet.Laag" ? n = this.getLinked().linkedObj.getView() : n = this.getLinked().getView(), n.addObjectToArrDeleted(t.originator.getEvent().eventID);
var r = this.getLinked().getObjectHandlers().indexOf(t.originator.getEvent());
return this.getLinked().getObjectHandlers().splice(r, 1), this.eventsChanged(), !0;
},
showDialog: function(e) {
this.createComponent({
name: "ActieDialoog",
kind: "educate.create.view.eigenschappen.dialoogvensters.ActieDialoog",
linked: this.getLinked(),
layer: this.getLayer(),
event: e,
viewId: this.getViewId(),
onSaveEvent: "saveEvent"
}), this.$.ActieDialoog.show();
},
saveEvent: function(e, t) {
var n = t.event, r = !1;
for (var i in this.events) this.events[i].eventID === n.eventID && (this.events[i] = n, r = !0);
r || this.events.push(n), this.getLinked().objectHandlers = this.events, this.eventsChanged();
}
});

// actie.js

enyo.kind({
kind: enyo.Control,
name: "educate.create.view.eigenschappen.acties.Actie",
published: {
event: null,
open: !1,
layer: null,
viewId: -1
},
classes: "",
events: {
onDeleteTap: "",
onEditTap: ""
},
components: [ {
tag: "table",
classes: "table table-bordered table-condensed actions",
components: [ {
tag: "thead",
components: [ {
tag: "tr",
components: [ {
tag: "th",
attributes: {
colspan: 2
},
components: [ {
tag: "span",
name: "lblEvent",
content: "event"
}, {
classes: "pull-right btn-group",
components: [ {
kind: enyo.Button,
classes: "btn",
ontap: "editAction",
components: [ {
tag: "i",
classes: "icon-pencil"
} ]
}, {
kind: enyo.Button,
classes: "btn",
ontap: "deleteAction",
components: [ {
tag: "i",
classes: "icon-trash"
} ]
}, {
kind: enyo.Button,
classes: "btn",
ontap: "toggleOpen",
components: [ {
tag: "i",
name: "icnToggle",
classes: "icon-minus-sign"
} ]
} ]
} ]
} ]
} ]
}, {
tag: "tbody",
name: "tbody"
}, {
tag: "tfooter"
} ]
} ],
create: function() {
this.inherited(arguments), this.layerChanged(), this.eventChanged(), this.openChanged();
},
rendered: function() {
this.inherited(arguments);
},
eventChanged: function() {
this.$.lblEvent.content = this.getEvent().eventName || "event", this.createView();
},
layerChanged: function() {},
createView: function() {
this.$.tbody.destroyComponents();
var e, t = this.getEvent().targets.length;
for (e = 0; e < t; e++) this.$.tbody.createComponent({
kind: "educate.create.view.eigenschappen.acties.Target",
target: this.getEvent().targets[e],
reactions: this.getEvent().reactions[e],
layer: this.getLayer(),
viewId: this.getViewId()
});
},
toggleOpen: function(e, t) {
this.setOpen(!this.getOpen());
},
openChanged: function() {
this.$.tbody.setShowing(this.getOpen()), this.$.icnToggle.addRemoveClass("icon-minus-sign", this.getOpen()), this.$.icnToggle.addRemoveClass("icon-plus-sign", !this.getOpen());
},
editAction: function(e, t) {
this.bubble("onEditTap");
},
deleteAction: function(e, t) {
this.bubble("onDeleteTap");
}
});

// ThreeDActie.js

enyo.kind({
kind: enyo.Control,
name: "educate.create.view.eigenschappen.acties.ThreeDActie",
published: {
event: null,
open: !1,
layer: null,
viewId: -1,
mesh: []
},
classes: "",
events: {
onDeleteTap: "",
onEditTap: ""
},
components: [ {
tag: "table",
classes: "table table-bordered table-condensed actions",
components: [ {
tag: "thead",
components: [ {
tag: "tr",
components: [ {
tag: "th",
attributes: {
colspan: 2
},
components: [ {
tag: "span",
name: "lblEvent",
content: "event"
}, {
classes: "pull-right btn-group",
components: [ {
kind: enyo.Button,
classes: "btn",
ontap: "editAction",
components: [ {
tag: "i",
classes: "icon-pencil"
} ]
}, {
kind: enyo.Button,
classes: "btn",
ontap: "deleteAction",
components: [ {
tag: "i",
classes: "icon-trash"
} ]
}, {
kind: enyo.Button,
classes: "btn",
ontap: "toggleOpen",
components: [ {
tag: "i",
name: "icnToggle",
classes: "icon-minus-sign"
} ]
} ]
} ]
} ]
} ]
}, {
tag: "tbody",
name: "tbody"
}, {
tag: "tfooter"
} ]
} ],
create: function() {
this.inherited(arguments), this.layerChanged(), this.meshEventChanged(), this.openChanged();
},
rendered: function() {
this.inherited(arguments);
},
meshEventChanged: function() {
this.$.lblEvent.content = this.getEvent().eventName || "event", this.addEventToList();
},
layerChanged: function() {},
addEventToList: function() {
this.$.tbody.createComponent({
kind: "educate.create.view.eigenschappen.acties.ThreeDTarget",
target: this.mesh,
reactions: this.getEvent().reactions[0],
layer: this.getLayer(),
viewId: this.getViewId()
});
},
toggleOpen: function(e, t) {
this.setOpen(!this.getOpen());
},
openChanged: function() {
this.$.tbody.setShowing(this.getOpen()), this.$.icnToggle.addRemoveClass("icon-minus-sign", this.getOpen()), this.$.icnToggle.addRemoveClass("icon-plus-sign", !this.getOpen());
},
editAction: function(e, t) {
this.bubble("onEditTap");
},
deleteAction: function(e, t) {
this.bubble("onDeleteThreeDTap", {
mesh: this.mesh
});
}
});

// target.js

enyo.kind({
kind: enyo.Control,
name: "educate.create.view.eigenschappen.acties.Target",
published: {
target: "",
reactions: [],
layer: null,
viewId: -1
},
classes: "",
components: [ {
tag: "tr",
components: [ {
tag: "td",
classes: "",
name: "lblTarget",
content: "target"
}, {
tag: "td",
components: [ {
tag: "ol",
name: "lstReactions"
} ]
} ]
} ],
create: function() {
this.inherited(arguments), this.targetChanged(), this.reactionsChanged();
},
rendered: function() {
this.inherited(arguments);
},
targetChanged: function() {
var e = enyo.$["create_view" + this.getViewId()].$.lijstPanel.getAllLayers();
this.$.lblTarget.content = "target";
var t = enyo.$["create_view" + this.viewId];
if (t) for (var n in t.getViewChildren()) t.getViewChildren()[n].objectId == this.getTarget() && (this.$.lblTarget.content = t.viewChildren[this.getTarget()].getLayername());
},
reactionsChanged: function() {
var e = enyo.$["create_view" + this.viewId], t = e && e.getChildById(this.getTarget());
if (t) {
this.$.lstReactions.destroyComponents();
var n, r = this.getReactions().length;
for (n = 0; n < r; n++) {
var i = "" + this.getReactions()[n];
if (i !== "") {
var s = i.split(","), o;
if (s.length > 1) {
var u = [];
for (var n in s) u.push({
tag: "li",
content: t.getReactieOptions()[s[n]].label || ""
});
o = {
tag: "li",
components: [ {
tag: "ul",
components: u
} ]
};
} else o = {
tag: "li",
content: t.getReactieOptions()[i].label || i
};
this.$.lstReactions.createComponent(o);
} else this.$.lstReactions.createComponent({
tag: "li",
components: [ {
tag: "code",
content: "null"
} ]
});
}
}
}
});

// ThreeDTarget.js

enyo.kind({
kind: enyo.Control,
name: "educate.create.view.eigenschappen.acties.ThreeDTarget",
published: {
target: "",
reactions: [],
layer: null,
viewId: -1
},
classes: "",
components: [ {
tag: "tr",
components: [ {
tag: "td",
classes: "",
name: "lblTarget",
content: "target"
}, {
tag: "td",
components: [ {
tag: "ol",
name: "lstReactions"
} ]
} ]
} ],
create: function() {
this.inherited(arguments), this.targetChanged(), this.reactionsChanged();
},
rendered: function() {
this.inherited(arguments);
},
targetChanged: function() {
this.$.lblTarget.content = this.target.name;
},
reactionsChanged: function() {
this.$.lstReactions.destroyComponents();
var e, t = this.getReactions().length;
for (e = 0; e < t; e++) {
var n = "" + this.getReactions()[e];
if (n !== "") {
var r = n.split(","), i;
if (r.length > 1) {
var s = [];
for (var e in r) s.push({
tag: "li",
content: educate.Actie.REACTIES[r[e]].label || ""
});
i = {
tag: "li",
components: [ {
tag: "ul",
components: s
} ]
};
} else i = {
tag: "li",
content: educate.Actie.REACTIES[n].label || n
};
this.$.lstReactions.createComponent(i);
} else this.$.lstReactions.createComponent({
tag: "li",
components: [ {
tag: "code",
content: "null"
} ]
});
}
}
});

// veld.js

enyo.kind({
name: "educate.create.view.eigenschappen.components.cijferveld.veld",
tag: "article",
classes: "numfield__value",
published: {
label: "veld 1",
value: "",
min: "",
max: "",
solution: "",
unit: "",
random: !1,
isRandom: !1,
enabled: !0,
valueLinkable: !1,
minLinkable: !1,
maxLinkable: !1,
solutionLinkable: !1,
unitLinkable: !1,
valueLinkProp: "value",
minLinkProp: "minimum1",
maxLinkProp: "maximum1",
solutionLinkProp: "solution",
unitLinkProp: "answered"
},
_changedValue: null,
position: -1,
events: {
onValueChanged: "",
onMinChanged: "",
onMaxChanged: "",
onSolutionChanged: "",
onUnitChanged: "",
onEnabledChanged: "",
onIsRandomChanged: "",
onLinkPropValue: "",
onLinkRemoved: ""
},
components: [ {
tag: "label",
components: [ {
kind: "enyo.Checkbox",
name: "enabled",
checked: this.enabled,
onActivate: "propertiesChanged"
}, {
tag: "span",
name: "lbl",
content: "this.label"
} ]
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "value",
inputType: "number",
label: "waarde: ",
inputPlaceholder: "",
value: this.value,
onchange: "propertiesChanged",
linkable: this.valueLinkable,
linkedProp: this.valueLinkProp,
random: this.random,
onLinkPropValue: "onLinkPropValueHandler",
onLinkRemoved: "linkRemovedHandler",
onRandomChange: "onRandomChangeHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "min",
inputType: "number",
label: "minimum: ",
inputPlaceholder: "",
value: this.min,
onchange: "propertiesChanged",
linkable: this.minLinkable,
linkedProp: this.minLinkProp,
onLinkPropValue: "onLinkPropValueHandler",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "max",
inputType: "number",
label: "maximum: ",
inputPlaceholder: "",
value: this.max,
onchange: "propertiesChanged",
linkable: this.maxLinkable,
linkedProp: this.maxLinkProp,
onLinkPropValue: "onLinkPropValueHandler",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "solution",
inputType: "number",
label: "oplossing: ",
inputPlaceholder: "",
value: this.solution,
onchange: "propertiesChanged",
linkable: this.solutionLinkable,
linkedProp: this.solutionLinkProp,
onLinkPropValue: "onLinkPropValueHandler",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "unit",
inputType: "text",
label: "eenheid: ",
inputPlaceholder: "",
value: this.unit,
onchange: "propertiesChanged",
linkable: this.unitLinkable,
linkedProp: this.unitLinkProp,
onLinkPropValue: "onLinkPropValueHandler",
onLinkRemoved: "linkRemovedHandler"
} ],
create: function() {
this.inherited(arguments), this.position === 1 && this.$.enabled.setShowing(!1), this.valueLinkableChanged(), this.solutionLinkableChanged(), this.unitLinkableChanged(), this.minLinkableChanged(), this.maxLinkableChanged(), this.valueLinkPropChanged(), this.solutionLinkPropChanged(), this.minLinkPropChanged(), this.maxLinkPropChanged(), this.unitLinkPropChanged(), this.randomChanged(), this.isRandomChanged();
},
propertiesChanged: function(e, t) {
this._changedValue = e.name;
switch (e.name) {
case "value":
this.value = e.getValue(), this.doValueChanged();
break;
case "min":
this.min = e.getValue(), this.doMinChanged();
break;
case "max":
this.max = e.getValue(), this.doMaxChanged();
break;
case "solution":
this.solution = e.getValue(), this.doSolutionChanged();
break;
case "unit":
this.unit = e.getValue(), this.doUnitChanged();
break;
case "enabled":
this.enabled = e.getChecked(), this.toggleShowing(), this.doEnabledChanged();
}
},
labelChanged: function() {
this.$.lbl.setContent(" " + this.label), this.$.enabled.setAttribute("disabled", this.position === 1);
},
valueChanged: function() {
this.$.value.setValue(this.getValue()), this.$.enabled.setAttribute("disabled", this.position === 1);
},
minChanged: function() {
this.$.min.setValue(this.getMin()), this.$.enabled.setAttribute("disabled", this.position === 1);
},
maxChanged: function() {
this.$.max.setValue(this.getMax()), this.$.enabled.setAttribute("disabled", this.position === 1);
},
solutionChanged: function() {
this.$.solution.setValue(this.getSolution()), this.$.enabled.setAttribute("disabled", this.position === 1);
},
unitChanged: function() {
this.$.unit.setValue(this.getUnit()), this.$.enabled.setAttribute("disabled", this.position === 1);
},
enabledChanged: function() {
this.$.enabled.setAttribute("disabled", this.position === 1), this.$.enabled.setChecked(this.getEnabled()), this.toggleShowing();
},
toggleShowing: function() {
this.position > 1 ? (this.$.value.setShowing(this.enabled), this.$.min.setShowing(this.enabled), this.$.max.setShowing(this.enabled), this.$.solution.setShowing(this.enabled), this.$.unit.setShowing(this.enabled)) : this.setEnabled(!0);
},
getChangedValue: function() {
return this._changedValue;
},
setChangedValue: function(e) {
throw new Error("You can't set the last changed-value");
},
onLinkPropValueHandler: function(e, t) {
this.doLinkPropValue({
originator: t.originator
});
},
randomChanged: function() {
this.$.value.random = this.getRandom(), this.$.value.randomChanged();
},
onRandomChangeHandler: function(e, t) {
this.setIsRandom(this.$.value.getIsRandom()), this.doIsRandomChanged();
},
isRandomChanged: function() {
this.$.value.setIsRandom(this.getIsRandom());
},
valueLinkableChanged: function() {
this.$.value.setLinkable(this.getValueLinkable());
},
solutionLinkableChanged: function() {
this.$.solution.setLinkable(this.getSolutionLinkable());
},
unitLinkableChanged: function() {
this.$.unit.setLinkable(this.getUnitLinkable());
},
minLinkableChanged: function() {
this.$.min.setLinkable(this.getMinLinkable());
},
maxLinkableChanged: function() {
this.$.max.setLinkable(this.getMaxLinkable());
},
valueLinkPropChanged: function() {
this.$.value.setLinkedProp(this.getValueLinkProp());
},
solutionLinkPropChanged: function() {
this.$.solution.setLinkedProp(this.getSolutionLinkProp());
},
minLinkPropChanged: function() {
this.$.min.setLinkedProp(this.getMinLinkProp());
},
maxLinkPropChanged: function() {
this.$.max.setLinkedProp(this.getMaxLinkProp());
},
unitLinkPropChanged: function() {
this.$.unit.setLinkedProp(this.getUnitLinkProp());
}
});

// origin.js

enyo.kind({
name: "educate.create.view.eigenschappen.components.Origin",
published: {
origin: "50 50"
},
events: {
onOriginChanged: "onOriginChanged"
},
components: [ {
classes: "control-group",
components: [ {
tag: "label",
content: "nulpunt",
classes: "control-label"
}, {
classes: "controls origin",
name: "chks",
components: [ {
kind: "enyo.Checkbox",
name: "chk0-0",
classes: "chk0-0",
onActivate: "propertiesChanged"
}, {
kind: "enyo.Checkbox",
name: "chk50-0",
classes: "chk50-0",
onActivate: "propertiesChanged"
}, {
kind: "enyo.Checkbox",
name: "chk100-0",
classes: "chk100-0",
onActivate: "propertiesChanged"
}, {
kind: "enyo.Checkbox",
name: "chk0-50",
classes: "chk0-50",
onActivate: "propertiesChanged"
}, {
kind: "enyo.Checkbox",
name: "chk50-50",
classes: "chk50-50",
onActivate: "propertiesChanged",
checked: !0
}, {
kind: "enyo.Checkbox",
name: "chk100-50",
classes: "chk100-50",
onActivate: "propertiesChanged"
}, {
kind: "enyo.Checkbox",
name: "chk0-100",
classes: "chk0-100",
onActivate: "propertiesChanged"
}, {
kind: "enyo.Checkbox",
name: "chk50-100",
classes: "chk50-100",
onActivate: "propertiesChanged"
}, {
kind: "enyo.Checkbox",
name: "chk100-100",
classes: "chk100-100",
onActivate: "propertiesChanged"
} ]
} ]
} ],
create: function() {
this.inherited(arguments);
},
originChanged: function(e) {
var t = this.getOrigin().split(" ")[0], n = this.getOrigin().split(" ")[1];
t = t < 30 ? 0 : t < 60 ? 50 : 100, n = n < 30 ? 0 : n < 60 ? 50 : 100, this.origin = t + " " + n, this.updateOrigin(), this.origin !== e && e !== undefined && this.bubble("onOriginChanged");
},
propertiesChanged: function(e, t) {
if (e.getChecked()) {
var n = e.name.substr(3), r = n.split("-")[0], i = n.split("-")[1], s = r + " " + i;
this.origin !== s && this.setOrigin(s);
}
},
updateOrigin: function() {
var e = this.getOrigin().split(" ")[0], t = this.getOrigin().split(" ")[1], n, r = this.$.chks.children.length;
for (n = 0; n < r; n++) this.$.chks.children[n].name === "chk" + e + "-" + t ? this.$.chks.children[n].setChecked(!0) : this.$.chks.children[n].setChecked(!1);
}
});

// ThumbList.js

enyo.kind({
name: "educate.create.view.eigenschappen.components.ThumbList",
kind: enyo.Control,
tag: "ul",
classes: "thumbs",
published: {
images: [],
descriptions: []
},
events: {
onImagesChanged: "",
onImageEdit: ""
},
create: function() {
this.inherited(arguments), this.imagesChanged();
},
addImage: function(e) {
this.getImages().push(e), this.imagesChanged();
},
removeImage: function() {
this.getImages().splice(this.getImages().indexOf(image), 1), this.imagesChanged();
},
imagesChanged: function() {
this.destroyClientControls(), this.destroyComponents();
var e, t = this.getImages().length;
for (e = 0; e < t; e++) this.createComponent({
kind: "educate.create.view.eigenschappen.components.Thumb",
url: Settings.WEBAPP + "/" + this.getImages()[e],
index: e,
listLength: t,
onUpClick: "onUpClickHandler",
onDownClick: "onDownClickHandler",
onEditClick: "onEditClickHandler",
onDeleteClick: "onDeleteClickHandler"
});
this.render(), this.doImagesChanged();
},
onUpClickHandler: function(e, t) {
var n = this.controls.indexOf(t.originator);
n > 0 && (this.images.splice(n - 1, 0, this.images.splice(n, 1)[0]), this.descriptions.splice(n - 1, 0, this.descriptions.splice(n, 1)[0]), this.imagesChanged());
},
onDownClickHandler: function(e, t) {
var n = this.controls.indexOf(t.originator);
n < this.images.length - 1 && n !== -1 && (this.images.splice(n + 1, 0, this.images.splice(n, 1)[0]), this.descriptions.splice(n + 1, 0, this.descriptions.splice(n, 1)[0]), this.imagesChanged());
},
onEditClickHandler: function(e, t) {
var n = this.controls.indexOf(t.originator);
this.doImageEdit({
originator: t.originator,
index: n
});
},
onDeleteClickHandler: function(e, t) {
var n = this.controls.indexOf(t.originator);
n !== -1 && (this.images.splice(n, 1), this.imagesChanged());
}
});

// Thumb.js

enyo.kind({
name: "educate.create.view.eigenschappen.components.Thumb",
kind: enyo.Control,
tag: "li",
classes: "thumb",
published: {
url: "http://placehold.it/180x113&text=thumb",
index: -1,
listLength: -1
},
events: {
onUpClick: "",
onDownClick: "",
onEditClick: "",
onDeleteClick: ""
},
components: [ {
classes: "arrows btn-group btn-group-vertical",
components: [ {
tag: "button",
name: "btnUp",
classes: "btn",
allowHtml: !0,
content: "<i class='icon-chevron-up'></i>",
ontap: "upHandler"
}, {
tag: "button",
name: "btnDown",
classes: "btn",
allowHtml: !0,
content: "<i class='icon-chevron-down'></i>",
ontap: "downHandler"
} ]
}, {
kind: enyo.Image,
src: this.url,
name: "image"
}, {
classes: "buttons btn-group btn-group-vertical",
components: [ {
tag: "button",
name: "btnEdit",
classes: "btn",
allowHtml: !0,
content: "<i class='icon-pencil'></i>",
ontap: "editHandler"
}, {
tag: "button",
name: "btnDelete",
classes: "btn",
allowHtml: !0,
content: "<i class='icon-trash'></i>",
ontap: "trashHandler"
} ]
} ],
create: function() {
this.inherited(arguments), this.urlChanged(), this.indexChanged();
},
indexChanged: function() {
this.$.btnUp.setAttribute("disabled", this.index === 0 ? "disabled" : null), this.$.btnDown.setAttribute("disabled", this.index === this.listLength - 1 ? "disabled" : null);
},
listLengthChanged: function() {
this.$.btnUp.setAttribute("disabled", this.index === 0 ? "disabled" : null), this.$.btnDown.setAttribute("disabled", this.index === this.listLength - 1 ? "disabled" : null);
},
urlChanged: function() {
this.$.image.setSrc(this.getUrl());
},
upHandler: function() {
this.doUpClick();
},
downHandler: function() {
this.doDownClick();
},
editHandler: function() {
this.doEditClick();
},
trashHandler: function() {
this.doDeleteClick();
}
});

// Eigenschappen.js

enyo.kind({
name: "educate.create.view.eigenschappen.Eigenschappen",
kind: enyo.Control,
tag: "div",
classes: "Properties",
handlers: {
updateProperties: "updatePropertiesHandler",
updateLinks: "updateLinksHandler",
assetsLibrarySubmitted: "assetsLibrarySubmittedHandler",
layerLockClicked: "layerLockClickedHandler",
changeMeshPosition: "changeMeshPositionHandler",
changeCameraPosition: "changeCameraPositionHandler"
},
published: {
linked: "",
layer: "",
width: "auto",
height: "150",
pValue: "",
pSolution: "",
pPosX: "0",
pPosY: "0",
pPosZ: "0",
pOrigin: "0 0",
pRotation_x: 0,
pRotation_y: 0,
pRotation_z: 0,
pLayername: "",
pWidth: "",
pHeight: "",
pCssClass: "",
viewId: "",
disabledFields: [],
pIsPosLimiet: "",
pIsRotLimiet: "",
pPosXmin: "",
pPosXmax: "",
pPosYmin: "",
pPosYmax: "",
pPosZmin: "",
pPosZmax: "",
pRotXmin: "",
pRotXmax: "",
pRotYmin: "",
pRotYmax: "",
pRotZmin: "",
pRotZmax: "",
visible: !0,
pActive: !0,
alpha: !0,
inLayerHolder: !1,
view: null
},
components: [ {
name: "basicProperties",
classes: "form-horizontal",
components: [ {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "layername",
label: "naam: ",
inputPlaceholder: "naam van de laag",
value: this.pLayername,
linkedProp: "layername",
linkable: !1,
onchange: "propertiesChanged"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "position_x",
inputType: "number",
label: "x: ",
inputPlaceholder: "",
value: this.pPosX,
linkedProp: "position_x",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "position_y",
inputType: "number",
label: "y: ",
inputPlaceholder: "",
value: this.pPosY,
linkedProp: "position_y",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "position_z",
inputType: "number",
label: "z: ",
inputPlaceholder: "",
value: this.pPosZ,
linkedProp: "position_z",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "width",
inputType: "number",
label: "breedte: ",
inputPlaceholder: "",
value: this.pWidth,
linkedProp: "width",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "height",
inputType: "number",
label: "hoogte: ",
inputPlaceholder: "",
value: this.pHeight,
linkedProp: "height",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "rotation_x",
inputType: "number",
label: "rotatie-X: ",
inputPlaceholder: "",
value: 0,
linkedProp: "rotation_x",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "rotation_y",
inputType: "number",
label: "rotatie-Y: ",
inputPlaceholder: "",
value: 0,
linkedProp: "rotation_y",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "rotation_z",
inputType: "number",
label: "rotatie-Z: ",
inputPlaceholder: "",
value: 0,
linkedProp: "rotation_z",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "alpha",
inputType: "number",
label: "alpha: ",
inputPlaceholder: "",
value: 0,
linkedProp: "alpha",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.components.Origin",
name: "origin",
origin: this.pOrigin,
onOriginChanged: "propertiesChanged"
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkZichtbaar",
checked: !0,
content: "zichtbaar",
onchange: "propertiesChanged"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkActive",
checked: !0,
content: "actief",
onchange: "propertiesChanged"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkLaag",
checked: this.inLayerHolder,
content: "laag",
onchange: "propertiesChanged"
} ]
} ]
} ]
} ]
}, {
tag: "h4",
content: "Limieten",
linkblok: "limieten",
ontap: "togglePropBlock"
}, {
name: "limieten",
classes: "limieten form-horizontal",
components: [ {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "posLimiteren",
checked: this.pIsPosLimiet,
content: "Positie limiteren",
onchange: "chkPosLimietHandler"
} ]
} ]
} ]
}, {
name: "limietPosCon",
classes: "limietCon",
showing: !1,
components: [ {
classes: "control-group",
components: [ {
tag: "label",
content: "x min max: ",
classes: "control-label"
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
name: "posxmin",
value: this.pPosXmin,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentPosXmin",
propvar: "position_x",
inputProperty: "posxmin",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
}, {
kind: "enyo.Input",
name: "posxmax",
value: this.pPosXmax,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentPosXmax",
propvar: "position_x",
inputProperty: "posxmax",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "y min max: ",
classes: "control-label"
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
name: "posymin",
value: this.pPosYmin,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentPosYmin",
propvar: "position_y",
inputProperty: "posymin",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
}, {
kind: "enyo.Input",
name: "posymax",
value: this.pPosYmax,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentPosYmax",
propvar: "position_y",
inputProperty: "posymax",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "z min max: ",
classes: "control-label"
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
name: "poszmin",
value: this.pPosZmin,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentPosZmin",
propvar: "position_z",
inputProperty: "poszmin",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
}, {
kind: "enyo.Input",
name: "poszmax",
value: this.pPosZmax,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentPosZmax",
propvar: "position_z",
inputProperty: "poszmax",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "rotLimiteren",
checked: this.pIsRotLimiet,
content: "Rotatie limiteren",
onchange: "chkRotLimietHandler"
} ]
} ]
} ]
}, {
name: "limietRotCon",
classes: "limietCon",
showing: !1,
components: [ {
classes: "control-group",
components: [ {
tag: "label",
content: "x min max: ",
classes: "control-label"
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
name: "rotxmin",
value: this.pRotXmin,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentRotXmin",
propvar: "rotation_x",
inputProperty: "rotxmin",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
}, {
kind: "enyo.Input",
name: "rotxmax",
value: this.pRotXmax,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentRotXmax",
propvar: "rotation_x",
inputProperty: "rotxmax",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "y min max: ",
classes: "control-label"
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
name: "rotymin",
value: this.pRotYmin,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentRotYmin",
propvar: "rotation_y",
inputProperty: "rotymin",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
}, {
kind: "enyo.Input",
name: "rotymax",
value: this.pRotYmax,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentRotYmax",
propvar: "rotation_y",
inputProperty: "rotymax",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "z min max: ",
classes: "control-label"
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
name: "rotzmin",
value: this.pRotZmin,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentRotZmin",
propvar: "rotation_z",
inputProperty: "rotzmin",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
}, {
kind: "enyo.Input",
name: "rotzmax",
value: this.pRotZmax,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentRotZmax",
propvar: "rotation_z",
inputProperty: "rotzmax",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
} ]
} ]
} ]
} ]
}, {
tag: "h4",
content: "Extra eigenschappen",
linkblok: "blokExtraEnButtons",
ontap: "togglePropBlock"
}, {
name: "blokExtraEnButtons",
components: [ {
name: "extraProperties",
classes: "form-horizontal",
components: []
}, {
name: "buttons",
classes: "form-horizontal",
components: []
} ]
} ],
create: function() {
this.inherited(arguments), this.setValues();
},
rendered: function() {
this.inherited(arguments), this.handleLinkEigenschappen(), this.$.valueBox && this.pValueChanged(), this.$.solution && this.pSolutionChanged(), this.$.position_x && this.pPosXChanged(), this.$.position_y && this.pPosYChanged(), this.$.position_z && this.pPosZChanged(), this.$.layername && this.pLayernameChanged(), this.$.rotation_x && this.pRotation_xChanged(), this.$.rotation_y && this.pRotation_yChanged(), this.$.rotation_z && this.pRotation_zChanged(), this.$.posLimiteren && this.pIsPosLimietChanged(), this.$.rotLimiteren && this.pIsRotLimietChanged(), this.$.posxmin && this.pPosXminChanged(), this.$.posxmax && this.pPosXmaxChanged(), this.$.posymin && this.pPosYminChanged(), this.$.posymax && this.pPosYmaxChanged(), this.$.poszmin && this.pPosZminChanged(), this.$.poszmax && this.pPosZmaxChanged(), this.$.rotxmin && this.pRotXminChanged(), this.$.rotxmax && this.pRotXmaxChanged(), this.$.rotymin && this.pRotYminChanged(), this.$.rotymax && this.pRotYmaxChanged(), this.$.rotzmin && this.pRotZminChanged(), this.$.rotzmax && this.pRotZmaxChanged(), this.$.chkLaag && this.inLayerHolderChanged(), this.getLinked().locked && this.enableDisableProperties(this.getLinked().getLocked()), this.disabledFieldsChanged();
},
generateExtraFields: function(e) {
this.$.extraProperties.destroyComponents();
for (var t in e) this.createComponent({
container: this.$.extraProperties,
kind: "educate.create.view.eigenschappen.Eigenschap",
label: e[t].label,
inputPlaceholder: e[t].placeholder,
value: this[e[t].value],
name: e[t].name,
linkable: e[t].linkable,
onchange: "extraPropertiesChanged",
linkedProp: e[t].name,
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
});
},
setValues: function() {
this.getLinked().layername && (this.pLayername = this.getLinked().getLayername()), !isNaN(parseInt(this.getLinked().position_x)) && (this.pPosX = this.getLinked().getPosition_x()), !isNaN(parseInt(this.getLinked().position_y)) && (this.pPosY = this.getLinked().getPosition_y()), !isNaN(parseInt(this.getLinked().position_z)) && (this.pPosZ = this.getLinked().getPosition_z()), !isNaN(parseInt(this.getLinked().rotation_x)) && this.setPRotation_x(this.getLinked().getRotation_x()), !isNaN(parseInt(this.getLinked().rotation_y)) && this.setPRotation_y(this.getLinked().getRotation_y()), !isNaN(parseInt(this.getLinked().rotation_z)) && this.setPRotation_z(this.getLinked().getRotation_z()), this.getLinked().origin && this.$.origin && this.updateOrigin(), this.getLinked().isPosLimiet && (this.pIsPosLimiet = this.getLinked().getIsPosLimiet()), this.getLinked().isRotLimiet && (this.pIsRotLimiet = this.getLinked().getIsRotLimiet()), !isNaN(parseInt(this.getLinked().position_x_min)) && (this.pPosXmin = this.getLinked().getPosition_x_min()), !isNaN(parseInt(this.getLinked().position_x_max)) && (this.pPosXmax = this.getLinked().getPosition_x_max()), !isNaN(parseInt(this.getLinked().position_y_min)) && (this.pPosYmin = this.getLinked().getPosition_y_min()), !isNaN(parseInt(this.getLinked().position_y_max)) && (this.pPosYmax = this.getLinked().getPosition_y_max()), !isNaN(parseInt(this.getLinked().position_z_min)) && (this.pPosZmin = this.getLinked().getPosition_z_min()), !isNaN(parseInt(this.getLinked().position_z_max)) && (this.pPosZmax = this.getLinked().getPosition_z_max()), !isNaN(parseInt(this.getLinked().rotation_x_min)) && (this.pRotXmin = this.getLinked().getRotation_x_min()), !isNaN(parseInt(this.getLinked().rotation_x_max)) && (this.pRotXmax = this.getLinked().getRotation_x_max()), !isNaN(parseInt(this.getLinked().rotation_y_min)) && (this.pRotYmin = this.getLinked().getRotation_y_min()), !isNaN(parseInt(this.getLinked().rotation_y_max)) && (this.pRotYmax = this.getLinked().getRotation_y_max()), !isNaN(parseInt(this.getLinked().rotation_z_min)) && (this.pRotZmin = this.getLinked().getRotation_z_min()), !isNaN(parseInt(this.getLinked().rotation_z_max)) && (this.pRotZmax = this.getLinked().getRotation_z_max()), this.setPActive(this.getLinked().getActive()), this.$.width && !isNaN(parseInt(this.getLinked().width)) && this.setPWidth(this.getLinked().getWidth()), this.$.height && !isNaN(parseInt(this.getLinked().height)) && this.setPHeight(this.getLinked().getHeight()), this.getLinked().inLayerHolder && (this.inLayerHolder = this.getLinked().getInLayerHolder()), this.getLinked().getOptions() && this.getLinked().getOptions().visible && this.setVisible(this.getLinked().getOptions().visible), this.getLinked().getOptions() && this.getLinked().getOptions().alpha && this.setAlpha(this.getLinked().getOptions().alpha), this.getLinked().getOptions() && (this.getLinked().getOptions().visible === undefined && (this.getLinked().getOptions().visible = !0), this.visible = this.getLinked().getOptions().visible, this.visibleChanged()), this.pIsPosLimiet && this.$.limietPosCon.setShowing(!0), this.pIsRotLimiet && this.$.limietRotCon.setShowing(!0);
if (this.$.extraProperties) for (var e in this.$.extraProperties.controls) this.$.extraProperties.controls[e].kind === "educate.create.view.eigenschappen.Eigenschap" && this.getLinked()[this.$.extraProperties.controls[e].name] && this.$.extraProperties.controls[e].setValue(this.getLinked()[this.$.extraProperties.controls[e].name]);
},
handleLinkEigenschappen: function() {
if (this.getLinked().linkedEigenschappen) {
var e = this.getView(), t = this.getLinked().getLinkedEigenschappen();
for (var n in t) if (e.properties[this.getLinked().getName()]) {
var r = e.properties[this.getLinked().getName()][t[n].eigenschap];
r !== undefined && r.setLinked(!0);
}
}
},
generateSelection: function(e) {
var t;
for (var n in e) {
if (e[n].type === "radio") {
t = {
classes: "control-group",
components: [ {
tag: "label",
content: e[n].label,
classes: "control-label"
}, {
classes: "controls",
components: []
} ]
};
for (var r in e[n].options) t.components[1].components.push({
tag: "label",
classes: "radio",
components: [ {
kind: "enyo.Checkbox",
value: e[n].options[r].value,
name: e[n].options[r].name,
onActivate: e[n].listener,
type: "radio",
attributes: {
name: e[n].name
}
}, {
tag: "span",
content: e[n].options[r].label
} ]
});
} else {
t = {
classes: "control-group",
components: [ {
tag: "label",
content: e[n].label,
classes: "control-label"
}, {
classes: "controls",
components: []
} ]
};
for (var r in e[n].options) t.components[1].components.push({
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
value: e[n].options[r].value,
name: e[n].options[r].name,
checked: e[n].options[r].checked || !1,
onchange: e[n].options[r].onchange || ""
}, {
tag: "span",
content: e[n].options[r].label
} ]
});
}
this.$.extraProperties.createComponent(t, {
owner: e[n].owner || this
});
}
},
disabledFieldsChanged: function(e) {
for (var t in this.disabledFields) this.$[this.disabledFields[t]].setAttribute("disabled", "disabled");
},
pLayernameChanged: function() {
this.$.layername.setValue(this.pLayername);
},
pValueChanged: function() {
this.$.valueBox.setValue(this.pValue);
},
pSolutionChanged: function() {
this.$.solution.setValue(this.pSolution);
},
pPosXChanged: function() {
this.$.position_x.setValue(this.pPosX);
},
pPosYChanged: function() {
this.$.position_y.setValue(this.pPosY);
},
pPosZChanged: function() {
this.$.position_z.setValue(this.pPosZ);
},
pRotation_xChanged: function() {
this.$.rotation_x.setValue(this.pRotation_x);
},
pRotation_yChanged: function() {
this.$.rotation_y.setValue(this.pRotation_y);
},
pRotation_zChanged: function() {
this.$.rotation_z.setValue(this.pRotation_z);
},
pOriginChanged: function() {
this.$.origin.setOrigin(this.getPOrigin());
},
updateOrigin: function() {
this.pOrigin = this.linked.origin, this.$.origin.origin = this.linked.origin, this.$.origin.updateOrigin();
},
pIsPosLimietChanged: function() {
this.$.posLimiteren.checked = this.pIsPosLimiet;
},
pIsRotLimietChanged: function() {
this.$.rotLimiteren.checked = this.pIsRotLimiet;
},
pPosXminChanged: function() {
this.$.posxmin.setValue(this.pPosXmin);
},
pPosXmaxChanged: function() {
this.$.posxmax.setValue(this.pPosXmax);
},
pPosYminChanged: function() {
this.$.posymin.setValue(this.pPosYmin);
},
pPosYmaxChanged: function() {
this.$.posymax.setValue(this.pPosYmax);
},
pPosZminChanged: function() {
this.$.poszmin.setValue(this.pPosZmin);
},
pPosZmaxChanged: function() {
this.$.poszmax.setValue(this.pPosZmax);
},
pRotXminChanged: function() {
this.$.rotxmin.setValue(this.pRotXmin);
},
pRotXmaxChanged: function() {
this.$.rotxmax.setValue(this.pRotXmax);
},
pRotYminChanged: function() {
this.$.rotymin.setValue(this.pRotYmin);
},
pRotYmaxChanged: function() {
this.$.rotymax.setValue(this.pRotYmax);
},
pRotZminChanged: function() {
this.$.rotzmin.setValue(this.pRotZmin);
},
pRotZmaxChanged: function() {
this.$.rotzmax.setValue(this.pRotZmax);
},
pWidthChanged: function() {
this.$.width.setValue(this.pWidth);
},
pHeightChanged: function() {
this.$.height.setValue(this.pHeight);
},
pActiveChanged: function() {
undefined !== this.$.chkActive && this.$.chkActive.setChecked(this.pActive);
},
togglePropBlock: function(e, t) {
this.$[t.originator.linkblok].setShowing(!this.$[t.originator.linkblok].getShowing());
},
chkPosLimietHandler: function(e, t) {
this.$.limietPosCon.setShowing(t.originator.checked), this.getLinked().setIsPosLimiet(t.originator.checked), this.setPIsPosLimiet(t.originator.checked);
},
chkRotLimietHandler: function(e, t) {
this.$.limietRotCon.setShowing(t.originator.checked), this.getLinked().setIsRotLimiet(t.originator.checked), this.setPIsRotLimiet(t.originator.checked);
},
getCurrentPropValue: function(e, t) {
if (e.propvar == "rotation_x") {
var n = this.getLinked().rotation.split(" ")[0];
this.$[e.inputProperty].setValue(n);
} else if (e.propvar == "rotation_y") {
var r = this.getLinked().rotation.split(" ")[1];
this.$[e.inputProperty].setValue(r);
} else if (e.propvar == "rotation_z") {
var i = this.getLinked().rotation.split(" ")[2];
this.$[e.inputProperty].setValue(i);
} else this.$[e.inputProperty].setValue(this.getLinked()[e.propvar]);
this.propertiesChanged();
},
browseSvg: function() {
this.generateLibraryPopup("Vector");
},
browseFoto: function() {
this.generateLibraryPopup("Bitmap");
},
browseTexture: function() {
this.generateLibraryPopup("Texture");
},
browseNewImageStep: function() {
this.generateLibraryPopup("Bitmap");
},
browseAnimatie: function() {
this.generateLibraryPopup("Animation");
},
browseVideo: function() {
this.generateLibraryPopup("Video");
},
browseModel: function() {
this.generateLibraryPopup("Model");
},
generateLibraryPopup: function(e) {
this.$.library && this.$.library.destroy(), this.createComponent({
name: "library",
kind: "educate.create.Assets",
viewId: this.getViewId(),
searchType: e
}), this.$.library.show();
},
assetsLibrarySubmittedHandler: function(e, t) {
this.name.indexOf("3DMesh") != -1 ? this.selectTexture() : this.propertiesChanged();
},
propertiesChanged: function(e, t) {
if (e) switch (e.name) {
case "layername":
this.getLinked().setLayername(e.getValue());
break;
case "valueBox":
this.getLinked().setValue(e.getValue());
break;
case "position_x":
this.handlePosX();
break;
case "position_y":
this.handlePosY();
break;
case "position_z":
this.handlePosZ();
break;
case "width":
this.getLinked().setWidth(e.getValue());
break;
case "height":
this.getLinked().setHeight(e.getValue());
break;
case "rotation_x":
case "rotation_y":
case "rotation_z":
this.$.rotation_x && this.$.rotation_y && this.$.rotation_z && this.checkRotation();
break;
case "alpha":
this.getLinked().setAlpha(e.getValue());
break;
case "origin":
this.getLinked().setOrigin(e.getOrigin());
break;
case "chkZichtbaar":
this.getLinked().setVisible(e.getChecked());
break;
case "chkActive":
this.getLinked().setActive(e.getChecked());
break;
case "chkLaag":
this.setInLayerHolder(e.getChecked());
break;
case "posxmin":
this.getLinked().setPosition_x_min(e.getValue());
break;
case "posxmax":
this.getLinked().setPosition_x_max(e.getValue());
break;
case "posymin":
this.getLinked().setPosition_y_min(e.getValue());
break;
case "posymax":
this.getLinked().setPosition_y_max(e.getValue());
break;
case "poszmin":
this.getLinked().setPosition_z_min(e.getValue());
break;
case "poszmax":
this.getLinked().setPosition_z_max(e.getValue());
break;
case "rotxmin":
this.getLinked().setRotation_x_min(e.getValue());
break;
case "rotxmax":
this.getLinked().setRotation_x_max(e.getValue());
break;
case "rotymin":
this.getLinked().setRotation_y_min(e.getValue());
break;
case "rotymax":
this.getLinked().setRotation_y_max(e.getValue());
break;
case "rotzmin":
this.getLinked().setRotation_z_min(e.getValue());
break;
case "rotzmax":
this.getLinked().setRotation_z_max(e.getValue());
} else this.$.valueBox && this.getLinked().setValue(this.$.valueBox.getValue()), this.$.solution && this.getLinked().setSolution(this.$.solution.getValue()), this.$.position_x && this.handlePosX(), this.$.position_y && this.handlePosY(), this.$.position_z && this.handlePosZ(), this.$.layername && this.getLinked().setLayername(this.$.layername.getValue()), this.$.width && this.linked.setWidth(this.$.width.getValue()), this.$.height && this.linked.setHeight(this.$.height.getValue()), this.$.alpha && this.linked.setAlpha(this.$.alpha.getValue()), this.$.origin && this.getLinked().setOrigin(this.$.origin.getOrigin()), this.$.rotation_x && this.$.rotation_y && this.$.rotation_z && this.checkRotation(), this.$.posxmin && this.getLinked().setPosition_x_min(this.$.posxmin.getValue()), this.$.posxmax && this.getLinked().setPosition_x_max(this.$.posxmax.getValue()), this.$.posymin && this.getLinked().setPosition_y_min(this.$.posymin.getValue()), this.$.posymax && this.getLinked().setPosition_y_max(this.$.posymax.getValue()), this.$.poszmin && this.getLinked().setPosition_z_min(this.$.poszmin.getValue()), this.$.poszmax && this.getLinked().setPosition_z_max(this.$.poszmax.getValue()), this.$.rotxmin && this.getLinked().setRotation_x_min(this.$.rotxmin.getValue()), this.$.rotxmax && this.getLinked().setRotation_x_max(this.$.rotxmax.getValue()), this.$.rotymin && this.getLinked().setRotation_y_min(this.$.rotymin.getValue()), this.$.rotymax && this.getLinked().setRotation_y_max(this.$.rotymax.getValue()), this.$.rotzmin && this.getLinked().setRotation_z_min(this.$.rotzmin.getValue()), this.$.rotzmax && this.getLinked().setRotation_z_max(this.$.rotzmax.getValue()), this.$.chkZichtbaar && this.setVisible(this.$.chkZichtbaar.getChecked()), this.$.chkActive && this.getLinked().setActive(this.$.chkActive.getChecked()), this.$.chkLaag && this.setInLayerHolder(this.$.chkLaag.getChecked());
},
extraPropertiesChanged: function(e, t) {
this.getLinked()[t.originator.name] = t.originator.getValue(), this.getLinked()[t.originator.name + "Changed"] && this.getLinked()[t.originator.name + "Changed"]();
},
changeMeshPositionHandler: function(e, t) {
this.pLayername == t.name && (this.pPosX = parseInt(t.pPosX), this.pPosY = parseInt(t.pPosY), this.pPosZ = parseInt(t.pPosZ), this.$.pPosX.setValue(this.pPosX), this.$.pPosY.setValue(this.pPosY), this.$.pPosZ.setValue(this.pPosZ));
},
changeCameraPositionHandler: function(e, t) {
if (this.kind == "educate.create.view.eigenschappen.Eigenschappen3DCamera") {
var n = t.liveCameraPosition, r = t.liveCameraCenter;
this.$.camPosition_x.setValue(n.x), this.$.camPosition_y.setValue(n.y), this.$.camPosition_z.setValue(n.z), this.$.camTarget_x.setValue(r.x), this.$.camTarget_y.setValue(r.y), this.$.camTarget_z.setValue(r.z);
}
},
handlePosX: function() {
if (this.pIsPosLimiet) switch (this.checkLimiet(this.$.posxmin.getValue(), this.$.posxmax.getValue(), this.$.position_x.getValue())) {
case "ok":
this.getLinked().setPosition_x(this.$.position_x.getValue());
break;
case "groter":
this.getLinked().setPosition_x(this.$.posxmax.getValue()), this.setPPosX(this.$.posxmax.getValue()), this.pPosXChanged();
break;
case "kleiner":
this.getLinked().setPosition_x(this.$.posxmin.getValue()), this.setPPosX(this.$.posxmin.getValue()), this.pPosXChanged();
} else this.getLinked().setPosition_x(this.$.position_x.getValue());
},
handlePosY: function() {
if (this.pIsPosLimiet) switch (this.checkLimiet(this.$.posymin.getValue(), this.$.posymax.getValue(), this.$.position_y.getValue())) {
case "ok":
this.getLinked().setPosition_y(this.$.position_y.getValue());
break;
case "groter":
this.getLinked().setPosition_y(this.$.posymax.getValue()), this.setPPosY(this.$.posymax.getValue()), this.pPosYChanged();
break;
case "kleiner":
this.getLinked().setPosition_y(this.$.posymin.getValue()), this.setPPosY(this.$.posymin.getValue()), this.pPosYChanged();
} else this.getLinked().setPosition_y(this.$.position_y.getValue());
},
handlePosZ: function() {
if (this.pIsPosLimiet) switch (this.checkLimiet(this.$.poszmin.getValue(), this.$.poszmax.getValue(), this.$.position_z.getValue())) {
case "ok":
this.getLinked().setPosition_z(this.$.position_z.getValue());
break;
case "groter":
this.getLinked().setPosition_z(this.$.poszmax.getValue()), this.setPPosZ(this.$.poszmax.getValue()), this.pPosZChanged();
break;
case "kleiner":
this.getLinked().setPosition_z(this.$.poszmin.getValue()), this.setPPosZ(this.$.poszmin.getValue()), this.pPosZChanged();
} else this.getLinked().setPosition_z(this.$.position_z.getValue());
},
checkRotation: function() {
var e, t, n;
this.pIsRotLimiet ? (e = this.handleRot("x"), t = this.handleRot("y"), n = this.handleRot("z")) : (e = this.$.rotation_x.getValue(), t = this.$.rotation_y.getValue(), n = this.$.rotation_z.getValue()), this.setPRotation_x(e), this.setPRotation_y(t), this.setPRotation_z(n), this.getLinked().setRotation_x(e), this.getLinked().setRotation_y(t), this.getLinked().setRotation_z(n);
},
handleRot: function(e) {
if (this.$["rot" + e + "min"].getValue() || this.$["rot" + e + "max"].getValue()) {
var t = this.checkLimiet(this.$["rot" + e + "min"].getValue(), this.$["rot" + e + "max"].getValue(), this.$["rotation_" + e].getValue()), n = 0;
switch (t) {
case "ok":
n = this.$["rotation_" + e].getValue();
break;
case "groter":
n = parseInt(this.$["rot" + e + "max"].getValue());
break;
case "kleiner":
n = this.$["rot" + e + "min"].getValue();
}
return isNaN(parseInt(n)) ? -90 : parseInt(n);
}
return this.$["rotation_" + e].getValue();
},
checkLimiet: function(e, t, n) {
return e = parseFloat(e), t = parseFloat(t), n = parseFloat(n), e && n < e ? "kleiner" : t && n > t ? "groter" : "ok";
},
linkPropValue: function(e, t) {
var n = t.originator.linkedProp;
if (n) {
var r = t.originator.linked ? this.getExistingLinkEigenschap(n) : "";
this.$.linkEigenschap && this.$.linkEigenschap.destroy(), this.createComponent({
kind: "educate.create.view.eigenschappen.dialoogvensters.LinkEigenschapDialoog",
name: "linkEigenschap",
layer: this.getLayer(),
eigenschap: t.originator.linkedProp,
field: t.originator,
linkExist: r,
viewId: this.getViewId()
});
}
},
getExistingLinkEigenschap: function(e) {
var t = this.getLinked().getLinkedEigenschappen();
for (var n in t) if (t[n].eigenschap === e) return t[n];
},
linkRemovedHandler: function(e, t) {
this.removeLinkEigenschap(t.eigenschap);
},
removeLinkEigenschap: function(e) {
var t = this.getLinked().getLinkedEigenschappen();
for (var n in t) t[n].eigenschap === e && (t[n].databaseId && this.addObjectToArrDeleted(t[n].databaseId), t.splice(n, 1));
},
addObjectToArrDeleted: function(e) {
this.bubble("addObjectToArrDeleted", {
objDbId: e
});
},
sendChangedEvent: function() {
this.bubble("onPropertiesChanged", this.layer);
},
updatePropertiesHandler: function(e, t) {
this.setValues(), this.render(), this.propertiesChanged();
},
updateLinksHandler: function(e, t) {
e.destroy(), this.handleLinkEigenschappen(), this.updatePropertiesHandler("", this.getLinked());
},
layerLockClickedHandler: function(e, t) {
t == this.layer && this.enableDisableProperties(this.getLinked().getLocked());
},
enableDisableProperties: function(e) {
var t = this.children;
for (var n in t) this.$[t[n].name].disabled = e, this.$[t[n].name].render();
},
visibleChanged: function() {
this.getVisible() ? this.getLinked().makeVisible() : this.getLinked().makeInvisible(), this.$.chkZichtbaar && this.$.chkZichtbaar.setChecked(this.getVisible());
},
alphaChanged: function() {
this.getLinked().setAlpha(this.getAlpha()), this.$.alpha && this.$.alpha.setValue(this.getAlpha());
},
inLayerHolderChanged: function() {
var e = this.getInLayerHolder() ? "onAddLayerInLayerHolder" : "onRemoveLayerInLayerHolder";
this.bubble(e, this), this.getLinked().setInLayerHolder(this.getInLayerHolder()), this.$.chkLaag.setChecked(this.getInLayerHolder());
},
getByLinkedProp: function(e) {
for (var t in this.$) if (this.$[t].linkedProp === e) return this.$[t];
return !1;
}
});

// EigenschappenImage.js

enyo.kind({
name: "educate.create.view.eigenschappen.EigenschappenImage",
kind: "educate.create.view.eigenschappen.Eigenschappen",
tag: "div",
classes: "PropertiesImage",
published: {
imgSource: "",
pAchtergrond: ""
},
create: function() {
this.inherited(arguments), this.generateImageProps();
},
rendered: function() {
this.inherited(arguments), this.$.width && this.pWidthChanged(), this.$.height && this.pHeightChanged();
},
generateImageProps: function() {
this.pAchtergrond = this.linked.getBAchtergrond(), this.imgSource = this.linked.value, this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkAchtergrond",
checked: this.getPAchtergrond(),
onchange: "chkAchtergrondHandler",
content: "Als Achtergrond"
} ]
} ]
} ]
}, {
owner: this
}), this.$.buttons.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
kind: "enyo.Button",
classes: "btn btn-block",
name: "browseImageAsset",
ontap: "browseFoto",
content: "kies afbeelding"
} ]
} ]
}, {
owner: this
}), this.setInputReadonly();
},
chkAchtergrondHandler: function(e, t) {
this.setPAchtergrond(this.$.chkAchtergrond.getChecked());
},
pAchtergrondChanged: function() {
this.getLinked().setBAchtergrond(this.getPAchtergrond()), this.setInputReadonly(), this.getPAchtergrond() ? (this.$.position_x.setValue(0), this.$.position_y.setValue(0), this.$.width.setValue(window.settings.STAGEWIDTH), this.$.height.setValue(window.settings.STAGEHEIGHT)) : (this.$.position_x.setValue(0), this.$.position_y.setValue(0), this.$.width.setValue("auto"), this.$.height.setValue("auto")), this.propertiesChanged();
},
setInputReadonly: function() {
this.getPAchtergrond() ? (this.$.position_x.setInputReadonly(), this.$.position_y.setInputReadonly(), this.$.width.setInputReadonly(), this.$.height.setInputReadonly()) : (this.$.position_x.setInputWritable(), this.$.position_y.setInputWritable(), this.$.width.setInputWritable(), this.$.height.setInputWritable());
},
updatePropertiesHandler: function(e, t) {
this.inherited(arguments), this.render();
},
propertiesChanged: function(e, t) {
this.inherited(arguments), this.$.browseImageAsset && this.$.library && this.$.library.getSelectedAsset() != "" && this.linked.setValue(this.$.library.getSelectedAsset()), this.sendChangedEvent();
}
});

// EigenschappenSvg.js

enyo.kind({
name: "educate.create.view.eigenschappen.EigenschappenSvg",
kind: "educate.create.view.eigenschappen.Eigenschappen",
tag: "div",
classes: "PropertiesSvg",
published: {
svgSource: "",
pBackground: !1,
uitlichten: !1,
colorOptions: []
},
handlers: {},
create: function() {
this.inherited(arguments), this.generateSvgProps(), this.linked.renderedFromPickPlace && (this.$.basicProperties.destroy(), this.$.limieten.destroy(), this.$.control9.destroy(), this.$.chkAchtergrond.parent.destroy());
},
rendered: function() {
this.inherited(arguments), this.$.width && this.pWidthChanged(), this.$.height && this.pHeightChanged(), this.handleBackground();
var e = this;
$(".minicolorEdge").minicolors({
change: function(t) {
e.strokeColorSelected(t);
},
defaultValue: this.colorOptions.stroke,
theme: "bootstrap"
}), $(".minicolorFill").minicolors({
change: function(t) {
e.fillColorSelected(t);
},
defaultValue: this.colorOptions.fill,
theme: "bootstrap"
});
},
pWidthChanged: function() {
this.$.width.setValue(this.pWidth);
},
pHeightChanged: function() {
this.$.height.setValue(this.pHeight);
},
generateSvgProps: function() {
this.pWidth = this.linked.getWidth(), this.pHeight = this.linked.getHeight(), this.pBackground = this.linked.getIsBackground(), this.uitlichten = this.linked.getShowArea(), this.colorOptions = this.linked.getColorOptions(), this.svgSource = this.linked.value, this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkAchtergrond",
checked: this.getPBackground(),
onchange: "chkAchtergrondHandler",
content: "Als Achtergrond"
} ]
} ]
} ]
}, {
owner: this
}), this.$.buttons.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
kind: "enyo.Button",
classes: "btn btn-block",
name: "browseSvgAsset",
ontap: "browseSvg",
content: "kies SVG"
} ]
} ]
}, {
owner: this
}), this.linked.renderedFromPickPlace && this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkUitlichten",
checked: this.getUitlichten(),
onchange: "chkUitlichtenHandler",
content: "Gebied Uitlichten"
} ]
} ]
} ]
}, {
owner: this
}), this.uitlichten && this.initColorBoxes();
},
pBackgroundChanged: function(e) {
this.handleBackground(), this.propertiesChanged(), this.getLinked().setIsBackground(this.getPBackground());
},
handleBackground: function() {
this.getPBackground() ? this.setInputReadonly() : this.setInputWritable(), this.linked.renderedFromPickPlace ? this.getPBackground() ? (this.$.position_x.setValue(parseInt($(".picker").css("width").replace("px", "")) / window.settings.SCALE), this.$.position_y.setValue(0), this.$.width.setValue(window.settings.STAGEWIDTH - parseInt($(".picker").css("width").replace("px", "")) / window.settings.SCALE), this.$.height.setValue(window.settings.STAGEHEIGHT)) : (this.$.position_x.setValue(0), this.$.position_y.setValue(0), this.$.width.setValue("auto"), this.$.height.setValue("auto")) : this.getPBackground() ? (this.$.position_x.setValue(0), this.$.position_y.setValue(0), this.$.width.setValue(window.settings.STAGEWIDTH), this.$.height.setValue(window.settings.STAGEHEIGHT)) : (this.$.position_x.setValue(this.getLinked().getPosition_x()), this.$.position_y.setValue(this.getLinked().getPosition_y()), this.$.width.setValue(this.getLinked().getWidth()), this.$.height.setValue(this.getLinked().getHeight())), this.$.position_x.valueChanged(), this.$.position_y.valueChanged(), this.$.width.valueChanged(), this.$.height.valueChanged();
},
uitlichtenChanged: function() {
this.linked.options.showArea = this.getUitlichten(), this.getUitlichten() ? this.initColorBoxes() : this.deleteColorBoxes(), this.propertiesChanged();
},
initColorBoxes: function() {
this.$.extraProperties.createComponent({
name: "fillControl",
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
content: "Vulling",
classes: "control-label"
}, {
tag: "input",
type: "text",
classes: "minicolorFill",
style: "width: 128px;"
} ]
} ]
}, {
owner: this
}), this.$.extraProperties.createComponent({
name: "opacityControl",
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
content: "Opacity",
classes: "control-label"
}, {
kind: "enyo.Input",
name: "rangeNumber",
type: "text",
onchange: "opacitySelected",
value: this.colorOptions.opacity
} ]
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
type: "range",
classes: "slider",
style: "height: 10px;margin-top: 8px;",
value: this.colorOptions.opacity,
onchange: "opacitySelected",
name: "scrollOpacity",
attributes: {
min: "0",
max: "1",
step: "0.1"
}
} ]
} ]
}, {
owner: this
}), this.$.extraProperties.createComponent({
name: "strokeControl",
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
content: "Rand",
classes: "control-label"
}, {
tag: "input",
type: "text",
classes: "minicolorEdge",
style: "width: 128px;"
} ]
} ]
}, {
owner: this
}), this.$.extraProperties.render();
var e = this;
$(".minicolorEdge").minicolors({
change: function(t) {
e.strokeColorSelected(t);
},
defaultValue: this.colorOptions.stroke,
theme: "bootstrap"
}), $(".minicolorFill").minicolors({
change: function(t) {
e.fillColorSelected(t);
},
defaultValue: this.colorOptions.fill,
theme: "bootstrap"
});
},
deleteColorBoxes: function() {
this.$.fillControl.destroy(), this.$.opacityControl.destroy(), this.$.strokeControl.destroy();
},
strokeColorSelected: function(e) {
this.colorOptions.stroke = e, this.linked.options.colorOptions = this.colorOptions, this.propertiesChanged();
},
fillColorSelected: function(e) {
this.colorOptions.fill = e, this.linked.options.colorOptions = this.colorOptions, this.propertiesChanged();
},
opacitySelected: function(e, t) {
switch (e.name) {
case "rangeNumber":
this.colorOptions.opacity = e.eventNode.value;
break;
case "scrollOpacity":
this.colorOptions.opacity = e.eventNode.valueAsNumber;
break;
default:
console.log("something went wrong in EigenschappenSvg.js");
}
this.linked.options.colorOptions = this.colorOptions, this.$.rangeNumber.setValue(this.colorOptions.opacity), this.$.scrollOpacity.setValue(this.colorOptions.opacity), this.propertiesChanged();
},
chkAchtergrondHandler: function(e, t) {
this.setPBackground(this.$.chkAchtergrond.getChecked());
},
chkUitlichtenHandler: function(e, t) {
this.setUitlichten(this.$.chkUitlichten.getChecked());
},
setInputReadonly: function() {
this.$.position_x.setInputReadonly(), this.$.position_y.setInputReadonly(), this.$.width.setInputReadonly(), this.$.height.setInputReadonly();
},
setInputWritable: function() {
this.$.position_x.setInputWritable(), this.$.position_y.setInputWritable(), this.$.width.setInputWritable(), this.$.height.setInputWritable();
},
updatePropertiesHandler: function(e, t) {
this.inherited(arguments), this.render();
},
propertiesChanged: function(e, t) {
this.inherited(arguments), this.$.width && this.linked.setWidth(this.$.width.getValue()), this.$.height && this.linked.setHeight(this.$.height.getValue()), this.$.browseSvgAsset && this.$.library && this.$.library.getSelectedAsset() != "" && this.linked.setValue(this.$.library.getSelectedAsset()), this.sendChangedEvent();
}
});

// EigenschappenSvgZone.js

enyo.kind({
name: "educate.create.view.eigenschappen.EigenschappenSvgZone",
kind: "educate.create.view.eigenschappen.Eigenschappen",
tag: "div",
classes: "PropertiesSvgZone",
published: {},
components: [ {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "alpha",
inputType: "number",
label: "alpha: ",
inputPlaceholder: "",
value: 0,
linkedProp: "alpha",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkActive",
content: "Active",
checked: !1,
onchange: "chkActiveHandler"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkZichtbaar",
content: "Zichtbaar",
checked: !1,
onchange: "chkVisibleHandler"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkInlayerholder",
content: "InLayerHolder",
checked: !1,
onchange: "chkInLayerholderHandler"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkPopupZoneName",
checked: !1,
onchange: "chkPopupZoneNameHandler",
content: "ZoneName popup"
} ]
} ]
} ]
} ],
handlers: {},
create: function() {
this.inherited(arguments), this.init();
},
init: function() {
this.$.chkActive.setChecked(this.linked.getActive()), this.$.chkZichtbaar.setChecked(this.linked.getVisible()), this.$.chkInlayerholder.setChecked(this.linked.getInLayerHolder()), this.$.chkPopupZoneName.setChecked(this.linked.getPopupZoneName());
},
rendered: function() {
this.inherited(arguments);
},
chkActiveHandler: function(e, t) {
this.linked.setActive(this.$.chkActive.checked);
},
chkVisibleHandler: function(e, t) {
this.linked.setVisible(this.$.chkZichtbaar.checked);
},
chkInLayerholderHandler: function(e, t) {
this.linked.inLayerHolder = this.$.chkInlayerholder.getChecked(), this.bubble("layerInLayerHolderClicked", this);
},
chkPopupZoneNameHandler: function(e, t) {
this.getLinked().setPopupZoneName(this.$.chkPopupZoneName.getChecked());
},
propertiesChanged: function(e, t) {
this.inherited(arguments), this.sendChangedEvent();
}
});

// EigenschappenSvgZoneLegende.js

enyo.kind({
name: "educate.create.view.eigenschappen.EigenschappenSvgZoneLegende",
kind: "educate.create.view.eigenschappen.EigenschappenSvgZone",
tag: "div",
classes: "PropertiesSvgZoneLegende",
published: {},
components: [],
handlers: {}
});

// EigenschappenSvgZoneLegendeItem.js

enyo.kind({
name: "educate.create.view.eigenschappen.EigenschappenSvgZoneLegendeItem",
kind: "educate.create.view.eigenschappen.EigenschappenSvgZone",
classes: "PropertiesSvgZoneLegende",
create: function() {
this.inherited(arguments);
}
});

// EigenschappenKnop.js

enyo.kind({
name: "educate.create.view.eigenschappen.EigenschappenKnop",
kind: "educate.create.view.eigenschappen.Eigenschappen",
tag: "div",
classes: "PropertiesButton",
handlers: {
onHandlersPopUp: "generateHandlersPopup",
onStylePopUp: "generateButtonStylePopup"
},
published: {
open: !1
},
create: function() {
this.inherited(arguments), this.generateBtnProps();
},
rendered: function() {
this.inherited(arguments), this.$.width && this.pWidthChanged(), this.$.height && this.pHeightChanged();
},
pWidthChanged: function() {
this.$.width.setValue(this.pWidth);
},
pHeightChanged: function() {
this.$.height.setValue(this.pHeight);
},
generateBtnProps: function() {
this.pValue = this.linked.getValue(), this.pSolution = this.linked.getSolution(), this.pAnswered = this.linked.getAnswered(), this.pWidth = this.linked.getWidth(), this.pHeight = this.linked.getHeight(), this.pCssClass = "Button", this.createComponent({
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkOpen",
checked: !1,
content: "open",
onchange: "propertiesChanged"
} ]
} ]
} ],
container: this.$.basicProperties
}, {
owner: this
}), this.generateExtraFields([ {
label: "label",
name: "value",
value: "pValue"
}, {
label: "oplossing",
name: "solution",
value: "pSolution"
}, {
label: "ga naar...",
name: "answered",
value: "pAnswered"
} ]), this.$.buttons.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
kind: "enyo.Button",
classes: "btn btn-block",
name: "styleButton",
ontap: "generateButtonStylePopup",
content: "stijl kiezen"
} ]
} ]
}, {
owner: this
});
},
generateButtonStylePopup: function() {
this.createComponent({
name: "ButtonStylePicker",
kind: "educate.create.view.eigenschappen.dialoogvensters.ButtonStylePicker",
onStyleSelectionChanged: "styleSelectionChanged"
}), this.$.ButtonStylePicker.show();
},
createLayerHandlersHidden: function(e, t) {},
updatePropertiesHandler: function(e, t) {
this.inherited(arguments), this.render();
},
propertiesChanged: function(e, t) {
this.inherited(arguments), this.$.width && this.linked.setWidth(this.$.width.getValue()), this.$.height && this.linked.setHeight(this.$.height.getValue()), this.linked.setCss_class(this.getPCssClass()), this.$.chkOpen && this.setOpen(this.$.chkOpen.getChecked()), this.sendChangedEvent();
},
styleSelectionChanged: function(e, t) {
this.setPCssClass(e.selected.getClass()), this.propertiesChanged(), e.hide();
},
openChanged: function() {
this.getOpen() ? this.getLinked().openUp() : this.getLinked().closeDown(), this.$.chkOpen && this.$.chkOpen.setChecked(this.getOpen());
},
setValues: function() {
this.inherited(arguments), this.getLinked().getOptions() && this.getLinked().getOptions().open && this.setOpen(this.getLinked().getOptions().open), this.getLinked().getOptions() && (this.getLinked().getOptions().open === undefined && (this.getLinked().getOptions().open = !1), this.open = this.getLinked().getOptions().open, this.openChanged());
}
});

// EigenschappenInfoIcon.js

enyo.kind({
name: "educate.create.view.eigenschappen.EigenschappenInfoIcon",
kind: "educate.create.view.eigenschappen.Eigenschappen",
tag: "div",
classes: "PropertiesInfoIcon",
published: {
pContentWidth: "",
pConValue: "",
pConPosX: "",
pConPosY: ""
},
components: [ {
name: "basicProperties",
classes: "form-horizontal",
components: [ {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "layername",
label: "naam: ",
inputPlaceholder: "naam van de laag",
value: this.pLayername,
linkedProp: "layername",
linkable: !1,
onchange: "propertiesChanged"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "solution",
label: "Titel: ",
inputPlaceholder: "Optionele Titel",
value: this.pSolution,
linkedProp: "solution",
linkable: !1,
onchange: "propertiesChanged"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "contentWidth",
inputType: "number",
label: "breedte (%): ",
inputPlaceholder: 50,
min: 30,
max: 100,
value: this.pContentWidth,
linkedProp: "contentWidth",
linkable: !1,
onchange: "propertiesChanged"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "position_x",
inputType: "number",
label: "x: ",
inputPlaceholder: "",
value: this.pPosX,
linkedProp: "position_x",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "position_y",
inputType: "number",
label: "y: ",
inputPlaceholder: "",
value: this.pPosY,
linkedProp: "position_y",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkZichtbaar",
checked: !0,
content: "zichtbaar",
onchange: "propertiesChanged"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkActive",
checked: !0,
content: "actief",
onchange: "propertiesChanged"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkLaag",
checked: this.inLayerHolder,
content: "laag",
onchange: "propertiesChanged"
} ]
} ]
} ]
} ]
}, {
name: "blokExtraEnButtons",
components: [ {
name: "extraProperties",
classes: "form-horizontal",
components: []
}, {
name: "buttons",
classes: "form-horizontal",
components: [ {
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
kind: "enyo.Button",
classes: "btn btn-block",
name: "editcontent",
content: "<i class='icon-pencil'></i> bewerk inhoud",
ontap: "editContentHandler",
allowHtml: !0
} ]
} ]
} ]
} ]
}, {
kind: "educate.create.dialoogvensters.RichTexteditor",
name: "RTE",
title: "meer info",
value: "",
onSubmit: "onSubmitHandler"
} ],
create: function() {
this.inherited(arguments), this.generateInfoIconProps();
},
generateInfoIconProps: function() {
this.pConValue = this.linked.getCollection()[0].getValue(), this.pSolution = this.linked.getCollection()[0].getSolution(), this.pContentWidth = this.linked.getCollection()[0].getWidth();
},
rendered: function() {
this.inherited(arguments), this.$.RTE && this.pConValueChanged(), this.$.contentWidth && this.pContentWidthChanged();
},
pConValueChanged: function() {
this.$.RTE.setValue(this.pConValue);
},
pContentWidthChanged: function() {
this.$.contentWidth.setValue(this.pContentWidth);
},
editContentHandler: function() {
this.$.RTE.setValue(this.getPConValue()), this.$.RTE.setShowing(!0);
},
onSubmitHandler: function() {
this.$.RTE.setShowing(!1), this.setPConValue(this.$.RTE.getValue()), this.propertiesChanged();
},
cancelEditContentPopup: function() {
this.$.editContentPopup.hide();
},
updatePropertiesHandler: function(e, t) {
t == this.linked.getCollection()[0] ? this.pContentWidth = t.getWidth() : (this.pPosX = t.getPosition_x(), this.pPosY = t.getPosition_y()), this.render();
},
propertiesChanged: function(e, t) {
this.$.position_x && this.handlePosX(), this.$.position_y && this.handlePosY(), this.$.layername && this.getLinked().setLayername(this.$.layername.getValue()), this.$.chkZichtbaar && this.setVisible(this.$.chkZichtbaar.getChecked()), this.$.chkActive && this.getLinked().setActive(this.$.chkActive.getChecked()), this.$.chkLaag && this.setInLayerHolder(this.$.chkLaag.getChecked()), this.$.RTE && this.linked.getCollection()[0].setValue(this.getPConValue()), this.$.solution && this.getLinked().getCollection()[0].setSolution(this.$.solution.getValue()), this.$.contentWidth && this.getLinked().getCollection()[0].setWidth(this.$.contentWidth.getValue()), this.$.layername && this.linked.getCollection()[0] && this.linked.getCollection()[0].carrier == window.settings.CARRIERS.CONTENT_ICON && this.linked.getCollection()[0].setLayername(this.$.layername.getValue() + "content"), this.sendChangedEvent();
}
});

// EigenschappenPhotoIcon.js

enyo.kind({
name: "educate.create.view.eigenschappen.EigenschappenPhotoIcon",
kind: "educate.create.view.eigenschappen.Eigenschappen",
tag: "div",
classes: "PropertiesPhotoIcon",
published: {
pConValue: "",
pConPosX: "",
pConPosY: "",
pAfbList: [],
pCommentList: [],
isEdit: !1
},
components: [ {
name: "basicProperties",
classes: "form-horizontal",
components: [ {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "layername",
label: "naam: ",
inputPlaceholder: "naam van de laag",
value: this.pLayername,
linkedProp: "layername",
linkable: !1,
onchange: "propertiesChanged"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "position_x",
inputType: "number",
label: "x: ",
inputPlaceholder: "",
value: this.pPosX,
linkedProp: "position_x",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "position_y",
inputType: "number",
label: "y: ",
inputPlaceholder: "",
value: this.pPosY,
linkedProp: "position_y",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkZichtbaar",
checked: !0,
content: "zichtbaar",
onchange: "propertiesChanged"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkLaag",
checked: this.inLayerHolder,
content: "laag",
onchange: "propertiesChanged"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkMoveable",
checked: this.verplaatsbaar,
content: "verplaatsbaar",
onchange: "propertiesChanged"
} ]
} ]
} ]
} ]
}, {
name: "blokExtraEnButtons",
components: [ {
name: "extraProperties",
classes: "form-horizontal",
components: [ {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "contentposx",
inputType: "number",
label: "x: ",
inputPlaceholder: "",
value: this.pPosY,
linkedProp: "pConPosX",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "contentposy",
inputType: "number",
label: "y: ",
inputPlaceholder: "",
value: this.pPosY,
linkedProp: "pConPosY",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "contentwidth",
inputType: "number",
label: "breedte: ",
inputPlaceholder: "",
value: this.pPosY,
linkedProp: "pWidth",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "contentheight",
inputType: "number",
label: "hoogte: ",
inputPlaceholder: "",
value: this.pPosY,
linkedProp: "pHeight",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
} ]
}, {
name: "buttons",
classes: "form-horizontal",
components: [ {
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
kind: "enyo.Button",
classes: "btn btn-block",
name: "editcontent",
content: "<i class='icon-plus-sign'></i> afbeelding toevoegen",
allowHtml: !0,
ontap: "browseFoto"
} ]
} ]
} ]
}, {
name: "images",
kind: "educate.create.view.eigenschappen.components.ThumbList",
onImagesChanged: "onImagesChangedHandler",
onImageEdit: "onImageEditHandler"
} ]
} ],
create: function() {
this.inherited(arguments), this.generatePhotoIconProps();
},
generatePhotoIconProps: function() {
this.setPPosX(this.getLinked().getPosition_x()), this.setPPosY(this.getLinked().getPosition_y()), this.setPConPosX(this.getLinked().getCollection()[0].getPosition_x()), this.setPConPosY(this.getLinked().getCollection()[0].getPosition_y()), this.setPWidth(this.getLinked().getCollection()[0].getWidth()), this.setPHeight(this.getLinked().getCollection()[0].getHeight()), this.pCommentList = this.getLinked().getCollection()[0].getDescriptions(), this.pAfbList = this.getLinked().getCollection()[0].getPhotos(), this.$.chkMoveable.setChecked(this.getLinked().getVerplaatsbaar()), this.pAfbListChanged();
},
rendered: function() {
this.inherited(arguments), this.$.contentvalue && this.pConValueChanged(), this.$.contentposx && this.pConPosXChanged(), this.$.contentposy && this.pConPosYChanged(), this.$.contentwidth && this.pWidthChanged(), this.$.contentheight && this.pHeightChanged();
},
pConValueChanged: function() {
this.$.contentvalue.setValue(this.pConValue);
},
pConPosXChanged: function() {
this.$.contentposx.setValue(this.pConPosX);
},
pConPosYChanged: function() {
this.$.contentposy.setValue(this.pConPosY);
},
pWidthChanged: function() {
this.$.contentwidth.setValue(this.pWidth);
},
pHeightChanged: function() {
this.$.contentheight.setValue(this.pHeight);
},
updatePropertiesHandler: function(e, t) {
t == this.linked.getCollection()[0] ? (this.pConPosX = t.getPosition_x(), this.pConPosY = t.getPosition_y(), this.pHeight = t.getHeight()) : (this.pPosX = t.getPosition_x(), this.pPosY = t.getPosition_y()), this.render();
},
browseFoto: function() {
this.isEdit = !1, this.generateLibraryPopup("Foto");
},
onImageEditHandler: function(e, t) {
this.isEdit = t.index, this.$.editPhoto && this.$.editPhoto.destroy(), this.createComponent({
kind: "educate.create.view.eigenschappen.dialoogvensters.IconPhotoEditor",
name: "editPhoto",
url: this.getPAfbList()[this.isEdit],
description: this.getPCommentList()[this.isEdit],
onSave: "onPhotoEditSaveHandler",
onCancel: "onPhotoEditCancelHandler",
viewId: this.getViewId()
}), this.$.editPhoto.render();
},
onPhotoEditSaveHandler: function(e, t) {
this.getPAfbList()[this.isEdit] = t.url, this.getPCommentList()[this.isEdit] = t.description, this.pAfbListChanged(), this.$.editPhoto.destroy(), this.isEdit = !1;
},
onPhotoEditCancelHandler: function(e, t) {
this.$.editPhoto.destroy();
},
propertiesChanged: function(e, t) {
this.inherited(arguments);
var n = this.getLinked().getCollection()[0];
this.setPConPosX(this.$.contentposx.getValue()), this.setPConPosY(this.$.contentposy.getValue()), this.setPWidth(this.$.contentwidth.getValue()), this.setPHeight(this.$.contentheight.getValue()), this.getLinked().setPosition_x(this.$.position_x.getValue()), this.getLinked().setPosition_y(this.$.position_y.getValue()), this.getLinked().setVerplaatsbaar(this.$.chkMoveable.getChecked()), this.$.library && this.$.library.getSelectedAsset() != "" && (this.isEdit === !1 ? (this.getPAfbList().push(this.$.library.getSelectedAsset().value), this.getPCommentList().push("")) : this.getPAfbList()[this.isEdit] = this.$.library.getSelectedAsset().value, this.$.library.setSelectedAsset(""), this.pAfbListChanged()), n.setPosition_x(this.getPConPosX()), n.setPosition_y(this.getPConPosY()), n.setWidth(this.getPWidth()), n.setHeight(this.getPHeight()), this.sendChangedEvent();
},
getPAfbList: function() {
return this.pAfbList && this.pAfbList.length === undefined && (this.pAfbList = []), this.pAfbList;
},
pAfbListChanged: function() {
this.$.images.images = this.getPAfbList(), this.$.images.descriptions = this.getPCommentList(), this.$.images.imagesChanged(), this.getLinked().getCollection()[0].photos = this.getPAfbList(), this.getLinked().getCollection()[0].descriptions = this.getPCommentList(), this.getLinked().getCollection()[0].photosChanged();
},
pCommentListChanged: function() {
this.pAfbListChanged();
},
onImagesChangedHandler: function(e, t) {
this.getLinked().getCollection()[0].photosChanged();
}
});

// EigenschappenAnimatie.js

enyo.kind({
name: "educate.create.view.eigenschappen.EigenschappenAnimatie",
kind: "educate.create.view.eigenschappen.Eigenschappen",
tag: "div",
classes: "PropertiesSprite",
published: {
pJsonSource: "",
pPngSource: ""
},
create: function() {
this.inherited(arguments), this.generateSpriteProps(), this.initialising = !0;
},
rendered: function() {
this.inherited(arguments), this.checkType(), this.initialising = !1;
},
generateSpriteProps: function() {
this.pJsonSource = this.linked.getValue(), this.pPngSource = this.linked.getSolution(), this.pCssClass = this.linked.getCss_class() !== "" ? this.linked.getCss_class() : educate.components.animatie.Animatie.LOOP, this.setDisabledFields([ "height", "width" ]), this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
tag: "label",
content: "type",
classes: "control-label"
}, {
classes: "controls",
components: [ {
kind: "enyo.Select",
name: "css_class",
onchange: "typeChanged",
attributes: {
size: 5
},
components: [ {
content: "herhaal",
value: "loop"
}, {
content: "intro - herhaal",
value: "actionLoop"
}, {
content: "speel 1x",
value: "playOnce"
}, {
content: "speel 1x en verwijder",
value: "playOnceRemove"
}, {
content: "random start",
value: "randomStart"
} ]
} ]
} ]
}, {
owner: this
}), this.$.buttons.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
kind: "enyo.Button",
classes: "btn btn-block",
name: "browseAnimatieAsset",
ontap: "browseAnimatie",
content: "kies animatie"
} ]
} ]
}, {
owner: this
});
},
checkType: function() {
switch (this.pCssClass) {
case "loop":
this.$.css_class.setSelected(0);
break;
case "actionLoop":
this.$.css_class.setSelected(1);
break;
case "playOnce":
this.$.css_class.setSelected(2);
break;
case "playOnceRemove":
this.$.css_class.setSelected(3);
break;
case "randomStart":
this.$.css_class.setSelected(4);
}
},
propertiesChanged: function(e, t) {
this.inherited(arguments), this.$.browseAnimatieAsset && this.$.library && this.$.library.getSelectedAsset() != "" && this.linked.setValue(this.$.library.getSelectedAsset()), this.sendChangedEvent();
},
typeChanged: function(e, t) {
switch (e.getValue()) {
case "loop":
this.linked.setCss_class(educate.components.animatie.Animatie.LOOP);
break;
case "actionLoop":
this.linked.setCss_class(educate.components.animatie.Animatie.ACTION_LOOP);
break;
case "playOnce":
this.linked.setCss_class(educate.components.animatie.Animatie.PLAY_ONCE);
break;
case "playOnceRemove":
this.linked.setCss_class(educate.components.animatie.Animatie.PLAY_ONCE_REMOVE);
break;
case "randomStart":
this.linked.setCss_class(educate.components.animatie.Animatie.RANDOM_START);
}
this.initialising || this.propertiesChanged();
}
});

// EigenschappenGroep.js

enyo.kind({
name: "educate.create.view.eigenschappen.EigenschappenGroep",
kind: "educate.create.view.eigenschappen.Eigenschappen",
tag: "div",
classes: "PropertiesGroep",
handlers: {},
components: [ {
name: "basicProperties",
classes: "form-horizontal",
components: [ {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "layername",
label: "naam: ",
inputPlaceholder: "naam van de laag",
value: this.pLayername,
linkedProp: "layername",
linkable: !1,
onchange: "propertiesChanged"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "position_x",
inputType: "number",
label: "x: ",
inputPlaceholder: "",
value: this.pPosX,
linkedProp: "position_x",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "position_y",
inputType: "number",
label: "y: ",
inputPlaceholder: "",
value: this.pPosY,
linkedProp: "position_y",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "position_z",
inputType: "number",
label: "z: ",
inputPlaceholder: "",
value: this.pPosZ,
linkedProp: "position_z",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "rotation_x",
inputType: "number",
label: "rotatie-X: ",
inputPlaceholder: "",
value: 0,
linkedProp: "rotation_x",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "rotation_y",
inputType: "number",
label: "rotatie-Y: ",
inputPlaceholder: "",
value: 0,
linkedProp: "rotation_y",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "rotation_z",
inputType: "number",
label: "rotatie-Z: ",
inputPlaceholder: "",
value: 0,
linkedProp: "rotation_z",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.components.Origin",
name: "origin",
origin: this.pOrigin,
onOriginChanged: "propertiesChanged"
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkZichtbaar",
checked: !0,
content: "zichtbaar",
onchange: "propertiesChanged"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkLaag",
checked: this.inLayerHolder,
content: "laag",
onchange: "propertiesChanged"
} ]
} ]
} ]
} ]
}, {
tag: "h4",
content: "Limieten",
linkblok: "limieten",
ontap: "togglePropBlock"
}, {
name: "limieten",
classes: "limieten form-horizontal",
components: [ {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "posLimiteren",
checked: this.pIsPosLimiet,
content: "Positie limiteren",
onchange: "chkPosLimietHandler"
} ]
} ]
} ]
}, {
name: "limietPosCon",
classes: "limietCon",
showing: !1,
components: [ {
classes: "control-group",
components: [ {
tag: "label",
content: "x min max: ",
classes: "control-label"
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
name: "posxmin",
value: this.pPosXmin,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentPosXmin",
propvar: "position_x",
inputProperty: "posxmin",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
}, {
kind: "enyo.Input",
name: "posxmax",
value: this.pPosXmax,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentPosXmax",
propvar: "position_x",
inputProperty: "posxmax",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "y min max: ",
classes: "control-label"
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
name: "posymin",
value: this.pPosYmin,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentPosYmin",
propvar: "position_y",
inputProperty: "posymin",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
}, {
kind: "enyo.Input",
name: "posymax",
value: this.pPosYmax,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentPosYmax",
propvar: "position_y",
inputProperty: "posymax",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "z min max: ",
classes: "control-label"
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
name: "poszmin",
value: this.pPosZmin,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentPosZmin",
propvar: "position_z",
inputProperty: "poszmin",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
}, {
kind: "enyo.Input",
name: "poszmax",
value: this.pPosZmax,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentPosZmax",
propvar: "position_z",
inputProperty: "poszmax",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "rotLimiteren",
checked: this.pIsRotLimiet,
content: "Rotatie limiteren",
onchange: "chkRotLimietHandler"
} ]
} ]
} ]
}, {
name: "limietRotCon",
classes: "limietCon",
showing: !1,
components: [ {
classes: "control-group",
components: [ {
tag: "label",
content: "x min max: ",
classes: "control-label"
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
name: "rotxmin",
value: this.pRotXmin,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentRotXmin",
propvar: "rotation_x",
inputProperty: "rotxmin",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
}, {
kind: "enyo.Input",
name: "rotxmax",
value: this.pRotXmax,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentRotXmax",
propvar: "rotation_x",
inputProperty: "rotxmax",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "y min max: ",
classes: "control-label"
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
name: "rotymin",
value: this.pRotYmin,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentRotYmin",
propvar: "rotation_y",
inputProperty: "rotymin",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
}, {
kind: "enyo.Input",
name: "rotymax",
value: this.pRotYmax,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentRotYmax",
propvar: "rotation_y",
inputProperty: "rotymax",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "z min max: ",
classes: "control-label"
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
name: "rotzmin",
value: this.pRotZmin,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentRotZmin",
propvar: "rotation_z",
inputProperty: "rotzmin",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
}, {
kind: "enyo.Input",
name: "rotzmax",
value: this.pRotZmax,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentRotZmax",
propvar: "rotation_z",
inputProperty: "rotzmax",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
} ]
} ]
} ]
} ]
}, {
tag: "h4",
content: "Extra eigenschappen",
linkblok: "blokExtraEnButtons",
ontap: "togglePropBlock"
}, {
name: "blokExtraEnButtons",
components: [ {
name: "extraProperties",
classes: "form-horizontal",
components: []
}, {
name: "buttons",
classes: "form-horizontal",
components: []
} ]
} ],
published: {},
create: function() {
this.inherited(arguments), this.generateGroepProps();
},
rendered: function() {
this.inherited(arguments);
},
generateGroepProps: function() {},
propertiesChanged: function(e, t) {
this.inherited(arguments), this.sendChangedEvent();
}
});

// EigenschappenHand.js

enyo.kind({
name: "educate.create.view.eigenschappen.EigenschappenHand",
kind: "educate.create.view.eigenschappen.Eigenschappen",
tag: "div",
classes: "PropertiesHand",
handlers: {},
components: [],
published: {},
create: function() {
this.inherited(arguments), this.generateHandProps();
},
rendered: function() {
this.inherited(arguments);
},
generateHandProps: function() {
this.createComponents([ {
tag: "div",
classes: "handProperties form-horizontal",
components: [ {
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "activeren",
content: "Activeren",
checked: this.linked.value,
onchange: "chkActiveerHandler"
} ]
} ]
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "activeByStart",
content: "Aan bij start",
checked: this.linked.solution,
onchange: "chkActiveStartHandler"
} ]
} ]
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "rememberOriState",
content: "Onthou originele staat",
checked: this.linked.answered,
onchange: "chkRememberOriStateHandler"
} ]
} ]
} ]
} ]
} ], {
owner: this
});
},
chkActiveerHandler: function(e, t) {
this.linked.setValue(this.$.activeren.checked);
},
chkActiveStartHandler: function(e, t) {
this.linked.setSolution(this.$.activeByStart.checked);
},
chkRememberOriStateHandler: function(e, t) {
this.linked.setAnswered(this.$.rememberOriState.checked);
},
propertiesChanged: function(e, t) {
this.inherited(arguments), this.sendChangedEvent();
}
});

// EigenschappenOplossing.js

enyo.kind({
name: "educate.create.view.eigenschappen.EigenschappenOplossing",
kind: "educate.create.view.eigenschappen.Eigenschappen",
tag: "div",
classes: "PropertiesOplossing",
handlers: {},
components: [],
published: {},
create: function() {
this.inherited(arguments), this.generateOplossingProps();
},
rendered: function() {
this.inherited(arguments), this.$.activeByStart.setAttribute("disabled", !0), this.$.rememberOriState.setAttribute("disabled", !0);
},
generateOplossingProps: function() {
this.createComponents([ {
tag: "div",
classes: "handProperties form-horizontal",
components: [ {
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "activeren",
content: "Activeren",
checked: this.linked.value,
onchange: "chkActiveerHandler"
} ]
} ]
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "activeByStart",
content: "Aan bij start",
checked: !1,
active: !1,
onchange: "chkActiveStartHandler"
} ]
} ]
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "rememberOriState",
content: "Onthou originele staat",
checked: !1,
active: !1,
onchange: "chkRememberOriStateHandler"
} ]
} ]
} ]
} ]
} ], {
owner: this
});
},
chkActiveerHandler: function(e, t) {
this.linked.setValue(this.$.activeren.checked);
},
chkActiveStartHandler: function(e, t) {
this.linked.setSolution(this.$.activeByStart.checked);
},
chkRememberOriStateHandler: function(e, t) {
this.linked.setAnswered(this.$.rememberOriState.checked);
},
pActiveChanged: function() {},
propertiesChanged: function(e, t) {
this.inherited(arguments), this.sendChangedEvent();
}
});

// EigenschappenTekst.js

enyo.kind({
name: "educate.create.view.eigenschappen.EigenschappenTekst",
kind: "educate.create.view.eigenschappen.Eigenschappen",
tag: "div",
classes: "PropertiesTekst",
create: function() {
this.inherited(arguments), this.generateTekstProps();
},
rendered: function() {
this.inherited(arguments), this.$.width && this.pWidthChanged(), this.$.height && this.pHeightChanged();
},
pWidthChanged: function() {
this.$.width.setValue(this.pWidth);
},
pHeightChanged: function() {
this.$.height.setValue(this.pHeight);
},
generateTekstProps: function() {
this.pValue = this.linked.getValue(), this.pWidth = this.linked.getWidth(), this.pHeight = this.linked.getHeight(), this.$.buttons.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
kind: "enyo.Button",
classes: "btn btn-block",
name: "editcontent",
content: "Edit",
ontap: "editContentHandler"
} ]
} ]
}, {
owner: this
}), this.createComponent({
name: "editContentPopup",
kind: "enyo.Popup",
floating: !0,
centered: !1,
scrim: !1,
autoDismiss: !1,
modal: !1,
classes: "modal editContentPopup",
components: [ {
classes: "modal-header",
components: [ {
kind: "enyo.Button",
classes: "close",
content: "\u00d7",
attributes: {
"data-dismiss": "modal",
"aria-hidden": "true"
}
}, {
tag: "h3",
content: "bewerk inhoud"
} ]
}, {
kind: "enyo.TextArea",
name: "value",
value: this.pValue,
type: "text",
classes: "modal-body txteditcontent",
attributes: {
name: "value"
}
}, {
classes: "modal-footer",
components: [ {
kind: "enyo.Button",
classes: "btn",
content: "Cancel",
ontap: "cancelEditContentPopup"
}, {
kind: "enyo.Button",
classes: "btn btn-primary",
content: "Ok",
ontap: "SubmitteditContentPopup"
} ]
} ]
}, {
owner: this
});
},
editContentHandler: function() {
this.$.editContentPopup.show(), $(".txteditcontent").ckeditor(function() {}, {
toolbar: "Basic"
});
},
SubmitteditContentPopup: function() {
this.$.editContentPopup.hide(), this.propertiesChanged();
},
cancelEditContentPopup: function() {
this.$.editContentPopup.hide();
},
updatePropertiesHandler: function(e, t) {
this.inherited(arguments), this.render();
},
propertiesChanged: function(e, t) {
this.inherited(arguments), $(".txteditcontent").length && this.linked.setValue($(".txteditcontent").val()), this.$.width && this.linked.setWidth(this.$.width.getValue()), this.$.height && this.linked.setHeight(this.$.height.getValue()), this.sendChangedEvent();
}
});

// EigenschappenRaster.js

enyo.kind({
name: "educate.create.view.eigenschappen.EigenschappenRaster",
kind: "educate.create.view.eigenschappen.Eigenschappen",
tag: "div",
classes: "PropertiesRaster",
published: {
pKolommen: "",
pRijen: "",
pRepeatLastKolom: ""
},
create: function() {
this.inherited(arguments), this.generateRasterProps(), this.initRasterUitlijning();
},
initRasterUitlijning: function() {
var e = this.$.horUitlijning.children, t = this.$.verUitlijning.children, n = e.length, r = t.length;
this.$.horUitlijning.selected = this.getSelectedUitlijning(e, n, this.linked.getHorUitlijning()), this.$.verUitlijning.selected = this.getSelectedUitlijning(t, r, this.linked.getVerUitlijning());
},
getSelectedUitlijning: function(e, t, n) {
for (var r = 0; r < t; r++) if (e[r].getValue() === n) return r;
},
rendered: function() {
this.inherited(arguments), this.$.width && this.pWidthChanged(), this.$.height && this.pHeightChanged();
},
pWidthChanged: function() {
this.$.width.setValue(this.pWidth);
},
pHeightChanged: function() {
this.$.height.setValue(this.pHeight);
},
generateRasterProps: function() {
this.pWidth = this.linked.getWidth(), this.pHeight = this.linked.getHeight(), this.pKolommen = this.linked.getKolommen(), this.pRijen = this.linked.getRijen(), this.pRepeatLastKolom = this.linked.getRepeatLastKolom(), this.$.extraProperties.createComponents([ {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: "Kolommen: "
}, {
classes: "controls",
components: [ {
kind: "enyo.Button",
classes: "btn btn-block",
name: "btnAddKolom",
ontap: "btnAddKolomTapped",
content: "Voeg kolom toe"
} ]
}, {
classes: "controls",
components: [ {
kind: "enyo.Button",
classes: "btn btn-block",
name: "btnRemoveKolom",
ontap: "btnRemoveKolomTapped",
content: "Verwijder kolom"
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: "Rijen: "
}, {
classes: "controls",
components: [ {
kind: "enyo.Button",
classes: "btn btn-block",
name: "btnAddRij",
ontap: "btnAddRijTapped",
content: "Voeg rij toe"
} ]
}, {
classes: "controls",
components: [ {
kind: "enyo.Button",
classes: "btn btn-block",
name: "btnRemoveRij",
ontap: "btnRemoveRijTapped",
content: "Verwijder rij"
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: "Horizontale uitlijning: "
}, {
classes: "controls",
components: [ {
kind: "Select",
name: "horUitlijning",
onchange: "propertiesChanged",
components: [ {
content: "links",
value: "left"
}, {
content: "midden",
value: "center"
}, {
content: "rechts",
value: "right"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: "Verticale uitlijning: "
}, {
classes: "controls",
components: [ {
kind: "Select",
name: "verUitlijning",
onchange: "propertiesChanged",
components: [ {
content: "boven",
value: "top"
}, {
content: "midden",
value: "center"
}, {
content: "onder",
value: "bottom"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkRepeatLastKolom",
checked: this.getPRepeatLastKolom(),
onActivate: "chkRepeatLastKolomHandler",
content: "Herhaal laatste kolom"
} ]
} ]
} ]
} ], {
owner: this
});
},
chkRepeatLastKolomHandler: function(e, t) {
this.setPRepeatLastKolom(!this.getPRepeatLastKolom()), this.propertiesChanged();
},
updatePropertiesHandler: function(e, t) {
this.inherited(arguments), this.render();
},
btnAddKolomTapped: function() {
this.linked.addKolom();
},
btnAddRijTapped: function() {
this.linked.addRij();
},
btnRemoveKolomTapped: function() {},
btnRemoveRijTapped: function() {},
propertiesChanged: function(e, t) {
this.inherited(arguments), this.$.width && this.linked.setWidth(this.$.width.getValue()), this.$.height && this.linked.setHeight(this.$.height.getValue()), this.$.horUitlijning && this.linked.setHorUitlijning(this.$.horUitlijning.getValue()), this.$.verUitlijning && this.linked.setVerUitlijning(this.$.verUitlijning.getValue()), this.sendChangedEvent();
}
});

// EigenschappenCijferveld.js

enyo.kind({
name: "educate.create.view.eigenschappen.EigenschappenCijferveld",
kind: "educate.create.view.eigenschappen.Eigenschappen",
tag: "div",
published: {
pEditable: !0,
pSleepbaar: !1,
pOpmaak: !0,
pRandom: !1,
pValue: "",
pSolution: "",
pAnswered: "",
pSpinner1: "",
pMinimum1: "",
pMaximum1: "",
pHasValue1: !0,
pValue2: "",
pSolution2: "",
pAnswered2: "",
pSpinner2: "",
pMinimum2: "",
pMaximum2: "",
pHasValue2: !1,
pValue3: "",
pSolution3: "",
pAnswered3: "",
pSpinner3: "",
pMinimum3: "",
pMaximum3: "",
pHasValue3: !1,
pTalstelsel: "",
pTeller: "",
pRound: 0,
pCssClass: "",
pBgkleur: ""
},
components: [ {
name: "basicProperties",
classes: "form-horizontal",
components: [ {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "layername",
label: "naam: ",
inputPlaceholder: "naam van de laag",
value: this.pLayername,
linkedProp: "layername",
linkable: !1,
onchange: "propertiesChanged"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "position_x",
inputType: "number",
label: "x: ",
inputPlaceholder: "",
value: this.pPosX,
linkedProp: "position_x",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "position_y",
inputType: "number",
label: "y: ",
inputPlaceholder: "",
value: this.pPosY,
linkedProp: "position_y",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "position_z",
inputType: "number",
label: "z: ",
inputPlaceholder: "",
value: this.pPosZ,
linkedProp: "position_z",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "width",
inputType: "number",
label: "breedte: ",
inputPlaceholder: "",
value: this.pWidth,
linkedProp: "width",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "height",
inputType: "number",
label: "hoogte: ",
inputPlaceholder: "",
value: this.pHeight,
linkedProp: "height",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "rotation_x",
inputType: "number",
label: "rotatie-X: ",
inputPlaceholder: "",
value: 0,
linkedProp: "rotation_x",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "rotation_y",
inputType: "number",
label: "rotatie-Y: ",
inputPlaceholder: "",
value: 0,
linkedProp: "rotation_y",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "rotation_z",
inputType: "number",
label: "rotatie-Z: ",
inputPlaceholder: "",
value: 0,
linkedProp: "rotation_z",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "alpha",
inputType: "number",
label: "alpha: ",
inputPlaceholder: "",
value: 0,
linkedProp: "alpha",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.components.Origin",
name: "origin",
origin: this.pOrigin,
onOriginChanged: "propertiesChanged"
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkZichtbaar",
checked: !0,
content: "zichtbaar",
onchange: "propertiesChanged"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkActive",
checked: !0,
content: "actief",
onchange: "propertiesChanged"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkLaag",
checked: this.inLayerHolder,
content: "laag",
onchange: "propertiesChanged"
} ]
} ]
} ]
} ]
}, {
tag: "h4",
content: "Limieten",
linkblok: "limieten",
ontap: "togglePropBlock"
}, {
name: "limieten",
classes: "limieten form-horizontal",
components: [ {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "posLimiteren",
checked: this.pIsPosLimiet,
content: "Positie limiteren",
onchange: "chkPosLimietHandler"
} ]
} ]
} ]
}, {
name: "limietPosCon",
classes: "limietCon",
showing: !1,
components: [ {
classes: "control-group",
components: [ {
tag: "label",
content: "x min max: ",
classes: "control-label"
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
name: "posxmin",
value: this.pPosXmin,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentPosXmin",
propvar: "position_x",
inputProperty: "posxmin",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
}, {
kind: "enyo.Input",
name: "posxmax",
value: this.pPosXmax,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentPosXmax",
propvar: "position_x",
inputProperty: "posxmax",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "y min max: ",
classes: "control-label"
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
name: "posymin",
value: this.pPosYmin,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentPosYmin",
propvar: "position_y",
inputProperty: "posymin",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
}, {
kind: "enyo.Input",
name: "posymax",
value: this.pPosYmax,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentPosYmax",
propvar: "position_y",
inputProperty: "posymax",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "z min max: ",
classes: "control-label"
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
name: "poszmin",
value: this.pPosZmin,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentPosZmin",
propvar: "position_z",
inputProperty: "poszmin",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
}, {
kind: "enyo.Input",
name: "poszmax",
value: this.pPosZmax,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentPosZmax",
propvar: "position_z",
inputProperty: "poszmax",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "rotLimiteren",
checked: this.pIsRotLimiet,
content: "Rotatie limiteren",
onchange: "chkRotLimietHandler"
} ]
} ]
} ]
}, {
name: "limietRotCon",
classes: "limietCon",
showing: !1,
components: [ {
classes: "control-group",
components: [ {
tag: "label",
content: "x min max: ",
classes: "control-label"
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
name: "rotxmin",
value: this.pRotXmin,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentRotXmin",
propvar: "rotation_x",
inputProperty: "rotxmin",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
}, {
kind: "enyo.Input",
name: "rotxmax",
value: this.pRotXmax,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentRotXmax",
propvar: "rotation_x",
inputProperty: "rotxmax",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "y min max: ",
classes: "control-label"
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
name: "rotymin",
value: this.pRotYmin,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentRotYmin",
propvar: "rotation_y",
inputProperty: "rotymin",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
}, {
kind: "enyo.Input",
name: "rotymax",
value: this.pRotYmax,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentRotYmax",
propvar: "rotation_y",
inputProperty: "rotymax",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "z min max: ",
classes: "control-label"
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
name: "rotzmin",
value: this.pRotZmin,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentRotZmin",
propvar: "rotation_z",
inputProperty: "rotzmin",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
}, {
kind: "enyo.Input",
name: "rotzmax",
value: this.pRotZmax,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentRotZmax",
propvar: "rotation_z",
inputProperty: "rotzmax",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
} ]
} ]
} ]
} ]
}, {
tag: "h4",
content: "Extra eigenschappen",
linkblok: "blokExtraEnButtons",
ontap: "togglePropBlock"
}, {
name: "blokExtraEnButtons",
components: [ {
name: "extraProperties",
classes: "form-horizontal",
components: [ {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "pRound",
inputType: "number",
label: "afronding: ",
inputPlaceholder: "",
value: 0,
linkedProp: "pRound",
linkable: !1,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkReadOnly",
checked: !this.pEditable,
content: "alleen lezen",
onchange: "propertiesChanged"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkBare",
checked: !this.pOpmaak,
content: "zonder opmaak",
onchange: "propertiesChanged"
} ]
} ]
} ]
}, {
classes: "control-group",
name: "colorComp",
components: [ {
tag: "label",
classes: "control-label",
content: "Kleur: "
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
classes: "kleur",
name: "bgkleur",
value: this.pBgkleur,
type: "text",
placeholder: "default"
} ]
} ]
}, {
kind: "educate.create.view.eigenschappen.components.cijferveld.veld",
name: "field_0",
position: 1,
label: "veld 1",
value: this.pValue,
min: this.pMinimum1,
max: this.pMaximum1,
solution: this.pSolution,
unit: this.pAnswered,
enabled: !0,
onValueChanged: "propertiesChanged",
onMinChanged: "propertiesChanged",
onMaxChanged: "propertiesChanged",
onSolutionChanged: "propertiesChanged",
onUnitChanged: "propertiesChanged",
onEnabledChanged: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler",
onIsRandomChanged: "onIsRandomChangedHandler",
valueLinkable: !0,
minLinkable: !0,
maxLinkable: !0,
solutionLinkable: !0,
unitLinkable: !1,
random: !0,
valueLinkProp: "value",
minLinkProp: "minimum1",
maxLinkProp: "maximum1",
solutionLinkProp: "solution",
unitLinkProp: "answered"
}, {
kind: "educate.create.view.eigenschappen.components.cijferveld.veld",
name: "field_1",
position: 2,
label: "veld 2",
value: this.pValue2,
min: this.pMinimum2,
max: this.pMaximum2,
solution: this.pSolution2,
unit: this.pAnswered2,
enabled: !1,
onValueChanged: "propertiesChanged",
onMinChanged: "propertiesChanged",
onMaxChanged: "propertiesChanged",
onSolutionChanged: "propertiesChanged",
onUnitChanged: "propertiesChanged",
onEnabledChanged: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler",
onIsRandomChanged: "onIsRandomChangedHandler",
valueLinkable: !0,
minLinkable: !0,
maxLinkable: !0,
solutionLinkable: !0,
unitLinkable: !1,
random: !0,
valueLinkProp: "value2",
minLinkProp: "minimum2",
maxLinkProp: "maximum2",
solutionLinkProp: "solution2",
unitLinkProp: "answered2"
}, {
kind: "educate.create.view.eigenschappen.components.cijferveld.veld",
name: "field_2",
position: 3,
label: "veld 3",
value: this.pValue2,
min: this.pMinimum2,
max: this.pMaximum2,
solution: this.pSolution2,
unit: this.pAnswered2,
enabled: !1,
onValueChanged: "propertiesChanged",
onMinChanged: "propertiesChanged",
onMaxChanged: "propertiesChanged",
onSolutionChanged: "propertiesChanged",
onUnitChanged: "propertiesChanged",
onEnabledChanged: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler",
onIsRandomChanged: "onIsRandomChangedHandler",
valueLinkable: !0,
minLinkable: !0,
maxLinkable: !0,
solutionLinkable: !0,
unitLinkable: !1,
random: !0,
valueLinkProp: "value3",
minLinkProp: "minimum3",
maxLinkProp: "maximum3",
solutionLinkProp: "solution3",
unitLinkProp: "answered3"
} ]
}, {
name: "buttons",
classes: "form-horizontal",
components: []
}, {
kind: "Signals",
onUpdate: "onUpdateHandler"
} ]
} ],
create: function() {
this.inherited(arguments), this.generateProps();
},
rendered: function() {
this.inherited(arguments), this.$.width && this.pWidthChanged(), this.$.height && this.pHeightChanged();
var e = this;
$(".kleur").minicolors({
changeDelay: 200,
change: function(t, n) {
e.propertiesChanged();
}
});
},
pWidthChanged: function() {
this.$.width.setValue(this.pWidth);
},
pHeightChanged: function() {
this.$.height.setValue(this.pHeight);
},
onUpdateHandler: function(e, t) {
t.originator === this.linked && this.generateProps();
},
generateProps: function() {
this.pValue = this.linked.getValue(), this.pSolution = this.linked.getSolution(), this.pAnswered = this.linked.getAnswered(), this.pMinimum1 = this.linked.getMinimum1(), this.pMaximum1 = this.linked.getMaximum1(), this.pSpinner1 = this.linked.getSpinner1(), this.pHasValue1 = this.linked.getHasValue1(), this.pValue2 = this.linked.getValue2(), this.pSolution2 = this.linked.getSolution2(), this.pMinimum2 = this.linked.getMinimum2(), this.pMaximum2 = this.linked.getMaximum2(), this.pAnswered2 = this.linked.getAnswered2(), this.pSpinner2 = this.linked.getSpinner2(), this.pHasValue2 = this.linked.getHasValue2(), this.pValue3 = this.linked.getValue3(), this.pSolution3 = this.linked.getSolution3(), this.pMaximum3 = this.linked.getMaximum3(), this.pMinimum3 = this.linked.getMinimum3(), this.pAnswered3 = this.linked.getAnswered3(), this.pSpinner3 = this.linked.getSpinner3(), this.pHasValue3 = this.linked.getHasValue3(), this.pWidth = this.linked.getWidth(), this.pHeight = this.linked.getHeight(), this.pCssClass = this.linked.getCss_class(), this.pEditable = this.linked.getEditable(), this.pSleepbaar = this.linked.getSleepbaar(), this.pOpmaak = this.linked.getOpmaak(), this.pRound = this.linked.getRound(), this.pTalstelsel = this.linked.getTalstelsel(), this.pTeller = this.linked.getTeller(), this.pBgkleur = this.linked.getBgkleur(), this.pRandom = this.linked.getRandom(), this.pBgkleurChanged(), this.pRoundChanged(), this.$.field_0.value = this.pValue, this.$.field_0.min = this.pMinimum1, this.$.field_0.max = this.pMaximum1, this.$.field_0.solution = this.pSolution, this.$.field_0.unit = this.pAnswered, this.$.field_0.enabled = this.pHasValue1, this.$.field_0.isRandom = this.pRandom, this.$.field_0.labelChanged(), this.$.field_0.valueChanged(), this.$.field_0.minChanged(), this.$.field_0.maxChanged(), this.$.field_0.solutionChanged(), this.$.field_0.unitChanged(), this.$.field_0.enabledChanged(), this.$.field_0.isRandomChanged(), this.$.field_1.value = this.pValue2, this.$.field_1.min = this.pMinimum2, this.$.field_1.max = this.pMaximum2, this.$.field_1.solution = this.pSolution2, this.$.field_1.unit = this.pAnswered2, this.$.field_1.enabled = this.pHasValue2, this.$.field_1.isRandom = this.pRandom, this.$.field_1.labelChanged(), this.$.field_1.valueChanged(), this.$.field_1.minChanged(), this.$.field_1.maxChanged(), this.$.field_1.solutionChanged(), this.$.field_1.unitChanged(), this.$.field_1.enabledChanged(), this.$.field_1.isRandomChanged(), this.$.field_2.value = this.pValue3, this.$.field_2.min = this.pMinimum3, this.$.field_2.max = this.pMaximum3, this.$.field_2.solution = this.pSolution3, this.$.field_2.unit = this.pAnswered3, this.$.field_2.enabled = this.pHasValue3, this.$.field_2.isRandom = this.pRandom, this.$.field_2.labelChanged(), this.$.field_2.valueChanged(), this.$.field_2.minChanged(), this.$.field_2.maxChanged(), this.$.field_2.solutionChanged(), this.$.field_2.unitChanged(), this.$.field_2.enabledChanged(), this.$.field_2.isRandomChanged(), this.$.chkReadOnly.setChecked(!this.getPEditable()), this.$.chkBare.setChecked(!this.getPOpmaak()), this.$.colorComp.addRemoveClass("readonly", !this.pEditable), this.$.colorComp.addRemoveClass("nostyle", !this.pOpmaak);
},
chkChanged: function(e, t) {
switch (t.originator.name) {
case "chkEdit":
this.linked.setEditable(this.$.chkEdit.checked);
break;
case "chkDrag":
this.linked.setSleepbaar(this.$.chkDrag.checked);
break;
case "chkOpmaak":
this.linked.setOpmaak(this.$.chkOpmaak.checked);
break;
case "chkControleerDirect":
this.linked.setCss_class(this.$.chkControleerDirect.checked);
break;
case "chkSpinner1":
this.linked.setSpinner1(this.$.chkSpinner1.checked);
break;
case "chkSpinner2":
this.linked.setSpinner2(this.$.chkSpinner2.checked);
break;
case "chkSpinner3":
this.linked.setSpinner3(this.$.chkSpinner3.checked);
break;
case "chkTeller":
this.linked.setTeller(this.$.chkTeller.checked);
break;
default:
console.log("geen checkbox");
}
},
onIsRandomChangedHandler: function(e, t) {
var n = t.originator.getIsRandom();
this.$.field_0.setIsRandom(n), this.getPHasValue2() && this.$.field_1.setIsRandom(n), this.getPHasValue3() && this.$.field_2.setIsRandom(n), this.linked.setRandom(n);
},
propertiesChanged: function(e, t) {
if (e && e.kindName && e.kindName === "educate.create.view.eigenschappen.components.cijferveld.veld") switch (e.getChangedValue()) {
case "value":
this.getLinked()["setValue" + (e.position > 1 ? e.position : "")](e.getValue());
break;
case "min":
this.getLinked()["setMinimum" + e.position](e.min);
break;
case "max":
this.getLinked()["setMaximum" + e.position](e.max);
break;
case "solution":
this.getLinked()["setSolution" + (e.position > 1 ? e.position : "")](e.solution);
break;
case "unit":
this.getLinked()["setAnswered" + (e.position > 1 ? e.position : "")](e.unit);
break;
case "enabled":
this.getLinked()["setHasValue" + e.position](e.enabled);
break;
default:
console.log(e.getChangedValue());
} else {
this.$.bgkleur && this.linked.setBgkleur(this.$.bgkleur.getValue());
if (e) {
switch (e.name) {
case "pRound":
this.pRound = e.getValue(), this.getLinked().setRound(this.getPRound());
break;
case "chkReadOnly":
this.pEditable = !e.getActive(), this.linked.setEditable(this.pEditable), this.$.colorComp.addRemoveClass("readonly", !this.pEditable);
break;
case "chkBare":
this.pOpmaak = !e.getActive(), this.linked.setOpmaak(this.pOpmaak), this.$.colorComp.addRemoveClass("nostyle", !this.pOpmaak);
break;
default:
console.log('case "' + e.name + '": break;'), this.inherited(arguments);
}
this.sendChangedEvent();
}
}
},
pValueChanged: function() {
this.$.value.setValue(this.getPValue());
},
pValue2Changed: function() {
this.$.talstelsel.getValue() != "" && this.getPValue2() > this.$.talstelsel.getValue() && this.handleTalstelsel(2), this.$.value2.setValue(this.getPValue2());
},
pValue3Changed: function() {
this.$.talstelsel.getValue() != "" && this.getPValue3() > this.$.talstelsel.getValue() && this.handleTalstelsel(3), this.$.value3.setValue(this.getPValue3());
},
pMinimum1Changed: function() {
this.$.minimum1.setValue(this.getPMinimum1());
},
pMinimum2Changed: function() {
this.$.minimum2.setValue(this.getPMinimum2());
},
pMinimum3Changed: function() {
this.$.minimum3.setValue(this.getPMinimum3());
},
pMaximum1Changed: function() {
this.$.maximum1.setValue(this.getPMaximum1());
},
pMaximum2Changed: function() {
this.$.maximum2.setValue(this.getPMaximum2());
},
pMaximum3Changed: function() {
this.$.maximum3.setValue(this.getPMaximum3());
},
pBgkleurChanged: function() {
this.$.bgkleur.setValue(this.getPBgkleur());
},
pRoundChanged: function() {
this.$.pRound.setValue(isNaN(parseInt(this.getPRound())) ? 0 : parseInt(this.getPRound()));
},
checkWaarde: function(e) {
e == "value" && this.$.value.getValue() ? this.setPValue(this.checkLimietWaarde(this.$.value.getValue(), this.$.minimum1.getValue(), this.$.maximum1.getValue())) : e == "value2" && this.$.value2.getValue() ? this.setPValue2(this.checkLimietWaarde(this.$.value2.getValue(), this.$.minimum2.getValue(), this.$.maximum2.getValue())) : e == "value3" && this.$.value3.getValue() && this.setPValue3(this.checkLimietWaarde(this.$.value3.getValue(), this.$.minimum3.getValue(), this.$.maximum3.getValue()));
},
checkLimietWaarde: function(e, t, n) {
return e = parseFloat(e), t && e < t ? t : n && e > n ? n : e;
},
handleTalstelsel: function(e) {
var t;
e == 2 ? (t = this.berekenStelsel(this.getPValue2()), this.setPValue2(t.val1), this.setPValue(this.getPValue() + t.val2)) : e == 3 ? (t = this.berekenStelsel(this.getPValue3()), this.setPValue3(t.val1), this.setPValue2(this.getPValue2() + t.val2)) : (t = this.berekenStelsel(this.getPValue2()), this.setPValue2(t.val1), this.setPValue(this.getPValue() + t.val2), t = this.berekenStelsel(this.getPValue3()), this.setPValue3(t.val1), this.setPValue2(this.getPValue2() + t.val2));
},
berekenStelsel: function(e) {
var t = {}, n = parseInt(this.$.talstelsel.getValue());
return t.val1 = e % n, t.val2 = (e - t.val1) / n, t;
}
});

// EigenschappenVideo.js

enyo.kind({
name: "educate.create.view.eigenschappen.EigenschappenVideo",
kind: "educate.create.view.eigenschappen.Eigenschappen",
tag: "div",
classes: "PropertiesVideo",
published: {
pBordered: !0,
pTimelined: !0,
pPlayable: !0,
pSkipable: !0,
pWindable: !0,
pLoopable: !0,
pFullscreenable: !0,
pMoreinfo: !0,
pCloseable: !0,
pAutoClose: !1,
pSolution: !0,
pPercentage: 0,
pPlaybackRate: 100,
pTitle: "",
pLabel: "",
pDescription: "",
editor: null
},
components: [ {
name: "basicProperties",
classes: "form-horizontal",
components: [ {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "layername",
label: "naam: ",
inputPlaceholder: "naam van de laag",
value: this.pLayername,
linkedProp: "layername",
linkable: !1,
onchange: "propertiesChanged"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "position_x",
inputType: "number",
label: "x: ",
inputPlaceholder: "",
value: this.pPosX,
linkedProp: "position_x",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "position_y",
inputType: "number",
label: "y: ",
inputPlaceholder: "",
value: this.pPosY,
linkedProp: "position_y",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "position_z",
inputType: "number",
label: "z: ",
inputPlaceholder: "",
value: this.pPosZ,
linkedProp: "position_z",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "width",
inputType: "number",
label: "breedte: ",
inputPlaceholder: "",
value: this.pWidth,
linkedProp: "width",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "height",
inputType: "number",
label: "hoogte: ",
inputPlaceholder: "",
value: this.pHeight,
linkedProp: "height",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "rotation_x",
inputType: "number",
label: "rotatie-X: ",
inputPlaceholder: "",
value: 0,
linkedProp: "rotation_x",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "rotation_y",
inputType: "number",
label: "rotatie-Y: ",
inputPlaceholder: "",
value: 0,
linkedProp: "rotation_y",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "rotation_z",
inputType: "number",
label: "rotatie-Z: ",
inputPlaceholder: "",
value: 0,
linkedProp: "rotation_z",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "percentage",
inputType: "number",
label: "%: ",
inputPlaceholder: "",
value: this.pPercentage,
extraAttributes: {
min: 0,
max: 100
},
linkedProp: "percentage",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "playbackRate",
inputType: "number",
label: "snelheid %: ",
inputPlaceholder: "",
value: this.pPlaybackRate,
extraAttributes: {
min: 0,
max: 400
},
linkedProp: "playbackRate",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler",
addBefore: this.$.origin
}, {
kind: "educate.create.view.eigenschappen.components.Origin",
name: "origin",
origin: this.pOrigin,
onOriginChanged: "propertiesChanged"
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkZichtbaar",
checked: !0,
content: "zichtbaar",
onchange: "propertiesChanged"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkActive",
checked: !0,
content: "actief",
onchange: "propertiesChanged"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkLaag",
checked: this.inLayerHolder,
content: "laag",
onchange: "propertiesChanged"
} ]
} ]
} ]
} ]
}, {
tag: "h4",
content: "Limieten",
linkblok: "limieten",
ontap: "togglePropBlock"
}, {
name: "limieten",
classes: "limieten form-horizontal",
components: [ {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "posLimiteren",
checked: this.pIsPosLimiet,
content: "Positie limiteren",
onchange: "chkPosLimietHandler"
} ]
} ]
} ]
}, {
name: "limietPosCon",
classes: "limietCon",
showing: !1,
components: [ {
classes: "control-group",
components: [ {
tag: "label",
content: "x min max: ",
classes: "control-label"
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
name: "posxmin",
value: this.pPosXmin,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentPosXmin",
propvar: "position_x",
inputProperty: "posxmin",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
}, {
kind: "enyo.Input",
name: "posxmax",
value: this.pPosXmax,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentPosXmax",
propvar: "position_x",
inputProperty: "posxmax",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "y min max: ",
classes: "control-label"
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
name: "posymin",
value: this.pPosYmin,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentPosYmin",
propvar: "position_y",
inputProperty: "posymin",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
}, {
kind: "enyo.Input",
name: "posymax",
value: this.pPosYmax,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentPosYmax",
propvar: "position_y",
inputProperty: "posymax",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "z min max: ",
classes: "control-label"
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
name: "poszmin",
value: this.pPosZmin,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentPosZmin",
propvar: "position_z",
inputProperty: "poszmin",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
}, {
kind: "enyo.Input",
name: "poszmax",
value: this.pPosZmax,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentPosZmax",
propvar: "position_z",
inputProperty: "poszmax",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "rotLimiteren",
checked: this.pIsRotLimiet,
content: "Rotatie limiteren",
onchange: "chkRotLimietHandler"
} ]
} ]
} ]
}, {
name: "limietRotCon",
classes: "limietCon",
showing: !1,
components: [ {
classes: "control-group",
components: [ {
tag: "label",
content: "x min max: ",
classes: "control-label"
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
name: "rotxmin",
value: this.pRotXmin,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentRotXmin",
propvar: "rotation_x",
inputProperty: "rotxmin",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
}, {
kind: "enyo.Input",
name: "rotxmax",
value: this.pRotXmax,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentRotXmax",
propvar: "rotation_x",
inputProperty: "rotxmax",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "y min max: ",
classes: "control-label"
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
name: "rotymin",
value: this.pRotYmin,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentRotYmin",
propvar: "rotation_y",
inputProperty: "rotymin",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
}, {
kind: "enyo.Input",
name: "rotymax",
value: this.pRotYmax,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentRotYmax",
propvar: "rotation_y",
inputProperty: "rotymax",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "z min max: ",
classes: "control-label"
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
name: "rotzmin",
value: this.pRotZmin,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentRotZmin",
propvar: "rotation_z",
inputProperty: "rotzmin",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
}, {
kind: "enyo.Input",
name: "rotzmax",
value: this.pRotZmax,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentRotZmax",
propvar: "rotation_z",
inputProperty: "rotzmax",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
} ]
} ]
} ]
} ]
}, {
tag: "h4",
content: "Extra eigenschappen",
linkblok: "blokExtraEnButtons",
ontap: "togglePropBlock"
}, {
name: "blokExtraEnButtons",
components: [ {
name: "extraProperties",
classes: "form-horizontal",
components: [ {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "title",
label: "titel: ",
inputPlaceholder: "",
value: this.pTitle,
linkedProp: "titel",
linkable: !1,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "label",
label: "label: ",
inputPlaceholder: "",
value: this.pLabel,
linkedProp: "label",
linkable: !1,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: "beschrijving"
}, {
classes: "controls",
components: [ {
kind: "enyo.Button",
classes: "btn btn-block",
name: "editcontent",
content: "Edit",
ontap: "editContentHandler"
} ]
} ]
}, {
classes: "spacer"
}, {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: ""
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkMoreinfo",
checked: this.pMoreinfo,
onActivate: "chkMoreinfoHandler",
content: "beschrijving en label"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: ""
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkTimeline",
checked: this.pTimelined,
onActivate: "chkTimelineHandler",
content: "tijdslijn"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: ""
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkBordered",
checked: this.pBordered,
onActivate: "chkBorderedHandler",
content: "omranding"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: ""
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkPlayable",
checked: this.pPlayable,
onActivate: "chkPlayableHandler",
content: "play / pauze"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: ""
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkSkipable",
checked: this.pSkipable,
onActivate: "chkSkipableHandler",
content: "vorige / volgende"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: ""
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkWindable",
checked: this.pWindable,
onActivate: "chkWindableHandler",
content: "door- / terugspoelen"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: ""
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkLoopable",
checked: this.pLoopable,
onActivate: "chkLoopableHandler",
content: "loop"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: ""
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkFullscreenable",
checked: this.pFullscreenable,
onActivate: "chkFullscreenableHandler",
content: "fullscreen"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: ""
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkCloseable",
checked: this.pCloseable,
onActivate: "chkCloseableHandler",
content: "sluitknop"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: ""
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkAutoClose",
checked: this.pCloseable,
onActivate: "chkAutoCloseHandler",
content: "sluit automatisch af"
} ]
} ]
} ]
}, {
name: "editContentPopup",
kind: "enyo.Popup",
floating: !0,
centered: !1,
scrim: !1,
autoDismiss: !1,
modal: !1,
classes: "modal editContentPopup",
components: [ {
classes: "modal-header",
components: [ {
kind: "enyo.Button",
classes: "close",
content: "\u00d7",
attributes: {
"data-dismiss": "modal",
"aria-hidden": "true"
}
}, {
tag: "h3",
content: "bewerk inhoud"
} ]
}, {
kind: "enyo.TextArea",
name: "descriptionBox",
placeholder: this.pDescription,
type: "text",
classes: "modal-body txteditcontent",
attributes: {
name: "description"
}
}, {
classes: "modal-footer",
components: [ {
kind: "enyo.Button",
classes: "btn",
content: "Cancel",
ontap: "cancelEditContentPopup"
}, {
kind: "enyo.Button",
classes: "btn btn-primary",
content: "Ok",
ontap: "SubmitteditContentPopup"
} ]
} ]
} ]
}, {
name: "buttons",
classes: "form-horizontal",
components: [ {
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
kind: "enyo.Button",
classes: "btn btn-block",
name: "browseAsset",
ontap: "browseVideo",
content: "kies video"
} ]
} ]
} ]
}, {
name: "extraOptions",
tag: "div"
}, {
name: "buttonsFrame",
classes: "form-horizontal",
components: [ {
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
kind: "enyo.Button",
classes: "btn btn-block",
name: "insertKeyFrame",
ontap: "createKeyFrame",
content: "maak keyframe"
} ]
} ]
} ]
} ]
} ],
create: function() {
this.inherited(arguments), this.generateExtraProperties(), this.updateList();
},
setValues: function() {
this.inherited(arguments), this.setPBordered(this.linked.getBordered()), this.setPMoreinfo(this.linked.getMoreinfo()), this.setPTimelined(this.linked.getTimeline()), this.setPPlayable(this.linked.getPlayable()), this.setPSkipable(this.linked.getSkipable()), this.setPWindable(this.linked.getWindable()), this.setPLoopable(this.linked.getLoopable()), this.setPFullscreenable(this.linked.getFullscreenable()), this.setPCloseable(this.linked.getCloseable()), this.setPAutoClose(this.linked.getAutoClose()), this.setPPercentage(this.linked.getPercentage()), this.setPPlaybackRate(this.linked.getPlaybackRate()), this.pBorderedChanged(), this.pMoreinfoChanged(), this.pTimelinedChanged(), this.pPlayableChanged(), this.pSkipableChanged(), this.pWindableChanged(), this.pLoopableChanged(), this.pFullscreenableChanged(), this.pCloseableChanged(), this.pAutoCloseChanged(), this.pPercentageChanged(), this.pPlaybackRateChanged();
},
rendered: function() {
this.inherited(arguments);
},
pWidthChanged: function() {
this.$.width.setValue(this.pWidth);
},
pHeightChanged: function() {
this.$.height.setValue(this.pHeight);
},
editContentHandler: function() {
this.$.editContentPopup.show(), this.editor || (this.editor = CKEDITOR.replace(this.$.descriptionBox.getId(), {
customConfig: "config_frontend.js"
})), this.editor.setData(this.linked.getDescription()), console.log(this.editor.getData());
},
SubmitteditContentPopup: function() {
this.$.editContentPopup.hide(), this.propertiesChanged();
},
cancelEditContentPopup: function() {
this.$.editContentPopup.hide();
},
createKeyFrame: function(e, t) {
this.insertKeyFrame();
},
insertKeyFrame: function(e, t) {
this.destroyClientControls();
var n = this.linked.getCurrentTime(), r = (t != undefined ? t : n).toFixed(2), i = "", s = "";
e !== undefined && (i = e.label, s = e.description), this.createComponents([ {
classes: "form-horizontal",
components: [ {
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
content: "Tijd:",
classes: "control-label"
}, {
kind: "enyo.Input",
name: "currentTime",
classes: "enyo-input",
type: "text",
value: r,
onchange: "changeCurrentTime"
} ]
} ]
}, {
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
content: "Titel:",
classes: "control-label"
}, {
kind: "enyo.Input",
name: "frameTitel",
classes: "enyo-input",
type: "text",
value: i
} ]
} ]
}, {
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
content: "Beschrijving:",
classes: "control-label"
}, {
kind: "enyo.Input",
name: "frameBeschrijving",
classes: "enyo-input",
type: "text",
value: s
} ]
} ]
} ]
}, {
name: "buttonsMakeKeyFrame",
classes: "form-horizontal",
components: [ {
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
kind: "enyo.Button",
classes: "btn btn-block",
name: "makeKeyFrame",
ontap: "makeKeyFrame",
content: "sla keyframe op",
value: t != undefined ? t : "undefined"
} ]
} ]
} ]
} ], {
owner: this
}), this.render();
},
changeCurrentTime: function(e, t) {
var n = e.node.value, r = this.linked.$.player.$.video.duration;
this.linked.$.player.$.video.gotoAndStop(100 * (n / r));
},
makeKeyFrame: function(e, t) {
this.linked.addKeyframe(parseFloat(this.$.currentTime.node.value), this.$.frameTitel.node.value, this.$.frameBeschrijving.node.value), this.destroyClientControls(), this.updateList();
},
deleteKeyFrame: function(e, t) {
var n = parseFloat(e.name.split("_")[1]);
this.linked.removeKeyframe(n), this.destroyClientControls(), this.updateList();
},
editKeyFrame: function(e, t) {
var n = parseFloat(e.name.split("_")[1]), r = this.linked.keyframes[n];
this.insertKeyFrame(r, n);
},
updateList: function() {
this.$.extraOptions.destroyClientControls();
for (var e in this.linked.keyframes) this.$.extraOptions.createComponent({
classes: "form-horizontal",
components: [ {
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
content: math.round(e * 100) / 100 + " - " + this.linked.keyframes[e].label,
classes: "control-label",
style: "width:160px;"
}, {
kind: enyo.Button,
classes: "btn",
name: "btnDelete_" + e,
ontap: "deleteKeyFrame",
components: [ {
tag: "i",
name: "btnDelete_" + e + "icon",
classes: "icon-trash"
} ]
}, {
kind: enyo.Button,
classes: "btn",
name: "btnEdit_" + e,
ontap: "editKeyFrame",
components: [ {
tag: "i",
name: "btnEdit_" + e + "icon",
classes: "icon-pencil"
} ]
} ]
} ]
} ]
}, {
owner: this
});
this.render();
},
propertiesChanged: function(e, t) {
this.inherited(arguments), this.editor && (this.pDescription = this.editor.getData(), this.linked.setDescription(this.pDescription)), this.pTitle = this.$.title.getValue(), this.pLabel = this.$.label.getValue(), this.pPercentage = this.$.percentage.getValue() / 100, this.pPlaybackRate = this.$.playbackRate.getValue() / 100, this.linked.setTitle(this.pTitle), this.linked.setLabel(this.pLabel), this.linked.setPercentage(this.pPercentage), this.linked.setPlaybackRate(this.pPlaybackRate), this.$.library && this.linked.setValue(this.$.library.getSelectedAsset()), this.sendChangedEvent();
},
chkBorderedHandler: function(e, t) {
this.setPBordered(this.$.chkBordered.getChecked());
},
chkTimelineHandler: function(e, t) {
this.setPTimelined(this.$.chkTimeline.getChecked());
},
chkPlayableHandler: function(e, t) {
this.setPPlayable(this.$.chkPlayable.getChecked());
},
chkSkipableHandler: function(e, t) {
this.setPSkipable(this.$.chkSkipable.getChecked());
},
chkWindableHandler: function(e, t) {
this.setPWindable(this.$.chkWindable.getChecked());
},
chkLoopableHandler: function(e, t) {
this.setPLoopable(this.$.chkLoopable.getChecked());
},
chkFullscreenableHandler: function(e, t) {
this.setPFullscreenable(this.$.chkFullscreenable.getChecked());
},
chkCloseableHandler: function(e, t) {
this.setPCloseable(this.$.chkCloseable.getChecked());
},
chkAutoCloseHandler: function(e, t) {
this.setPAutoClose(this.$.chkAutoClose.getChecked());
},
chkMoreinfoHandler: function(e, t) {
this.setPMoreinfo(this.$.chkMoreinfo.getChecked());
},
pBorderedChanged: function() {
this.getLinked().setBordered(this.getPBordered()), this.$.chkBordered && this.$.chkBordered.setChecked(this.getPBordered());
},
pTimelinedChanged: function() {
this.getLinked().setTimeline(this.getPTimelined()), this.$.chkTimeline && this.$.chkTimeline.setChecked(this.getPTimelined());
},
pPlayableChanged: function() {
this.getLinked().setPlayable(this.getPPlayable()), this.$.chkPlayable && this.$.chkPlayable.setChecked(this.getPPlayable());
},
pSkipableChanged: function() {
this.getLinked().setSkipable(this.getPSkipable()), this.$.chkSkipable && this.$.chkSkipable.setChecked(this.getPSkipable());
},
pWindableChanged: function() {
this.getLinked().setWindable(this.getPWindable()), this.$.chkWindable && this.$.chkWindable.setChecked(this.getPWindable());
},
pLoopableChanged: function() {
this.getLinked().setLoopable(this.getPLoopable()), this.$.chkLoopable && this.$.chkLoopable.setChecked(this.getPLoopable());
},
pFullscreenableChanged: function() {
this.getLinked().setFullscreenable(this.getPFullscreenable()), this.$.chkFullscreenable && this.$.chkFullscreenable.setChecked(this.getPFullscreenable());
},
pCloseableChanged: function() {
this.getLinked().setCloseable(this.getPCloseable()), this.$.chkCloseable && this.$.chkCloseable.setChecked(this.getPCloseable());
},
pAutoCloseChanged: function() {
this.getLinked().setAutoClose(this.getPAutoClose()), this.$.chkAutoClose && this.$.chkAutoClose.setChecked(this.getPAutoClose());
},
pMoreinfoChanged: function() {
this.getLinked().moreinfo = this.getPMoreinfo(), this.getLinked().moreinfoChanged(), this.$.chkMoreinfo && this.$.chkMoreinfo.setChecked(this.getPMoreinfo());
},
pPercentageChanged: function() {
this.linked.setPercentage(this.getPPercentage());
var e = ("" + this.getPPercentage() * 100).split(".");
if (e.length === 1) this.$.percentage.setValue(e[0]); else {
while (e[1].length < 4) e[1] += "0";
this.$.percentage.setValue(e[0] + "," + e[1].substr(0, 4));
}
},
pPlaybackRateChanged: function() {
this.linked.setPlaybackRate(parseFloat(this.getPPlaybackRate()));
var e = ("" + this.getPPlaybackRate() * 100).split(".");
if (e.length === 1) this.$.playbackRate.setValue(e[0]); else {
while (e[1].length < 4) e[1] += "0";
this.$.playbackRate.setValue(e[0] + "," + e[1].substr(0, 4));
}
},
pValueChanged: function() {
this.getPValue() !== "" && this.getLinked().setValue(this.getPValue());
},
updatePropertiesHandler: function(e, t) {
this.inherited(arguments), this.setValues(), this.propertiesChanged(), this.render();
},
generateExtraProperties: function() {}
});

// EigenschappenLijnstuk.js

enyo.kind({
name: "educate.create.view.eigenschappen.EigenschappenLijnstuk",
kind: "educate.create.view.eigenschappen.Eigenschappen",
tag: "div",
classes: "PropertiesImage",
published: {
linked: "",
layer: "",
width: "auto",
height: "150",
pPosition_x: 0,
pPosition_y: 0,
pWidth: 0,
pHeight: 0,
pValue: null,
pRotation: null,
pCss_class: 0,
pStyle: "solid",
pColor: "#000000",
pWeight: 1,
pLayername: "",
pPosition_xMin: null,
pPosition_xMax: null,
pPosition_xRandom: !1,
pPosition_yMin: null,
pPosition_yMax: null,
pPosition_yRandom: !1,
pWidthMin: null,
pWidthMax: null,
pWidthRandom: !1,
pHeightMin: null,
pHeightMax: null,
pHeightRandom: !1,
pValueMin: null,
pValueMax: null,
pValueRandom: !1,
pRotationMin: null,
pRotationMax: null,
pRotationRandom: !1,
pRound: 2,
visible: !0,
inLayerHolder: !1
},
components: [ {
name: "basicProperties",
classes: "form-horizontal",
components: [ {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "layername",
inputType: "text",
label: "naam: ",
inputPlaceholder: "naam van de laag",
value: this.pLayername,
linkedProp: "layername",
linkable: !1,
onchange: "propertiesChanged"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "position_x",
inputType: "number",
label: "begin x: ",
inputPlaceholder: "",
value: this.pPosX,
linkedProp: "position_x",
linkable: !0,
random: !0,
onRandomChange: "randomChanged",
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "position_y",
inputType: "number",
label: "begin y: ",
inputPlaceholder: "",
value: this.pPosY,
linkedProp: "position_y",
linkable: !0,
random: !0,
onRandomChange: "randomChanged",
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "width",
inputType: "number",
label: "eind x: ",
inputPlaceholder: "",
value: this.pWidth,
linkedProp: "width",
linkable: !0,
random: !0,
onRandomChange: "randomChanged",
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "height",
inputType: "number",
label: "eind y: ",
inputPlaceholder: "",
value: this.pHeight,
linkedProp: "height",
linkable: !0,
random: !0,
onRandomChange: "randomChanged",
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "rotation",
inputType: "number",
label: "rotatie: ",
inputPlaceholder: "",
value: 0,
linkedProp: "rotation",
linkable: !0,
random: !0,
onRandomChange: "randomChanged",
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "value",
inputType: "number",
label: "lengte: ",
inputPlaceholder: "",
value: 0,
linkedProp: "value",
linkable: !0,
random: !0,
onRandomChange: "randomChanged",
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "alpha",
inputType: "number",
label: "alpha: ",
inputPlaceholder: "",
value: 0,
linkedProp: "alpha",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkZichtbaar",
checked: !0,
content: "zichtbaar",
onchange: "propertiesChanged"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkLaag",
checked: this.inLayerHolder,
content: "laag",
onchange: "propertiesChanged"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkDragable",
checked: !1,
content: "verplaatsbaar",
onchange: "propertiesChanged"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkBeginPointDragable",
checked: !1,
content: "beginpunt verplaatsbaar",
onchange: "propertiesChanged"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkEndPointDragable",
checked: !1,
content: "eindpunt verplaatsbaar",
onchange: "propertiesChanged"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "eindpunten",
classes: "control-label"
}, {
classes: "controls",
components: [ {
kind: "Select",
name: "selectPoints",
onchange: "propertiesChanged",
linkedProp: "css_class",
components: [ {
content: "geen",
value: "0"
}, {
content: "lijntjes",
value: "1"
}, {
content: "vierkantjes",
value: "2"
}, {
content: "cirkels",
value: "3"
}, {
content: "pijl >",
value: "4"
}, {
content: "pijl <",
value: "5"
}, {
content: "pijlen < >",
value: "6"
}, {
content: "pijlen > <",
value: "7"
} ]
} ]
} ]
} ]
}, {
tag: "h4",
content: "Limieten",
linkblok: "limieten",
ontap: "togglePropBlock"
}, {
name: "limieten",
classes: "limieten form-horizontal",
components: [ {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "posLimiteren",
checked: this.pIsPosLimiet,
content: "Positie limiteren",
onchange: "chkPosLimietHandler"
} ]
} ]
} ]
}, {
name: "limietPosCon",
classes: "limietCon",
components: [ {
kind: "educate.create.view.eigenschappen.Limiet",
name: "lim_position_x",
linkedProp: "position_x",
label: "begin x: ",
showing: !1,
min: "",
max: "",
onchange: "propertiesChanged",
onInherit: "inheritProp"
}, {
kind: "educate.create.view.eigenschappen.Limiet",
name: "lim_position_y",
linkedProp: "position_y",
label: "begin y: ",
showing: !1,
min: "",
max: "",
onchange: "propertiesChanged",
onInherit: "inheritProp"
}, {
kind: "educate.create.view.eigenschappen.Limiet",
name: "lim_width",
linkedProp: "width",
label: "eind x: ",
showing: !1,
min: "",
max: "",
onchange: "propertiesChanged",
onInherit: "inheritProp"
}, {
kind: "educate.create.view.eigenschappen.Limiet",
name: "lim_height",
linkedProp: "height",
label: "eind y: ",
showing: !1,
min: "",
max: "",
onchange: "propertiesChanged",
onInherit: "inheritProp"
} ]
} ]
}, {
tag: "h4",
content: "Extra eigenschappen",
linkblok: "blokExtraEnButtons",
ontap: "togglePropBlock"
}, {
name: "blokExtraEnButtons",
components: [ {
name: "extraProperties",
classes: "form-horizontal",
components: [ {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: "lijndikte: "
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
classes: "",
name: "lijndikte",
value: "1",
onchange: "propertiesChanged",
type: "number"
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: "lijnkleur: "
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
classes: "kleur",
name: "lijnkleur",
value: "#000000",
onchange: "propertiesChanged",
type: "text"
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: "lijnstijl: "
}, {
classes: "controls lijnstijl",
components: [ {
kind: "Select",
name: "lijnstijl",
onchange: "propertiesChanged",
components: [ {
content: "\u2013\u2013\u2013\u2013\u2013\u2013\u2013",
value: "solid"
}, {
content: "- - - -",
value: "dashed"
}, {
content: "\u2022 \u2022 \u2022 \u2022",
value: "dotted"
} ]
} ]
} ]
} ]
}, {
name: "buttons",
classes: "form-horizontal",
components: []
} ]
} ],
create: function() {
this.inherited(arguments);
},
rendered: function() {
this.inherited(arguments), this.$.width && this.pWidthChanged(), this.$.height && this.pHeightChanged();
var e = this;
$(".kleur").minicolors({
changeDelay: 200,
change: function(t, n) {
e.propertiesChanged(e.$.lijnkleur);
}
}), this.setValues(!0);
},
setValues: function(e) {
var t;
e ? (t = this.getLinked().getMinMax("position_x"), this.pPosition_xMin = t.minimum, this.pPosition_xMax = t.maximum, t = this.getLinked().getMinMax("position_y"), this.pPosition_yMin = t.minimum, this.pPosition_yMax = t.maximum, t = this.getLinked().getMinMax("width"), this.pWidthMin = t.minimum, this.pWidthMax = t.maximum, t = this.getLinked().getMinMax("height"), this.pHeightMin = t.minimum, this.pHeightMax = t.maximum, t = this.getLinked().getMinMax("rotation"), this.pRotationMin = t.minimum, this.pRotationMax = t.maximum, t = this.getLinked().getMinMax("value"), this.pValueMin = t.minimum, this.pValueMax = t.maximum, this.pPosition_xMinChanged(), this.pPosition_xMaxChanged(), this.pPosition_yMinChanged(), this.pPosition_yMaxChanged(), this.pWidthMinChanged(), this.pWidthMaxChanged(), this.pHeightMinChanged(), this.pHeightMaxChanged(), this.pRotationMinChanged(), this.pRotationMaxChanged(), this.pValueMinChanged(), this.pValueMaxChanged(), this.pPosition_x = this.getLinked().getPosition_x(), this.pPosition_y = this.getLinked().getPosition_y(), this.pWidth = this.getLinked().getWidth(), this.pHeight = this.getLinked().getHeight(), this.pValue = this.getLinked().getValue(), this.pRotation = this.getLinked().getRotation(), this.pCss_class = this.getLinked().getCss_class(), this.pStyle = this.getLinked().getOptions().style, this.pColor = this.getLinked().getOptions().color, this.pWeight = this.getLinked().getOptions().weight, this.pLayername = this.getLinked().getLayername(), this.pPosition_xChanged(), this.pPosition_yChanged(), this.pWidthChanged(), this.pHeightChanged(), this.pValueChanged(), this.pRotationChanged(), this.pCss_classChanged(), this.pStyleChanged(), this.pColorChanged(), this.pWeightChanged()) : (t = this.getLinked().getMinMax("position_x"), this.setPPosition_xMin(t.min), this.setPPosition_xMax(t.max), t = this.getLinked().getMinMax("position_y"), this.setPPosition_yMin(t.min), this.setPPosition_yMax(t.max), t = this.getLinked().getMinMax("width"), this.setPWidthMin(t.min), this.setPWidthMax(t.max), t = this.getLinked().getMinMax("height"), this.setPHeightMin(t.min), this.setPHeightMax(t.max), t = this.getLinked().getMinMax("value"), this.setPValueMin(t.min), this.setPValueMax(t.max), t = this.getLinked().getMinMax("rotation"), this.setPRotationMin(t.min), this.setPRotationMax(t.max), this.setPPosition_x(this.getLinked().getPosition_x()), this.setPPosition_y(this.getLinked().getPosition_y()), this.setPWidth(this.getLinked().getWidth()), this.setPHeight(this.getLinked().getHeight()), this.setPRotation(this.getLinked().getRotation()), this.setPValue(this.getLinked().getValue()), this.setPCss_class(this.getLinked().getCss_class()), this.setPWeight(this.getLinked().getOptions().weight), this.setPColor(this.getLinked().getOptions().color), this.setPStyle(this.getLinked().getOptions().style), this.setPLayername(this.getLinked().getLayername()), this.$.chkDragable.setChecked(this.getLinked().getOptions().dragable), this.$.chkBeginPointDragable.setChecked(this.getLinked().getOptions().begin_point_dragable), this.$.chkEndPointDragable.setChecked(this.getLinked().getOptions().end_point_dragable)), this.checkRandoms();
},
checkRandoms: function() {
var e = this.getLinked().getOptions(), t, n, r;
for (t in e) t.search("rnd_") !== -1 && (n = t.substr(4), r = "p" + n.substr(0, 1).toUpperCase() + n.substr(1) + "Random", e[t] ? (this[r] = e[t], this[r + "Changed"]()) : (r = "setP" + n.substr(0, 1).toUpperCase() + n.substr(1) + "Random", this[r](e[t])));
},
updatePropertiesHandler: function(e, t) {
this.setPPosition_x(this.getLinked().getPosition_x()), this.setPPosition_y(this.getLinked().getPosition_y()), this.setPWidth(this.getLinked().getWidth()), this.setPHeight(this.getLinked().getHeight()), this.setPRotation(this.getLinked().getRotation()), this.setPValue(this.getLinked().getValue()), this.setPCss_class(this.getLinked().getCss_class()), this.setPWeight(this.getLinked().getOptions().weight), this.setPColor(this.getLinked().getOptions().color), this.setPStyle(this.getLinked().getOptions().style);
},
propertiesChanged: function(e, t) {
if (e !== undefined) {
var n, r, i;
if (e.getLinkedProp !== undefined && e.getValue !== undefined && e.name.search("lim_") === -1) n = e.getLinkedProp(), r = "set" + n.substr(0, 1).toUpperCase() + n.substr(1), i = "p" + n.substr(0, 1).toUpperCase() + n.substr(1), this.getLinked()[r](e.getValue()), this[i] = e.getValue(); else if (e.name.search("lim_") !== -1) {
n = e.getLinkedProp(), i = "p" + n.substr(0, 1).toUpperCase() + n.substr(1), this[i + "Min"] = e.getMin(), this[i + "Max"] = e.getMax(), this.getLinked().setMinMax(n, e.getMin(), e.getMax());
var s = this.$[e.name.substr(4)];
s.setMin(e.getMin()), s.setMax(e.getMax());
} else switch (e.name) {
case "chkZichtbaar":
this.setVisible(this.$.chkZichtbaar.getChecked());
break;
case "chkLaag":
this.setInLayerHolder(this.$.chkLaag.getChecked());
break;
case "selectPoints":
this.pCss_class = e.getSelected(), this.getLinked().setCss_class(e.getSelected());
break;
case "lijndikte":
this.pWeight = e.getValue(), this.getLinked().addOption("weight", e.getValue()), this.getLinked().draw();
break;
case "lijnkleur":
this.pColor = e.getValue(), this.getLinked().addOption("color", e.getValue()), this.getLinked().draw();
break;
case "lijnstijl":
this.pStyle = e.getValue(), this.getLinked().addOption("style", e.getValue()), this.getLinked().draw();
break;
case "chkDragable":
this.getLinked().getOptions().dragable = this.$.chkDragable.getChecked();
break;
case "chkBeginPointDragable":
this.getLinked().getOptions().begin_point_dragable = this.$.chkBeginPointDragable.getChecked();
break;
case "chkEndPointDragable":
this.getLinked().getOptions().end_point_dragable = this.$.chkEndPointDragable.getChecked();
break;
default:
console.log('case "' + e.name + '": break;');
}
}
},
randomChanged: function(e, t) {
e.random && (this.$["lim_" + e.name] || (this.createComponent({
kind: "educate.create.view.eigenschappen.Limiet",
name: "lim_" + e.name,
container: this.$.limieten,
linkedProp: e.linkedProp,
label: e.label,
min: this.getLinked().getMinMax(e.linkedProp).min,
max: this.getLinked().getMinMax(e.linkedProp).max,
onchange: "propertiesChanged",
onInherit: "inheritProp"
}), this.render()), this.getLinked().setIsRandom(e.linkedProp, e.isRandom)), this.$["lim_" + e.name].setShowing(e.random);
},
pPosition_xChanged: function() {
this.$.position_x.setValue(this.getPPosition_x());
},
pPosition_yChanged: function() {
this.$.position_y.setValue(this.getPPosition_y());
},
pWidthChanged: function() {
this.$.width.setValue(this.getPWidth());
},
pHeightChanged: function() {
this.$.height.setValue(this.getPHeight());
},
pValueChanged: function() {
this.$.value.setValue(this.getPValue());
},
pRotationChanged: function() {
this.$.rotation.setValue(this.getPRotation());
},
pCss_classChanged: function() {
this.$.selectPoints.setSelected(this.getPCss_class());
},
pStyleChanged: function() {
this.$.lijnstijl.setSelected(this.getPStyle());
},
pColorChanged: function() {
this.$.lijnkleur.setValue(this.getPColor());
},
pWeightChanged: function() {
this.$.lijndikte.setValue(this.getPWeight());
},
inheritProp: function(e, t) {
t.originator.name === "btnInheritMin" ? e.setMin(this.getLinked()[e.linkedProp]) : e.setMax(this.getLinked()[e.linkedProp]);
},
pIsPosLimietChanged: function() {},
pIsRotLimietChanged: function() {},
pPosition_xMinChanged: function() {
this.$.lim_position_x && (this.$.lim_position_x.min = this.getPPosition_xMin(), this.$.lim_position_x.$.inputMin.setValue(this.getPPosition_xMin()), this.$.lim_position_x.render(), this.$.position_x.setMin(this.getPPosition_xMin()));
},
pPosition_xMaxChanged: function() {
this.$.lim_position_x && (this.$.lim_position_x.max = this.getPPosition_xMax(), this.$.lim_position_x.$.inputMax.setValue(this.getPPosition_xMax()), this.$.lim_position_x.render(), this.$.position_x.setMax(this.getPPosition_xMax()));
},
pPosition_yMinChanged: function() {
this.$.lim_position_y && (this.$.lim_position_y.min = this.getPPosition_yMin(), this.$.lim_position_y.$.inputMin.setValue(this.getPPosition_yMin()), this.$.lim_position_y.render(), this.$.position_y.setMin(this.getPPosition_yMin()));
},
pPosition_yMaxChanged: function() {
this.$.lim_position_y && (this.$.lim_position_y.max = this.getPPosition_yMax(), this.$.lim_position_y.$.inputMax.setValue(this.getPPosition_yMax()), this.$.lim_position_y.render(), this.$.position_y.setMax(this.getPPosition_yMax()));
},
pRotationMinChanged: function() {
this.$.lim_rotation && (this.$.lim_rotation.min = this.getPRotationMin(), this.$.lim_rotation.$.inputMin.setValue(this.getPRotationMin()), this.$.lim_rotation.render(), this.$.rotation.setMin(this.getPRotationMin()));
},
pRotationMaxChanged: function() {
this.$.lim_rotation && (this.$.lim_rotation.max = this.getPRotationMax(), this.$.lim_rotation.$.inputMax.setValue(this.getPRotationMax()), this.$.lim_rotation.render(), this.$.rotation.setMax(this.getPRotationMax()));
},
pValueMinChanged: function() {
this.$.lim_value && (this.$.lim_value.min = this.getPValueMin(), this.$.lim_value.$.inputMin.setValue(this.getPValueMin()), this.$.lim_value.render(), this.$.value.setMin(this.getPValueMin()));
},
pValueMaxChanged: function() {
this.$.lim_value && (this.$.lim_value.max = this.getPValueMax(), this.$.lim_value.$.inputMax.setValue(this.getPValueMax()), this.$.lim_value.render(), this.$.value.setMax(this.getPValueMax()));
},
pWidthMinChanged: function() {
this.$.lim_width && (this.$.lim_width.min = this.getPWidthMin(), this.$.lim_width.$.inputMin.setValue(this.getPWidthMin()), this.$.lim_width.render(), this.$.width.setMin(this.getPWidthMin()));
},
pWidthMaxChanged: function() {
this.$.lim_width && (this.$.lim_width.max = this.getPWidthMax(), this.$.lim_width.$.inputMax.setValue(this.getPWidthMax()), this.$.lim_width.render(), this.$.width.setMax(this.getPWidthMax()));
},
pHeightMinChanged: function() {
this.$.lim_height && (this.$.lim_height.min = this.getPHeightMin(), this.$.lim_height.$.inputMin.setValue(this.getPHeightMin()), this.$.lim_height.render(), this.$.height.setMin(this.getPHeightMin()));
},
pHeightMaxChanged: function() {
this.$.lim_height && (this.$.lim_height.max = this.getPHeightMax(), this.$.lim_height.$.inputMax.setValue(this.getPHeightMax()), this.$.lim_height.render(), this.$.height.setMax(this.getPHeightMax()));
},
pPosition_xRandomChanged: function() {
this.$.position_x.isRandom = this.getPPosition_xRandom(), this.$.position_x.isRandomChanged();
},
pPosition_yRandomChanged: function() {
this.$.position_y.isRandom = this.getPPosition_yRandom(), this.$.position_y.isRandomChanged();
},
pWidthRandomChanged: function() {
this.$.width.isRandom = this.getPWidthRandom(), this.$.width.isRandomChanged();
},
pHeightRandomChanged: function() {
this.$.height.isRandom = this.getPHeightRandom(), this.$.height.isRandomChanged();
},
pValueRandomChanged: function() {
this.$.value.isRandom = this.getPValueRandom(), this.$.value.isRandomChanged();
},
pRotationRandomChanged: function() {
this.$.rotation.isRandom = this.getPRotationRandom(), this.$.rotation.isRandomChanged();
},
pLayernameChanged: function() {
this.inherited(arguments);
},
pPosZminChanged: function() {},
pPosZmaxChanged: function() {},
pRotXminChanged: function() {},
pRotXmaxChanged: function() {},
pRotYminChanged: function() {},
pRotYmaxChanged: function() {},
pRotZminChanged: function() {},
pRotZmaxChanged: function() {}
});

// EigenschappenInputField.js

enyo.kind({
name: "educate.create.view.eigenschappen.EigenschappenInputField",
kind: "educate.create.view.eigenschappen.Eigenschappen",
tag: "div",
classes: "PropertiesInputField",
published: {
pMaxCharacters: ""
},
create: function() {
this.inherited(arguments), this.generateInputFieldProps();
},
rendered: function() {
this.inherited(arguments);
},
generateInputFieldProps: function() {
this.setPMaxCharacters(this.linked.getMaxCharacters()), this.generateExtraFields([ {
label: "Maximum tekens",
name: "maxCharacters",
value: "pMaxCharacters",
placeholder: "",
linkable: !0
} ]);
},
propertiesChanged: function(e, t) {
this.inherited(arguments), this.sendChangedEvent();
}
});

// EigenschappenLaag.js

enyo.kind({
name: "educate.create.view.eigenschappen.EigenschappenLaag",
kind: "educate.create.view.eigenschappen.Eigenschappen",
tag: "div",
classes: "PropertiesLaag",
components: [],
published: {
pKleur: "",
pGroepskleur: ""
},
create: function() {
this.inherited(arguments), this.generateLaagProps(), this.initGroupColorType();
},
rendered: function() {
this.inherited(arguments);
var e = this;
$(".kleur").minicolors({
changeDelay: 200,
change: function(t, n) {
e.propertiesChanged();
}
});
},
initGroupColorType: function() {
this.$.groupColorTypeCon.setShowing(this.linked.getIsGroup());
var e = this.$.groupColorType.children, t = e.length;
for (var n = 0; n < t; n++) e[n].getValue() === this.linked.getGroupColorType() && (this.$.groupColorType.selected = n);
},
generateLaagProps: function() {
this.pKleur = this.linked.value, this.pGroepskleur = this.linked.groupColor, this.createComponents([ {
tag: "div",
classes: "form-horizontal",
components: [ {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: "Naam: "
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
name: "layername",
placeholder: this.pLayername,
onchange: "propertiesChanged",
type: "text"
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: "Kleur: "
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
classes: "kleur laagkleur",
name: "kleur",
value: this.pKleur,
type: "text"
} ]
} ]
}, {
tag: "div",
name: "groupColorTypeCon",
components: [ {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: "Groep kleurtype: "
}, {
classes: "controls",
components: [ {
kind: "Select",
name: "groupColorType",
onchange: "propertiesChanged",
components: [ {
content: "Kleur per laag",
value: "uniek"
}, {
content: "Zelfde kleur",
value: "gelijk"
}, {
content: "Aflopende kleur",
value: "aflopend"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: "Groepskleur: "
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
classes: "kleur groepskleur",
name: "groepskleur",
value: this.pGroepskleur,
type: "text"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkuniek",
content: "Uniek",
checked: this.linked.uniek,
onchange: "chkUniekHandler"
} ]
} ]
} ]
} ]
} ], {
owner: this
});
},
chkUniekHandler: function(e, t) {
this.linked.setUniek(this.$.chkuniek.checked);
},
pActiveChanged: function() {},
propertiesChanged: function(e, t) {
this.inherited(arguments), this.$.kleur && this.linked.setValue(this.$.kleur.getValue()), this.$.groupColorType && this.linked.setGroupColorType(this.$.groupColorType.getValue()), this.$.groepskleur && this.linked.setGroupColor(this.$.groepskleur.getValue()), this.sendChangedEvent();
}
});

// EigenschappenSquare.js

enyo.kind({
name: "educate.create.view.eigenschappen.EigenschappenSquare",
kind: "educate.create.view.eigenschappen.Eigenschappen",
tag: "div",
classes: "PropertiesSquare",
create: function() {
this.inherited(arguments), this.generateSquareProps();
},
rendered: function() {
this.inherited(arguments);
var e = this;
$(".minicolorEdge").minicolors({
change: function(t) {
e.lineColorSelected(t);
},
defaultValue: this.linked.lineColor,
theme: "bootstrap"
});
var t = "rgb(" + this.linked.fillColor + ")", n = t.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
delete n[0];
for (var r = 1; r <= 3; ++r) n[r] = parseInt(n[r]).toString(16), n[r].length == 1 && (n[r] = "0" + n[r]);
var i = "#" + n.join("").toUpperCase();
$(".minicolorFill").minicolors({
change: function(t) {
e.fillColorSelected($(this).minicolors("rgbObject"));
},
defaultValue: i,
theme: "bootstrap"
}), this.setInputValues();
},
generateSquareProps: function() {
this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
content: "Vulling",
classes: "control-label"
}, {
tag: "input",
type: "text",
classes: "minicolorFill",
style: "width: 128px;"
} ]
} ]
}, {
owner: this
}), this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
content: "Opacity",
classes: "control-label"
}, {
kind: "enyo.Input",
name: "rangeNumber",
type: "text",
onchange: "opacitySelected"
} ]
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
type: "range",
classes: "slider",
style: "height: 10px;margin-top: 8px;",
onchange: "opacitySelected",
name: "scrollOpacity",
attributes: {
min: "0",
max: "1",
step: "0.1"
}
} ]
} ]
}, {
owner: this
}), this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
content: "Rand",
classes: "control-label"
}, {
tag: "input",
type: "text",
classes: "minicolorEdge",
style: "width: 128px;"
} ]
} ]
}, {
owner: this
}), this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
content: "Randtype",
classes: "control-label"
}, {
tag: "select",
classes: "dropdown",
onchange: "lineTypeSelected",
name: "selectLineType",
style: "width: 64%",
components: [ {
tag: "option",
content: "solid",
value: "solid"
}, {
tag: "option",
content: "dotted",
value: "dotted"
}, {
tag: "option",
content: "double",
value: "double"
}, {
tag: "option",
content: "dashed",
value: "dashed"
} ]
} ]
} ]
}, {
owner: this
}), this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
content: "Thickness",
classes: "control-label"
}, {
kind: "enyo.Input",
name: "thicknessNumber",
onchange: "lineThicknessSelected",
type: "text"
} ]
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
type: "range",
classes: "slider",
style: "height: 10px;margin-top: 8px;",
onchange: "lineThicknessSelected",
name: "scrollLineThickness",
attributes: {
min: "0",
max: "10",
step: "1"
}
} ]
} ]
}, {
owner: this
}), this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
content: "Radius",
classes: "control-label"
}, {
kind: "enyo.Input",
name: "radiusNumber",
onchange: "radiusSelected",
type: "text"
} ]
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
type: "range",
classes: "slider",
style: "height: 10px;margin-top: 8px;",
onchange: "radiusSelected",
name: "scrollradius",
value: this.linked.radius.toString(),
attributes: {
min: "0",
max: (this.linked.calculatedWidth / 2).toString(),
step: "1"
}
} ]
} ]
}, {
owner: this
});
},
fillColorSelected: function(e) {
this.linked.fillColor = e.r + ", " + e.g + ", " + e.b, this.linked.redrawSquare(this.linked);
},
opacitySelected: function(e, t) {
switch (e.name) {
case "rangeNumber":
this.linked.opacity = e.eventNode.value;
break;
case "scrollOpacity":
this.linked.opacity = e.eventNode.valueAsNumber;
break;
default:
console.log("something went wrong in EigenschappenSquare.js");
}
this.setInputValues(), this.linked.redrawSquare(this.linked);
},
lineColorSelected: function(e) {
this.linked.lineColor = e, this.linked.redrawSquare(this.linked);
},
lineTypeSelected: function(e, t) {
this.linked.lineType = t.srcElement.value, this.setInputValues(), this.linked.redrawSquare(this.linked);
},
lineThicknessSelected: function(e, t) {
switch (e.name) {
case "thicknessNumber":
this.linked.lineThickness = e.eventNode.value;
break;
case "scrollLineThickness":
this.linked.lineThickness = e.eventNode.valueAsNumber;
break;
default:
console.log("something went wrong in EigenschappenSquare.js");
}
this.setInputValues(), this.linked.redrawSquare(this.linked);
},
radiusSelected: function(e, t) {
switch (e.name) {
case "radiusNumber":
this.linked.radius = e.eventNode.value;
break;
case "scrollradius":
this.linked.radius = e.eventNode.valueAsNumber;
break;
default:
console.log("something went wrong in EigenschappenSquare.js");
}
this.setInputValues(), this.linked.redrawSquare(this.linked);
},
setInputValues: function() {
this.$.radiusNumber.setValue(this.linked.radius), this.$.scrollradius.attributes.value = this.linked.radius, this.$.thicknessNumber.setValue(this.linked.lineThickness), this.$.scrollLineThickness.attributes.value = this.linked.lineThickness;
for (var e = 0; e < this.$.selectLineType.children.length; e++) this.$.selectLineType.children[e].value == this.linked.lineType ? this.$.selectLineType.children[e].attributes.selected = "selected" : this.$.selectLineType.children[e].attributes.selected = undefined;
this.$.rangeNumber.setValue(this.linked.opacity), this.$.scrollOpacity.attributes.value = this.linked.opacity;
}
});

// EigenschappenEllipse.js

enyo.kind({
name: "educate.create.view.eigenschappen.EigenschappenEllipse",
kind: "educate.create.view.eigenschappen.Eigenschappen",
tag: "div",
classes: "PropertiesEllipse",
create: function() {
this.inherited(arguments), this.generateEllipseProps();
},
rendered: function() {
this.inherited(arguments);
var e = this;
$(".minicolorEdge").minicolors({
change: function(t) {
e.lineColorSelected(t);
},
defaultValue: this.linked.lineColor,
theme: "bootstrap"
});
var t = "rgb(" + this.linked.fillColor + ")", n = t.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
delete n[0];
for (var r = 1; r <= 3; ++r) n[r] = parseInt(n[r]).toString(16), n[r].length == 1 && (n[r] = "0" + n[r]);
var i = "#" + n.join("").toUpperCase();
$(".minicolorFill").minicolors({
change: function(t) {
e.fillColorSelected($(this).minicolors("rgbObject"));
},
defaultValue: i,
theme: "bootstrap"
}), this.setInputValues();
},
generateEllipseProps: function() {
this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
content: "Vulling",
classes: "control-label"
}, {
tag: "input",
type: "text",
classes: "minicolorFill",
style: "width: 128px;"
} ]
} ]
}, {
owner: this
}), this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
content: "Opacity",
classes: "control-label"
}, {
kind: "enyo.Input",
name: "rangeNumber",
onchange: "opacitySelected",
type: "text"
} ]
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
type: "range",
classes: "slider",
style: "height: 10px;margin-top: 8px;",
onchange: "opacitySelected",
name: "scrollOpacity",
attributes: {
min: "0",
max: "1",
step: "0.1"
}
} ]
} ]
}, {
owner: this
}), this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
content: "Rand",
classes: "control-label"
}, {
tag: "input",
type: "text",
classes: "minicolorEdge",
style: "width: 128px;"
} ]
} ]
}, {
owner: this
}), this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
content: "Randtype",
classes: "control-label"
}, {
tag: "select",
classes: "dropdown",
onchange: "lineTypeSelected",
name: "selectLineType",
style: "width: 64%",
components: [ {
tag: "option",
content: "solid",
value: "solid"
}, {
tag: "option",
content: "dotted",
value: "dotted"
}, {
tag: "option",
content: "double",
value: "double"
}, {
tag: "option",
content: "dashed",
value: "dashed"
} ]
} ]
} ]
}, {
owner: this
}), this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
content: "Thickness",
classes: "control-label"
}, {
kind: "enyo.Input",
name: "thicknessNumber",
onchange: "lineThicknessSelected",
type: "text"
} ]
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
type: "range",
classes: "slider",
style: "height: 10px;margin-top: 8px;",
onchange: "lineThicknessSelected",
name: "scrollLineThickness",
attributes: {
min: "0",
max: "10",
step: "1"
}
} ]
} ]
}, {
owner: this
});
},
fillColorSelected: function(e) {
this.linked.fillColor = e.r + ", " + e.g + ", " + e.b, this.setInputValues(), this.linked.redrawEllipse(this.linked);
},
opacitySelected: function(e, t) {
switch (e.name) {
case "rangeNumber":
this.linked.opacity = e.eventNode.value;
break;
case "scrollOpacity":
this.linked.opacity = e.eventNode.valueAsNumber;
break;
default:
console.log("something went wrong in EigenschappenEllipse.js");
}
this.setInputValues(), this.linked.redrawEllipse(this.linked);
},
lineColorSelected: function(e) {
this.linked.lineColor = e, this.setInputValues(), this.linked.redrawEllipse(this.linked);
},
lineTypeSelected: function(e, t) {
this.linked.lineType = t.srcElement.value, this.setInputValues(), this.linked.redrawEllipse(this.linked);
},
lineThicknessSelected: function(e, t) {
switch (e.name) {
case "thicknessNumber":
this.linked.lineThickness = e.eventNode.value;
break;
case "scrollLineThickness":
this.linked.lineThickness = e.eventNode.valueAsNumber;
break;
default:
console.log("something went wrong in EigenschappenEllipse.js");
}
this.setInputValues(), this.linked.redrawEllipse(this.linked);
},
setInputValues: function() {
this.$.thicknessNumber.setValue(this.linked.lineThickness), this.$.scrollLineThickness.attributes.value = this.linked.lineThickness;
for (var e = 0; e < this.$.selectLineType.children.length; e++) this.$.selectLineType.children[e].value == this.lineType && (this.$.selectLineType.children[e].attributes.selected = "selected");
this.$.rangeNumber.setValue(this.linked.opacity), this.$.scrollOpacity.attributes.value = this.linked.opacity;
}
});

// EigenschappenFree.js

enyo.kind({
name: "educate.create.view.eigenschappen.EigenschappenFree",
kind: "educate.create.view.eigenschappen.Eigenschappen",
tag: "div",
classes: "PropertiesFree",
create: function() {
this.inherited(arguments), this.generateLineProps();
},
rendered: function() {
this.inherited(arguments);
var e = this;
$(".minicolorEdge").minicolors({
change: function(t) {
e.lineColorSelected(t);
},
defaultValue: this.linked.lineColor,
theme: "bootstrap"
});
var t = "rgb(" + this.linked.fillColor + ")", n = t.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
delete n[0];
for (var r = 1; r <= 3; ++r) n[r] = parseInt(n[r]).toString(16), n[r].length == 1 && (n[r] = "0" + n[r]);
var i = "#" + n.join("").toUpperCase();
$(".minicolorFill").minicolors({
change: function(t) {
e.fillColorSelected($(this).minicolors("rgbObject"));
},
defaultValue: i,
theme: "bootstrap"
}), this.setInputValues();
},
generateLineProps: function() {
this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkFill",
onchange: "chkFillHandler",
content: "Opvullen"
} ]
} ]
} ]
}, {
owner: this
}), this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
content: "Vulling",
classes: "control-label"
}, {
tag: "input",
type: "text",
classes: "minicolorFill",
style: "width: 128px;"
} ]
} ]
}, {
owner: this
}), this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
content: "Opacity",
classes: "control-label"
}, {
kind: "enyo.Input",
name: "rangeNumber",
onchange: "opacitySelected",
type: "text"
} ]
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
type: "range",
classes: "slider",
style: "height: 10px;margin-top: 8px;",
onchange: "opacitySelected",
name: "scrollOpacity",
attributes: {
min: "0",
max: "1",
step: "0.1"
}
} ]
} ]
}, {
owner: this
}), this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
content: "Rand",
classes: "control-label"
}, {
tag: "input",
type: "text",
classes: "minicolorEdge",
style: "width: 128px;"
} ]
} ]
}, {
owner: this
}), this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
content: "Randtype",
classes: "control-label"
}, {
tag: "select",
classes: "dropdown",
onchange: "lineTypeSelected",
name: "selectLineType",
style: "width: 64%",
components: [ {
tag: "option",
content: "solid",
value: "solid"
}, {
tag: "option",
content: "dotted",
value: "dotted"
}, {
tag: "option",
content: "dashed",
value: "dashed"
}, {
tag: "option",
content: "double",
value: "double"
} ]
} ]
} ]
}, {
owner: this
}), this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
content: "Thickness",
classes: "control-label"
}, {
kind: "enyo.Input",
name: "thicknessNumber",
onchange: "lineThicknessSelected",
type: "text"
} ]
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
type: "range",
classes: "slider",
style: "height: 10px;margin-top: 8px;",
onchange: "lineThicknessSelected",
name: "scrollLineThickness",
attributes: {
min: "0",
max: "10",
step: "1"
}
} ]
} ]
}, {
owner: this
});
},
chkFillHandler: function() {
this.linked.fill = this.$.chkFill.getChecked(), this.setInputValues(), this.linked.redrawLine(this.linked);
},
fillColorSelected: function(e) {
this.linked.fillColor = e.r + ", " + e.g + ", " + e.b, this.setInputValues(), this.linked.redrawLine(this.linked);
},
opacitySelected: function(e, t) {
switch (e.name) {
case "rangeNumber":
this.linked.opacity = e.eventNode.value;
break;
case "scrollOpacity":
this.linked.opacity = e.eventNode.valueAsNumber;
break;
default:
console.log("something went wrong in EigenschappenFree.js");
}
this.setInputValues(), this.linked.redrawLine(this.linked);
},
lineColorSelected: function(e) {
this.linked.lineColor = e, this.setInputValues(), this.linked.redrawLine(this.linked);
},
lineTypeSelected: function(e, t) {
this.linked.lineType = t.srcElement.value, this.setInputValues(), this.linked.redrawLine(this.linked);
},
lineThicknessSelected: function(e, t) {
switch (e.name) {
case "thicknessNumber":
this.linked.lineThickness = e.eventNode.value;
break;
case "scrollLineThickness":
this.linked.lineThickness = e.eventNode.valueAsNumber;
break;
default:
console.log("something went wrong in EigenschappenFree.js");
}
this.setInputValues(), this.linked.redrawLine(this.linked);
},
setInputValues: function() {
this.$.scrollOpacity.attributes.value = this.linked.opacity, this.$.scrollLineThickness.attributes.value = this.linked.lineThickness, this.$.chkFill.setChecked(this.linked.fill), this.$.thicknessNumber.setValue(this.linked.lineThickness), this.$.rangeNumber.setValue(this.linked.opacity);
for (var e = 0; e < this.$.selectLineType.children.length; e++) this.$.selectLineType.children[e].value == this.linked.lineType && (this.$.selectLineType.children[e].attributes.selected = "selected");
}
});

// EigenschappenMulti.js

enyo.kind({
name: "educate.create.view.eigenschappen.EigenschappenMulti",
kind: "educate.create.view.eigenschappen.Eigenschappen",
tag: "div",
classes: "PropertiesMulti",
create: function() {
this.inherited(arguments), this.generateMultiProps();
},
rendered: function() {
this.inherited(arguments);
var e = this;
$(".minicolorEdge").minicolors({
change: function(t) {
e.lineColorSelected(t);
},
defaultValue: this.linked.lineColor,
theme: "bootstrap"
});
var t = "rgb(" + this.linked.fillColor + ")", n = t.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
delete n[0];
for (var r = 1; r <= 3; ++r) n[r] = parseInt(n[r]).toString(16), n[r].length == 1 && (n[r] = "0" + n[r]);
var i = "#" + n.join("").toUpperCase();
$(".minicolorFill").minicolors({
change: function(t) {
e.fillColorSelected($(this).minicolors("rgbObject"));
},
defaultValue: i,
theme: "bootstrap"
}), this.setInputValues();
},
generateMultiProps: function() {
this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
content: "Vulling",
classes: "control-label"
}, {
tag: "input",
type: "text",
classes: "minicolorFill",
style: "width: 128px;"
} ]
} ]
}, {
owner: this
}), this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
content: "Opacity",
classes: "control-label"
}, {
kind: "enyo.Input",
name: "rangeNumber",
onchange: "opacitySelected",
type: "text"
} ]
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
type: "range",
classes: "slider",
style: "height: 10px;margin-top: 8px;",
onchange: "opacitySelected",
name: "scrollOpacity",
attributes: {
min: "0",
max: "1",
step: "0.1"
}
} ]
} ]
}, {
owner: this
}), this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
content: "Rand",
classes: "control-label"
}, {
tag: "input",
type: "text",
classes: "minicolorEdge",
style: "width: 128px;"
} ]
} ]
}, {
owner: this
}), this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
content: "Randtype",
classes: "control-label"
}, {
tag: "select",
classes: "dropdown",
onchange: "lineTypeSelected",
name: "selectLineType",
style: "width: 64%",
components: [ {
tag: "option",
content: "solid",
value: "solid"
}, {
tag: "option",
content: "dotted",
value: "dotted"
}, {
tag: "option",
content: "dashed",
value: "dashed"
}, {
tag: "option",
content: "double",
value: "double"
} ]
} ]
} ]
}, {
owner: this
}), this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
content: "Thickness",
classes: "control-label"
}, {
kind: "enyo.Input",
name: "thicknessNumber",
onchange: "lineThicknessSelected",
type: "text"
} ]
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
type: "range",
classes: "slider",
style: "height: 10px;margin-top: 8px;",
onchange: "lineThicknessSelected",
name: "scrollLineThickness",
attributes: {
min: "0",
max: "10",
step: "1"
}
} ]
} ]
}, {
owner: this
});
},
fillColorSelected: function(e) {
this.linked.fillColor = e.r + ", " + e.g + ", " + e.b, this.setInputValues(), this.linked.redrawMulti(this.linked);
},
opacitySelected: function(e, t) {
switch (e.name) {
case "rangeNumber":
this.linked.opacity = e.eventNode.value;
break;
case "scrollOpacity":
this.linked.opacity = e.eventNode.valueAsNumber;
break;
default:
console.log("something went wrong in EigenschappenMulti.js");
}
this.setInputValues(), this.linked.redrawMulti(this.linked);
},
lineColorSelected: function(e) {
this.linked.lineColor = e, this.setInputValues(), this.linked.redrawMulti(this.linked);
},
lineTypeSelected: function(e, t) {
this.linked.lineType = t.srcElement.value, this.setInputValues(), this.linked.redrawMulti(this.linked);
},
lineThicknessSelected: function(e, t) {
switch (e.name) {
case "thicknessNumber":
this.linked.lineThickness = e.eventNode.value;
break;
case "scrollLineThickness":
this.linked.lineThickness = e.eventNode.valueAsNumber;
break;
default:
console.log("something went wrong in EigenschappenMulti.js");
}
this.setInputValues(), this.linked.redrawMulti(this.linked);
},
setInputValues: function() {
this.$.scrollOpacity.attributes.value = this.linked.opacity, this.$.scrollLineThickness.attributes.value = this.linked.lineThickness, this.$.thicknessNumber.setValue(this.linked.lineThickness), this.$.rangeNumber.setValue(this.linked.opacity);
for (var e = 0; e < this.$.selectLineType.children.length; e++) this.$.selectLineType.children[e].value == this.linked.lineType && (this.$.selectLineType.children[e].attributes.selected = "selected");
}
});

// EigenschappenMeetlat.js

enyo.kind({
name: "educate.create.view.eigenschappen.EigenschappenMeetlat",
kind: "educate.create.view.eigenschappen.Eigenschappen",
tag: "div",
classes: "PropertiesRuler",
create: function() {
this.inherited(arguments), this.generateRulerProps();
},
rendered: function() {
this.inherited(arguments), this.$.width && this.pWidthChanged(), this.$.height && this.pHeightChanged(), this.setInputValues();
},
generateRulerProps: function() {
this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
content: "Lengte",
classes: "control-label"
}, {
kind: "enyo.Input",
name: "rLength",
value: this.linked.lengte,
type: "text",
onchange: "rLengthChanged"
} ]
} ]
}, {
owner: this
}), this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
content: "Eenheid",
classes: "control-label"
}, {
tag: "select",
classes: "dropdown",
onchange: "unitSelected",
name: "selectUnit",
style: "width: 64%",
components: [ {
tag: "option",
content: "cm",
value: "cm"
}, {
tag: "option",
content: "mm",
value: "mm"
}, {
tag: "option",
content: "inch",
value: "inch"
} ]
} ]
} ]
}, {
owner: this
}), this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
content: "Nauwkeurigheid",
classes: "control-label"
}, {
tag: "select",
classes: "dropdown",
onchange: "divideSelected",
name: "selectDivide",
style: "width: 64%",
components: [ {
tag: "option",
content: "1/10",
value: "1/10"
}, {
tag: "option",
content: "1/5",
value: "1/5"
}, {
tag: "option",
content: "1/2",
value: "1/2"
} ]
} ]
} ]
}, {
owner: this
});
},
rLengthChanged: function(e, t) {
switch (this.linked.unit) {
case "cm":
var n = parseInt(e.node.value);
isNaN(n) && (n = 10), this.linked.lengte = n;
break;
case "mm":
var n = parseInt(e.node.value);
isNaN(n) && (n = 10), this.linked.lengte = math.ceil(n / 10) * 10;
break;
case "inch":
var n = parseInt(e.node.value);
isNaN(n) && (n = 10), this.linked.lengte = n;
}
this.setInputValues(), this.linked.extraPropertiesChanged(this.linked);
},
unitSelected: function(e, t) {
this.linked.unit = t.srcElement.value;
if (this.linked.unit == "mm") {
var n = this.linked.lengte;
isNaN(n) && (n = 10), this.linked.lengte = math.round(n / 10) * 10;
}
this.setInputValues(), this.linked.extraPropertiesChanged(this.linked);
},
divideSelected: function(e, t) {
this.linked.divide = t.srcElement.value.split("/")[1], this.setInputValues(), this.linked.extraPropertiesChanged(this.linked);
},
setInputValues: function() {
this.$.rLength.setValue(this.linked.lengte);
}
});

// EigenschappenZoomImage.js

enyo.kind({
name: "educate.create.view.eigenschappen.EigenschappenZoomImage",
kind: "educate.create.view.eigenschappen.Eigenschappen",
tag: "div",
classes: "PropertiesImage",
published: {
imgSource: "",
pAchtergrond: ""
},
create: function() {
this.inherited(arguments), this.generateImageProps();
},
rendered: function() {
this.inherited(arguments), this.$.width && this.pWidthChanged(), this.$.height && this.pHeightChanged(), this.updateZoomSteps();
},
generateImageProps: function() {
this.pAchtergrond = this.linked.getBAchtergrond(), this.imgSource = this.linked.value, this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkAchtergrond",
checked: this.getPAchtergrond(),
onchange: "chkAchtergrondHandler",
content: "Als Achtergrond"
} ]
} ]
} ]
}, {
owner: this
}), this.$.buttons.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
content: "Zoom schaal:",
classes: "control-label"
}, {
kind: "enyo.Input",
name: "zoomScale",
classes: "enyo-input",
type: "text",
value: ""
} ]
} ]
}, {
owner: this
}), this.$.buttons.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
kind: "enyo.Button",
classes: "btn btn-block",
name: "browseImageAsset",
ontap: "browseNewImageStep",
content: "Kies een stap"
} ]
} ]
}, {
owner: this
}), this.$.extraProperties.createComponent({
tag: "div",
name: "zoomList"
}, {
owner: this
}), this.setInputReadonly();
},
chkAchtergrondHandler: function(e, t) {
this.setPAchtergrond(this.$.chkAchtergrond.getChecked());
},
pAchtergrondChanged: function() {
this.getLinked().setBAchtergrond(this.getPAchtergrond()), this.setInputReadonly(), this.getPAchtergrond() ? (this.$.position_x.setValue(0), this.$.position_y.setValue(0), this.$.width.setValue(window.settings.STAGEWIDTH), this.$.height.setValue(window.settings.STAGEHEIGHT)) : (this.$.position_x.setValue(0), this.$.position_y.setValue(0), this.$.width.setValue("auto"), this.$.height.setValue("auto")), this.propertiesChanged();
},
setInputReadonly: function() {
this.getPAchtergrond() ? (this.$.position_x.setInputReadonly(), this.$.position_y.setInputReadonly(), this.$.width.setInputReadonly(), this.$.height.setInputReadonly()) : (this.$.position_x.setInputWritable(), this.$.position_y.setInputWritable(), this.$.width.setInputWritable(), this.$.height.setInputWritable());
},
updatePropertiesHandler: function(e, t) {
this.inherited(arguments), this.render();
},
propertiesChanged: function(e, t) {
this.inherited(arguments), this.$.library != undefined && this.linked.options.zoomSteps.push(this.$.library.getSelectedAsset().value + "&zoom=" + this.$.zoomScale.node.value), this.$.browseImageAsset && this.$.library && this.$.library.getSelectedAsset() != "" && this.linked.setValue(this.$.library.getSelectedAsset()), this.sendChangedEvent(), this.updateZoomSteps();
},
updateZoomSteps: function() {
this.$.zoomList.destroyClientControls();
for (var e in this.linked.options.zoomSteps) this.$.zoomList.createComponent({
classes: "form-horizontal",
components: [ {
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
content: "Stap " + e + ": x" + this.linked.options.zoomSteps[e].split("&zoom=")[1],
classes: "control-label",
style: "width:160px;"
}, {
tag: "img",
name: "preview_" + e,
classes: "preview"
}, {
kind: enyo.Button,
classes: "btn",
name: "btnDelete_" + e,
ontap: "deleteZoomStep",
components: [ {
tag: "i",
name: "btnDelete_" + e + "icon",
classes: "icon-trash"
} ]
}, {
tag: "div",
classes: "btn-group btn-group-vertical",
components: [ {
kind: enyo.Button,
name: "btnStepUp_" + e,
classes: "btn btn-mini",
ontap: "moveStepUp",
components: [ {
tag: "i",
name: "btnStepUp_" + e + "Icon",
classes: "icon-chevron-up"
} ]
}, {
kind: enyo.Button,
name: "btnStepDown_" + e,
classes: "btn btn-mini",
ontap: "moveStepDown",
components: [ {
tag: "i",
name: "btnStepDown_" + e + "Icon",
classes: "icon-chevron-down"
} ]
} ]
} ]
} ]
} ]
}, {
owner: this
}), this.$["preview_" + e].setProperty("src", Settings.WEBAPP + "/" + this.linked.options.zoomSteps[e].split("&zoom=")[0]);
this.$.zoomList.render();
},
deleteZoomStep: function(e, t) {
var n = parseInt(e.name.split("_")[1]);
this.linked.options.zoomSteps.splice(n, 1), this.updateZoomSteps();
},
moveStepUp: function(e, t) {
var n = parseInt(e.name.split("_")[1]), r = n - 1;
if (n > 0) {
var i = this.linked.options.zoomSteps[n];
this.linked.options.zoomSteps[n] = this.linked.options.zoomSteps[r], this.linked.options.zoomSteps[r] = i, this.updateZoomSteps();
}
},
moveStepDown: function(e, t) {
var n = parseInt(e.name.split("_")[1]), r = n + 1, i = this.linked.options.zoomSteps.length - 1;
if (n < i) {
var s = this.linked.options.zoomSteps[n];
this.linked.options.zoomSteps[n] = this.linked.options.zoomSteps[r], this.linked.options.zoomSteps[r] = s, this.updateZoomSteps();
}
}
});

// EigenschappenPickAndPlaceWords.js

enyo.kind({
name: "educate.create.view.eigenschappen.EigenschappenPickAndPlaceWords",
kind: "educate.create.view.eigenschappen.Eigenschappen",
tag: "div",
classes: "PropertiesPickAndPlaceWords",
published: {
pNumberOfQuizItems: "",
pAlphaZones: ""
},
components: [ {
name: "basicProperties",
classes: "form-horizontal",
components: [ {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "layername",
label: "naam: ",
inputPlaceholder: "naam van de laag",
value: this.pLayername,
linkedProp: "layername",
linkable: !1,
onchange: "propertiesChanged"
} ]
}, {
tag: "h4",
content: "Extra eigenschappen",
linkblok: "blokExtraEnButtons",
ontap: "togglePropBlock"
}, {
name: "blokExtraEnButtons",
components: [ {
name: "extraProperties",
classes: "form-horizontal",
components: []
}, {
name: "buttons",
classes: "form-horizontal",
components: []
} ]
} ],
create: function() {
this.inherited(arguments), this.generatePickAndPlaceProps();
},
rendered: function() {
this.inherited(arguments), this.$.width && this.pWidthChanged(), this.$.height && this.pHeightChanged();
},
generatePickAndPlaceProps: function() {
this.svgSource = this.linked.value, this.pNumberOfQuizItems = this.linked.getNumberOfQuizItems(), this.pAlphaZones = this.linked.getAlphaZones();
var e = {
practise: 0,
test: 1,
quiz: 2
}, t = e[this.linked.getModus()];
this.generateExtraFields([ {
label: "Aantal items in quiz",
name: "numberOfQuizItems",
value: "pNumberOfQuizItems",
placeholder: "",
linkable: !1
}, {
label: "Alpha zones",
name: "alphaZones",
value: "pAlphaZones",
placeholder: "",
linkable: !1
} ]), this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
tag: "label",
content: "Standaard mode",
classes: "control-label"
}, {
classes: "controls",
components: [ {
kind: "enyo.Select",
name: "selectDefaultModus",
selected: t,
onchange: "selectDefaultModusChanged",
components: [ {
content: "Oefenen",
value: "practise"
}, {
content: "Test",
value: "test"
}, {
content: "Quiz",
value: "quiz"
} ]
} ]
} ]
}, {
owner: this
}), this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkHighlightZone",
checked: this.linked.highlightZone,
onchange: "changeHighlightZone",
content: "Zone opgeven"
} ]
} ]
} ]
}, {
owner: this
}), this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkRemovePickObjectsByTest",
checked: this.linked.removePickObjectsByTest,
onchange: "changeRemovePickObjectsByTest",
content: "Verwijder items bij test"
} ]
} ]
} ]
}, {
owner: this
}), this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkRemovePickObjectsByPractise",
checked: this.linked.removePickObjectsByPractise,
onchange: "changeRemovePickObjectsByPractise",
content: "Verwijder items bij oefenen"
} ]
} ]
} ]
}, {
owner: this
}), this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkShowUnusedDropZones",
checked: this.linked.unusedDropZoneShowing,
onchange: "changeShowUnusedDropZones",
content: "Toon ongebruikte dropzones"
} ]
} ]
} ]
}, {
owner: this
}), this.$.buttons.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
kind: "enyo.Button",
classes: "btn btn-block",
name: "browseSvgAsset",
ontap: "browseSvg",
content: "kies SVG"
} ]
} ]
}, {
owner: this
});
},
updatePropertiesHandler: function(e, t) {
this.inherited(arguments), this.render();
},
selectDefaultModusChanged: function(e, t) {
this.linked.setModus(e.getValue());
},
changeHighlightZone: function(e, t) {
this.linked.setHighlightZone(this.$.chkHighlightZone.getChecked());
},
changeRemovePickObjectsByTest: function(e, t) {
this.linked.setRemovePickObjectsByTest(this.$.chkRemovePickObjectsByTest.getChecked());
},
changeRemovePickObjectsByPractise: function(e, t) {
this.linked.setRemovePickObjectsByPractise(this.$.chkRemovePickObjectsByPractise.getChecked());
},
changeShowUnusedDropZones: function(e, t) {
this.linked.setUnusedDropZoneShowing(this.$.chkShowUnusedDropZones.getChecked());
},
propertiesChanged: function(e, t) {
this.inherited(arguments), this.$.browseSvgAsset && this.$.library && this.$.library.getSelectedAsset() !== "" && this.linked.setValueFromProperties(this.$.library.getSelectedAsset()), this.sendChangedEvent();
}
});

// EigenschappenPickAndPlaceImages.js

enyo.kind({
name: "educate.create.view.eigenschappen.EigenschappenPickAndPlaceImages",
kind: "educate.create.view.eigenschappen.Eigenschappen",
tag: "div",
classes: "PropertiesPickAndPlaceImages",
published: {
pNumberOfQuizItems: "",
pAlphaZones: "",
pDropMargin: ""
},
components: [ {
name: "basicProperties",
classes: "form-horizontal",
components: [ {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "layername",
label: "naam: ",
inputPlaceholder: "naam van de laag",
value: this.pLayername,
linkedProp: "layername",
linkable: !1,
onchange: "propertiesChanged"
} ]
}, {
tag: "h4",
content: "Extra eigenschappen",
linkblok: "blokExtraEnButtons",
ontap: "togglePropBlock"
}, {
name: "blokExtraEnButtons",
components: [ {
name: "extraProperties",
classes: "form-horizontal",
components: []
}, {
name: "buttons",
classes: "form-horizontal",
components: []
} ]
} ],
create: function() {
this.inherited(arguments), this.generatePickAndPlaceProps();
},
rendered: function() {
this.inherited(arguments), this.$.width && this.pWidthChanged(), this.$.height && this.pHeightChanged();
},
generatePickAndPlaceProps: function() {
this.svgSource = this.linked.value, this.pNumberOfQuizItems = this.linked.getNumberOfQuizItems(), this.pAlphaZones = this.linked.getAlphaZones(), this.pDropMargin = this.linked.getDropMargin();
var e = {
practise: 0,
test: 1,
quiz: 2
}, t = e[this.linked.getModus()];
this.generateExtraFields([ {
label: "Aantal items in quiz",
name: "numberOfQuizItems",
value: "pNumberOfQuizItems",
placeholder: "",
linkable: !1
}, {
label: "Alpha zones",
name: "alphaZones",
value: "pAlphaZones",
placeholder: "",
linkable: !1
}, {
label: "Drop margin",
name: "dropMargin",
value: "pDropMargin",
placeholder: "",
linkable: !1
} ]), this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
tag: "label",
content: "Standaard mode",
classes: "control-label"
}, {
classes: "controls",
components: [ {
kind: "enyo.Select",
name: "selectDefaultModus",
selected: t,
onchange: "selectDefaultModusChanged",
components: [ {
content: "Oefenen",
value: "practise"
}, {
content: "Test",
value: "test"
}, {
content: "Quiz",
value: "quiz"
} ]
} ]
} ]
}, {
owner: this
}), this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkHighlightZone",
checked: this.linked.highlightZone,
onchange: "changeHighlightZone",
content: "Zone opgeven"
} ]
} ]
} ]
}, {
owner: this
}), this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkRemovePickObjectsByTest",
checked: this.linked.removePickObjectsByTest,
onchange: "changeRemovePickObjectsByTest",
content: "Verwijder items bij test"
} ]
} ]
} ]
}, {
owner: this
}), this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkRemovePickObjectsByPractise",
checked: this.linked.removePickObjectsByPractise,
onchange: "changeRemovePickObjectsByPractise",
content: "Verwijder items bij oefenen"
} ]
} ]
} ]
}, {
owner: this
}), this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkShowUnusedDropZones",
checked: this.linked.unusedDropZoneShowing,
onchange: "changeShowUnusedDropZones",
content: "Toon ongebruikte dropzones"
} ]
} ]
} ]
}, {
owner: this
}), this.$.buttons.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
kind: "enyo.Button",
classes: "btn btn-block",
name: "browseSvgAsset",
ontap: "browseSvg",
content: "kies SVG"
} ]
} ]
}, {
owner: this
});
},
updatePropertiesHandler: function(e, t) {
this.inherited(arguments), this.render();
},
selectDefaultModusChanged: function(e, t) {
this.linked.setModus(e.getValue());
},
changeHighlightZone: function(e, t) {
this.linked.setHighlightZone(this.$.chkHighlightZone.getChecked());
},
changeRemovePickObjectsByTest: function(e, t) {
this.linked.setRemovePickObjectsByTest(this.$.chkRemovePickObjectsByTest.getChecked());
},
changeRemovePickObjectsByPractise: function(e, t) {
this.linked.setRemovePickObjectsByPractise(this.$.chkRemovePickObjectsByPractise.getChecked());
},
changeShowUnusedDropZones: function(e, t) {
this.linked.setUnusedDropZoneShowing(this.$.chkShowUnusedDropZones.getChecked());
},
propertiesChanged: function(e, t) {
this.inherited(arguments), this.$.browseSvgAsset && this.$.library && this.$.library.getSelectedAsset() !== "" && this.linked.setValueFromProperties(this.$.library.getSelectedAsset()), this.sendChangedEvent();
}
});

// EigenschappenKolomWoorden.js

enyo.kind({
name: "educate.create.view.eigenschappen.EigenschappenKolomWoorden",
kind: "educate.create.view.eigenschappen.Eigenschappen",
tag: "div",
classes: "PropertiesKolomWoorden",
published: {},
create: function() {
this.inherited(arguments), this.generateColumnProps();
},
rendered: function() {
this.inherited(arguments);
},
generateColumnProps: function() {
this.$.buttons.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
content: "Aantal kolommen",
classes: "control-label"
}, {
kind: "enyo.Input",
name: "columnAmount",
classes: "enyo-input",
type: "text",
value: this.linked.options.columns,
onchange: "changeColumns"
} ]
} ]
}, {
owner: this
}), this.$.buttons.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
content: "Max aantal woorden",
classes: "control-label"
}, {
kind: "enyo.Input",
name: "wordAmount",
classes: "enyo-input",
type: "text",
value: this.linked.options.maxWords,
onchange: "changeWordAmount"
} ]
} ]
}, {
owner: this
}), this.$.buttons.render();
},
changeColumns: function(e, t) {
if (parseInt(e.node.value) <= 6 && parseInt(e.node.value) >= 2) {
this.linked.options.columns = parseInt(e.node.value);
var n = this.linked.options.titles[this.linked.options.titles.length - 1];
this.linked.options.titles.length = 0;
for (var r = 0; r < e.node.value; r++) this.linked.options.titles[r] = "Titel";
this.linked.options.titles[parseInt(e.node.value)] = n;
var i = this.linked.words.length, s = parseInt(e.node.value);
if (i > s) for (var o = 1; o <= i - s; o++) this.linked.words.splice(i - o, 1);
this.linked.drawPlaceColumns();
}
},
changeWordAmount: function(e, t) {
var n = parseInt(e.node.value);
n > 0 && n <= 40 ? this.linked.options.maxWords = n : this.linked.options.maxWords = 40, this.linked.drawPlaceColumns();
}
});

// EigenschappenKolomAfbeeldingen.js

enyo.kind({
name: "educate.create.view.eigenschappen.EigenschappenKolomAfbeeldingen",
kind: "educate.create.view.eigenschappen.Eigenschappen",
tag: "div",
classes: "PropertiesKolomWoorden",
published: {},
create: function() {
this.inherited(arguments), this.generateColumnProps();
},
rendered: function() {
this.inherited(arguments);
},
generateColumnProps: function() {
this.$.buttons.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
content: "Aantal kolommen",
classes: "control-label"
}, {
kind: "enyo.Input",
name: "columnAmount",
classes: "enyo-input",
type: "text",
value: this.linked.options.columns,
onchange: "changeColumns"
} ]
} ]
}, {
owner: this
}), this.$.buttons.render();
},
changeColumns: function(e, t) {
if (parseInt(e.node.value) <= 6 && parseInt(e.node.value) >= 2) {
this.linked.options.columns = parseInt(e.node.value);
var n = this.linked.options.titles[this.linked.options.titles.length - 1];
this.linked.options.titles.length = 0;
for (var r = 0; r < e.node.value; r++) this.linked.options.titles[r] = "Titel";
this.linked.options.titles[parseInt(e.node.value)] = n;
var i = this.linked.images.length, s = parseInt(e.node.value);
if (i > s) for (var o = 1; o <= i - s; o++) this.linked.images.splice(i - o, 1);
this.linked.drawPlaceColumns();
}
}
});

// EigenschappenDropdown.js

enyo.kind({
name: "educate.create.view.eigenschappen.EigenschappenDropdown",
kind: "educate.create.view.eigenschappen.Eigenschappen",
tag: "div",
published: {
selectOptions: []
},
create: function() {
this.inherited(arguments), this.selectOptions = this.linked.options.selectOptions, this.generateDropdownProps(), this.updateList();
},
rendered: function() {
this.inherited(arguments);
},
generateDropdownProps: function() {
this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkSolutionType",
checked: this.linked.options.automaticSolution,
onchange: "changeSolutionType",
content: "Automatische oplossing"
} ]
} ]
} ]
}, {
owner: this
}), this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkOpenDirectionUp",
checked: this.linked.options.openDirectionUp,
onchange: "changeOpenDirectionUp",
content: "Open naar boven"
} ]
} ]
} ]
}, {
owner: this
}), this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkShowOptions",
checked: this.linked.options.showOptions,
onchange: "changeShowOptions",
content: "Opties weergeven"
} ]
} ]
} ]
}, {
owner: this
}), this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkShuffleAnswers",
checked: this.linked.options.shuffleAnswers,
onchange: "changeShuffleAnswers",
content: "Shuffle antwoorden"
} ]
} ]
} ]
}, {
owner: this
}), this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkStartWithChoose",
checked: this.linked.options.startWithChoose,
onchange: "changeStartWithChoose",
content: 'Begin met "kies..."'
} ]
} ]
} ]
}, {
owner: this
}), this.$.extraProperties.createComponent({
name: "extraOptions",
tag: "div"
}, {
owner: this
}), this.$.extraProperties.createComponent({
components: [ {
classes: "newOptie",
components: [ {
kind: enyo.Button,
classes: "btn",
name: "btnAddOptie",
ontap: "addNewOption",
components: [ {
tag: "i",
name: "btnAddIcon",
classes: "icon-plus"
} ]
} ]
} ]
}, {
owner: this
});
},
updateList: function() {
this.$.extraOptions.destroyClientControls(), this.$.extraOptions.createComponent({
name: "formOpties",
classes: "formOpties",
components: [ {
classes: "optieRow",
components: [ {
tag: "label",
classes: "labelText",
content: "text"
}, {
tag: "label",
classes: "labelValue",
content: "value"
}, {
tag: "label",
classes: "labelCorrect",
components: [ {
tag: "i",
classes: "icon-check"
} ]
}, {
tag: "i",
classes: "icon-trash"
} ]
} ]
}, {
owner: this
});
for (var e in this.selectOptions) this.createComponent({
classes: "optieRow",
container: this.$.formOpties,
components: [ {
kind: "enyo.Input",
value: this.selectOptions[e].text,
name: "optieText_" + e,
placeholder: "label",
classes: "option-text",
onblur: "updateOptieText"
}, {
kind: "enyo.Input",
value: this.selectOptions[e].value,
name: "optieValue_" + e,
classes: "optieValue",
onblur: "updateOptieValue"
}, {
kind: "enyo.Checkbox",
classes: "option-correct",
name: "chkCorrect_" + e,
checked: this.selectOptions[e].correct,
onchange: "changeCorrect"
}, {
kind: enyo.Button,
classes: "btn",
name: "btnDelete_" + e,
ontap: "deleteOption",
components: [ {
tag: "i",
name: "btnDelete_" + e + "icon",
classes: "icon-trash"
} ]
} ]
}, {
owner: this
});
this.render();
},
addNewOption: function(e, t) {
var n = this.selectOptions.length;
this.selectOptions[n] = {
text: "",
value: 0,
correct: !1
}, this.linked.selectOptions = this.selectOptions, this.linked.updateDropdown(), this.updateList(), this.$["optieText_" + n].focus();
},
checkWordInSelectOptions: function(e) {
var t = this.selectOptions.length;
for (var n = 0; n < t; n++) if (this.selectOptions[n].text === e) return !0;
return !1;
},
deleteOption: function(e, t) {
var n = e.name.split("_")[1];
this.selectOptions.splice(n, 1), this.linked.selectOptions = this.selectOptions, this.linked.updateDropdown(), this.updateList();
},
updateOptieText: function(e, t) {
var n = e.name.split("_")[1], r = e.getValue();
this.checkWordInSelectOptions(r) ? r != this.selectOptions[n].text && (e.addClass("option-error"), e.setValue("")) : (this.selectOptions[n].text = r, this.linked.selectOptions = this.selectOptions, this.linked.updateDropdown(), this.updateList());
},
updateOptieValue: function(e, t) {
var n = e.name.split("_")[1];
this.selectOptions[n].value = e.getValue(), this.linked.selectOptions = this.selectOptions, this.linked.updateDropdown(), this.updateList();
},
changeCorrect: function(e, t) {
var n = e.name.split("_")[1];
this.selectOptions[n].correct = e.getChecked(), this.linked.selectOptions = this.selectOptions, this.linked.updateDropdown(), this.updateList();
},
changeSolutionType: function(e, t) {
this.linked.automaticSolution = this.$.chkSolutionType.getChecked(), this.linked.updateDropdown();
},
changeOpenDirectionUp: function(e, t) {
this.linked.setOpenDirectionUp(this.$.chkOpenDirectionUp.getChecked()), this.linked.addPropertiesToOptions();
},
changeShowOptions: function(e, t) {
this.linked.setShowOptions(this.$.chkShowOptions.getChecked()), this.linked.addPropertiesToOptions();
},
changeShuffleAnswers: function(e, t) {
this.linked.setShuffleAnswers(this.$.chkShuffleAnswers.getChecked()), this.linked.addPropertiesToOptions();
},
changeStartWithChoose: function(e, t) {
this.linked.setStartWithChoose(this.$.chkStartWithChoose.getChecked()), this.linked.addPropertiesToOptions();
}
});

// EigenschappenFlipcard.js

enyo.kind({
name: "educate.create.view.eigenschappen.EigenschappenFlipcard",
kind: "educate.create.view.eigenschappen.Eigenschappen",
tag: "div",
published: {},
create: function() {
this.inherited(arguments), this.selectOptions = this.linked.options.selectOptions, this.generateFlipcardProps();
},
rendered: function() {
this.inherited(arguments);
},
generateFlipcardProps: function() {
this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
classes: "radio",
components: [ {
kind: "onyx.RadioGroup",
name: "radioGroup",
onActivate: "changeBackSide",
components: [ {
content: "Tekst",
name: "cText",
active: this.linked.options.currentBackSide == "Tekst" ? !0 : !1
}, {
content: "Afbeelding",
name: "cImage",
active: this.linked.options.currentBackSide == "Afbeelding" ? !0 : !1
} ]
} ]
} ]
} ]
}, {
owner: this
}), this.$.extraProperties.createComponent({
classes: "control-group",
name: "textGroup",
components: [ {
classes: "controls",
components: [ {
kind: "enyo.Input",
name: "optionText",
type: "text",
onchange: "changeBackText"
} ]
} ]
}, {
owner: this
}), this.$.extraProperties.createComponent({
classes: "control-group",
name: "imageGroup",
components: [ {
classes: "controls",
components: [ {
kind: "enyo.Button",
classes: "btn btn-block",
name: "browseImageAsset",
ontap: "browseFoto",
content: "kies afbeelding"
} ]
} ]
}, {
owner: this
}), this.$.optionText.setValue(this.linked.options.backText), this.$.textGroup.hide(), this.$.imageGroup.hide(), this.$.buttons.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
kind: "enyo.Button",
classes: "btn btn-block",
name: "flipPreview",
ontap: "doFlipPreview",
content: "toon preview"
} ]
} ]
}, {
owner: this
});
},
changeBackSide: function(e, t) {
if (t.originator.getActive()) switch (t.originator.getContent()) {
case "Tekst":
this.$.imageGroup.hide(), this.$.textGroup.show(), this.linked.options.currentBackSide = t.originator.getContent(), this.linked.propertyChanged();
break;
case "Afbeelding":
this.$.textGroup.hide(), this.$.imageGroup.show(), this.linked.options.currentBackSide = t.originator.getContent(), this.linked.propertyChanged();
break;
default:
console.log("Something went wrong");
}
},
changeBackText: function(e, t) {
this.linked.options.backText = e.node.value, this.linked.propertyChanged();
},
propertiesChanged: function(e, t) {
this.inherited(arguments), this.getWidth == "auto" && (this.linked.autoWidth = !0), this.$.browseImageAsset && this.$.library && this.$.library.getSelectedAsset() != "" && (this.linked.options.backImage = this.$.library.getSelectedAsset().value, this.linked.propertyChanged()), this.sendChangedEvent();
},
doFlipPreview: function() {
this.linked.doFlipPreview();
}
});

// EigenschappenWebsite.js

enyo.kind({
name: "educate.create.view.eigenschappen.EigenschappenWebsite",
kind: "educate.create.view.eigenschappen.Eigenschappen",
tag: "div",
published: {},
create: function() {
this.inherited(arguments), this.selectOptions = this.linked.options.selectOptions, this.generateWebFrameProps();
},
rendered: function() {
this.inherited(arguments);
},
generateWebFrameProps: function() {
this.$.extraProperties.createComponent({
classes: "control-group",
name: "textGroup",
components: [ {
classes: "controls",
components: [ {
tag: "label",
content: "Url",
classes: "control-label"
}, {
kind: "enyo.Input",
name: "urlText",
type: "text",
onchange: "changeUrl"
} ]
} ]
}, {
owner: this
}), this.$.urlText.setValue(this.linked.options.url);
},
changeUrl: function(e, t) {
this.linked.options.url = e.node.value, this.linked.propertyChanged();
}
});

// EigenschappenMap.js

enyo.kind({
name: "educate.create.view.eigenschappen.EigenschappenMap",
kind: "educate.create.view.eigenschappen.Eigenschappen",
tag: "div",
published: {
pHuidigeLocatie: "",
pAdres: ""
},
create: function() {
this.inherited(arguments), this.generateMapProps();
},
rendered: function() {
this.inherited(arguments), this.setInputReadonly();
},
generateMapProps: function() {
this.pAdres = this.linked.getAdres(), this.pHuidigeLocatie = this.linked.getBHuidigeLocatie();
var e = {
roadmap: 0,
satellite: 1,
hybrid: 2,
terrain: 3
}, t = e[this.linked.getMapType()];
this.generateExtraFields([ {
label: "Adres",
name: "adres",
value: "pAdres",
placeholder: "",
linkable: !1
} ]), this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkHuidigeLocatie",
checked: this.getPHuidigeLocatie(),
onchange: "chkHuidigeLocatieHandler",
content: "Huidige locatie"
} ]
} ]
} ]
}, {
owner: this
}), this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
tag: "label",
content: "Kaarttype",
classes: "control-label"
}, {
classes: "controls",
components: [ {
kind: "enyo.Select",
name: "selectMapType",
selected: t,
onchange: "selectMapTypeChanged",
components: [ {
content: "Kaart",
value: "roadmap"
}, {
content: "Satelliet",
value: "satellite"
}, {
content: "Hybrid",
value: "hybrid"
}, {
content: "Terrain",
value: "terrain"
} ]
} ]
} ]
}, {
owner: this
});
},
chkHuidigeLocatieHandler: function(e, t) {
this.setPHuidigeLocatie(this.$.chkHuidigeLocatie.getChecked());
},
pHuidigeLocatieChanged: function() {
this.getLinked().setBHuidigeLocatie(this.getPHuidigeLocatie()), this.setInputReadonly(), this.propertiesChanged();
},
setInputReadonly: function() {
this.getPHuidigeLocatie() ? this.$.adres.setInputReadonly() : this.$.adres.setInputWritable();
},
selectMapTypeChanged: function(e, t) {
this.linked.setMapType(e.getValue());
},
propertiesChanged: function(e, t) {
this.inherited(arguments), this.sendChangedEvent();
}
});

// EigenschappenYoutube.js

enyo.kind({
name: "educate.create.view.eigenschappen.EigenschappenYoutube",
kind: "educate.create.view.eigenschappen.Eigenschappen",
tag: "div",
published: {
pVideoUrl: ""
},
create: function() {
this.inherited(arguments), this.generateYoutubeProps();
},
rendered: function() {
this.inherited(arguments);
},
generateYoutubeProps: function() {
this.pVideoUrl = this.linked.getVideoUrl(), this.generateExtraFields([ {
label: "Youtube link",
name: "videoUrl",
value: "pVideoUrl",
placeholder: "",
linkable: !1
} ]);
},
propertiesChanged: function(e, t) {
this.inherited(arguments), this.sendChangedEvent();
}
});

// Eigenschappen3DObject.js

enyo.kind({
name: "educate.create.view.eigenschappen.Eigenschappen3DObject",
kind: "educate.create.view.eigenschappen.Eigenschappen",
tag: "div",
classes: "Properties3DObject",
published: {},
create: function() {
this.inherited(arguments), this.generate3DObjectProps();
var e = this.$.basicProperties.children.length;
for (var t = 5; t < e - 1; t++) this.$.basicProperties.children[6].destroy();
this.$.control9.destroy(), this.$.control10.destroy(), this.$.limieten.destroy();
},
rendered: function() {
this.inherited(arguments);
},
generate3DObjectProps: function() {
this.$.buttons.createComponents([ {
tag: "h5",
content: "Belichting",
linkblok: "blokExtraBelichting",
ontap: "togglePropBlock"
}, {
name: "blokExtraBelichting",
components: [ {
name: "belichtingProperties",
classes: "form-horizontal",
components: []
}, {
name: "belichtingButtons",
classes: "form-horizontal",
components: []
} ]
} ]), this.$.buttons.createComponents([ {
tag: "h5",
content: "Scene",
linkblok: "blokExtraScene",
ontap: "togglePropBlock"
}, {
name: "blokExtraScene",
components: [ {
name: "sceneProperties",
classes: "form-horizontal",
components: []
}, {
name: "sceneButtons",
classes: "form-horizontal",
components: []
} ]
} ]), this.$.buttons.$.belichtingProperties.createComponent({
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
disabled: !0,
name: "chkToggleSpot",
checked: this.linked.options.spotLightOn,
content: "toggle spotlight",
onchange: "toggleSpotlight"
} ]
} ]
} ]
}, {
owner: this
}), this.$.buttons.$.belichtingProperties.createComponent({
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkToggleHemi",
checked: this.linked.options.hemiLightOn,
content: "toggle omgevingslicht",
onchange: "toggleHemi"
} ]
} ]
} ]
}, {
owner: this
}), this.$.buttons.$.sceneProperties.createComponent({
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkToggleGround",
checked: this.linked.options.groundOn,
content: "toggle ground",
onchange: "toggleGround"
} ]
} ]
} ]
}, {
owner: this
}), this.$.buttons.$.sceneProperties.createComponent({
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
kind: "enyo.Button",
classes: "btn btn-block",
name: "browseModelAsset",
ontap: "browseModel",
content: "kies model"
} ]
} ]
}, {
owner: this
});
},
toggleGround: function(e, t) {
this.linked.options.groundOn = this.$.chkToggleGround.getChecked(), this.linked.propertyChanged();
},
toggleSpotlight: function(e, t) {
this.linked.options.spotLightOn = this.$.chkToggleSpot.getChecked(), this.linked.propertyChanged();
},
toggleHemi: function(e, t) {
this.linked.options.hemiLightOn = this.$.chkToggleHemi.getChecked(), this.linked.propertyChanged();
},
propertiesChanged: function(e, t) {
this.inherited(arguments);
if (this.$.browseModelAsset && this.$.library && this.$.library.getSelectedAsset() != null) {
var n = this.$.library.getSelectedAsset().value, r = ".dae";
n.indexOf(r, n.length - r.length) !== -1 && (this.linked.modelName = this.$.library.getSelectedAsset().options, this.linked.modelUrl = this.$.library.getSelectedAsset().value, this.linked.modelUrlChanged());
}
this.sendChangedEvent();
}
});

// Eigenschappen3DMesh.js

enyo.kind({
name: "educate.create.view.eigenschappen.Eigenschappen3DMesh",
kind: "educate.create.view.eigenschappen.Eigenschappen",
tag: "div",
classes: "PropertiesImage",
published: {
linked: "",
layer: "",
visible: !0,
pLayername: "",
pPosX: 0,
pPosY: 0,
pPosZ: 0,
pRotX: 0,
pRotY: 0,
pRotZ: 0,
pPosLimit: !1,
pScale: 0,
texture: ""
},
components: [ {
name: "basicProperties",
classes: "form-horizontal",
components: [ {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: "naam:"
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
classes: "",
name: "input",
value: this.pLayername,
onchange: "inputChanged",
type: "text",
disabled: !0
} ]
} ]
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "pPosX",
inputType: "number",
label: "positie x: ",
inputPlaceholder: "",
value: this.pPosX,
linkedProp: "pPosX",
linkable: !0,
onchange: "inputChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "pPosY",
inputType: "number",
label: "positie y: ",
inputPlaceholder: "",
value: this.pPosY,
linkedProp: "pPosY",
linkable: !0,
onchange: "inputChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "pPosZ",
inputType: "number",
label: "positie z: ",
inputPlaceholder: "",
value: this.pPosZ,
linkedProp: "pPosZ",
linkable: !0,
onchange: "inputChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "pRotX",
inputType: "number",
label: "rotatie x: ",
inputPlaceholder: "",
value: this.pRotX,
linkedProp: "pRotX",
linkable: !0,
onchange: "inputChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "pRotY",
inputType: "number",
label: "rotatie y: ",
inputPlaceholder: "",
value: this.pRotY,
linkedProp: "pRotY",
linkable: !0,
onchange: "inputChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "pRotZ",
inputType: "number",
label: "rotatie z: ",
inputPlaceholder: "",
value: this.pRotZ,
linkedProp: "pRotZ",
linkable: !0,
onchange: "inputChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: "Schaal:"
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
classes: "",
name: "scale",
value: this.pScale,
onchange: "inputChanged",
type: "text"
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkZichtbaar",
checked: this.visible,
content: "zichtbaar",
onchange: "visibleChanged"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
kind: "enyo.Button",
classes: "btn btn-block",
name: "browseTextureAsset",
ontap: "browseTexture",
content: "kies texture"
} ]
} ]
}, {
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
kind: "enyo.Button",
classes: "btn btn-block",
name: "centerObject",
ontap: "centerObject",
content: "focus op object"
} ]
} ]
} ]
} ],
create: function() {
this.inherited(arguments), this.pLayername = this.linked.name;
var e = this.linked;
this.visible = Boolean(e.visible), this.pPosLimit = Boolean(e.pPosLimit), this.pPosX = parseInt(e.pPosX), this.pPosY = parseInt(e.pPosY), this.pPosZ = parseInt(e.pPosZ), this.pRotX = parseFloat(e.pRotX) / 2 / Math.PI * 360, this.pRotY = parseFloat(e.pRotY) / 2 / Math.PI * 360, this.pRotZ = parseFloat(e.pRotZ) / 2 / Math.PI * 360, this.texture = e.texture, this.pScale = parseFloat(e.pScale), this.setValues();
},
rendered: function() {
this.inherited(arguments);
},
setValues: function() {
this.$.input.setValue(this.pLayername), this.$.chkZichtbaar.setChecked(this.visible), this.$.pPosX.setValue(this.pPosX), this.$.pPosY.setValue(this.pPosY), this.$.pPosZ.setValue(this.pPosZ), this.$.pRotX.setValue(this.pRotX), this.$.pRotY.setValue(this.pRotY), this.$.pRotZ.setValue(this.pRotZ), this.$.scale.setValue(this.pScale);
},
inputChanged: function(e, t) {
switch (e.name) {
case "pPosX":
console.log(e), this.pPosX = e.value;
break;
case "pPosY":
this.pPosY = e.value;
break;
case "pPosZ":
this.pPosZ = e.value;
break;
case "pRotX":
this.pRotX = e.value;
break;
case "pRotY":
this.pRotY = e.value;
break;
case "pRotZ":
this.pRotZ = e.value;
break;
case "scale":
this.pScale = e.node.value;
break;
default:
console.log("Wrong input value");
}
this.setActiveMeshParameters();
},
visibleChanged: function(e, t) {
this.visible = this.$.chkZichtbaar.getChecked(), this.setActiveMeshParameters();
},
selectTexture: function(e, t) {
this.$.browseTextureAsset && this.$.library && this.$.library.getSelectedAsset() != null && (this.texture = this.$.library.getSelectedAsset().value), this.setActiveMeshTexture();
},
centerObject: function(e, t) {
var n = new THREE.Vector3(this.pPosX + 20, this.pPosY, this.pPosZ), r = new THREE.Vector3(this.pPosX, this.pPosY, this.pPosZ);
this.linked.parent.centerOnObject(n, r);
},
setActiveMeshParameters: function() {
var e = this.linked;
e.visible = this.visible, e.pPosLimit = this.pPosLimit, e.pPosX = parseInt(this.pPosX), e.pPosY = parseInt(this.pPosY), e.pPosZ = parseInt(this.pPosZ), e.pRotX = parseFloat(this.pRotX) / 360 * 2 * Math.PI, e.pRotY = parseFloat(this.pRotY) / 360 * 2 * Math.PI, e.pRotZ = parseFloat(this.pRotZ) / 360 * 2 * Math.PI, e.pScale = parseFloat(this.pScale), this.linked.setMeshProperties(this.linked.mesh), this.linked.parent.renderScene();
},
setActiveMeshTexture: function() {
var e = this.linked;
e.texture = this.texture, this.linked.setMeshMaterial(this.linked.mesh);
}
});

// Eigenschappen3DCamera.js

enyo.kind({
name: "educate.create.view.eigenschappen.Eigenschappen3DCamera",
kind: "educate.create.view.eigenschappen.Eigenschappen",
tag: "div",
classes: "Properties3DObject",
published: {},
components: [ {
name: "basicProperties",
classes: "form-horizontal",
components: [ {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: "naam:"
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
classes: "",
name: "input",
value: "",
onchange: "inputChanged",
type: "text",
disabled: !0
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: "positie x:"
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
classes: "",
name: "camPosition_x",
onchange: "camChanged",
type: "text"
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: "positie y:"
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
classes: "",
name: "camPosition_y",
onchange: "camChanged",
type: "text"
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: "positie z:"
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
classes: "",
name: "camPosition_z",
onchange: "camChanged",
type: "text"
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: "richting x:"
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
classes: "",
name: "camTarget_x",
onchange: "camChanged",
type: "text"
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: "richting y:"
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
classes: "",
name: "camTarget_y",
onchange: "camChanged",
type: "text"
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: "richting z:"
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
classes: "",
name: "camTarget_z",
onchange: "camChanged",
type: "text"
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkZoomCamera",
content: "camera zoom",
onchange: "zoomCameraChanged"
} ]
} ]
} ]
}, {
name: "limitZoom",
classes: "control-group",
components: [ {
tag: "label",
content: "min max: ",
classes: "control-label"
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
name: "limitZoomMin",
onchange: "limitChanged",
type: "text"
}, {
kind: "enyo.Input",
name: "limitZoomMax",
onchange: "limitChanged",
type: "text"
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkRotateCamera",
content: "camera rotatie",
onchange: "rotateCameraChanged"
} ]
} ]
} ]
}, {
name: "limitRotY",
classes: "control-group",
components: [ {
tag: "label",
content: "y min max: ",
classes: "control-label"
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
name: "limitRotYMin",
onchange: "limitChanged",
type: "text"
}, {
kind: "enyo.Input",
name: "limitRotYMax",
onchange: "limitChanged",
type: "text"
} ]
} ]
}, {
name: "limitRotX",
classes: "control-group",
components: [ {
tag: "label",
content: "x min max: ",
classes: "control-label"
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
name: "limitRotXMin",
onchange: "limitChanged",
type: "text"
}, {
kind: "enyo.Input",
name: "limitRotXMax",
onchange: "limitChanged",
type: "text"
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkPanCamera",
content: "camera pannen",
onchange: "panCameraChanged"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
kind: "enyo.Button",
classes: "btn btn-block",
name: "saveCamera",
ontap: "saveCamera",
content: "camerastandpunt vastleggen"
} ]
} ]
}, {
classes: "control-group",
components: [ {
classes: "controls",
components: [ {
kind: "enyo.Button",
classes: "btn btn-block",
name: "previewCamera",
ontap: "previewCamera",
content: "camerastandpunt preview"
} ]
} ]
} ]
} ],
create: function() {
this.inherited(arguments), this.setVal();
},
rendered: function() {
this.inherited(arguments);
},
setVal: function() {
this.$.input.setValue(this.linked.layername);
var e = this.linked.liveCameraPosition, t = this.linked.liveCameraCenter;
this.$.camPosition_x.setValue(e.x), this.$.camPosition_y.setValue(e.y), this.$.camPosition_z.setValue(e.z), this.$.camTarget_x.setValue(t.x), this.$.camTarget_y.setValue(t.y), this.$.camTarget_z.setValue(t.z), this.$.chkZoomCamera.setChecked(this.linked.zoomCamera), this.$.chkRotateCamera.setChecked(this.linked.rotateCamera), this.$.chkPanCamera.setChecked(this.linked.panCamera), this.linked.rotateCamera && (this.$.limitRotY.show(), this.$.limitRotX.show()), this.linked.zoomCamera && this.$.limitZoom.show(), this.$.limitRotYMin.setValue(this.linked.limitRotYMin), this.$.limitRotYMax.setValue(this.linked.limitRotYMax), this.$.limitRotXMin.setValue(this.linked.limitRotXMin), this.$.limitRotXMax.setValue(this.linked.limitRotXMax), this.$.limitZoomMin.setValue(this.linked.limitZoomMin), this.$.limitZoomMax.setValue(this.linked.limitZoomMax);
},
camChanged: function(e, t) {
var n = new THREE.Vector3(parseInt(this.$.camPosition_x.getValue()), parseInt(this.$.camPosition_y.getValue()), parseInt(this.$.camPosition_z.getValue())), r = new THREE.Vector3(parseInt(this.$.camTarget_x.getValue()), parseInt(this.$.camTarget_y.getValue()), parseInt(this.$.camTarget_z.getValue()));
this.linked.liveCameraPosition = n, this.linked.liveCameraCenter = r, this.linked.previewLiveCamera();
},
rotateCameraChanged: function(e, t) {
this.linked.rotateCamera = this.$.chkRotateCamera.getChecked(), this.linked.rotateCamera ? this.$.limitRotY.show() : this.$.limitRotY.hide(), this.linked.camPropertyChanged();
},
limitChanged: function(e, t) {
var n = this.linked.limitRotYMin, r = this.linked.limitRotYMax, i = this.linked.limitRotXMin, s = this.linked.limitRotXMax, o = this.linked.limitZoomMin, u = this.linked.limitZoomMax;
switch (e.name) {
case "limitRotYMin":
n = e.node.value;
break;
case "limitRotYMax":
r = e.node.value;
break;
case "limitRotXMin":
i = e.node.value;
break;
case "limitRotXMax":
s = e.node.value;
break;
case "limitZoomMin":
o = e.node.value;
break;
case "limitZoomMax":
u = e.node.value;
break;
default:
console.log("Wrong input value");
}
this.linked.limitsChanged(n, r, i, s, o, u);
},
zoomCameraChanged: function(e, t) {
this.linked.zoomCamera = this.$.chkZoomCamera.getChecked(), this.linked.zoomCamera ? this.$.limitZoom.show() : this.$.limitZoom.hide(), this.linked.camPropertyChanged();
},
panCameraChanged: function(e, t) {
this.linked.panCamera = this.$.chkPanCamera.getChecked(), this.linked.camPropertyChanged();
},
saveCamera: function(e, t) {
this.linked.instance.propertyCamera(), this.setVal();
},
previewCamera: function(e, t) {
this.linked.instance.previewCamera();
}
});

// EigenschappenKlimatogram.js

enyo.kind({
name: "educate.create.view.eigenschappen.EigenschappenKlimatogram",
kind: "educate.create.view.eigenschappen.Eigenschappen",
tag: "div",
classes: "PropertiesKlimatogram",
published: {
pEditable: !1,
pTemperatureData: [ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ],
pRainfallData: [ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ],
pWarmMonths: [],
pWetMonths: [],
pPlace: "",
pBreedtegraad: 0,
pLengtegraad: 0,
pHoogte: 0,
pTemperatureScaleMax: 100,
pTemperatureScaleMin: -40,
pAutoScaling: !1
},
components: [ {
name: "basicProperties",
classes: "form-horizontal",
components: [ {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "layername",
label: "naam: ",
inputPlaceholder: "naam van de laag",
value: this.pLayername,
linkedProp: "layername",
linkable: !1,
onchange: "propertiesChanged"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "position_x",
inputType: "number",
label: "x: ",
inputPlaceholder: "",
value: this.pPosX,
linkedProp: "position_x",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "position_y",
inputType: "number",
label: "y: ",
inputPlaceholder: "",
value: this.pPosY,
linkedProp: "position_y",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "position_z",
inputType: "number",
label: "z: ",
inputPlaceholder: "",
value: this.pPosZ,
linkedProp: "position_z",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "width",
inputType: "number",
label: "breedte: ",
inputPlaceholder: "",
value: this.pWidth,
linkedProp: "width",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "height",
inputType: "number",
label: "hoogte: ",
inputPlaceholder: "",
value: this.pHeight,
linkedProp: "height",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "rotation_x",
inputType: "number",
label: "rotatie-X: ",
inputPlaceholder: "",
value: 0,
linkedProp: "rotation_x",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "rotation_y",
inputType: "number",
label: "rotatie-Y: ",
inputPlaceholder: "",
value: 0,
linkedProp: "rotation_y",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "rotation_z",
inputType: "number",
label: "rotatie-Z: ",
inputPlaceholder: "",
value: 0,
linkedProp: "rotation_z",
linkable: !0,
onchange: "propertiesChanged",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.components.Origin",
name: "origin",
origin: this.pOrigin,
onOriginChanged: "propertiesChanged"
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkZichtbaar",
checked: !0,
content: "zichtbaar",
onchange: "propertiesChanged"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkActive",
checked: !0,
content: "actief",
onchange: "propertiesChanged"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkLaag",
checked: this.inLayerHolder,
content: "laag",
onchange: "propertiesChanged"
} ]
} ]
} ]
} ]
}, {
tag: "h4",
content: "Limieten",
linkblok: "limieten",
ontap: "togglePropBlock"
}, {
name: "limieten",
classes: "limieten form-horizontal",
components: [ {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "posLimiteren",
checked: this.pIsPosLimiet,
content: "Positie limiteren",
onchange: "chkPosLimietHandler"
} ]
} ]
} ]
}, {
name: "limietPosCon",
classes: "limietCon",
showing: !1,
components: [ {
classes: "control-group",
components: [ {
tag: "label",
content: "x min max: ",
classes: "control-label"
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
name: "posxmin",
value: this.pPosXmin,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentPosXmin",
propvar: "position_x",
inputProperty: "posxmin",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
}, {
kind: "enyo.Input",
name: "posxmax",
value: this.pPosXmax,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentPosXmax",
propvar: "position_x",
inputProperty: "posxmax",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "y min max: ",
classes: "control-label"
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
name: "posymin",
value: this.pPosYmin,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentPosYmin",
propvar: "position_y",
inputProperty: "posymin",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
}, {
kind: "enyo.Input",
name: "posymax",
value: this.pPosYmax,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentPosYmax",
propvar: "position_y",
inputProperty: "posymax",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "z min max: ",
classes: "control-label"
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
name: "poszmin",
value: this.pPosZmin,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentPosZmin",
propvar: "position_z",
inputProperty: "poszmin",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
}, {
kind: "enyo.Input",
name: "poszmax",
value: this.pPosZmax,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentPosZmax",
propvar: "position_z",
inputProperty: "poszmax",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "rotLimiteren",
checked: this.pIsRotLimiet,
content: "Rotatie limiteren",
onchange: "chkRotLimietHandler"
} ]
} ]
} ]
}, {
name: "limietRotCon",
classes: "limietCon",
showing: !1,
components: [ {
classes: "control-group",
components: [ {
tag: "label",
content: "x min max: ",
classes: "control-label"
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
name: "rotxmin",
value: this.pRotXmin,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentRotXmin",
propvar: "rotation_x",
inputProperty: "rotxmin",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
}, {
kind: "enyo.Input",
name: "rotxmax",
value: this.pRotXmax,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentRotXmax",
propvar: "rotation_x",
inputProperty: "rotxmax",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "y min max: ",
classes: "control-label"
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
name: "rotymin",
value: this.pRotYmin,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentRotYmin",
propvar: "rotation_y",
inputProperty: "rotymin",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
}, {
kind: "enyo.Input",
name: "rotymax",
value: this.pRotYmax,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentRotYmax",
propvar: "rotation_y",
inputProperty: "rotymax",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
content: "z min max: ",
classes: "control-label"
}, {
classes: "controls",
components: [ {
kind: "enyo.Input",
name: "rotzmin",
value: this.pRotZmin,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentRotZmin",
propvar: "rotation_z",
inputProperty: "rotzmin",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
}, {
kind: "enyo.Input",
name: "rotzmax",
value: this.pRotZmax,
onchange: "propertiesChanged",
type: "text"
}, {
kind: "enyo.Button",
name: "btnCurrentRotZmax",
propvar: "rotation_z",
inputProperty: "rotzmax",
ontap: "getCurrentPropValue",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
} ]
} ]
} ]
} ]
}, {
tag: "h4",
content: "Extra eigenschappen",
linkblok: "blokExtraEnButtons",
ontap: "togglePropBlock"
}, {
name: "blokExtraEnButtons",
components: [ {
name: "extraProperties",
classes: "form-horizontal",
components: [ {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "place",
label: "Plaats: ",
inputPlaceholder: "Plaats",
value: this.pPlace,
linkedProp: "place",
linkable: !1,
onchange: "pPlaceHandler",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "breedtegraad",
inputType: "number",
label: "breedtegraad: ",
inputPlaceholder: "",
value: this.pBreedtegraad,
linkedProp: "breedtegraad: ",
linkable: !1,
onchange: "pBreedtegraadHandler",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "lengtegraad",
inputType: "number",
label: "lengtegraad: ",
inputPlaceholder: "",
value: this.pLengtegraad,
linkedProp: "lengtegraad",
linkable: !1,
onchange: "pLengtegraadHandler",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "hoogte",
inputType: "number",
label: "hoogte: ",
inputPlaceholder: "",
value: this.pHoogte,
linkedProp: "hoogte",
linkable: !1,
onchange: "pHoogteHandler",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: ""
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkEditable",
onActivate: "pEditableHandler",
content: "invulbaar"
} ]
} ]
} ]
}, {
classes: "control-group",
components: [ {
tag: "label",
classes: "control-label",
content: ""
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
value: !1,
name: "chkAutoScaling",
onActivate: "pAutoScalingHandler",
content: "automatisch schalen"
} ]
} ]
} ]
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "temperatureScaleMax",
inputType: "number",
label: "maximum schaal (temperatuur): ",
inputPlaceholder: "",
value: this.pTemperatureScaleMax,
linkedProp: "temperatureScaleMax",
linkable: !1,
onchange: "pTemperatureScaleMaxHandler",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "temperatureScaleMin",
inputType: "number",
label: "minimum schaal (temperatuur): ",
inputPlaceholder: "",
value: this.pTemperatureScaleMin,
linkedProp: "temperatureScaleMin",
linkable: !1,
onchange: "pTemperatureScaleMinHandler",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
name: "temperature",
classes: "form-horizontal"
}, {
name: "rainfall",
classes: "form-horizontal"
} ]
} ]
} ],
create: function() {
this.inherited(arguments), this.setValues();
for (var e = 0; e < 12; e++) this.$.temperature.createComponent({
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "T" + (e + 1),
inputType: "number",
label: "T" + (e + 1),
inputPlaceholder: "",
value: this.getPTemperatureData()[e],
linkedProp: "T" + (e + 1),
linkable: !0,
onchange: "temperatureDataHandler",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
owner: this
}), this.$.rainfall.createComponent({
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "N" + (e + 1),
inputType: "number",
label: "N" + (e + 1),
inputPlaceholder: "",
value: this.getPRainfallData()[e],
linkedProp: "N" + (e + 1),
linkable: !0,
onchange: "rainfallDataHandler",
onLinkPropValue: "linkPropValue",
onLinkRemoved: "linkRemovedHandler"
}, {
owner: this
});
this.render();
},
setupTemperatureField: function(e, t) {
var n = t.index, r = t.item;
return r.$.TemperatureInput.$.input.setValue(this.getPTemperatureData()[n]), r.$.TemperatureInput.setLabel("T" + (n + 1)), r.$.TemperatureInput.setLinkable(!0), r.$.TemperatureInput.setLinkedProp("T" + (n + 1)), !0;
},
setupRainfallField: function(e, t) {
var n = t.index, r = t.item;
return r.$.RainfallInput.$.input.setValue(this.getPRainfallData()[n]), r.$.RainfallInput.setLabel("N" + (n + 1)), r.$.RainfallInput.setLinkable(!0), r.$.RainfallInput.setLinkedProp("N" + (n + 1)), !0;
},
temperatureDataHandler: function(e, t) {
var n = this.getPTemperatureData();
for (var r = 0; r < 12; r++) n[r] = this.$["T" + (r + 1)].getValue();
return this.propertiesChanged(), !0;
},
rainfallDataHandler: function(e, t) {
var n = this.getPRainfallData();
for (var r = 0; r < 12; r++) n[r] = this.$["N" + (r + 1)].getValue();
return this.propertiesChanged(), !0;
},
renderAllRowsForRepeater: function(e) {
for (var t = 0; t < e.getCount(); t++) e.renderRow(t);
},
pEditableChanged: function() {
this.getLinked().setEditable(this.getPEditable()), this.$.chkEditable.setValue(this.getPEditable());
},
pPlaceChanged: function() {
this.getLinked().setPlace(this.getPPlace()), this.$.place.setValue(this.getPPlace());
},
pHoogteChanged: function() {
this.getLinked().setHoogte(this.getPHoogte()), this.$.hoogte.setValue(this.getPHoogte());
},
pBreedtegraadChanged: function() {
this.getLinked().setBreedtegraad(this.getPBreedtegraad()), this.$.breedtegraad.setValue(this.getPBreedtegraad());
},
pLengtegraadChanged: function() {
this.getLinked().setLengtegraad(this.getPLengtegraad()), this.$.lengtegraad.setValue(this.getPLengtegraad());
},
pTemperatureScaleMaxChanged: function() {
this.getLinked().setTemperatureScaleMax(this.getPTemperatureScaleMax()), this.$.temperatureScaleMax.setValue(this.getPTemperatureScaleMax());
},
pTemperatureScaleMinChanged: function() {
this.getLinked().setTemperatureScaleMin(this.getPTemperatureScaleMin()), this.$.temperatureScaleMin.setValue(this.getPTemperatureScaleMin());
},
pAutoScalingChanged: function() {
this.getLinked().setAutoScaling(this.getPAutoScaling()), this.$.chkAutoScaling.setValue(this.getPAutoScaling());
},
pEditableHandler: function() {
this.setPEditable(this.$.chkEditable.getChecked());
},
pPlaceHandler: function() {
this.setPPlace(this.$.place.getValue());
},
pHoogteHandler: function() {
this.setPHoogte(this.$.hoogte.getValue());
},
pBreedtegraadHandler: function() {
this.setPBreedtegraad(this.$.breedtegraad.getValue());
},
pLengtegraadHandler: function() {
this.setPLengtegraad(this.$.lengtegraad.getValue());
},
pTemperatureScaleMaxHandler: function() {
this.setPTemperatureScaleMax(this.$.temperatureScaleMax.getValue());
},
pTemperatureScaleMinHandler: function() {
this.setPTemperatureScaleMin(this.$.temperatureScaleMin.getValue());
},
pAutoScalingHandler: function() {
this.setPAutoScaling(this.$.chkAutoScaling.getChecked());
},
render: function() {
this.inherited(arguments);
},
setValues: function() {
this.inherited(arguments), this.setPPlace(this.getLinked().getPlace()), this.setPHoogte(this.getLinked().getHoogte()), this.setPBreedtegraad(this.getLinked().getBreedtegraad()), this.setPLengtegraad(this.getLinked().getLengtegraad()), this.setPEditable(this.getLinked().getEditable()), this.setPTemperatureData(this.getLinked().getTemperatureDataAsArray()), this.setPRainfallData(this.getLinked().getRainfallDataAsArray()), this.setPTemperatureScaleMax(this.getLinked().getTemperatureScaleMax()), this.setPTemperatureScaleMin(this.getLinked().getTemperatureScaleMin()), this.setPAutoScaling(this.getLinked().getAutoScaling());
},
propertiesChanged: function() {
this.inherited(arguments);
var e = this.getPTemperatureData();
for (var t = 0; t < 12; t++) this.getLinked()["setT" + (t + 1)](e[t]);
var n = this.getPRainfallData();
for (var t = 0; t < 12; t++) this.getLinked()["setN" + (t + 1)](n[t]);
this.sendChangedEvent();
}
});

// EigenschappenColumnExercise.js

enyo.kind({
name: "educate.create.view.eigenschappen.EigenschappenColumnExercise",
kind: "educate.create.view.eigenschappen.Eigenschappen",
components: [ {
name: "basicProperties",
classes: "form-horizontal",
components: [ {
kind: "educate.create.view.eigenschappen.Eigenschap",
name: "layername",
label: "naam: ",
inputPlaceholder: "naam van de laag",
value: this.pLayername,
linkedProp: "layername",
linkable: !1,
onchange: "propertiesChanged"
} ]
} ]
});

// EigenschappenMultipleChoice.js

enyo.kind({
name: "educate.create.view.eigenschappen.EigenschappenMultipleChoice",
kind: "educate.create.view.eigenschappen.Eigenschappen",
tag: "div",
published: {
selectOptions: []
},
create: function() {
this.inherited(arguments), this.selectOptions = this.linked.options.selectOptions, this.generateMultipleChoiceProps(), this.updateList();
},
rendered: function() {
this.inherited(arguments);
},
generateMultipleChoiceProps: function() {
this.pQuestion = this.linked.getQuestion(), this.generateExtraFields([ {
label: "Vraag: ",
name: "question",
value: "pQuestion",
placeholder: "",
linkable: !1
} ]), this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkSolutionType",
checked: this.linked.options.solutionFromFrame,
onchange: "changeSolutionType",
content: "Oplossing via frame"
} ]
} ]
} ]
}, {
owner: this
}), this.$.extraProperties.createComponent({
classes: "control-group",
components: [ {
tag: "label",
content: "",
classes: "control-label"
}, {
classes: "controls",
components: [ {
tag: "label",
classes: "checkbox",
components: [ {
kind: "enyo.Checkbox",
name: "chkShuffleAnswers",
checked: this.linked.options.shuffleAnswers,
onchange: "changeShuffleAnswers",
content: "Shuffle antwoorden"
} ]
} ]
} ]
}, {
owner: this
}), this.$.extraProperties.createComponent({
name: "extraOptions",
tag: "div"
}, {
owner: this
}), this.$.extraProperties.createComponent({
components: [ {
classes: "newOptie",
components: [ {
kind: enyo.Button,
classes: "btn",
name: "btnAddOptie",
ontap: "addNewOption",
components: [ {
tag: "i",
name: "btnAddIcon",
classes: "icon-plus"
} ]
} ]
} ]
}, {
owner: this
});
},
updateList: function() {
this.$.extraOptions.destroyClientControls(), this.$.extraOptions.createComponent({
name: "formOpties",
classes: "formOpties",
components: [ {
classes: "optieRow",
components: [ {
tag: "label",
classes: "labelText",
content: "text"
}, {
tag: "label",
classes: "labelCorrect",
components: [ {
tag: "i",
classes: "icon-check"
} ]
}, {
tag: "i",
classes: "icon-trash"
} ]
} ]
}, {
owner: this
});
for (var e in this.selectOptions) this.createComponent({
classes: "optieRow",
container: this.$.formOpties,
components: [ {
kind: "enyo.Input",
value: this.selectOptions[e].text,
name: "optionText_" + e,
placeholder: "label",
classes: "option-text",
onblur: "updateOptieText"
}, {
kind: "enyo.Checkbox",
classes: "option-correct",
name: "chkCorrect_" + e,
checked: this.selectOptions[e].correct,
onchange: "changeCorrect"
}, {
kind: enyo.Button,
classes: "btn",
name: "btnDelete_" + e,
ontap: "deleteOption",
components: [ {
tag: "i",
name: "btnDelete_" + e + "icon",
classes: "icon-trash"
} ]
} ]
}, {
owner: this
});
this.render();
},
addNewOption: function(e, t) {
var n = this.selectOptions.length;
this.selectOptions[n] = {
text: "",
correct: !1
}, this.linked.selectOptions = this.selectOptions, this.linked.updateMultipleChoice(), this.updateList(), this.$["optionText_" + n].focus();
},
checkWordInSelectOptions: function(e) {
var t = this.selectOptions.length;
for (var n = 0; n < t; n++) if (this.selectOptions[n].text === e) return !0;
return !1;
},
deleteOption: function(e, t) {
var n = e.name.split("_")[1];
this.selectOptions.splice(n, 1), this.linked.selectOptions = this.selectOptions, this.linked.updateMultipleChoice(), this.updateList();
},
updateOptieText: function(e, t) {
var n = e.name.split("_")[1], r = e.getValue();
this.checkWordInSelectOptions(r) ? r != this.selectOptions[n].text && (e.addClass("option-error"), e.setValue("")) : (this.selectOptions[n].text = r, this.linked.selectOptions = this.selectOptions, this.linked.updateMultipleChoice(), this.updateList());
},
changeCorrect: function(e, t) {
var n = e.name.split("_")[1];
this.selectOptions[n].correct = e.getChecked(), this.linked.selectOptions = this.selectOptions, this.linked.updateMultipleChoice(), this.updateList();
},
changeSolutionType: function(e, t) {
this.linked.solutionFromFrame = this.$.chkSolutionType.getChecked(), this.linked.updateMultipleChoice();
},
changeShuffleAnswers: function(e, t) {
this.linked.setShuffleAnswers(this.$.chkShuffleAnswers.getChecked()), this.linked.addPropertiesToOptions();
}
});

// EigenschappenPanel.js

enyo.kind({
name: "educate.create.view.eigenschappen.EigenschappenPanel",
kind: enyo.Control,
tag: "div",
classes: "propertiesPanel",
handlers: {
layerSelected: "layerSelectedHandler",
threeDLayerSelected: "threeDLayerSelectedHandler",
layerZoneSelected: "layerZoneSelectedHandler",
deselectedObjects: "deselectedObjectsHandler",
layerDeleted: "layerDeletedHandler",
layerDeletedAll: "layerDeletedAllHandler",
onPropertiesChanged: "onPropertiesChangedHandler",
frameBottomIconClicked: "frameBottomIconClickedHandler",
onLaagClicked: "onLaagClickedHandler"
},
components: [ {
kind: "educate.create.view.Header",
content: "Eigenschappen"
}, {
kind: "enyo.Scroller",
classes: "enyo-fit topPosProperties",
components: [ {
kind: "onyx.Groupbox",
name: "grpProperties",
classes: "propertiesgroup"
} ]
} ],
published: {
viewId: "",
current: "",
view: null
},
rendered: function() {
this.inherited(arguments);
},
layerSelectedHandler: function(e, t) {
e.owner.kindName == "educate.create.view.View" && this.showProperties(t);
},
threeDLayerSelectedHandler: function(e, t) {
e.owner.kindName == "educate.create.view.View" && this.showProperties(t);
},
layerZoneSelectedHandler: function(e, t) {
e.owner.kindName == "educate.create.view.View" && this.showProperties(t);
},
deselectedObjectsHandler: function(e, t) {
this.removeProperties();
},
layerDeletedHandler: function(e, t) {
this.removeProperties();
},
layerDeletedAllHandler: function(e, t) {
this.removeProperties();
},
frameBottomIconClickedHandler: function(e, t) {
if (this.getViewId() == t.viewId) {
var n = new Object;
n.linked = t, this.showProperties(n);
}
},
onLaagClickedHandler: function(e, t) {
var n = new Object;
n.linked = t, this.showProperties(n);
},
onPropertiesChangedHandler: function(e, t) {
this.showProperties(t);
},
showProperties: function(e) {
if (this.current !== e.linked.name) {
this.removeProperties();
var t, n;
switch (e.linked.kindName) {
case "educate.create.components.bediening.Knop":
t = "EigenschappenKnop";
break;
case "educate.create.components.bediening.InfoIcon":
t = "EigenschappenInfoIcon";
break;
case "educate.create.components.bediening.PhotoIcon":
t = "EigenschappenPhotoIcon";
break;
case "educate.create.components.svg.SvgParser":
t = "EigenschappenSvg";
break;
case "educate.create.components.svg.svgzone.SvgZone":
t = "EigenschappenSvgZone";
break;
case "educate.create.components.svg.svgzone.SvgZoneLegende":
t = "EigenschappenSvgZoneLegende";
break;
case "educate.create.components.svg.svgzone.SvgZoneLegendeItem":
t = "EigenschappenSvgZoneLegendeItem";
break;
case "educate.create.components.image.Image":
t = "EigenschappenImage";
break;
case "educate.create.components.tekst.Tekst":
t = "EigenschappenTekst";
break;
case "educate.create.components.raster.Raster":
t = "EigenschappenRaster";
break;
case "educate.create.components.animatie.Animatie":
t = "EigenschappenAnimatie";
break;
case "educate.create.components.groep.Groep":
t = "EigenschappenGroep";
break;
case "educate.create.onderbalk.knoppen.KnopHand":
t = "EigenschappenHand";
break;
case "educate.create.onderbalk.knoppen.KnopOplossing":
t = "EigenschappenOplossing";
break;
case "educate.create.components.input.Cijferveld":
t = "EigenschappenCijferveld";
break;
case "educate.create.view.lagenpalet.Laag":
t = "EigenschappenLaag";
break;
case "educate.create.components.video.Video":
t = "EigenschappenVideo";
break;
case "educate.create.components.input.Lijnstuk":
t = "EigenschappenLijnstuk";
break;
case "educate.create.components.input.InputField":
t = "EigenschappenInputField";
break;
case "educate.create.components.tekendoos.Square":
t = "EigenschappenSquare";
break;
case "educate.create.components.tekendoos.Ellipse":
t = "EigenschappenEllipse";
break;
case "educate.create.components.tekendoos.Free":
t = "EigenschappenFree";
break;
case "educate.create.components.tekendoos.Multi":
t = "EigenschappenMulti";
break;
case "educate.create.components.meetlat.Meetlat":
t = "EigenschappenMeetlat";
break;
case "educate.create.components.zoomImage.ZoomImage":
t = "EigenschappenZoomImage";
break;
case "educate.create.components.pickAndPlace.PickAndPlaceWords":
t = "EigenschappenPickAndPlaceWords";
break;
case "educate.create.components.pickAndPlace.PickAndPlaceImages":
t = "EigenschappenPickAndPlaceImages";
break;
case "educate.create.components.kolomOefening.KolomWoorden":
t = "EigenschappenKolomWoorden";
break;
case "educate.create.components.kolomOefening.KolomAfbeeldingen":
t = "EigenschappenKolomAfbeeldingen";
break;
case "educate.create.components.bediening.Dropdown":
t = "EigenschappenDropdown";
break;
case "educate.create.components.flipcard.Flipcard":
t = "EigenschappenFlipcard";
break;
case "educate.create.components.website.Website":
t = "EigenschappenWebsite";
break;
case "educate.create.components.map.Map":
t = "EigenschappenMap";
break;
case "educate.create.components.youtube.Youtube":
t = "EigenschappenYoutube";
break;
case "educate.create.components.3DObject.3DObject":
t = "Eigenschappen3DObject";
break;
case "educate.components.3DObject.3DMesh":
t = "Eigenschappen3DMesh";
break;
case "educate.components.3DObject.3DCamera":
t = "Eigenschappen3DCamera";
break;
case "educate.components.svg.svgzone.SvgZone":
t = "EigenschappenSvgZone";
break;
case "educate.create.components.bibliotheek.Klimatogram":
t = "EigenschappenKlimatogram";
break;
case "educate.create.components.multipleChoice.MultipleChoice":
t = "EigenschappenMultipleChoice";
break;
case "educate.create.components.columnExercise.ColumnExerciseWords":
t = "EigenschappenColumnExercise";
break;
default:
console.log("case '" + e.linked.kindName + "': break;");
}
t && (n = this.createComponent({
container: this.$.grpProperties,
kind: "educate.create.view.eigenschappen." + t,
layer: e,
linked: e.linked,
viewId: this.getViewId(),
view: this.getView()
}), e.linked.disableActions || this.createComponent({
container: this.$.grpProperties,
kind: "educate.create.view.eigenschappen.acties.Acties",
layer: e,
linked: e.linked,
viewId: this.getViewId(),
view: this.getView()
})), this.$.grpProperties.render();
}
this.current = e.linked.name;
},
removeProperties: function() {
this.current = "", this.$.grpProperties.destroyComponents(), this.$.grpProperties.destroyClientControls();
}
});

// Eigenschap.js

enyo.kind({
name: "educate.create.view.eigenschappen.Eigenschap",
kind: enyo.Control,
tag: "div",
classes: "control-group",
published: {
label: "",
inputType: "text",
inputPlaceholder: "",
value: null,
min: null,
max: null,
linkedProp: null,
linkable: !1,
linked: !1,
extraAttributes: null,
random: !1,
isRandom: !1,
round: 0
},
_link: null,
isRendered: !1,
events: {
onchange: "",
onLinkPropValue: "",
onRandomChange: ""
},
components: [ {
tag: "label",
classes: "control-label",
name: "lbl"
}, {
classes: "controls input-append",
name: "controls",
components: [ {
kind: enyo.Input,
type: this.inputType,
placeholder: this.inputPlaceholder,
value: this.value,
name: "input",
onchange: "inputChanged"
}, {
container: this.$.controls,
classes: "btn-group",
name: "btnLinkGroup",
showing: !1,
components: [ {
kind: enyo.Button,
classes: "btn",
name: "btnLink",
ontap: "onLinkPropValueTap",
showing: !1,
components: [ {
tag: "i",
name: "btnLinkIcon",
classes: "icon-link btnLinkIcon"
} ]
}, {
kind: enyo.Button,
name: "btnLinkDropdown",
classes: "btn dropdown-toggle",
attributes: {
"data-toggle": "dropdown"
},
showing: !1,
components: [ {
tag: "span",
classes: "caret"
} ]
}, {
tag: "ul",
classes: "dropdown-menu",
components: [ {
tag: "li",
name: "ctxLinkMnuItemBewerk",
components: [ {
tag: "a",
attributes: {
href: "#"
},
content: "Bewerk",
ontap: "onLinkPropValueTap"
} ]
}, {
tag: "li",
name: "ctxLinkMnuItemVerwijder",
components: [ {
tag: "a",
attributes: {
href: "#"
},
content: "Verwijder",
ontap: "onLinkRemoveTap"
} ]
} ]
} ]
}, {
kind: enyo.Button,
container: this.$.controls,
classes: "btn",
name: "btnRandom",
ontap: "onRandomTap",
showing: !1,
components: [ {
tag: "i",
name: "btnRandomIcon",
classes: "icon-random"
} ]
} ]
} ],
create: function() {
this.inherited(arguments);
},
rendered: function() {
this.inherited(arguments), this.minChanged(), this.maxChanged(), this.labelChanged(), this.inputTypeChanged(), this.inputPlaceholderChanged(), this.valueChanged(), this.linkableChanged(), this.linkedPropChanged(), this.extraAttributesChanged(), this.randomChanged(), this.linkedPropChanged(), this.linkedChanged(), $(".dropdown-toggle").click(function(e) {
e.preventDefault(), setTimeout($.proxy(function() {
"ontouchstart" in document.documentElement && $(this).siblings(".dropdown-backdrop").off().remove();
}, this), 0);
});
var e = this.owner;
while (e.linked === undefined && e !== enyo) e = e.owner;
e.linked !== undefined && (this._link = e.linked.name), this.setLast();
},
labelChanged: function() {
this.$.lbl.setContent(this.label);
},
inputTypeChanged: function() {
this.$.input.setType(this.inputType);
},
inputPlaceholderChanged: function() {
this.$.input.setPlaceholder(this.inputPlaceholder);
},
valueChanged: function() {
var e = this.getValue();
if (!/^\d+([,.]\d+)?$/.test(e)) return this.$.input.setValue(e), !0;
e = parseFloat(/,/.test(e) ? e.replace(/,/, ".") : e);
var t = parseFloat(this.getMin()), n = parseFloat(this.getMax()), r = !1;
return isNaN(t) || e < t && (e = t, r = !0), isNaN(n) || e > n && (e = n, r = !0), this.value = e, this.$.input !== undefined && this.$.input.setValue(e), r && this.bubble("onchange"), !0;
},
extraAttributesChanged: function() {
for (var e in this.getExtraAttributes()) this.$.input.setAttribute(e, this.getExtraAttributes()[e]);
},
linkableChanged: function() {
this.$.btnLinkGroup.setShowing(this.linkable), this.setLast();
},
randomChanged: function() {
this.$.btnRandom.setShowing(this.random), this.$.btnRandom.addRemoveClass("btn-primary", this.isRandom), this.setLast();
},
linkedChanged: function() {
return this.hasNode() ? (this.$.btnLink.setShowing(this.getLinkable()), this.linkable && (this.linked ? (this.setInputReadonly(), this.$.btnLinkIcon.removeClass("icon-link"), this.$.btnLinkIcon.addClass("icon-pencil"), this.showHideLinkDropdownMenu(!0)) : (this.setInputWritable(), this.$.btnLinkIcon.addClass("icon-link"), this.$.btnLinkIcon.removeClass("icon-pencil"), this.showHideLinkDropdownMenu(!1), this.$.btnRemoveLink && this.$.btnRemoveLink.destroy()), this.setLast()), !0) : (this.render(), !1);
},
setInputReadonly: function() {
this.$.input !== undefined && this.$.input.setAttribute("readonly", "readonly");
},
setInputWritable: function() {
this.$.input && (this.$.input.setAttribute("readonly", null), this.$.input.setValue(this.getValue()));
},
inputChanged: function(e, t) {
return this.value = t.originator.getValue(), this.bubble("onchange"), !0;
},
onLinkPropValueTap: function(e, t) {
return this.doLinkPropValue(), !0;
},
linkedPropChanged: function(e) {
if (this._link === undefined || this._link === null) return !1;
var t = this.owner;
while (t.properties === undefined && t !== enyo) t = t.owner;
return t.properties[this._link] === undefined && (t.properties[this._link] = {}), t.properties[this._link][this.linkedProp] && delete t.properties[this._link][this.linkedProp], t.properties[this._link][this.linkedProp] = this, !0;
},
showHideLinkDropdownMenu: function(e) {
this.$.btnLinkDropdown.setShowing(e), this.setLast();
},
onRandomTap: function(e, t) {
this.getRandom() && this.setIsRandom(!this.getIsRandom());
},
onLinkRemoveTap: function(e, t) {
return this.setLinked(!1), this.bubble("onLinkRemoved", {
eigenschap: this.getLinkedProp()
}), !0;
},
minChanged: function() {
var e = parseFloat(this.min);
isNaN(e) ? this.min = null : this.min = e, this.valueChanged(), this.isRandomChanged();
},
maxChanged: function() {
var e = parseFloat(this.max);
isNaN(e) ? this.max = null : this.max = e, this.valueChanged(), this.isRandomChanged();
},
isRandomChanged: function() {
this.getRandom() && (this.bubble("onRandomChange"), this.bubble("onchange"), this.$.btnRandom.addRemoveClass("btn-primary", this.getIsRandom())), this.setLast();
},
setLast: function() {
this.$.input.removeClass("last"), this.$.btnLink.removeClass("last"), this.$.btnLinkDropdown.removeClass("last"), this.$.btnRandom.removeClass("last");
switch (!0) {
case this.$.btnRandom.hasNode() && this.$.btnRandom.getShowing():
this.$.btnRandom.addClass("last");
break;
case this.$.btnLinkDropdown.hasNode() && this.$.btnLinkDropdown.getShowing():
this.$.btnLinkDropdown.addClass("last");
break;
case this.$.btnLink.hasNode() && this.$.btnLink.getShowing():
this.$.btnLink.addClass("last");
break;
default:
this.$.input.addClass("last");
}
}
});

// Limiet.js

enyo.kind({
name: "educate.create.view.eigenschappen.Limiet",
kind: enyo.Control,
tag: "div",
classes: "control-group",
published: {
label: "label",
min: null,
max: null,
inputType: "number",
linkedProp: ""
},
events: {
onchange: "",
onInherit: ""
},
components: [ {
tag: "label",
classes: "control-label",
name: "label"
}, {
classes: "controls input-append",
name: "controls",
components: [ {
kind: enyo.Input,
type: "number",
value: this.min,
name: "inputMin",
onchange: "inputChanged"
}, {
kind: enyo.Button,
classes: "btn",
name: "btnInheritMin",
ontap: "onInheritTap",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
}, {
kind: enyo.Input,
type: "number",
value: this.max,
name: "inputMax",
onchange: "inputChanged"
}, {
kind: enyo.Button,
classes: "btn",
name: "btnInheritMax",
ontap: "onInheritTap",
components: [ {
tag: "i",
classes: "icon-download-alt"
} ]
} ]
} ],
create: function() {
this.inherited(arguments), this.$.label.setContent(this.getLabel()), this.$.inputMin.setValue(this.getMin()), this.$.inputMax.setValue(this.getMax());
},
labelChanged: function() {
this.$.label.setContent(this.getLabel());
},
minChanged: function() {
this.$.inputMin.setValue(isNaN(this.min) ? "" : this.min), this.bubble("onchange");
},
maxChanged: function() {
this.$.inputMax.setValue(isNaN(this.max) ? "" : this.max), this.bubble("onchange");
},
inputChanged: function() {
this.setMin(parseFloat(this.$.inputMin.getValue())), this.setMax(parseFloat(this.$.inputMax.getValue()));
},
onInheritTap: function(e, t) {
t.originator = e, this.bubble("onInherit", t);
}
});

// CreateLayerHandlers.js

enyo.kind({
name: "educate.create.view.eigenschappen.CreateLayerHandlers",
kind: "onyx.Popup",
classes: "layerHandlersPopup",
floating: !0,
centered: !0,
scrim: !0,
autoDismiss: !1,
modal: !0,
published: {
layer: ""
},
components: [ {
content: "Layerhandlers"
}, {
tag: "div",
name: "listContainer"
}, {
tag: "div",
components: [ {
kind: "onyx.Input",
name: "handlername",
style: "float:left;"
}, {
kind: "onyx.Button",
content: "New handler",
name: "btnNewHandler",
ontap: "makeNewHandler",
style: "float:left;"
}, {
kind: "onyx.Button",
content: "Add handler",
name: "btnAddHandler",
ontap: "addNewHandler",
style: "float:left;"
}, {
kind: "onyx.Button",
content: "Edit handler",
name: "btnEditHandler",
ontap: "saveEditHandler",
style: "float:left;"
}, {
kind: "onyx.Button",
content: "Remove handler",
name: "btnRemoveHandler",
ontap: "removeHandler",
style: "float:left;"
}, {
kind: "onyx.Button",
content: "Save",
ontap: "submitLayerHandlersPopup",
style: "float:right;"
}, {
kind: "onyx.Button",
content: "Cancel",
ontap: "cancelLayerHandlersPopup",
style: "float:right;"
} ]
} ],
makeNewHandler: function() {
this.$.handlername.setValue(""), this.buttonsVisibleFalse(), this.$.btnAddHandler.show(), this.makeEventList();
},
addNewHandler: function() {
var e = this.$.handlername.getValue(), t = new Object;
t.event = this.$.eventList.getSelection().link, t.object = this.$.objectList.getSelection().link, t.action = this.$.actionList.getSelection().link;
var n = new Object;
n.label = e, n.link = t, this.$.handlerList.addItem(n), this.$.handlerList.render(), this.removeLists(), this.buttonsVisibleFalse(), this.$.btnNewHandler.show();
},
saveEditHandler: function() {
var e = this.$.handlername.getValue(), t = this.$.handlerList.getSelection(), n = t.label;
t.label = e, t.link.event = this.$.eventList.getSelection().link, t.link.object = this.$.objectList.getSelection().link, t.link.action = this.$.actionList.getSelection().link, this.$.handlerList.updateItem(n, t), this.$.handlerList.render(), this.removeLists(), this.buttonsVisibleFalse(), this.$.btnNewHandler.show();
},
removeHandler: function() {
this.$.handlerList.removeItem(this.$.handlerList.getSelection()), this.removeLists(), this.buttonsVisibleFalse(), this.$.btnNewHandler.show();
},
editHandler: function(e, t) {
if (t.dispatchTarget.kindName == "educate.hulpklassen.list.ListItem") {
this.buttonsVisibleFalse(), this.$.btnEditHandler.show(), this.$.btnRemoveHandler.show();
var n = this.$.handlerList.getSelection();
this.$.handlername.setValue(n.label), this.makeEventList(), this.$.eventList.selectItem(n.link.event), this.makeObjectList(), this.$.objectList.selectItem(n.link.object);
var r = {
dispatchTarget: {
link: n.link.object
}
};
this.makeActionsList("", r), this.$.actionList.selectItem(n.link.action);
} else this.buttonsVisibleFalse(), this.$.btnNewHandler.show(), this.removeLists();
},
create: function() {
this.inherited(arguments), this.buttonsVisibleFalse(), this.$.btnNewHandler.show(), this.makeHandlerList();
},
rendered: function() {
this.inherited(arguments);
},
buttonsVisibleFalse: function() {
this.$.btnNewHandler.hide(), this.$.btnAddHandler.hide(), this.$.btnEditHandler.hide(), this.$.btnRemoveHandler.hide();
},
makeHandlerList: function() {
this.objectHandlers = this.getLayer().linked.objectHandlers;
var e = [];
for (var t in this.objectHandlers) {
var n = new Object;
n.label = this.objectHandlers[t].name, n.link = {
event: this.objectHandlers[t].event,
object: this.objectHandlers[t].object,
action: this.objectHandlers[t].action
}, e.push(n);
}
this.createComponent({
kind: "educate.hulpklassen.list.List",
container: this.$.listContainer,
name: "handlerList",
width: "250",
ontap: "editHandler",
arrList: e
}), this.$.handlerList.render();
},
removeLists: function() {
this.$.eventList && this.$.eventList.destroy(), this.$.objectList && this.$.objectList.destroy(), this.$.actionList && this.$.actionList.destroy();
},
makeEventList: function() {
this.removeLists(), this.objectEvents = this.getLayer().linked.objectEvents;
var e = [];
for (var t in this.objectEvents) {
var n = new Object;
n.label = this.objectEvents[t].label, n.link = this.objectEvents[t], e.push(n);
}
this.createComponent({
kind: "educate.hulpklassen.list.List",
container: this.$.listContainer,
name: "eventList",
ontap: "makeObjectList",
arrList: e
}), this.$.eventList.render();
},
makeObjectList: function() {
this.$.objectList && this.$.objectList.destroy(), this.$.actionList && this.$.actionList.destroy(), this.layers = this.getLayer().owner.getAllLayers();
var e = [];
for (var t in this.layers) {
var n = new Object;
n.label = this.layers[t].linked.layername, n.link = this.layers[t].linked, e.push(n);
if (this.layers[t].linked.collection) var r = this.zonesInObjectList(this.layers[t].linked.collection);
}
for (var i in r) e.push(r[i]);
this.createComponent({
kind: "educate.hulpklassen.list.List",
container: this.$.listContainer,
name: "objectList",
ontap: "makeActionsList",
arrList: e
}), this.$.objectList.render();
},
zonesInObjectList: function(e) {
var t = [];
for (var n in e) if (e[n].carrier == window.settings.CARRIERS.ZONES) {
var r = new Object;
r.label = e[n].layername, r.link = e[n], t.push(r);
}
return t;
},
makeActionsList: function(e, t) {
this.$.actionList && this.$.actionList.destroy(), linkedObject = t.dispatchTarget.link;
if (linkedObject) {
this.objectActions = linkedObject.objectActions;
var n = [];
for (var r in this.objectActions) {
var i = new Object;
i.label = this.objectActions[r].label, i.link = this.objectActions[r], n.push(i);
}
this.createComponent({
kind: "educate.hulpklassen.list.List",
container: this.$.listContainer,
name: "actionList",
ontap: "actionListTapHandler",
arrList: n
}), this.$.actionList.render();
}
},
actionListTapHandler: function() {
this.makeHandlerName();
},
makeHandlerName: function() {
var e = this.$.eventList.getSelection().label;
e += "_" + this.$.objectList.getSelection().label, e += "_" + this.$.actionList.getSelection().label, this.$.handlername.setValue(e);
},
submitLayerHandlersPopup: function() {
var e = this.checkIsDrag();
e && (this.saveHandlers(e), this.hide());
},
cancelLayerHandlersPopup: function() {
this.hide();
},
checkIsDrag: function() {
var e = this.$.handlerList.getAllListItems(), t = this.isStartDrag(e), n = this.isStopDrag(e);
if (t || n) {
if (t && n) {
var r = new Object, i = new Object;
i.event = {
event: "ondragstart",
label: "dragstart"
}, i.object = this.getLayer().linked, i.action = {
label: "startdrag",
action: "startdrag"
}, r.label = "startdrag", r.link = i, e.push(r);
var s = new Object, o = new Object;
return o.event = {
event: "ondragfinish",
label: "dragstop"
}, o.object = this.getLayer().linked, o.action = {
label: "stopdrag",
action: "stopdrag"
}, s.label = "stopdrag", s.link = o, e.push(s), e;
}
return t ? console.log("voeg stop toe") : console.log("voeg start toe"), !1;
}
return console.log("geen drag"), e;
},
isStartDrag: function(e) {
for (var t in e) if (e[t].link.event.event == "ondragstart") return !0;
return !1;
},
isStopDrag: function(e) {
for (var t in e) if (e[t].link.event.event == "ondragfinish") return !0;
return !1;
},
saveHandlers: function(e) {
var t = [], n = [];
for (var r in e) {
var i = new Object;
i.name = e[r].label, i.event = e[r].link.event, i.object = e[r].link.object, i.action = e[r].link.action, t.push(i);
var s = new Object;
s.layername = e[r].label, s.carrier = window.settings.CARRIERS.EVENTACTIONHANDLER, s.value = e[r].link.object.objectId, s.solution = e[r].link.action.action, s.answered = e[r].link.event.event, s.width = 0, s.height = 0, s.position_x = 0, s.position_y = 0, s.inLayerHolder = 0, n.push(s);
}
this.getLayer().linked.objectHandlers = t, this.getLayer().linked.objectDbHandlers = n;
}
});

// Header.js

enyo.kind({
name: "educate.create.view.Header",
kind: enyo.Control,
classes: "grpHeaders",
published: {
content: "label"
},
components: [ {
tag: "span",
name: "label",
content: "label"
} ],
create: function() {
this.inherited(arguments), this.contentChanged();
},
contentChanged: function() {
this.$.label.setContent(this.getContent());
}
});

// Lagenpalet.js

enyo.kind({
name: "educate.create.view.lagenpalet.Lagenpalet",
kind: enyo.Control,
tag: "div",
classes: "lagenPalet",
handlers: {
ontap: "ontapHandler",
onRemoveLayerInLayerHolder: "onRemoveLayerInLayerHolderHandler",
ondragstart: "dragstartHandler",
ondrag: "dragHandler",
ondragover: "dragoverHandler",
ondragout: "dragoutHandler",
ondrop: "dropHandler",
ondragfinish: "dragfinishHandler",
onUniekChanged: "uniekChangedHandler"
},
components: [ {
kind: "educate.create.view.Header",
content: "Lagen",
name: "layerpaletHeader"
}, {
kind: "enyo.Scroller",
classes: "enyo-fit topposition",
components: [ {
kind: "onyx.Groupbox",
name: "grpLagen",
tag: "ul",
classes: "lagen"
} ]
} ],
published: {
viewId: "",
dragLaag: "",
lastHover: "",
placeholder: "",
uniekState: !1
},
create: function() {
this.inherited(arguments);
},
rendered: function() {
this.inherited(arguments);
},
addLaag: function(e) {
var t = e.obj, n = e.objId, r = this.createComponent({
kind: "educate.create.view.lagenpalet.Laag",
name: t.linked.layername + "Laag_" + n,
layername: t.linked.layername + "Laag",
linkedObj: t.linked,
solution: t.linked.objectId,
linkedLijstItem: t,
container: this.$.grpLagen,
inLayerHolder: !0,
label: t.linked.layername + "Laag",
uniek: this.getUniekState(),
objectId: n
});
return r;
},
openLaag: function(e) {
var t = {};
e.obj && (t = JSON.parse(!e.obj.options || e.obj.options === "" ? "{}" : e.obj.options)), this.setUniekState(t.uniek || !1);
var n = this.owner.getChildById(e.obj.solution);
if (n) {
var r = this.createComponent({
kind: "educate.create.view.lagenpalet.Laag",
name: e.obj.name + "Laag_" + e.objId,
layername: e.obj.name,
linkedObj: n,
solution: n.objectId,
linkedLijstItem: e.obj,
container: this.$.grpLagen,
label: e.obj.name,
uniek: t.uniek || !1,
objectId: e.objId
});
return r;
}
},
handlePosLagen: function() {
var e = this.$.grpLagen.children.length;
for (var t = 0; t < e; t++) this.$.grpLagen.children[t].setPosition(this.$.grpLagen.children.indexOf(this.$.grpLagen.children[t]));
},
getLagenForView: function() {
var e = [], t = this.$.grpLagen.children.length;
for (var n = 0; n < t; n++) parseInt(this.$.grpLagen.children[n].getAnswered()) === 0 && e.push(this.$.grpLagen.children[n]);
return e;
},
toggleLaag: function(e) {
e.setInLayerHolder(!e.getInLayerHolder());
},
ontapHandler: function(e, t) {
t.originator.name === "layerpaletHeader" && this.bubble("toggleVensterLagen");
},
onRemoveLayerInLayerHolderHandler: function(e, t) {
var n = this.$.grpLagen.children;
for (var r = 0; r < n.length; r++) n[r].linkedObj.objectId === t.objectId && n[r].setInLayerHolder(!1);
},
uniekChangedHandler: function(e, t) {
this.setUniekState(t.uniekState);
var n = this.$.grpLagen.children.length;
for (var r = 0; r < n; r++) this.$.grpLagen.children[r].setUniek(t.uniekState);
},
dragstartHandler: function(e, t) {
t.originator.applyStyle("opacity", "0.4");
var n = this.$.grpLagen.children.length;
for (var r = 0; r < n; r++) this.$.grpLagen.children[r].$.laagSpan.addClass("addgroup");
this.placeholder = this.createComponent({
name: "placeHolder",
tag: "li",
classes: "placeholder",
container: this.$.grpLagen
}), this.$.grpLagen.render(), this.dragLaag = t.originator;
},
dragHandler: function(e, t) {},
dragoverHandler: function(e, t) {
return t.preventDefault && t.preventDefault(), t.originator.kindName === "educate.create.view.lagenpalet.Laag" && (t.originator.addClass("over"), this.lastHover = t.originator), t.originator.hasClass("over") ? (this.insertBeforeItem(t.clientY, t.originator.hasNode()) ? t.originator.hasNode().parentNode.insertBefore(this.placeholder.hasNode(), t.originator.hasNode()) : t.originator.hasNode().parentNode.insertBefore(this.placeholder.hasNode(), t.originator.hasNode().nextSibling), this.placeholder.applyStyle("visibility", "visible")) : t.originator.hasClass("addgroup") && this.placeholder.applyStyle("visibility", "hidden"), !1;
},
insertBeforeItem: function(e, t) {
return e - $(t).offset().top < $(t).height() / 2 ? !0 : !1;
},
dragoutHandler: function(e, t) {
t.originator.removeClass("over");
},
dropHandler: function(e, t) {
this.dragLaag.setContainer(null);
if (this.dragLaag != this.lastHover && this.dragLaag.kindName != "enyo.Scroller") {
this.dragLaag.getToGroup() && this.removeLaagFromOldGroup(this.dragLaag, this.dragLaag.getToGroup());
if (t.originator.hasClass("addgroup")) this.addLaagToGroup(); else {
if (this.insertBeforeItem(t.clientY, this.lastHover.hasNode())) this.dragLaag.addBefore = this.lastHover; else {
var n = this.$.grpLagen.indexOfChild(this.lastHover);
this.dragLaag.addBefore = this.$.grpLagen.children[n + 1];
}
this.lastHover.getToGroup() != "" ? (this.dragLaag.setToGroup(this.lastHover.getToGroup()), this.dragLaag.setAnswered(this.lastHover.getToGroup().getAnswered() + 1)) : this.dragLaag.setToGroup("");
}
this.dragLaag.setContainer(this.$.grpLagen), t.originator.hasClass("addgroup") && this.lastHover.addToGroup(this.$[tmpLaag.getName()]), !t.originator.hasClass("addgroup") && this.lastHover.getToGroup() != "" && this.lastHover.getToGroup().addToGroup(this.$[tmpLaag.getName()]), this.$.grpLagen.render();
}
return !1;
},
addLaagToGroup: function() {
var e = this.$.grpLagen.indexOfChild(this.lastHover);
this.dragLaag.addBefore = this.$.grpLagen.children[e + 1], this.dragLaag.setToGroup(this.lastHover), this.dragLaag.setAnswered(this.lastHover.getAnswered() + 1);
},
removeLaagFromOldGroup: function(e, t) {
var n = t.getCollection().indexOf(e);
t.getCollection().splice(n, 1), t.checkIsGroup();
},
dragfinishHandler: function(e, t) {
t.originator.applyStyle("opacity", "1"), this.placeholder.destroy();
var n = this.$.grpLagen.children.length;
for (var r = 0; r < n; r++) this.$.grpLagen.children[r].removeClass("over"), this.$.grpLagen.children[r].$.laagSpan.removeClass("addgroup");
this.handlePosLagen();
}
});

// Laag.js

enyo.kind({
name: "educate.create.view.lagenpalet.Laag",
kind: "educate.components.ActionHandler",
tag: "li",
classes: "laag",
handlers: {
ontap: "ontapHandler",
onPropertiesChanged: "onPropertiesChangedHandler"
},
events: {
onLaagClicked: "",
onUniekChanged: ""
},
components: [ {
tag: "p",
name: "tekstlabel",
content: this.layername
}, {
tag: "div",
name: "toggleGroup",
classes: "icon-folder-open pull-right",
ontap: "toggleGroupClicked",
showing: !1
}, {
tag: "span",
name: "laagSpan",
content: "+"
} ],
published: {
linkedObj: "",
linkedLijstItem: "",
layername: "",
carrier: window.settings.CARRIERS.LAAG,
value: "#333333",
position: "",
answered: 0,
inLayerHolder: !1,
objectHandlers: [],
options: null,
uniek: !1,
isGroup: !1,
isGroupOpen: !0,
collection: [],
groupColor: "#333333",
groupColorType: "uniek",
toGroup: ""
},
create: function() {
this.inherited(arguments), this.setCollection([]);
},
rendered: function() {
this.inherited(arguments), this.layernameChanged(), this.valueChanged();
if (this.getObjectHandlers().length === 0 && this.getLinkedObj() !== null && this.getLinkedObj() !== undefined && this.getLinkedObj() !== "") {
var e = new educate.Actie;
e.event = "KLIK", e.targets = [ this.getLinkedObj().getObjectId() ], e.reactions = [ [ [ "TOGGLE_VISIBLE" ] ] ], this.objectHandlers.push(e);
}
},
destroy: function() {
this.inherited(arguments);
},
initEventsReactiesOptions: function() {
this.inherited(arguments), this.getReactieOptions().LAAGACTIES = {
label: "laag acties",
action: "laagActies"
};
},
layernameChanged: function() {
this.$.tekstlabel.setContent(this.getLayername());
},
valueChanged: function() {
this.applyStyle("background-color", this.getValue()), this.handleChildBorderKleur();
},
uniekChanged: function() {
this.doUniekChanged({
uniekState: this.getUniek()
}), this.addOption("uniek", this.getUniek());
},
groupColorChanged: function() {
this.getIsGroup() && this.handleGroupColorType();
},
groupColorTypeChanged: function() {
this.getIsGroup() && this.handleGroupColorType();
},
handleGroupColorType: function() {
switch (this.getGroupColorType()) {
case "uniek":
this.groupColorTypeUniek();
break;
case "gelijk":
this.groupColorTypeGelijk();
break;
case "aflopend":
this.groupColorTypeAflopend();
break;
default:
this.groupColorTypeUniek();
}
},
groupColorTypeUniek: function() {
var e = this.getCollection().length;
for (var t = 0; t < e; t++) this.getCollection()[t].setValue(this.getCollection()[t].getIsGroup() ? "#3a719e" : "#333333");
},
groupColorTypeGelijk: function() {
var e = this.getCollection().length;
for (var t = 0; t < e; t++) this.getCollection()[t].setValue(this.getGroupColor());
},
groupColorTypeAflopend: function() {
var e = this.getCollection().length;
for (var t = 0; t < e; t++) this.getCollection()[t].setValue(this.shadeFromColor(this.getGroupColor(), (e - t) * .4));
},
shadeFromColor: function(e, t) {
var n = "#";
e = e.substr(1);
for (var r = 0; r < 3; r++) {
var i = e.substr(r * 2, 2);
i = parseInt(i, 16), i = (this.checkLimiet(i + i * t) + .5 >> 0).toString(16), n += i;
}
return n;
},
checkLimiet: function(e) {
return e < 0 ? 0 : e > 255 ? 255 : e;
},
toGroupChanged: function() {
this.handleBorderLaag();
},
handleChildBorderKleur: function() {
var e = this.getCollection().length;
for (var t = 0; t < e; t++) this.getCollection()[t].handleBorderLaag();
},
answeredChanged: function() {},
collectionChanged: function() {
this.checkIsGroup();
},
isGroupChanged: function() {
this.setValue(this.getIsGroup() ? "#3a719e" : "#333333"), this.$.toggleGroup.setShowing(this.getIsGroup());
},
inLayerHolderChanged: function() {
this.setShowing(this.getInLayerHolder());
},
toggleGroupClicked: function(e, t) {
this.handleIconGroup(), this.toggleGroup(this.getCollection(), !this.getIsGroupOpen()), this.setIsGroupOpen(!this.getIsGroupOpen());
},
toggleGroup: function(e, t) {
var n = e.length;
for (var r = 0; r < n; r++) e[r].getIsGroup() && this.toggleGroup(e[r].getCollection(), t ? e[r].getIsGroupOpen() : !1), e[r].setShowing(t), this.parent.render();
},
handleIconGroup: function() {
this.$.toggleGroup.hasClass("icon-folder-open") ? (this.$.toggleGroup.removeClass("icon-folder-open"), this.$.toggleGroup.addClass("icon-folder-close")) : (this.$.toggleGroup.removeClass("icon-folder-close"), this.$.toggleGroup.addClass("icon-folder-open"));
},
addToGroup: function(e) {
this.getCollection().push(e), this.checkIsGroup(), e.handleBorderLaag();
},
checkIsGroup: function() {
this.setIsGroup(this.getCollection().length > 0 ? !0 : !1);
},
handleBorderLaag: function() {
this.getToGroup() != "" ? this.applyStyle("border-left", 10 + this.getAnswered() * 10 + "px " + this.getToGroup().getValue() + " solid") : this.applyStyle("border-left", null);
},
ontapHandler: function() {
this.doLaagClicked(this);
},
onPropertiesChangedHandler: function(e, t) {
t.linked == this && (this.layername = t.linked.layername, this.render());
},
downHandler: function(e, t) {
t.preventDefault();
}
});

// Stage.js

enyo.kind({
name: "educate.create.view.stage.Stage",
kind: "enyo.Control",
tag: "div",
classes: "stage",
published: {
viewId: "",
view: null,
width: 0,
height: 0,
originalImgWidth: window.settings.STAGEWIDTH,
originalImgHeight: window.settings.STAGEHEIGHT,
position_x: 0,
position_y: 0,
meshOptions: [],
isFirstTap: !0,
timeoutUID: -1,
meshes: []
},
handlers: {
onmousemove: "onMouseMoveHandler",
ontap: "ontapHandler",
addSquare: "addSquareHandler"
},
events: {
onObjectAdded: "",
onHideLayer: "",
onNewObjectAdded: ""
},
components: [ {
kind: "Signals",
onCarrierAddedToStage: "onCarrierAddedToStageHandler",
onObjectGroupChange: "objectGroupChange",
onListOrderChanged: "listOrderChangedHandler"
} ],
create: function() {
this.inherited(arguments);
},
rendered: function() {
this.inherited(arguments), this.resizeHandler();
},
onMouseMoveHandler: function(e, t) {
var n = new Object;
n.clientX = t.layerX - t.target.offsetLeft, n.clientY = t.layerY - t.target.offsetTop, this.bubble("mouseMoveStage", n);
},
ontapHandler: function(e, t) {
t.originator.kindName === "educate.create.view.stage.Stage" && this.bubble("deselectedObjects");
if (this.isFirstTap) {
this.isFirstTap = !1;
var n = this;
this.timeoutUID = setTimeout(function() {
n.isFirstTap = !0, clearTimeout(this.timeoutUID), n.timeoutUID = -1;
}, 300);
} else this.bubble("deselectedObjects"), clearTimeout(this.timeoutUID), this.timeoutUID = -1, this.isFirstTap = !0;
},
resizeHandler: function() {
this.inherited(arguments);
if (this.parent.owner.getViewActive()) {
var e = $("#create_" + this.parent.owner.name + "_panelMiddle").height(), t = $("#create_" + this.parent.owner.name + "_panelMiddle").width(), n = this.originalImgHeight, r = this.originalImgWidth;
this.scale = Math.min(e / n, t / r), this.offsetX = (t - r * this.scale) * .5, this.offsetY = (e - n * this.scale) * .5, $("#create_view" + this.getViewId() + "_stage").css({
height: n * this.scale,
width: r * this.scale,
"margin-top": this.offsetY,
"margin-left": this.offsetX
}), this.resizeComponents();
}
},
resizeComponents: function() {
window.settings.SCALE = this.scale, window.settings.OFFSETX = this.offsetX, window.settings.OFFSETY = this.offsetY;
for (var e in this.$) {
var t = this.$[e];
t.removeAndResize && t.resizeComponent();
}
},
getView: function() {
var e = enyo.$["frame_view" + this.viewId];
return e ? e : enyo.$["create_view" + this.viewId];
},
onCarrierAddedToStageHandler: function(e, t) {
var n = this.getView();
if (n.getViewActive()) {
var r = n.countViewObjectsId(), i = this, s = this;
switch (t.type) {
case "svgImage":
s.addSvg(r, null, i);
break;
case "image":
s.addImage(r, null, i);
break;
case "tekst":
s.addTekst(r, null, i);
break;
case "button":
s.addKnop(r, null, i);
break;
case "infoIcon":
s.addInfoIcon(r, null, i);
break;
case "photoIcon":
s.addPhotoIcon(r, null, i);
break;
case "sprite":
s.addAnimatie(r, null, i);
break;
case "cijferveld":
s.addCijferveld(r, null, i);
break;
case "video":
s.addVideo(r, null, i);
break;
case "raster":
s.addRaster(r, null, i);
break;
case "lijnstuk":
s.addLijnstuk(r, null, i);
break;
case "inputfield":
s.addInputField(r, null, i);
break;
case "square":
s.addSquareHandler(r, null, i);
break;
case "ellipse":
s.addEllipseHandler(r, null, i);
break;
case "free":
s.addFreeHandler(r, null, i);
break;
case "multi":
s.addMultiAngleHandler(r, null, i);
break;
case "meetlat":
s.addMeetlat(r, null, i);
break;
case "pickAndPlace":
s.addPickAndPlace(r, null, i);
break;
case "zoomImage":
s.addZoomImage(r, null, i);
break;
case "columnExerciseWords":
s.addColumnExerciseWords(r, null, i);
break;
case "columnExerciseImages":
s.addColumnExerciseImages(r, null, i);
break;
case "kolomWoorden":
s.addKolomOefeningWoorden(r, null, i);
break;
case "kolomAfbeeldingen":
s.addKolomOefeningAfbeeldingen(r, null, i);
break;
case "pickAndPlaceAfbeeldingen":
s.addPickAndPlaceAfbeeldingen(r, null, i);
break;
case "dropdown":
s.addDropdown(r, null, i);
break;
case "flipcard":
s.addFlipcard(r, null, i);
break;
case "webFrame":
s.addWebFrame(r, null, i);
break;
case "map":
s.addMap(r, null, i);
break;
case "youtube":
s.addYoutube(r, null, i);
break;
case "3DObject":
s.add3DObject(r, null, i);
break;
case "klimatogram":
s.addKlimatogram(r, null, i);
break;
case "multipleChoice":
s.addMultipleChoice(r, null, i);
break;
default:
console.log("case '" + t.type + "': break;");
}
enyo.Signals.send("onNewObjectAdded");
}
},
addGroep: function(e, t, n) {
var r = this.createComponent({
container: n,
kind: "educate.create.components.groep.Groep",
layername: "Groep naam",
position_x: 100,
position_y: 100,
width: 100,
height: 100,
viewId: this.getViewId(),
objectId: e
});
t && (r = this.applyPropertiesToObject(r, t)), this.addGroepLayer(r);
},
addImage: function(e, t, n) {
var r = {};
t && (r = JSON.parse(!t.options || t.options === "" ? "{}" : t.options));
var i = this.createComponent({
container: n,
kind: "educate.create.components.image.Image",
layername: "Image name",
viewId: this.getViewId(),
bAchtergrond: r.background === !0,
objectId: e
});
t && (i = this.applyPropertiesToObject(i, t)), this.addLayer(i);
},
addSvg: function(e, t, n) {
var r = {};
t && (r = JSON.parse(!t.options || t.options === "" ? "{}" : t.options));
var i = [];
i.fill = t ? r.fill : "#555555", i.stroke = t ? r.stroke : "#000000", i.opacity = t ? r.opacity : .7;
var s = this.createComponent({
container: n,
kind: "educate.create.components.svg.SvgParser",
layername: "Svg name",
viewId: this.getViewId(),
value: t ? t.value : "",
isBackground: r.background === !0,
showArea: t ? r.showArea : !1,
renderedFromPickPlaceImages: t ? r.renderedFromPickPlaceImages : !1,
colorOptions: i,
objectId: e
});
t && (s = this.applyPropertiesToObject(s, t)), this.addLayer(s);
},
addSvgTekst: function(e, t, n) {
var r = this.calculateTextProp(e.attributes), i = this.createComponent({
container: this,
kind: "educate.create.components.tekst.Tekst",
layername: t,
name: t,
position_x: r.posx,
position_y: r.posy,
rotation: "0 0 " + r.rot,
width: "200",
height: "100",
value: e.textContent,
viewId: this.getViewId(),
objectId: n
});
this.addLayer(i);
},
calculateTextProp: function(e) {
var t = new Object, n = e["font-size"], r = e.transform.nodeValue;
return r = r.match(/[0-9.]+/g), t.posx = parseFloat(r[4]) + .5 >> 0, t.posy = parseFloat(r[5]) + .5 >> 0, t.rot = this.radiansToDegrees(Math.acos(r[0])) + .5 >> 0, t;
},
radiansToDegrees: function(e) {
return e * (180 / Math.PI);
},
addTekst: function(e, t, n) {
var r = this.createComponent({
container: n,
kind: "educate.create.components.tekst.Tekst",
layername: "Tekst naam",
position_x: "300",
position_y: "200",
width: "200",
height: "100",
value: "Hier komt uw tekst.",
viewId: this.getViewId(),
objectId: e
});
t && (r = this.applyPropertiesToObject(r, t)), this.addLayer(r);
},
addRaster: function(e, t, n) {
var r = this.createComponent({
container: n,
kind: "educate.create.components.raster.Raster",
layername: "Raster naam",
position_x: "300",
position_y: "200",
width: "500",
height: "200",
viewId: this.getViewId(),
objectId: e
});
t && (r = this.applyPropertiesToObject(r, t)), this.addLayer(r);
},
addKnop: function(e, t, n) {
var r = this.createComponent({
container: n,
kind: "educate.create.components.bediening.Knop",
value: "default",
solution: "",
position_x: "200",
position_y: "100",
width: "",
height: "",
layername: "button",
viewId: this.getViewId(),
objectId: e
});
t && (r = this.applyPropertiesToObject(r, t)), this.addLayer(r);
},
addInfoIcon: function(e, t, n) {
var r = this.createComponent({
container: n,
kind: "educate.create.components.bediening.InfoIcon",
position_x: "300",
position_y: "200",
width: "40",
height: "40",
layername: "InfoIconLayer",
viewId: this.getViewId(),
objectId: e
});
t && (r = this.applyPropertiesToObject(r, t)), this.addLayer(r), this.addInfoIconContentTemplate(r, t && t.collection);
},
addPhotoIcon: function(e, t, n) {
var r = this.createComponent({
container: n,
kind: "educate.create.components.bediening.PhotoIcon",
position_x: "400",
position_y: "200",
width: "40",
height: "40",
layername: "PhotoIconLayer",
viewId: this.getViewId(),
objectId: e
});
t && (r = this.applyPropertiesToObject(r, t)), this.addLayer(r), this.addPhotoIconContentTemplate(r, t && t.collection);
},
addInfoIconContentTemplate: function(e, t) {
var n = this.createComponent({
container: this,
kind: "educate.create.components.bediening.InfoIconContent",
layername: e.layername + "_content",
linked: e,
viewId: this.getViewId()
}), r = 0;
for (var i in t) t[i].carrier.code == window.settings.CARRIERS.CONTENT_ICON && (n = this.applyPropertiesToObject(n, t[i]), e.collection[i] = n), r++;
r === 0 && (e.collection = [ n ]);
},
addPhotoIconContentTemplate: function(e, t) {
var n = this.createComponent({
container: this,
kind: "educate.create.components.bediening.PhotoIconContent",
layername: e.layername + "_content",
linked: e,
viewId: this.getViewId()
}), r = 0;
for (var i in t) n = this.applyPropertiesToObject(n, t[i]), e.collection[i] = n, r++;
r === 0 && (e.collection = [ n ]);
},
addAnimatie: function(e, t, n) {
var r = this.createComponent({
container: n,
kind: "educate.create.components.animatie.Animatie",
layername: "Animatie naam",
position_x: 300,
position_y: 200,
viewId: this.getViewId(),
objectId: e
});
t && (r = this.applyPropertiesToObject(r, t)), this.addLayer(r);
},
addCijferveld: function(e, t, n) {
var r = this.createComponent({
container: n,
kind: "educate.create.components.input.Cijferveld",
layername: "cijferveld",
viewId: this.getViewId(),
objectId: e,
width: "",
height: ""
});
t && t.value == null && (t.value = ""), t && (r = this.applyPropertiesToObject(r, t)), this.addLayer(r);
},
addVideo: function(e, t, n) {
var r = {};
t && (r = JSON.parse(!t.options || t.options === "" ? "{}" : t.options));
var i = this.createComponent({
container: n,
kind: "educate.create.components.video.Video",
layername: "video",
position_x: t ? t.position_x : "50",
position_y: t ? t.position_y : "50",
viewId: this.getViewId(),
objectId: e,
keyframes: r.keyframes
});
t && (i = this.applyPropertiesToObject(i, t)), this.addLayer(i);
},
addLijnstuk: function(e, t, n) {
var r = this.createComponent({
container: n,
kind: "educate.create.components.input.Lijnstuk",
layername: "lijnstuk",
viewId: this.getViewId(),
objectId: e
});
t && (r = this.applyPropertiesToObject(r, t)), this.addLayer(r);
},
addInputField: function(e, t, n) {
var r = this.createComponent({
container: n,
kind: "educate.create.components.input.InputField",
layername: "inputfield",
viewId: this.getViewId(),
objectId: e
});
t && (r = this.applyPropertiesToObject(r, t)), this.addLayer(r);
},
addSquareHandler: function(e, t, n) {
var r = {};
t && (r = JSON.parse(t.options));
var i = this.createComponent({
container: n,
kind: "educate.create.components.tekendoos.Square",
removeAndResize: !0,
position_x: t ? t.position_x : "100",
position_y: t ? t.position_y : "100",
reposition: t ? !0 : !1,
beginP: t ? r.beginP : this.$.drawCanvas.beginP,
endP: t ? r.endP : this.$.drawCanvas.endP,
lineColor: t ? r.lineColor : this.$.drawCanvas.lineColor,
lineThickness: t ? r.lineThickness : this.$.drawCanvas.lineThickness,
lineType: t ? r.lineType : this.$.drawCanvas.lineType,
fillColor: t ? r.fillColor : this.$.drawCanvas.fillColor,
radius: t ? r.radius : this.$.drawCanvas.radius,
opacity: t ? r.opacity : this.$.drawCanvas.opacity,
layername: "square",
viewId: this.getViewId(),
objectId: e
});
t && (i = this.applyPropertiesToObject(i, t)), this.addLayer(i);
},
addEllipseHandler: function(e, t, n) {
var r = {};
t && (r = JSON.parse(!t.options || t.options === "" ? "{}" : t.options));
var i = this.createComponent({
container: n,
kind: "educate.create.components.tekendoos.Ellipse",
removeAndResize: !0,
position_x: t ? t.position_x : "100",
position_y: t ? t.position_y : "100",
reposition: t ? !0 : !1,
beginP: t ? r.beginP : this.$.drawCanvas.beginP,
endP: t ? r.endP : this.$.drawCanvas.endP,
lineColor: t ? r.lineColor : this.$.drawCanvas.lineColor,
lineThickness: t ? r.lineThickness : this.$.drawCanvas.lineThickness,
lineType: t ? r.lineType : this.$.drawCanvas.lineType,
fillColor: t ? r.fillColor : this.$.drawCanvas.fillColor,
opacity: t ? r.opacity : this.$.drawCanvas.opacity,
layername: "ellipse",
viewId: this.getViewId(),
objectId: e
});
t && (i = this.applyPropertiesToObject(i, t)), this.addLayer(i);
},
addFreeHandler: function(e, t, n) {
var r = {};
t && (r = JSON.parse(!t.options || t.options === "" ? "{}" : t.options));
var i = this.createComponent({
container: n,
kind: "educate.create.components.tekendoos.Free",
removeAndResize: !0,
tmpX: t ? r.tmpX : "100",
tmpY: t ? r.tmpY : "100",
xreposition: t ? !0 : !1,
beginP: t ? r.beginP : this.$.drawCanvas.beginP,
endP: t ? r.endP : this.$.drawCanvas.endP,
lineColor: t ? r.lineColor : this.$.drawCanvas.lineColor,
lineThickness: t ? r.lineThickness : this.$.drawCanvas.lineThickness,
lineType: t ? r.lineType : this.$.drawCanvas.lineType,
fillColor: t ? r.fillColor : this.$.drawCanvas.fillColor,
fill: t ? r.fill : this.$.drawCanvas.fill,
pathPointsA: t ? undefined : this.$.drawCanvas.pathPoints,
pathString: t ? r.pathString : "",
opacity: t ? r.opacity : this.$.drawCanvas.opacity,
layername: "free",
viewId: this.getViewId(),
objectId: e
});
t && (i = this.applyPropertiesToObject(i, t)), this.addLayer(i);
},
addMultiAngleHandler: function(e, t, n) {
var r = {};
t && (r = JSON.parse(!t.options || t.options === "" ? "{}" : t.options));
var i = this.createComponent({
container: n,
kind: "educate.create.components.tekendoos.Multi",
removeAndResize: !0,
tmpX: t ? r.tmpX : "100",
tmpY: t ? r.tmpY : "100",
reposition: t ? !0 : !1,
beginP: t ? r.beginP : this.$.drawCanvas.beginP,
endP: t ? r.endP : this.$.drawCanvas.endP,
lineColor: t ? r.lineColor : this.$.drawCanvas.lineColor,
lineThickness: t ? r.lineThickness : this.$.drawCanvas.lineThickness,
lineType: t ? r.lineType : this.$.drawCanvas.lineType,
fillColor: t ? r.fillColor : this.$.drawCanvas.fillColor,
pathPoints: t ? r.pathPoints : this.$.drawCanvas.pathPoints,
pathString: t ? r.pathString : "",
opacity: t ? r.opacity : this.$.drawCanvas.opacity,
layername: "multi",
viewId: this.getViewId(),
objectId: e
});
t && (i = this.applyPropertiesToObject(i, t)), this.addLayer(i);
},
addTekenLayer: function(e, t, n) {
var r = this.createComponent({
container: n,
kind: "educate.create.components.tekendoos.Draw",
name: "drawCanvas",
width_: "100%",
viewId: this.getViewId(),
removeAndResize: !0
});
t && (r = this.applyPropertiesToObject(r, t));
},
addMeetlat: function(e, t, n) {
var r = {};
t && (r = JSON.parse(!t.options || t.options === "" ? "{}" : t.options));
var i = this.createComponent({
container: n,
kind: "educate.create.components.meetlat.Meetlat",
position_x: t ? t.position_x : "100",
position_y: t ? t.position_y : "100",
lengte: t ? r.lengte : 10,
unit: t ? r.unit : "cm",
divide: t ? r.divide : 10,
layername: "Meetlat name",
removeAndResize: !0,
viewId: this.getViewId(),
objectId: e
});
t && (i = this.applyPropertiesToObject(i, t)), this.addLayer(i);
},
addPickAndPlace: function(e, t, n) {
var r = {};
t && (r = JSON.parse(!t.options || t.options === "" ? "{}" : t.options));
var i = this.createComponent({
container: n,
kind: "educate.create.components.pickAndPlace.PickAndPlaceWords",
layername: "pickPlace name",
removeAndResize: !0,
showArea: t ? r.showArea : !1,
viewId: this.getViewId(),
objectId: e
});
t && (i = this.applyPropertiesToObject(i, t)), this.addLayer(i);
},
addPickAndPlaceAfbeeldingen: function(e, t, n) {
var r = {};
t && (r = JSON.parse(!t.options || t.options === "" ? "{}" : t.options));
var i = this.createComponent({
container: n,
kind: "educate.create.components.pickAndPlace.PickAndPlaceImages",
layername: "pickPlace name",
images: [],
removeAndResize: !0,
viewId: this.getViewId(),
objectId: e
});
t && (i = this.applyPropertiesToObject(i, t)), this.addLayer(i);
},
addZoomImage: function(e, t, n) {
var r = {};
t && (r = JSON.parse(!t.options || t.options === "" ? "{}" : t.options));
var i = this.createComponent({
container: n,
kind: "educate.create.components.zoomImage.ZoomImage",
layername: "zoomImage name",
viewId: this.getViewId(),
bAchtergrond: r.background === !0,
zoomSteps: t ? r.zoomSteps : [],
objectId: e
});
t && (i = this.applyPropertiesToObject(i, t)), this.addLayer(i);
},
addColumnExerciseWords: function(e, t, n) {
var r = {};
t !== null ? r = JSON.parse(!t.options || t.options === "" ? "{}" : t.options) : r = {
columns: [ {
header: "Klik om aan te passen."
} ],
optionListHeader: "Klik om aan te passen."
};
var i = this.createComponent({
container: n,
kind: "educate.create.components.columnExercise.ColumnExerciseWords",
layername: "kolomOefeningWoorden name",
viewId: this.getViewId(),
objectId: e
});
t && (i = this.applyPropertiesToObject(i, t)), i.options = r, i.optionsChanged(), this.addLayer(i);
},
addColumnExerciseImages: function(e, t, n) {
var r = {};
t !== null ? r = JSON.parse(!t.options || t.options === "" ? "{}" : t.options) : r = {
columns: [ {
header: "Klik om aan te passen."
} ],
optionListHeader: "Klik om aan te passen."
};
var i = this.createComponent({
container: n,
kind: "educate.create.components.columnExercise.ColumnExerciseImages",
layername: "kolomOefeningImages",
viewId: this.getViewId(),
objectId: e
});
t && (i = this.applyPropertiesToObject(i, t)), i.options = r, i.optionsChanged(), this.addLayer(i);
},
addKolomOefeningWoorden: function(e, t, n) {
var r = {};
t && (r = JSON.parse(!t.options || t.options === "" ? "{}" : t.options));
var i = this.createComponent({
container: n,
kind: "educate.create.components.kolomOefening.KolomWoorden",
layername: "kolomOefeningWoorden name",
viewId: this.getViewId(),
words: t ? r.words : [],
columns: t ? r.columns : 3,
splitCols: t ? r.splitCols : "{}",
titles: t ? r.titles : [ "Titel", "Titel", "Titel", "Voeg een vraag in" ],
maxWords: t ? r.maxWords : 40,
objectId: e
});
t && (i = this.applyPropertiesToObject(i, t)), this.addLayer(i);
},
addKolomOefeningAfbeeldingen: function(e, t, n) {
var r = {};
t && (r = JSON.parse(!t.options || t.options === "" ? "{}" : t.options));
var i = this.createComponent({
container: n,
kind: "educate.create.components.kolomOefening.KolomAfbeeldingen",
layername: "kolomOefeningAfbeeldingen name",
viewId: this.getViewId(),
images: t ? r.images : [],
columns: t ? r.columns : 2,
titles: t ? r.titles : [ "Titel", "Titel", "Titel", "Voeg een vraag in" ],
maxImages: t ? r.maxImages : 12,
objectId: e
});
t && (i = this.applyPropertiesToObject(i, t)), this.addLayer(i);
},
addDropdown: function(e, t, n) {
var r = {};
t && (r = JSON.parse(!t.options || t.options === "" ? "{}" : t.options));
var i = this.createComponent({
container: n,
kind: "educate.create.components.bediening.Dropdown",
layername: "dropdown naam",
position_x: "300",
position_y: "200",
selectOptions: t ? r.selectOptions : [],
automaticSolution: t ? r.automaticSolution : !0,
showOptions: t ? r.showOptions : !0,
openDirectionUp: t ? r.openDirectionUp : !1,
shuffleAnswers: t ? r.shuffleAnswers : !0,
startWithChoose: t ? r.startWithChoose : !0,
viewId: this.getViewId(),
objectId: e
});
t && (i = this.applyPropertiesToObject(i, t)), this.addLayer(i);
},
addMultipleChoice: function(e, t, n) {
var r = {};
t && (r = JSON.parse(!t.options || t.options === "" ? "{}" : t.options));
var i = this.createComponent({
container: n,
kind: "educate.create.components.multipleChoice.MultipleChoice",
layername: "multipleChoice name",
selectOptions: t ? r.selectOptions : [],
solutionFromFrame: t ? r.solutionFromFrame : !1,
shuffleAnswers: t ? r.shuffleAnswers : !0,
question: t ? r.question : "",
viewId: this.getViewId(),
objectId: e
});
t && (i = this.applyPropertiesToObject(i, t)), this.addLayer(i);
},
addFlipcard: function(e, t, n) {
var r = {};
t && (r = JSON.parse(!t.options || t.options === "" ? "{}" : t.options));
var i = this.createComponent({
container: n,
kind: "educate.create.components.flipcard.Flipcard",
layername: "flipcard naam",
currentBackSide: t ? r.currentBackSide : "Tekst",
backText: t ? r.backText : "",
backImage: t ? r.backImage : "",
viewId: this.getViewId(),
objectId: e
});
t && (i = this.applyPropertiesToObject(i, t)), this.addLayer(i);
},
addWebFrame: function(e, t, n) {
var r = {};
t && (r = JSON.parse(!t.options || t.options === "" ? "{}" : t.options));
var i = this.createComponent({
container: n,
kind: "educate.create.components.website.Website",
layername: "flipcard naam",
url: t ? r.url : "http://jquery.com/",
viewId: this.getViewId(),
objectId: e
});
t && (i = this.applyPropertiesToObject(i, t)), this.addLayer(i);
},
addMap: function(e, t, n) {
var r = {};
t && (r = JSON.parse(!t.options || t.options === "" ? "{}" : t.options));
var i = this.createComponent({
container: n,
kind: "educate.create.components.map.Map",
layername: "Map name",
viewId: this.getViewId(),
objectId: e
});
t && (i = this.applyPropertiesToObject(i, t)), this.addLayer(i);
},
addYoutube: function(e, t, n) {
var r = {};
t && (r = JSON.parse(!t.options || t.options === "" ? "{}" : t.options));
var i = this.createComponent({
container: n,
kind: "educate.create.components.youtube.Youtube",
layername: "Youtube name",
viewId: this.getViewId(),
objectId: e
});
t && (i = this.applyPropertiesToObject(i, t)), this.addLayer(i);
},
add3DObject: function(e, t, n) {
var r = {};
t && (r = JSON.parse(!t.options || t.options === "" ? "{}" : t.options));
var i = this.createComponent({
container: n,
kind: "educate.create.components.3DObject.3DObject",
layername: "scene 3D",
viewId: this.getViewId(),
meshOptions: this.meshOptions,
cameraPosition: t ? r.cameraPosition : '{"x":20,"y":0,"z":0}',
cameraCenter: t ? r.cameraCenter : '{"x":0,"y":0,"z":0}',
spotLightOn: t ? r.spotLightOn : !1,
hemiLightOn: t ? r.hemiLightOn : !0,
groundOn: t ? r.groundOn : !0,
modelUrls: t ? r.modelUrls : [],
modelNames: t ? r.modelNames : [],
meshActions: t ? r.meshActions : [],
objectId: e
});
t && (i = this.applyPropertiesToObject(i, t)), this.addLayer(i);
},
add3DMesh: function(e, t, n) {
var r = JSON.parse(!t.options || t.options === "" ? "{}" : t.options);
this.meshOptions[r.name] = r, this.meshOptions[r.name].objectId = e;
var i = this.createComponent({
container: n,
kind: "educate.components.3DObject.3DMesh",
viewId: this.getViewId(),
objectId: e
});
t && (i = this.applyPropertiesToObject(i, t)), this.addLayer(i), this.hideLayer(r.name), this.meshes[e] = i;
},
addKlimatogram: function(e, t, n) {
var r = {};
t && (r = JSON.parse(!t.options || t.options === "" ? "{}" : t.options));
var i = this.createComponent({
container: n,
kind: "educate.create.components.bibliotheek.Klimatogram",
layername: "klimatogram",
position_x: t ? t.position_x : "50",
position_y: t ? t.position_y : "50",
viewId: this.getViewId(),
objectId: e
});
t && (i = this.applyPropertiesToObject(i, t)), this.addLayer(i);
},
applyPropertiesToObject: function(e, t) {
return e && (e.setValue(t.value), e.setSolution(t.solution), e.setAnswered(t.answered), e.setCss_class(t.css_class), e.setWidth(t.width), e.setHeight(t.height), e.setPosition(t.position), e.setPosition_x(t.position_x), e.setPosition_y(t.position_y), e.setInLayerHolder(t.inLayerHolder == 1 ? !0 : !1), e.setOptions(JSON.parse(!t.options || t.options === "" ? "{}" : t.options)), e.setVisible(e.options.visible), e.setAlpha(e.options.alpha), e.setOpen(e.options.open), e.setRotation(t.rotation), e.setActive(t.active == 0 ? !1 : !0), e.setOrigin(t.origin), e.setDatabaseId(t.id), e.collection = t.collection, e.setBIsInGroup && e.setBIsInGroup(e.container.kindName === "educate.create.components.groep.Groep" ? !0 : !1), e.setLayername(t.name), e.setIsPosLimiet(t.isPosLimiet), t.isPosLimiet && (e.setPosition_x_min(t.position_x_min), e.setPosition_x_max(t.position_x_max), e.setPosition_y_min(t.position_y_min), e.setPosition_y_max(t.position_y_max), e.setPosition_z_min(t.position_z_min), e.setPosition_z_max(t.position_z_max)), e.setIsRotLimiet(t.isRotLimiet), t.isRotLimiet && (e.setRotation_x_min(t.rotation_x_min), e.setRotation_x_max(t.rotation_x_max), e.setRotation_y_min(t.rotation_y_min), e.setRotation_y_max(t.rotation_y_max), e.setRotation_z_min(t.rotation_z_min), e.setRotation_z_max(t.rotation_z_max))), e;
},
addLayer: function(e) {
var t = {
obj: e,
objType: "object"
};
this.doObjectAdded(t);
},
addGroepLayer: function(e) {
var t = {
obj: e,
objType: "groep"
};
this.doObjectAdded(t);
},
hideLayer: function(e) {
this.doHideLayer({
name: e
});
},
deleteObjectFromStage: function(e) {
this.$[e].destroy();
},
getObjectFromStageByName: function(e) {
return this.$[e];
},
getObjectFromStageByDbId: function(e, t) {
var n = e.length;
for (var r = 0; r < n; r++) {
if (e[r].databaseId === t) return this.$[e[r].name];
if (e[r].kindName === "educate.create.components.groep.Groep") {
var i = this.getObjectFromStageByDbId(e[r].children, t);
if (i !== !1) return i;
}
}
return !1;
},
objectGroupChange: function(e, t) {
var n = this.getView();
if (n.getViewActive()) {
var r = t.grp, i = t.obj, s = t.oldgrp;
i = n.getChildById(i.objectId), r != "stage" ? this.$[r.name].addObjToGroup(i, s) : this.addObjToStage(i, s);
}
},
addObjToStage: function(e, t) {
e.addBefore = undefined, e.setContainer(this), e.changeOfGroup("stage", t), this.render();
},
listOrderChangedHandler: function(e, t) {
this.render(), this.arrangeObjecten();
},
arrangeObjecten: function() {
var e = this.children;
e.sort(enyo.bind(this, "sortObjecten"));
for (var t in e) e[t].kindName === "educate.create.components.groep.Groep" && e[t].arrangeObjectenGroup(), $(e[t].hasNode()).prependTo(this.hasNode());
},
sortObjecten: function(e, t) {
return e.position - t.position;
}
});

// Tekendoos.js

enyo.kind({
name: "educate.create.view.tekendoos.Tekendoos",
kind: enyo.Control,
tag: "div",
classes: "drawTool",
published: {
width: 85,
height: "100%",
shape: "",
move: !1,
lineColor: "",
lineStyle: "",
lineThickness: "",
fillColor: ""
},
handlers: {
disableDrawing: "disableDrawingHandler"
},
components: [ {
kind: "educate.create.view.Header",
content: "Tekendoos"
}, {
kind: "enyo.Scroller",
classes: "enyo-fit topposition",
components: [ {
kind: enyo.Button,
name: "rect",
classes: "icon rect",
ontap: "drawSquareHandler",
components: [ {
tag: "i",
classes: "icon-check-empty"
} ]
}, {
kind: enyo.Button,
name: "ellipse",
classes: "icon ellipse",
ontap: "drawCircleHandler",
components: [ {
tag: "i",
classes: "icon-circle-blank"
} ]
}, {
kind: enyo.Button,
name: "multi",
classes: "icon multi",
ontap: "drawMultiHandler",
components: [ {
tag: "i",
classes: "icon-star-empty"
} ]
}, {
kind: enyo.Button,
name: "free",
classes: "icon free",
ontap: "drawFreeHandler",
components: [ {
tag: "i",
classes: "icon-pencil"
} ]
}, {
kind: enyo.Button,
name: "mover",
classes: "icon move selectedTool",
ontap: "moverHandler",
components: [ {
tag: "i",
classes: "icon-move"
} ]
}, {
tag: "span",
classes: "minicolorFill"
}, {
tag: "p"
}, {
tag: "span",
classes: "minicolorEdge"
} ]
} ],
rendered: function() {
this.inherited(arguments), $(".minicolorEdge").minicolors({
change: function(e) {
self.enyo.$.create_view1_tekendoosPanel.lineColorSelected(e), $(".minicolors-theme-rand .minicolors-swatch").css("border", "5px solid " + e);
},
textfield: !1,
defaultValue: "#222222",
theme: "rand"
}), $(".minicolorFill").minicolors({
change: function(e) {
self.enyo.$.create_view1_tekendoosPanel.fillColorSelected($(this).minicolors("rgbObject"));
},
textfield: !1,
defaultValue: "#222222"
});
},
lineColorSelected: function(e) {
this.lineColor = e, this.bubble("lineColorSelected");
},
fillColorSelected: function(e) {
this.fillColor = e.r + ", " + e.g + ", " + e.b, this.bubble("fillColorSelected");
},
drawSquareHandler: function(e, t) {
this.removeClasses(), this.$.rect.addClass("selectedTool"), this.move = !1, this.shape = "rect", this.bubble("toggleDrawing");
},
drawCircleHandler: function(e, t) {
this.removeClasses(), this.$.ellipse.addClass("selectedTool"), this.move = !1, this.shape = "ellipse", this.bubble("toggleDrawing");
},
drawFreeHandler: function(e, t) {
this.removeClasses(), this.$.free.addClass("selectedTool"), this.move = !1, this.shape = "free", this.bubble("toggleDrawing");
},
drawMultiHandler: function(e, t) {
this.removeClasses(), this.$.multi.addClass("selectedTool"), this.shape = "triangle", this.move = !1, this.bubble("toggleDrawing"), this.$.selectMultiType || (this.createComponent({
tag: "select",
classes: "dropdown",
container: this.$.scroller,
style: "width: 90%;display: block;margin: 5%;",
onchange: "selectMultiTypeHandler",
name: "selectMultiType",
components: [ {
tag: "option",
content: "triangle",
value: "triangle"
}, {
tag: "option",
content: "pentagon",
value: "pentagon"
}, {
tag: "option",
content: "star",
value: "star"
}, {
tag: "option",
content: "arrow",
value: "arrow"
} ]
}), this.render());
},
selectMultiTypeHandler: function(e, t) {
this.shape = t.srcElement.value, this.bubble("toggleDrawing");
},
moverHandler: function(e, t) {
this.removeClasses(), this.$.mover.addClass("selectedTool"), this.move = !0, this.shape = "", this.bubble("toggleDrawing");
},
removeClasses: function() {
this.$.selectMultiType && this.$.selectMultiType.destroy(), this.$.rect.removeClass("selectedTool"), this.$.ellipse.removeClass("selectedTool"), this.$.mover.removeClass("selectedTool"), this.$.free.removeClass("selectedTool"), this.$.multi.removeClass("selectedTool");
},
resizeComponent: function() {
this.inherited(arguments);
},
disableDrawingHandler: function() {
this.removeClasses(), this.$.mover.addClass("selectedTool"), this.move = !0, this.shape = "";
}
});

// Onderbalk.js

enyo.kind({
kind: enyo.Control,
name: "educate.create.onderbalk.Onderbalk",
tag: "div",
classes: "bottombarCreator",
published: {},
handlers: {
viewAdded: "viewAddedHandler",
createSceneTabs: "createSceneTabsHandler",
removeSceneTabs: "removeSceneTabsHandler",
openSceneTabs: "openSceneTabsHandler",
tabButtonClicked: "tabButtonClickedHandler",
frameBottomIconClicked: "frameBottomIconClickedHandler",
viewActivated: "viewActivatedHandler"
},
components: [ {
kind: "Signals",
onTabsClose: "onTabCloseHandler",
onObjectLayerSelect: "onObjectLayerSelectHandler"
}, {
tag: "div",
name: "sceneViews",
classes: "sceneViewsCon"
}, {
tag: "div",
name: "addSceneView",
classes: "addSceneViewBtn",
content: "+",
showing: !1,
ontap: "addViewHandler"
}, {
name: "tabHolder"
}, {
kind: "educate.create.onderbalk.tabbladen.Tabknoppen",
name: "tabbladenCon"
}, {
tag: "div",
name: "viewFrameButtonsCon",
classes: "viewFrameButtonsCon"
} ],
create: function() {
this.inherited(arguments);
},
rendered: function() {
this.inherited(arguments);
},
addViewHandler: function(e, t) {
this.bubble("addView");
},
removeViewHandler: function(e, t) {},
viewAddedHandler: function(e, t) {
this.addBtnToSceneViewsCon(t), this.createViewFrameButtons(t);
},
addBtnToSceneViewsCon: function(e) {
this.deselectViewBtns(), this.createComponent({
container: this.$.sceneViews,
tag: "div",
name: "viewBtn" + e,
content: "View " + e,
linked: "view" + e,
ontap: "selectView",
classes: "sceneViewBtnSelect",
components: [ {
tag: "i",
classes: "edu-icon edu-" + e
} ]
}), this.$.sceneViews.render(), this.$.addSceneView.setShowing(e < 4 ? !0 : !1);
},
viewActivatedHandler: function(e, t) {
this.deselectViewBtns();
var n = this.$.sceneViews.children;
for (var r in n) n[r].linked == t.view.name && n[r].addClass("sceneViewBtnSelect");
},
selectView: function(e, t) {
this.bubble("viewBtnClicked", e), this.deselectViewBtns(), e.addClass("sceneViewBtnSelect"), this.updateViewFrameButtons(e);
},
deselectViewBtns: function() {
var e = this.$.sceneViews.children;
for (var t in e) e[t].removeClass("sceneViewBtnSelect");
},
deleteAllViewsHandler: function() {
this.$.sceneViews.destroyClientControls(), this.$.addSceneView.setShowing(!1), this.$.viewFrameButtonsCon.destroyClientControls();
},
createSceneTabsHandler: function(e, t) {
var n = t;
for (var r = 0; r < n.length; r++) {
var i = this.createComponent({
kind: "educate.create.onderbalk.tabbladen.Tabblad",
name: n[r] + "Content",
layername: n[r],
labelname: "Edit " + n[r],
container: this.$.tabHolder
});
this.waterfall("tabCreated", i);
}
this.render();
},
removeSceneTabsHandler: function() {
this.$.tabHolder.destroyClientControls();
},
openSceneTabsHandler: function(e, t) {
for (var n = 0; n < t.length; n++) this.$[t[n].name + "Content"].setValue(t[n].value), this.$[t[n].name + "Content"].setDatabaseId(t[n].id);
},
tabButtonClickedHandler: function(e, t) {
this.waterfallDown("tabButtonClicked", t), this.updateTabs();
},
onTabCloseHandler: function(e, t) {
this.updateTabs();
},
updateTabs: function() {
var e = new Object;
e.info = this.$.infoContent, e.leerinhoud = this.$.leerinhoudContent, e.leerdoel = this.$.leerdoelContent, e.begrippen = this.$.begrippenContent, e.links = this.$.linksContent, this.bubble("tabContentChanged", {
tabBladen: e
});
},
frameBottomIconClickedHandler: function(e, t) {
this.removeSelectedViewFrameButtons(t.viewId);
},
onObjectLayerSelectHandler: function(e, t) {
this.removeSelectedViewFrameButtons(t);
},
createViewFrameButtons: function(e) {
this.hideViewFrameButtons();
var t = this.createComponents([ {
tag: "div",
name: "frameBtnsView" + e,
container: this.$.viewFrameButtonsCon,
components: [ {
name: "icon-hand" + e,
layername: "knopHand" + e,
kind: "educate.create.onderbalk.knoppen.KnopHand",
viewId: e,
css_class: e
}, {
name: "icon-oplossing" + e,
layername: "knopOplossing" + e,
kind: "educate.create.onderbalk.knoppen.KnopOplossing",
viewId: e,
css_class: e
} ]
} ]);
this.bubble("frameBtnsViewCreated", {
frameBtns: t,
viewnr: e
}), this.$.viewFrameButtonsCon.render();
},
removeViewFrameButtons: function(e) {},
hideViewFrameButtons: function() {
var e = this.$.viewFrameButtonsCon.children;
for (var t in e) e[t].setShowing(!1);
},
updateViewFrameButtons: function(e) {
var t = e.linked.substr(4);
this.hideViewFrameButtons(), this.$["frameBtnsView" + t].setShowing(!0);
},
removeSelectedViewFrameButtons: function(e) {
var t = this.$["frameBtnsView" + e].children;
for (var n in t) for (var r in t[n].children) t[n].children[r].removeClass("iconSelected");
}
});

// Tabknop.js

enyo.kind({
kind: enyo.Control,
name: "educate.create.onderbalk.tabbladen.Tabknop",
classes: "tab-button",
tag: "li",
content: "tab-button"
});

// Tabknoppen.js

enyo.kind({
kind: enyo.Control,
name: "educate.create.onderbalk.tabbladen.Tabknoppen",
classes: "tab-buttons",
tag: "ul",
components: [ {
kind: "Signals",
onTabsClose: "onTabCloseHandler"
} ],
events: {
onTabClicked: ""
},
handlers: {
tabCreated: "tabCreatedHandler",
removeSceneTabs: "removeSceneTabsHandler"
},
tabCreatedHandler: function(e, t) {
this.createComponent({
kind: "educate.create.onderbalk.tabbladen.Tabknop",
content: t.layername,
name: "tab" + t.layername,
linked: t,
ontap: "onTabTapHandler"
}), this.render();
},
onTabTapHandler: function(e, t) {
e.hasClass("active") ? (enyo.Signals.send("onTabsClose"), t.originator.linked.closeTab()) : (this.removeActiveClasses(), e.addClass("active"), this.bubble("tabButtonClicked", t));
},
onTabCloseHandler: function(e, t) {
this.removeActiveClasses();
},
removeActiveClasses: function() {
for (var e in this.$) this.$[e].kind == "educate.create.onderbalk.tabbladen.Tabknop" && this.$[e].removeClass("active");
},
removeSceneTabsHandler: function() {
for (var e in this.$) this.$[e].kind == "educate.create.onderbalk.tabbladen.Tabknop" && this.$[e].destroy();
}
});

// Tabblad.js

enyo.kind({
name: "educate.create.onderbalk.tabbladen.Tabblad",
kind: "enyo.Control",
classes: "tab",
published: {
value: "",
labelname: "labelname",
carrier: window.settings.CARRIERS.SCENETAB,
layername: "",
solution: "",
answered: "",
width: 0,
height: 0,
position_x: 0,
position_y: 0,
inLayerHolder: 0,
objectId: "",
databaseId: ""
},
handlers: {
tabButtonClicked: "tabButtonClickedHandler"
},
components: [ {
tag: "span",
content: "&times",
classes: "closetabbtn",
allowHtml: !0,
ontap: "closeTabHandler"
}, {
tag: "label",
name: "labelname",
content: this.labelname
} ],
create: function() {
this.inherited(arguments), this.makeTextarea();
},
rendered: function() {
this.inherited(arguments), this.valueChanged(), this.labelnameChanged(), this.makeEditor();
},
makeTextarea: function() {
this.createComponent({
kind: "enyo.TextArea",
name: "contenttab" + this.name,
type: "text",
classes: "txtTabcontent",
attributes: {
name: "contenttab" + this.name
}
});
},
makeEditor: function() {
var e = this;
$(".txtTabcontent").ckeditor(function() {
this.on("blur", function(t) {
this.checkDirty() && e.txtContentChanged();
});
}, {
customConfig: "config_frontend.js"
});
},
txtContentChanged: function() {
this.setValue($('.txtTabcontent[name="contenttab' + this.getName() + '"]').val());
},
tabButtonClickedHandler: function(e, t) {
t.originator.linked == this ? this.openTab() : this.closeTab();
},
closeTabHandler: function() {
enyo.Signals.send("onTabsClose"), this.closeTab();
},
valueChanged: function() {
this.$["contenttab" + this.getName()].setValue(this.getValue());
},
openTab: function() {
this.addClass("active"), this.applyStyle("right", ($(window).width() - $(this.hasNode()).width()) / 2 + "px"), this.applyStyle("bottom", ($(window).height() - $(this.hasNode()).height()) / 2 + "px");
},
closeTab: function() {
this.removeClass("active"), this.applyStyle("right", "-1280px"), this.applyStyle("bottom", "-800px");
},
labelnameChanged: function() {
this.$.labelname.setContent(this.getLabelname());
}
});

// KnopHand.js

enyo.kind({
name: "educate.create.onderbalk.knoppen.KnopHand",
kind: enyo.Control,
classes: "frameBtn",
tag: "div",
published: {
viewId: "",
databaseId: "",
objectId: "",
carrier: window.settings.CARRIERS.HAND,
value: !1,
solution: !1,
answered: !0,
css_class: "",
layername: "",
objectHandlers: [],
options: null,
eventOptions: [],
reactieOptions: []
},
handlers: {
ontap: "handClicked"
},
components: [ {
tag: "i",
classes: "edu-icon edu-hand"
}, {
tag: "span",
content: "help"
} ],
create: function() {
this.inherited(arguments), this.initEventsReactiesOptions();
},
rendered: function() {
this.inherited(arguments);
},
initEventsReactiesOptions: function() {
this.inherited(arguments), delete this.getEventOptions().MOUSE_DOWN, delete this.getEventOptions().MOUSE_UP, delete this.getEventOptions().DRAG, delete this.getEventOptions().START_DRAG, delete this.getEventOptions().STOP_DRAG;
},
handClicked: function(e, t) {
this.bubble("frameBottomIconClicked", this), t.originator.addClass("iconSelected");
}
});

// KnopOplossing.js

enyo.kind({
name: "educate.create.onderbalk.knoppen.KnopOplossing",
kind: enyo.Control,
classes: "frameBtn",
tag: "div",
published: {
viewId: "",
databaseId: "",
objectId: "",
carrier: window.settings.CARRIERS.OPLOSSING,
value: !1,
solution: !1,
answered: !0,
css_class: "",
layername: "",
objectHandlers: [],
options: null,
eventOptions: [],
reactieOptions: [],
active: ""
},
handlers: {
ontap: "oplossingClicked"
},
components: [ {
tag: "i",
classes: "edu-icon edu-oplossing"
}, {
tag: "span",
content: "oplossing"
}, {
kind: "Signals",
onToggleSolution: "onToggleSolutionHandler"
} ],
create: function() {
this.inherited(arguments), this.initEventsReactiesOptions();
},
rendered: function() {
this.inherited(arguments), this.valueChanged();
},
valueChanged: function() {
this.addRemoveClass("active", this.getValue());
},
initEventsReactiesOptions: function() {
this.setEventOptions({
KLIK: {
label: "klik",
action: "ontap"
}
});
},
oplossingClicked: function(e, t) {
this.bubble("frameBottomIconClicked", this), t.originator.addClass("iconSelected");
},
onToggleSolutionHandler: function(e, t) {
t.originator.hasSolutions() && this.setValue(!0);
}
});
